export const schema = {
    "enums": {
        "SHMFailure": {
            "ARP_UNRESOLVED": {
                "description": "Unable to resolve ARP for server."
            },
            "CONNECTION_REFUSED": {
                "description": "Connection refused or unable to connect."
            },
            "CONNECTION_TIMEOUT": {
                "description": "Connections timed out."
            },
            "RESPONSE_CODE_MISMATCH": {
                "description": "Unexpected response code from server."
            },
            "PAYLOAD_CONTENT_MISMATCH": {
                "description": "Unexpected response data from server."
            },
            "SERVER_UNREACHABLE": {
                "description": "Network down or unreachable."
            },
            "CONNECTION_RESET": {
                "description": "Connection reset by server."
            },
            "CONNECTION_ERROR": {
                "description": "Generic connection error."
            },
            "HOST_ERROR": {
                "description": "Host down or unreachable."
            },
            "ADDRESS_ERROR": {
                "description": "Server address is in use or unavailable."
            },
            "NO_PORT": {
                "description": "No source port for health monitor."
            },
            "PAYLOAD_TIMEOUT": {
                "description": "Payload timed out."
            },
            "NO_RESPONSE": {
                "description": "No response for pings."
            },
            "NO_RESOURCES": {
                "description": "Out of resources."
            },
            "SSL_ERROR": {
                "description": "SSL connection failed."
            },
            "SSL_CERT_ERROR": {
                "description": "SSL certificate validation failed."
            },
            "PORT_UNREACHABLE": {
                "description": "Server Port Unreachable."
            },
            "SCRIPT_ERROR": {
                "description": "Script errors."
            },
            "OTHER_ERROR": {
                "description": "Remaining unaccounted errors."
            },
            "SERVER_DISABLED": {
                "description": "Server is disabled."
            },
            "REMOTE_STATE": {
                "description": "State not derived locally."
            },
            "MAINTENANCE_RESPONSE_CODE_MATCH": {
                "description": "Response from server contains the maintenance response code configured in health monitor."
            },
            "MAINTENANCE_PAYLOAD_CONTENT_MATCH": {
                "description": "Response from server contains the maintenance message configured in health monitor."
            },
            "CHUNKED_RESPONSE_PAYLOAD_NOT_FOUND": {
                "description": "Server sent chunked data greater than 2K bytes, response data not found in the 2K bytes."
            },
            "GSLB_POOL_MEMBER_DOWN": {
                "description": "GSLB pool member service in the site is detected to be down."
            },
            "GSLB_POOL_MEMBER_DISABLED": {
                "description": "GSLB pool member service in the site is disabled."
            },
            "GSLB_POOL_MEMBER_STATE_UNKNOWN": {
                "description": "GSLB pool member service in the remote site is not up."
            },
            "INSUFFICIENT_HEALTH_MONITORS_UP": {
                "description": "Number of health monitors in operational up state is less than configured minimum."
            },
            "GSLB_POOL_MEMBER_REMOTE_STATE_UNKNOWN": {
                "description": "GSLB pool member remote state not available (HM sharding is enabled)."
            },
            "RESPONSE_BUFFER_OVERFLOW": {
                "description": "Server sent data greater than 2K bytes, response data not found in the first 2K bytes."
            },
            "REQUEST_BUFFER_OVERFLOW": {
                "description": "Health Monitor is trying to send a request larger than 2k bytes."
            },
            "SERVER_AUTHENTICATION_ERR": {
                "description": "Server authentication error."
            },
            "INITIALIZATION_ERR": {
                "description": "Mail health monitor initialization error."
            },
            "EXT_HM_ERROR": {
                "description": "External HM failed with error."
            },
            "HTTP2_NOT_SUPPORTED": {
                "description": "Backend server doesn't support HTTP2"
            }
        },
        "SSLCertificateExpiryStatus": {
            "SSL_CERTIFICATE_GOOD": {
                "description": "SSL Certificate is good"
            },
            "SSL_CERTIFICATE_EXPIRY_WARNING": {
                "description": "SSL Certificate nearing expiration"
            },
            "SSL_CERTIFICATE_EXPIRED": {
                "description": "SSL Certificate has expired"
            }
        },
        "UpgradeFsmUiState": {
            "UPGRADE_FSM_UI_INIT": {
                "text": "UPGRADE_INIT",
                "description": "Initial State before any Upgrade Operations.",
                "ui_fsm_state_options": {
                    "allowed_states": [
                        "UPGRADE_FSM_INIT"
                    ]
                }
            },
            "UPGRADE_FSM_UI_IN_PROGRESS": {
                "text": "UPGRADE_IN_PROGRESS",
                "description": "Upgrade operations request in progress.",
                "ui_fsm_state_options": {
                    "allowed_states": [
                        "UPGRADE_FSM_STARTED",
                        "UPGRADE_FSM_WAITING",
                        "UPGRADE_FSM_IN_PROGRESS",
                        "UPGRADE_FSM_ENQUEUED",
                        "UPGRADE_FSM_PAUSED",
                        "UPGRADE_FSM_ABORT_IN_PROGRESS",
                        "UPGRADE_FSM_SUSPENDED",
                        "UPGRADE_FSM_SE_UPGRADE_IN_PROGRESS",
                        "UPGRADE_FSM_CONTROLLER_COMPLETED"
                    ]
                }
            },
            "UPGRADE_FSM_UI_COMPLETED": {
                "text": "UPGRADE_COMPLETED",
                "description": "Upgrade operations completed for the requested node.",
                "ui_fsm_state_options": {
                    "allowed_states": [
                        "UPGRADE_FSM_COMPLETED"
                    ]
                }
            },
            "UPGRADE_FSM_UI_ERROR": {
                "text": "UPGRADE_ERROR",
                "description": "Upgrade operations are in error.",
                "ui_fsm_state_options": {
                    "allowed_states": [
                        "UPGRADE_FSM_ERROR",
                        "UPGRADE_FSM_ABORTED",
                        "UPGRADE_FSM_ENQUEUE_FAILED"
                    ]
                }
            }
        },
        "AviDefinedFilters": {
            "ADF_CLIENT_CONN_SETUP_REFUSED": {
                "text": "Connection setup failed: client ended connection setup",
                "description": "The connection setup was prematurely stopped by the client, which sent a RST during the TCP three way handshake."
            },
            "ADF_SERVER_CONN_SETUP_REFUSED": {
                "text": "Connection setup failed: server refused connection",
                "description": "The connection setup was refused by the server, which sent a RST during the TCP three way handshake."
            },
            "ADF_CLIENT_CONN_SETUP_TIMEDOUT": {
                "text": "Connection setup failed: client conn setup timed out",
                "description": "TCP three way handshake with the client timed out despite multiple retries."
            },
            "ADF_SERVER_CONN_SETUP_TIMEDOUT": {
                "text": "Connection setup failed: server conn setup timed out",
                "description": "TCP three way handshake with the server timed out despite multiple retries."
            },
            "ADF_CLIENT_CONN_SETUP_FAILED_INTERNAL": {
                "text": "Connection setup failed: client conn setup failed",
                "description": "Avi was unable to complete the TCP three way handshake with the client due to an internal Avi error.  This may be due to lack of memory or other resource."
            },
            "ADF_SERVER_CONN_SETUP_FAILED_INTERNAL": {
                "text": "Connection setup failed: server conn setup failed",
                "description": "Avi was unable to complete the TCP three way handshake with the server due to an internal Avi error.  This may be due to lack of memory or other resource."
            },
            "ADF_CLIENT_CONN_SETUP_FAILED_BAD_PACKET": {
                "text": "Connection setup failed: client conn setup failed with bad packet",
                "description": "The connection was dropped due to bad packets received from client during TCP three way handshake."
            },
            "ADF_UDP_CONN_SETUP_FAILED_INTERNAL": {
                "text": "Client request processing failure: internal failure",
                "description": "Avi was unable to complete UDP request from the client due to an internal Avi error. This may be due to lack of memory or other resources."
            },
            "ADF_UDP_SERVER_CONN_SETUP_FAILED_INTERNAL": {
                "text": "Client request processing failure: server conn setup failed",
                "description": "Avi was unable to complete UDP request from the client due to an internal Avi error setting up server connectivity. This may be due to lack of memory or other resources."
            },
            "ADF_SCTP_SERVER_CONN_SETUP_REFUSED": {
                "text": "Connection setup failed: server refused connection",
                "description": "The connection setup was refused by the server, which sent an abort during the SCTP four way handshake."
            },
            "ADF_SCTP_SERVER_CONN_SETUP_TIMEDOUT": {
                "text": "Connection setup failed: server conn setup timed out",
                "description": "SCTP four way handshake with the server timed out despite multiple retries."
            },
            "ADF_SCTP_SERVER_CONN_SETUP_FAILED_INTERNAL": {
                "text": "Connection setup failed: server conn setup failed",
                "description": "Avi was unable to complete the SCTP four way handshake with the server due to an internal Avi error. This may be due to lack of memory or other resource."
            },
            "ADF_TCP_CLIENT_CONN_SETUP_FAILED_SMALL_WINDOW": {
                "text": "Connection setup failed: client advertised small TCP receive window",
                "description": "The connection was dropped due to client advertises a very small window in the last ACK of the 3 way handshake."
            },
            "ADF_CLIENT_SENT_RESET": {
                "text": "Connection closed abnormally: client ended connection",
                "description": "Client abnormally terminated the connection by sending a TCP RST."
            },
            "ADF_SERVER_SENT_RESET": {
                "text": "Connection closed abnormally: server ended connection",
                "description": "Server abnormally terminated the connection by sending a TCP RST."
            },
            "ADF_CLIENT_CONN_TIMEDOUT": {
                "text": "Connection closed abnormally: client connection timed out",
                "description": "The established TCP connection with the client was closed due to timeout. Despite multiple retry attempts, the client stopped responding to Avi's packets."
            },
            "ADF_SERVER_CONN_TIMEDOUT": {
                "text": "Connection closed abnormally: server connection timed out",
                "description": "The established TCP connection with the server was closed due to timeout.  Despite multiple retry attempts, the server stopped responding to Avi's packets."
            },
            "ADF_USER_DELETE_OPERATION": {
                "text": "Connection closed abnormally: conn deleted due to config update",
                "description": "The connection was deleted due to an Avi configuration update."
            },
            "ADF_CLIENT_REQUEST_TIMEOUT": {
                "text": "Connection closed abnormally: timed out waiting for HTTP request from client",
                "description": "The connection timed out waiting for the client to send HTTP request."
            },
            "ADF_CLIENT_CONN_ABORTED": {
                "text": "Connection closed abnormally: connection was prematurely closed by the client",
                "description": "connection was prematurely closed by the client."
            },
            "ADF_CLIENT_SSL_HANDSHAKE_FAILURE": {
                "text": "Connection closed abnormally: connection dropped due to SSL handshake failure",
                "description": "The connection dropped due to SSL handshake failure."
            },
            "ADF_CLIENT_CONN_FAILED": {
                "text": "Connection closed abnormally: connection was closed due to internal error",
                "description": "The connection was closed due to internal error."
            },
            "ADF_SERVER_CERTIFICATE_VERIFICATION_FAILED": {
                "text": "Connection closed abnormally: server x509 certificate verification failed",
                "description": "Validation of the server's x509 certificate failed."
            },
            "ADF_SERVER_SIDE_SSL_HANDSHAKE_FAILED": {
                "text": "Connection closed abnormally: connection dropped due to server side SSL handshake failure",
                "description": "The connection dropped due to server side SSL handshake failure."
            },
            "ADF_IDLE_TIMEDOUT": {
                "text": "Connection closed abnormally: connection idle timed out",
                "description": "The established TCP connection was closed due to the TCPprofile's idle timeout."
            },
            "ADF_CLIENT_CONNECTION_CLOSED_BEFORE_REQUEST": {
                "text": "Connection closed abnormally: Connection was closed before client sent HTTP request",
                "description": "The connection was closed while waiting for the client to send HTTP request."
            },
            "ADF_CLIENT_INCOMPLETE_DATA": {
                "text": "Connection closed abnormally: Partial data available for Application. Server not setup.",
                "description": "The connection was closed with partial data available from the client."
            },
            "ADF_CLIENT_CONN_STOPPED": {
                "text": "Connection closed abnormally: connection was prematurely closed by the client",
                "description": "connection was prematurely closed by the client."
            },
            "ADF_SCTP_CLIENT_SENT_RESET": {
                "text": "Connection closed abnormally: client ended connection",
                "description": "Client abnormally terminated the connection by sending an SCTP abort."
            },
            "ADF_SCTP_CLIENT_CONN_TIMEDOUT": {
                "text": "Connection closed abnormally: client connection timed out",
                "description": "The established SCTP connection with the client was closed due to timeout. Despite multiple retry attempts, the client stopped responding to Avi's SCTP packets."
            },
            "ADF_SCTP_IDLE_TIMEDOUT": {
                "text": "Connection closed abnormally: connection idle timed out",
                "description": "The established SCTP connection was closed due to the SCTP profile's idle timeout."
            },
            "ADF_SCTP_SERVER_SENT_RESET": {
                "text": "Connection closed abnormally: server ended connection",
                "description": "Server abnormally terminated the connection by sending an SCTP abort."
            },
            "ADF_SCTP_SERVER_CONN_TIMEDOUT": {
                "text": "Connection closed abnormally: server connection timed out",
                "description": "The established SCTP connection with the server was closed due to timeout. Despite multiple retry attempts, the server stopped responding to Avi's SCTP packets."
            },
            "ADF_CLIENT_HIGH_TIMEOUT_RETRANSMITS": {
                "text": "Connection abnormal event: client timeout caused retransmits",
                "description": "The TCP connection completed gracefully, but there are a high number of retransmitted packets due to timeouts from Avi to the client. This could be due to lossy network or a slow client."
            },
            "ADF_SERVER_HIGH_TIMEOUT_RETRANSMITS": {
                "text": "Connection abnormal event: server timeout caused retransmits",
                "description": "The TCP connection completed gracefully, but there were a high number of retransmitted packets due to timeouts from Avi to the server. This could be due to lossy network or a slow server."
            },
            "ADF_CLIENT_HIGH_RX_ZERO_WINDOW_SIZE_EVENTS": {
                "text": "Connection abnormal event: zero window from client",
                "description": "The TCP connection completed gracefully, but there were instances when the TCP window advertised by the client depleted to zero. This means that Avi could not send any more packets until the client opened the TCP window. This is typically due to a slow client."
            },
            "ADF_SERVER_HIGH_RX_ZERO_WINDOW_SIZE_EVENTS": {
                "text": "Connection abnormal event: zero window from server",
                "description": "The TCP connection completed gracefully, but there were instances when the TCP window advertised by the server depleted to zero. This means that Avi could not send any more packets until the server opened  the TCP window. This is typically due to a slow server."
            },
            "ADF_CLIENT_RTT_ABOVE_SEC": {
                "text": "Connection abnormal event: client high rtt",
                "description": "The TCP round trip time between Avi and the client is greater than 1 second."
            },
            "ADF_SERVER_RTT_ABOVE_500MS": {
                "text": "Connection abnormal event: server high rtt",
                "description": "The TCP round trip time between Avi and the server is greater than 500ms."
            },
            "ADF_CLIENT_HIGH_TOTAL_RETRANSMITS": {
                "text": "Connection abnormal event: client high retransmits",
                "description": "The TCP connection completed gracefully, but there were a high number of retransmitted packets from Avi to the client. This may be due to a lossy or congested network."
            },
            "ADF_SERVER_HIGH_TOTAL_RETRANSMITS": {
                "text": "Connection abnormal event: server high retransmits",
                "description": "The TCP connection completed gracefully, but there were a high number of retransmitted packets from Avi to the server. This may be due to a lossy or congested network."
            },
            "ADF_CLIENT_HIGH_OUT_OF_ORDERS": {
                "text": "Connection abnormal event: client out of order packets",
                "description": "The TCP connection completed gracefully, but Avi received a high number of out of order packets from the client. This is generally due to lossy or congested network or drops by Avi."
            },
            "ADF_SERVER_HIGH_OUT_OF_ORDERS": {
                "text": "Connection abnormal event: server out of order packets",
                "description": "The TCP connection completed gracefully, but Avi received a high number of out of order packets from the client. This is generally due to lossy or congested network or drops by Avi."
            },
            "ADF_CLIENT_HIGH_TX_ZERO_WINDOW_SIZE_EVENTS": {
                "text": "Connection abnormal event: zero window to client",
                "description": "The TCP connection completed gracefully, but there were instances when the TCP window advertised by Avi to client depleted to zero. This means that client could not send any more packets until Avi opened the TCP window. This is typically due to a slow server."
            },
            "ADF_SERVER_HIGH_TX_ZERO_WINDOW_SIZE_EVENTS": {
                "text": "Connection abnormal event: zero window to server",
                "description": "The TCP connection completed gracefully, but there were instances when the TCP window advertised by Avi to server depleted to zero. This means that server could not send any more packets until Avi opened the TCP window. This is typically due to a slow client."
            },
            "ADF_CLIENT_POSSIBLE_WINDOW_STUCK": {
                "text": "Connection abnormal event: client possible window stuck",
                "description": "The TCP connection completed gracefully, but there were instances when the TCP window advertised by the client was not opened fast enough, which may lead the window to be stuck."
            },
            "ADF_SERVER_POSSIBLE_WINDOW_STUCK": {
                "text": "Connection abnormal event: server possible window stuck",
                "description": "The TCP connection completed gracefully, but there were instances when the TCP window advertised by the server was not opened fast enough, which may lead the window to be stuck."
            },
            "ADF_SERVER_UNANSWERED_SYNS": {
                "text": "Connection abnormal event: server unanswered syns",
                "description": "The TCP connection completed gracefully, but there were some syns sent to backend server were not acked immediately that caused SE to retransmit the syn. This is typically due to busy server."
            },
            "ADF_CLIENT_CLOSE_CONNECTION_ON_VS_UPDATE": {
                "text": "Connection closed abnormally: connection was closed on VS config update",
                "description": "The client connection is closed if vs has close_client_conn_on_config_update enabled and a disruptive config update is done on the virtual server."
            },
            "ADF_CLIENT_POSSIBLE_SLOW_DRAIN": {
                "text": "Connection abnormal event: client has a slow receive rate",
                "description": "The client connection is slow. The packets are drained at a slow rate by the client compared to the incoming rate from the server."
            },
            "ADF_SERVER_POSSIBLE_SLOW_DRAIN": {
                "text": "Connection abnormal event: server has a slow receive rate",
                "description": "The server connection is slow. The packets are drained at a slow rate by the server compared to the incoming rate from the client."
            },
            "ADF_SERVER_INGRESS_LATENCY_EXCEEDED": {
                "text": "Connection abnormal event: Server side high ingress latency.",
                "description": "Ingress packet processing latency for the server side flow exceeds configured threshold."
            },
            "ADF_SERVER_CONN_EST_TIME_EXCEEDED": {
                "text": "Connection abnormal event: Server side high connection establishment time.",
                "description": "The connection establishment time for the server side flow exceeds threshold."
            },
            "ADF_CLIENT_INGRESS_LATENCY_EXCEEDED": {
                "text": "Connection abnormal event: Client side high ingress latency.",
                "description": "Ingress packet processing latency for the client side flow exceeds configured threshold."
            },
            "ADF_CLIENT_CONN_EST_TIME_EXCEEDED": {
                "text": "Connection abnormal event: Client side high connection establishment time.",
                "description": "The connection establishment time for the client side flow exceeds threshold."
            },
            "ADF_RESPONSE_CODE_4XX": {
                "text": "Request ended abnormally: response code 4xx",
                "description": "A 4xx 'client error' HTTP response code was sent to the client."
            },
            "ADF_RESPONSE_CODE_5XX": {
                "text": "Request ended abnormally: response code 5xx",
                "description": "A 5xx 'server error' HTTP response code was sent to the client."
            },
            "ADF_LOAD_BALANCING_FAILED": {
                "text": "Request ended abnormally: no available servers",
                "description": "The connection attempt was reset due to no servers available.  This may be because the server connection limits setting was reached, or all servers are in a down state."
            },
            "ADF_DATASCRIPT_EXECUTION_FAILED": {
                "text": "Request ended abnormally: Datascript failed to execute",
                "description": "The datascript failed to execute."
            },
            "ADF_REQUEST_NO_POOL": {
                "text": "Request ended abnormally: request failed to select pool",
                "description": "The request could not be fulfilled by any available pool"
            },
            "ADF_RATE_LIMIT_DROP_CLIENT_IP": {
                "text": "Request ended abnormally: Too many requests from this client IP",
                "description": "Request dropped because there were too many requests from this client IP"
            },
            "ADF_RATE_LIMIT_DROP_URI": {
                "text": "Request ended abnormally: Too many requests for this URI",
                "description": "Request dropped because there were too many requests for this URI"
            },
            "ADF_RATE_LIMIT_DROP_CLIENT_IP_URI": {
                "text": "Request ended abnormally: Too many requests for this URI from this client IP",
                "description": "Request dropped because there were too many requests for this URI from this client IP"
            },
            "ADF_RATE_LIMIT_DROP_UNKNOWN_URI": {
                "text": "Request ended abnormally: Too many requests for an unknown URI ",
                "description": "Request dropped because there were too many requests for this unknown URI"
            },
            "ADF_RATE_LIMIT_DROP_BAD_URI": {
                "text": "Request ended abnormally: Too many requests for a bad URI ",
                "description": "Request dropped because there were too many requests for this bad URI"
            },
            "ADF_REQUEST_VIRTUAL_HOSTING_APP_SELECT_FAILED": {
                "text": "Request ended abnormally: request failed to use a virtual hosting virtual server",
                "description": "The request could not be fulfilled by any virtual server"
            },
            "ADF_RATE_LIMIT_DROP_UNKNOWN_CIP": {
                "text": "Request ended abnormally: Too many requests from an unknown client IP ",
                "description": "Request dropped because there were too many requests from this unknown client IP"
            },
            "ADF_RATE_LIMIT_DROP_BAD_CIP": {
                "text": "Request ended abnormally: Too many requests from a bad client IP ",
                "description": "Request dropped because there were too many requests from this bad client IP"
            },
            "ADF_RATE_LIMIT_DROP_CLIENT_IP_BAD": {
                "text": "Request ended abnormally: Too many bad requests from this client IP",
                "description": "Request dropped because there were too many bad requests from this client IP"
            },
            "ADF_RATE_LIMIT_DROP_URI_BAD": {
                "text": "Request ended abnormally: Too many bad requests for this URI",
                "description": "Request dropped because there were too many bad requests for this URI"
            },
            "ADF_RATE_LIMIT_DROP_CLIENT_IP_URI_BAD": {
                "text": "Request ended abnormally: Too many bad requests for this URI from this client IP",
                "description": "Request dropped because there were too many bad requests for this URI from this client IP"
            },
            "ADF_RATE_LIMIT_DROP_REQ": {
                "text": "Request ended abnormally: Too many requests",
                "description": "Request dropped because there were too many requests for this virtualservice"
            },
            "ADF_RATE_LIMIT_DROP_CLIENT_IP_CONN": {
                "text": "Connection not allowed: Too many connections from this client IP",
                "description": "Configured rate limiting action taken for this connection from this client IP"
            },
            "ADF_RATE_LIMIT_DROP_CONN": {
                "text": "Connection not allowed: Too many connections",
                "description": "Configured rate limiting action taken for this connection for this virtualservice"
            },
            "ADF_RATE_LIMIT_DROP_HEADER": {
                "text": "Request ended abnormally: Throttled by the header-based rate limiter",
                "description": "Request dropped because there were too many requests that contain a header or cookie value"
            },
            "ADF_RATE_LIMIT_DROP_CUSTOM": {
                "text": "Request ended abnormally: Throttled by the custom string-based rate limiter",
                "description": "Request dropped because there were too many requests that map to a custom string"
            },
            "ADF_RATE_LIMIT_DROP_URI_SCAN_BAD": {
                "text": "Request ended abnormally: Throttled by bad URI scanning rate limiter.",
                "description": "Request dropped because there were too many requests to this known bad URI."
            },
            "ADF_RATE_LIMIT_DROP_URI_SCAN_UNKNOWN": {
                "text": "Request ended abnormally: Throttled by unknown URI scanning rate limiter.",
                "description": "Request dropped because there were too many requests to this unknown URI."
            },
            "ADF_RATE_LIMIT_DROP_CIP_SCAN_BAD": {
                "text": "Request ended abnormally: Throttled by known bad client IP scanning rate limiter.",
                "description": "Request dropped because there were too many requests from this known bad client."
            },
            "ADF_RATE_LIMIT_DROP_CIP_SCAN_UNKNOWN": {
                "text": "Request ended abnormally: Throttled by unknown client IP scanning rate limiter.",
                "description": "Request dropped because there were too many requests from this unknown client."
            },
            "ADF_CONFIGURED_RATE_LIMIT_DROP_CONN": {
                "text": "Dropped connection because of configured rate limiting or drop action",
                "description": "Configured rate limiting or drop action taken for this connection for this virtualservice"
            },
            "ADF_HTTP_VERSION_LT_1_0": {
                "text": "Request abnormal event: http version 0.9",
                "description": "Client sent request with HTTP Protocol version 0.9."
            },
            "ADF_CLIENT_HIGH_RESPONSE_TIME": {
                "text": "Request abnormal event: high total time",
                "description": "Total time greater than the configured threshold"
            },
            "ADF_SERVER_HIGH_RESPONSE_TIME": {
                "text": "Request abnormal event: high app response time",
                "description": "App response time greater than the configured threshold"
            },
            "ADF_PERSISTENT_SERVER_CHANGE": {
                "text": "Request abnormal event: persistent server changed",
                "description": "Persistent server changed"
            },
            "ADF_PERSISTENCE_FAILURE_SERVER_DOWN": {
                "text": "App Persistence failure: Selected Persistent server is down",
                "description": "App Persistence failure: Selected Persistent server is down"
            },
            "ADF_PERSISTENCE_FAILURE_SERVER_DISABLED": {
                "text": "App Persistence failure: Selected Persistent server has been disabled",
                "description": "App Persistence failure: Selected Persistent server has been disabled"
            },
            "ADF_PERSISTENCE_FAILURE_APP_COOKIE_MISSING": {
                "text": "App Persistence failure: Unable to find server with given App Cookie",
                "description": "App Persistence failure: Unable to find server with given App Cookie"
            },
            "ADF_DOS_SERVER_BAD_GATEWAY": {
                "text": "DOS_APP_ERROR: bad gateway",
                "description": "Potential denial of service attack where a backend network vulnerability is being exploited."
            },
            "ADF_DOS_SERVER_GATEWAY_TIMEOUT": {
                "text": "DOS_APP_ERROR: gateway timeout",
                "description": "Potential denial of service attack where a backend network vulnerability is being exploited."
            },
            "ADF_DOS_CLIENT_SENT_RESET": {
                "text": "DOS_HTTP_STOP: client reset the connection before sending any requests",
                "description": "Potential denial of service attack where client resets connections after having held up connection resources."
            },
            "ADF_DOS_CLIENT_CONN_TIMEOUT": {
                "text": "DOS_HTTP_TIMEOUT: connection timed out as no requests were received from the client after the connection was established",
                "description": "Potential denial of service attack where client holds up a connection without sending any requests. Browsers like Chrome are known to keep connections open for short durations of time without sending any requests, in which case this significance would not be triggered."
            },
            "ADF_DOS_CLIENT_REQUEST_TIMEOUT": {
                "text": "DOS_HTTP_TIMEOUT: request timed out ",
                "description": "Potential denial of service attack where client is sending requests few bytes at a time with no intention of completing the request. This could potentially be Slowloris or Slowbody attack."
            },
            "ADF_DOS_CLIENT_CONN_ABORTED": {
                "text": "DOS_HTTP_STOP: client reset connection abnormally",
                "description": "Potential denial of service attack where client resets connection after having sent a few bytes of the request holding up request and connection related resources"
            },
            "ADF_DOS_CLIENT_BAD_REQUEST": {
                "text": "DOS_HTTP_ERROR: bad request",
                "description": "Potential denial of service attack where client is sending bad requests."
            },
            "ADF_DOS_CLIENT_REQUEST_ENTITY_TOO_LARGE": {
                "text": "DOS_HTTP_ERROR: request body too large",
                "description": "Potential denial of service attack where client is sending requests with body size more than allowed by configuration."
            },
            "ADF_DOS_CLIENT_REQUEST_URI_TOO_LARGE": {
                "text": "DOS_HTTP_ERROR: request uri too large",
                "description": "Potential denial of service attack where client is sending requests with uri length more than allowed by configuration."
            },
            "ADF_DOS_CLIENT_REQUEST_HEADER_TOO_LARGE": {
                "text": "DOS_HTTP_ERROR: request header too large",
                "description": "Potential denial of service attack where client is sending requests with header size more than allowed by configuration."
            },
            "ADF_DOS_CLIENT_CLOSED_REQUEST": {
                "text": "DOS_HTTP_ERROR: request ended prematurely",
                "description": "Potential denial of service attack where client closed the connection in the middle of a request."
            },
            "ADF_DOS_SSL_ERROR": {
                "text": "DOS_SSL_ERROR: ssl error",
                "description": "Potential denial of service attack where client is causing SSL errors resulting in resources being exploited."
            },
            "ADF_REQUEST_MEMORY_LIMIT_EXCEEDED": {
                "text": "Request abnormal event: request memory limit exceeded",
                "description": "Maximum memory allocation limit for a single request exceeded."
            },
            "ADF_DOS_CLIENT_CONN_STOPPED": {
                "text": "DOS_HTTP_STOP: client reset connection abnormally",
                "description": "Potential denial of service attack where client resets connection after having sent a few bytes of the request holding up request and connection related resources"
            },
            "ADF_MULTI_SP_POOLS_INCORRECT_FQDN": {
                "text": "Request abnormal event: Invalid cookie with no/incorrect FQDN info.",
                "description": "The cookie received doesn't have FQDN information encrypted. It will be treated as invalid and request will be served locally with no cookie in response."
            },
            "ADF_GSLB_SITE_PERSISTENCE_LOOP_FOUND": {
                "text": "Request abnormal event: Site persistence cookie does not correspond to any of the sites.",
                "description": "Site persistence cookie received does not correspond to any site. Avi will expire this site cookie."
            },
            "ADF_X509_CLIENT_CERTIFICATE_VERIFICATION_FAILED": {
                "text": "Client certificate verification failed: client x509 certificate verification failed",
                "description": "Validation of the client's x509 certificate failed"
            },
            "ADF_X509_CLIENT_CERTIFICATE_NOT_YET_VALID": {
                "text": "Client certificate verification failed: client x509 certificate not yet valid",
                "description": "Client's x509 certificate not yet valid"
            },
            "ADF_X509_CLIENT_CERTIFICATE_EXPIRED": {
                "text": "Client certificate verification failed: client x509 certificate expired",
                "description": "Client's x509 certificate has expired"
            },
            "ADF_X509_CLIENT_CERTIFICATE_REVOKED": {
                "text": "Client certificate verification failed: client x509 certificate revoked",
                "description": "Client's x509 certificate has been revoked"
            },
            "ADF_X509_CLIENT_CERTIFICATE_INVALID_CA": {
                "text": "Client certificate verification failed: CA x509 certificate invalid",
                "description": "CA's x509 certificate is invalid"
            },
            "ADF_X509_CLIENT_CERTIFICATE_CRL_NOT_PRESENT": {
                "text": "Client certificate verification failed: Unable to get CRL for a certificate",
                "description": "Client's x509 certificate CRL not present"
            },
            "ADF_X509_CLIENT_CERTIFICATE_CRL_NOT_YET_VALID": {
                "text": "Client certificate verification failed: CRL not yet valid",
                "description": "Client's x509 certificate CRL not yet valid"
            },
            "ADF_X509_CLIENT_CERTIFICATE_CRL_EXPIRED": {
                "text": "Client certificate verification failed: CRL has expired",
                "description": "Client's x509 certificate CRL has expired"
            },
            "ADF_X509_CLIENT_CERTIFICATE_CRL_ERROR": {
                "text": "Client certificate verification failed: CRL error",
                "description": "Client's x509 certificate CRL had error"
            },
            "ADF_X509_CLIENT_CERTIFICATE_CHAINING_ERROR": {
                "text": "Client certificate verification failed: certificate chaining error",
                "description": "Certificate chain could not be formed correctly"
            },
            "ADF_X509_CLIENT_CERTIFICATE_INTERNAL_ERROR": {
                "text": "Client certificate verification failed: internal error ",
                "description": "Internal Error"
            },
            "ADF_X509_CLIENT_CERTIFICATE_FORMAT_ERROR": {
                "text": "Client certificate verification failed: client x509 certificate had errors",
                "description": "Client's x509 certificate has errors"
            },
            "ADF_UDP_PORT_NOT_REACHABLE": {
                "text": "Server connectivity failed: server udp port unreachable",
                "description": "ICMP port unreachable was received when client's packet was sent to the server. Either the server is not listening to UDP on the port or duplicate server ip in the network."
            },
            "ADF_UDP_CONN_TIMEOUT": {
                "text": "Connection abnormal event: server udp response timed out",
                "description": "Server response to client's udp packet timed out."
            },
            "ADF_X509_SERVER_CERTIFICATE_VERIFICATION_FAILED": {
                "text": "Server certificate verification failed: server x509 certificate verification failed",
                "description": "Validation of the server's x509 certificate failed"
            },
            "ADF_X509_SERVER_CERTIFICATE_NOT_YET_VALID": {
                "text": "Server certificate verification failed: server x509 certificate not yet valid",
                "description": "Server's x509 certificate not yet valid"
            },
            "ADF_X509_SERVER_CERTIFICATE_EXPIRED": {
                "text": "Server certificate verification failed: server x509 certificate expired",
                "description": "Server's x509 certificate has expired"
            },
            "ADF_X509_SERVER_CERTIFICATE_REVOKED": {
                "text": "Server certificate verification failed: server x509 certificate revoked",
                "description": "Server's x509 certificate has been revoked"
            },
            "ADF_X509_SERVER_CERTIFICATE_INVALID_CA": {
                "text": "Server certificate verification failed: CA x509 certificate invalid",
                "description": "CA's x509 certificate is invalid"
            },
            "ADF_X509_SERVER_CERTIFICATE_CRL_NOT_PRESENT": {
                "text": "Server certificate verification failed: Unable to get CRL for a certificate",
                "description": "Server's x509 certificate CRL not present"
            },
            "ADF_X509_SERVER_CERTIFICATE_CRL_NOT_YET_VALID": {
                "text": "Server certificate verification failed: CRL not yet valid",
                "description": "Server's x509 certificate CRL not yet valid"
            },
            "ADF_X509_SERVER_CERTIFICATE_CRL_EXPIRED": {
                "text": "Server certificate verification failed: CRL has expired",
                "description": "Server's x509 certificate CRL has expired"
            },
            "ADF_X509_SERVER_CERTIFICATE_CRL_ERROR": {
                "text": "Server certificate verification failed: CRL error",
                "description": "Server's x509 certificate CRL had error"
            },
            "ADF_X509_SERVER_CERTIFICATE_CHAINING_ERROR": {
                "text": "Server certificate verification failed: certificate chaining error",
                "description": "Certificate chain could not be formed correctly"
            },
            "ADF_X509_SERVER_CERTIFICATE_INTERNAL_ERROR": {
                "text": "Server certificate verification failed: internal error ",
                "description": "Internal Error"
            },
            "ADF_X509_SERVER_CERTIFICATE_FORMAT_ERROR": {
                "text": "Server certificate verification failed: server x509 certificate had errors",
                "description": "Server's x509 certificate has errors"
            },
            "ADF_X509_SERVER_CERTIFICATE_HOSTNAME_ERROR": {
                "text": "Server certificate verification failed: hostname did not match with upstream certificate",
                "description": "Hostname did not match with the upstream certificate"
            },
            "ADF_SSL_R_BAD_CHANGE_CIPHER_SPEC": {
                "text": "SSL Error: bad change cipher spec ",
                "description": "Change cipher spec is bad"
            },
            "ADF_SSL_R_BLOCK_CIPHER_PAD_IS_WRONG": {
                "text": "SSL Error: block cipher pad is wrong ",
                "description": "Block Cipher Pad is wrong"
            },
            "ADF_SSL_R_DIGEST_CHECK_FAILED": {
                "text": "SSL Error: digest check failed ",
                "description": "Digest check failed"
            },
            "ADF_SSL_R_ERROR_IN_RECEIVED_CIPHER_LIST": {
                "text": "SSL Error: error in received cipher list ",
                "description": "Received cipher list has an error"
            },
            "ADF_SSL_R_EXCESSIVE_MESSAGE_SIZE": {
                "text": "SSL Error: excessive message size ",
                "description": "Message size is excessive"
            },
            "ADF_SSL_R_LENGTH_MISMATCH": {
                "text": "SSL Error: length mismatch ",
                "description": "Length mismatch was detected"
            },
            "ADF_SSL_R_NO_CIPHERS_PASSED": {
                "text": "SSL Error: no ciphers passed ",
                "description": "No ciphers were passed"
            },
            "ADF_SSL_R_NO_CIPHERS_SPECIFIED": {
                "text": "SSL Error: no ciphers specified ",
                "description": "No ciphers were specified"
            },
            "ADF_SSL_R_NO_COMPRESSION_SPECIFIED": {
                "text": "SSL Error: no compression specified ",
                "description": "No compression was specified"
            },
            "ADF_SSL_R_NO_SHARED_CIPHER": {
                "text": "SSL Error: no shared cipher ",
                "description": "No shared cipher"
            },
            "ADF_SSL_R_RECORD_LENGTH_MISMATCH": {
                "text": "SSL Error: record length mismatch ",
                "description": "Mismatch in record length"
            },
            "ADF_SSL_R_PARSE_TLSEXT": {
                "text": "SSL Error: parse tlsext ",
                "description": "Error parsing tlsext"
            },
            "ADF_SSL_R_UNEXPECTED_MESSAGE": {
                "text": "SSL Error: unexpected message ",
                "description": "Unexpected message"
            },
            "ADF_SSL_R_UNEXPECTED_RECORD": {
                "text": "SSL Error: unexpected record ",
                "description": "Unexpected record"
            },
            "ADF_SSL_R_UNKNOWN_ALERT_TYPE": {
                "text": "SSL Error: unknown alert type ",
                "description": "Unknown alert type"
            },
            "ADF_SSL_R_UNKNOWN_PROTOCOL": {
                "text": "SSL Error: unknown protocol ",
                "description": "Unknown protocol"
            },
            "ADF_SSL_R_WRONG_VERSION_NUMBER": {
                "text": "SSL Error: wrong version number ",
                "description": "Wrong version number"
            },
            "ADF_SSL_R_DECRYPTION_FAILED_OR_BAD_RECORD_MAC": {
                "text": "SSL Error: decryption failed or bad record mac ",
                "description": "Decryption failed or Bad record MAC"
            },
            "ADF_SSL_R_RENEGOTIATE_EXT_TOO_LONG": {
                "text": "SSL Error: renegotiate ext too long ",
                "description": "Renegotiate extestions were too long"
            },
            "ADF_SSL_R_RENEGOTIATION_ENCODING_ERR": {
                "text": "SSL Error: renegotiation encoding err ",
                "description": "Error in renegotiation encoding"
            },
            "ADF_SSL_R_RENEGOTIATION_MISMATCH": {
                "text": "SSL Error: renegotiation mismatch ",
                "description": "Mismatch detected in renegotiation"
            },
            "ADF_SSL_R_UNSAFE_LEGACY_RENEGOTIATION_DISABLED": {
                "text": "SSL Error: unsafe legacy renegotiation disabled ",
                "description": "Unsafe legacy renegotiation is disabled"
            },
            "ADF_SSL_R_SCSV_RECEIVED_WHEN_RENEGOTIATING": {
                "text": "SSL Error: scsv received when renegotiating ",
                "description": "SCSV was received when renegotiating"
            },
            "ADF_SSL_R_INAPPROPRIATE_FALLBACK": {
                "text": "SSL Error: inappropriate fallback ",
                "description": "Inappropriate fallback to a lower version"
            },
            "ADF_SSL_R_SSLV3_ALERT_UNEXPECTED_MESSAGE": {
                "text": "SSL Error: sslv3 alert unexpected message ",
                "description": "SSLv3 alert - Unexpected Message"
            },
            "ADF_SSL_R_SSLV3_ALERT_BAD_RECORD_MAC": {
                "text": "SSL Error: sslv3 alert bad record mac ",
                "description": "SSLv3 alert - Record with incorrect MAC received"
            },
            "ADF_SSL_R_TLSV1_ALERT_DECRYPTION_FAILED": {
                "text": "SSL Error: tlsv1 alert decryption failed ",
                "description": "TLSv1 alert - Decryption failed"
            },
            "ADF_SSL_R_TLSV1_ALERT_RECORD_OVERFLOW": {
                "text": "SSL Error: tlsv1 alert record overflow ",
                "description": "TLSv1 alert - Record Overflow"
            },
            "ADF_SSL_R_SSLV3_ALERT_DECOMPRESSION_FAILURE": {
                "text": "SSL Error: sslv3 alert decompression failure ",
                "description": "SSLv3 alert - Decompression Failure"
            },
            "ADF_SSL_R_SSLV3_ALERT_HANDSHAKE_FAILURE": {
                "text": "SSL Error: sslv3 alert handshake failure ",
                "description": "SSLv3 alert - Handshake Failure"
            },
            "ADF_SSL_R_SSLV3_ALERT_NO_CERTIFICATE": {
                "text": "SSL Error: sslv3 alert no certificate ",
                "description": "SSLv3 alert - No Certificate"
            },
            "ADF_SSL_R_SSLV3_ALERT_BAD_CERTIFICATE": {
                "text": "SSL Error: sslv3 alert bad certificate ",
                "description": "SSLv3 alert - Bad Certificate"
            },
            "ADF_SSL_R_SSLV3_ALERT_UNSUPPORTED_CERTIFICATE": {
                "text": "SSL Error: sslv3 alert unsupported certificate ",
                "description": "SSLv3 alert - Unsupported Certificate"
            },
            "ADF_SSL_R_SSLV3_ALERT_CERTIFICATE_REVOKED": {
                "text": "SSL Error: sslv3 alert certificate revoked ",
                "description": "SSLv3 alert - Certificate revoked"
            },
            "ADF_SSL_R_SSLV3_ALERT_CERTIFICATE_EXPIRED": {
                "text": "SSL Error: sslv3 alert certificate expired ",
                "description": "SSLv3 alert - Certificate expired"
            },
            "ADF_SSL_R_SSLV3_ALERT_CERTIFICATE_UNKNOWN": {
                "text": "SSL Error: sslv3 alert certificate unknown ",
                "description": "SSLv3 alert - Certificate unknown"
            },
            "ADF_SSL_R_SSLV3_ALERT_ILLEGAL_PARAMETER": {
                "text": "SSL Error: sslv3 alert illegal parameter ",
                "description": "SSLv3 alert - Illegal Parameter"
            },
            "ADF_SSL_R_TLSV1_ALERT_UNKNOWN_CA": {
                "text": "SSL Error: tlsv1 alert unknown ca ",
                "description": "TLSv1 alert - CA could not be located or Doesn't match known, trusted CA"
            },
            "ADF_SSL_R_TLSV1_ALERT_ACCESS_DENIED": {
                "text": "SSL Error: tlsv1 alert access denied ",
                "description": "TLSv1 alert - Access denied"
            },
            "ADF_SSL_R_TLSV1_ALERT_DECODE_ERROR": {
                "text": "SSL Error: tlsv1 alert decode error ",
                "description": "TLSv1 alert - Decode error - Field out of specified range or message length incorrect"
            },
            "ADF_SSL_R_TLSV1_ALERT_DECRYPT_ERROR": {
                "text": "SSL Error: tlsv1 alert decrypt error ",
                "description": "TLSv1 alert - Decrypt error"
            },
            "ADF_SSL_R_TLSV1_ALERT_EXPORT_RESTRICTION": {
                "text": "SSL Error: tlsv1 alert export restriction ",
                "description": "TLSv1 alert - Export Restriction"
            },
            "ADF_SSL_R_TLSV1_ALERT_PROTOCOL_VERSION": {
                "text": "SSL Error: tlsv1 alert protocol version ",
                "description": "TLSv1 alert - Attempt to negotiate with unsupported protocol version"
            },
            "ADF_SSL_R_TLSV1_ALERT_INSUFFICIENT_SECURITY": {
                "text": "SSL Error: tlsv1 alert insufficient security ",
                "description": "TLSv1 alert - Ciphers not secure enough"
            },
            "ADF_SSL_R_TLSV1_ALERT_INTERNAL_ERROR": {
                "text": "SSL Error: tlsv1 alert internal error ",
                "description": "TLSv1 alert - Internal Error"
            },
            "ADF_SSL_R_TLSV1_ALERT_USER_CANCELLED": {
                "text": "SSL Error: tlsv1 alert user cancelled ",
                "description": "TLSv1 alert - User Cancelled"
            },
            "ADF_SSL_R_TLSV1_ALERT_NO_RENEGOTIATION": {
                "text": "SSL Error: tlsv1 alert no renegotiation ",
                "description": "TLSv1 alert - No Renegotiation"
            },
            "ADF_SSL_OCSP_CERT_STATUS_REVOKED": {
                "text": "OCSP Alert: The Status of the SSL/TLS Certificate is Revoked.",
                "description": "The Status of the SSL/TLS Certificate is Revoked."
            },
            "ADF_SSL_OCSP_RESPONSE_STALE": {
                "text": "OCSP Alert: The OCSP Response of the certificate used is Stale.",
                "description": "The OCSP Response of the certificate used is Stale."
            },
            "ADF_SSL_OCSP_RESPONSE_UNAVAILABLE": {
                "text": "OCSP Alert: The OCSP Response for the certificate used is unavailable.",
                "description": "The OCSP Response for the certificate used is unavailable."
            },
            "ADF_SSL_OCSP_CERT_STATUS_ISSUER_REVOKED": {
                "text": "OCSP Alert: OCSP Response is not available as the Issuer certificate is Revoked.",
                "description": "OCSP Response is not available as the Issuer certificate is Revoked."
            },
            "ADF_SSL_R_NO_CIPHERS_AVAILABLE": {
                "text": "SSL Error: no ciphers passed.",
                "description": "No ciphers were available."
            },
            "ADF_CLIENT_AUTH_UNKNOWN_USER": {
                "text": "Auth Error: authentication server did not recognize the user",
                "description": "Authentication server did not recognize the user"
            },
            "ADF_CLIENT_AUTH_LOGIN_FAILED": {
                "text": "Auth Error: user credentials failed",
                "description": "User credentials failed"
            },
            "ADF_CLIENT_AUTH_MISSING_CREDENTIALS": {
                "text": "Auth Error: user login failed due to missing credentials",
                "description": "User login failed due to missing credentials"
            },
            "ADF_CLIENT_AUTH_SERVER_CONN_ERROR": {
                "text": "Auth Error: authentication server connection error",
                "description": "Authentication server connection error"
            },
            "ADF_CLIENT_AUTH_USER_NOT_AUTHORIZED": {
                "text": "Auth Error: user not authorized for access",
                "description": "User not authorized for access"
            },
            "ADF_CLIENT_AUTH_TIMED_OUT": {
                "text": "Auth Error: user authentication timed out",
                "description": "User authentication timed out"
            },
            "ADF_CLIENT_AUTH_UNKNOWN_ERROR": {
                "text": "Auth Error: user authentication failed due to unknown error",
                "description": "User authentication failed due to unknown error"
            },
            "ADF_CLIENT_DNS_FAILED_INVALID_QUERY": {
                "text": "DNS query failed: invalid DNS query",
                "description": "Avi Vantage was unable to serve the DNS Query  received from the client, since the query was malformed or invalid"
            },
            "ADF_CLIENT_DNS_FAILED_INVALID_DOMAIN": {
                "text": "DNS query failed: DNS query for an excluded domain",
                "description": "Avi Vantage was unable to serve the DNS Query  received from the client, since the query was destined to an excluded domain"
            },
            "ADF_CLIENT_DNS_FAILED_NO_SERVICE": {
                "text": "DNS query failed: no configured service found",
                "description": "Avi Vantage was unable to serve the DNS Query  received from the client, since there was no configured service"
            },
            "ADF_CLIENT_DNS_FAILED_GS_DOWN": {
                "text": "DNS query failed: global service down",
                "description": "Avi Vantage was unable to serve the DNS Query  received from the client, since the global service was down"
            },
            "ADF_CLIENT_DNS_FAILED_NO_VALID_GS_MEMBER": {
                "text": "DNS query failed: no valid global service member found ",
                "description": "Avi Vantage was unable to serve the DNS Query  received from the client, since no valid global service member was found"
            },
            "ADF_SERVER_DNS_ERROR_RESPONSE": {
                "text": "DNS query failed: server returned error response",
                "description": "Avi Vantage received an error response from the server for  the DNS query received from the client"
            },
            "ADF_CLIENT_DNS_FAILED_UNSUPPORTED_QUERY": {
                "text": "DNS query failed: unsupported DNS query",
                "description": "Avi Vantage was unable to serve the DNS Query  received from the client, since the query type was not supported"
            },
            "ADF_MEMORY_EXHAUSTED": {
                "text": "Memory Exhausted: system memory exhausted",
                "description": "Avi Vantage was unable to process packets due to system memory exhaustion"
            },
            "ADF_CLIENT_DNS_POLICY_DROP": {
                "text": "DNS query: policy drop",
                "description": "Avi Vantage was unable to serve the DNS Query  received from the client, since a configured policy has dropped  the DNS query "
            },
            "ADF_CLIENT_DNS_RL_POLICY_HIT": {
                "text": " DNS query: Request has been flagged by DNS Rate Limit policy rule.",
                "description": "Avi Vantage has marked this Request for rate limiting."
            },
            "ADF_CLIENT_DNS_TCP_REQUEST_DROP_SLOW_CLIENT": {
                "text": "DNS TCP connection closed: client too slow.",
                "description": "NSX ALB closed the connection because client failed to transmit the entire DNS request within the configured time limit."
            },
            "ADF_WAF_MATCH": {
                "text": "WAF Match: WAF matched the transaction",
                "description": "WAF matched the transaction"
            },
            "ADF_CLIENT_BAD_BOT_CLASSIFICATION": {
                "text": "Bot Detection Policy mapping rules classified this client as a bad bot.",
                "description": "Bot Detection Policy mapping rules classified this client as a bad bot."
            },
            "ADF_CLIENT_DANGEROUS_BOT_CLASSIFICATION": {
                "text": "Bot Detection Policy mapping rules classified this client as a dangerous bot.",
                "description": "Bot Detection Policy mapping rules classified this client as a dangerous bot."
            },
            "ADF_HTTP2_CLIENT_TIMEDOUT": {
                "text": "HTTP2 Protocol Error: Client timed out",
                "description": "Client timed out"
            },
            "ADF_HTTP2_PROXY_PROTOCOL_ERROR": {
                "text": "HTTP2 Protocol Error: Proxy protocol error",
                "description": "Proxy protocol error"
            },
            "ADF_HTTP2_INVALID_CONNECTION_PREFACE": {
                "text": "HTTP2 Protocol Error: Invalid connection preface received",
                "description": "Invalid connection preface received"
            },
            "ADF_HTTP2_CLIENT_INVALID_DATA_FRAME_INCORRECT_LENGTH": {
                "text": "HTTP2 Protocol Error: Client sent invalid DATA frame with incorrect frame length - 0",
                "description": "Client sent invalid DATA frame with incorrect frame length - 0"
            },
            "ADF_HTTP2_CLIENT_PADDED_DATA_FRAME_WITH_INCORRECT_LENGTH": {
                "text": "HTTP2 Protocol Error: Client sent padded DATA frame with incorrect frame length",
                "description": "Client sent padded DATA frame with incorrect frame length"
            },
            "ADF_HTTP2_CLIENT_VIOLATED_CONN_FLOW_CONTROL": {
                "text": "HTTP2 Flow Control Error: Received DATA frame length from client violated connection's available window size",
                "description": "Received DATA frame length from client violated connection's available window size"
            },
            "ADF_HTTP2_CLIENT_VIOLATED_STREAM_FLOW_CONTROL": {
                "text": "HTTP2 Flow Control Error: Received DATA frame length from client violated stream's available window size",
                "description": "Received DATA frame length from client violated stream's available window size"
            },
            "ADF_HTTP2_CLIENT_DATA_FRAME_HALF_CLOSED_STREAM": {
                "text": "HTTP2 Stream Error: Client sent data on a half-closed stream",
                "description": "Client sent data on a half-closed stream"
            },
            "ADF_HTTP2_CLIENT_HEADERS_FRAME_WITH_INCORRECT_LENGTH": {
                "text": "HTTP2 Frame Size Error: Client sent HEADERS frame with incorrect length",
                "description": "Client sent HEADERS frame with incorrect length"
            },
            "ADF_HTTP2_CLIENT_HEADERS_FRAME_WITH_EMPTY_HEADER_BLOCK": {
                "text": "HTTP2 Frame Size Error: Client sent HEADERS frame with empty header block",
                "description": "Client sent HEADERS frame with empty header block"
            },
            "ADF_HTTP2_CLIENT_PADDED_HEADERS_FRAME_WITH_INCORRECT_LENGTH": {
                "text": "HTTP2 Protocol Error: Client sent padded HEADERS frame with incorrect frame length",
                "description": "Client sent padded HEADERS frame with incorrect frame length"
            },
            "ADF_HTTP2_CLIENT_HEADERS_FRAME_INCORRECT_IDENTIFIER": {
                "text": "HTTP2 Protocol Error: Client sent HEADERS frame with incorrect identifier",
                "description": "Client sent HEADERS frame with incorrect identifier"
            },
            "ADF_HTTP2_CLIENT_HEADERS_FRAME_STREAM_INCORRECT_DEPENDENCY": {
                "text": "HTTP2 Protocol Error: Client sent HEADERS frame for stream with incorrect dependency",
                "description": "Client sent HEADERS frame for stream with incorrect dependency"
            },
            "ADF_HTTP2_CONCURRENT_STREAMS_EXCEEDED": {
                "text": "HTTP2 Refused Stream Error: Concurrent streams exceeded",
                "description": "Concurrent streams exceeded"
            },
            "ADF_HTTP2_CLIENT_STREAM_DATA_BEFORE_ACK_SETTINGS": {
                "text": "HTTP2 Refused Stream Error: Client sent stream with data before settings were acknowledged",
                "description": "Client sent stream with data before settings were acknowledged"
            },
            "ADF_HTTP2_CLIENT_HEADER_BLOCK_TOO_LONG_SIZE_UPDATE": {
                "text": "HTTP2 Compression Error: Client sent header block with too long size update value",
                "description": "Client sent header block with too long size update value"
            },
            "ADF_HTTP2_CLIENT_HEADER_BLOCK_TOO_LONG_HEADER_INDEX": {
                "text": "HTTP2 Compression Error: Client sent header block with too long header index value",
                "description": "Client sent header block with too long header index value"
            },
            "ADF_HTTP2_CLIENT_HEADER_BLOCK_INCORRECT_LENGTH": {
                "text": "HTTP2 Frame Size Error: Client sent header block with incorrect length",
                "description": "Client sent header block with incorrect length"
            },
            "ADF_HTTP2_CLIENT_INVALID_HPACK_TABLE_INDEX": {
                "text": "HTTP2 Compression Error: Client sent invalid HPACK table index - 0",
                "description": "Client sent invalid HPACK table index - 0"
            },
            "ADF_HTTP2_CLIENT_OUT_OF_BOUND_HPACK_TABLE_INDEX": {
                "text": "HTTP2 Compression Error: Client sent out of bound HPACK table index",
                "description": "Client sent out of bound HPACK table index"
            },
            "ADF_HTTP2_CLIENT_INVALID_TABLE_SIZE_UPDATE": {
                "text": "HTTP2 Compression Error: Client sent invalid table size update",
                "description": "Client sent invalid table size udpate"
            },
            "ADF_HTTP2_CLIENT_HEADER_FIELD_TOO_LONG_LENGTH_VALUE": {
                "text": "HTTP2 Compression Error: Client sent header field with too long length value",
                "description": "Client sent header field with too long length value"
            },
            "ADF_HTTP2_CLIENT_EXCEEDED_HTTP2_MAX_FIELD_SIZE_LIMIT": {
                "text": "HTTP2 Frame Size Error: client exceeded compressed header size limit",
                "description": "Client exceeded compressed header size limit"
            },
            "ADF_HTTP2_CLIENT_INVALID_ENCODED_HEADER_FIELD": {
                "text": "HTTP2 Compression Error: Client sent invalid encoded header field",
                "description": "Client sent invalid encoded header field"
            },
            "ADF_HTTP2_CLIENT_EXCEEDED_HTTP2_MAX_HEADER_SIZE_LIMIT": {
                "text": "HTTP2 Error: client exceeded total header size limit.",
                "description": "Client exceeded total header size limit."
            },
            "ADF_HTTP2_CLIENT_INVALID_HEADER_NAME": {
                "text": "HTTP2 Protocol Error: Client sent invalid header name",
                "description": "Client sent invalid header name"
            },
            "ADF_HTTP2_CLIENT_HEADER_WITH_INVALID_VALUE": {
                "text": "HTTP2 Protocol Error: Client sent header with invalid value",
                "description": "Client sent header with invalid value"
            },
            "ADF_HTTP2_CLIENT_UNKNOWN_PSEUDO_HEADER": {
                "text": "HTTP2 Protocol Error: Client sent unknown pseudo-header",
                "description": "Client sent unknown pseudo-header"
            },
            "ADF_HTTP2_CLIENT_DUPLICATE_PATH_HEADER": {
                "text": "HTTP2 Protocol Error: Client sent duplicate :path header",
                "description": "Client sent duplicate :path header"
            },
            "ADF_HTTP2_CLIENT_EMPTY_PATH_HEADER": {
                "text": "HTTP2 Protocol Error: Client sent empty :path header",
                "description": "Client sent empty :path header"
            },
            "ADF_HTTP2_CLIENT_INVALID_PATH_HEADER": {
                "text": "HTTP2 Protocol Error: Client sent invalid :path header",
                "description": "Client sent invalid :path header"
            },
            "ADF_HTTP2_CLIENT_DUPLICATE_METHOD_HEADER": {
                "text": "HTTP2 Protocol Error: Client sent duplicate :method header",
                "description": "Client sent duplicate :method header"
            },
            "ADF_HTTP2_CLIENT_EMPTY_METHOD_HEADER": {
                "text": "HTTP2 Protocol Error: Client sent empty :method header",
                "description": "Client sent empty :method header"
            },
            "ADF_HTTP2_CLIENT_INVALID_METHOD_HEADER": {
                "text": "HTTP2 Protocol Error: Client sent invalid :method header",
                "description": "Client sent invalid :method header"
            },
            "ADF_HTTP2_CLIENT_DUPLICATE_SCHEME_HEADER": {
                "text": "HTTP2 Protocol Error: Client sent duplicate :scheme header",
                "description": "Client sent duplicate :scheme header"
            },
            "ADF_HTTP2_CLIENT_EMPTY_SCHEME_HEADER": {
                "text": "HTTP2 Protocol Error: Client sent empty :scheme header",
                "description": "Client sent empty :scheme header"
            },
            "ADF_HTTP2_CLIENT_NO_METHOD_HEADER": {
                "text": "HTTP2 Protocol Error: Client sent no :method header",
                "description": "Client sent no :method header"
            },
            "ADF_HTTP2_CLIENT_NO_SCHEME_HEADER": {
                "text": "HTTP2 Protocol Error: Client sent no :scheme header",
                "description": "Client sent no :scheme header"
            },
            "ADF_HTTP2_CLIENT_NO_PATH_HEADER": {
                "text": "HTTP2 Protocol Error: Client sent no :path header",
                "description": "Client sent no :path header"
            },
            "ADF_HTTP2_CLIENT_PREMATURELY_CLOSED_STREAM": {
                "text": "HTTP2 Miscellaneous Error: Client prematurely closed stream",
                "description": "Client prematurely closed stream"
            },
            "ADF_HTTP2_CLIENT_PREMATURELY_CLOSED_CONNECTION": {
                "text": "HTTP2 Miscellaneous Error: Client prematurely closed connection",
                "description": "Client prematurely closed connection"
            },
            "ADF_HTTP2_CLIENT_LARGER_DATA_BODY_THAN_DECLARED": {
                "text": "HTTP2 Protocol Error: Client intended to send body data larger than declared",
                "description": "Client intended to send body data larger than declared"
            },
            "ADF_HTTP2_CLIENT_LARGE_CHUNKED_BODY": {
                "text": "HTTP2 Protocol Error: Client intended to send too large chunked body",
                "description": "Client intended to send too large chunked body"
            },
            "ADF_HTTP2_NEGATIVE_WINDOW_UPDATE": {
                "text": "HTTP2 Miscellaneous Error: Negative window update",
                "description": "HTTP2 Negative window update"
            },
            "ADF_HTTP2_SEND_WINDOW_FLOW_CONTROL_ERROR": {
                "text": "HTTP2 Flow Control Error: Send Window larger than allowed",
                "description": "Send Window larger than allowed"
            },
            "ADF_HTTP2_CLIENT_UNEXPECTED_CONTINUATION_FRAME": {
                "text": "HTTP2 Protocol Error: Client sent unexpected CONTINUATION frame",
                "description": "Client sent unexpected CONTINUATION frame"
            },
            "ADF_HTTP2_CLIENT_WINDOW_UPDATE_INCORRECT_LENGTH": {
                "text": "HTTP2 Protocol Error: Client sent WINDOW_UPDATE frame with incorrect length",
                "description": "Client sent WINDOW_UPDATE frame with incorrect length"
            },
            "ADF_HTTP2_CLIENT_WINDOW_UPDATE_FRAME_INCORRECT_INCREMENT": {
                "text": "HTTP2 Protocol Error: Client sent WINDOW_UPDATE frame with incorrect window increment 0",
                "description": "Client sent WINDOW_UPDATE frame with incorrect window increment 0"
            },
            "ADF_HTTP2_CLIENT_WINDOW_UPDATE_FRAME_INCREMENT_NOT_ALLOWED_FOR_WINDOW": {
                "text": "HTTP2 Flow Control Error: Client violated flow control for stream by sending WINDOW_UPDATE frame with window increment disallowed for window",
                "description": "Client violated flow control for stream by sending WINDOW_UPDATE frame with window increment disallowed for window"
            },
            "ADF_HTTP2_CLIENT_GOAWAY_FRAME_INCORRECT_LENGTH": {
                "text": "HTTP2 Frame Size Error: Client sent GOAWAY frame with incorrect length",
                "description": "Client sent GOAWAY frame  with incorrect length"
            },
            "ADF_HTTP2_CLIENT_PING_FRAME_INCORRECT_LENGTH": {
                "text": "HTTP2 Frame Size Error: Client sent PING frame with incorrect length",
                "description": "Client sent PING frame with incorrect length"
            },
            "ADF_HTTP2_CLIENT_PUSH_PROMISE": {
                "text": "HTTP2 Protocol Error: Client sent PUSH PROMISE frame",
                "description": "Client sent PUSH PROMISE frame"
            },
            "ADF_HTTP2_CLIENT_SETTINGS_FRAME_INCORRECT_MAX_FRAME_SIZE": {
                "text": "HTTP2 Protocol Error: Client sent SETTINGS frame with incorrect MAX_FRAME_SIZE",
                "description": "Client sent SETTINGS frame with incorrect MAX_FRAME_SIZE"
            },
            "ADF_HTTP2_CLIENT_SETTINGS_FRAME_INCORRECT_INIIAL_WINDOW_SIZE": {
                "text": "HTTP2 Flow Control Error: Client sent SETTINGS frame with incorrect INITIAL_WINDOW_SIZE value",
                "description": "Client sent SETTINGS frame with incorrect INITIAL_WINDOW_SIZE value"
            },
            "ADF_HTTP2_CLIENT_SETTINGS_FRAME_INCORRECT_LENGTH": {
                "text": "HTTP2 Frame Size Error: Client sent SETTINGS frame with incorrect length",
                "description": "Client sent SETTINGS frame with incorrect length"
            },
            "ADF_HTTP2_CLIENT_SETTINGS_FRAME_ACK_FLAG_NONZERO_LENGTH": {
                "text": "HTTP2 Frame Size Error: Client sent SETTINGS frame with ACK flag and nonzero length",
                "description": "Client sent SETTINGS frame with ACK flag and nonzero length"
            },
            "ADF_HTTP2_CLIENT_RST_STREAM_FRAME_INCORRECT_LENGTH": {
                "text": "HTTP2 Frame Size Error: Client sent RST_STREAM frame with incorrect length",
                "description": "Client sent RST_STREAM frame with incorrect length"
            },
            "ADF_HTTP2_CLIENT_RST_STREAM_FRAME_INCORRECT_IDENTIFIER": {
                "text": "HTTP2 Protocol Error: Client sent RST_STREAM frame with incorrect identifier",
                "description": "Client sent RST_STREAM frame with incorrect identifier"
            },
            "ADF_HTTP2_CLIENT_PRIORITY_FRAME_INCORRECT_DEPENDENCY": {
                "text": "HTTP2 Protocol Error: Client sent PRIORITY frame with incorrect dependency",
                "description": "Client sent PRIORITY frame with incorrect dependency"
            },
            "ADF_HTTP2_CLIENT_PRIORITY_FRAME_INCORRECT_IDENTIFIER": {
                "text": "HTTP2 Protocol Error: Client sent PRIORITY frame with incorrect identifier",
                "description": "Client sent PRIORITY frame with incorrect identifier"
            },
            "ADF_HTTP2_CLIENT_PRIORITY_FRAME_INCORRECT_LENGTH": {
                "text": "HTTP2 Frame Size Error: Client sent PRIRORITY frame with incorrect length",
                "description": "Client sent PRIORITY frame with incorrect length"
            },
            "ADF_HTTP2_CLIENT_CONTINUATION_FRAME_INCORRECT_IDENTIFIER": {
                "text": "HTTP2 Protocol Error: Client sent CONTINUATION frame with incorrect identifier",
                "description": "Client sent CONTINUATION frame with incorrect identifier"
            },
            "ADF_HTTP2_CLIENT_CONTINUATION_FRAME_EXPECTED_INAPPROPRIATE_FRAME": {
                "text": "HTTP2 Protocol Error: Client sent inappropriate frame while CONTINUATION frame was expected",
                "description": "Client sent inappropriate frame while CONTINUATION frame was expected"
            },
            "ADF_HTTP2_CLIENT_INVALID_HEADER": {
                "text": "HTTP2 Protocol Error: Client sent invalid header",
                "description": "Client sent invalid header"
            },
            "ADF_HTTP2_CLIENT_UNEXPECTED_DATA_FRAME": {
                "text": "HTTP2 Protocol Error: Client sent DATA frame on an idle stream.",
                "description": "Client sent DATA frame on an idle stream."
            },
            "ADF_HTTP2_CLIENT_UNEXPECTED_RST_FRAME": {
                "text": "HTTP2 Protocol Error: Client sent RST frame on an idle stream.",
                "description": "Client sent RST frame on an idle stream."
            },
            "ADF_HTTP2_CLIENT_UNEXPECTED_WINDOW_UPDATE_FRAME": {
                "text": "HTTP2 Protocol Error: Client sent WINDOW_UPDATE frame on an idle stream.",
                "description": "Client sent WINDOW_UPDATE frame on an idle stream."
            },
            "ADF_HTTP2_CLIENT_SENT_PING_NONZERO_ID": {
                "text": "HTTP2 Protocol Error: Client sent PING frame with non-zero stream id.",
                "description": "Client sent PING frame with non-zero stream id."
            },
            "ADF_HTTP2_CLIENT_SENT_SETTINGS_NONZERO_ID": {
                "text": "HTTP2 Protocol Error: Client sent SETTINGS frame with non-zero stream id.",
                "description": "Client sent SETTINGS frame with non-zero stream id."
            },
            "ADF_HTTP2_CLIENT_SENT_GOAWAY_NONZERO_ID": {
                "text": "HTTP2 Protocol Error: Client sent GOAWAY frame with non-zero stream id.",
                "description": "Client sent GOAWAY frame with non-zero stream id."
            },
            "ADF_HTTP2_CLIENT_HEADER_FRAME_UNEXPECTED_PSEUDO_HEADER": {
                "text": "HTTP2 Protocol Error: Client sent a pseudo-header after regular header.",
                "description": "Client sent a pseudo-header after regular header."
            },
            "ADF_HTTP2_CLIENT_DATA_FRAME_INCORRECT_IDENTIFIER": {
                "text": "HTTP2 Protocol Error: Client sent DATA frame with incorrect identifier.",
                "description": "Client sent DATA frame with incorrect identifier."
            },
            "ADF_HTTP2_CLIENT_HEADER_FRAME_CONNECTION_SPECIFIC_HDR": {
                "text": "HTTP2 Protocol Error: Client sent connection-specific headers in header frame.",
                "description": "Client sent connection-specific headers in header frame."
            },
            "ADF_HTTP2_CLIENT_HEADER_FRAME_INCORRECT_TE_HDR": {
                "text": "HTTP2 Protocol Error: Client sent Transfer Encoding header with incorrect value in header frame.",
                "description": "Client sent TE header with incorrect value in header frame."
            },
            "ADF_HTTP2_CLIENT_CONTROL_FRAME_FLOOD_DETECTED": {
                "text": "HTTP2 Flood Detected: Too many control frames need to be sent back to client.",
                "description": "Too many control frames need to be sent back to client."
            },
            "ADF_HTTP2_FRAME_TO_CLIENT_FLOOD_DETECTED": {
                "text": "HTTP2 Flood Detected: Too many frames are queued waiting to be sent to client.",
                "description": "Too many data frames are queued waiting to be sent to client."
            },
            "ADF_HTTP2_CLIENT_EMPTY_DATA_FRAME_FLOOD_DETECTED": {
                "text": "HTTP2 Flood Detected: Client sent too many empty data frames without End of Stream flag set.",
                "description": "Client sent too many empty frames without End of Stream flag set."
            },
            "ADF_HTTP2_CLIENT_ZERO_HEAD_NAME": {
                "text": "HTTP2 Protocol Error: Client sent zero length header name.",
                "description": "Client sent zero length header name."
            },
            "ADF_HTTP2_CLIENT_EXCEEDED_HTTP2_MAX_SINGLE_HEADER_SIZE_LIMIT": {
                "text": "HTTP2 Error: client exceeded single header size limit.",
                "description": "Client exceeded single header size limit."
            },
            "ADF_HTTP2_CLIENT_RST_FRAME_FLOOD_DETECTED": {
                "text": "HTTP2 Flood Detected: Client sent too many RST_STREAM frames.",
                "description": "Client sent too many RST_STREAM frames."
            },
            "ADF_HTTP2_CLIENT_INVALID_FRAMES_FLOOD_DETECTED": {
                "text": "HTTP2 Flood Detected: The client sent too many frames that were refused.",
                "description": "The client sent too many frames that were refused."
            },
            "ADF_USER_DELETE_OPERATION_DATASCRIPT_RESET_CONN": {
                "text": "Connection closed abnormally: connection was closed by datascript",
                "description": "The connection was reset by adatascript installed by user"
            },
            "ADF_USER_DELETE_OPERATION_HTTP_RULE_SECURITY_ACTION_CLOSE_CONN": {
                "text": "Connection closed abnormally: connection was closed by HTTP policy action",
                "description": "The connection was reset due to a close action in HTTP security policy on the VS."
            },
            "ADF_USER_DELETE_OPERATION_HTTP_RULE_SECURITY_RATE_LIMIT_ACTION_CLOSE_CONN": {
                "text": "Connection closed abnormally: connection was closed by HTTP policy rate-limit action",
                "description": "The connection was reset due to a close action in HTTP security policy while rate-limiting flows on VS"
            },
            "ADF_USER_DELETE_OPERATION_HTTP_RULE_MISSING_TOKEN_ACTION_CLOSE_CONN": {
                "text": "Connection closed abnormally: connection was closed while trying to find the configured tokens in URL",
                "description": "The connection was reset on failure to find configured tokens in url"
            },
            "ADF_HTTP_BAD_REQUEST_INVALID_HOST_IN_REQUEST_LINE": {
                "text": "Request abnormal event: client sent an invalid host in the request line",
                "description": "Found an invalid host in the request line while parsing."
            },
            "ADF_HTTP_BAD_REQUEST_RECEIVED_VERSION_LESS_THAN_10": {
                "text": "Request abnormal event: client sent a request with version less than 1.0",
                "description": "Found invalid version less than 1.0 in request."
            },
            "ADF_HTTP_NOT_ALLOWED_DATASCRIPT_RESPONSE_RETURNED_4XX": {
                "text": "Datascript error: a datascript attached to the VS returned a 4xx response",
                "description": "Datascript attached to the VS returned a 4xx response."
            },
            "ADF_HTTP_NOT_ALLOWED_RUM_FLAGGED_INVALID_METHOD": {
                "text": "Request abnormal event: RUM module cannot handle HTTP request method",
                "description": "RUM can only handle GET and POST. Incoming request method isn't one of them."
            },
            "ADF_HTTP_CONTENT_LENGTH_HDR_WITH_UNSUPPORTED_METHOD": {
                "text": "Request abnormal event: Content-Length header sent on request method with no body semantics.",
                "description": "Client sent a Content-Length header on a request, where the method has no defined semantics for a request body. (Like GET or HEAD)"
            },
            "ADF_HTTP_NOT_ALLOWED_UNSUPPORTED_TRACE_METHOD": {
                "text": "Request abnormal event: client sent HTTP TRACE method which is currently not supported",
                "description": "Client sent HTTP TRACE method which is currently not supported"
            },
            "ADF_HTTP_REQUEST_TIMEOUT_WAITING_FOR_CLIENT": {
                "text": "Connection abnormal event: request timed out while waiting for client",
                "description": "Request timed out while waiting for client"
            },
            "ADF_HTTP_BAD_REQUEST_CLIENT_SENT_INVALID_CONTENT_LENGTH": {
                "text": "Request abnormal event: client sent an invalid content length",
                "description": "Client sent an invalid content length"
            },
            "ADF_HTTP_BAD_REQUEST_CLIENT_SENT_HTTP11_WITHOUT_HOST_HDR": {
                "text": "Request abnormal event: client sent a HTTP 1.1 request without Host header",
                "description": "Client sent a HTTP 1.1 request without Host header"
            },
            "ADF_HTTP_BAD_REQUEST_FAILED_TO_PARSE_URI": {
                "text": "Request abnormal event: client sent a URI which failed to parse",
                "description": " Failed to parse a URI received from the client"
            },
            "ADF_HTTP_BAD_REQUEST_INVALID_HEADER_LINE": {
                "text": "Request abnormal event: client sent an invalid header line",
                "description": "The newline character was missing after the carriage returnin a header line"
            },
            "ADF_HTTP_BAD_REQUEST_ERROR_WHILE_READING_CLIENT_HEADERS": {
                "text": "Request abnormal event: there was an error while reading client headers",
                "description": "There was an error while reading client headers"
            },
            "ADF_HTTP_BAD_REQUEST_CLIENT_SENT_DUPLICATE_HEADER": {
                "text": "Request abnormal event: client sent duplicate header",
                "description": "Among the list of headers sent by client, there was a duplicate"
            },
            "ADF_HTTP_BAD_REQUEST_CLIENT_SENT_INVALID_HOST_HEADER": {
                "text": "Request abnormal event: client sent invalid host header",
                "description": "Host header sent by client is invalid"
            },
            "ADF_HTTP_NOT_IMPLEMENTED_CLIENT_SENT_UNKNOWN_TRANSFER_ENCODING": {
                "text": "Request abnormal event: client sent unknown transfer encoding",
                "description": "Client sent unknown transfer encoding"
            },
            "ADF_HTTP_BAD_REQUEST_REQUESTED_SERVER_NAME_DIFFERS": {
                "text": "Request abnormal event: client attempted to request a different server name",
                "description": "Client attempted to request a server name that wasdifferent from the one that was negotiated."
            },
            "ADF_HTTP_BAD_REQUEST_CLIENT_SENT_INVALID_CHUNKED_BODY": {
                "text": "Request abnormal event: client sent invalid chunked body",
                "description": "Client sent invalid chunked body"
            },
            "ADF_HTTP_BAD_REQUEST_INVALID_HEADER_IN_SPDY": {
                "text": "Request abnormal event: encountered an invalid header during SPDY header parsing",
                "description": "Encountered an invalid header during SPDY header parsing"
            },
            "ADF_HTTP_BAD_REQUEST_INVALID_HEADER_BLOCK_IN_SPDY": {
                "text": "Request abnormal event: client sent invalid header block while processing SPDY stream",
                "description": "Client sent invalid header block while processing SPDY stream"
            },
            "ADF_HTTP_BAD_REQUEST_DATA_ERROR_IN_SPDY": {
                "text": "Request abnormal event: error while processing SPDY data",
                "description": "Error while processing SPDY data"
            },
            "ADF_HTTP_BAD_REQUEST_NO_METHOD_URI_OR_PROT_IN_REQ_CREATE_SPDY": {
                "text": "Request abnormal event: no method or uri or protocol seen while constructing SPDY request",
                "description": "No method or uri or protocol seen while constructing SPDY request"
            },
            "ADF_HTTP_BAD_REQUEST_CLIENT_PREMATURELY_CLOSED_SPDY_STREAM": {
                "text": "Connection closed abnormally: client prematurely closed SPDY stream",
                "description": "Client prematurely closed SPDY stream"
            },
            "ADF_HTTP_BAD_REQUEST_DATA_ERROR_IN_SPDY_READ_REQ_BODY": {
                "text": "Request abnormal event: data error while reading SPDY request body",
                "description": "Data error while reading SPDY request body"
            },
            "ADF_HTTP_BAD_REQUEST_CERT_ERROR": {
                "text": "SSL Error: client SSL certificate verify error",
                "description": "Client SSL certificate verify error"
            },
            "ADF_HTTP_BAD_REQUEST_PLAIN_HTTP_REQUEST_SENT_ON_HTTPS_PORT": {
                "text": "SSL Error: client sent a plain request on HTTPS port",
                "description": "Client sent a plain request on HTTPS port"
            },
            "ADF_HTTP_BAD_REQUEST_PLAIN_HTTP_REQUEST_SENT_ON_HTTPS_PORT_RESET_CONN": {
                "text": "SSL Error: connection reset because client sent a plain request on HTTPS port",
                "description": "Connection reset because client sent a plain request on HTTPS port"
            },
            "ADF_HTTP_BAD_REQUEST_NO_CERT_ERROR": {
                "text": "SSL Error: client sent no required SSL certificate",
                "description": "Client sent no required SSL certificate"
            },
            "ADF_HTTP_BAD_REQUEST_HEADER_TOO_LARGE": {
                "text": "Request abnormal event: client sent too long request or header",
                "description": "Client sent too long request or header"
            },
            "ADF_SERVER_HIGH_RESPONSE_TIME_L7": {
                "text": "Connection abnormal event: HTTP Server took longer than configured threshold to respond",
                "description": "HTTP Server took longer than configured threshold to respond"
            },
            "ADF_SERVER_HIGH_RESPONSE_TIME_L4": {
                "text": "Connection abnormal event: TCP Server took longer than expected to respond",
                "description": "TCP Server took longer than expected to respond"
            },
            "ADF_COOKIE_SIZE_GREATER_THAN_MAX": {
                "text": "Request abnormal event: cookie size in the incoming request was greater than the maximum possible size",
                "description": "Cookie size in the incoming request was greater than the maximum possible size"
            },
            "ADF_COOKIE_SIZE_LESS_THAN_MIN_COOKIE_LEN": {
                "text": "Request abnormal event: cookie size in the incoming request was lesser than the minimum expected cookie size",
                "description": "Cookie size in the incoming request was lesser than the minimum expected cookie size"
            },
            "ADF_PERSISTENCE_PROFILE_KEYS_NOT_CONFIGURED": {
                "text": "Persistence Error: persistence Profile Keys were not configured",
                "description": "Persistence Profile Keys were not configured"
            },
            "ADF_PERSISTENCE_COOKIE_VERSION_MISMATCH": {
                "text": "Request abnormal event: cookie version in the incoming request does not match the expected version",
                "description": "Cookie version in the incoming request does not match the expected version"
            },
            "ADF_COOKIE_ABSENT_FROM_KEYS_IN_PERSISTENCE_PROFILE": {
                "text": "Persistence Error: cookie key is not in the list of keys configured in the persistence profile",
                "description": "Cookie key is not in the list of keys configured in the persistence profile"
            },
            "ADF_GSLB_SITE_PERSISTENCE_REMOTE_SITE_DOWN": {
                "text": "Persistence Error: request was intended for a remote site, but remote site was down",
                "description": "Request was intended for a remote site, but remote site was down"
            },
            "ADF_HTTP_NOT_ALLOWED_DATASCRIPT_RESPONSE_RETURNED_5XX": {
                "text": "Datascript Error: a datascript attached to the VS returned a 5xx response.",
                "description": "A datascript attached to the VS returned a 5xx response."
            },
            "ADF_SERVER_UPSTREAM_TIMEOUT": {
                "text": "Connection abnormal event: HTTP Server took longer than configured time to respond",
                "description": "HTTP Server took longer than configured time to respond"
            },
            "ADF_SERVER_UPSTREAM_READ_ERROR": {
                "text": "Upstream Error: data error while reading from server",
                "description": "Data error while reading from server"
            },
            "ADF_SERVER_UPSTREAM_RESOLVER_ERROR": {
                "text": "Connection abnormal event: can't resolve server address",
                "description": "Can't resolve server address"
            },
            "ADF_SIP_INVALID_MESSAGE_FROM_CLIENT": {
                "text": "SIP error: Can not parse message from a client",
                "description": "Can not parse SIP message sent by a client"
            },
            "ADF_SIP_MESSAGE_UPDATE_FAILED": {
                "text": "SIP error: Can not update SIP message",
                "description": "Can not update SIP message"
            },
            "ADF_SIP_SERVER_UNKNOWN_CALLID": {
                "text": "SIP error: Server sent a SIP message with unknown CallId header",
                "description": "Server sent a SIP message with unknown CallId header"
            },
            "ADF_SIP_REQUEST_FAILED": {
                "text": "SIP error: request failed",
                "description": "SIP request failed"
            },
            "ADF_SIP_REQUEST_TIMEDOUT": {
                "text": "SIP error: Either app transaction timeout or connection idle timeout occurred in middle of transaction",
                "description": "SIP request timed out"
            },
            "ADF_SIP_CONN_IDLE_TIMEDOUT": {
                "text": "SIP Proxy Profile Timeout: connection idle timeout occurred, closing the connection",
                "description": "Proxy profile connection timeout occurred"
            },
            "ADF_SIP_TRANSACTION_TIMEDOUT": {
                "text": "SIP Proxy Profile Timeout: transaction timeout occurred, closing server side connection",
                "description": "Proxy profile transaction timeout occurred"
            },
            "ADF_SIP_SVR_UDP_PORT_NOT_REACHABLE": {
                "text": "SIP server connectivity failed: server UDP port unreachable",
                "description": "ICMP port unreachable was received when client's message was sent to the server. Either the server is not listening to UDP on the port or duplicate server IP in the network."
            },
            "ADF_SIP_CLT_UDP_PORT_NOT_REACHABLE": {
                "text": "SIP client connectivity failed: client UDP port unreachable",
                "description": "ICMP port unreachable was received when server's message was sent to the client. Either the client has closed the UDP port or duplicate client IP in the network."
            },
            "ADF_SIP_INVALID_MESSAGE_FROM_SERVER": {
                "text": "SIP error: Can not parse message from server",
                "description": "Can not parse SIP message sent by server"
            },
            "ADF_L4_DATASCRIPT_DROP": {
                "text": "L4 Datascript Action: Drop packet",
                "description": "Packet dropped due to L4 Datascript action"
            },
            "ADF_DATASCRIPT_SIGNIFICANCE": {
                "text": "DataScript Significant Log.",
                "description": "Request marked significant by DataScript."
            },
            "ADF_SAML_COOKIE_VERSION_MISMATCH": {
                "text": "Request abnormal event: SAML authentication cookie version in the incoming request does not match the expected version",
                "description": "SAML authentication cookie version in the incoming request does not match the expected version"
            },
            "ADF_SAML_COOKIE_KEYS_NOT_CONFIGURED": {
                "text": "SAML authentication error: cookie keys were not configured in the SAML authentication policy.",
                "description": "Cookie keys were not configured in the SAML authentication policy."
            },
            "ADF_SAML_COOKIE_ABSENT_FROM_KEYS_IN_SAML_AUTH_POLICY": {
                "text": "SAML authentication Error: cookie key is not in the list of keys configured in the SAML authentication policy.",
                "description": "Cookie key is not in the list of keys configured in the SAML authentication policy."
            },
            "ADF_SAML_COOKIE_INVALID": {
                "text": "SAML authentication Error: invalid handshake cookie.",
                "description": "Received an invalid cookie."
            },
            "ADF_SAML_COOKIE_DECRYPTION_ERROR": {
                "text": "SAML authentication Error: failed to decrypt the cookie.",
                "description": "Failed to decrypt the cookie."
            },
            "ADF_SAML_COOKIE_ENCRYPTION_ERROR": {
                "text": "SAML authentication Error: failed to encrypt the cookie.",
                "description": "Failed to encrypt the cookie."
            },
            "ADF_SAML_COOKIE_DECODE_ERROR": {
                "text": "SAML authentication Error: failed to decode the cookie.",
                "description": "Failed to decode the cookie."
            },
            "ADF_SAML_COOKIE_SESSION_COOKIE_GREATER_THAN_MAX": {
                "text": "SAML warning: SAML assertion attribute value is larger than the maximum session cookie size.",
                "description": "SAML assertion attribute values larger than the maximum session cookie size."
            },
            "ADF_SAML_COOKIE_HANDSHAKE_COOKIE_GREATER_THAN_MAX": {
                "text": "SAML warning: SAML Handshake cookie is greater than the maximum cookie size.",
                "description": "SAML Handshake cookie is greater than the maximum cookie size."
            },
            "ADF_SAML_ASSERTION_DOES_NOT_MATCH_REQUEST_ID": {
                "text": "SAML authentication error: SAML Assertion does not match Request ID  awaiting response.",
                "description": "SAML authentication error: SAML Assertion does not match Request ID  awaiting response."
            },
            "ADF_SAML_AUTHENTICATION_UNSUPPORTED_METHOD": {
                "text": "SAML authentication error: SAML authentication can not be initiated for non-GET methods.",
                "description": "SAML authentication doesn't support any HTTP method other than GET for requests coming in with an expired or invalid session cookie."
            },
            "ADF_SAML_COOKIE_SESSION_COOKIE_TIMEOUT": {
                "text": "SAML authentication warning: SAML session cookie has expired. Reauthentication is required.",
                "description": "SAML session cookie has expired. Reauthentication is required."
            },
            "ADF_SAML_ACS_URL_MISMATCH": {
                "text": "SAML authentication error: Assertion Consumer Service (ACS) URL doesn't match the one configured on VS.",
                "description": "Assertion Consumer Service (ACS) URL doesn't match the one configured on VS."
            },
            "ADF_SAML_ASSERTION_NO_BODY": {
                "text": "SAML authentication error: Received an empty assertion from IDP.",
                "description": "Assertion is empty."
            },
            "ADF_SAML_ASSERTION_INVALID": {
                "text": "SAML authentication error: Failed to process SAML assertion.",
                "description": "Failed to process SAML assertion."
            },
            "ADF_SAML_ASSERTION_ATTRIBUTE_ERROR": {
                "text": "SAML authentication error: Failed to extract attributes from SAML assertion.",
                "description": "Failed to extract attributes from SAML assertion."
            },
            "ADF_SAML_LOGIN_ERROR": {
                "text": "SAML authentication error: Unable to get SAML login information from lasso server.",
                "description": "Unable to get SAML login information from lasso server"
            },
            "ADF_SAML_DECRYPT_ASSERTION_FAILURE": {
                "text": "SAML authentication error: Failed to decrypt SAML assertion.",
                "description": "Failed to decrypt SAML assertion."
            },
            "ADF_SAML_LASSO_PROFILE_ERROR_INVALID_MSG": {
                "text": "SAML authentication error: Invalid SAML Response.",
                "description": "Invalid SAML Response."
            },
            "ADF_SAML_LASSO_PROFILE_ERROR_MISSING_STATUS_CODE": {
                "text": "SAML authentication error: Status code is missing in the SAML Response.",
                "description": "Status code is missing in the SAML Response."
            },
            "ADF_SAML_LASSO_LOGIN_ERROR_REQUEST_DENIED": {
                "text": "SAML Request Denied: The IDP is able to process the request, but has chosen not to respond due to concerns about the security context of the request message.",
                "description": "The IDP is able to process the request, but has chosen not to respond due to concerns about the security context of the request message."
            },
            "ADF_SAML_LASSO_LOGIN_ERROR_STATUS_NOT_SUCCESS": {
                "text": "SAML authentication error: Status code is not Success.",
                "description": "Status code is not Success."
            },
            "ADF_SAML_LASSO_PROFILE_ERROR_UNSUPPORTED_PROFILE": {
                "text": "SAML unsupported profile: Only HTTP-Post binding is supported.",
                "description": "SAML unsupported profile: Only HTTP-Post binding is supported."
            },
            "ADF_SAML_LASSO_PROFILE_ERROR_MISSING_RESPONSE": {
                "text": "SAML authentication error: Missing SAML Response.",
                "description": "Missing SAML Response."
            },
            "ADF_SAML_LASSO_LOGIN_ERROR_ASSERTION_REPLAY": {
                "text": "SAML authentication error: SAML Assertion Replay.",
                "description": "SAML Assertion replay."
            },
            "ADF_SAML_LASSO_PROFILE_ERROR_MISSING_NAME_IDENTIFIER": {
                "text": "SAML authentication error: Name Identifier is missing from the SAML Assertion.",
                "description": "Name Identifier is missing from the SAML Assertion."
            },
            "ADF_SAML_LASSO_PROFILE_ERROR_MISSING_SERVER": {
                "text": "SAML authentication error: Lasso server is not available in the Lasso Profile .",
                "description": "Lasso server is not available in the Lasso Profile ."
            },
            "ADF_SAML_LASSO_PROFILE_ERROR_INVALID_REQUEST": {
                "text": "SAML authentication error: The SAML request received is not SAML P2 AuthN Request.",
                "description": "The SAML request received is not SAML P2 AuthN Request."
            },
            "ADF_SAML_AUTHENTICATION_ERROR": {
                "text": "An error occurred during SAML authentication process.",
                "description": "An error occurred during SAML authentication process."
            },
            "ADF_SAML_AUTHENTICATION_RULE_NOMATCH": {
                "text": "None of the SAML authentication policy rules matched.",
                "description": "None of the SAML authentication policy rules matched."
            },
            "ADF_SAML_AUTHORIZATION_RULE_NOMATCH": {
                "text": "None of the SAML authorization policy rules matched.",
                "description": "None of the SAML authorization policy rules matched."
            },
            "ADF_SAML_AUTHENTICATION_SKIPPED_RULE_MATCH": {
                "text": "SAML authentication skipped due to policy rules match.",
                "description": "SAML authentication skipped due to policy rules match."
            },
            "ADF_SAML_AUTHORIZATION_FAILED_RULE_MATCH": {
                "text": "SAML authorization failed due to policy rule match.",
                "description": "SAML authorization failed due to policy rule match."
            },
            "ADF_SAML_AUTHENTICATION_DISABLED_BY_DS": {
                "text": "SAML authentication is disabled by the Datascript.",
                "description": "SAML authentication is disabled by the Datascript."
            },
            "ADF_SSO_AUTHENTICATION_RULE_NOMATCH": {
                "text": "None of the authentication policy rules matched.",
                "description": "None of the authentication policy rules matched."
            },
            "ADF_SSO_AUTHORIZATION_RULE_NOMATCH": {
                "text": "None of the authorization policy rules matched.",
                "description": "None of the authorization policy rules matched."
            },
            "ADF_SSO_AUTHENTICATION_SKIPPED_RULE_MATCH": {
                "text": "Authentication skipped due to policy rules match.",
                "description": "Authentication skipped due to policy rules match."
            },
            "ADF_SSO_AUTHORIZATION_FAILED_RULE_MATCH": {
                "text": "Authorization failed due to policy rule match.",
                "description": "Authorization failed due to policy rule match."
            },
            "ADF_SAML_AUTH_INVALID_POST_REQUEST": {
                "text": "Invalid POST request to single signon url with valid session cookie.",
                "description": "Invalid POST request to single signon url with valid session cookie."
            },
            "ADF_SAML_AUTH_SIGNATURE_VERIFICATION_FAILED": {
                "text": "SAML authentication error: Signature verification failed.",
                "description": "SAML authentication error: Signature verification failed."
            },
            "ADF_HTTP_SERVER_RESELECT_OCCURRENCE": {
                "text": "HTTP Server Reselect triggered: At least one server did not respond correctly.",
                "description": "HTTP Server Reselect was triggered suggesting that at least one server did not respond correctly."
            },
            "ADF_HTTP_SERVER_RESELECT_SKIP_V1_SERVER_AFTER_SENT_V2_REQ": {
                "text": "HTTP Server Reselect triggered: Skip the HTTP/1.x server after sending an HTTP/2 request.",
                "description": "HTTP Server Reselect triggered: Skip the HTTP/1.x server after sending an HTTP/2 request."
            },
            "ADF_HTTP_SERVER_RESELECT_SKIP_V2_SERVER_AFTER_SENT_V1_REQ": {
                "text": "HTTP Server Reselect triggered: Skip the HTTP/2 server after sending an HTTP/1.x request.",
                "description": "HTTP Server Reselect triggered: Skip the HTTP/2 server after sending an HTTP/1.x request."
            },
            "ADF_HTTP_RULE_SECURITY_RATE_LIMIT_ACTION_REPORT": {
                "text": "Request flagged: An HTTP security policy with a 'report only' rate limit action flagged this request.",
                "description": "The request was flagged by a 'report only' action in an HTTP security policy while rate-limiting flows on VS."
            },
            "ADF_HTTP_RULE_SECURITY_RATE_LIMIT_ACTION_REDIRECT": {
                "text": "Request ended abnormally: Request was redirected by an HTTP security policy with a 'redirect' rate limit action.",
                "description": "The client was redirected by a 'redirect' action in an HTTP security policy while rate-limiting flows on VS."
            },
            "ADF_HTTP_RULE_SECURITY_RATE_LIMIT_ACTION_RESPONSE": {
                "text": "Request ended abnormally: Request was sent a local response by an HTTP security policy with a 'local response' rate limit action.",
                "description": "A response was sent to the client by a 'local response' action in an HTTP security policy while rate-limiting flows on VS."
            },
            "ADF_HTTP_RULE_REDIRECT_ACTION_FAILED": {
                "text": "Redirect error: URI does not contain the tokens specified in rewrite/redirect action. Request was sent unmodified.",
                "description": "The request URI does not contain the tokens specified in the redirect action."
            },
            "ADF_HTTP_RULE_REDIRECT_ACTION_FAILED_WITH_IP_ADDRESS": {
                "text": "Redirect error: URI contains a valid IPv4 address in rewrite/redirect action which cannot be tokenized. Request was sent unmodified.",
                "description": "The request URI contains a valid IPv4 address in the redirect action so URI can't be tokenized."
            },
            "ADF_HTTP2_SERVER_SENT_UNEXPECTED_FRAME": {
                "text": "HTTP2 Protocol Error: Server sent unexpected frame before headers.",
                "description": "Server sent unexpected frame before headers."
            },
            "ADF_HTTP2_SERVER_SENT_FRAME_UNKNOWN_STREAM": {
                "text": "HTTP2 Protocol Error: Server sent frame for unknown stream.",
                "description": "Server sent frame for unknown stream."
            },
            "ADF_HTTP2_SERVER_REJECTED_REQUEST_WITH_ERROR": {
                "text": "HTTP2 Protocol Error: Server rejected request.",
                "description": "Server rejected request."
            },
            "ADF_HTTP2_SERVER_SENT_GOAWAY_WITH_ERROR": {
                "text": "HTTP2 Protocol Error: Server Sent GOAWAY frame with error.",
                "description": "Server Sent GOAWAY frame with error."
            },
            "ADF_HTTP2_SERVER_SENT_UNEXPECTED_PUSH_PROMISE": {
                "text": "HTTP2 Protocol Error: Server sent unexpected push promise frame.",
                "description": "Server sent unexpected push promise frame."
            },
            "ADF_HTTP2_SERVER_SENT_INVALID_HEADER": {
                "text": "HTTP2 Protocol Error: Server sent invalid header.",
                "description": "Server sent invalid header."
            },
            "ADF_HTTP2_SERVER_SENT_DUP_STATUS_HEADER": {
                "text": "HTTP2 Protocol Error: Server sent duplicate status.",
                "description": "Server sent duplicate status."
            },
            "ADF_HTTP2_SERVER_SENT_INVALID_STATUS_HEADER": {
                "text": "HTTP2 Protocol Error: Server sent invalid status.",
                "description": "Server sent invalid status."
            },
            "ADF_HTTP2_SERVER_SENT_LARGE_HEADER_NAME_LEN": {
                "text": "HTTP2 Protocol Error: Server sent header name length larger than the expected value.",
                "description": "Server sent header name length larger than the expected value."
            },
            "ADF_HTTP2_SERVER_NO_STATUS_HEADER": {
                "text": "HTTP2 Protocol Error: Didn not receive status from Server.",
                "description": "Did not receive status from Server."
            },
            "ADF_HTTP2_SERVER_SENT_DATA_FOR_UNKNOWN_STREAM": {
                "text": "HTTP2 Protocol Error: Server sent data for unknown stream.",
                "description": "Server sent data for unknown stream."
            },
            "ADF_HTTP2_SERVER_STREAM_FLOW_CONTROL_VIOLATION": {
                "text": "HTTP2 Flow Control Error: Server sent DATA frame length which violated stream's available window size.",
                "description": "Server sent DATA frame length which violated stream's available window size."
            },
            "ADF_HTTP2_SERVER_CONN_FLOW_CONTROL_VIOLATION": {
                "text": "HTTP2 Flow Control Error: Server sent DATA frame length which violated connection's available window size.",
                "description": "Server sent DATA frame length which violated connection's available window size."
            },
            "ADF_HTTP2_SERVER_SENT_INVALID_TRAILER": {
                "text": "HTTP2 Protocol Error: Server sent invalid trailer.",
                "description": "Server sent invalid trailer."
            },
            "ADF_HTTP2_SERVER_SENT_TRAILER_NO_ENDSTREAM_FLAG": {
                "text": "HTTP2 Protocol Error: Server sent trailer without end stream flag.",
                "description": "Server sent trailer without end stream flag."
            },
            "ADF_HTTP2_SERVER_SENT_SHORT_FRAME": {
                "text": "HTTP2 Frame Size Error: Server sent frame shorter than the expected length.",
                "description": "Server sent frame shorter than the expected length."
            },
            "ADF_HTTP2_SERVER_SENT_FRAME_LONG_PADDING": {
                "text": "HTTP2 Frame Size Error: Server sent frame with padding that was too long.",
                "description": "Server sent frame with padding that was too long."
            },
            "ADF_HTTP2_SERVER_SENT_LARGE_FRAME": {
                "text": "HTTP2 Frame Size Error: Server sent frame larger than the expected length.",
                "description": "Server sent frame larger than the expected length."
            },
            "ADF_HTTP2_SERVER_SENT_FRAME_INVALID_LENGTH": {
                "text": "HTTP2 Frame Size Error: Server sent frame with invalid length.",
                "description": "Server sent frame with invalid length."
            },
            "ADF_HTTP2_SERVER_SENT_TRUNCATED_HEADER": {
                "text": "HTTP2 Frame Size Error: Server sent truncated header.",
                "description": "Server sent truncated header."
            },
            "ADF_HTTP2_SERVER_SENT_INVALID_TABLE_INDEX": {
                "text": "HTTP2 Compression Error: Server sent invalid HPACK table index.",
                "description": "Server sent invalid HPACK table index."
            },
            "ADF_HTTP2_SERVER_SENT_INVALID_TABLE_SIZE_UPDATE": {
                "text": "HTTP2 Compression Error: Server sent header block with invalid table size update.",
                "description": "Server sent header block with invalid table size update."
            },
            "ADF_HTTP2_SERVER_SENT_TABLE_INDEX_CONT_FLAG": {
                "text": "HTTP2 Compression Error: Server sent table index with continuation flag.",
                "description": "Server sent table index with continuation flag."
            },
            "ADF_HTTP2_SERVER_SENT_ZERO_HEADER_NAME_LEN": {
                "text": "HTTP2 Protocol Error: Server sent zero header name length.",
                "description": "Server sent zero header name length."
            },
            "ADF_HTTP2_SERVER_SENT_INVALID_ENCODED_HEADER": {
                "text": "HTTP2 Compression Error: Server sent invalid encoded header field.",
                "description": "Server sent invalid encoded header field."
            },
            "ADF_HTTP2_SERVER_SENT_RST_INVALID_LENGTH": {
                "text": "HTTP2 Frame Size Error: Server sent RST_STREAM frame with incorrect length.",
                "description": "Server sent RST_STREAM frame with incorrect length."
            },
            "ADF_HTTP2_SERVER_SENT_GOAWAY_NONZERO_ID": {
                "text": "HTTP2 Protocol Error: Server sent GOAWAY frame with non-zero stream id.",
                "description": "Server sent GOAWAY frame with non-zero stream id."
            },
            "ADF_HTTP2_SERVER_SENT_GOAWAY_INVALID_LEN": {
                "text": "HTTP2 Frame Size Error: Server sent GOAWAY frame with incorrect length.",
                "description": "Server sent GOAWAY frame with incorrect length"
            },
            "ADF_HTTP2_SERVER_SENT_WIN_UPDATE_INVALID_LEN": {
                "text": "HTTP2 Protocol Error: Server sent WINDOW_UPDATE frame with incorrect length.",
                "description": "Server sent WINDOW_UPDATE frame with incorrect length."
            },
            "ADF_HTTP2_SERVER_SENT_WIN_UPDATE_LARGE_LEN": {
                "text": "HTTP2 Protocol Error: Server sent WINDOW_UPDATE frame with length larger than the expected value.",
                "description": "Server sent WINDOW_UPDATE frame with length larger than the expected value."
            },
            "ADF_HTTP2_SERVER_SENT_SETTINGS_NONZERO_ID": {
                "text": "HTTP2 Protocol Error: Server sent settings frame with non-zero stream id.",
                "description": "Server sent settings frame with non-zero stream id."
            },
            "ADF_HTTP2_SERVER_SENT_SETTINGS_ACK_NONZERO_ID": {
                "text": "HTTP2 Protocol Error: Server sent settings frame with ack flag and non-zero length.",
                "description": "Server sent settings frame with ack flag and non-zero length."
            },
            "ADF_HTTP2_SERVER_SENT_SETTINGS_INVALID_LEN": {
                "text": "HTTP2 Frame Size Error: Server sent SETTINGS frame with incorrect length.",
                "description": "Server sent SETTINGS frame with incorrect length."
            },
            "ADF_HTTP2_SERVER_SENT_SETTING_LARGE_INI_WIN_SIZE": {
                "text": "HTTP2 Frame Size Error: Server sent settings frame with initial window size larger than the expected value.",
                "description": "Server sent settings frame with initial window size larger than the expected value."
            },
            "ADF_HTTP2_SERVER_SENT_PING_NONZERO_ID": {
                "text": "HTTP2 Protocol Error: Server sent ping frame with non-zero stream id.",
                "description": "Server sent ping frame with non-zero stream id."
            },
            "ADF_HTTP2_SERVER_SENT_PING_INVALID_LEN": {
                "text": "HTTP2 Frame Size Error: Server sent PING frame with incorrect length.",
                "description": "Server sent PING frame with incorrect length."
            },
            "ADF_HTTP2_SERVER_SENT_PING_ACK": {
                "text": "HTTP2 Protocol Error: Server sent ping frame with ack flag.",
                "description": "Server sent ping frame with ack flag."
            },
            "ADF_HTTP2_SERVER_NO_UPSTREAM_KEEPALIVE": {
                "text": "HTTP2 Protocol Error: Server sent keepalive for unknown connection.",
                "description": "Server sent keepalive for unknown connection."
            },
            "ADF_HTTP2_CLIENT_SENT_TRAILER": {
                "text": "HTTP2 Protocol Warning: HTTP2 trailer is not supported on client side yet.",
                "description": "HTTP2 trailer is not supported on client side yet."
            },
            "ADF_HTTP2_CLIENT_SENT_UNSUPPORTED_PROTOCOL_HDR": {
                "text": "HTTP2 Protocol Error: Client sent an unsupported protocol header.",
                "description": "Client sent an unsupported protocol header."
            },
            "ADF_HTTP2_WEBSOCKET_IS_NOT_ENABLED": {
                "text": "HTTP2 Protocol Error: WebSocket is not enabled in the application profile.",
                "description": "WebSocket is not enabled in the application profile."
            },
            "ADF_HTTP2_WEBSOCKET_DETECTED": {
                "text": "HTTP2 Protocol Info: WebSocket is detected on HTTP2 connection.",
                "description": "WebSocket is detected on HTTP2 connection."
            },
            "ADF_HTTP2_CLIENT_SENT_PROTOCOL_HDR_WITH_WRONG_METHOD": {
                "text": "HTTP2 Protocol Error: Client sent a protocol header with incorrect method.",
                "description": "Client sent a protocol header with incorrect method."
            },
            "ADF_HTTP2_WEBSOCKET_VERSION_MISMATCH": {
                "text": "HTTP2 Protocol Error: WebSocket is detected but client and server have different HTTP version.",
                "description": "WebSocket is detected but client and server have different HTTP version."
            },
            "ADF_HTTP2_BAD_REQUEST_CLIENT_SENT_NO_HOST_HEADER": {
                "text": "Request abnormal event: client sent an HTTP request with no Host header to an HTTP/2.0 pool.",
                "description": "Client sent a request with no host header to a pool with HTTP/2.0 enabled.Host header is required for proxying to HTTP/2.0 pools."
            },
            "ADF_HTTP_CONTENT_REWRITE_EMPTY_STRING": {
                "text": "Content Rewrite abnormal event: Replacement String Variable not defined or provided.",
                "description": "Content Rewrite overwrote a match variable with an empty string because replacement string variable was not defined in the Data Script or provided as a part of an HTTP header."
            },
            "ADF_HTTP2_SERVER_SIDE_SSL_ALPN_FAILURE": {
                "text": "Connection closed abnormally: SSL ALPN negotiation failure. Server doesn't support HTTPv2.",
                "description": "Connection closed abnormally: SSL ALPN negotiation failure. Server doesn't support HTTPv2."
            },
            "ADF_HTTP2_SERVER_DOES_NOT_SUPPORT_V2": {
                "text": "Connection closed abnormally: Server doesn't support HTTPv2.",
                "description": "Connection closed abnormally: Server doesn't support HTTPv2."
            },
            "ADF_HTTP2_MAX_REQUESTS_EXCEEDED": {
                "text": "HTTP2 Refused Stream Error: Max number of requests per connection is exceeded",
                "description": "Max number of requests per connection is exceeded"
            },
            "ADF_HTTP2_SERVER_CONTROL_FRAME_FLOOD_DETECTED": {
                "text": "HTTP2 Server Flood Detected: Server sent too many control frames on one connection.",
                "description": "Server sent too many control frames on one connection."
            },
            "ADF_HTTP2_SERVER_EXCEEDED_HTTP2_MAX_FIELD_SIZE_LIMIT": {
                "text": "HTTP2 Server Frame Size Error: Server exceeded compressed header size limit.",
                "description": "Server exceeded compressed header size limit."
            },
            "ADF_HTTP2_SERVER_OUT_OF_BOUND_HPACK_TABLE_INDEX": {
                "text": "HTTP2 Compression Error: Server sent out of bound HPACK table index.",
                "description": "Server sent out of bound HPACK table index."
            },
            "ADF_HTTP2_CLIENT_HPACK_LARGE_HEADER": {
                "text": "HTTP2 Compression Error: Client sent out a header which is too big to be added to dynamic HPACK table.",
                "description": "Client sent out a header which is too big to be added to dynamic HPACK table."
            },
            "ADF_HTTP2_SERVER_HPACK_LARGE_HEADER": {
                "text": "HTTP2 Compression Error: Server sent out a header which is too big to be added to dynamic HPACK table.",
                "description": "Server sent out a header which is too big to be added to dynamic HPACK table."
            },
            "ADF_HTTP2_SERVER_HEADER_BLOCK_TOO_LONG_HEADER_INDEX": {
                "text": "HTTP2 Compression Error: Server sent header block with too long header index value.",
                "description": "Server sent header block with too long header index value."
            },
            "ADF_HTTP2_UPSTREAM_NO_SUPPORT_DYNAMIC_TABLE": {
                "text": "HTTP2 Upstream Error: Dynamic HPACK table is not supported on upstream side.",
                "description": "Dynamic HPACK table is not supported on upstream side."
            },
            "ADF_HTTP2_UPSTREAM_NO_SUPPORT_DYNAMIC_TABLE_ON_CACHE": {
                "text": "HTTP2 Upstream Error: Dynamic HPACK table is not supported when caching is enabled.",
                "description": "Dynamic HPACK table is not supported when caching is enabled."
            },
            "ADF_PERSISTENCE_APP_COOKIE_INVALID_EXPIRY_TIMESTAMP": {
                "text": "Invalid expiry timestamp in the appcookie sent by server.",
                "description": "Invalid expiry timestamp in the appcookie sent by server."
            },
            "ADF_PERSISTENCE_COOKIE_EXPIRED": {
                "text": "Persistence cookie expired.",
                "description": "Persistence cookie expired."
            },
            "ADF_SITE_PERSISTENCE_COOKIE_EXPIRED": {
                "text": "Site Persistence cookie expired.",
                "description": "Site Persistence cookie expired."
            },
            "ADF_ICAP_SERVER_HIGH_RESPONSE_TIME": {
                "text": "ICAP Warning: ICAP server took longer than configured threshold to respond.",
                "description": "ICAP server took longer than configured threshold to respond."
            },
            "ADF_ICAP_BLOCKED": {
                "text": "ICAP Error: Request was blocked by ICAP server.",
                "description": "Request was blocked by ICAP server."
            },
            "ADF_ICAP_MODIFIED": {
                "text": "ICAP Warning: Content was modified by ICAP server.",
                "description": "Content was modified by ICAP server."
            },
            "ADF_ICAP_OUT_OF_MEMORY": {
                "text": "ICAP Error: Out of memory when buffering request or ICAP response.",
                "description": "Out of memory when buffering request or ICAP response."
            },
            "ADF_ICAP_TIMEDOUT": {
                "text": "ICAP Error: ICAP processing took longer than configured timeout.",
                "description": "ICAP processing took longer than configured timeout."
            },
            "ADF_ICAP_BODY_SIZE_BIGGER_THAN_CONFIGURED": {
                "text": "ICAP Error: Content size is more than configured allowed size for ICAP processing.",
                "description": "Content size is more than configured allowed size for ICAP processing."
            },
            "ADF_ICAP_CONNECTION_ERROR": {
                "text": "ICAP Error: Connection to ICAP server failed.",
                "description": "Connection to ICAP server failed."
            },
            "ADF_ICAP_SERVER_ERROR": {
                "text": "ICAP Error: ICAP server responded with 4xx or 5xx status code.",
                "description": "ICAP server responded with 4xx or 5xx status code."
            },
            "ADF_ICAP_FAILED": {
                "text": "ICAP Error: ICAP processing failed due to either ICAP server failure or internal error.",
                "description": "ICAP processing failed due to either ICAP server failure or internal error."
            },
            "ADF_HTTP_BAD_REQUEST_INVALID_REQUEST_LINE": {
                "text": "Request abnormal event: Client sent an invalid HTTP/1.x request.",
                "description": "Client sent an invalid HTTP/1.x request."
            },
            "ADF_HTTP_BAD_RESPONSE_INVALID_REQUEST_LINE": {
                "text": "Response abnormal event: Server replied an invalid HTTP/1.x response.",
                "description": "Server replied an invalid HTTP/1.x response."
            },
            "ADF_LDAP_AUTHENTICATION_DISABLED_BY_DS": {
                "text": "LDAP authentication is disabled by the Datascript.",
                "description": "LDAP authentication is disabled by the Datascript."
            },
            "ADF_PAA_AUTHENTICATION_DISABLED_BY_DS": {
                "text": "PingAccess authentication is disabled by the Datascript.",
                "description": "PingAccess authentication is disabled by the Datascript."
            },
            "ADF_JWT_MISSING_BEARER_TOKEN": {
                "text": "Bearer token is not present in the Authorization header.",
                "description": "Bearer token is not present in the Authorization header."
            },
            "ADF_JWT_MISSING_AUTHORIZATION_HEADER": {
                "text": "Authorization header is missing in the request.",
                "description": "Authorization header is missing in the request."
            },
            "ADF_JWT_MISSING_QUERY_PARAMS": {
                "text": "Query parameters are not present in this request.",
                "description": "Query parameters are not present in this request."
            },
            "ADF_JWT_EMPTY_TOKEN_IN_QUERY_PARAM": {
                "text": "Empty token value in the request query parameters.",
                "description": "Empty token value in the request query parameters."
            },
            "ADF_JWT_QUERY_PARAMS_MISSING_TOKEN_NAME": {
                "text": "Query parameter with the configured token name does not exist in the request.",
                "description": "Query parameter with the configured token name does not exist in the request."
            },
            "ADF_JWT_EMPTY_TOKEN_HEADERS": {
                "text": "Protected headers section is not present in the JWT.",
                "description": "Protected headers section is not present in the JWT."
            },
            "ADF_JWT_EMPTY_TOKEN_PAYLOAD": {
                "text": "Payload section is not present in the JWT.",
                "description": "Payload section is not present in the JWT."
            },
            "ADF_JWT_AUD_CLAIM_NULL": {
                "text": "Audience claim doesn't exist in the JWT payload.",
                "description": "Audience claim doesn't exist in the JWT payload."
            },
            "ADF_JWT_AUD_MISMATCH": {
                "text": "JWT is not issued for this application.",
                "description": "JWT is not issued for this application."
            },
            "ADF_JWT_ISSUER_CLAIM_NULL": {
                "text": "Issuer claim doesn't exist in the JWT payload.",
                "description": "Issuer claim doesn't exist in the JWT payload."
            },
            "ADF_JWT_UNKNOWN_ISSUER": {
                "text": "JWT is issued by an unknown issuer.",
                "description": "JWT is issued by an unknown issuer."
            },
            "ADF_JWT_KID_NULL": {
                "text": "Kid claim doesn't exist in the JWT Header.",
                "description": "Kid claim doesn't exist in the JWT Header."
            },
            "ADF_JWT_INVALID_KID": {
                "text": "JWK corresponding to the kid is not present in the configured JWKS key set.",
                "description": "JWK corresponding to the kid is not present in the configured JWKS key set."
            },
            "ADF_JWT_ALG_NULL": {
                "text": "Algorithm claim doesn't exist in the JWT Header.",
                "description": "Algorithm claim doesn't exist in the JWT Header."
            },
            "ADF_JWT_ALG_MISMATCH": {
                "text": "Algorithm with which the JWT is signed is different from that in JWK.",
                "description": "Algorithm with which the JWT is signed is different from that in JWK."
            },
            "ADF_JWT_NOT_YET_VALID": {
                "text": "JWT is not valid yet.",
                "description": "JWT is not valid yet."
            },
            "ADF_JWT_EXPIRED": {
                "text": "JWT is expired.",
                "description": "JWT is expired."
            },
            "ADF_JWT_SIGNATURE_VERIFICATION_FAILURE": {
                "text": "JWT Signature verification Failure.",
                "description": "JWT Signature verification Failure."
            },
            "ADF_JWT_VALIDATION_DISABLED_BY_DS": {
                "text": "JWT Validation is disabled by the Datascript.",
                "description": "JWT Validation is disabled by the Datascript."
            },
            "ADF_JWT_INVALID_JWKS": {
                "text": "Invalid JWKS configured in the JWTServerProfile.",
                "description": "Invalid JWKS configured in the JWTServerProfile."
            },
            "ADF_HTTP_CONNECTION_STRATEGY_CONVERTED": {
                "text": "VS Connection Strategy Changed.",
                "description": "Virtual Service Connection Strategy Changed and Connection Multiplexing disabled."
            },
            "ADF_HTTP_NTLM_AUTHENTICATION_FAILED": {
                "text": "NTLM Authentication Failed.",
                "description": "NTLM Authentication Failed."
            },
            "ADF_HTTP_NTLM_NEGOTIATION_RESPONSE_DECODE_FAIL": {
                "text": "NTLM Negotiation failed in response due to decode failure.",
                "description": "NTLM Negotiation failed in response due to decode failure."
            },
            "ADF_HTTP_NTLM_NEGOTIATION_RESPONSE_WRONG_SIG": {
                "text": "NTLM Negotiation failed in response due to wrong signature.",
                "description": "NTLM Negotiation failed in response due to wrong signature."
            },
            "ADF_HTTP_NTLM_NEGOTIATION_RESPONSE_WRONG_MESSAGE": {
                "text": "NTLM Negotiation failed in response due to wrong message type.",
                "description": "NTLM Negotiation failed in response due to message type."
            },
            "ADF_HTTP_NTLM_NEGOTIATION_REQUEST_DECODE_FAIL": {
                "text": "NTLM Negotiation failed in request due to decode failure.",
                "description": "NTLM Negotiation failed in request due to decode failure."
            },
            "ADF_HTTP_NTLM_NEGOTIATION_REQUEST_WRONG_SIG": {
                "text": "NTLM Negotiation failed in request due to wrong signature.",
                "description": "NTLM Negotiation failed in request due to wrong signature."
            },
            "ADF_HTTP_NTLM_NEGOTIATION_REQUEST_WRONG_MESSAGE": {
                "text": "NTLM Negotiation failed in reqeuest due to wrong message type.",
                "description": "NTLM Negotiation failed in request due to message type."
            },
            "ADF_HTTP_UNEXPECTED_RUM_REQUEST": {
                "text": "Request abnormal event: Received a RUM request while Client Insights is disabled.",
                "description": "Received a RUM request while Client Insights is disabled."
            },
            "ADF_HTTP_NTLM_REQUEST_QUEUEING_DISABLED": {
                "text": "Request queueing disabled for NTLM connection.",
                "description": "Request queueing disabled for NTLM detected connection."
            },
            "ADF_HTTP_NTLM_SERVER_RESELECT_DISABLED": {
                "text": "Server Reselect disabled for NTLM connection.",
                "description": "Server Reselect disabled for NTLM detected connection."
            },
            "ADF_HTTP_NTLM_POOL_SWITCHED": {
                "text": "NTLM connection switched to a different pool.",
                "description": "NTLM connection switched to a different pool."
            },
            "ADF_HTTP_NTLM_CONNECTION_DETECTED": {
                "text": "NTLM connection detected.",
                "description": "NTLM connection detected."
            },
            "ADF_REQUEST_URI_INVALID_UTF8_FORMAT": {
                "text": "HTTP Request URI is of invalid UTF-8 format.",
                "description": "HTTP Request URI is of invalid UTF-8 format."
            },
            "ADF_REQUEST_ARGS_INVALID_UTF8_FORMAT": {
                "text": "HTTP Request args are of invalid UTF-8 format.",
                "description": "HTTP Request args are of invalid UTF-8 format."
            },
            "ADF_REQUEST_CHUNK_MODE_WITH_CONTENT_LENGTH": {
                "text": "Client sent a request with both chunked Transfer-Encoding and Content-Length headers.",
                "description": "Client sent a request with both chunked Transfer-Encoding and Content-Length headers."
            },
            "ADF_HTTP2_H2C_UPGRADE_NO_HTTP2_SETTINGS": {
                "text": "H2c Upgrade Error: HTTP2-SETTINGS is missed from h2c upgrade request.",
                "description": "HTTP2-SETTINGS is missed from h2c upgrade request."
            },
            "ADF_HTTP2_H2C_UPGRADE_HTTP2_SETTINGS_ERR": {
                "text": "H2c Upgrade Error: HTTP2-SETTINGS can't be decoded.",
                "description": "HTTP2-SETTINGS can't be decoded."
            },
            "ADF_HTTP2_H2C_UPGRADE_REQUEST": {
                "text": "H2c Upgrade Request: Client sent an h2c upgrade request.",
                "description": "Client sent an h2c upgrade request."
            },
            "ADF_HTTP2_H2C_UPGRADE_TO_HTTP2": {
                "text": "H2c Upgrade Request: Request was upgraded to HTTP/2.",
                "description": "Request was upgraded to HTTP/2."
            },
            "ADF_HTTP2_H2C_UPGRADE_OPTIONS_REQUEST": {
                "text": "H2c Upgrade Request: Client sent an OPTIONS request.",
                "description": "Client sent an OPTIONS request."
            },
            "ADF_HTTP2_H2C_UPGRADE_OPTIONS_REQUEST_WITH_BODY": {
                "text": "H2c Upgrade Request: Client sent an OPTIONS request with body.",
                "description": "Client sent an OPTIONS request with body."
            },
            "ADF_HTTP2_INVALID_VERSION": {
                "text": "HTTP2 Protocol Error: Client sent an HTTP/1.x request without an h2c upgrade header.",
                "description": "HTTP2 Protocol Error: Client sent an HTTP/1.x request without an h2c upgrade header."
            },
            "ADF_HTTP2_INVALID_CHUNKED_BODY": {
                "text": "HTTP2 Protocol Error: client sent an chunked body on HTTP/2 port.",
                "description": "HTTP2 Protocol Error: client sent an chunked body on HTTP/2 port."
            },
            "ADF_SERVER_RESPONSE_HEADER_TOO_LARGE": {
                "text": "Upstream error: total size of all response headers is larger than the configured value.",
                "description": "Upstream error: total size of all response headers is larger than the configured value."
            },
            "ADF_HTTP_CLIENT_EXCEEDED_MAX_HEADER_SIZE_LIMIT": {
                "text": "Request abnormal event: client exceeded total header size limit.",
                "description": "Client exceeded total header size limit."
            },
            "ADF_HTTP_CLIENT_EXCEEDED_MAX_SINGLE_HEADER_SIZE_LIMIT": {
                "text": "Request abnormal event: client exceeded single header size limit.",
                "description": "Client exceeded single header size limit."
            },
            "ADF_HTTP_BAD_REQUEST_REQUESTED_HOST_NAME_DOES_NOT_MATCH_SERVERNAME": {
                "text": "Request abnormal event: client attempted to request a server that has a different domain name from the one that was negotiated.",
                "description": "Client attempted to request a server name that has a different domain name from the one that was negotiated."
            },
            "ADF_OAUTH_INVALID_REQUEST": {
                "text": "OAUTH Error: Request is missing a required parameter.",
                "description": "OAUTH Error: Request is missing a required parameter."
            },
            "ADF_OAUTH_INVALID_CLIENT": {
                "text": "OAUTH Error: Client authentication failed.",
                "description": "OAUTH Error: Client authentication failed."
            },
            "ADF_OAUTH_INVALID_GRANT": {
                "text": "OAUTH Error: The provided authorization grant/refresh token/redirect uri is invalid.",
                "description": "OAUTH Error: The provided authorization grant/refresh token/redirect uri is invalid."
            },
            "ADF_OAUTH_UNAUTHORIZED_CLIENT": {
                "text": "OAUTH Error: The authenticated client is not authorized to use this authorization grant type.",
                "description": "OAUTH Error: The authenticated client is not authorized to use this authorization grant type."
            },
            "ADF_OAUTH_UNAUTHORIZED_GRANT_TYPE": {
                "text": "OAUTH Error: The authorization grant type is not supported by the authorization server.",
                "description": "OAUTH Error: The authorization grant type is not supported by the authorization server."
            },
            "ADF_OAUTH_INVALID_SCOPE": {
                "text": "OAUTH Error: The requested scope is invalid or unknown.",
                "description": "OAUTH Error: The requested scope is invalid or unknown."
            },
            "ADF_OAUTH_ACCESS_DENIED": {
                "text": "OAUTH Error: The authorization server denied the request.",
                "description": "OAUTH Error: The authorization server denied the request."
            },
            "ADF_OAUTH_UNSUPPORTED_RESPONSE_TYPE": {
                "text": "OAUTH Error: Authorization server does not support obtaining an authorization code using this method.",
                "description": "OAUTH Error: Authorization server does not support obtaining an authorization code using this method."
            },
            "ADF_OAUTH_HANDSHAKE_UNAUTHORIZED_CLIENT": {
                "text": "OAUTH Error: The client is not authorized to request an authorization code using this method.",
                "description": "OAUTH Error: The client is not authorized to request an authorization code using this method."
            },
            "ADF_OAUTH_SERVER_ERROR": {
                "text": "OAUTH Error: The authorization server encountered an unexpected condition that prevented it from fulfilling the request.",
                "description": "OAUTH Error: The authorization server encountered an unexpected condition that prevented it from fulfilling the request."
            },
            "ADF_OAUTH_TEMPORARILY_UNAVAILABLE": {
                "text": "OAUTH Error: The authorization server is currently unable to handle the requests.",
                "description": "OAUTH Error: The authorization server is currently unable to handle the requests."
            },
            "ADF_OAUTH_OIDC_INVALID_ALG": {
                "text": "OAUTH Error: The alg value specified in the OIDC ID token is invalid.",
                "description": "OAUTH Error: The alg value specified in the OIDC ID token is invalid."
            },
            "ADF_OAUTH_OIDC_INVALID_AT_HASH": {
                "text": "OAUTH Error: The at_hash value specified in the OIDC ID token is invalid .",
                "description": "OAUTH Error: The at_hash value specified in the OIDC ID token is invalid ."
            },
            "ADF_OAUTH_AUTHORIZATION_FAILED_RULE_MATCH": {
                "text": "OAUTH Error: Authorization failed due to policy rule match.",
                "description": "OAUTH Error: Authorization failed due to policy rule match."
            },
            "ADF_OAUTH_OIDC_JWT_AZP_MISMATCH": {
                "text": "OAUTH Error: The azp claim in the OIDC ID token does not match the client_id.",
                "description": "OAUTH Error: The azp claim in the OIDC ID token does not match the client_id."
            },
            "ADF_OAUTH_OIDC_JWT_AZP_CLAIM_INVALID": {
                "text": "OAUTH Error: The azp claim in the OIDC ID token is invalid.",
                "description": "OAUTH Error: The azp claim in the OIDC ID token is invalid."
            },
            "ADF_OAUTH_COOKIE_VERSION_MISMATCH": {
                "text": "Request abnormal event: OAUTH Session cookie version in the incoming request does not match the expected version",
                "description": "OAUTH Session cookie version in the incoming request does not match the expected version"
            },
            "ADF_OAUTH_COOKIE_KEYS_NOT_CONFIGURED": {
                "text": "OAUTH error: cookie keys were not configured.",
                "description": "Cookie keys were not configured."
            },
            "ADF_OAUTH_COOKIE_ENCRYPTION_ERROR": {
                "text": "OAUTH authentication Error: failed to encrypt the cookie.",
                "description": "Failed to encrypt the cookie."
            },
            "ADF_OAUTH_AUTHENTICATION_SKIPPED_RULE_MATCH": {
                "text": "OAUTH Skipped: OAUTH authentication skipped due to policy rules match.",
                "description": "OAUTH authentication skipped due to policy rules match."
            },
            "ADF_OAUTH_TOKEN_EXCHANGE_FAIL": {
                "text": "OAUTH Error: OAUTH token exchange failed.",
                "description": "OAUTH token exchange failed."
            },
            "ADF_OAUTH_USERINFO_FAIL": {
                "text": "OAUTH Error: OAUTH Userinfo fetch failed.",
                "description": "OAUTH Userinfo fetch failed."
            },
            "ADF_OAUTH_JWKS_URI_FAIL": {
                "text": "OAUTH Error: OAUTH JWKs fetch failed.",
                "description": "OAUTH JWKs fetch failed."
            },
            "ADF_OAUTH_INTROSPECT_FAIL": {
                "text": "OAUTH Error: OAUTH token introspection failed.",
                "description": "OAUTH token introspection failed."
            },
            "ADF_OAUTH_NULL_COOKIE": {
                "text": "OAUTH Error: OAUTH cookie is absent.",
                "description": "OAUTH cookie is absent in the request."
            },
            "ADF_OAUTH_INVALID_HS_REDIRECT_URI": {
                "text": "OAUTH Error: OAUTH Handshake Cookie received on invalid redirect URI.",
                "description": "OAUTH Handshake Cookie received on invalid redirect URI."
            },
            "ADF_OAUTH_INVALID_COOKIE": {
                "text": "OAUTH Error: OAUTH Cookie is invalid or corrupted.",
                "description": "OAUTH Cookie is invalid or corrupted."
            },
            "ADF_OAUTH_ACCESS_TOKEN_INACTIVE": {
                "text": "OAUTH Error: OAUTH Access token is inactive.",
                "description": "OAUTH Access token is inactive."
            },
            "ADF_HTTP_CLIENT_EXCEEDED_MAX_HEADER_COUNT_LIMIT": {
                "text": "Request abnormal event: client exceeded total header count limit.",
                "description": "Client exceeded total header count limit."
            },
            "ADF_HTTP_SERVER_EXCEEDED_MAX_HEADER_COUNT_LIMIT": {
                "text": "Response abnormal event: server exceeded total header count limit.",
                "description": "Server exceeded total header count limit."
            },
            "ADF_HTTP2_CLIENT_EXCEEDED_HTTP2_MAX_HEADER_COUNT_LIMIT": {
                "text": "HTTP2 Error: client exceeded total header count limit.",
                "description": "Client exceeded total header count limit."
            },
            "ADF_HTTP2_SERVER_PUSH_INITIATED_REQUEST": {
                "text": "HTTP2 Server Push: Request was initiated by Server Push.",
                "description": "Request was sent through Server Push."
            },
            "ADF_OAUTH_USER_ID_TOKEN_NULL": {
                "text": "OAuth Error: Missing OAuth user ID token.",
                "description": "OAuth User ID token fetch failed."
            },
            "ADF_OAUTH_END_SESSION_ENDPOINT_NOT_CONFIGURED": {
                "text": "OAuth Error: OAuth IDP's End Session Endpoint not configured.",
                "description": "OAuth Logout failed."
            },
            "ADF_OAUTH_INTROSPECT_DATA_SAVE_FAILED": {
                "text": "OAuth Error: Failed to save OAuth token introspection data.",
                "description": "OAuth token introspection data save failed."
            },
            "ADF_WEBSOCKET_ACCEPT_VERIFY_FAILED": {
                "text": "Websocket Error: Websocket handshake failed. Server refused to initiate the Websocket connection.",
                "description": "Websocket handshake failed. Server refused to initiate the Websocket connection."
            },
            "ADF_WEBSOCKET_DUPLICATE_ACCEPT_HEADER": {
                "text": "Websocket Error: Websocket handshake failed. Server sent a duplicate Sec-WebSocket-Accept header.",
                "description": "Websocket handshake failed. Server sent a duplicate Sec-WebSocket-Accept header."
            },
            "ADF_WEBSOCKET_ACCEPT_HEADER_MISSED": {
                "text": "Websocket Error: Websocket handshake failed. Sec-WebSocket-Accept header is missed.",
                "description": "Websocket handshake failed. Sec-WebSocket-Accept header is missed."
            },
            "ADF_WEBSOCKET_DETECTED": {
                "text": "HTTP/1.1 Protocol Info: WebSocket is detected on HTTP/1.1 connection.",
                "description": "WebSocket is detected on HTTP/1.1 connection."
            },
            "ADF_WEBSOCKET_HANDSHAKE_FAILED": {
                "text": "Websocket Error: Websocket handshake failed.",
                "description": "Websocket handshake failed."
            },
            "ADF_WEBSOCKET_WRONG_SEC_WEBSOCKET_KEY": {
                "text": "Websocket Error: Websocket handshake failed. Client sent a wrong Sec-WebSocket-Key.",
                "description": "Websocket handshake failed. Client sent a wrong Sec-WebSocket-key."
            },
            "ADF_OAUTH_TOKEN_ENDPOINT_CONN_FAIL": {
                "text": "OAUTH Error: OAUTH token endpoint connection failed.",
                "description": "OAUTH token endpoint connection failed."
            },
            "ADF_OAUTH_USERINFO_ENDPOINT_CONN_FAIL": {
                "text": "OAUTH Error: OAUTH userinfo endpoint connection failed.",
                "description": "OAUTH userinfo endpoint connection failed."
            },
            "ADF_OAUTH_JWKS_ENDPOINT_CONN_FAIL": {
                "text": "OAUTH Error: OAUTH JWKS URI endpoint connection failed.",
                "description": "OAUTH JWKS URI endpoint connection failed."
            },
            "ADF_OAUTH_INTRO_ENDPOINT_CONN_FAIL": {
                "text": "OAUTH Error: OAUTH introspection endpoint connection failed.",
                "description": "OAUTH introspection endpoint connection failed."
            },
            "ADF_SESSION_NOT_ENABLED": {
                "text": "HTTP Session: Cannot set session value if session is not enabled.",
                "description": "Cannot perform operation unless session is enabled. Enable session from CLI."
            },
            "ADF_SESSION_MODULE_LENGTH_MISMATCH": {
                "text": "HTTP Session: Incorrect module length.",
                "description": "Cannot perform operation unless length of module name is 3."
            },
            "ADF_HTTP_UNEXPECTED_CSRF_REQUEST": {
                "text": "HTTP Error: Unexpected CSRF request.",
                "description": "Unexpected CSRF request."
            },
            "ADF_CSRF_REJECTED": {
                "text": "CSRF Error: CSRF validation failed.",
                "description": "CSRF token validation failed."
            },
            "ADF_DIAM_REQUEST_TIMEDOUT": {
                "text": "Diameter error: Either app transaction timeout or connection close occurred in middle of transaction.",
                "description": "Diameter request timed out"
            },
            "ADF_USER_DELETE_OPERATION_DATASCRIPT_CLOSE_CONN": {
                "text": "Connection closed abnormally: connection was closed by datascript",
                "description": "The connection was closed by a datascript installed by user"
            },
            "ADF_DATASCRIPT_TIMEOUT_CLOSE_CONN": {
                "text": "Connection closed abnormally: Connection timed out while collecting data in the DataScript.",
                "description": "The connection was closed by a datascript installed by user"
            },
            "ADF_HTTP_RULE_INVALID_LOCATION_HEADER": {
                "text": "Server response sent an invalid Location header",
                "description": "Detected a malformed Location header in the server response when rewriting the Location header in the HTTP response policy."
            }
        },
        "FailHttpStatusCode": {
            "FAIL_HTTP_STATUS_CODE_200": {},
            "FAIL_HTTP_STATUS_CODE_503": {}
        },
        "OCSPUiStatus": {
            "OCSP_UI_STATUS_OK": {
                "text": "OCSP status: OK.",
                "description": "OCSP UI status: OK.",
                "ocsp_ui_status_options": {
                    "allowed_ocsp_error_status": [
                        "OCSP_ERR_CERTSTATUS_GOOD",
                        "OCSP_ERR_CERTSTATUS_DISABLED"
                    ]
                }
            },
            "OCSP_UI_STATUS_WARNING": {
                "text": "OCSP status: Warning.",
                "description": "OCSP UI status: Warning.",
                "ocsp_ui_status_options": {
                    "allowed_ocsp_error_status": [
                        "OCSP_ERR_CERTSTATUS_UNKNOWN",
                        "OCSP_ERR_CERTSTATUS_SERVERFAIL_ERR",
                        "OCSP_ERR_CERTSTATUS_SELFSIGNED",
                        "OCSP_ERR_CERTSTATUS_NONVSCERT",
                        "OCSP_ERR_CERTSTATUS_REQUEST",
                        "OCSP_ERR_CERTSTATUS_JOBDB",
                        "OCSP_ERR_CERTSTATUS_HTTP_REQ",
                        "OCSP_ERR_CERTSTATUS_URL_LIST",
                        "OCSP_ERR_CERTSTATUS_HTTP_SEND",
                        "OCSP_ERR_CERTSTATUS_HTTP_RECV",
                        "OCSP_ERR_CERTSTATUS_HTTP_RESP"
                    ]
                }
            },
            "OCSP_UI_STATUS_ERROR": {
                "text": "OCSP status: Error.",
                "description": "OCSP UI status: Error.",
                "ocsp_ui_status_options": {
                    "allowed_ocsp_error_status": [
                        "OCSP_ERR_CERTSTATUS_REVOKED",
                        "OCSP_ERR_CERTSTATUS_ISSUER_REVOKED",
                        "OCSP_ERR_CERTSTATUS_GETCERT",
                        "OCSP_ERR_CERTSTATUS_NONVSCERT",
                        "OCSP_ERR_CERTSTATUS_CERTFINISH",
                        "OCSP_ERR_CERTSTATUS_CACERT",
                        "OCSP_ERR_CERTSTATUS_PARSE_CERT"
                    ]
                }
            }
        },
        "SSLScore": {
            "SSL_SCORE_NOT_SECURE": {},
            "SSL_SCORE_VERY_BAD": {},
            "SSL_SCORE_BAD": {},
            "SSL_SCORE_AVERAGE": {},
            "SSL_SCORE_GOOD": {},
            "SSL_SCORE_EXCELLENT": {},
            "SSL_SCORE_UNKNOWN": {}
        },
        "WafStatusCode": {
            "NO_WAF": {
                "text": "No WAF",
                "description": "Request was not processed by WAF."
            },
            "FLAGGED": {
                "text": "Flagged",
                "description": "The transaction matched one or more WAF rules and was flagged as an attack. It was not rejected due to Detection mode."
            },
            "PASSED": {
                "text": "Passed",
                "description": "The transaction was classified as not-an-attack, and allowed by WAF Policy."
            },
            "REJECTED": {
                "text": "Rejected",
                "description": "The transaction was classified as an attack, and rejected by WAF Policy. This status is only possible when Enforcement mode is turned on for WAF."
            },
            "ALLOWLISTED": {
                "text": "Allowlisted",
                "description": "The transaction matched one or more WAF Allowlist rules, or rules that disable the WAF engine, and was allowed by WAF Policy."
            },
            "BYPASSED": {
                "text": "Bypassed",
                "description": "The transaction matched one or more WAF Allowlist rules, or rules that deactivate the WAF engine, and was allowed by WAF Policy."
            }
        },
        "ClusterVipStatus": {
            "CLUSTER_VIP_NOT_CONFIGURED": {
                "text": "Cluster VIP Not Configured",
                "description": "Cluster VIP is not configured by the user."
            },
            "CLUSTER_VIP_DECONFIG_FAILURE": {
                "text": "Cluster VIP Deconfig Failure",
                "description": "Cluster VIP failed while deconfiguring."
            },
            "CLUSTER_VIP_FAILED": {
                "text": "Cluster VIP Failed",
                "description": "Cluster VIP in failed state."
            },
            "CLUSTER_VIP_ACTIVE": {
                "text": "Cluster VIP Active",
                "description": "Cluster VIP is active."
            }
        },
        "DnsEdnsOptionCode": {
            "EDNS_OPTION_CODE_NSID": {
                "description": ""
            },
            "EDNS_OPTION_CODE_DNSSEC_DAU": {
                "description": "DNSSEC algorithms understood by client"
            },
            "EDNS_OPTION_CODE_DNSSEC_DHU": {
                "description": "DNSSEC DS hash understood by client"
            },
            "EDNS_OPTION_CODE_DNSSEC_N3U": {
                "description": ""
            },
            "EDNS_OPTION_CODE_CLIENT_SUBNET": {
                "description": "Client subnet option"
            },
            "EDNS_OPTION_CODE_EXPIRE": {
                "description": ""
            },
            "EDNS_OPTION_CODE_COOKIE": {
                "description": ""
            },
            "EDNS_OPTION_CODE_TCP_KEEPALIVE": {
                "description": "TCP keepalive option"
            },
            "EDNS_OPTION_CODE_PADDING": {
                "description": ""
            },
            "EDNS_OPTION_CODE_CHAIN": {
                "description": ""
            }
        },
        "GslbSiteCfgSyncState": {
            "GSLB_SITE_CFG_IN_SYNC": {
                "text": "In Sync",
                "description": "Replication In Sync"
            },
            "GSLB_SITE_CFG_OUT_OF_SYNC": {
                "text": "Out of Sync",
                "description": "Replication Out Of Sync"
            },
            "GSLB_SITE_CFG_SYNC_DISABLED": {
                "text": "Sync Deactivated",
                "description": "Replication Disabled"
            },
            "GSLB_SITE_CFG_SYNC_IN_PROGRESS": {
                "text": "Sync In Progress",
                "description": "Replication In Progress"
            },
            "GSLB_SITE_CFG_SYNC_NOT_APPLICABLE": {
                "text": "Sync Not Applicable",
                "description": "Replication Not Applicable"
            },
            "GSLB_SITE_CFG_SYNCED_TILL_CHECKPOINT": {
                "text": "Synced Till Checkpoint",
                "description": "Replication Till Checkpoint"
            },
            "GSLB_SITE_CFG_SYNC_SUSPENDED": {
                "text": "Sync Suspended",
                "description": "Replication Suspended"
            },
            "GSLB_SITE_CFG_SYNC_STALLED": {
                "text": "Sync Stalled",
                "description": "Replication Stalled"
            }
        },
        "ClusterStateValue": {
            "CLUSTER_UP_HA_ACTIVE": {
                "text": "Up (HA Active)"
            },
            "CLUSTER_UP_HA_NOT_READY": {
                "text": "Up (HA Not Ready)"
            },
            "CLUSTER_UP_NO_HA": {
                "text": "Up (No HA)"
            },
            "CLUSTER_STARTING_UP": {
                "text": "Starting"
            },
            "CLUSTER_REBOOTING": {
                "text": "Rebooting"
            },
            "CLUSTER_PROCESSING": {
                "text": "Processing"
            },
            "CLUSTER_UP_HA_COMPROMISED": {
                "text": "Up (HA Compromised)"
            }
        },
        "OperationalState": {
            "OPER_UP": {
                "text": "Up"
            },
            "OPER_DOWN": {
                "text": "Down",
                "description": "Operationally down"
            },
            "OPER_CREATING": {
                "text": "Creating",
                "description": "Controller is Creating resources"
            },
            "OPER_RESOURCES": {
                "text": "Resources",
                "description": "Controller is waiting for resources to become available"
            },
            "OPER_INACTIVE": {
                "text": "Inactive",
                "description": "Controller is not attempting to place object"
            },
            "OPER_DISABLED": {
                "text": "Deactivated",
                "description": "Object is Deactivated"
            },
            "OPER_UNUSED": {
                "text": "Unused",
                "description": "Object not attached to a Virtual Service"
            },
            "OPER_UNKNOWN": {
                "text": "Unknown",
                "description": "Unknown state"
            },
            "OPER_PROCESSING": {
                "text": "Processing"
            },
            "OPER_INITIALIZING": {
                "text": "Initializing"
            },
            "OPER_ERROR_DISABLED": {
                "text": "Failed to Deactivate"
            },
            "OPER_AWAIT_MANUAL_PLACEMENT": {
                "text": "Awaiting Manual Placement"
            },
            "OPER_UPGRADING": {
                "text": "Upgrading",
                "description": "Upgrade in progress"
            },
            "OPER_SE_PROCESSING": {
                "text": "SE Processing",
                "description": "Service Engine is processing request"
            },
            "OPER_PARTITIONED": {
                "text": "Partitioned",
                "description": "Unreachable from Controller"
            },
            "OPER_DISABLING": {
                "text": "Deactivating",
                "description": "Service Engine awaiting Migration of all Virtual Services"
            },
            "OPER_FAILED": {
                "text": "Failed",
                "description": "Currently in failed state"
            },
            "OPER_UNAVAIL": {
                "text": "Status Unavailable",
                "description": "Object status is unavailable"
            },
            "OPER_AGGREGATE_DOWN": {
                "text": "OPER_AGGREGATE_DOWN",
                "description": "If object is down on any Service Engine, aggregate state of the object becomes operationally down."
            }
        },
        "NodeType": {
            "NODE_CONTROLLER_CLUSTER": {
                "description": "This value represents the Controller Cluster."
            },
            "NODE_SE_GROUP": {
                "description": "This value represents the ServiceEngineGroup."
            },
            "NODE_SE_TYPE": {
                "description": "This value represents the ServiceEngine."
            }
        },
        "ImageState": {
            "IMG_STATE_UNKNOWN": {
                "text": "Unknown",
                "description": "Image state unknown."
            },
            "IMG_GEN_IN_PROGRESS": {
                "text": "In Progress",
                "description": "Image generation in progress."
            },
            "IMG_GEN_FAILED": {
                "text": "Failed",
                "description": "Image generation failed."
            },
            "IMG_GEN_COMPLETE": {
                "text": "Complete",
                "description": "Image generation complete for ServiceEngine creation."
            }
        },
        "CloudConnectorHostState": {
            "CC_HOST_STATE_UNKNOWN": {
                "text": "State Unknown",
                "description": "Host state unknown"
            },
            "CC_HOST_IMAGE_IN_PROGRESS": {
                "text": "Image In Progress",
                "description": "Service Engine image upload in progress to host"
            },
            "CC_HOST_IMAGE_COMPLETE": {
                "text": "Image Complete",
                "description": "Service Engine image upload complete to host"
            },
            "CC_HOST_IMAGE_FAILED": {
                "text": "Image Failed",
                "description": "Service Engine image upload failed to host"
            },
            "CC_HOST_START_IN_PROGRESS": {
                "text": "Start In Progress",
                "description": "Service Engine starting on host"
            },
            "CC_HOST_START_FAILED": {
                "text": "Start Failed",
                "description": "Service Engine start failed on host"
            },
            "CC_HOST_SSH_FAILED": {
                "text": "SSH Failed",
                "description": "SSH access to host failed"
            },
            "CC_HOST_SSH_OK": {
                "text": "SSH Ok",
                "description": "SSH access to host failed"
            },
            "CC_HOST_STARTED": {
                "text": "Started",
                "description": "Service Engine started on host"
            },
            "CC_HOST_STOP_IN_PROGRESS": {
                "text": "Stop In Progress",
                "description": "Service Engine stopping on host"
            },
            "CC_HOST_STOP_FAILED": {
                "text": "Stop Failed",
                "description": "Service Engine stop failed on host"
            },
            "CC_HOST_STOPPED": {
                "text": "Stopped",
                "description": "Service Engine stopped on host"
            },
            "CC_HOST_ENABLED": {
                "text": "Enabled",
                "description": "Host enabled"
            },
            "CC_HOST_DISABLED": {
                "text": "Disabled",
                "description": "Host disabled"
            },
            "CC_HOST_UNUSED": {
                "text": "Unused",
                "description": "Host unused due to label exclusion"
            },
            "CC_HOST_READY": {
                "text": "Ready",
                "description": "Cloud host ready"
            }
        },
        "ProgressType": {
            "PSM_PROGRAMMING_PROGRESS": {
                "text": "PSM Programming Progress",
                "description": "Indicates PSM programming progress. THIS TYPE IS NOT USED TO INDICATE PROGRESS."
            },
            "LEARNING_PROGRESS": {
                "text": "Learning Progress",
                "description": "Indicates learning progress. THIS TYPE IS NOT USED TO INDICATE PROGRESS."
            },
            "NA": {
                "text": "-",
                "description": "Indicates Not Applicable"
            },
            "LEARNING": {
                "text": "LEARNING",
                "description": "Indicates learning is in progress."
            },
            "LEARNING_COMPLETED": {
                "text": "LEARNING COMPLETED",
                "description": "Indicates learning is completed."
            },
            "PSM_PROGRAMMED": {
                "text": "PSM PROGRAMMED",
                "description": "Indicates psm programming is completed."
            }
        },
        "ParamType": {
            "PARAM_FLAG": {
                "text": "FLAG",
                "description": "The empty value."
            },
            "PARAM_DIGITS": {
                "text": "DIGITS",
                "description": "Parameter which only contains digits."
            },
            "PARAM_HEXDIGITS": {
                "text": "HEXDIGITS",
                "description": "Parameter which only contains hex-digits."
            },
            "PARAM_WORD": {
                "text": "WORD",
                "description": "A word."
            },
            "PARAM_SAFE_TEXT": {
                "text": "SAFE_TEXT",
                "description": "Safe text. Parameters of this class should not be usable to create injections."
            },
            "PARAM_SAFE_TEXT_MULTILINE": {
                "text": "SAFE_TEXT_MULTILINE",
                "description": "Safe multi-line text. The same as PARAM_SAFE_TEXT and newline characters."
            },
            "PARAM_TEXT": {
                "text": "TEXT",
                "description": "Generic text. Can contain any printable characters and whitspace."
            },
            "PARAM_TEXT_MULTILINE": {
                "text": "TEXT_MULTILINE",
                "description": "Generic multi-line text. The same as PARAM_TEXT and newline characters."
            },
            "PARAM_ALL": {
                "text": "ALL",
                "description": "Every possible character."
            }
        },
        "ParamLength": {
            "EMPTY": {},
            "SMALL": {},
            "MEDIUM": {},
            "LARGE": {},
            "UNLIMITED": {}
        },
        "GslbLeaderChangeState": {
            "GSLB_LC_STATE_INIT": {
                "text": "Leader change is initialized.",
                "description": "Leader change is initialized."
            },
            "GSLB_LC_STATE_MONITORING": {
                "text": "Automatic leader change is active and monitoring.",
                "description": "Automatic leader change is active and monitoring."
            },
            "GSLB_LC_STATE_IN_PROGRESS": {
                "text": "Leader change is in progress",
                "description": "Leader change process is in progress."
            },
            "GSLB_LC_STATE_COMPLETED": {
                "text": "Leader change completed",
                "description": "Leader change process has successfully completed."
            },
            "GSLB_LC_STATE_UNAVAILABLE": {
                "text": "The site is not available",
                "description": "Leader change process can't reach to this site"
            },
            "GSLB_LC_STATE_DISABLED": {
                "text": "Leader change is disabled",
                "description": "Leader change is disabled."
            }
        },
        "AlertLevel": {
            "ALERT_LOW": {
                "text": "Low"
            },
            "ALERT_MEDIUM": {
                "text": "Medium"
            },
            "ALERT_HIGH": {
                "text": "High"
            }
        },
        "ConfigCreator": {
            "SERVICE_USER": {
                "text": "Config creator",
                "description": "Config creator user type"
            }
        },
        "ALBServiceMode": {
            "MODE_UNKNOWN": {
                "text": "UNKNOWN.",
                "description": "Unknown mode."
            },
            "SALESFORCE": {
                "text": "Salesforce",
                "description": "Salesforce mode."
            },
            "SYSTEST": {
                "text": "Systest",
                "description": "Systest mode."
            },
            "MYVMWARE": {
                "text": "MyVmware",
                "description": "My Vmware mode."
            },
            "BROADCOM": {
                "text": "Broadcom",
                "description": "Broadcom mode."
            }
        },
        "MetricUnits": {
            "METRIC_COUNT": {},
            "BITS_PER_SECOND": {},
            "MILLISECONDS": {},
            "SECONDS": {},
            "PER_SECOND": {},
            "BYTES": {},
            "PERCENT": {},
            "KILO_BYTES": {},
            "KILO_BYTES_PER_SECOND": {},
            "BYTES_PER_SECOND": {},
            "KILO_BITS_PER_SECOND": {},
            "GIGA_BYTES": {},
            "MEGA_BYTES": {},
            "NORMALIZED": {},
            "STRING": {},
            "SEC": {},
            "MIN": {},
            "DAYS": {},
            "KB": {},
            "MB": {},
            "GB": {},
            "MBPS": {},
            "GHZ": {},
            "RATIO": {},
            "WORD": {},
            "MICROSECONDS": {},
            "HEALTH": {},
            "HOURS": {},
            "NANOSECONDS": {
                "text": "nanoseconds",
                "description": "This unit denotes a thousandth of a microsecond."
            }
        },
        "AlertState": {
            "ALERT_STATE_ON": {},
            "ALERT_STATE_DISMISSED": {},
            "ALERT_STATE_THROTTLED": {}
        },
        "AviCompressionStatus": {
            "NO_COMPRESSION_DISABLED": {
                "text": "Compression not enabled",
                "description": "Response not compressed since compression was disabled in the application profile"
            },
            "NO_COMPRESSION_GZIP_CONTENT": {
                "text": "Response already compressed",
                "description": "Response not compressed since content was compressed at server"
            },
            "NO_COMPRESSION_CONTENT_TYPE": {
                "text": "Response not compressed due to content type",
                "description": "Response not compressed since content type was not identified as compressible"
            },
            "NO_COMPRESSION_CUSTOM_FILTER": {
                "text": "Response not compressed due to custom filter",
                "description": "Response not compressed due to application profile compression custom filter"
            },
            "NO_COMPRESSION_AUTO_FILTER": {
                "text": "Response not compressed due to auto",
                "description": "Response not compressed due to application profile compression type setting auto"
            },
            "NO_COMPRESSION_MIN_LENGTH": {
                "text": "Response not compressed due to small content length",
                "description": "Response not compressed since content length was too small"
            },
            "NO_COMPRESSION_CAN_BE_COMPRESSED": {
                "text": "Response can be compressed if compression enabled",
                "description": "Response content can be compressed if compression is enabled in the application profile"
            },
            "COMPRESSED": {
                "text": "Response content compressed",
                "description": "Response was compressed based on application profile settings"
            }
        },
        "AviClientInsightsStatus": {
            "INSIGHTS_DISABLED": {
                "text": "No client insights",
                "description": "Client Insights not collected due to Virtual Service configuration"
            },
            "NO_INSIGHTS_NOT_SAMPLED_COUNT": {
                "text": "No client insights, not sampled due to sampling frequency",
                "description": "Client Insights not collected"
            },
            "NO_INSIGHTS_NOT_SAMPLED_TYPE": {
                "text": "No client insights, not sampled due to content type",
                "description": "Client Insights not collected"
            },
            "NO_INSIGHTS_NOT_SAMPLED_SKIP_URI": {
                "text": "No client insights, not sampled since URL is in skip list",
                "description": "Client Insights not collected"
            },
            "NO_INSIGHTS_NOT_SAMPLED_URI_NOT_IN_LIST": {
                "text": "No client insights, not sampled since URL is not in the sample URL list",
                "description": "Client Insights not collected"
            },
            "NO_INSIGHTS_NOT_SAMPLED_CLIENT_IP_NOT_IN_RANGE": {
                "text": "No client insights, not sampled since client IP does not match configured value",
                "description": "Client Insights not collected"
            },
            "NO_INSIGHTS_NOT_SAMPLED_OTHER": {
                "text": "No client insights, not sampled due to other reasons.",
                "description": "Client Insights not collected"
            },
            "ACTIVE_INSIGHTS_FAILED": {
                "text": "Active client insights failed",
                "description": "Client Insights not collected since script insertion failed"
            },
            "ACTIVE_INSIGHTS_ENABLED": {
                "text": "Active client insights enabled on this request",
                "description": "Client Insights collected using script insertion"
            },
            "PASSIVE_INSIGHTS_ENABLED": {
                "text": "Passive client insights enabled on this request",
                "description": "Client Insights collected from the SE"
            }
        },
        "AviHTTPRequestState": {
            "AVI_HTTP_REQUEST_STATE_CONN_ACCEPT": {
                "text": "Connection Accepted"
            },
            "AVI_HTTP_REQUEST_STATE_WAITING_FOR_REQUEST": {
                "text": "Waiting for request from client"
            },
            "AVI_HTTP_REQUEST_STATE_SSL_HANDSHAKING": {
                "text": "SSL handshake initiated"
            },
            "AVI_HTTP_REQUEST_STATE_PROCESSING_SPDY": {
                "text": "SPDY connection initiated"
            },
            "AVI_HTTP_REQUEST_STATE_READ_CLIENT_REQ_LINE": {
                "text": "Reading client request line"
            },
            "AVI_HTTP_REQUEST_STATE_READ_CLIENT_REQ_HDR": {
                "text": "Reading client request headers"
            },
            "AVI_HTTP_REQUEST_STATE_CONNECT_TO_UPSTREAM": {
                "text": "Connecting to upstream server"
            },
            "AVI_HTTP_REQUEST_STATE_SEND_REQ_TO_UPSTREAM": {
                "text": "Sending request to upstream server"
            },
            "AVI_HTTP_REQUEST_STATE_READ_RESP_HDR_FROM_UPSTREAM": {
                "text": "Reading response headers from upstream server"
            },
            "AVI_HTTP_REQUEST_STATE_SEND_TO_CLIENT": {
                "text": "Sending response to client"
            },
            "AVI_HTTP_REQUEST_STATE_KEEPALIVE": {
                "text": "Connection in keepalive state"
            },
            "AVI_HTTP_REQUEST_STATE_PROXY_UPGRADED_CONN": {
                "text": "Proxying upgraded connection"
            },
            "AVI_HTTP_REQUEST_STATE_CLOSING_REQUEST": {
                "text": "Closing client request"
            },
            "AVI_HTTP_REQUEST_STATE_READ_FROM_UPSTREAM": {
                "text": "Reading from upstream server"
            },
            "AVI_HTTP_REQUEST_STATE_READ_PROXY_PROTOCOL": {
                "text": "Reading proxy protocol"
            },
            "AVI_HTTP_REQUEST_STATE_READ_CLIENT_PIPELINE_REQ_LINE": {
                "text": "Reading client pipeline request line"
            },
            "AVI_HTTP_REQUEST_STATE_SSL_HANDSHAKE_TO_UPSTREAM": {
                "text": "SSL handshake to upstream initiated"
            },
            "AVI_HTTP_REQUEST_STATE_WAITING_IN_CONNPOOL_CACHE": {
                "text": "Waiting in connection pool cache"
            },
            "AVI_HTTP_REQUEST_STATE_SEND_RESPONSE_HEADER_TO_CLIENT": {
                "text": "Sending response header to client"
            },
            "AVI_HTTP_REQUEST_STATE_SEND_RESPONSE_BODY_TO_CLIENT": {
                "text": "Sending response body to client"
            }
        },
        "AviHTTPResponseBodyUpdated": {
            "NOT_UPDATED": {
                "text": "Response body not modified"
            },
            "BY_CONTENT_REWRITE_PROFILE": {
                "text": "Configuration in content rewrite profiled modified the response body"
            },
            "BY_DATA_SCRIPT": {
                "text": "Data Script modified the response body"
            }
        },
        "GRPCStatus": {
            "GRPC_STATUS_CODE_OK": {
                "text": "OK",
                "description": "Not an error; Success."
            },
            "GRPC_STATUS_CODE_CANCELLED": {
                "text": "Cancelled",
                "description": "The operation was cancelled, typically by the caller."
            },
            "GRPC_STATUS_CODE_UNKNOWN": {
                "text": "Unknown",
                "description": "Unknown error."
            },
            "GRPC_STATUS_CODE_INVALID_ARGUMENT": {
                "text": "Invalid Argument",
                "description": "The client specified an invalid argument."
            },
            "GRPC_STATUS_CODE_DEADLINE_EXCEEDED": {
                "text": "Deadline Exceeded",
                "description": "The deadline expired before the operation could complete."
            },
            "GRPC_STATUS_CODE_NOT_FOUND": {
                "text": "Not Found",
                "description": "Some requested entity (e.g., file or directory) was not found."
            },
            "GRPC_STATUS_CODE_ALREADY_EXISTS": {
                "text": "Already Exists",
                "description": "The entity that a client attempted to create (e.g., file or directory) already exists."
            },
            "GRPC_STATUS_CODE_PERMISSION_DENIED": {
                "text": "Permission Denied",
                "description": "The caller does not have permission to execute the specified operation."
            },
            "GRPC_STATUS_CODE_RESOURCE_EXHAUSTED": {
                "text": "Resource Exhausted",
                "description": "Some resource has been exhausted, perhaps a per-user quota, or perhaps the entire file system is out of space."
            },
            "GRPC_STATUS_CODE_FAILED_PRECONDITION": {
                "text": "Failed Precondition",
                "description": "The operation was rejected because the system is not in a state required for the operation's execution."
            },
            "GRPC_STATUS_CODE_STOPPED": {
                "text": "Stopped",
                "description": "The operation was prematurely stopped, typically due to a concurrency issue such as a sequencer check failure or transaction prematurely stop."
            },
            "GRPC_STATUS_CODE_OUT_OF_RANGE": {
                "text": "Out of Range",
                "description": "The operation was attempted past the valid range."
            },
            "GRPC_STATUS_CODE_UNIMPLEMENTED": {
                "text": "Unimplemented",
                "description": "The operation is not implemented or is not supported/enabled in this service."
            },
            "GRPC_STATUS_CODE_INTERNAL": {
                "text": "Internal",
                "description": "Internal errors. This means that some invariants expected by the underlying system have been broken."
            },
            "GRPC_STATUS_CODE_UNAVAILABLE": {
                "text": "Unavailable",
                "description": "The service is currently unavailable."
            },
            "GRPC_STATUS_CODE_DATA_LOSS": {
                "text": "Data Loss",
                "description": "Unrecoverable data loss or corruption."
            },
            "GRPC_STATUS_CODE_UNAUTHENTICATED": {
                "text": "Unauthenticated",
                "description": "The request does not have valid authentication credentials for the operation."
            }
        },
        "AuthStatus": {
            "AUTH_STATUS_NO_AUTHENTICATION": {
                "text": "No Authentication.",
                "description": "Auth Status: No Authentication."
            },
            "AUTH_STATUS_AUTHENTICATION_SUCCESS": {
                "text": "Authentication Success.",
                "description": "Auth Status: Success."
            },
            "AUTH_STATUS_AUTHENTICATION_FAILURE": {
                "text": "Authentication Failure.",
                "description": "Auth Status: Authentication failure."
            },
            "AUTH_STATUS_UNAUTHORIZED": {
                "text": "Unauthorized.",
                "description": "Auth Status: Unauthorized."
            },
            "AUTH_STATUS_AUTHENTICATED_REQUEST": {
                "text": "Authenticated Request.",
                "description": "Auth Status: Authenticated Request."
            },
            "AUTH_STATUS_AUTHZ_FAILED": {
                "text": "Authorization Failed.",
                "description": "Auth Status: Authorization Failed."
            }
        },
        "AviHTTPRequestBodyUpdated": {
            "REQ_BODY_NOT_UPDATED": {
                "text": "Not modified",
                "description": "Request body not modified."
            },
            "REQ_BODY_UPDATED_BY_CONTENT_REWRITE_PROFILE": {
                "text": "Modified by Content Rewrite",
                "description": "Configuration in content rewrite profile modified the request body."
            },
            "REQ_BODY_UPDATE_SKIPPED_COMPRESSION": {
                "text": "Not modified since compressed",
                "description": "Request rewrite policy is skipped since the body is compressed."
            }
        },
        "WafLearningStatus": {
            "NOT_ACTIVE": {
                "text": "Not active",
                "description": "Learning is not active for this request."
            },
            "LEARNED": {
                "text": "Learned",
                "description": "This request is included in learning."
            },
            "NOTHING_TO_LEARN": {
                "text": "No data",
                "description": "The request does not contain any data to learn."
            },
            "SERVER_ERROR": {
                "text": "Server error",
                "description": "The server responded with an error status code or not at all. WAF will not learn from this request."
            },
            "FLAGGED_BY_WAF": {
                "text": "Flagged or rejected by WAF",
                "description": "The request was flagged or rejected by WAF and is therefore not considered for learning."
            },
            "SKIPPED_BY_SAMPLING": {
                "text": "Skipped by sampling",
                "description": "The request passes all other requirements for learning, but was skipped due to sampling settings."
            },
            "CLIENT_IS_NOT_AUTHENTICATED": {
                "text": "Not authenticated",
                "description": "Option learn_from_authenticated_clients_only is configured for learning and the request is not authenticated."
            },
            "CLIENT_IS_NOT_TRUSTED": {
                "text": "Not trusted",
                "description": "Option trusted_ipgroup_uuid is configured for learning and the client IP is not in this group."
            },
            "CLIENT_IS_A_BOT": {
                "text": "Is a Bot",
                "description": "Bot detection is active and its outcome does not match the requirements configured in learning."
            },
            "ERROR": {
                "text": "Error",
                "description": "An error occured during learning."
            }
        },
        "OauthState": {
            "OAUTH_STATE_CLIENT_IDP_HANDSHAKE_REDIRECT": {
                "text": "Client IDP Handshake.",
                "description": "Client IDP Handshake."
            },
            "OAUTH_STATE_CLIENT_IDP_HANDSHAKE_FAIL": {
                "text": "Client IDP Handshake failure.",
                "description": "Client IDP Handshake failure."
            },
            "OAUTH_STATE_TOKEN_EXCHANGE_REQUEST": {
                "text": "Code - Token exchange request.",
                "description": "Code - Token exchange request."
            },
            "OAUTH_STATE_TOKEN_EXCHANGE_RESPONSE": {
                "text": "Code - Token exchange response.",
                "description": "Code - Token exchange response."
            },
            "OAUTH_STATE_TOKEN_INTROSPECTION_REQUEST": {
                "text": "Token Introspection request.",
                "description": "Token Introspection request."
            },
            "OAUTH_STATE_TOKEN_INTROSPECTION_RESPONSE": {
                "text": "Token Introspection response.",
                "description": "Token Introspection response."
            },
            "OAUTH_STATE_REFRESH_TOKEN_REQUEST": {
                "text": "Token refresh request.",
                "description": "Token refresh request."
            },
            "OAUTH_STATE_REFRESH_TOKEN_RESPONSE": {
                "text": "Token refresh response.",
                "description": "Token refresh response."
            },
            "OAUTH_STATE_JWKS_URI_REQUEST": {
                "text": "JWKS uri request.",
                "description": "JWKS uri request."
            },
            "OAUTH_STATE_JWKS_URI_RESPONSE": {
                "text": "JWKS uri response.",
                "description": "JWKS uri response."
            },
            "OAUTH_STATE_USERINFO_REQUEST": {
                "text": "OIDC userinfo request.",
                "description": "OIDC userinfo request."
            },
            "OAUTH_STATE_USERINFO_RESPONSE": {
                "text": "OIDC userinfo response.",
                "description": "OIDC userinfo response."
            }
        },
        "HTTPMethod": {
            "HTTP_METHOD_GET": {
                "text": "GET",
                "description": "HTTP get method"
            },
            "HTTP_METHOD_HEAD": {
                "text": "HEAD",
                "description": "HTTP head method"
            },
            "HTTP_METHOD_PUT": {
                "text": "PUT",
                "description": "HTTP put method"
            },
            "HTTP_METHOD_DELETE": {
                "text": "DELETE",
                "description": "HTTP delete method"
            },
            "HTTP_METHOD_POST": {
                "text": "POST",
                "description": "HTTP post method"
            },
            "HTTP_METHOD_OPTIONS": {
                "text": "OPTIONS",
                "description": "HTTP options method"
            },
            "HTTP_METHOD_TRACE": {
                "text": "TRACE",
                "description": "HTTP trace method"
            },
            "HTTP_METHOD_CONNECT": {
                "text": "CONNECT",
                "description": "HTTP connect method"
            },
            "HTTP_METHOD_PATCH": {
                "text": "PATCH",
                "description": "HTTP PATCH method"
            },
            "HTTP_METHOD_PROPFIND": {
                "text": "PROPFIND",
                "description": "HTTP PROPFIND method"
            },
            "HTTP_METHOD_PROPPATCH": {
                "text": "PROPPATCH",
                "description": "HTTP PROPPATCH method"
            },
            "HTTP_METHOD_MKCOL": {
                "text": "MKCOL",
                "description": "HTTP MKCOL method"
            },
            "HTTP_METHOD_COPY": {
                "text": "COPY",
                "description": "HTTP COPY method"
            },
            "HTTP_METHOD_MOVE": {
                "text": "MOVE",
                "description": "HTTP MOVE method"
            },
            "HTTP_METHOD_LOCK": {
                "text": "LOCK",
                "description": "HTTP LOCK method"
            },
            "HTTP_METHOD_UNLOCK": {
                "text": "UNLOCK",
                "description": "HTTP UNLOCK method"
            }
        },
        "HTTPVersion": {
            "ZERO_NINE": {
                "text": "0.9",
                "description": "HTTP protocol version 0.9"
            },
            "ONE_ZERO": {
                "text": "1.0",
                "description": "HTTP protocol version 1.0"
            },
            "ONE_ONE": {
                "text": "1.1",
                "description": "HTTP protocol version 1.1"
            },
            "TWO_ZERO": {
                "text": "2.0",
                "description": "HTTP protocol version 2.0"
            }
        },
        "AuthorizationActionEnum": {
            "ALLOW_ACCESS": {
                "description": "Allow Access on Authorization policy rule match."
            },
            "CLOSE_CONNECTION": {
                "description": "Close connection on Authorization policy rule match."
            },
            "HTTP_LOCAL_RESPONSE": {
                "description": "Send HTTP local response on Authorization policy rule match."
            }
        },
        "AuthenticationActionEnum": {
            "SKIP_AUTHENTICATION": {
                "description": "Skip Authentication."
            },
            "USE_DEFAULT_AUTHENTICATION": {
                "description": "Use Default Authentication."
            }
        },
        "BotClassificationTypes": {
            "HUMAN": {
                "text": "Human",
                "description": "Human user."
            },
            "GOOD_BOT": {
                "text": "Good Bot",
                "description": "Benign Bot, maybe even wanted bot."
            },
            "BAD_BOT": {
                "text": "Bad Bot",
                "description": "Bad Bot."
            },
            "DANGEROUS_BOT": {
                "text": "Dangerous Bot",
                "description": "Bot is itself an attack or a threat."
            },
            "USER_DEFINED_BOT": {
                "text": "User-defined Bot",
                "description": "Bot category defined by the user."
            },
            "UNKNOWN_CLIENT": {
                "text": "Unknown",
                "description": "Bot status is unknown, no classification possible."
            }
        },
        "BotDecisionComponent": {
            "BOT_DECIDER_CONSOLIDATION": {
                "text": "Consolidation",
                "description": "A module that compares the evaluations of all basic components, checks them for plausibility and looks for inconsistencies, discrepancies and contradictions."
            },
            "BOT_DECIDER_USER_AGENT": {
                "text": "User-Agent",
                "description": "A sub-module that checks the User-Agent in an HTTP request."
            },
            "BOT_DECIDER_IP_REPUTATION": {
                "text": "IP reputation",
                "description": "A sub-module that checks the reputation of the peer's IP address."
            },
            "BOT_DECIDER_IP_NETWORK_LOCATION": {
                "text": "IP location",
                "description": "A sub-module that checks an IP's ASN information."
            },
            "BOT_DECIDER_CLIENT_BEHAVIOR": {
                "text": "Client Behavior",
                "description": "A sub-module that checks the client behavior across multiple HTTP requests."
            }
        },
        "BotConfidence": {
            "LOW_CONFIDENCE": {
                "text": "Low confidence",
                "description": "Low confidence."
            },
            "MEDIUM_CONFIDENCE": {
                "text": "Reasonable confidence",
                "description": "Medium confidence."
            },
            "HIGH_CONFIDENCE": {
                "text": "High confidence",
                "description": "High confidence."
            }
        },
        "BotClientClass": {
            "UNDETERMINED_CLIENT": {
                "text": "Unknown",
                "description": "No classification could be determined."
            },
            "HUMAN_CLIENT": {
                "text": "Human being",
                "description": "High-level classification as a human user."
            },
            "BOT_CLIENT": {
                "text": "Bot",
                "description": "High-level classification as a bot: an automated computer program."
            }
        },
        "BotClientType": {
            "UNDETERMINED_CLIENT_TYPE": {
                "text": "Unknown",
                "description": "No type could be determined for this client."
            },
            "WEB_BROWSER": {
                "text": "Web browser",
                "description": "Mid-level classification as a conventional web browser."
            },
            "IN_APP_BROWSER": {
                "text": "In-App browser",
                "description": "Human user visiting a web page via an application that uses a browser's engine, e.g. Thunderbird using Firefox's Gecko engine."
            },
            "SEARCH_ENGINE": {
                "text": "Search engine",
                "description": "Web-crawling bot from a known search engine, usually considered a 'good' bot."
            },
            "IMPERSONATOR": {
                "text": "Impersonator",
                "description": "Usually the result of contradicting information, e.g. User-Agent says Firefox, but IP address says bot-net."
            },
            "SPAM_SOURCE": {
                "text": "Spam source",
                "description": "Mid-level classification as a spam source."
            },
            "WEB_ATTACKS": {
                "text": "Web attacks",
                "description": "Mid-level classification as a source of Web attacks."
            },
            "BOTNET": {
                "text": "Botnet",
                "description": "A bot-net, often used for DDoS (Distributed Denial of Service) attacks."
            },
            "SCANNER": {
                "text": "Scanner",
                "description": "A bot that systematically scans web-sites, often to use the gained information for competitive advantage."
            },
            "DENIAL_OF_SERVICE": {
                "text": "Denial of service",
                "description": "Denial of Service (DoS) attacks have originated from this client."
            },
            "CLOUD_SOURCE": {
                "text": "Cloud source",
                "description": "Peer is located inside a known cloud, e.g. AWS; many bots operate on virtual machines inside public clouds."
            },
            "SECURITY_SCANNER": {
                "text": "Security Scanner",
                "description": "Request comes from a security scanner."
            },
            "SITE_MONITOR": {
                "text": "Site Monitor",
                "description": "Request comes from a site monitor."
            },
            "GENERIC_APPLICATION": {
                "text": "Application",
                "description": "Request comes from an application other than a browser or an in-browser app."
            },
            "SUSPICIOUS_APPLICATION": {
                "text": "Suspicious Application",
                "description": "One or more aspects of the request are suspicious, but no specific bot type could be identified."
            }
        },
        "VSDataScriptEvent": {
            "VS_DATASCRIPT_EVT_HTTP_REQ": {
                "text": "HTTP Request Event",
                "description": "Event triggers when the client side http request headers are fully parsed"
            },
            "VS_DATASCRIPT_EVT_HTTP_RESP": {
                "text": "HTTP Response Event",
                "description": "Event triggers when the server side http response status and headers are fully parsed"
            },
            "VS_DATASCRIPT_EVT_HTTP_RESP_DATA": {
                "text": "HTTP Response Data Event",
                "description": "Event triggers when data is received in the http response from the backend server"
            },
            "VS_DATASCRIPT_EVT_HTTP_LB_FAILED": {
                "description": "This event is deprecated. Event triggers when server selection for load balancing the HTTP request fails."
            },
            "VS_DATASCRIPT_EVT_HTTP_REQ_DATA": {
                "text": "HTTP Request Data Event",
                "description": "Event triggers when the client side http request data is fully received"
            },
            "VS_DATASCRIPT_EVT_HTTP_RESP_FAILED": {
                "text": "HTTP Response Failed Event",
                "description": "Event triggers when http response from backend server fails"
            },
            "VS_DATASCRIPT_EVT_HTTP_LB_DONE": {
                "text": "HTTP LB Done Event",
                "description": "Event triggers after the server selection for load balancing the HTTP request is done"
            },
            "VS_DATASCRIPT_EVT_HTTP_AUTH": {
                "text": "HTTP Auth Event",
                "description": "This is the first event that gets triggered after the client side HTTP request headers are fully parsed and before authenticating the client request."
            },
            "VS_DATASCRIPT_EVT_HTTP_POST_AUTH": {
                "text": "HTTP Post Auth Event",
                "description": "Event triggers after the execution of access policies."
            },
            "VS_DATASCRIPT_EVT_TCP_CLIENT_ACCEPT": {
                "description": "Event triggers when TCP client connection is accepted"
            },
            "VS_DATASCRIPT_EVT_SSL_HANDSHAKE_DONE": {
                "text": "Client-side SSL handshake is done.",
                "description": "Event triggers after client-side SSL handshake is done."
            },
            "VS_DATASCRIPT_EVT_CLIENT_SSL_PRE_CONNECT": {
                "text": "Client side SSL Handshake start.",
                "description": "Event triggers at start of client-side SSL handshake."
            },
            "VS_DATASCRIPT_EVT_CLIENT_SSL_CLIENT_HELLO": {
                "text": "Client-side SSL client hello is processed.",
                "description": "Event triggers after client-side SSL client hello is processed."
            },
            "VS_DATASCRIPT_EVT_DNS_REQ": {
                "description": "Event triggers when DNS request received from the client is parsed successfully"
            },
            "VS_DATASCRIPT_EVT_DNS_RESP": {
                "description": "Event triggers when DNS response is received from an upstream load balanced DNS server"
            },
            "VS_DATASCRIPT_EVT_L4_REQUEST": {
                "text": "First Request from client : L4 Profile",
                "description": "Event triggers when first packet from the client is received on L4 profile"
            },
            "VS_DATASCRIPT_EVT_L4_RESPONSE": {
                "text": "Response from server : L4 Profile",
                "description": "Event triggers when response from server is received on L4 profile"
            },
            "VS_DATASCRIPT_EVT_CLIENT_CLOSED": {
                "text": "Client initiated connection close",
                "description": "Event triggers when client initiates the connection close"
            },
            "VS_DATASCRIPT_EVT_SERVER_CLOSED": {
                "text": "Server initiated connection close",
                "description": "Event triggers when server initiates the connection close"
            },
            "VS_DATASCRIPT_EVT_SERVER_CONNECTED": {
                "text": "Server connection is established",
                "description": "Event triggers when server connection is established"
            },
            "VS_DATASCRIPT_EVT_MAX": {}
        },
        "NtlmStatus": {
            "NTLM_AUTHENTICATION_SUCCESS": {
                "text": "Authentication Success",
                "description": "NTLM Status: Authentication Success."
            },
            "NTLM_UNAUTHORIZED": {
                "text": "Unauthorized",
                "description": "NTLM Status: Unauthorized."
            },
            "NTLM_NEGOTIATION": {
                "text": "Negotiation",
                "description": "NTLM Status: Negotiation."
            },
            "NTLM_AUTHENTICATION_FAILURE": {
                "text": "Authentication Failure",
                "description": "NTLM Status: Authentication failure."
            },
            "NTLM_AUTHENTICATED_REQUESTS": {
                "text": "Authenticated Requests",
                "description": "NTLM Status: Authenticated requests."
            }
        },
        "SamlAuthStatus": {
            "SAML_AUTH_STATUS_UNAVAILABLE": {
                "text": "SAML Authentication status unavailable.",
                "description": "SAML Auth status: SAML Authentication status unavailable."
            },
            "SAML_AUTH_STATUS_UNAUTH_GET_REQUEST": {
                "text": "SAML Unauthentiated GET request.",
                "description": "SAML Auth status: SAML Unauthentiated GET request."
            },
            "SAML_AUTH_STATUS_UNAUTH_REQ_UNSUPPORTED_METHOD": {
                "text": "SAML Unauthentiated request with unsupported method.",
                "description": "SAML Auth status: SAML Authentication is supported only for GET requests."
            },
            "SAML_AUTH_STATUS_AUTH_REQUEST_GENERATED": {
                "text": "SAML Authentication request generated to be sent to IDP.",
                "description": "SAML Auth status: SAML Authentication request generated to be sent to IDP."
            },
            "SAML_AUTH_STATUS_AUTH_RESPONSE_RECEIVED": {
                "text": "SAML Authentication response received from IDP.",
                "description": "SAML Auth status: SAML Authentication response received from IDP."
            },
            "SAML_AUTH_STATUS_AUTHENTICATED_REQUEST": {
                "text": "SAML Authentiated request.",
                "description": "SAML Auth status: SAML Authentiated request."
            },
            "SAML_AUTH_STATUS_AUTHORIZATION_FAILED": {
                "text": "SAML Authorization failed.",
                "description": "SAML Auth status: SAML Authorization failed."
            }
        },
        "IcapAction": {
            "ICAP_DISABLED": {
                "text": "ICAP processing is not enabled.",
                "description": "Content was not processed by ICAP server. ICAP processing is not enabled by HTTP security Policy or skipped due to FAIL_OPEN action."
            },
            "ICAP_PASSED": {
                "text": "Content was allowed by ICAP server.",
                "description": "Content was allowed by ICAP server."
            },
            "ICAP_MODIFIED": {
                "text": "Content was modified by ICAP server.",
                "description": "Content was modified by ICAP server."
            },
            "ICAP_BLOCKED": {
                "text": "Content was blocked by ICAP server.",
                "description": "Content was blocked by ICAP server."
            },
            "ICAP_FAILED": {
                "text": "Failed to process the content by ICAP server.",
                "description": "Failed to process the content by ICAP server. This can happen due to communication timeout, protocol error, pool error, request size exceed buffer size etc..."
            }
        },
        "ICAPMethod": {
            "ICAP_METHOD_REQMOD": {
                "text": "REQMOD",
                "description": "ICAP Method for request modification"
            },
            "ICAP_METHOD_RESPMOD": {
                "text": "RESPMOD",
                "description": "ICAP Method for response modification"
            }
        },
        "ICAPVendor": {
            "ICAP_VENDOR_GENERIC": {
                "text": "Generic ICAP",
                "description": "Generic ICAP implementation which follows RFC 3507. Do not use or assume any vendor extensions. Use this as last resort, if your ICAP vendor is not supported."
            },
            "ICAP_VENDOR_OPSWAT": {
                "text": "OPSWAT",
                "description": "ICAP implementation of https://www.opswat.com."
            },
            "ICAP_VENDOR_LASTLINE": {
                "text": "NSXDefender",
                "description": "ICAP implementation of https://www.lastline.com."
            }
        },
        "AviObjectType": {
            "VIRTUALSERVICE": {},
            "POOL": {},
            "HEALTHMONITOR": {},
            "NETWORKPROFILE": {},
            "APPLICATIONPROFILE": {},
            "HTTPPOLICYSET": {},
            "DNSPOLICY": {},
            "SECURITYPOLICY": {},
            "IPADDRGROUP": {},
            "STRINGGROUP": {},
            "SSLPROFILE": {},
            "SSLKEYANDCERTIFICATE": {},
            "NETWORKSECURITYPOLICY": {},
            "APPLICATIONPERSISTENCEPROFILE": {},
            "ANALYTICSPROFILE": {},
            "VSDATASCRIPTSET": {},
            "TENANT": {},
            "PKIPROFILE": {},
            "AUTHPROFILE": {},
            "CLOUD": {},
            "SERVERAUTOSCALEPOLICY": {},
            "AUTOSCALELAUNCHCONFIG": {},
            "MICROSERVICEGROUP": {},
            "IPAMPROFILE": {},
            "HARDWARESECURITYMODULEGROUP": {},
            "POOLGROUP": {},
            "PRIORITYLABELS": {},
            "POOLGROUPDEPLOYMENTPOLICY": {},
            "GSLBSERVICE": {},
            "GSLBSERVICERUNTIME": {},
            "SCHEDULER": {},
            "GSLBGEODBPROFILE": {},
            "GSLBAPPLICATIONPERSISTENCEPROFILE": {},
            "TRAFFICCLONEPROFILE": {},
            "VSVIP": {},
            "WAFPOLICY": {},
            "WAFPROFILE": {},
            "ERRORPAGEPROFILE": {},
            "ERRORPAGEBODY": {},
            "L4POLICYSET": {},
            "GSLBSERVICERUNTIMEBATCH": {},
            "WAFPOLICYPSMGROUP": {},
            "PINGACCESSAGENT": {},
            "NETWORKSERVICE": {},
            "NATPOLICY": {},
            "SSOPOLICY": {},
            "PROTOCOLPARSER": {},
            "EXAMPLECHILD": {},
            "TESTSEDATASTORELEVEL1": {},
            "TESTSEDATASTORELEVEL2": {},
            "TESTSEDATASTORELEVEL3": {},
            "FILEOBJECT": {},
            "IPREPUTATIONDB": {},
            "ICAPPROFILE": {},
            "DYNAMICDNSRECORD": {},
            "JWTSERVERPROFILE": {},
            "GEODB": {},
            "BOTDETECTIONPOLICY": {},
            "BOTMAPPING": {},
            "BOTCONFIGCONSOLIDATOR": {},
            "BOTIPREPUTATIONTYPEMAPPING": {},
            "AVIFALSEPOSITIVEDETECTION": {
                "text": "AVIFALSEPOSITIVEDETECTION",
                "description": "False positive detection"
            },
            "VSGS": {},
            "WAFCRS": {},
            "SYSTEMDEFAULTOBJECT": {},
            "CSRFPOLICY": {},
            "APPLICATIONINSIGHTSPOLICY": {},
            "POSITIVESECURITYPOLICY": {},
            "APPLICATIONINSIGHTSRUNTIMESTATE": {},
            "SERVICEENGINE": {},
            "DEBUGSERVICEENGINE": {},
            "DEBUGCONTROLLER": {},
            "DEBUGVIRTUALSERVICE": {},
            "SERVICEENGINEGROUP": {},
            "SEPROPERTIES": {},
            "NETWORK": {},
            "CONTROLLERNODE": {},
            "CONTROLLERPROPERTIES": {},
            "SYSTEMCONFIGURATION": {},
            "VRFCONTEXT": {},
            "USER": {},
            "ALERTCONFIG": {},
            "ALERTSYSLOGCONFIG": {},
            "ALERTEMAILCONFIG": {},
            "ALERTTYPECONFIG": {},
            "APPLICATION": {},
            "ROLE": {},
            "CLOUDPROPERTIES": {},
            "SNMPTRAPPROFILE": {},
            "ACTIONGROUPPROFILE": {},
            "MICROSERVICE": {},
            "ALERTPARAMS": {},
            "ACTIONGROUPCONFIG": {},
            "CLOUDCONNECTORUSER": {},
            "GSLB": {},
            "GSLBDNSUPDATE": {},
            "GSLBSITEOPS": {},
            "GLBMGRWARMSTART": {},
            "IPAMDNSRECORD": {},
            "GSLBDNSGSSTATUS": {},
            "GSLBDNSGEOFILEOPS": {},
            "GSLBDNSGEOUPDATE": {},
            "GSLBDNSGEOCLUSTEROPS": {},
            "GSLBDNSCLEANUP": {},
            "GSLBSITEOPSRESYNC": {},
            "IPAMDNSPROVIDERPROFILE": {},
            "ALBSERVICESCONFIG": {},
            "SYSTEMLIMITS": {},
            "REPLICATIONOPERATION": {},
            "VCENTERSERVER": {},
            "AVAILABILITYZONE": {},
            "IMAGE": {},
            "VSMGRDNSCLEANUP": {},
            "ALBSERVICESFILEUPLOAD": {},
            "CONTROLLERSITE": {},
            "ALERTOBJECTLIST": {},
            "BACKUPCONFIGURATION": {},
            "USERACCOUNTPROFILE": {},
            "WAFAPPLICATIONSIGNATUREPROVIDER": {},
            "LABELGROUP": {},
            "CERTIFICATEMANAGEMENTPROFILE": {},
            "CUSTOMIPAMDNSPROFILE": {},
            "ALERTSCRIPTCONFIG": {},
            "WEBHOOK": {},
            "CLUSTERCLOUDDETAILS": {},
            "INVENTORYFAULTCONFIG": {},
            "MEMORYBALANCERREQUEST": {},
            "SECURECHANNELMAPPING": {},
            "ALBSERVICESJOB": {},
            "STATEDIFFOPERATION": {},
            "SITEVERSION": {},
            "AUTHMAPPINGPROFILE": {},
            "WEBAPPUT": {},
            "TENANTSYSTEMCONFIGURATION": {},
            "ALERT": {},
            "JOBENTRY": {},
            "SECURECHANNELTOKEN": {},
            "SECURECHANNELAVAILABLELOCALIPS": {},
            "LICENSESTATUS": {},
            "FLOATINGIPSUBNET": {},
            "STATEDIFFSNAPSHOT": {},
            "CONTROLLERLICENSE": {},
            "SCVSSTATEINFO": {},
            "SCPOOLSERVERSTATEINFO": {},
            "UPGRADESTATUSSUMMARY": {},
            "CONTROLLERPORTALREGISTRATION": {},
            "LOGCONTROLLERMAPPING": {},
            "VIDCINFO": {},
            "VIPGNAMEINFO": {},
            "BACKUP": {},
            "SECURITYMANAGERDATA": {},
            "VSAPICEXTENSION": {},
            "GSLBSITE": {},
            "GSLBTHIRDPARTYSITE": {},
            "LICENSEINFO": {},
            "LICENSELEDGERDETAILS": {},
            "USERACTIVITY": {},
            "OBJECTACCESSPOLICY": {},
            "SERVICEAUTHPROFILE": {},
            "ALBSERVICESFILEDOWNLOAD": {},
            "TRUSTEDHOSTPROFILE": {},
            "APIRATELIMITPROFILE": {},
            "RATELIMITCONFIGURATION": {},
            "VIRETRIEVEPGNAMES": {},
            "VCENTERLOGIN": {},
            "SEGROUPINFO": {},
            "LICENSERESERVATIONINFO": {},
            "REDISCOVERVCENTERPARAM": {},
            "CERTJWTSTORE": {},
            "LICENSEQUOTAUSAGEINFO": {},
            "MANAGEMENTSERVICEREQ": {},
            "MANAGEMENTSERVICEACCESSGRANTREQ": {},
            "CREATEMANAGEMENTSERVICEREQ": {},
            "CREATEMANAGEMENTSERVICEACCESSGRANTREQ": {},
            "TENANTBINDING": {},
            "CCCREATESEREQ": {},
            "CCDELETESEREQ": {},
            "CCADDVNICSREQ": {},
            "CCDELVNICSREQ": {},
            "TCPSTATRUNTIME": {},
            "UDPSTATRUNTIME": {},
            "IPSTATRUNTIME": {},
            "ARPSTATRUNTIME": {},
            "MBSTATRUNTIME": {},
            "IPSTKQSTATSRUNTIME": {},
            "MALLOCSTATRUNTIME": {},
            "SHMALLOCSTATRUNTIME": {},
            "CPUUSAGERUNTIME": {},
            "L7GLOBALSTATSRUNTIME": {},
            "L7VIRTUALSERVICESTATSRUNTIME": {},
            "SEAGENTVNICDBRUNTIME": {},
            "SEAGENTGRAPHDBRUNTIME": {},
            "SEAGENTSTATERUNTIME": {},
            "INTERFACERUNTIME": {},
            "ARPTABLERUNTIME": {},
            "DISPATCHERSTATRUNTIME": {},
            "DISPATCHERSTATCLEARRUNTIME": {},
            "DISPATCHERTABLEDUMPRUNTIME": {},
            "DISPATCHERREMOTETIMERLISTDUMPRUNTIME": {},
            "METRICSAGENTMESSAGE": {},
            "HEALTHMONITORSTATRUNTIME": {},
            "METRICSENTITYRUNTIME": {},
            "PERSISTENCEINTERNAL": {},
            "HTTPPOLICYSETINTERNAL": {},
            "DNSPOLICYINTERNAL": {},
            "CONNECTIONDUMPRUNTIME": {},
            "SHAREDDBSTATS": {},
            "SHAREDDBSTATSCLEAR": {},
            "ICMPSTATRUNTIME": {},
            "ROUTETABLERUNTIME": {},
            "VIRTUALMACHINE": {},
            "POOLSERVER": {},
            "SEVSLIST": {},
            "MEMINFORUNTIME": {},
            "RTERINGSTATRUNTIME": {},
            "ALGOSTATRUNTIME": {},
            "HEALTHMONITORRUNTIME": {},
            "CPUSTATRUNTIME": {},
            "SEVM": {},
            "HOST": {},
            "PORTGROUP": {},
            "CLUSTER": {},
            "DATACENTER": {},
            "VCENTER": {},
            "HTTPPOLICYSETSTATS": {},
            "DNSPOLICYSTATS": {},
            "METRICSSESTATS": {},
            "RATELIMITERSTATRUNTIME": {},
            "NETWORKSECURITYPOLICYSTATS": {},
            "TCPCONNRUNTIME": {},
            "POOLSTATS": {},
            "CONNPOOLINTERNAL": {},
            "CONNPOOLSTATS": {},
            "VSHASHSHOWRUNTIME": {},
            "SELOGSTATSRUNTIME": {},
            "NETWORKSECURITYPOLICYDETAIL": {},
            "LICENSERUNTIME": {},
            "SERVERRUNTIME": {},
            "METRICSRUNTIMESUMMARY": {},
            "METRICSRUNTIMEDETAIL": {},
            "DISPATCHERSEHMPROBETEMPDISABLERUNTIME": {},
            "POOLDEBUG": {},
            "VSLOGMGRMAP": {},
            "SERUMINSERTIONSTATS": {},
            "HTTPCACHE": {},
            "HTTPCACHESTATS": {},
            "SEDOSSTATRUNTIME": {},
            "VSDOSSTATRUNTIME": {},
            "SERVERUPDATEREQ": {},
            "VSSCALEOUTLIST": {},
            "SEMEMDISTRUNTIME": {},
            "TCPCONNRUNTIMEDETAIL": {},
            "SEUPGRADESTATUS": {},
            "SEUPGRADEPREVIEW": {},
            "SEFAULTINJECTEXHAUSTM": {},
            "SEFAULTINJECTEXHAUSTMCL": {},
            "SEFAULTINJECTEXHAUSTMCLSMALL": {},
            "SEFAULTINJECTEXHAUSTCONN": {},
            "SEHEADLESSONLINEREQ": {},
            "SEUPGRADE": {},
            "SEUPGRADESTATUSDETAIL": {},
            "SERESERVEDVS": {},
            "SERESERVEDVSCLEAR": {},
            "VSCANDIDATESEHOSTLIST": {},
            "SEGROUPUPGRADE": {},
            "REBALANCE": {},
            "SEGROUPREBALANCE": {},
            "SEAUTHSTATSRUNTIME": {},
            "AUTOSCALESTATE": {},
            "VIRTUALSERVICEAUTHSTATS": {},
            "NETWORKSECURITYPOLICYDOS": {},
            "KEYVALINTERNAL": {},
            "KEYVALSUMMARYINTERNAL": {},
            "SERVERSTATEUPDATEINFO": {},
            "CLTRACKINTERNAL": {},
            "CLTRACKSUMMARYINTERNAL": {},
            "MICROSERVICERUNTIME": {},
            "SEMICROSERVICE": {},
            "VIRTUALSERVICEANALYSIS": {},
            "CLIENTINTERNAL": {},
            "CLIENTSUMMARYINTERNAL": {},
            "MICROSERVICEGROUPRUNTIME": {},
            "BGPRUNTIME": {},
            "REQUESTQUEUERUNTIME": {},
            "MIGRATEALL": {},
            "MIGRATEALLSTATUSSUMMARY": {},
            "MIGRATEALLSTATUSDETAIL": {},
            "INTERFACESUMMARYRUNTIME": {},
            "INTERFACELACPRUNTIME": {},
            "DNSTABLE": {},
            "GSLBSERVICEDETAIL": {},
            "GSLBSERVICEINTERNAL": {},
            "GSLBSERVICEHMONSTAT": {},
            "SETROLESREQUEST": {},
            "TRAFFICCLONERUNTIME": {},
            "GEOLOCATIONINFO": {},
            "SEVSHBSTATRUNTIME": {},
            "GEODBINTERNAL": {},
            "GSLBSITEINTERNAL": {},
            "WAFSTATS": {},
            "USERDEFINEDDATASCRIPTCOUNTERS": {},
            "LLDPRUNTIME": {},
            "VSESSHARINGPOOL": {},
            "NDTABLERUNTIME": {},
            "IP6STATRUNTIME": {},
            "ICMP6STATRUNTIME": {},
            "SEVSSPLACEMENT": {},
            "L4POLICYSETSTATS": {},
            "L4POLICYSETINTERNAL": {},
            "BGPDEBUGINFO": {},
            "SHARD": {},
            "CPUSTATRUNTIMEDETAIL": {},
            "SEASSERTSTATRUNTIME": {},
            "SEFAULTINJECTINFRA": {},
            "SEAGENTASSERTSTATRUNTIME": {},
            "SEDATASTORESTATUS": {},
            "DIFFQUEUESTATUS": {},
            "IP6ROUTETABLERUNTIME": {},
            "SECURITYMGRSTATE": {},
            "VIRTUALSERVICESESCALEOUTSTATUS": {},
            "SHARDSERVERSTATUS": {},
            "SEAGENTSHARDCLIENTRESOURCEMAP": {},
            "SEAGENTCONSISTENTHASH": {},
            "SEAGENTVNICDBHISTORY": {},
            "SEAGENTSHARDCLIENTAPPMAP": {},
            "SEAGENTSHARDCLIENTEVENTHISTORY": {},
            "NATSTATRUNTIME": {},
            "NATFLOWRUNTIME": {},
            "SECUTIRYMGRRUNTIME": {},
            "SSOPOLICYSTATS": {},
            "SENETWORKSERVICERUNTIME": {},
            "SEGEORUNTIME": {},
            "NATPOLICYSTATS": {},
            "SEFAULTRUNTIME": {},
            "VIRTUALSERVICESCALEOUTSTATUS": {},
            "VIRTUALSERVICESCALEOUTSTATUSDETAIL": {},
            "SECURITYMGRLEARN": {},
            "SECURITYMGRTOPN": {},
            "SSLSESSIONCACHE": {},
            "SEGEODETAILS": {},
            "GSLBSERVICEALGOSTAT": {},
            "HTTPCONNECTIONRUNTIME": {},
            "HTTPCONNECTIONRUNTIMEDETAIL": {},
            "REMOTESITEWATCHERSUMMARY": {},
            "REMOTESITEWATCHEREVENT": {},
            "IPREPUTATIONDBRUNTIME": {},
            "SEFAULTINJECTEXHAUSTCFG": {},
            "SEFAULTINJECTEXHAUSTSHMCFG": {},
            "SEFAULTINJECTEXHAUSTSHMCONN": {},
            "BGPRUNNINGCONFIG": {},
            "BGPADVERTISEDROUTES": {},
            "BGPPEERSTATUS": {},
            "BFDSESSIONSTATUS": {},
            "BGPPEERINFO": {},
            "GSLBSITEOPSREPLICATIONPOLICYOPS": {},
            "FEDERATEDDATASTORESTATUS": {},
            "FEDERATEDDIFFQUEUESTATUS": {},
            "ROUTESTATRUNTIME": {},
            "ROUTEFLOWRUNTIME": {},
            "NSXTSEGMENTRUNTIME": {},
            "VIRTUALSERVICEICAPSTATS": {},
            "KEYVALSUMMARYOBJSYNC": {},
            "POOLOBJSYNC": {},
            "KEYVALDISPATCH": {},
            "SEAGENTOBJSYNCDETAILS": {},
            "VIRTUALSERVICESCALEOUTSTATUSKEYVAL": {},
            "VIRTUALSERVICESCALEOUTSTATUSKEYVALSUMMARY": {},
            "VIRTUALSERVICEOUTOFBANDREQUESTSTATS": {},
            "GEODBLOCATIONINFO": {},
            "SEAGENTRESOLVDBRUNTIME": {},
            "SEAGENTRESOLVDBRUNTIMESUMMARY": {},
            "METRICSRUNTIMEDEBUG": {},
            "BOTCLASSIFICATIONRESULTMETRICS": {},
            "BOTUACACHERUNTIME": {},
            "BOTUACACHESTATSRUNTIME": {},
            "POOLGROUPRUNTIMEDETAIL": {},
            "SECURITYMGRUACACHEQUERY": {},
            "SECURITYMGRUACACHECLEAR": {},
            "SECURITYMGRUACACHESUMMARY": {},
            "GSLBADAPTIVERUNTIME": {},
            "BGPPEERSSTATE": {},
            "VSSERVICESERVERMAPKV": {},
            "VSSERVICESERVERMAPTABLE": {},
            "UPGRADESTATUSINFO": {},
            "CLOUDRUNTIME": {},
            "ALERTPERFDATA": {},
            "METRICSRUNTIMEDEBUGSUMMARY": {},
            "SCTPCONNRUNTIME": {},
            "SCTPCONNRUNTIMEDETAIL": {},
            "VIMGRIPSUBNETRUNTIME": {},
            "VIMGRSEVMRUNTIME": {},
            "VIMGRVMRUNTIME": {},
            "VIMGRCLUSTERRUNTIME": {},
            "SEAGENTDPPROBE": {},
            "BFDRUNNINGCONFIG": {},
            "LOGAGENTSTATSPERVS": {},
            "VSLOGSTATSDISAGGR": {},
            "VRFIPINFORUNTIME": {},
            "DPMETRICSRUNTIME": {},
            "SEAGENTOBJSYNCSTATS": {},
            "KEYVALSTATS": {},
            "CSRFMETRICS": {},
            "DIAMETERCONNECTIONS": {},
            "DUMPALLOBJSYNCSTATS": {},
            "QATSTATSRUNTIME": {},
            "DISPATCHERSTATRUNTIME6": {},
            "DISPATCHERSTATCLEARRUNTIME6": {},
            "SEFAULTINJECTSEPARAM": {},
            "SEFAULTINJECTEXHAUSTPARAM": {},
            "PRIMARYPOOL": {},
            "CONNECTIONCLEARFILTER": {},
            "DISPATCHERTABLEDUMPCLEAR": {},
            "ARPTABLEFILTER": {},
            "HTTPCACHEOBJFILTER": {},
            "CONNPOOLFILTER": {},
            "PERSISTENCEFILTER": {},
            "SELOGAGENTSTATS": {},
            "SELOGAGENTOPERSTATS": {},
            "SELOGAGENTCONTROLLERINTERFACESTATS": {},
            "SELOGAGENTNETWORKSTREAMSTATS": {},
            "SEGROUPREBALANCEREQSTATUSRESPONSE": {},
            "SEAUTOSCALERSTATUSRESPONSE": {},
            "SEGROUPONETIMEREQUESTRESPONSE": {},
            "SEGROUPREBALANCEHISTORYRESPONSE": {},
            "REBALANCEPARAMS": {},
            "SESYSTEMINFORUNTIME": {},
            "NICINFO": {},
            "METRICSAPISRVRSTATS": {},
            "SERESOURCEPROTO": {},
            "SECONSUMERPROTO": {},
            "SECREATEPENDINGPROTO": {},
            "PLACEMENTSTATS": {},
            "SEVIPPROTO": {},
            "RMVRFPROTO": {},
            "VCENTERMAP": {},
            "VIMGRVCENTERRUNTIME": {},
            "INTERESTEDVMS": {},
            "INTERESTEDHOSTS": {},
            "VCENTERSUPPORTEDCOUNTERS": {},
            "ENTITYCOUNTERS": {},
            "TRANSACTIONSTATS": {},
            "SEVMCREATEPROGRESS": {},
            "PLACEMENTSTATUS": {},
            "VISUBFOLDERS": {},
            "VIDATASTORE": {},
            "VIHOSTRESOURCES": {},
            "CLOUDCONNECTOR": {},
            "VINETWORKSUBNETVMS": {},
            "VIDATASTORECONTENTS": {},
            "VIMGRVCENTERCLOUDRUNTIME": {},
            "VIVCENTERPORTGROUPS": {},
            "VIVCENTERDATACENTERS": {},
            "VIMGRHOSTRUNTIME": {},
            "PLACEMENTGLOBALS": {},
            "ALBSERVICES": {},
            "RMCLOUDOPSPROTO": {},
            "CLOUDPLACEMENTSUMMARY": {},
            "CLOUDPLACEMENTINELIGIBLE": {},
            "SEGROUPPLACEMENTSUMMARY": {},
            "SEGROUPPLACEMENTDETAIL": {},
            "SEGROUPPLACEMENTINELIGIBLE": {},
            "SECONSUMERSUMMARY": {},
            "SECONSUMERDETAIL": {},
            "SERESOURCESUMMARY": {},
            "SERESOURCEDETAIL": {},
            "PLACEMENTSYSTEMSUMMARY": {},
            "VIMGRNWRUNTIME": {},
            "NETWORKRUNTIME": {},
            "SCTPSTATRUNTIME": {},
            "SEHUGEPAGEINFORUNTIME": {},
            "VIRTUALSERVICESTATEDBCACHESUMMARY": {},
            "POOLSTATEDBCACHESUMMARY": {},
            "SERVERSTATEDBCACHESUMMARY": {},
            "STATECACHESTATS": {},
            "STATECACHECONFIG": {},
            "STATECACHEINTERNAL": {},
            "STATECACHEDNS": {},
            "STATECACHECONFIGVERSION": {},
            "STATECACHEOPERSTATUS": {},
            "STATECACHEVIRTUALSERVICE": {},
            "STATECACHEPOOL": {},
            "STATECACHENODE": {},
            "STATECACHEOPERSTATE": {},
            "STATECACHESERVICEENGINE": {},
            "NSXTAGENT": {},
            "SERATELIMITINGRLINTERNAL": {},
            "SERATELIMITINGMSFINTERNAL": {},
            "ADAPTREPL": {},
            "POOLGROUPENABLEPRIMARYPOOL": {},
            "KEYVALSESSION": {},
            "KEYVALSESSIONSUMMARY": {},
            "SYSTEMREPORT": {},
            "AWSLOGIN": {},
            "ADAPTREPLFAULTINJ": {},
            "ALERTFAULTPARAMS": {},
            "ALERTMGRPARAMS": {},
            "ALERTTESTEMAILPARAMS": {},
            "ALERTTESTSYSLOGSNMPPARAMS": {},
            "APICVSPLACEMENTREQ": {},
            "APPLYLOGRECOMMENDATIONS": {},
            "CCFAULTPARAMS": {},
            "CLUSTERPARAMS": {},
            "CREDPARAMS": {},
            "GETLOGRECOMMENDATIONS": {},
            "GROUPPARAMS": {},
            "NSXTNSSERVICEPARAMS": {},
            "OPENSTACKLOGIN": {},
            "RETRYPLACEMENTPARAMS": {},
            "SERVERSCALEINPARAMS": {},
            "SERVERSCALEOUTPARAMS": {},
            "SYSTESTEMAILPARAMS": {},
            "TIER1ROUTERFILTER": {},
            "TRANSPORTZONEPARAMS": {},
            "VIFAULTINJECTION": {},
            "VISETMGMTIPSEREQ": {},
            "VCENTERCLOUDSTATUSREQ": {},
            "VCENTERINVENTORYDIAGREQ": {},
            "VCENTERQUARANTINEDHOSTPARAMS": {},
            "VSMIGRATEPARAMS": {},
            "VSRESYNCPARAMS": {},
            "VSSCALEINPARAMS": {},
            "VSSCALEOUTPARAMS": {},
            "VSSWITCHOVERPARAMS": {},
            "TASKJOURNAL": {},
            "JOURNALERROR": {},
            "JOURNALINFO": {},
            "JOURNALSUMMARY": {},
            "EVENTMANAGERSTATS": {},
            "EVENTMANAGERSUBSCRIPTIONS": {},
            "EVENTMANAGERCONFIG": {},
            "SYSTEMHEALTHGETSYSTEMHEALTHSECURECHANNELRESPONSE": {},
            "SYSTEMHEALTHGETSYSTEMHEALTHCLUSTERINGRESPONSE": {},
            "SYSTEMHEALTHGETSYSTEMHEALTHPOSTGRESRESPONSE": {},
            "SYSTEMHEALTHGETSERVICEFAILEDRESPONSE": {},
            "SYSTEMHEALTHGETSERVICERESTARTEDRESPONSE": {},
            "SYSTEMHEALTHGETSERVICEDETAILRESPONSE": {},
            "SEAGENTSEDATASTOREDOWNLOADFAIL": {},
            "UPGRADEPROFILE": {},
            "QATINFO": {},
            "RETENTIONPOLICY": {},
            "SYSTEMLIMITOBJECTCOUNT": {},
            "SYSTEMLIMITOBJECTCOUNTS": {},
            "EVENTGENPARAMS": {},
            "LOGMANAGERSTATS": {},
            "TECHSUPPORTPROFILE": {},
            "TECHSUPPORT": {},
            "TECHSUPPORTPARAMS": {},
            "TECHSUPPORTMESSAGE": {},
            "REPORT": {},
            "REPORTPROFILE": {},
            "SSPINSTANCE": {},
            "VSPHEREZONEPARAMS": {},
            "ROTATIONPARAMS": {},
            "IPADDRGROUPSYNCPARAMS": {},
            "ALERTMGRMONITORINGDATA": {},
            "MAXOBJECTS": {},
            "GSLBSMRUNTIME": {},
            "GSLBCRMRUNTIME": {},
            "GSLBHSMRUNTIME": {},
            "VERSIONINFO": {},
            "CFGSTATE": {},
            "GSLBDNSSEINFO": {},
            "GSLBPERDNSSTATE": {},
            "GSLBRUNTIME": {},
            "GSLBSERVICESITEPERSISTENCEPOOL": {},
            "GSLBHEALTHMONITORRUNTIME": {},
            "GSLBGEODBPROFILERUNTIME": {},
            "GSLBAPPLICATIONPERSISTENCEPROFILERUNTIME": {},
            "GSLBPKIPROFILERUNTIME": {},
            "GSLBJWTSERVERPROFILERUNTIME": {},
            "GSLBSSLPROFILERUNTIME": {},
            "GSLBSSLKEYANDCERTIFICATERUNTIME": {},
            "GSLBGEOFILE": {},
            "GSLBGEOFILERUNTIME": {},
            "EVENTINFO": {},
            "GSLBSITEHTTPTABLE": {},
            "LOCALWORKERFDSVERSION": {},
            "GSLBSERVICEHEALTHSTATUS": {},
            "GSLBFILEOBJECTRUNTIME": {},
            "GSLBRUNTIMESUMMARY": {},
            "GSLBRUNTIMEDETAIL": {},
            "GSLBRUNTIMEINTERNAL": {},
            "GSLBLEADERCHANGERUNTIME": {}
        },
        "EventId": {
            "MGMT_NW_NAME_CHANGED": {
                "description": "vCenter <vcenter> Existing <existing_nw> New <new_nw>"
            },
            "DISCOVERY_DATACENTER_DEL": {
                "description": "vCenter <vcenter> Discovery Datacenter <obj_name> deleted from vCenter"
            },
            "VINFRA_DISC_COMPLETE": {
                "description": "vCenter <vcenter> Discovery Complete. Num DCs <num_dcs> Num Clusters <num_clusters> Num Hosts <num_hosts> Num VMs <num_vms> Num NWs <num_nws>"
            },
            "VCENTER_ADDRESS_ERROR": {
                "description": "Unable to contact vCenter <vcenter>"
            },
            "SE_GROUP_CLUSTER_DEL": {
                "description": "vCenter <vcenter> Cluster <obj_name> deleted from vCenter"
            },
            "SE_GROUP_MGMT_NW_DEL": {
                "description": "vCenter <vcenter> Management Network <obj_name> deleted from vCenter"
            },
            "MGMT_NW_DEL": {
                "description": "vCenter <vcenter> Management Network <obj_name> deleted from vCenter"
            },
            "VCENTER_BAD_CREDENTIALS": {
                "description": "Bad user <name> credentials when logging to vCenter <vcenter>"
            },
            "ESX_HOST_UNREACHABLE": {
                "description": "Avi Controller unable to communicate with hosts in vCenter <vcenter>"
            },
            "SERVER_DELETED": {
                "description": "Server(s) <server_ip> deleted from Virtual Infrastructure"
            },
            "SE_GROUP_HOST_DEL": {
                "description": "vCenter <vcenter> Host <obj_name> deleted from vCenter"
            },
            "VINFRA_DISC_FAILURE": {
                "description": "vCenter <vcenter> Discovery Failure in retrieving <state>. Retrying."
            },
            "ESX_HOST_POWERED_DOWN": {
                "description": "vCenter <vcenter> Host <name> powered down"
            },
            "VCENTER_VERSION_NOT_SUPPORTED": {
                "description": "vCenter <vcenter_name> has a version which is not supported by Avi"
            },
            "VCENTER_CONNECTIVITY_FAIL": {
                "description": "Connectivity failed to vCenter <vcenter> Datacenter <datacenter> for Cloud <cloud>"
            },
            "VCENTER_CONNECTIVITY_SUCCESS": {
                "description": "Connectivity restored to vCenter <vcenter> Datacenter <datacenter> for Cloud <cloud>"
            },
            "VCENTER_ACCESS_SLOW": {
                "description": "Vcenter <vcenter> access is slow. Login took more than 10 secs"
            },
            "VCENTER_USER_ROLE_CHANGE": {
                "description": "Vcenter <vcenter> user <user> possible role change"
            },
            "VCENTER_NETWQRK_OBJECT_LIMIT_REACHED": {
                "description": "Avi Controller has <current> Network objects. Maximum limit <limit>. <additional_reason>"
            },
            "VCENTER_SE_TAGGING_FAIL": {
                "description": "Failed to tag SE"
            },
            "VCENTER_CLOUD_DELETE": {
                "description": "Waiting for removal of the objects referred to cloud %s' % pb.cc_id"
            },
            "VCENTER_QAT_CLUSTER_DRS_NOT_ENABLED": {
                "description": "For QAT-aware Service Engine placement, DRS must be enabled on the cluster(s)."
            },
            "SE_FATAL_ERROR": {
                "description": "Avi Service Engine crashed"
            },
            "SE_HEARTBEAT_FAILURE": {
                "description": "SE Heartbeat failure"
            },
            "SE_MARKED_DOWN": {
                "description": "SE unreachable - Marked down"
            },
            "SE_VM_DELETED": {
                "description": "SE VM deleted from virtual infrastructure"
            },
            "SE_UP": {
                "description": "Avi Service Engine connected to Avi Controller"
            },
            "SE_POWERED_DOWN": {
                "description": "SE powered down by virtual infrastructure"
            },
            "SE_EXTERNAL_HM_RESTART": {
                "description": "External health monitor process crashed"
            },
            "SE_DOWN": {
                "description": "Service Engine marked down"
            },
            "SE_VERSION_CHECK_FAILED": {
                "description": "SE version does not match Controller version"
            },
            "SE_UPGRADING": {
                "description": "Service Engine upgrade in progress"
            },
            "SE_ENABLE_STATE_CHANGED": {
                "description": "SE enable_state <enable_state>"
            },
            "SE_MIGRATE": {
                "description": "SE migrate_state <migrate_state>"
            },
            "CREATING_SE": {
                "description": "Creating Service Engine <se_name> for virtual service <vs_name>"
            },
            "CREATED_SE": {
                "description": "Service Engine <se_name> created"
            },
            "CREATE_SE_FAIL": {
                "description": "Service Engine <se_name> creation failed"
            },
            "CREATE_SE_TIMEOUT": {
                "description": "Service Engine <se_name> creation timed out"
            },
            "DELETING_SE": {
                "description": "Deleting Service Engine <se_name> "
            },
            "DELETED_SE": {
                "description": "Service Engine <se_name> deleted"
            },
            "DELETE_SE_FAIL": {
                "description": "Service Engine <se_name> deletion failed"
            },
            "ADD_NW_SE": {
                "description": "Network(s) <network_name> added for Virtual Service <vs_name>"
            },
            "DEL_NW_SE": {
                "description": "Network(s) <network_name> deleted"
            },
            "VS_ADD_SE": {
                "description": "Virtual service <vs_name> (<ip>) added to Service Engine <se_name>. Role: <type>"
            },
            "VS_REMOVED_SE": {
                "description": "Virtual service <vs_name> (<ip>) removed from Service Engine <se_name>"
            },
            "ADD_NW_FAIL": {
                "description": "Failed to add network(s) <network_name> to SE <se_name> for virtual service <vs_name>. Reason <reason>"
            },
            "RM_DEL_NETWORK_FAIL": {
                "description": "Deleting networks from Service Engine failed"
            },
            "REBOOT_SE": {
                "description": "Rebooting unresponsive Service Engine"
            },
            "MODIFY_NW": {
                "description": "Network(s) <network_name> modified for virtual service <vs_name>"
            },
            "MODIFY_NW_FAIL": {
                "description": "Modify network(s) <network_name> failed on Service Engine <se_name>. Reason <reason>"
            },
            "VS_SE_BOOTUP_FAIL": {
                "description": "Service Engine <se_name> failed to boot"
            },
            "VS_SE_IP_FAIL": {
                "description": "SE <se_name> failed to acquire IP address on network(s) <network_name> subnet(s) <subnet>"
            },
            "NO_HOST_AVAIL": {
                "description": "No host available for placement of new Service Engine virtual machine"
            },
            "VS_SWITCHOVER": {
                "description": "VS primary SE switchover successful"
            },
            "VS_SWITCHOVER_FAIL": {
                "description": "VS primary SE switchover failed"
            },
            "ADD_VIP_VNIC": {
                "description": "Virtual service <vs_name> (<ip>) IP added to Service Engine <se_name> NICs. Role: <type>"
            },
            "DEL_VIP_VNIC": {
                "description": "Virtual service <vs_name> (<ip>) IP removed from Service Engine <se_name> NICs"
            },
            "CC_ATTACH_IP_SUCCESS": {
                "description": "Attach IP successful for Virtual Service <vs_name><vip_id> on Service Engine <se_name>."
            },
            "CC_ATTACH_IP_TIMEDOUT": {
                "description": "Attach IP timed-out for Virtual Service <vs_name><vip_id> on Service Engine <se_name>."
            },
            "CC_ATTACH_IP_FAILURE": {
                "description": "Attach IP failed for Virtual Service <vs_name><vip_id> on Service Engine <se_name>. Reason - <reason>"
            },
            "CC_DETACH_IP_SUCCESS": {
                "description": "Detach IP successful for Virtual Service <vs_name><vip_id> on Service Engine <se_name>."
            },
            "CC_DETACH_IP_TIMEDOUT": {
                "description": "Detach IP timed-out for Virtual Service <vs_name><vip_id> on Service Engine <se_name>."
            },
            "CC_DETACH_IP_FAILURE": {
                "description": "Detach IP failed for Virtual Service <vs_name><vip_id> on Service Engine <se_name>. Reason - <reason>"
            },
            "SHARED_VIP_ASYMMETRIC": {
                "description": "Shared VIP with <num_vs> Virtual Services is scaled out asymmetrically"
            },
            "SHARED_VIP_SYMMETRIC": {
                "description": "Shared VIP with <num_vs> Virtual Services is scaled out symmetrically"
            },
            "NEW_PROBABLE_SRVR": {
                "description": "New Server matching filter in network for pool"
            },
            "VS_SCALEOUT_COMPLETE": {
                "description": "Virtual service Scale-Out Done"
            },
            "VS_SCALEIN_COMPLETE": {
                "description": "Virtual service Scale-In Done"
            },
            "VS_MIGRATE_STARTED": {
                "description": "Virtual service Migrate Started"
            },
            "VS_MIGRATE_COMPLETE": {
                "description": "Virtual service Migrate Done"
            },
            "VS_SCALEOUT_FAILED": {
                "description": "Virtual service Scale-Out Failed"
            },
            "VS_SCALEIN_FAILED": {
                "description": "Virtual service Scale-In Failed"
            },
            "VS_MIGRATE_FAILED": {
                "description": "Virtual service Migrate Failed"
            },
            "VS_AWAITING_SE": {
                "description": "Service Engine not assigned to this virtual service even after <awaitingse_timeout> seconds"
            },
            "VS_INITIAL_PLACEMENT_FAILED": {
                "description": "Virtual service initial placement on a Service Engine failed"
            },
            "UPGRADE_ALL_SE_START": {
                "description": "Starting upgrade of <num_se> Service Engines with <num_vs> virtual services"
            },
            "UPGRADE_ALL_SE_DONE": {
                "description": "Done upgrading <num_se> Service Engines"
            },
            "UPGRADE_ALL_SE_NOT_NEEDED": {
                "description": "Upgrading <num_se> Service Engines not needed"
            },
            "UPGRADE_SE_START": {
                "description": "Starting upgrade for Service Engine <se_uuid>"
            },
            "UPGRADE_SE_DONE": {
                "description": "Service Engine <se_uuid> upgrade done"
            },
            "UPGRADE_SE_NOT_NEEDED": {
                "description": "Service Engine <se_uuid> already upgraded"
            },
            "UPGRADE_SE_SUSPENDED": {
                "description": "Service Engine <se_uuid> upgrade suspended"
            },
            "UPGRADE_SE_VS_SCALEOUT": {
                "description": "Action Scale-Out executed during Service Engine upgrade"
            },
            "UPGRADE_SE_VS_SCALEIN": {
                "description": "Action Scale-In executed during Service Engine upgrade"
            },
            "UPGRADE_SE_VS_MIGRATE": {
                "description": "Action Migrate executed during Service Engine upgrade"
            },
            "UPGRADE_SE_VS_DISRUPTED": {
                "description": "Virtual service <vs_uuid> upgrade disrupted, Reason <reason>"
            },
            "REBALANCE_VS_SCALEOUT": {
                "description": "Action Scale-Out executed during Auto-Rebalance"
            },
            "REBALANCE_VS_SCALEIN": {
                "description": "Action Scale-In executed during Auto-Rebalance"
            },
            "REBALANCE_VS_MIGRATE": {
                "description": "Action Migrate executed during Auto-Rebalance"
            },
            "DISABLE_SE_VS_MIGRATE": {
                "description": "Action Migrate executed during Disable-SE"
            },
            "ROLLBACK_ALL_SE_START": {
                "description": "Starting rollback of <num_se> Service Engines with <num_vs> virtual services"
            },
            "ROLLBACK_ALL_SE_DONE": {
                "description": "Done rollback of <num_se> Service Engines"
            },
            "MIGRATE_SE_STARTED": {
                "description": "started migration on disable Service Engine"
            },
            "MIGRATE_SE_RESTARTED": {
                "description": "restarted migration on disable Service Engine"
            },
            "MIGRATE_SE_FINISHED": {
                "description": "successfully migrated all VSs from disable Service Engine"
            },
            "MIGRATE_SE_FAILED": {
                "description": "failed <num_vs> VS migrations on disable Service Engine"
            },
            "MIGRATE_SE_VS_MIGRATE_STARTED": {
                "description": "started VS <vs_uuid> migration on disable Service Engine"
            },
            "MIGRATE_SE_VS_MIGRATE_FINISHED": {
                "description": "successfully migrated <vs_uuid> VS from disable Service Engine"
            },
            "MIGRATE_SE_VS_MIGRATE_FAILED": {
                "description": "failed migrating <vs_uuid> VS from disable Service Engine"
            },
            "VIP_SCALEOUT": {
                "description": "Vip Scale-Out"
            },
            "VIP_SCALEOUT_FAILED": {
                "description": "Vip Scale-Out"
            },
            "VIP_SCALEIN": {
                "description": "Vip Scale-In"
            },
            "VIP_SCALEIN_FAILED": {
                "description": "Vip Scale-In"
            },
            "SERVER_DOWN": {
                "description": "Server <hostname> (<addr>:<port>) in Pool <pool> is DOWN due to health monitor <shm]> failure"
            },
            "SERVER_UP": {
                "description": "Server <hostname> (<addr>:<port>) in Pool <pool> is UP"
            },
            "POOL_DOWN": {
                "description": "Pool is DOWN"
            },
            "POOL_UP": {
                "description": "Pool is UP"
            },
            "VS_DOWN": {
                "description": "Virtual service is DOWN"
            },
            "VS_UP": {
                "description": "Virtual service is UP"
            },
            "SE_SERVER_DISABLED": {
                "description": "Server <hostname> (<addr>:<port>) in Pool <pool> was disabled"
            },
            "VS_CONN_LIMIT": {
                "description": "<value> connection(s) dropped due to virtual service connection limit"
            },
            "VS_THROUGHPUT_LIMIT": {
                "description": "<value> packet(s) dropped due to virtual service bandwidth limit"
            },
            "CONN_DROP_MAX_SYN_TBL": {
                "description": "<value> connection(s) dropped due to SYN table limit"
            },
            "CONN_DROP_MAX_FLOW_TBL": {
                "description": "<value> connection(s) dropped due to flow table limit"
            },
            "CONN_DROP_MAX_PERSIST_TBL": {
                "description": "<value> connection(s) dropped due to persistence table limit"
            },
            "CONN_DROP_POOL_LB_FAILURE": {
                "description": "<value> pool load balancing decision(s) failed"
            },
            "CONN_DROP_NO_CONN_MEM": {
                "description": "<value> connection(s) dropped due to insuffience memory"
            },
            "CONN_DROP_NO_PKT_BUFF": {
                "description": "<value> connection(s) dropped due to low packet buffer."
            },
            "PKT_DROP_NO_PKT_BUFF": {
                "description": "<value> packet(s) dropped due to low packet buffer"
            },
            "PKT_BUFF_ALLOC_FAIL": {
                "description": "<value> packet buffer allocation failure(s)"
            },
            "CACHE_OBJ_ALLOC_FAIL": {
                "description": "<value> HTTP cacheable objects dropped due to memory allocation failure"
            },
            "SYN_ATTACK": {
                "description": "SYN DDoS Attack"
            },
            "CONN_THROTTLED_MEMFAIL_FLOW_TBL": {
                "description": "<value> connection(s) throttled due to memory failure."
            },
            "SE_CPU_HIGH": {
                "description": "CPU usage over Threshold <threshold> % Current <current_value> %"
            },
            "SE_MEM_HIGH": {
                "description": "Memory usage over Threshold <threshold> % Current <current_value> %"
            },
            "SE_PKT_BUFF_HIGH": {
                "description": "Packet buffer usage over Threshold <threshold> % Current <current_value> %"
            },
            "SE_PERSIST_TBL_HIGH": {
                "description": "Persistence table usage over Threshold <threshold> % Current <current_value> %"
            },
            "SE_CONN_MEM_HIGH": {
                "description": "Connection memory usage over Threshold <threshold> % Current <current_value> %"
            },
            "SE_DISK_HIGH": {
                "description": "Disk usage over Threshold <threshold> % Current  <current_value> %"
            },
            "SE_FLOW_TBL_HIGH": {
                "description": "Flow table usage over Threshold <threshold> % Current  <current_value> %"
            },
            "SE_SYN_TBL_HIGH": {
                "description": "SYN table usage over Threshold <threshold> % Current <current_value> %"
            },
            "SE_VNIC_DHCP_IP_ALLOC_FAILURE": {
                "description": "IP address allocation failure, Service Engine <se_uuid> vNIC <vnic_name> Network <network_uuid> MAC <mac>"
            },
            "SE_VNIC_DUPLICATE_IP": {
                "description": "Duplicate - IP vNIC <vnic_name> IP <vnic_ip>  Remote MAC <remote_mac>  Local MAC <local_mac>"
            },
            "SE_SYN_CACHE_USAGE_HIGH": {
                "description": "SYN cache usage over Threshold <threshold> % Current <current_value> %"
            },
            "VM_CPU_HIGH": {
                "description": "CPU usage over Threshold VM <vm_type> : <threshold> % Current <current_value> %"
            },
            "VM_MEM_HIGH": {
                "description": "Memory usage over Threshold VM <vm_type> : <threshold> % Current <current_value> %"
            },
            "VS_SE_HA_ACTIVE": {
                "description": "Virtual service is UP on Service Engine <se_name>"
            },
            "VS_SE_HA_COMPROMISED": {
                "description": "Virtual service is DOWN on Service Engine <se_name>:<ha_reason>"
            },
            "POOL_SE_HA_ACTIVE": {
                "description": "Pool is UP on Service Engine <se_name>"
            },
            "POOL_SE_HA_COMPROMISED": {
                "description": "Pool is DOWN on Service Engine <se_name>:<ha_reason>"
            },
            "SERVER_DOWN_HA_COMPROMISED": {
                "description": "Server <hostname> (<addr>:<port>) down due to health monitor <shm]> failure by at least one but not all Service Engines"
            },
            "SERVER_UP_HA_ACTIVE": {
                "description": "Server <hostname> (<addr>:<port>) is active"
            },
            "SE_VNIC_IP_ADDED": {
                "description": "IP address added to vnic, Service Engine <se_uuid> vNIC <if_name> IP <ip> Mask <mask> Mode <mode> Namespace <ns> Network <network_uuid> MAC <mac>"
            },
            "SE_VNIC_IP_REMOVED": {
                "description": "IP address removed from vnic, Service Engine <se_uuid> vNIC <if_name> IP <ip> Mask <mask> Mode <mode> Namespace <ns> Network <network_uuid> MAC <mac>"
            },
            "GS_MEMBER_DOWN": {
                "description": "GslbService Member <addr> is DOWN due to gslb health monitor failure"
            },
            "GS_MEMBER_UP": {
                "description": "GslbService Member <addr> (<domain>) is UP"
            },
            "GS_GROUP_DOWN": {
                "description": "GslbService Group is DOWN"
            },
            "GS_GROUP_UP": {
                "description": "GslbService Group is UP"
            },
            "GS_DOWN": {
                "description": "GslbService is DOWN"
            },
            "GS_UP": {
                "description": "GslbService is UP"
            },
            "VIP_DOWN": {
                "description": "VIP <addr> is DOWN"
            },
            "VIP_UP": {
                "description": "VIP <addr> is UP"
            },
            "SE_GEO_DB_FAILURE": {
                "description": "Failed to load Geo Database"
            },
            "VS_GEO_DB_FAILURE": {
                "description": "Failed to load Geo Database"
            },
            "SE_GEO_DB_SUCCESS": {
                "description": "Successfully loaded Geo Database"
            },
            "VS_GEO_DB_SUCCESS": {
                "description": "Successfully loaded Geo Database"
            },
            "VS_CONFIG_SE_DATASTORE_DOWNLOAD_FAILED": {
                "description": "SeDatastore Config Download Failed On SE"
            },
            "SE_CONFIG_SE_DATASTORE_DOWNLOAD_FAILED": {
                "description": "SeDatastore Config Download Failed On SE"
            },
            "SE_IP6_DAD_FAILED": {
                "description": "DAD failed for <addr> on interface <if_name>"
            },
            "SE_EV_VS_RL_CONFIG_FAILED": {
                "description": "Virtual Service rate limiter configuration failed"
            },
            "SE_VS_PKT_BUFF_HIGH": {
                "description": "Packet buffer usage for the Virtual Service <virtual_service> is over threshold <threshold>%, current value: <current_value>%"
            },
            "SE_DISCONTINUOUS_TIME_CHANGE": {
                "description": "Time has discontinuously jumped in SE <se_name> (<se_uuid>) from <from_time> to <to_time> with NTP Servers <ntp_servers>"
            },
            "SE_HIGH_INGRESS_PROC_LATENCY": {
                "description": "SE : <se_name> (<se_uuid>) Packet processing latency is high. max dispatcher_processing_latency: <max_dispatcher_proc_time> msflow-core: <flow_core> max proxy_dequeue_latency: <max_disp_to_proxy_queing_delay> ms event-count: <event_count>"
            },
            "SE_NTP_SYNCHRONIZATION_FAILED": {
                "description": "SE <se_name> (<se_uuid>): NTP Synchronization failed for server(s): <ntp_servers>"
            },
            "SE_HIGH_EGRESS_PROC_LATENCY": {
                "description": "SE : <se_name> (<se_uuid>) Packet queueing latency is high. dispatcher-core : <dispatcher_core> max latency : <max_proxy_to_disp_queing_delay> ms event-count: <event_count>"
            },
            "SE_ARP_RATE_LIMIT_DROP": {
                "description": "SE: (<se_uuid>) ARP packets dropped due to rate limiting."
            },
            "SE_ND_RATE_LIMIT_DROP": {
                "description": "SE: (<se_uuid>) ND packets dropped due to rate limiting."
            },
            "DEBUG_MODE_ON": {
                "description": "debug_mode is enabled on SE."
            },
            "DEBUG_MODE_OFF": {
                "description": "debug_mode is disabled on SE."
            },
            "QAT_SERVICE_OPER_DOWN": {
                "description": "Intel QAT Hardware Offload service is not running on SE."
            },
            "CONFIG_CREATE": {
                "description": "Config <resource_name> create status is <status> (performed by user <user>)"
            },
            "CONFIG_UPDATE": {
                "description": "Config <resource_name> update status is <status> (performed by user <user>)"
            },
            "CONFIG_DELETE": {
                "description": "Config <resource_name> delete status is <status> (performed by <user>)"
            },
            "USER_LOGIN": {
                "description": "User <user> login (<status>) from <client_ip> using <client_type>"
            },
            "USER_LOGOUT": {
                "description": "User <user> logout from <client_ip>"
            },
            "CONFIG_ACTION": {
                "description": "Action <action_name> executed by <user>"
            },
            "USER_AUTHORIZED_BY_RULE": {
                "description": "User <user> was authorized by mapping rule <rule>"
            },
            "USER_NOT_AUTHORIZED_BY_ANY_RULE": {
                "description": "User <user> not authorized by any mapping rule"
            },
            "CONFIG_SE_GRP_FLAVOR_UPDATE": {
                "description": "Service Engine Group <se_group_name> VM Instance flavor was updated from <old_flv> to <new_flv>"
            },
            "API_VERSION_DEPRECATED": {
                "description": "<api_version_used> API version, used on path <path> from <client_ip>, is deprecated. Please switch to api version >= <min_supported_api_version>."
            },
            "DNS_QUERY_ERROR": {
                "description": "<error_message> FQDN - <fqdn>"
            },
            "CONFIG_EXPORT": {
                "description": "Export Configuration completed with status <status> (performed by user <user>)"
            },
            "TECHSUPPORT_COLLECTION_STARTED": {
                "description": "Tech Support invoked by user."
            },
            "TECHSUPPORT_COLLECTION_ONGOING": {
                "description": "Another Tech Support collection is already in progress."
            },
            "TECHSUPPORT_COLLECTION_SUCCESS": {
                "description": "Tech Support collected successfully."
            },
            "TECHSUPPORT_COLLECTION_SUCCESS_WITH_ERROR": {
                "description": "Tech Support collected successfully with errors."
            },
            "WARNING_EVENT": {
                "description": "Warning: <warning_message>"
            },
            "SSL_CERT_EXPIRE": {
                "description": "SSL certificate expires in <days_left> days"
            },
            "SSL_KEY_EXPORTED": {
                "description": "SSL Private Keys are exported by <user> "
            },
            "SSL_CERT_RENEW": {
                "description": "SSL certificate <name> is about to expire. Renewing with the Certificate Management Service"
            },
            "SSL_CERT_RENEW_FAILED": {
                "description": "SSL certificate <name> renewal failed. Error was <error>"
            },
            "SSL_CERT_IGNORED": {
                "description": "SSL Certificate with CN <name> has been ignored. Reason: <reason>"
            },
            "SSL_CERT_REVOKED": {
                "description": "SSL certificate revoked by OCSP Responder."
            },
            "CONTROLLER_NODE_JOINED": {
                "description": "Controller <node_name> joined the Controller cluster"
            },
            "CONTROLLER_NODE_LEFT": {
                "description": "Controller <node_name> left the Controller cluster"
            },
            "CONTROLLER_SERVICE_FAILURE": {
                "description": "Controller service <service_name> failed"
            },
            "CONTROLLER_LEADER_FAILOVER": {
                "description": "Controller cluster leader failover"
            },
            "CONTROLLER_WARM_REBOOT": {
                "description": "Controller warm restarted"
            },
            "CONTROLLER_SERVICE_RESTORED": {
                "description": "Controller service <service_name> restored"
            },
            "CONTROLLER_SERVICE_CRITICAL_FAILURE": {
                "description": "Controller service <service_name> critical failure"
            },
            "CONTROLLER_NODE_SHUTDOWN": {
                "description": "Controller <node_name> shutdown initiated"
            },
            "CONTROLLER_NODE_STARTED": {
                "description": "Controller <node_name> started"
            },
            "CLUSTER_CONFIG_FAILED": {
                "description": "Controller Cluster configuration failed."
            },
            "SE_SECURE_KEY_EXCHANGE": {
                "description": "SE <se_ip> initiates secure key exchange with controller <ctlr_public_ip>"
            },
            "CTLR_SECURE_KEY_EXCHANGE": {
                "description": "Follower <follower_ip> initiates secure key exchange with leader <leader_ip>"
            },
            "MALFORMED_SECURE_KEY_EXCHANGE": {
                "description": "Malformed client type"
            },
            "CLUSTIFY_CHECK_EVENT": {
                "description": "Cluster check event"
            },
            "SYSTEM_UPGRADE_STARTED": {
                "description": "Avi Vantage system upgrade started"
            },
            "SYSTEM_UPGRADE_COMPLETE": {
                "description": "Avi Vantage system upgrade complete"
            },
            "SYSTEM_UPGRADE_ABORTED": {
                "description": "Avi Vantage system upgrade failed and was aborted"
            },
            "SYSTEM_ROLLBACK_STARTED": {
                "description": "Avi Vantage system rollback started"
            },
            "SYSTEM_ROLLBACK_COMPLETE": {
                "description": "Avi Vantage system rollback complete"
            },
            "SYSTEM_ROLLBACK_ABORTED": {
                "description": "Avi Vantage system rollback failed and was aborted"
            },
            "CONTROLLER_NODE_DB_REPLICATION_FAILED": {
                "description": "Controller <node_name> failed database replication <failure_count> times"
            },
            "CONTROLLER_PROCESS_STOPPED": {
                "description": "Stopping process <process>/PID <pid> <debug_message> (actual=<memory_used> KB/limit=<limit> KB) via Memory Balancer"
            },
            "CONTROLLER_MEMORY_BALANCER_DEACTIVATED": {
                "description": "Memory Balancer deactivated. Controller memory <controller_memory> GB is less than minimum required (12 GB)"
            },
            "CONTROLLER_DISCONTINUOUS_TIME_CHANGE": {
                "description": "Time has discontinuously jumped in Controller <node_name> from <from_time> to <to_time> with NTP servers <ntp_servers>"
            },
            "CONTROLLER_PROCESS_STOPPED_MEMORY_VIOLATION": {
                "description": "Controller crossed higher memory limit, usage percent: <controller_memory_usage_percent>. Stopping process <process>/PID <pid>"
            },
            "LOG_MANAGER_TASKQUEUE_ABNORMAL_GROWTH": {
                "description": "Process <process>/PID <pid> abnormal usage of taskqueue, current length is <task_queue_length>"
            },
            "USAGE_METERING_REGISTRATION": {
                "description": "Usage Metering registration with NSX-T Clouds."
            },
            "USAGE_METERING_DE_REGISTRATION": {
                "description": "Usage Metering de-registration with NSX-T Clouds."
            },
            "METRIC_THRESHOLD_UP_VIOLATION": {
                "description": "Threshold exceeded for metric."
            },
            "LICENSE_EXPIRY": {
                "description": "License expiry notification."
            },
            "ANOMALY": {
                "description": "Anomalous metric <metric_id> of value <value> and deviation <deviation> "
            },
            "LICENSE_ADDITION_NOTIF": {
                "description": "License addition."
            },
            "LICENSE_REMOVAL_NOTIF": {
                "description": "License removal."
            },
            "METRICS_DB_DISK_FULL": {
                "description": "Metrics DB Disk usage reached quota <metrics_quota> GB"
            },
            "METRICS_DB_QUEUE_FULL": {
                "description": "Metrics DB queue is full"
            },
            "METRICS_DB_QUEUE_HEALTHY": {
                "description": "Metrics DB queue is healthy"
            },
            "METRICS_GRPC_AUTH_FAILURE": {
                "description": "Grpc authentication failure, peer <peer>"
            },
            "OPENSTACK_ACCESS_FAILURE": {
                "description": "OpenStack access/setup failure"
            },
            "OPENSTACK_IMAGE_UPLOAD_FAILURE": {
                "description": "OpenStack image upload failure"
            },
            "OPENSTACK_SE_VM_CREATED": {
                "description": "OpenStack Avi Service Engine created"
            },
            "OPENSTACK_SE_VM_DELETED": {
                "description": "OpenStack Avi Service Engine deleted"
            },
            "OPENSTACK_SE_VM_DELETION_DETECTED": {
                "description": "Avi Service Engine deleted in OpenStack"
            },
            "OPENSTACK_SE_CREATION_FAILURE": {
                "description": "Avi Service Engine creation failure"
            },
            "OPENSTACK_SE_DELETION_FAILURE": {
                "description": "Avi Service Engine deletion failure"
            },
            "OPENSTACK_VNIC_ADDITION_FAILURE": {
                "description": "vNIC addition failure"
            },
            "OPENSTACK_VNIC_DELETION_FAILURE": {
                "description": "vNIC deletion failure"
            },
            "OPENSTACK_IP_DETACH_FAILURE": {
                "description": "IP detach failure"
            },
            "OPENSTACK_IP_ATTACH_FAILURE": {
                "description": "IP attach failure"
            },
            "OPENSTACK_LBPROV_AUDIT_FAILURE": {
                "description": "OpenStack LBaaS audit check failure"
            },
            "OPENSTACK_LBPLUGIN_OP_FAILURE": {
                "description": "OpenStack LBaaS plugin operation failure"
            },
            "OPENSTACK_SYNC_SERVICES_FAILURE": {
                "description": "OpenStack sync services failure"
            },
            "OPENSTACK_TENANTS_DELETED": {
                "description": "OpenStack tenants deleted"
            },
            "OPENSTACK_API_VERSION_CHECK_FAILED": {
                "description": "OpenStack API version check failed"
            },
            "AWS_ACCESS_FAILURE": {
                "description": "AWS access/setup failure"
            },
            "AWS_IMAGE_UPLOAD_FAILURE": {
                "description": "AWS image upload failure"
            },
            "AWS_SNS_ACCESS_FAILURE": {
                "description": "AWS SNS access/setup failed"
            },
            "AWS_SQS_ACCESS_FAILURE": {
                "description": "AWS SQS access/setup failed"
            },
            "AWS_ASG_PUT_NOTIFICATION_CONFIGURATION_FAILURE": {
                "description": "Adding notification configuration to Autoscaling Group <asg_name> failed"
            },
            "AWS_ASG_DELETE_NOTIFICATION_CONFIGURATION_FAILURE": {
                "description": "Deleting notification configuration from Autoscaling Group <asg_name> failed"
            },
            "AWS_ASG_NOTIFICATION_PROCESSING_FAILURE": {
                "description": "Processing AWS Autoscaling Group notification failed"
            },
            "AWS_ASG_NOTIFICATION_INSTANCE_ADDED": {
                "description": "Instance <instance_ip_addr> added to AWS Autoscaling group <asg_name>"
            },
            "AWS_ASG_NOTIFICATION_INSTANCE_REMOVED": {
                "description": "Instance <instance_ip_addr> removed from AWS Autoscaling group <asg_name>"
            },
            "AWS_ASG_ACCESS_FAILURE": {
                "description": "AWS Autoscaling group access/setup failed"
            },
            "AWS_ASG_NOTIFICATION_INSTANCE_LAUNCH_ERROR": {
                "description": "Failed to launch instance in AWS Autoscaling group <asg_name>"
            },
            "AWS_ASG_NOTIFICATION_INSTANCE_TERMINATE_ERROR": {
                "description": "Failed to terminate instance <instance_id> in AWS Autoscaling group <asg_name>"
            },
            "AWS_ASG_NOTIFICATION_AUTOSCALE_GROUP_DELETED": {
                "description": "Autoscaling groups - %s deleted from AWS' % pb.asgs"
            },
            "CLOUD_AUTOSCALING_CONFIG_FAILURE": {
                "description": "Failed to configure autoscaling"
            },
            "CLOUD_AUTOSCALING_DECONFIG_FAILURE": {
                "description": "Failed to deconfigure autoscaling"
            },
            "CLOUD_AUTOSCALING_ASG_ADD_FAILURE": {
                "description": "Failed to add autoscaling group %s' % pb.asg_name"
            },
            "CLOUD_AUTOSCALING_ASG_REMOVE_FAILURE": {
                "description": "Failed to remove autoscaling groups %' % pb.asg_name"
            },
            "CLOUD_AUTOSCALING_NOTIFICATION_PROCESSING_FAILURE": {
                "description": "Failed to process autoscaling Group notification"
            },
            "CLOUD_ROUTE_CREATION_FAILURE": {
                "description": "Failed to Create/Update routes on cloud"
            },
            "CLOUD_ROUTE_REMOVE_FAILURE": {
                "description": "Failed to delete routes on cloud"
            },
            "CLOUDSTACK_ACCESS_FAILURE": {
                "description": "CloudStack access/setup failure"
            },
            "CLOUDSTACK_IMAGE_UPLOAD_FAILURE": {
                "description": "CloudStack image upload failure"
            },
            "DOCKER_UCP_ACCESS_SUCCESS": {
                "description": "Docker UCP access success"
            },
            "DOCKER_UCP_ACCESS_FAILURE": {
                "description": "Docker UCP access failure"
            },
            "DOCKER_UCP_IMAGE_UPLOAD_FAILURE": {
                "description": "Docker UCP image upload failure"
            },
            "DOCKER_UCP_IMAGE_UPLOAD_SUCCESS": {
                "description": "Docker UCP image upload success"
            },
            "VCA_ACCESS_FAILURE": {
                "description": "VCA access/setup failure"
            },
            "VCA_IMAGE_UPLOAD_FAILURE": {
                "description": "VCA image upload failure"
            },
            "LS_ACCESS_FAILURE": {
                "description": "LinuxServer access/setup failure"
            },
            "LS_IMAGE_UPLOAD_FAILURE": {
                "description": "LinuxServer image upload failure"
            },
            "MESOS_ACCESS_SUCCESS": {
                "description": "Mesos access success"
            },
            "MESOS_ACCESS_FAILURE": {
                "description": "Mesos access failure"
            },
            "MESOS_IMAGE_UPLOAD_FAILURE": {
                "description": "Mesos image upload failure"
            },
            "MESOS_IMAGE_UPLOAD_SUCCESS": {
                "description": "Mesos image upload success"
            },
            "MESOS_CREATED_SE": {
                "description": "Created Service Engine"
            },
            "MESOS_CREATE_SE_FAIL": {
                "description": "Service Engine create failed"
            },
            "MESOS_DELETED_SE": {
                "description": "Service Engine deleted"
            },
            "MESOS_DELETE_SE_FAIL": {
                "description": "Service Engine delete failed."
            },
            "MESOS_STOPPED_SE": {
                "description": "Service Engine stopped"
            },
            "MESOS_STOP_SE_FAIL": {
                "description": "Service Engine stop failed"
            },
            "MESOS_STARTED_SE": {
                "description": "Service Engine started"
            },
            "MESOS_START_SE_FAIL": {
                "description": "Service Engine start failed"
            },
            "MESOS_UPDATED_HOSTS": {
                "description": "Mesos list of hosts has changed"
            },
            "CC_SE_CREATED": {
                "description": "Service Engine created"
            },
            "CC_SE_CREATION_FAILURE": {
                "description": "Service Engine creation failure"
            },
            "CC_SE_DELETED": {
                "description": "Service Engine deleted"
            },
            "CC_SE_DELETION_FAILURE": {
                "description": "Service Engine delete failed"
            },
            "CC_SE_DELETION_DETECTED": {
                "description": "Service Engine deleted from cloud"
            },
            "CC_VNIC_ADDITION_FAILURE": {
                "description": "vNIC addition failure"
            },
            "CC_VNIC_DELETION_FAILURE": {
                "description": "vNIC delete failed"
            },
            "CC_IP_ATTACHED": {
                "description": "IP address attached to port."
            },
            "CC_IP_ATTACH_FAILURE": {
                "description": "IP attach to port failed"
            },
            "CC_IP_DETACHED": {
                "description": "IP address detached from port"
            },
            "CC_IP_DETACH_FAILURE": {
                "description": "IP detach failure."
            },
            "CC_SYNC_SERVICES_FAILURE": {
                "description": "Sync services failed"
            },
            "CC_UPDATE_VIP_FAILURE": {
                "description": "VS create/update failed"
            },
            "CC_DELETE_VIP_FAILURE": {
                "description": "VS delete failed"
            },
            "CC_CONFIG_FAILURE": {
                "description": "Cloud configuration failed"
            },
            "CC_DECONFIG_FAILURE": {
                "description": "Cloud deconfiguration failed"
            },
            "CC_GENERIC_FAILURE": {
                "description": "Cloud generic failure."
            },
            "CC_CLUSTER_VIP_CONFIG_FAILURE": {
                "description": "Cluster VIP configuration in cloud failed"
            },
            "CC_CLUSTER_VIP_DECONFIG_FAILURE": {
                "description": "Cluster VIP deconfiguration in cloud failed"
            },
            "CC_MARATHON_SERVICE_PORT_OUTSIDE_VALID_RANGE": {
                "description": "Application requested a service port outside the range of its Marathon instance"
            },
            "CC_MARATHON_SERVICE_PORT_ALREADY_IN_USE": {
                "description": "Application requested a service port already in use."
            },
            "CC_VIP_DNS_REGISTER_FAILURE": {
                "description": "DNS registration of VS FQDN in Cloud failed"
            },
            "CC_TENANT_INIT_FAILURE": {
                "description": "Initialization of tenant in cloud failed"
            },
            "CC_HEALTH_FAILURE": {
                "description": "Cloud health check failed."
            },
            "CC_HEALTH_OK": {
                "description": "Cloud health check passed."
            },
            "CC_SE_STARTED": {
                "description": "Service Engine started"
            },
            "CC_SE_START_FAILURE": {
                "description": "Service Engine start failed"
            },
            "CC_SE_STOPPED": {
                "description": "Service Engine stopped"
            },
            "CC_SE_STOP_FAILURE": {
                "description": "Service Engine stop failed"
            },
            "CC_VIP_PARK_INTF_FAILURE": {
                "description": "VIP-parking interface create/lookup failed"
            },
            "CC_VIP_DNS_DEREGISTER_FAILURE": {
                "description": "DNS deregistration of VS FQDN in Cloud failed"
            },
            "CC_VIP_DNS_VALIDATION_FAILURE": {
                "description": "DNS domain validation of VS FQDN in Cloud failed"
            },
            "CC_VIP_DNS_REGISTER_SUCCESS": {
                "description": "DNS registration of VS FQDN in Cloud succeeded"
            },
            "CC_VIP_DNS_DEREGISTER_SUCCESS": {
                "description": "DNS deregistration of VS FQDN in Cloud succeeded"
            },
            "AWS_ROUTE53_ACCESS_FAILURE": {
                "description": "AWS Route 53 access/setup failure"
            },
            "CC_SCALE_SET_POLLING_FAILURE": {
                "description": "Scaleset polling failed"
            },
            "CC_SCALE_SET_POLLING_SUCCESS": {
                "description": "Scaleset polling succeeded"
            },
            "CC_MANAGEMENT_SVC_CREATED": {
                "description": "Management Service <management_service_name> created for Supervisor <supervisor_id> to expose Avi Controller endpoint"
            },
            "CC_MANAGEMENT_SVC_CREATION_FAILURE": {
                "description": "Management Service <management_service_name> creation failed for Supervisor <supervisor_id>: <error_string>"
            },
            "CC_MANAGEMENT_SVC_DELETED": {
                "description": "Management Service <management_service_name> deleted for Supervisor <supervisor_id>"
            },
            "CC_MANAGEMENT_SVC_DELETION_FAILURE": {
                "description": "Management Service <management_service_name> deletion failed for Supervisor <supervisor_id>: <error_string>"
            },
            "CC_MANAGEMENT_SVC_ACCESS_GRANT_CREATED": {
                "description": "Access Grant <access_grant_name> created for namespace <namespace> enabling AKO connectivity to Avi Controller"
            },
            "CC_MANAGEMENT_SVC_ACCESS_GRANT_CREATION_FAILURE": {
                "description": "Access Grant creation failed for namespace <namespace>: <error_string>"
            },
            "CC_MANAGEMENT_SVC_ACCESS_GRANT_DELETED": {
                "description": "Access Grant <access_grant_name> deleted for namespace <namespace>"
            },
            "CC_MANAGEMENT_SVC_ACCESS_GRANT_DELETION_FAILURE": {
                "description": "Access Grant deletion failed for namespace <namespace>: <error_string>"
            },
            "VS_HEALTH_CHANGE": {
                "description": "Deprecated"
            },
            "SE_HEALTH_CHANGE": {
                "description": "Deprecated"
            },
            "POOL_HEALTH_CHANGE": {
                "description": "Deprecated"
            },
            "SERVER_HEALTH_CHANGE": {
                "description": "Deprecated"
            },
            "VS_HEALTH_DEGRADED": {
                "description": "Virtual service health score changed from <previous_value> to <value>"
            },
            "SE_HEALTH_DEGRADED": {
                "description": "Service Engine health score changed from <previous_value> to <value>"
            },
            "POOL_HEALTH_DEGRADED": {
                "description": "Pool health score changed from <previous_value> to <value>"
            },
            "SERVER_HEALTH_DEGRADED": {
                "description": "<sub_resource_prefix> health score changed from <previous_value> to <value>"
            },
            "DUPLICATE_SUBNETS": {
                "description": "IP subnet : <ip_nw> discovered in multiple networks"
            },
            "SUMMARIZED_SUBNETS": {
                "description": "Overlapping subnets detected in the Cloud Infrastructure"
            },
            "IP_POOL_ALMOST_EXHAUSTED": {
                "description": "90% of IP Pool configured has been utilized"
            },
            "IP_POOL_EXHAUSTED": {
                "description": "100% of IP Pool configured has been utilized"
            },
            "IP_POOL_ALMOST_EXHAUSTED_VIP": {
                "description": "90% of IP Pool configured for VIPs has been utilized"
            },
            "IP_POOL_EXHAUSTED_VIP": {
                "description": "100% of IP Pool configured for VIPs has been utilized"
            },
            "IP_POOL_ALMOST_EXHAUSTED_SE": {
                "description": "90% of IP Pool configured for SEs has been utilized"
            },
            "IP_POOL_EXHAUSTED_SE": {
                "description": "100% of IP Pool configured for SEs has been utilized"
            },
            "LICENSE_EXPIRED": {
                "description": "License expired."
            },
            "LICENSE_LIMIT_SE_SERVICE_CORES": {
                "description": "<current_value>% of total licensed ServiceEngine service cores used"
            },
            "CONTAINER_CLOUD_ACCESS_SUCCESS": {
                "description": "ContainerCloud access success"
            },
            "CONTAINER_CLOUD_ACCESS_FAILURE": {
                "description": "ContainerCloud access failure"
            },
            "CONTAINER_CLOUD_IMAGE_UPLOAD_FAILURE": {
                "description": "ContainerCloud image upload failure"
            },
            "CONTAINER_CLOUD_IMAGE_UPLOAD_SUCCESS": {
                "description": "ContainerCloud image upload success"
            },
            "CONTAINER_CLOUD_CREATED_SE": {
                "description": "Created Service Engine"
            },
            "CONTAINER_CLOUD_CREATE_SE_FAIL": {
                "description": "Service Engine create failed"
            },
            "CONTAINER_CLOUD_DELETED_SE": {
                "description": "Service Engine deleted"
            },
            "CONTAINER_CLOUD_DELETE_SE_FAIL": {
                "description": "Service Engine delete failed."
            },
            "CONTAINER_CLOUD_STOPPED_SE": {
                "description": "Service Engine stopped"
            },
            "CONTAINER_CLOUD_STOP_SE_FAIL": {
                "description": "Service Engine stop failed"
            },
            "CONTAINER_CLOUD_STARTED_SE": {
                "description": "Service Engines started"
            },
            "CONTAINER_CLOUD_START_SE_FAIL": {
                "description": "Service Engine start failed"
            },
            "CONTAINER_CLOUD_UPDATED_HOSTS": {
                "description": "ContainerCloud list of hosts has changed"
            },
            "CONTAINER_CLOUD_SERVICE_SUCCESS": {
                "description": "ContainerCloud service CRUD success"
            },
            "CONTAINER_CLOUD_SERVICE_FAILURE": {
                "description": "ContainerCloud service CRUD failure"
            },
            "CONTAINER_CLOUD_SERVICE_INCOMPLETE": {
                "description": "ContainerCloud service update incomplete"
            },
            "CONTAINER_CLOUD_HEALTHCHECK_SE": {
                "description": "Service Engines health check"
            },
            "CONTAINER_CLOUD_HEALTHCHECK_SE_FAIL": {
                "description": "Service Engine health check failed"
            },
            "AVG_UPTIME_CHANGE": {},
            "DOS_ATTACK": {
                "event_internal": false
            },
            "SERVER_AUTOSCALE_OUT": {
                "description": "Scale-Out of <num_scaleout_servers> server(s) due to <reason>."
            },
            "SERVER_AUTOSCALE_IN": {
                "description": "Scale-In of <num_scalein_servers> server(s) due to <reason>."
            },
            "SERVER_AUTOSCALE_OUT_COMPLETE": {
                "description": "<nscaleout> server(s) launch complete."
            },
            "SERVER_AUTOSCALE_IN_COMPLETE": {
                "description": "<nscalein> server(s) Scale-In complete"
            },
            "SERVER_AUTOSCALE_FAILED": {
                "description": "Server Scale-Out failed"
            },
            "SERVER_AUTOSCALE_IN_FAILED": {
                "description": "Server Scale-in failed"
            },
            "SERVER_AUTOSCALE_OUT_FAILED": {
                "description": "Server Scale-out failed"
            },
            "SE_GATEWAY_HEARTBEAT_FAILED": {
                "description": "Ping heartbeat to gateway IP <gateway_ip> vrf <vrf_name> failed "
            },
            "SE_GATEWAY_HEARTBEAT_SUCCESS": {
                "description": "Ping heartbeat to gateway IP <gateway_ip> vrf <vrf_name> is successful"
            },
            "SE_VNIC_DOWN_EVENT": {
                "description": "VNIC <if_name>/<linux_name>, MAC <mac> is down"
            },
            "SE_VNIC_TX_QUEUE_STALL": {
                "description": "VNIC <linux_name>, queue <queue> stall detected"
            },
            "SE_BGP_PEER_STATE_CHANGE": {
                "description": "BGP peer <peer_ip> state changed to <peer_state> in vrf <vrf_name>"
            },
            "SE_LICENSED_BANDWIDTH_EXCEEDED": {
                "description": "Licensed bandwidth exceeded on SE <se_uuid> (<num_pkts_dropped> packets dropped)"
            },
            "SERVER_AUTOSCALE_OUT_TRIGGERED": {
                "description": "Server Scale-out triggered for external orchestration"
            },
            "SERVER_AUTOSCALE_IN_TRIGGERED": {
                "description": "Server Scale-in triggered for external orchestration"
            },
            "SE_BGP_PEER_DOWN": {
                "description": "BGP peering to <peer_ip> in vrf <vrf_name> is down.<message>"
            },
            "SE_OBJSYNC_PEER_DOWN": {
                "description": "Objsync connections to SE peers <peer_se_uuids> are down"
            },
            "SE_REDIS_CONNECTION_DOWN": {
                "description": "Serviceengine not able to connect to the redis in leader controller"
            },
            "POOL_AUTO_DEPLOYMENT_FAILED": {
                "description": "Pool deployment failed"
            },
            "POOL_AUTO_DEPLOYMENT_SUCCESS": {
                "description": "Pool deployment success with ratio <ratio>"
            },
            "SE_VNIC_UP_EVENT": {
                "description": "VNIC <if_name>/<linux_name>, MAC <mac> is up"
            },
            "POOL_AUTO_DEPLOYMENT_UPDATE": {
                "description": "Pool deployment progress update with ratio <ratio>"
            },
            "GSLB_SITE_OPER_STATUS": {
                "description": "Site status <details>"
            },
            "GSLB_DNS_STATUS": {
                "description": "DNS service status: <details>"
            },
            "GSLB_SITE_EXCEPTION_STATUS": {
                "description": "Site exception <details>"
            },
            "GSLB_GS_STATUS": {
                "description": "GS status <details>"
            },
            "GSLB_SITE_SYNC_STATUS": {
                "description": "Site sync status is <details>"
            },
            "VSGS_STATUS": {
                "description": "VsGs status '<details>"
            },
            "GSLB_SM_STATUS": {
                "description": "GS SM status <details>"
            },
            "GSLB_CRM_STATUS": {
                "description": "GS CRM status <details>"
            },
            "SCHEDULER_ACTION_FAILURE": {
                "description": "Scheduler Action Failed"
            },
            "SCHEDULER_ACTION_FAILED_WITH_ERROR": {
                "description": "Scheduler Action failed with errors."
            },
            "CONTROLLER_SCHEDULER_UNENCRYPTED_CONFIG_EXPORT": {
                "description": "Backup Configuration in unencrypted."
            },
            "REMOTE_BACKUP_FAILURE": {
                "description": "Remote backup failed"
            },
            "GCP_ACCESS_FAIL": {
                "description": "GCP connection setup failed - reason <reason>"
            },
            "GCP_SE_DETECTED": {
                "description": "Detected a GCP Instance SE <hostname> in project <project> zone <zone> network <network> subnet <subnet>"
            },
            "GCP_API_FAIL": {
                "description": "GCP cloud access API failed project <project>, network <network> - reason <reason>"
            },
            "GCP_SUBNET_NOT_FOUND": {
                "description": "Unable to find matching subnet for GCP Instance <hostname> in project <project>, network <network> - reason <reason>"
            },
            "GCP_SUBNET_ATTACH_FAIL": {
                "description": "Unable to attach subnet <subnet> to Service Engine <hostname> in project <project>, network <network> - reason <reason>"
            },
            "GCP_ROUTE_ADD_FAIL": {
                "description": "GCP route add failed IP <addr>, next hop <addr>, virtualservice <vs_name> in project <project>, network <network> - reason <reason>"
            },
            "GCP_ROUTE_DELETE_FAIL": {
                "description": "GCP route delete failed in IP <addr>, next hop <addr> virtualservice <vs_name> project <project>, network <network> - reason <reason>"
            },
            "GCP_CLOUD_ROUTER_UPDATE_FAIL": {
                "description": "GCP cloud router update failed for virtualservice <vs_uuid> FIP % in router <fip>"
            },
            "VIP_DNS_REGISTER_SUCCESS": {
                "description": "VIP <addr> registered to < '>"
            },
            "VIP_DNS_REGISTER_FAILURE": {
                "description": "VIP <addr> register failed for < '>"
            },
            "VIP_DNS_DEREGISTER_SUCCESS": {
                "description": "VIP <addr> de-registered from < '>"
            },
            "VIP_DNS_DEREGISTER_FAILURE": {
                "description": "VIP <addr> de-registered failed for < '>"
            },
            "SYNC_DNS_RECORDS_SUCCESS": {
                "description": "Synchronised virtual service DNS records"
            },
            "SYNC_DNS_RECORDS_FAILURE": {
                "description": "Synchronising virtual service DNS records failed"
            },
            "FLUSH_DNS_RECORDS_SUCCESS": {
                "description": "Flushed virtual service DNS records"
            },
            "FLUSH_DNS_RECORDS_FAILURE": {
                "description": "Flushing virtual service DNS records failed"
            },
            "CC_HOST_SSH_FAILURE": {
                "description": "SSH to cloud host failed"
            },
            "CC_HOST_SSH_SUCCESS": {
                "description": "SSH to cloud host success"
            },
            "AZURE_ACCESS_FAILURE": {
                "description": "Azure connection setup failed - reason <reason>"
            },
            "AZURE_ALB_UPDATE_FAILURE": {
                "description": "Azure ALB update failed. Reason %s' % pb.reason"
            },
            "AZURE_NIC_UPDATE_FAILURE": {
                "description": "Azure NIC update failed. Reason %s' % pb.reason"
            },
            "AZURE_NIC_DELETE_FAILURE": {
                "description": "Azure NIC delete failed."
            },
            "AZURE_IMAGE_UPLOAD_FAILURE": {
                "description": "Azure image upload failed."
            },
            "VS_FAULT": {
                "description": "Virtual Service Fault"
            },
            "SE_SHM_MEM_HIGH": {
                "description": "Shared memory usage over Threshold <threshold> % Current <current_value> %"
            },
            "SE_CONFIG_MEM_USAGE_ABOVE_LIMIT": {
                "description": "Config memory usage reached threshold limit"
            },
            "OCI_ACCESS_FAILURE": {
                "description": "OCI connection setup failed - reason <reason>"
            },
            "TENCENT_ACCESS_FAILURE": {
                "description": "Tencent connection setup failed - reason <reason>"
            },
            "CONTROLLER_CPU_HIGH": {
                "description": "CPU usage over Threshold <threshold> % Current <current_value> %"
            },
            "CONTROLLER_MEM_HIGH": {
                "description": "Memory usage over Threshold <threshold> % Current <current_value> %"
            },
            "CONTROLLER_DISK_HIGH": {
                "description": "Disk usage over Threshold <threshold> % Current <current_value> %"
            },
            "ALBSERVICES_CONNECTION_FAILURE": {
                "description": "Connection to ALBServices failed"
            },
            "ALBSERVICES_CONTROLLER_DEREGISTERED": {
                "description": "Controller Deregistered from ALBServices"
            },
            "CRS_UPDATE": {
                "description": "New CRS data is available on ALBServices."
            },
            "CRS_DEPLOYMENT_SUCCESS": {
                "description": "CRS deployed successfully on controller."
            },
            "CRS_DEPLOYMENT_FAILURE": {
                "description": "Failed to deploy CRS on controller."
            },
            "IP_REPUTATION_DB_SYNC_SUCCESS": {
                "description": "IP Reputation ThreatDb Sync Success"
            },
            "IP_REPUTATION_DB_SYNC_FAILURE": {
                "description": "IP Reputation ThreatDb Sync Failed"
            },
            "APPSIGNATURE_SYNC_SUCCESS": {
                "description": "AppSignature Sync Success"
            },
            "APPSIGNATURE_SYNC_FAILURE": {
                "description": "AppSignature Sync Failed"
            },
            "IPV6_REPUTATION_DB_SYNC_SUCCESS": {
                "description": "IPv6 Reputation ThreatDb Sync Success"
            },
            "IPV6_REPUTATION_DB_SYNC_FAILURE": {
                "description": "IPv6 Reputation ThreatDb Sync Failed"
            },
            "PSM_PROGRAM_FAILURE": {
                "description": "Unable to program WAF PSM group"
            },
            "PSM_MAX_PARAM_EVENT": {
                "description": "Maximum number of parameters reached"
            },
            "PSM_MAX_URI_EVENT": {
                "description": "Maximum number of URIs reached"
            },
            "SEC_MGR_DATA_ERROR_EVENT": {
                "description": "Database transaction failed for SecMgrData."
            },
            "UACACHE_PULSE_CONN_FAILED_EVENT": {
                "description": "UACache connection with PULSE Failed."
            },
            "APP_INSIGHTS_MAX_URI_EVENT": {
                "description": "Maximum number of URIs reached for Application Insights"
            },
            "APP_INSIGHTS_MAX_PARAM_EVENT": {
                "description": "Maximum number of parameters for URI reached for Application Insights"
            },
            "ALBSERVICES_CONTROLLER_REGISTERED": {
                "description": "Controller registered to connected ALBServices."
            },
            "ALBSERVICES_SUPPORT_CASE_CREATED": {
                "description": "Support case - <case_number>: <subject> - created on ALBServices."
            },
            "ALBSERVICES_SUPPORT_CASE_UPDATED": {
                "description": "Support case - <case_number>: <subject> updated on ALBServices."
            },
            "ALBSERVICES_SUPPORT_CASE_FILE_ATTACHMENT_TRIGGERED": {
                "description": "File upload and attachment for file <file_path> to support case <case_id> triggered."
            },
            "ALBSERVICES_SUPPORT_CASE_FILE_ATTACHMENT_SUCCESS": {
                "description": "Successfully uploaded and attached file <file_path> to support case <case_id>."
            },
            "ALBSERVICES_SUPPORT_CASE_FILE_ATTACHMENT_FAILURE": {
                "description": "File upload and attachment for file <file_path> to support case <case_id> failed."
            },
            "ALBSERVICES_FILE_DOWNLOAD_TRIGGERED": {
                "description": "File download for file <name> with type <type> triggered."
            },
            "ALBSERVICES_FILE_DOWNLOAD_SUCCESS": {
                "description": "Successfully downloaded the file <name> to <destination_dir>."
            },
            "ALBSERVICES_FILE_DOWNLOAD_FAILURE": {
                "description": "File download failed <name>."
            },
            "NSXT_ACCESS_FAIL": {
                "description": "NSX-T connection setup failed - reason <reason>"
            },
            "VCENTER_ACCESS_FAIL": {
                "description": "VCenter connection setup failed - reason <reason>"
            },
            "NSXT_IMAGE_UPLOAD_FAILURE": {
                "description": "vCenter SE Image for NSX-T Cloud - Upload Failure - Image version: <image_version>, vCenter: <vc_url>"
            },
            "NSXT_IMAGE_DELETE_FAILURE": {
                "description": "vCenter SE Image for NSX-T Cloud - Delete Failure - Image version: <image_version>, vCenter: <vc_url>"
            },
            "VCENTER_IMAGE_UPLOAD_FAILURE": {
                "description": "vCenter SE Image - Upload Failure - Image version: <image_version>, vCenter: <vc_url>"
            },
            "VCENTER_IMAGE_DELETE_FAILURE": {
                "description": "vCenter SE Image - Delete Failure - Image version: <image_version>, vCenter: <vc_url>"
            },
            "NSXT_INVALID_T1_SEG": {
                "description": "Invalid Tier1(s) Segment(s) in NSX-T cloud"
            },
            "NSXT_STREAMAGENT_CONNECT": {
                "description": "Streaming agent connected for NSX-T cloud"
            },
            "NSXT_STREAMAGENT_DISCONNECT": {
                "description": "Streaming agent disconnected for NSX-T cloud"
            },
            "UPGRADE_CONTROLLER_STARTED": {
                "description": "Avi Vantage controller upgrade started"
            },
            "UPGRADE_SE_GROUP_STARTED": {
                "description": "Avi Vantage se group upgrade started"
            },
            "RESUME_SE_GROUP_STARTED": {
                "description": "Avi Vantage se group resume started"
            },
            "PATCH_CONTROLLER_STARTED": {
                "description": "Avi Vantage controller patch started"
            },
            "PATCH_SE_GROUP_STARTED": {
                "description": "Avi Vantage se group patch started"
            },
            "ROLLBACK_CONTROLLER_STARTED": {
                "description": "Avi Vantage controller rollback started"
            },
            "ROLLBACK_SE_GROUP_STARTED": {
                "description": "Avi Vantage se group rollback started"
            },
            "ROLLBACKPATCH_CONTROLLER_STARTED": {
                "description": "Avi Vantage controller rollback patch started"
            },
            "ROLLBACKPATCH_SE_GROUP_STARTED": {
                "description": "Avi Vantage se group rollback patch started"
            },
            "UPGRADE_CONTROLLER_COMPLETE": {
                "description": "Avi Vantage controller upgrade completed"
            },
            "UPGRADE_SE_GROUP_COMPLETE": {
                "description": "Avi Vantage se group upgrade completed"
            },
            "PATCH_CONTROLLER_COMPLETE": {
                "description": "Avi Vantage controller patch completed"
            },
            "PATCH_SE_GROUP_COMPLETE": {
                "description": "Avi Vantage se group patch completed"
            },
            "ROLLBACK_CONTROLLER_COMPLETE": {
                "description": "Avi Vantage controller rollback completed"
            },
            "ROLLBACK_SE_GROUP_COMPLETE": {
                "description": "Avi Vantage se group rollback completed"
            },
            "ROLLBACKPATCH_CONTROLLER_COMPLETE": {
                "description": "Avi Vantage controller rollback patch completed"
            },
            "ROLLBACKPATCH_SE_GROUP_COMPLETE": {
                "description": "Avi Vantage se group rollback patch completed"
            },
            "UPGRADE_CONTROLLER_ABORTED": {
                "description": "Avi Vantage controller upgrade aborted"
            },
            "PATCH_CONTROLLER_ABORTED": {
                "description": "Avi Vantage controller patch aborted"
            },
            "UPGRADE_SE_GROUP_SUSPENDED": {
                "description": "Avi Vantage se group upgrade suspended"
            },
            "PATCH_SE_GROUP_SUSPENDED": {
                "description": "Avi Vantage se group patch suspended"
            },
            "ROLLBACK_SE_GROUP_SUSPENDED": {
                "description": "Avi Vantage se group rollback suspended"
            },
            "ROLLBACKPATCH_SE_GROUP_SUSPENDED": {
                "description": "Avi Vantage se group rollback patch suspended"
            },
            "UPGRADE_REQUEST": {
                "description": "Upgrade/Rollback/Patch requested"
            },
            "LICENSE_TRANSACTION": {
                "description": "License transaction."
            },
            "LICENSE_SE_RECONCILE": {
                "description": "License reconciliation."
            },
            "LICENSE_CONTROLLER_LICENSE_RECONCILE": {
                "description": "License reconciliation."
            },
            "LICENSE_TIER_SWITCH": {
                "description": "License tier switch from <source_tier> to <destination_tier> <status>. <reason>"
            },
            "CENTRAL_LICENSE_SUBSCRIPTION": {
                "description": "Central license subscription."
            },
            "CENTRAL_LICENSE_UNSUBSCRIPTION": {
                "description": "Central license unsubscription."
            },
            "CENTRAL_LICENSE_REFRESH_SUCCESS": {
                "description": "Central license refresh."
            },
            "CENTRAL_LICENSE_REFRESH_FAILURE": {
                "description": "Central license refresh."
            },
            "ROLLBACK_CONTROLLER_ABORTED": {
                "description": "AVI Vantage controller rollback aborted"
            },
            "ROLLBACKPATCH_CONTROLLER_ABORTED": {
                "description": "AVI Vantage controller rollback patch aborted"
            },
            "UPGRADE_DRYRUN_STARTED": {
                "description": "Upgrade dryrun started"
            },
            "UPGRADE_DRYRUN_COMPLETED": {
                "description": "Upgrade dryrun completed"
            },
            "UPGRADE_DRYRUN_ABORTED": {
                "description": "Upgrade dryrun aborted"
            },
            "AUDIT_COMPLIANCE_EVENT": {},
            "LOGAGENT_STREAMING_CONN_EVENT": {
                "description": "Log agent streaming connection event of type <type> for log agent"
            },
            "AVI_FALSE_POSITIVE_DETECTION": {
                "text": "FalsePositiveDetection",
                "description": "False positive detection in VirtualService <vs_name>"
            },
            "CONNECT_TO_METRICSMGR_ERROR": {
                "description": "Cannot connect to metricsmgr"
            },
            "DNS_VS_STATUS": {
                "description": "DNS VS status that is participating in GSLB."
            },
            "CONFIG_VERSION_ACK_STATUS": {
                "description": "Federated object config version ACK status."
            },
            "PRE_CHECK_STARTED": {
                "description": "AVI Vantage pre check started"
            },
            "PRE_CHECK_COMPLETED": {
                "description": "AVI Vantage pre check completed"
            },
            "POSTGRES_REPLICATION_FAILED": {
                "description": "Postgres follower failed to replicate from leader"
            },
            "SAML_METADATA_UPDATE_FAILED": {
                "description": "SAML Metadata Update <name> failed. Reusing the old metadata"
            },
            "RESTORE_CONTROLLER_STARTED": {
                "description": "AVI Vantage controller restore started"
            },
            "RESTORE_CONTROLLER_ABORTED": {
                "description": "AVI Vantage controller restore aborted"
            },
            "RESTORE_CONTROLLER_COMPLETED": {
                "description": "AVI Vantage controller restore completed"
            },
            "LOG_FREQUENT_DISK_CLEANUP": {
                "description": "Log disk usage exceeds limit <size_limit> on controller <controller> from <from_time>. After <cleanup_count> times of cleanup, the disk size is <curr_size>"
            },
            "REQUEST_QUEUE_FULL": {
                "description": "Request [<method> <url>] from <client_ip> client is throttled as apiserver request queue is full."
            },
            "REQUEST_QUEUE_RECOVERING": {
                "description": "Request queue recovering from high load."
            },
            "POSTGRES_MAX_CONN_LIMIT_BREACHED": {
                "description": "Postgres connection usage abnormally high"
            },
            "POSTGRES_CONN_RECOVERY": {
                "description": "Postgres connection usage back to normal levels"
            },
            "REQUEST_RATELIMIT": {
                "description": "Request [<method> <url>] from <client_ip> client is ratelimited."
            },
            "SYSTEM_REPORT_GENERATION_STARTED": {
                "description": "System Report generation started."
            },
            "SYSTEM_REPORT_GENERATION_COMPLETED": {
                "description": "System Report generation completed."
            },
            "SYSTEM_REPORT_GENERATION_FAILED": {
                "description": "System Report generation failed."
            },
            "SYSTEM_REPORT_DELETED": {
                "description": "System Report is deleted."
            },
            "CRL_ENDPOINT_EXPIRED": {
                "description": "CRL <name> is expired."
            },
            "CRL_ENDPOINT_EXPIRING_SOON": {
                "description": "CRL <name> is about to expire within the next 24 hours."
            },
            "CRL_INVALID_ETAG": {
                "description": "Received invalid ETag value (0 or empty) for CRL <name> from Server URL <url>"
            },
            "UBER_EVENT_TEMPLATE": {
                "description": "String <x_str> Float %f FFloat <x_float> Int <x_float> Pcnt % Hex %x Enum <x_int> Idx <x_hex> Nested Msg.Val <x_enum> Msg.Val-List <x_x> Msg-List.Val <v> Msg-List.Msg-List.Val <rv>"
            },
            "UBER_EVENT_ERR_TEMPLATE": {
                "description": "Error Msg <x_rmsg> List <x_x> Msg0.Msg <rm> Msg0.List <rv>"
            },
            "UPGRADE_FILECOPY_COMPLETED": {
                "description": "Event for upgrade file-copy task successful completion."
            },
            "UPGRADE_FILECOPY_FAILED": {
                "description": "Event for upgrade file-copy task completion with failures."
            },
            "SE_PROCESS_CRASHED": {
                "description": "SE <se_name>: Process <process_name> has crashed for <crash_counter> times since SE start-up"
            },
            "CONTROLSCRIPT_EXECUTION_FAILURE": {
                "description": "Control Script execution has failed"
            },
            "SYSTEM_LIMIT_BEYOND_SUPPORTED_CONFIG": {
                "description": "System limits beyond supported config"
            },
            "SYSTEM_LIMIT_WITHIN_SUPPORTED_CONFIG": {
                "description": "System limits within supported config"
            },
            "SYSTEM_CONFIG_SYNC_FAILURE": {
                "description": "System configuration sync failed to service engine"
            },
            "SE_AUTOSCALER_ACTIONS_GENERATED": {
                "description": "SE Autoscaler has generated the actions for the SE group <se_group_uuid>"
            },
            "PASSWORD_ROTATION_COMPLETED": {
                "description": "Password rotation completed for CloudConnectorUser <name>"
            },
            "PASSWORD_ROTATION_FAILED": {
                "description": "Password rotation failed for CloudConnectorUser <name>. Will retry in next cycle."
            },
            "PASSWORD_ROTATION_BOTH_PASSWORDS_INVALID": {
                "description": "CRITICAL: Both old and new passwords are invalid for CloudConnectorUser <name>. Manual intervention required."
            }
        },
        "EventModule": {
            "UNKNOWN": {},
            "VSMGR": {},
            "SEMGR": {},
            "RESMGR": {},
            "VIMGR": {},
            "METRICSMGR": {},
            "CONFIG": {},
            "SE_GENERAL": {},
            "SE_FLOWTABLE": {},
            "SE_HM": {},
            "SE_POOL_PERSISTENCE": {},
            "SE_POOL": {},
            "VSERVER": {},
            "CLOUD_CONNECTOR": {},
            "CLUSTERMGR": {},
            "HSMGR": {},
            "NW_MGR": {},
            "LICENSE_MGR": {},
            "RES_MONITOR": {},
            "STATEDBCACHE": {},
            "STATEDBCACHEHA": {},
            "AUTOSCALE_MGR": {},
            "GLB_MGR": {},
            "SEC_MGR": {},
            "PORTAL_CONNECTOR": {},
            "SE_UPGRADE": {},
            "CONTROLLER_UPGRADE": {},
            "AUDIT_MGR": {},
            "DNS_MGR": {},
            "WEBAPP_IPAM": {},
            "ADAPT_REPL": {
                "text": "Adaptive Replication Module.",
                "description": "Adaptive Replication Module."
            },
            "POSTGRES_MGR": {},
            "LOG_MGR": {
                "text": "Log Manager Module.",
                "description": "Log Manager Module."
            },
            "UPGRADE_FILECOPY": {
                "text": "File-Copy Module.",
                "description": "File-Copy Module."
            },
            "GSLB_LOCAL": {
                "text": "Gslb Local Worker.",
                "description": "Gslb Local Worker."
            },
            "GSLB_REMOTE": {
                "text": "Gslb Remote Worker.",
                "description": "Gslb Remote Worker."
            },
            "WEBAPP": {
                "text": "Module for webapp related events.",
                "description": "Module for webapp related events."
            },
            "PLACEMENT_ORCHESTRATOR": {
                "text": "Module for placement orchestrator related events.",
                "description": "Module for placement orchestrator related events."
            },
            "SYSTEM_HEALTH": {
                "text": "Module for System Health related events.",
                "description": "Module for System Health related events."
            },
            "SE_AUTOSCALER": {
                "text": "Module for SE Autoscaler related events.",
                "description": "Module for SE Autoscaler related events."
            }
        },
        "EventInternalType": {
            "EVENT_INTERNAL": {},
            "EVENT_EXTERNAL": {}
        },
        "EventContext": {
            "EVENT_CONTEXT_SYSTEM": {},
            "EVENT_CONTEXT_CONFIG": {},
            "EVENT_CONTEXT_APP": {},
            "EVENT_CONTEXT_ALL": {}
        },
        "AlertSource": {
            "CONN_LOGS": {
                "text": "Conn Logs"
            },
            "APP_LOGS": {
                "text": "App Logs"
            },
            "EVENT_LOGS": {
                "text": "Event Logs"
            },
            "METRICS": {
                "text": "Metrics"
            }
        },
        "AlertCategory": {
            "REALTIME": {},
            "ROLLINGWINDOW": {},
            "WATERMARK": {}
        },
        "AlertRuleOperator": {
            "OPERATOR_AND": {
                "text": "AND"
            },
            "OPERATOR_OR": {
                "text": "OR"
            }
        },
        "AlertOperation": {
            "ALERT_OP_LT": {},
            "ALERT_OP_LE": {},
            "ALERT_OP_EQ": {},
            "ALERT_OP_NE": {},
            "ALERT_OP_GE": {},
            "ALERT_OP_GT": {}
        },
        "SyslogFormat": {
            "SYSLOG_LEGACY": {},
            "SYSLOG_RFC5424": {},
            "SYSLOG_JSON": {},
            "SYSLOG_RFC5425_ENHANCED": {}
        },
        "AnalyticsProfileRespCodeBlock": {
            "AP_HTTP_RSP_4XX": {
                "text": "4XX"
            },
            "AP_HTTP_RSP_5XX": {
                "text": "5XX"
            }
        },
        "TTAuditMode": {
            "TT_AUDIT_OFF": {
                "text": "Turn Off.",
                "description": "Turn off Time Tracker."
            },
            "TT_AUDIT_ON": {
                "text": "Turn On.",
                "description": "Turn on Time Tracker. Only audit counters are updated, significant logs are suppressed."
            },
            "TT_AUDIT_ON_WITH_SIG": {
                "text": "Turn on with significance.",
                "description": "Turn on Time Tracker, audit counters are updated, significant logs are generated if configured threshold is breached.(supported only for conn_est_audit_fe, conn_est_audit_be, and ingress)."
            }
        },
        "LatencyAuditMode": {
            "LATENCY_AUDIT_OFF": {
                "text": "Deprecated in 22.1.1",
                "description": "Deprecated in 22.1.1"
            },
            "LATENCY_AUDIT_ON": {
                "text": "Deprecated in 22.1.1",
                "description": "Deprecated in 22.1.1"
            },
            "LATENCY_AUDIT_ON_WITH_SIG": {
                "text": "Deprecated in 22.1.1",
                "description": "Deprecated in 22.1.1"
            }
        },
        "LogAction": {
            "LOG_FIELD_REMOVE": {
                "description": "Remove matched field and its value from log."
            },
            "LOG_FIELD_MASKOFF": {
                "description": "Replace matched field's value with X."
            }
        },
        "StringOperation": {
            "BEGINS_WITH": {
                "text": "Begins with",
                "description": "begins with the configured value(s)"
            },
            "DOES_NOT_BEGIN_WITH": {
                "text": "Does not begin with",
                "description": "does not begin with the configured value(s)"
            },
            "CONTAINS": {
                "text": "Contains",
                "description": "contains the configured value(s)"
            },
            "DOES_NOT_CONTAIN": {
                "text": "Does not contain",
                "description": "does not contain the configured value(s)"
            },
            "ENDS_WITH": {
                "text": "Ends with",
                "description": "ends with the configured value(s)"
            },
            "DOES_NOT_END_WITH": {
                "text": "Does not end with",
                "description": "does not end with the configured value(s)"
            },
            "EQUALS": {
                "text": "Equals",
                "description": "equals the configured value(s)"
            },
            "DOES_NOT_EQUAL": {
                "text": "Does not equal",
                "description": "does not equal the configured value(s)"
            },
            "REGEX_MATCH": {
                "text": "Regex pattern matches",
                "description": "regex pattern matches with the configured value(s)"
            },
            "REGEX_DOES_NOT_MATCH": {
                "text": "Regex pattern does not match",
                "description": "regex pattern does not match with the configured value(s)"
            }
        },
        "ClientLogStreamingProtocol": {
            "LOG_STREAMING_PROTOCOL_UDP": {
                "text": "UDP",
                "description": "Stream logs as UDP datagrams."
            },
            "LOG_STREAMING_PROTOCOL_SYSLOG_OVER_UDP": {
                "text": "Syslog-over-UDP",
                "description": "Stream logs using Syslog protocol (RFC5424) with UDP as the transport protocol."
            },
            "LOG_STREAMING_PROTOCOL_TCP": {
                "text": "TCP",
                "description": "Stream logs over a TCP connection."
            },
            "LOG_STREAMING_PROTOCOL_SYSLOG_OVER_TCP": {
                "text": "Syslog-over-TCP",
                "description": "Stream logs using Syslog protocol (RFC5424) with TCP as the transport protocol."
            },
            "LOG_STREAMING_PROTOCOL_RAW_OVER_UDP": {
                "text": "RAW",
                "description": "Stream logs as raw bytes (Protobuf serialized message) over UDP."
            },
            "LOG_STREAMING_PROTOCOL_TLS": {
                "text": "TLS",
                "description": "Stream logs over an encrypted TLS channel on top of a TCP connection."
            },
            "LOG_STREAMING_PROTOCOL_SYSLOG_OVER_TLS": {
                "text": "Syslog-over-TLS",
                "description": "Stream logs Syslog protocol (RFC5424) over an encrypted TLS channel on top of a TCP connection."
            }
        },
        "LogsType": {
            "LOGS_SIGNIFICANT_ONLY": {
                "text": "Only significant logs",
                "description": "Only significant logs"
            },
            "LOGS_UDF_ONLY": {
                "text": "Only filter-matching logs",
                "description": "Only logs that match any client log filters or rules with logging enabled"
            },
            "LOGS_UDF_SIGNIFICANT": {
                "text": "Significant/filter-matching logs",
                "description": "Logs that are either significant or match any client log filters or rules with logging enabled"
            },
            "LOGS_ALL": {
                "text": "All logs",
                "description": "All logs"
            }
        },
        "LogsProcessingType": {
            "LOGS_PROCESSING_NONE": {
                "text": "None",
                "description": "Don't send any logs to the Logs Analytics system. Queries will return 0 logs."
            },
            "LOGS_PROCESSING_SYNC_AND_INDEX_ON_DEMAND": {
                "text": "Sync And Index On Demand",
                "description": "Only upon query, sync logs from SEs to the Logs Analytics system and index them."
            },
            "LOGS_PROCESSING_AUTO_SYNC_AND_INDEX": {
                "text": "Auto Sync And Index",
                "description": "Continuously sync logs from SEs to the Logs Analytics system and index them."
            },
            "LOGS_PROCESSING_AUTO_SYNC_BUT_INDEX_ON_DEMAND": {
                "text": "Auto Sync But Index On Demand",
                "description": "Continuosly sync logs from SEs to the Logs Analytics system but index only when queried."
            }
        },
        "PersistentServerHMDownRecovery": {
            "HM_DOWN_PICK_NEW_SERVER": {
                "description": "If a persistent server has been marked down by a health monitor, pick a new server."
            },
            "HM_DOWN_ABORT_CONNECTION": {
                "description": "If persistent server has been marked down by health monitor, close the connection by sending a reset or an HTTP 5xx and  close/reset the connection as appropriate to the protocol."
            },
            "HM_DOWN_CONTINUE_PERSISTENT_SERVER": {
                "description": "Even if persistent server has been marked down by a health monitor, continue sending persisted users to the server, assuming the server may be overwhelmed and slow to respond to health monitors.  New or non-persisted clients will be sent to alternate servers."
            }
        },
        "PersistenceProfileType": {
            "PERSISTENCE_TYPE_CLIENT_IP_ADDRESS": {
                "description": "Persist based on the client's IP address."
            },
            "PERSISTENCE_TYPE_HTTP_COOKIE": {
                "description": "Persist based on an Avi generated HTTP cookie."
            },
            "PERSISTENCE_TYPE_TLS": {
                "description": "Persist based on TLS tickets or SSL session."
            },
            "PERSISTENCE_TYPE_CUSTOM_HTTP_HEADER": {
                "description": "If the value of a specified HTTP header matches the value in a server's Header field, the request will be sent to that server.  This is a statically defined mapping."
            },
            "PERSISTENCE_TYPE_APP_COOKIE": {
                "description": "Persist using a user or session identifier such as JSessionID included in a server's response.  Avi will persist against a cookie of this name, or one is not found, against an HTTP header of this name."
            },
            "PERSISTENCE_TYPE_GSLB_SITE": {
                "description": "Persist based on site session identififer."
            },
            "PERSISTENCE_TYPE_APP_DIAMETER": {
                "description": "Persist using an AVP pair such as Session-ID."
            }
        },
        "AvpKey": {
            "SESSION_ID": {
                "text": "Session ID",
                "description": "Session ID is used as key for persistence."
            },
            "ORIGIN_HOST": {
                "text": "Origin Host",
                "description": "Client origin host is used as key for persistence."
            },
            "ORIGIN_REALM": {
                "text": "Origin Realm",
                "description": "Client origin realm is used as key for persistence."
            },
            "DESTINATION_HOST": {
                "text": "Destination Host",
                "description": "Server origin host is used as key for persistence."
            },
            "DESTINATION_REALM": {
                "text": "Destination Realm",
                "description": "Server origin realm is used as key for persistence."
            },
            "APPLICATION_ID": {
                "text": "Auth Application ID",
                "description": "Application ID is used as key for persistence."
            }
        },
        "ApplicationProfileType": {
            "APPLICATION_PROFILE_TYPE_L4": {
                "text": "L4",
                "description": "Layer 4 application proxy is enabled for this virtual service."
            },
            "APPLICATION_PROFILE_TYPE_HTTP": {
                "text": "HTTP",
                "description": "HTTP application proxy is enabled for this virtual service."
            },
            "APPLICATION_PROFILE_TYPE_SYSLOG": {
                "text": "SYSLOG",
                "description": "Syslog Layer 4 application proxy is enabled for this virtual service."
            },
            "APPLICATION_PROFILE_TYPE_DNS": {
                "text": "DNS",
                "description": "DNS service is enabled for this virtual service. Based on config, this could be a DNS service for GSLB, IPAM or DNS proxy."
            },
            "APPLICATION_PROFILE_TYPE_SSL": {
                "text": "L4 SSL/TLS",
                "description": "SSL application proxy is enabled for this virtual service. This is used for non-HTTP applications that require SSL termination."
            },
            "APPLICATION_PROFILE_TYPE_SIP": {
                "text": "SIP",
                "description": "SIP application proxy is enabled for this virtual service."
            },
            "APPLICATION_PROFILE_TYPE_DIAMETER": {
                "text": "DIAMETER",
                "description": "Diameter application proxy is enabled for this virtual service ."
            }
        },
        "AppServiceType": {
            "APP_SERVICE_TYPE_L7_HORIZON": {
                "text": "HORIZON",
                "description": "Layer 7 application proxy and Horizon app."
            },
            "APP_SERVICE_TYPE_L4_BLAST": {
                "text": "BLAST",
                "description": "Layer 4 application proxy and protocol blast."
            },
            "APP_SERVICE_TYPE_L4_PCOIP": {
                "text": "PCoIP",
                "description": "Layer 4 application proxy and protocol PCoIP."
            },
            "APP_SERVICE_TYPE_L4_FTP": {
                "text": "FTP",
                "description": "Layer 4 application proxy and protocol FTP."
            },
            "APP_SERVICE_TYPE_HTTP_MCP": {
                "text": "MCP",
                "description": "Model Context Protocol application proxy for streamable-http transport."
            }
        },
        "DnsErrorResponseType": {
            "DNS_ERROR_RESPONSE_ERROR": {
                "text": "Respond to unhandled DNS requests",
                "description": "Respond with a relevant error code e.g. NXDOMAIN response for non-existent records, empty NOERROR response for unsupported queries, etc."
            },
            "DNS_ERROR_RESPONSE_NONE": {
                "text": "Drop unhandled DNS requests",
                "description": "No response for the client query when an error is encountered. Query is passed through to upstream DNS servers if such a passthrough pool is configured, and no local record exists."
            }
        },
        "ProxyProtocolVersion": {
            "PROXY_PROTOCOL_VERSION_1": {
                "text": "ProxyProtocolV1",
                "description": "Proxy Protocol Version 1"
            },
            "PROXY_PROTOCOL_VERSION_2": {
                "text": "ProxyProtocolV2",
                "description": "Proxy Protocol Version 2"
            }
        },
        "SSLClientCertificateMode": {
            "SSL_CLIENT_CERTIFICATE_NONE": {},
            "SSL_CLIENT_CERTIFICATE_REQUEST": {},
            "SSL_CLIENT_CERTIFICATE_REQUIRE": {}
        },
        "XFFUpdate": {
            "REPLACE_XFF_HEADERS": {
                "text": "Replace all incoming X-Forward-For headers with the Avi created header.",
                "description": "Drop all the incoming xff headers and add a new one with client's IP address"
            },
            "APPEND_TO_THE_XFF_HEADER": {
                "text": "All incoming X-Forwarded-For headers will be appended to the Avi created header.",
                "description": "Appends all the incoming XFF headers and client's IP address together"
            },
            "ADD_NEW_XFF_HEADER": {
                "text": "Simply add a new X-Forwarded-For header.",
                "description": "Add new XFF header with client's IP address"
            }
        },
        "HTTPCookieSameSite": {
            "SAMESITE_NONE": {
                "text": "None",
                "description": "HTTP cookie SameSite attribute value None."
            },
            "SAMESITE_LAX": {
                "text": "Lax",
                "description": "HTTP cookie SameSite attribute value Lax."
            },
            "SAMESITE_STRICT": {
                "text": "Strict",
                "description": "HTTP cookie SameSite attribute value Strict."
            }
        },
        "TrueClientIPIndexDirection": {
            "LEFT": {
                "text": "From Left.",
                "description": "From Left."
            },
            "RIGHT": {
                "text": "From Right.",
                "description": "From Right."
            }
        },
        "HTTPPolicyVar": {
            "HTTP_POLICY_VAR_CLIENT_IP": {
                "description": "Variable to get client IP address of the request"
            },
            "HTTP_POLICY_VAR_VS_PORT": {
                "description": "Variable to get virtual service port the request came on"
            },
            "HTTP_POLICY_VAR_VS_IP": {
                "description": "Variable to get IP address of the virtual service the request came for"
            },
            "HTTP_POLICY_VAR_HTTP_HDR": {
                "description": "Variable to get value of the HTTP header in the HTTP request"
            },
            "HTTP_POLICY_VAR_SSL_CLIENT_FINGERPRINT": {
                "description": "SSL Client Certificate fingerprint"
            },
            "HTTP_POLICY_VAR_SSL_CLIENT_SERIAL": {
                "description": "SSL Client Certificate serial number"
            },
            "HTTP_POLICY_VAR_SSL_CLIENT_ISSUER": {
                "description": "SSL Client Certificate Issuer name"
            },
            "HTTP_POLICY_VAR_SSL_CLIENT_SUBJECT": {
                "description": "SSL Client Certificate Subject name"
            },
            "HTTP_POLICY_VAR_SSL_CLIENT_RAW": {
                "description": "The whole SSL client certificate in a PEM format"
            },
            "HTTP_POLICY_VAR_SSL_PROTOCOL": {
                "description": "SSL protocol negotiated for this connection"
            },
            "HTTP_POLICY_VAR_SSL_SERVER_NAME": {
                "description": "Server name requested through SNI"
            },
            "HTTP_POLICY_VAR_USER_NAME": {
                "description": "Username obtained from http request using basic auth"
            },
            "HTTP_POLICY_VAR_SSL_CIPHER": {
                "description": "Cipher suite used for the SSL/TLS connection between the client and virtual service"
            },
            "HTTP_POLICY_VAR_REQUEST_ID": {
                "description": "Variable to get request id of the request"
            },
            "HTTP_POLICY_VAR_SSL_CLIENT_VERSION": {
                "text": "SSL Client Version.",
                "description": "SSL Client Certificate version."
            },
            "HTTP_POLICY_VAR_SSL_CLIENT_SIGALG": {
                "text": "SSL Client Signature Algorithm.",
                "description": "SSL Client Certificate signature algorithm."
            },
            "HTTP_POLICY_VAR_SSL_CLIENT_NOTVALIDBEFORE": {
                "text": "SSL Client Not Valid Before.",
                "description": "SSL Client Certificate not before date."
            },
            "HTTP_POLICY_VAR_SSL_CLIENT_NOTVALIDAFTER": {
                "text": "SSL Client Not Valid After.",
                "description": "SSL Client Certificate not after date."
            },
            "HTTP_POLICY_VAR_SSL_CLIENT_ESCAPED": {
                "text": "SSL Client Certificate Escaped.",
                "description": "The whole SSL Client Certificate in PEM format and percent encoded."
            },
            "HTTP_POLICY_VAR_SOURCE_IP": {
                "text": "Source IP of the client connection.",
                "description": "Variable to get source IP address of the request."
            }
        },
        "MatchCase": {
            "SENSITIVE": {
                "text": "Sensitive",
                "description": "case sensitive match"
            },
            "INSENSITIVE": {
                "text": "Insensitive",
                "description": "case insensitive match"
            }
        },
        "CompressionType": {
            "AUTO_COMPRESSION": {
                "text": "Auto",
                "description": "Compression actions based on SE state and Content properties"
            },
            "CUSTOM_COMPRESSION": {
                "text": "Custom",
                "description": "Compression actions based on custom compression rules"
            }
        },
        "MatchOperation": {
            "IS_IN": {
                "text": "Is in",
                "description": "is in the configured value(s)"
            },
            "IS_NOT_IN": {
                "text": "Is not in",
                "description": "is not in the configured value(s)"
            }
        },
        "CompressionFilterLevel": {
            "AGGRESSIVE_COMPRESSION": {
                "text": "Aggressive",
                "description": "Aggressive compression will use more Avi CPU, but will provide slightly improved compression percentage"
            },
            "NORMAL_COMPRESSION": {
                "text": "Normal",
                "description": "Normal compression level uses some Avi CPU, and provides good compression"
            },
            "NO_COMPRESSION": {
                "text": "None",
                "description": "No compression"
            }
        },
        "IpAddrType": {
            "V4": {},
            "DNS": {},
            "V6": {}
        },
        "AuthorizationActionHttpStatusCode": {
            "HTTP_RESPONSE_STATUS_CODE_401": {
                "text": "401",
                "description": "401 Unauthorized"
            },
            "HTTP_RESPONSE_STATUS_CODE_403": {
                "text": "403",
                "description": "403 Forbidden"
            }
        },
        "JWTClaimType": {
            "JWT_CLAIM_TYPE_BOOL": {
                "text": "Boolean"
            },
            "JWT_CLAIM_TYPE_INT": {
                "text": "Integer"
            },
            "JWT_CLAIM_TYPE_STRING": {
                "text": "String"
            }
        },
        "HdrMatchOperation": {
            "HDR_EXISTS": {
                "text": "Exists",
                "description": "header exists in the HTTP request"
            },
            "HDR_DOES_NOT_EXIST": {
                "text": "Does not exist",
                "description": "header does not exist in the HTTP request"
            },
            "HDR_BEGINS_WITH": {
                "text": "Begins with",
                "description": "header value begins with the configure value(s)"
            },
            "HDR_DOES_NOT_BEGIN_WITH": {
                "text": "Does not begin with",
                "description": "header value does not begins with the configure value(s)"
            },
            "HDR_CONTAINS": {
                "text": "Contains",
                "description": "header value contains configured value(s)"
            },
            "HDR_DOES_NOT_CONTAIN": {
                "text": "Does not contain",
                "description": "header value  does not contains configured value(s)"
            },
            "HDR_ENDS_WITH": {
                "text": "Ends with",
                "description": "header value ends with the configured value(s)"
            },
            "HDR_DOES_NOT_END_WITH": {
                "text": "Does not end with",
                "description": "header value does not ends with the configured value(s)"
            },
            "HDR_EQUALS": {
                "text": "Equals",
                "description": "header value equals the configured value(s)"
            },
            "HDR_DOES_NOT_EQUAL": {
                "text": "Does not equal",
                "description": "header value does not equals the configured value(s)"
            }
        },
        "AuthProfileType": {
            "AUTH_PROFILE_LDAP": {
                "text": "LDAP",
                "description": "Auth server type: LDAP"
            },
            "AUTH_PROFILE_TACACS_PLUS": {
                "text": "TACACS_PLUS",
                "description": "Auth server type: TACACS+"
            },
            "AUTH_PROFILE_SAML": {
                "text": "SAML",
                "description": "Auth server type: SAML"
            },
            "AUTH_PROFILE_JWT": {
                "text": "JWT Validation",
                "description": "Auth server type: JWT"
            },
            "AUTH_PROFILE_OAUTH": {
                "text": "OAuth/OIDC",
                "description": "Auth server type : OAuth/OIDC."
            },
            "AUTH_PROFILE_CLIENT_CERT": {
                "text": "Client Certificate",
                "description": "Auth server type: Client Certificate"
            }
        },
        "OAuthProfileType": {
            "CLIENT_OAUTH": {
                "text": "OAuth Profile for Client Auth",
                "description": "OAuth Profile to be used for client authorization."
            },
            "CONTROLLER_OAUTH": {
                "text": "OAuth profile for Controller Auth.",
                "description": "OAuth Profile to be used for controller authorization."
            }
        },
        "OauthProvider": {
            "OAUTH_VCF": {
                "text": "VCF",
                "description": "Oauth provider is VCF"
            }
        },
        "AuthSamlEntityType": {
            "AUTH_SAML_CLUSTER_VIP": {
                "text": "Use Cluster VIP",
                "description": "Use Cluster VIP"
            },
            "AUTH_SAML_DNS_FQDN": {
                "text": "Use DNS FQDN",
                "description": "Use DNS FQDN"
            },
            "AUTH_SAML_APP_VS": {
                "text": "Use user-provided entity ID",
                "description": "Use user-input entity ID or VS-uuid if not input"
            }
        },
        "AuthTacacsPlusService": {
            "AUTH_TACACS_PLUS_SERVICE_NONE": {
                "text": "None",
                "description": "Auth Tacacs+ service: None"
            },
            "AUTH_TACACS_PLUS_SERVICE_LOGIN": {
                "text": "Login",
                "description": "Auth Tacacs+ service: Login"
            },
            "AUTH_TACACS_PLUS_SERVICE_ENABLE": {
                "text": "Enable",
                "description": "Auth Tacacs+ service: Enable"
            },
            "AUTH_TACACS_PLUS_SERVICE_PPP": {
                "text": "PPP",
                "description": "Auth Tacacs+ service: PPP"
            },
            "AUTH_TACACS_PLUS_SERVICE_ARAP": {
                "text": "ARAP",
                "description": "Auth Tacacs+ service: ARAP"
            },
            "AUTH_TACACS_PLUS_SERVICE_PT": {
                "text": "PT",
                "description": "Auth Tacacs+ service: PT"
            },
            "AUTH_TACACS_PLUS_SERVICE_RCMD": {
                "text": "RCMD",
                "description": "Auth Tacacs+ service: RCMD"
            },
            "AUTH_TACACS_PLUS_SERVICE_X25": {
                "text": "X25",
                "description": "Auth Tacacs+ service: X25"
            },
            "AUTH_TACACS_PLUS_SERVICE_NASI": {
                "text": "NASI",
                "description": "Auth Tacacs+ service: NASI"
            },
            "AUTH_TACACS_PLUS_SERVICE_FWPROXY": {
                "text": "FWDPROXY",
                "description": "Auth Tacacs+ service: FWDPROXY"
            }
        },
        "AuthLdapSecurityMode": {
            "AUTH_LDAP_SECURE_NONE": {
                "text": "None",
                "description": "Auth server security type: None"
            },
            "AUTH_LDAP_SECURE_USE_LDAPS": {
                "text": "LDAPS",
                "description": "Auth server security type: ldaps"
            }
        },
        "AuthLdapSearchScope": {
            "AUTH_LDAP_SCOPE_BASE": {
                "text": "Scope Base",
                "description": "Ldap search at base"
            },
            "AUTH_LDAP_SCOPE_ONE": {
                "text": "Scope One Level",
                "description": "LDAP search one level"
            },
            "AUTH_LDAP_SCOPE_SUBTREE": {
                "text": "Scope Subtree",
                "description": "LDAP search entire subtree"
            }
        },
        "RoleFilterMatchOperation": {
            "ROLE_FILTER_EQUALS": {
                "text": "Equals.",
                "description": "Equals the configured value(s)."
            },
            "ROLE_FILTER_DOES_NOT_EQUAL": {
                "text": "Does not equal.",
                "description": "Does not equal the configured value(s)."
            },
            "ROLE_FILTER_GLOB_MATCH": {
                "text": "Unix styled glob match. Example: prod*, *prod, cluster*prod, etc.",
                "description": "Glob matches with the configured value(s)."
            },
            "ROLE_FILTER_GLOB_DOES_NOT_MATCH": {
                "text": "Unix styled glob un-match. Example: prod*, *prod, cluster*prod, etc.",
                "description": "Does not glob match with the configured value(s)."
            }
        },
        "AuthRuleAssignment": {
            "ASSIGN_ALL": {
                "text": "All",
                "description": "assign all"
            },
            "ASSIGN_FROM_SELECT_LIST": {
                "text": "Selected",
                "description": "assign selected"
            },
            "ASSIGN_MATCHING_GROUP_NAME": {
                "text": "Group name",
                "description": "assign matching group name"
            },
            "ASSIGN_MATCHING_ATTRIBUTE_VALUE": {
                "text": "Attribute value",
                "description": "assign matching attribute value"
            },
            "ASSIGN_MATCHING_GROUP_REGEX": {
                "text": "Group regex",
                "description": "assign matching group value from regex"
            },
            "ASSIGN_MATCHING_ATTRIBUTE_REGEX": {
                "text": "Attribute regex",
                "description": "assign matching attribute value from regex"
            },
            "ASSIGN_CONFIG_CONTAINS_ATTRIBUTE_VALUE": {
                "text": "Contains attribute value",
                "description": "assign matching config values that contains given attribute value"
            }
        },
        "AuthMatchOperation": {
            "AUTH_MATCH_CONTAINS": {
                "text": "Contains",
                "description": "match succeeds if specific attribute or a group list contains"
            },
            "AUTH_MATCH_DOES_NOT_CONTAIN": {
                "text": "Does Not Contain",
                "description": "match succeeds if specific attribute or a group list does not contain"
            },
            "AUTH_MATCH_REGEX": {
                "text": "Regex",
                "description": "match succeeds if regex matches any substring of attribute or group"
            }
        },
        "RemoteFileTransferProtocol": {
            "SCP": {
                "text": "SCP",
                "description": "Remote file transfer protocol SCP"
            },
            "SFTP": {
                "text": "SFTP",
                "description": "Remote file transfer protocol SFTP"
            }
        },
        "BotAction": {
            "BOT_ACTION_BYPASS": {
                "text": "Bypass",
                "description": "Bypass BOT detection."
            },
            "BOT_ACTION_CONTINUE": {
                "text": "Continue",
                "description": "Stop allow-list processing and move on to BOT detection."
            }
        },
        "GeoMappingAttribute": {
            "ATTRIBUTE_IP_PREFIX": {
                "text": "IP/prefix",
                "description": "IP or prefix value"
            },
            "ATTRIBUTE_COUNTRY_CODE": {
                "text": "Country Code",
                "description": "ISO 3166-1 alpha-2 Country Code"
            },
            "ATTRIBUTE_COUNTRY_NAME": {
                "text": "Country Name",
                "description": "Country Name"
            },
            "ATTRIBUTE_CONTINENT_CODE": {
                "text": "Continent Code",
                "description": "Continent Code"
            },
            "ATTRIBUTE_CONTINENT_NAME": {
                "text": "Continent Name",
                "description": "Continent Name"
            },
            "ATTRIBUTE_REGION_NAME": {
                "text": "Region Name",
                "description": "Region Name"
            },
            "ATTRIBUTE_CITY_NAME": {
                "text": "City Name",
                "description": "City Name"
            },
            "ATTRIBUTE_ISP_NAME": {
                "text": "ISP Name",
                "description": "ISP Name"
            },
            "ATTRIBUTE_ORGANIZATION_NAME": {
                "text": "Organization Name",
                "description": "Organization Name"
            },
            "ATTRIBUTE_AS_NUMBER": {
                "text": "AS Number",
                "description": "AS Number"
            },
            "ATTRIBUTE_AS_NAME": {
                "text": "AS Name",
                "description": "AS Name"
            },
            "ATTRIBUTE_LONGITUDE": {
                "text": "Longitude",
                "description": "Longitude"
            },
            "ATTRIBUTE_LATITUDE": {
                "text": "Latitude",
                "description": "Latitude"
            },
            "ATTRIBUTE_CUSTOM_1": {
                "text": "Custom 1",
                "description": "Custom 1"
            },
            "ATTRIBUTE_CUSTOM_2": {
                "text": "Custom 2",
                "description": "Custom 2"
            },
            "ATTRIBUTE_CUSTOM_3": {
                "text": "Custom 3",
                "description": "Custom 3"
            },
            "ATTRIBUTE_CUSTOM_4": {
                "text": "Custom 4",
                "description": "Custom 4"
            },
            "ATTRIBUTE_CUSTOM_5": {
                "text": "Custom 5",
                "description": "Custom 5"
            },
            "ATTRIBUTE_CUSTOM_6": {
                "text": "Custom 6",
                "description": "Custom 6"
            },
            "ATTRIBUTE_CUSTOM_7": {
                "text": "Custom 7",
                "description": "Custom 7"
            },
            "ATTRIBUTE_CUSTOM_8": {
                "text": "Custom 8",
                "description": "Custom 8"
            },
            "ATTRIBUTE_CUSTOM_9": {
                "text": "Custom 9",
                "description": "Custom 9"
            },
            "ATTRIBUTE_USER_DEFINED_MAPPING": {
                "text": "User Defined Mapping",
                "description": "Mapping of specific values of other geo attributes to a user defined group"
            }
        },
        "IPReputationType": {
            "IP_REPUTATION_TYPE_SPAM_SOURCE": {
                "text": "Spam source",
                "description": "IP address known to be a spam source. Spam sources include tunneling spam messages through proxy, anomalous SMTP activities or forum spam activities."
            },
            "IP_REPUTATION_TYPE_WINDOWS_EXPLOITS": {
                "text": "Windows exploit",
                "description": "IP address offering or distributing malware, shell code, rootkits, worms or viruses."
            },
            "IP_REPUTATION_TYPE_WEB_ATTACKS": {
                "text": "Web attacks",
                "description": "IP address known to be source of web attacks, including cross-site scripting, iFrame injection, SQL injection, cross domain injection, or domain password brute force attack."
            },
            "IP_REPUTATION_TYPE_BOTNETS": {
                "text": "Botnet",
                "description": "IP address known to be a bot 'command and control' channel,  or infected machine controlled by a bot master."
            },
            "IP_REPUTATION_TYPE_SCANNERS": {
                "text": "Scanner",
                "description": "IP address known to be a scanner, such as probes, host scan, domain scan and password brute force attack."
            },
            "IP_REPUTATION_TYPE_DOS": {
                "text": "DoS",
                "description": "DoS or DDoS attack, anomalous sync flood or anomalous traffic detection."
            },
            "IP_REPUTATION_TYPE_REPUTATION": {
                "text": "Reputation",
                "description": "IP address known to be infected with malware or identified to contact malware distribution points."
            },
            "IP_REPUTATION_TYPE_PHISHING": {
                "text": "Phishing",
                "description": "IP address hosting phishing sites or other kinds of fraud activities such as Ad Click Fraud or Gaming fraud."
            },
            "IP_REPUTATION_TYPE_PROXY": {
                "text": "Proxy",
                "description": "IP address providing proxy services."
            },
            "IP_REPUTATION_TYPE_NETWORK": {
                "text": "Network",
                "description": "Network infrastructure IP address."
            },
            "IP_REPUTATION_TYPE_CLOUD": {
                "text": "Cloud",
                "description": "IP address originating from a cloud."
            },
            "IP_REPUTATION_TYPE_MOBILE_THREATS": {
                "text": "Mobile threats",
                "description": "IP addresses of malicious and unwanted mobile applications."
            },
            "IP_REPUTATION_TYPE_TOR": {
                "text": "Tor proxy",
                "description": "IP addresses acting as exit nodes for the Tor network."
            },
            "IP_REPUTATION_TYPE_ALL": {
                "text": "All threats",
                "description": "All threats."
            }
        },
        "QueryMatchOperation": {
            "QUERY_MATCH_CONTAINS": {
                "text": "Contains",
                "description": "Contains the configured value(s)."
            },
            "QUERY_MATCH_DOES_NOT_CONTAIN": {
                "text": "Does not contain",
                "description": "Query value does not contain configured value(s)."
            },
            "QUERY_MATCH_EXISTS": {
                "text": "Exists",
                "description": "Query exists in the HTTP request."
            },
            "QUERY_MATCH_DOES_NOT_EXIST": {
                "text": "Does not exist",
                "description": "Query does not exist in the HTTP request."
            },
            "QUERY_MATCH_BEGINS_WITH": {
                "text": "Begins with",
                "description": "Query value begins with the configured value(s)."
            },
            "QUERY_MATCH_DOES_NOT_BEGIN_WITH": {
                "text": "Does not begin with",
                "description": "Query value does not begin with the configured value(s)."
            },
            "QUERY_MATCH_ENDS_WITH": {
                "text": "Ends with",
                "description": "Query value ends with the configured value(s)."
            },
            "QUERY_MATCH_DOES_NOT_END_WITH": {
                "text": "Does not end with",
                "description": "Query value does not end with the configured value(s)."
            },
            "QUERY_MATCH_EQUALS": {
                "text": "Equals",
                "description": "Query value equals the configured value(s)."
            },
            "QUERY_MATCH_DOES_NOT_EQUAL": {
                "text": "Does not equal",
                "description": "Query value does not equal the configured value(s)."
            },
            "QUERY_MATCH_REGEX_MATCH": {
                "text": "Regex pattern matches",
                "description": "Regex pattern matches with the configured value(s)."
            },
            "QUERY_MATCH_REGEX_DOES_NOT_MATCH": {
                "text": "Regex pattern does not match",
                "description": "Regex pattern does not match with the configured value(s)."
            }
        },
        "HTTPProtocol": {
            "HTTP": {
                "description": "HTTP Protocol"
            },
            "HTTPS": {
                "description": "Secure HTTP Protocol"
            }
        },
        "LogStreamingFormatType": {
            "LOG_STREAMING_FORMAT_JSON_FULL": {
                "text": "JSON with all fields.",
                "description": "Each log is converted into a JSON formatted string."
            },
            "LOG_STREAMING_FORMAT_JSON_SELECTED": {
                "text": "JSON with only selected fields.",
                "description": "Only selected fields of each log are included in a JSON formatted string."
            }
        },
        "CloudType": {
            "CLOUD_NONE": {
                "text": "No Orchestrator",
                "description": "No Orchestrator",
                "cloud_type_options": {
                    "allowed_licenses": [
                        "LIC_CORES"
                    ]
                }
            },
            "CLOUD_VCENTER": {
                "text": "VMware vCenter/vSphere ESX",
                "description": "VMware vCenter/vSphere ESX",
                "cloud_type_options": {
                    "allowed_licenses": [
                        "LIC_CORES"
                    ]
                }
            },
            "CLOUD_AWS": {
                "text": "Amazon Web Services",
                "description": "Amazon Web Services",
                "cloud_type_options": {
                    "allowed_licenses": [
                        "LIC_CORES"
                    ]
                }
            },
            "CLOUD_VCA": {
                "text": "vCloud Air",
                "description": "VMware vCloud Air",
                "cloud_type_options": {
                    "allowed_licenses": [
                        "LIC_CORES"
                    ]
                }
            },
            "CLOUD_MESOS": {
                "text": "Mesos",
                "description": "Mesos",
                "cloud_type_options": {
                    "allowed_licenses": [
                        "LIC_CORES"
                    ]
                }
            },
            "CLOUD_LINUXSERVER": {
                "text": "Linux Server",
                "description": "Linux Server",
                "cloud_type_options": {
                    "allowed_licenses": [
                        "LIC_CORES"
                    ]
                }
            },
            "CLOUD_DOCKER_UCP": {
                "text": "Docker Universal Control Plane",
                "description": "Docker Universal Control Plane",
                "cloud_type_options": {
                    "allowed_licenses": [
                        "LIC_CORES"
                    ]
                }
            },
            "CLOUD_RANCHER": {
                "text": "Rancher Cloud",
                "description": "Rancher Cloud",
                "cloud_type_options": {
                    "allowed_licenses": [
                        "LIC_CORES"
                    ]
                }
            },
            "CLOUD_OSHIFT_K8S": {
                "text": "OpenShift/Kubernetes Cloud",
                "description": "OpenShift/Kubernetes Cloud",
                "cloud_type_options": {
                    "allowed_licenses": [
                        "LIC_CORES"
                    ]
                }
            },
            "CLOUD_AZURE": {
                "text": "Azure Cloud",
                "description": "Azure Cloud",
                "cloud_type_options": {
                    "allowed_licenses": [
                        "LIC_CORES",
                        "LIC_METERED_SE_BANDWIDTH"
                    ]
                }
            },
            "CLOUD_GCP": {
                "text": "Google Cloud Platform",
                "description": "Google Cloud Platform",
                "cloud_type_options": {
                    "allowed_licenses": [
                        "LIC_CORES"
                    ]
                }
            },
            "CLOUD_NSXT": {
                "text": "NSX Cloud",
                "description": "NSX Cloud",
                "cloud_type_options": {
                    "allowed_licenses": [
                        "LIC_CORES"
                    ]
                }
            }
        },
        "LicenseType": {
            "LIC_CORES": {
                "text": "Cores",
                "description": "Limit based Cores license type."
            },
            "LIC_METERED_SE_BANDWIDTH": {
                "text": "SE Bandwidth",
                "description": "Usage based SE Bandwidth license type."
            }
        },
        "LicenseTierType": {
            "ENTERPRISE": {
                "text": "Enterprise",
                "description": "VMware Avi Load Balancer Enterprise."
            },
            "BASIC": {
                "text": "Basic",
                "description": "VMware Avi Load Balancer Basic (replacement for NSX LB)."
            },
            "ESSENTIALS": {
                "text": "Essentials",
                "description": "VMware Avi Load Balancer essentials for Tanzu."
            },
            "ENTERPRISE_WITH_CLOUD_SERVICES": {
                "text": "Enterprise with Cloud Services",
                "description": "VMware Avi Load Balancer Enterprise with Cloud Services."
            }
        },
        "NTPAuthAlgorithm": {
            "NTP_AUTH_ALGORITHM_MD5": {
                "text": "MD5",
                "description": "MD5 Message Digest"
            },
            "NTP_AUTH_ALGORITHM_SHA1": {
                "text": "SHA1",
                "description": "SHA1 Message Digest"
            }
        },
        "NsxtTransportZoneType": {
            "OVERLAY": {
                "text": "OverlayTransportzone",
                "description": "Nsxt overlay transport zone type."
            },
            "VLAN": {
                "text": "VlanTransportzone",
                "description": "Nsxt vlan transport zone type."
            }
        },
        "NsxtTier1SegmentConfigMode": {
            "TIER1_SEGMENT_MANUAL": {
                "text": "Tier1SegmentManual",
                "description": "Nsxt admin configures placement network for tier1s"
            },
            "TIER1_SEGMENT_AUTOMATIC": {
                "text": "Tier1SegmentAutomatic",
                "description": "Avi controller creates placement segments for tier1s"
            }
        },
        "GCPNetworkConfigMode": {
            "INBAND_MANAGEMENT": {
                "text": "InbandManagement",
                "description": "Use InBand Management for network configuration"
            },
            "ONE_ARM_MODE": {
                "text": "OneArmMode",
                "description": "Use One Arm Mode for network configuration"
            },
            "TWO_ARM_MODE": {
                "text": "TwoArmMode",
                "description": "Use Two Arm Mode for network configuration"
            }
        },
        "SeCreateMethodContainer": {
            "SE_CREATE_FLEET": {
                "description": "Use Fleet for SE creation/deletion/maintenance"
            },
            "SE_CREATE_SSH": {
                "description": "Use SSH for SE creation/deletion/maintenance"
            },
            "SE_CREATE_POD": {
                "description": "Create Avi SEs as OpenShift/Kubernetes Pods. Just applicable for OpenShift/Kubernetes Cloud"
            }
        },
        "Privilege": {
            "NO_ACCESS": {
                "text": "No Access"
            },
            "READ_ACCESS": {
                "text": "Read Access"
            },
            "WRITE_ACCESS": {
                "text": "Write Access"
            }
        },
        "AwsEncryptionMode": {
            "AWS_ENCRYPTION_MODE_NONE": {
                "text": "None",
                "description": "AWS encryption is disabled."
            },
            "AWS_ENCRYPTION_MODE_SSE_KMS": {
                "text": "KMS",
                "description": "Use AWS KMS for encryption of AMI/EBS and Server Side Encryption with KMS (SSE-KMS) for S3."
            }
        },
        "IpAddrMode": {
            "DHCP": {
                "text": "DHCP"
            },
            "STATIC": {
                "text": "Static"
            },
            "VIP": {
                "text": "VIP"
            },
            "DOCKER_HOST": {
                "text": "Docker Host"
            },
            "MODE_MANUAL": {
                "text": "Manual"
            }
        },
        "InterfaceLabel": {
            "MGMT": {
                "text": "Management Label",
                "description": "Management label for controller interface"
            },
            "SE_SECURE_CHANNEL": {
                "text": "SE Secure Channel Label",
                "description": "SE Secure channel label for controller interface"
            },
            "HSM": {
                "text": "HSM Label",
                "description": "HSM label for controller interface"
            }
        },
        "DnsRecordType": {
            "DNS_RECORD_OTHER": {
                "text": "OTHER",
                "description": "Invalid Record"
            },
            "DNS_RECORD_A": {
                "text": "A",
                "description": "A Record for a host IPv4 address"
            },
            "DNS_RECORD_NS": {
                "text": "NS",
                "description": "NS Record for an authoritative name server"
            },
            "DNS_RECORD_CNAME": {
                "text": "CNAME",
                "description": "CNAME Record for the canonical (real) name of an alias"
            },
            "DNS_RECORD_SOA": {
                "text": "SOA",
                "description": "SOA Record to mark the start of a zone of authority"
            },
            "DNS_RECORD_PTR": {
                "text": "PTR",
                "description": "PTR Record for the domain name pointer"
            },
            "DNS_RECORD_HINFO": {
                "text": "HINFO",
                "description": "HINFO Record for host information"
            },
            "DNS_RECORD_MX": {
                "text": "MX",
                "description": "MX Record for mail exchange"
            },
            "DNS_RECORD_TXT": {
                "text": "TXT",
                "description": "TXT Record for text strings"
            },
            "DNS_RECORD_RP": {
                "text": "RP",
                "description": "RP Record"
            },
            "DNS_RECORD_DNSKEY": {
                "text": "DNSKEY",
                "description": "KEY Record"
            },
            "DNS_RECORD_AAAA": {
                "text": "AAAA",
                "description": "AAAA Record for a host IPv6 address"
            },
            "DNS_RECORD_SRV": {
                "text": "SRV",
                "description": "SRV Record"
            },
            "DNS_RECORD_OPT": {
                "text": "OPT",
                "description": "OPT Record"
            },
            "DNS_RECORD_RRSIG": {
                "text": "RRSIG",
                "description": "RRSIG Record"
            },
            "DNS_RECORD_AXFR": {
                "text": "AXFR",
                "description": "AXFR Record for a request for a transfer of an entire zone"
            },
            "DNS_RECORD_ANY": {
                "text": "ANY",
                "description": "ANY Record"
            }
        },
        "DnsEntryType": {
            "DNS_ENTRY_PASS_THROUGH": {
                "description": "Pass through"
            },
            "DNS_ENTRY_GSLB": {
                "description": "GSLB DNS Entry"
            },
            "DNS_ENTRY_VIRTUALSERVICE": {
                "description": "Virtual Service DNS Entry"
            },
            "DNS_ENTRY_STATIC": {
                "description": "Static DNS Entry"
            },
            "DNS_ENTRY_POLICY": {
                "description": "Response through Policy"
            },
            "DNS_ENTRY_LOCAL": {
                "description": "Local response"
            }
        },
        "Protocol": {
            "PROTOCOL_ICMP": {},
            "PROTOCOL_TCP": {},
            "PROTOCOL_UDP": {},
            "PROTOCOL_SCTP": {}
        },
        "DnsOpcode": {
            "DNS_OPCODE_QUERY": {
                "description": "DNS Query message"
            },
            "DNS_OPCODE_IQUERY": {
                "description": "Inverse DNS Query (now obsolete) message"
            },
            "DNS_OPCODE_STATUS": {
                "description": "DNS Status message"
            },
            "DNS_OPCODE_NOTIFY": {
                "description": "DNS Notify message"
            },
            "DNS_OPCODE_UPDATE": {
                "description": "DNS Update message"
            }
        },
        "DnsRcode": {
            "DNS_RCODE_NOERROR": {
                "text": "NoError",
                "description": "DNS query completed successfully."
            },
            "DNS_RCODE_FORMERR": {
                "text": "FormErr",
                "description": "DNS query has formatting error."
            },
            "DNS_RCODE_SERVFAIL": {
                "text": "ServFail",
                "description": "DNS server failed to process the DNS query."
            },
            "DNS_RCODE_NXDOMAIN": {
                "text": "NXDomain",
                "description": "DNS query failed since the requested domain name does not exist."
            },
            "DNS_RCODE_NOTIMP": {
                "text": "NotImp",
                "description": "DNS query failed since requested functionality in query Opcode is not implemented at the server."
            },
            "DNS_RCODE_REFUSED": {
                "text": "Refused",
                "description": "DNS server refused to answer the query for policy or security reasons."
            },
            "DNS_RCODE_YXDOMAIN": {
                "text": "YXDomain",
                "description": "DNS query failed since the requested domain name ought not to exist, but exist."
            },
            "DNS_RCODE_YXRRSET": {
                "text": "YXRRSet",
                "description": "RRSet that ought not to exist, does exist."
            },
            "DNS_RCODE_NXRRSET": {
                "text": "NXRRSet",
                "description": "RRSet that ought to exist, does not exist."
            },
            "DNS_RCODE_NOTAUTH": {
                "text": "NotAuth",
                "description": "DNS server not authoritative for the zone named in the Zone section."
            },
            "DNS_RCODE_NOTZONE": {
                "text": "NotZone",
                "description": "Name not in the zone."
            }
        },
        "ReplaceStringType": {
            "DATASCRIPT_VAR": {
                "text": "Datascript variable",
                "description": "A variable defined using avi.http.set_reqvar() in the DataScript, whose value will be the search string used in the body."
            },
            "AVI_VAR": {
                "text": "Avi variable",
                "description": "A predefined Avi variable, whose value will be the search string used in the body. eg: http_host, upstream_addr, client_ip, request_id, vs_name, etc."
            },
            "LITERAL_STRING": {
                "text": "Literal String",
                "description": "The literal string to be used as the replacement string in content rewrite."
            },
            "COMBINATION_STRING": {
                "text": "Combination String",
                "description": "Using this type allows configuring a replacement string that can have a combination of literal strings and ${variable names}. The variable names when parsed, will be replaced with the value of that variable. Capture groups can be referred to using the variables ${1}, ${2}, ..., ${n}."
            }
        },
        "SearchStringType": {
            "SEARCH_DATASCRIPT_VAR": {
                "text": "Datascript variable",
                "description": "A variable defined using avi.http.set_reqvar() in the DataScript, whose value will be the search string used in the body."
            },
            "SEARCH_AVI_VAR": {
                "text": "Avi variable",
                "description": "A predefined Avi variable, whose value will be the search string used in the body. eg: http_host, upstream_addr, client_ip, request_id, vs_name, etc."
            },
            "SEARCH_LITERAL_STRING": {
                "text": "Literal String",
                "description": "The literal string to be used as the search string in content rewrite."
            },
            "SEARCH_REGEX": {
                "text": "Regular Expression",
                "description": "A PCRE flavored regular expression to be used as the search string. Can contain regex captures that can be used in the corresponding replacement string."
            }
        },
        "LicenseAddon": {
            "LICENSE_UNKNOWN_ADDON": {
                "text": "Unknown",
                "description": "Unknown Addon."
            },
            "LICENSE_LEGACY_ADDON": {
                "text": "legacy",
                "description": "Legacy addon."
            }
        },
        "LicenseUnits": {
            "UNNOWN_UNIT": {
                "text": "Unknown Unit",
                "description": "Unknown Licensing unit."
            },
            "SERVICE_UNIT": {
                "text": "Service Unit",
                "description": "Resources will be licensed based on Service Units"
            },
            "LEGACY_ADDON_UNIT": {
                "text": "Legacy Addon Unit",
                "description": "Legacy Addons will be licensed with this Licensing Unit."
            }
        },
        "SeFromMarketplace": {
            "MARKETPLACE": {
                "description": "Deploy SE from Marketplace"
            },
            "IMAGE_SE": {
                "text": "Image",
                "description": "Deploy SE from Controller Image"
            }
        },
        "SCFaultType": {
            "DELAY_NOTIF": {
                "text": "Delay notifications from config",
                "description": "Delay notifications from config"
            },
            "DELAY_SE": {
                "text": "Delay updates from SE",
                "description": "Delay updates from SE"
            },
            "DELAY_RM": {
                "text": "Delay updates from ResMgrGo",
                "description": "Delay updates from ResMgrGo"
            }
        },
        "CSRFAction": {
            "VERIFY_CSRF_TOKEN": {
                "text": "Verify CSRF Token",
                "description": "Verify CSRF Token."
            },
            "VERIFY_ORIGIN": {
                "text": "Verify HTTP Origin Header",
                "description": "Verify Origin Header against Host Header or FQDN, Use it for AJAX requests."
            },
            "VERIFY_ORIGIN_AND_CSRF_TOKEN": {
                "text": "Verify HTTP Origin Header or CSRF Token",
                "description": "Verify Origin Header first if not valid then verify CSRF token."
            },
            "BYPASS_CSRF": {
                "text": "Bypass CSRF Protection",
                "description": "Bypass CSRF Protection."
            }
        },
        "SeBenchmarkLayer": {
            "SE_BENCHMARK_LAYER_NONE": {
                "description": "Disable performance benchmarking hooks"
            },
            "SE_BENCHMARK_LAYER_POST_VNIC_RX": {
                "description": "Enable performance benchmarking hook after NIC receive"
            },
            "SE_BENCHMARK_LAYER_POST_FT_LOOKUP": {
                "description": "Enable performance benchmarking hook after flow table lookup"
            },
            "SE_BENCHMARK_LAYER_NSP_LOOKUP": {
                "description": "Enable performance benchmarking hook after network security policy lookup"
            },
            "SE_BENCHMARK_LAYER_PRE_PROXY_PUNT": {
                "description": "Enable performance benchmarking hook before proxy core punt"
            },
            "SE_BENCHMARK_LAYER_POST_PROXY_PUNT": {
                "description": "Enable performance benchmarking hook after proxy core punt"
            },
            "SE_BENCHMARK_LAYER_ETHER_INPUT": {
                "description": "Enable performance benchmarking hook after ether input"
            },
            "SE_BENCHMARK_LAYER_IP_INPUT": {
                "description": "Enable performance benchmarking hook after IP input"
            },
            "SE_BENCHMARK_LAYER_UDP_INPUT": {
                "description": "Enable performance benchmarking hook after UDP input"
            },
            "SE_BENCHMARK_LAYER_POST_L2_PROCESSING": {
                "description": "Enable performance benchmarking hook after L2 processing"
            },
            "SE_BENCHMARK_LAYER_POST_BUILD_KEY_LITE": {
                "description": "Enable performance benchmarking hook after build key lite"
            }
        },
        "SeBenchmarkMode": {
            "SE_BENCHMARK_MODE_DROP": {
                "description": "Enable packet drop"
            },
            "SE_BENCHMARK_MODE_REFLECT": {
                "description": "Enable packet reflect"
            }
        },
        "SeBenchmarkReflectOption": {
            "SE_BENCHMARK_REFLECT_SWAP_L4": {
                "description": "Swap at L2, L3 and L4 headers"
            },
            "SE_BENCHMARK_REFLECT_SWAP_L2": {
                "description": "Swap only L2 headers"
            },
            "SE_BENCHMARK_REFLECT_SWAP_L3": {
                "description": "Swap only L2 and L3 headers"
            }
        },
        "SeBenchmarkRssHash": {
            "SE_BENCHMARK_DISABLE_HASH": {
                "description": "Disable RSS hash. Use RR to select the queues in TX path."
            },
            "SE_BENCHMARK_RTE_SOFT_HASH": {
                "description": "Use RTE soft RSS hash to select the TX queue."
            }
        },
        "OsyncLogLevel": {
            "LOG_LVL_ERROR": {},
            "LOG_LVL_WARNING": {},
            "LOG_LVL_INFO": {},
            "LOG_LVL_DEBUG": {}
        },
        "EtherTypes": {
            "ETH_TYPE_IPV4": {
                "description": "Ether type IPv4"
            },
            "ETH_TYPE_IPV6": {
                "description": "Ether type IPv6"
            }
        },
        "LogicalOperation": {
            "OR": {
                "text": "Logical OR",
                "description": "Logical OR among configured fields"
            },
            "AND": {
                "text": "Logical AND",
                "description": "Logical AND among configured fields"
            }
        },
        "DebugControllerModuleType": {
            "TASK_QUEUE_DEBUG": {},
            "RPC_INFRA_DEBUG": {},
            "JOB_MGR_DEBUG": {},
            "TRANSACTION_DEBUG": {},
            "SE_AGENT_DEBUG": {},
            "SE_AGENT_METRICS_DEBUG": {},
            "VIRTUALSERVICE_DEBUG": {},
            "RES_MGR_DEBUG": {},
            "SE_MGR_DEBUG": {},
            "VI_MGR_DEBUG": {},
            "METRICS_MANAGER_DEBUG": {},
            "METRICS_MGR_DEBUG": {},
            "EVENT_API_DEBUG": {},
            "HS_MGR_DEBUG": {
                "description": "set troubleshooting settings for HealthScore Manager"
            },
            "ALERT_MGR_DEBUG": {
                "description": "set troubleshooting settings for Alert Manager"
            },
            "AUTOSCALE_MGR_DEBUG": {
                "description": "set troubleshooting settings for AutoScale Manager"
            },
            "REDIS_INFRA_DEBUG": {},
            "CLOUD_CONNECTOR_DEBUG": {
                "text": "Cloud connector Go",
                "description": "set troubleshooting settings for Cloud Connector"
            },
            "MESOS_METRICS_DEBUG": {
                "description": "set troubleshooting settings for Mesos Metrics"
            },
            "STATECACHE_MGR_DEBUG": {
                "text": "State Cache Mgr Go",
                "description": "set troubleshooting settings for State Cache Manager"
            },
            "SE_AGENT_CPU_UTIL_DEBUG": {
                "description": "Debug logs related to cpu utilization"
            },
            "SE_AGENT_MEM_UTIL_DEBUG": {
                "description": "Debug logs related to SE memory utilization"
            },
            "SE_RPC_PROXY_DEBUG": {
                "text": "SE RPC Proxy",
                "description": "See all messages flowing through the SE RPC proxy on controller"
            },
            "SE_AGENT_GSLB_DEBUG": {
                "text": "SE Agent GSLB",
                "description": "Debug logs for GSLB se_agent"
            },
            "METRICSAPI_SRV_DEBUG": {
                "text": "Metricsapi Server",
                "description": "Debug logs for Metricsapi_server"
            },
            "SECURITYMGR_DEBUG": {
                "text": "Security Manager",
                "description": "Debug logs for Security Manager"
            },
            "RES_MGR_READ_DEBUG": {
                "text": "Resource Manager (Reads)",
                "description": "Debug logs for reads to Resource Manager"
            },
            "LICENSE_VMWSRVR_DEBUG": {
                "text": "License server",
                "description": "Debug logs for vmware license server."
            },
            "SE_AGENT_RESOLVERDB_DEBUG": {
                "text": "ResolverDB",
                "description": "Debug logs for ResolverDB"
            },
            "LOGMANAGER_DEBUG": {
                "text": "Log Manager",
                "description": "Debug logs for Log Manager"
            },
            "OSYNC_DEBUG": {
                "text": "Object Sync",
                "description": "Debug logs for object sync"
            },
            "EVENTMANAGER_DEBUG": {
                "text": "Event Manager",
                "description": "Debug logs for Event Manager"
            },
            "SHARD_ORCHESTRATOR_DEBUG": {
                "text": "Shard Orchestrator",
                "description": "Debug logs for Shard Orchestrator"
            },
            "RUNNOTIFICATIONS_DEBUG": {
                "text": "Run Notifications",
                "description": "Debug logs for Run Notifications"
            },
            "JOBMANAGER_DEBUG": {
                "text": "Job Manager Go",
                "description": "Debug logs for Job Manager"
            },
            "DNS_MANAGER_DEBUG": {
                "text": "DNS Manager",
                "description": "Debug logs for DNS Manager"
            },
            "SECURE_KEY_EXCHANGE_DEBUG": {
                "text": "Secure Key Exchange",
                "description": "Debug logs for Secure Key Exchange"
            },
            "SE_DATASTORE_DEBUG": {
                "text": "SE Datastore",
                "description": "Debug logs for SE Datastore"
            },
            "FEDERATED_DATASTORE_DEBUG": {
                "text": "Federated Datastore",
                "description": "Debug logs for Federated Datastore"
            },
            "SHARD_SERVER_DEBUG": {
                "text": "Shard Server",
                "description": "Debug logs for Shard Server"
            },
            "SE_GRPC_AUTH_SERVER_DEBUG": {
                "text": "GRPC Auth Server",
                "description": "Debug logs for GRPC Auth Server"
            },
            "SE_CONTROLLER_INTF_DEBUG": {
                "text": "SE Controller Interface",
                "description": "Debug logs for SE Controller Interface"
            },
            "CLUSTER_SERVICES_WATCHER_DEBUG": {
                "text": "Cluster Services Watcher",
                "description": "Debug logs for Cluster Services Watcher"
            },
            "SEUPGRADE_PARENT_DEBUG": {
                "text": "SE Upgrade Parent",
                "description": "Debug logs for SE Upgrade Parent"
            },
            "PORTALCONNECTOR_DEBUG": {
                "text": "Portal Connector",
                "description": "Debug logs for Portal Connector"
            },
            "PROCESS_EVENT_FORWARDER_DEBUG": {
                "text": "Process Event Forwarder",
                "description": "Debug logs for Process Event Forwarder"
            },
            "DIFF_COMPACTOR_DEBUG": {
                "text": "Diff Compactor",
                "description": "Debug logs for Diff Compactor"
            },
            "RES_MGR_GO_DEBUG": {
                "text": "Resource Manager Go",
                "description": "Debug logs for Golang Resource Manager"
            },
            "PLACEMENT_ORCHESTRATOR_DEBUG": {
                "text": "Placement Orchestrator",
                "description": "Debug logs for Placement Orchestrator"
            },
            "LICENSE_MGR_DEBUG": {
                "text": "License Manager",
                "description": "Debug logs for License Manager"
            },
            "OCTAVIUS_DEBUG": {
                "text": "Octavius",
                "description": "Debug logs for Octavius"
            },
            "GSLB_LOCAL_WORKER_DEBUG": {
                "text": "GSLB Local Worker",
                "description": "Debug logs for GSLB Local Worker"
            },
            "GSLB_REMOTE_WORKER_DEBUG": {
                "text": "GSLB Remote Worker",
                "description": "Debug logs for GSLB Remote Worker"
            },
            "IMAGE_MANAGER_DEBUG": {
                "text": "Image Manager",
                "description": "Debug logs for Image Manager"
            },
            "STATEDIFF_SERVICE_DEBUG": {
                "text": "StateDiff Service",
                "description": "Debug logs for StateDiff Service"
            },
            "REMOTE_TASK_MANAGER_DEBUG": {
                "text": "Remote Task Manager",
                "description": "Debug logs for Remote Task Manager"
            },
            "REMOTE_TASK_MANAGER_CLIENT_DEBUG": {
                "text": "Remote Task Manager Client",
                "description": "Debug logs for Remote Task Manager Client"
            },
            "AVISCP_SERVER_DEBUG": {
                "text": "AVISCP Server",
                "description": "Debug logs for AVISCP Server"
            },
            "UPGRADE_PORTAL_DEBUG": {
                "text": "Upgrade Portal",
                "description": "Debug logs for Upgrade Portal"
            },
            "AUTHSERVER_DEBUG": {
                "text": "Auth Server",
                "description": "Debug logs for Auth Server"
            },
            "APISERVER_DEBUG": {
                "text": "API Server",
                "description": "Debug logs for API Server"
            },
            "GSLBPORTAL_DEBUG": {
                "text": "GSLB Portal",
                "description": "Debug logs for GSLB Portal"
            },
            "ANALYTICS_ENGINE_LOGRECEIVER_DEBUG": {
                "text": "Analytics Engine Log Receiver",
                "description": "Debug logs for Analytics Engine Log Receiver"
            },
            "CLUSTIFY_DEBUG": {
                "text": "Clustify",
                "description": "Debug logs for Clustify"
            },
            "IPGEOLOCATIONSERVER_DEBUG": {
                "text": "IP Geolocation Server",
                "description": "Debug logs for IP Geolocation Server"
            },
            "SYSTEM_HEALTH_AGENT_DEBUG": {
                "text": "System Health Agent",
                "description": "Debug logs for System Health Agent"
            },
            "SYSTEM_HEALTH_SERVICE_DEBUG": {
                "text": "System Health Service",
                "description": "Debug logs for System Health Service"
            },
            "TECH_SUPPORT_HANDLER_DEBUG": {
                "text": "Tech Support Handler",
                "description": "Debug logs for Tech Support Handler"
            },
            "SE_AUTOSCALER_DEBUG": {
                "text": "SE Autoscaler",
                "description": "Debug logs for SE Autoscaler"
            },
            "REPORTING_SERVER_DEBUG": {
                "text": "Reporting Server",
                "description": "Debug logs for Reporting Server"
            }
        },
        "TraceLevel": {
            "TRACE_LEVEL_DISABLED": {},
            "TRACE_LEVEL_ERROR": {},
            "TRACE_LEVEL_DEBUG": {},
            "TRACE_LEVEL_DEBUG_DETAIL": {}
        },
        "LogLevel": {
            "LOG_LEVEL_DISABLED": {},
            "LOG_LEVEL_INFO": {},
            "LOG_LEVEL_WARNING": {},
            "LOG_LEVEL_ERROR": {},
            "LOG_LEVEL_DEBUG": {}
        },
        "IPTypes": {
            "IP_TYPE_TCP": {
                "description": "IP type TCP"
            }
        },
        "DebugSeDataplaneFlags": {
            "DEBUG_DISPATCHER_FLOW": {
                "text": "Dispatcher flow debug logs",
                "description": "Dispatcher flow debug logs"
            },
            "DEBUG_DISPATCHER_FLOW_DETAIL": {
                "text": "Dispatcher flow detailed debug logs",
                "description": "Dispatcher flow detailed debug logs"
            },
            "DEBUG_DISPATCHER_FLOW_ALL": {
                "text": "Both dispatcher flow debug logs",
                "description": "Both dispatcher flow debug logs"
            },
            "DEBUG_CONFIG": {
                "text": "Configuration debug logs",
                "description": "Configuration debug logs"
            },
            "DEBUG_IP": {
                "text": "IP layer debug logs",
                "description": "IP layer debug logs"
            },
            "DEBUG_IP_PKT_IN": {
                "text": "Debug log for each packet received at TP layer",
                "description": "Debug log for each packet received at TP layer"
            },
            "DEBUG_IP_PKT_OUT": {
                "text": "Debug log for each packet sent at TP layer",
                "description": "Debug log for each packet sent at TP layer"
            },
            "DEBUG_ARP": {
                "text": "ARP layer debug logs",
                "description": "Arp layer debug logs"
            },
            "DEBUG_ARP_PKT_IN": {
                "text": "Debug logs for each packet received at the ARP layer",
                "description": "Debug logs for each packet received at the ARP layer"
            },
            "DEBUG_ARP_PKT_OUT": {
                "text": "Debug logs for each packet sent at the ARP layer",
                "description": "Debug logs for each packet sent at the ARP layer"
            },
            "DEBUG_ETHERNET": {
                "text": "Ethernet layer debug logs",
                "description": "Ethernet layer debug logs"
            },
            "DEBUG_ETHERNET_PKT_IN": {
                "text": "Debug logs for each packet received at the Ethernet layer",
                "description": "Debug logs for each packet received at the Ethernet layer"
            },
            "DEBUG_ETHERNET_PKT_OUT": {
                "text": "Debug logs for each packet sent at the Ethernet layer",
                "description": "Debug logs for each packet sent at the Ethernet layer"
            },
            "DEBUG_ICMP": {
                "text": "ICMP layer debug logs",
                "description": "ICMP layer debug logs"
            },
            "DEBUG_PCAP_RX": {
                "text": "Packet capture in pcap format for each packet received",
                "description": "Packet capture in pcap format for each packet received"
            },
            "DEBUG_PCAP_TX": {
                "text": "Packet capture in pcap format for each packet sent",
                "description": "Packet capture in pcap format for each packet sent"
            },
            "DEBUG_PCAP_DROP": {
                "text": "Packet capture in pcap format for each packet dropped",
                "description": "Packet capture in pcap format for each packet dropped"
            },
            "DEBUG_PCAP_ALL": {
                "text": "Packet capture in pcap format for all packets",
                "description": "Packet capture in pcap format for all packets"
            },
            "DEBUG_MISC": {
                "text": "Miscellaneous debug logs",
                "description": "Miscellaneous debug logs"
            },
            "DEBUG_CRUD": {
                "text": "SeAgent CRUD transaction logs",
                "description": "SeAgent CRUD transaction logs"
            },
            "DEBUG_POOL": {
                "text": "Pool debug logs",
                "description": "Pool debug logs"
            },
            "DEBUG_PCAP_DOS": {
                "text": "Packet capture in pcap format for each DOS packet",
                "description": "Packet capture in pcap format for each dos packet"
            },
            "DEBUG_PCAP_HM": {
                "text": "Packet capture in pcap format for each health monitor packet",
                "description": "Packet capture in pcap format for each health monitor packet"
            },
            "DEBUG_SE_APP": {
                "text": "Debug logs for higher layer se infrastructure apps",
                "description": "Debug logs for higher layer se infrastructure apps"
            },
            "DEBUG_UDP": {
                "text": "Debug logs for UDP packets at the Ethernet layer",
                "description": "Debug logs for udp packets at the Ethernet layer"
            },
            "DEBUG_SE_VS_HB": {
                "text": "Debug logs for SE heartbeat for virtualservices",
                "description": "Debug logs for se heartbeat for virtualservices"
            },
            "DEBUG_ND": {
                "text": "Neighbour Discovery debug logs",
                "description": "Neighbour Discovery debug logs"
            },
            "DEBUG_ERROR": {
                "text": "Enabled all error logs",
                "description": "Enable all error logs"
            },
            "DEBUG_NONE": {
                "text": "Turn off all debug logs",
                "description": "Turn off all debug logs"
            },
            "DEBUG_ALL": {
                "text": "Enable all debug logs",
                "description": "Enable all debug logs"
            },
            "DEBUG_STRICT": {
                "text": "Strictly ensure delivery of the debug logs",
                "description": "Strictly ensure delivery of the debug logs"
            },
            "DEBUG_FLOW_MIRROR": {
                "text": "Debug logs for Flow Mirror.",
                "description": "Debug logs for Flow Mirror."
            },
            "DEBUG_NAT": {
                "text": "Debug logs for NAT.",
                "description": "Debug logs for Nat."
            },
            "DEBUG_NAT_ERROR": {
                "text": "Error logs at the NAT layer.",
                "description": "Error logs at the Nat layer."
            },
            "DEBUG_NAT_PKT": {
                "text": "Debug logs for each packet received at the NAT layer.",
                "description": "Debug logs for each packet received at the Nat layer."
            },
            "DEBUG_NAT_END2END": {
                "text": "Debug logs for NAT flow creation and deletion.",
                "description": "Debug logs for Nat flow creation and deletion."
            },
            "DEBUG_NAT_ALL": {
                "text": "Enable all NAT logs.",
                "description": "Enable all Nat logs."
            },
            "DEBUG_PCAP_SE_IPC": {
                "text": "Packet capture in pcap format for each IPC packet",
                "description": "Packet capture in pcap format for each IPC packet"
            },
            "DEBUG_PCAP_NAT": {
                "text": "Packet capture in pcapng format for each NAT packet",
                "description": "Packet capture in pcapng format for each NAT packet"
            },
            "DEBUG_PCAP_ROUTING": {
                "text": "Packet capture in pcapng format for each routed packet",
                "description": "Packet capture in pcapng format for each routed packet"
            }
        },
        "DebugVirtualServiceHM": {
            "DEBUG_VS_HM_NONE": {
                "description": "Turn off capture for Health Monitor Packets"
            },
            "DEBUG_VS_HM_ONLY": {
                "description": "Turn on capture for Health Monitor Packets only"
            },
            "DEBUG_VS_HM_INCLUDE": {
                "description": "Turn on capture for Health Monitor Packets as well"
            }
        },
        "AttackType": {
            "LAND": {
                "description": "DoS attack in which the attacker sets the source and destination information of a TCP segment to be the same making a vulnerable machine crash or freeze due to the packet being repeatedly processed by the TCP stack."
            },
            "SMURF": {
                "description": "DDoS attack in which large numbers of ICMP packets with the intended victim's spoofed source IP are broadcast to a computer network using an IP Broadcast address."
            },
            "ICMP_PING_FLOOD": {
                "description": "DoS attack in which the attacker overwhelms the victim ICMP packets."
            },
            "UNKOWN_PROTOCOL": {
                "description": "DoS attack in which the attacker overwhelms the victim's protocol stack from packets with unsupported or unknown protocols."
            },
            "TEARDROP": {
                "description": "DoS attack in which the attacker sends fragmented packets with incorrect offset and/or size leading to overlapping fragments causing vulnerable machines to crash."
            },
            "IP_FRAG_OVERRUN": {
                "description": "DoS attack in which the attacker sends fragments, which after reassembly have data length that exceeds declared IP data length or the maximum datagram length."
            },
            "IP_FRAG_TOOSMALL": {
                "description": "DoS attack in which the attacker sends small fragments with incomplete fields in the first segment, overflowing fields in subsequent segments, thus tricking any filters and letting packets through."
            },
            "IP_FRAG_FULL": {
                "description": "DoS attack in which the attacker sends excessive number of incomplete fragments exhausting victim's protocol buffers."
            },
            "IP_FRAG_INCOMPLETE": {
                "description": "DoS attack in which the attacker sends incomplete fragments leading to incomplete reassembly of the IP datagram."
            },
            "PORT_SCAN": {
                "description": "DoS attack in which the attacker sends connection requests to non listening ports."
            },
            "TCP_NON_SYN_FLOOD_OLD": {
                "description": "flood of non-SYN pkts (deprecated)"
            },
            "SYN_FLOOD": {
                "description": "DoS attack in which the attacker initiates TCP connections but does not complete them, holding upvictim's resources."
            },
            "BAD_RST_FLOOD": {
                "description": "DoS attack in which the attacker hijacksclient's connection and resets it by spoofing the sequence numbers."
            },
            "MALFORMED_FLOOD": {
                "description": "DoS attack in which the attacker sends packets with bad flags set after TCP connection closehas been initiated."
            },
            "FAKE_SESSION": {
                "description": "DoS attack in which the attacker sends packets with wrong sequence numbers for a valid connection."
            },
            "ZERO_WINDOW_STRESS": {
                "description": "DoS attack in which a zero window is advertised in the last ACK during the 3 way handshake leading tothe victim holding up connections until the window opens up or connections are timedout."
            },
            "SMALL_WINDOW_STRESS": {
                "description": "DoS attack in which the attacker advertises a very small window in the last ACK of the 3 way handshake. Attacker sends a request expecting a big response but the victim's buffers are held up as the receiving window is very small."
            },
            "DOS_HTTP_TIMEOUT": {
                "description": "DoS attack in which the attacker establishes an L7 connection and does one of the following. 1. Does not send a request 2. Send request header at a very slow pace.3. Send request body at a very slow pace."
            },
            "DOS_HTTP_ERROR": {
                "description": "DoS attack in which the attacker sends bad requests some of which include exceeding header size, missing urls and more."
            },
            "DOS_HTTP_ABORT": {
                "description": "DoS attack in which the attacker established an L7 connection and sends Resets during requests."
            },
            "DOS_SSL_ERROR": {
                "description": "DoS attack in which the attacker fails to establish and SSH session due to bad ciphers, versions not supported, etc."
            },
            "DOS_APP_ERROR": {
                "description": "DoS attack in which the attacker requests URLs that are known to beget slow or timedout responses from the victim."
            },
            "DOS_REQ_IP_RL_DROP": {
                "description": "Requests dropped due to source IP rate limit"
            },
            "DOS_REQ_URI_RL_DROP": {
                "description": "Requests dropped due to URL rate limit"
            },
            "DOS_REQ_URI_SCAN_BAD_RL_DROP": {
                "description": "Requests dropped due to bad URL rate limit"
            },
            "DOS_REQ_URI_SCAN_UNKNOWN_RL_DROP": {
                "description": "Requests dropped due to unknown URL rate limit"
            },
            "DOS_REQ_IP_URI_RL_DROP": {
                "description": "Requests dropped due to source IP & URL rate limit"
            },
            "DOS_CONN_IP_RL_DROP": {
                "description": "Connections dropped due to source IP rate limit"
            },
            "DOS_SLOW_URL": {
                "description": "Server response time for a url is high"
            },
            "TCP_NON_SYN_FLOOD": {
                "description": "DoS attack in which the attacker sends non SYN packets before establishing or after closing connections."
            },
            "DOS_REQ_CIP_SCAN_BAD_RL_DROP": {
                "description": "Requests dropped due to bad client ip rate limit"
            },
            "DOS_REQ_CIP_SCAN_UNKNOWN_RL_DROP": {
                "description": "Requests dropped due to unknown client ip rate limit"
            },
            "DOS_REQ_IP_RL_DROP_BAD": {
                "description": "Requests dropped due to bad source IP rate limit"
            },
            "DOS_REQ_URI_RL_DROP_BAD": {
                "description": "Requests dropped due to bad URL rate limit"
            },
            "DOS_REQ_IP_URI_RL_DROP_BAD": {
                "description": "Requests dropped due to bad source IP & URL rate limit"
            },
            "POLICY_DROPS": {
                "description": "All drops due to policies. Any connection or request dropped due to L4 security policy, VS connection limit or rules or rate limits are counted towards policy drops. "
            },
            "DOS_CONN_RL_DROP": {
                "description": "Requests dropped due to connection rate limit across client IPs."
            },
            "DOS_REQ_RL_DROP": {
                "description": "Requests dropped due to request rate limit across client IPs."
            },
            "DOS_REQ_HDR_RL_DROP": {
                "description": "Requests dropped due to header rate limit"
            },
            "DOS_REQ_CUSTOM_RL_DROP": {
                "description": "Requests dropped due to custom rate limit"
            },
            "DNS_ATTACK_REFLECTION": {
                "text": "DNS Reflection",
                "description": "Unsolicited DNS response received by the DNS virtual service"
            },
            "DNS_ATTACK_AMPLIFICATION_EGRESS": {
                "text": "DNS Amplification Egress",
                "description": "Incoming queries that may make the VS a vehicle for amplification egress attack"
            },
            "TCP_SLOW_AND_LOW": {
                "text": "Slow and low TCP attack",
                "description": "Extremely slow client traffic drain rate"
            },
            "DNS_ATTACK_NXDOMAIN": {
                "text": "DNS NxDomain",
                "description": "Incoming queries that get NxDomain responses"
            }
        },
        "DnsTransportProtocol": {
            "DNS_OVER_UDP": {
                "description": "DNS over UDP"
            },
            "DNS_OVER_TCP": {
                "description": "DNS over TCP"
            }
        },
        "DnsRuleRLActionType": {
            "DNS_RL_ACTION_NONE": {
                "text": "Report Only",
                "description": "No action for rate limiting."
            },
            "DNS_RL_ACTION_DROP_REQ": {
                "text": "Drop",
                "description": "Drop rate limited requests."
            }
        },
        "DnsMessageSection": {
            "DNS_MESSAGE_SECTION_QUESTION": {
                "text": "Question section",
                "description": "Question section"
            },
            "DNS_MESSAGE_SECTION_ANSWER": {
                "text": "Answer section",
                "description": "Answer section"
            },
            "DNS_MESSAGE_SECTION_AUTHORITY": {
                "text": "Authority section",
                "description": "Authority section"
            },
            "DNS_MESSAGE_SECTION_ADDITIONAL": {
                "text": "Additional section",
                "description": "Additional section"
            }
        },
        "ErrorPageFormat": {
            "ERROR_PAGE_FORMAT_HTML": {
                "text": "HTML",
                "description": "Format of an error page body is HTML"
            },
            "ERROR_PAGE_FORMAT_JSON": {
                "text": "JSON",
                "description": "Format of an error page body is JSON"
            }
        },
        "FileType": {
            "OTHER_FILE_TYPES": {
                "text": "Other",
                "description": "Other file type."
            },
            "IP_REPUTATION": {
                "text": "IP Reputation IPv4",
                "description": "IP reputation IPv4."
            },
            "GEO_DB": {
                "text": "Geo DB",
                "description": "Geo database."
            },
            "TECH_SUPPORT": {
                "text": "Tech Support",
                "description": "Tech support."
            },
            "HSMPACKAGES": {
                "text": "HSM",
                "description": "Hardware Security Module package."
            },
            "IPAMDNSSCRIPTS": {
                "text": "IPAM DNS",
                "description": "IPAM DNS script."
            },
            "CONTROLLER_IMAGE": {
                "text": "Controller Image",
                "description": "Controller image."
            },
            "CRL_DATA": {
                "text": "CRL",
                "description": "Certificate Revocation List."
            },
            "IP_REPUTATION_IPV6": {
                "text": "IP Reputation IPv6",
                "description": "IP reputation IPv6."
            },
            "GSLB_GEO_DB": {
                "text": "GSLB Geo DB",
                "description": "GSLB Geo DB files."
            },
            "CSRF_JS": {
                "text": "CSRF JS",
                "description": "CSRF JS."
            }
        },
        "GslbGeoDbFileFormat": {
            "GSLB_GEODB_FILE_FORMAT_AVI": {
                "description": "The file format is AVI format and a gzip(.gz) package. This file has v4 entries and will be used in GeoDb lookup."
            },
            "GSLB_GEODB_FILE_FORMAT_MAXMIND_CITY": {
                "description": "The file is in Maxmind city format and a zip(.zip) package. When the file is uploaded with this option, only the v4 entries will be used in the GeoDb lookup."
            },
            "GSLB_GEODB_FILE_FORMAT_MAXMIND_CITY_V6": {
                "description": "The file is in Maxmind city format and a zip(.zip) package. When the file is uploaded with this option, only the v6 entries will be used in the GeoDb lookup."
            },
            "GSLB_GEODB_FILE_FORMAT_MAXMIND_CITY_V4_AND_V6": {
                "description": "The file is in Maxmind city format and a zip(.zip) package. When the file is uploaded with this option, both the v4 and v6 entries will be used in the GeoDb lookup."
            },
            "GSLB_GEODB_FILE_FORMAT_AVI_V6": {
                "description": "The file format is AVI format and a gzip(.gz) package. This file has v6 entries and will be used in GeoDb lookup."
            },
            "GSLB_GEODB_FILE_FORMAT_AVI_V4_AND_V6": {
                "description": "The file format is AVI format and a gzip(.gz) package. This file has both v4 and v6 entries that will be used in GeoDb lookup."
            }
        },
        "GCPVIPAllocationMode": {
            "ROUTES": {
                "text": "Routes",
                "description": "Configure Google Cloud VPC Routes for VIP."
            },
            "ILB": {
                "text": "ILB",
                "description": "Configure Google Cloud Internal LoadBalancer for VIP."
            }
        },
        "GeoDBFileVendor": {
            "VENDOR_USER_DEFINED": {
                "text": "User-defined",
                "description": "The GeoDB file is in a user-defined format."
            },
            "VENDOR_AVI_DEFINED": {
                "text": "Avi-defined",
                "description": "The GeoDB file is in an Avi-defined format."
            }
        },
        "GslbLeaderChangeMode": {
            "GSLB_LC_MODE_MANUAL": {
                "text": "Manual leader change mode.",
                "description": "Manual leader change mode."
            },
            "GSLB_LC_MODE_AUTO": {
                "text": "Automatic leader change mode.",
                "description": "Automatic leader change mode."
            }
        },
        "GslbIpAddrType": {
            "GSLB_IP_PUBLIC": {
                "description": "Public IP Address."
            },
            "GSLB_IP_PRIVATE": {
                "description": "Private IP Address."
            }
        },
        "GslbHealthMonitorProxyType": {
            "GSLB_HEALTH_MONITOR_PROXY_ALL_MEMBERS": {
                "description": "The designated site for health monitor proxy shall monitor all private and public members of a given site. "
            },
            "GSLB_HEALTH_MONITOR_PROXY_PRIVATE_MEMBERS": {
                "description": "The designated site for health monitor proxy shall monitor all private public members of a given site. "
            }
        },
        "GslbGeoLocationSource": {
            "GSLB_LOCATION_SRC_USER_CONFIGURED": {
                "description": "The location information is provided by the user. "
            },
            "GSLB_LOCATION_SRC_INHERIT_FROM_SITE": {
                "description": "The location information is inherited from the site. "
            },
            "GSLB_LOCATION_SRC_FROM_GEODB": {
                "description": "The location information is derived by doing a GeoDB lookup. "
            }
        },
        "GslbDistanceAlgorithm": {
            "GSLB_DISTANCE_AVI_OPTIMISED": {
                "text": "AVI Optimised distance computing algorithm.",
                "description": "AVI optimised distance computing algorithm using Euclidean and Manhattan formulae. Default distance computation algorithm."
            },
            "GSLB_DISTANCE_HAVERSINE": {
                "text": "Haversine distance computing algorithm.",
                "description": "Haversine formula is used for distance computation."
            }
        },
        "GslbServiceHealthMonitorScope": {
            "GSLB_SERVICE_HEALTH_MONITOR_ALL_MEMBERS": {
                "description": "Health monitor probes in dataplane are sent for all the GSLB service members (Avi and third-party)."
            },
            "GSLB_SERVICE_HEALTH_MONITOR_ONLY_NON_AVI_MEMBERS": {
                "description": "Health monitor probes in dataplane are sent for third-party members of the GSLB service."
            }
        },
        "GslbServiceAlgorithm": {
            "GSLB_SERVICE_ALGORITHM_PRIORITY": {
                "text": "Priority-based",
                "description": "Pick the GSLB pool with the highest priority. "
            },
            "GSLB_SERVICE_ALGORITHM_GEO": {
                "text": "Geo location-based",
                "description": "Use the client (LDNS) source IP to choose the GSLB Pool closest by  geographical location. Use this algorithm when the pools are laid   out based on geographical locations, and geodb is configured."
            }
        },
        "GslbServiceRecordType": {
            "GSLB_SERVICE_RECORD_TYPE_A_AAAA_CNAME": {
                "text": "GS record of type A/AAAA/CNAME.",
                "description": "GS record of type A/AAAA/CNAME."
            },
            "GSLB_SERVICE_RECORD_TYPE_SRV": {
                "text": "GS record of type SRV.",
                "description": "GS record of type SRV."
            }
        },
        "GslbServiceDownResponseType": {
            "GSLB_SERVICE_DOWN_RESPONSE_NONE": {
                "text": "No Response",
                "description": "No response to the client query when the GSLB service is down."
            },
            "GSLB_SERVICE_DOWN_RESPONSE_ALL_RECORDS": {
                "text": "Response with all records",
                "description": "Respond with all the records to the client query when the GSLB service is down."
            },
            "GSLB_SERVICE_DOWN_RESPONSE_FALLBACK_IP": {
                "text": "Response with Fallback IP",
                "description": "Respond with the given fallback IP address to the client query when GSLB service is down."
            },
            "GSLB_SERVICE_DOWN_RESPONSE_EMPTY": {
                "text": "Empty Response",
                "description": "Respond with an empty response to the client query when the GSLB service is down."
            },
            "GSLB_SERVICE_DOWN_RESPONSE_CNAME": {
                "text": "CNAME Response",
                "description": "Respond with the given CNAME FQDN to the client query when GSLB service is down."
            }
        },
        "GslbAlgorithm": {
            "GSLB_ALGORITHM_ROUND_ROBIN": {
                "text": "Round Robin",
                "description": "Direct traffic by linearly cycling through the list of available local virtual services and providing these in response to DNS requests."
            },
            "GSLB_ALGORITHM_CONSISTENT_HASH": {
                "text": "Consistent Hash",
                "description": "Use a consistent hash to load balance and persist based on the source ip (LDNS)."
            },
            "GSLB_ALGORITHM_GEO": {
                "text": "Geo",
                "description": "Use the client (LDNS) source IP to choose the VIP closest by geographical location"
            },
            "GSLB_ALGORITHM_TOPOLOGY": {
                "text": "Topology",
                "description": "Direct traffic to the best server based on the topology policy.If no topology policy is configured, GEO algorithm is used."
            },
            "GSLB_ALGORITHM_PREFERENCE_ORDER": {
                "text": "Preference Order",
                "description": "Direct traffic to the first available member in ordered list specified by user."
            }
        },
        "GslbPoolType": {
            "GSLB_POOL_TYPE_GENERIC": {
                "text": "Pool type generic",
                "description": "Default Pool type."
            },
            "GSLB_POOL_TYPE_PRIVATE": {
                "text": "Pool type private",
                "description": "Should contain Private IP's as pool members."
            },
            "GSLB_POOL_TYPE_PUBLIC": {
                "text": "Pool type public",
                "description": "Should contain Public IP's as pool members."
            }
        },
        "SiteMemberType": {
            "GSLB_ACTIVE_MEMBER": {
                "description": "A DNS VS can be configured on an Active member.  Active members will health-status monitor other members.  Leader shall replicate configuration to an active member. "
            },
            "GSLB_PASSIVE_MEMBER": {
                "description": "A DNS VS cannot be configured on a passive member.  It will not initiate any health-status probes to other members. "
            }
        },
        "ReplicationMode": {
            "REPLICATION_MODE_CONTINUOUS": {
                "text": "Continuous Replication Mode.",
                "description": "Continuous Replication Mode."
            },
            "REPLICATION_MODE_ADAPTIVE": {
                "text": "Adaptive Replication Mode.",
                "description": "Adaptive Replication Mode."
            }
        },
        "HSMType": {
            "HSM_TYPE_SAFENET_LUNA": {
                "text": "Thales Luna HSM",
                "description": "HSM using Thales Luna HSM device"
            },
            "HSM_TYPE_AWS_CLOUDHSM": {
                "text": "AWS CloudHSMv2",
                "description": "HSM using AWS Cloud HSM"
            }
        },
        "HealthMonitorType": {
            "HEALTH_MONITOR_PING": {
                "text": "Ping"
            },
            "HEALTH_MONITOR_TCP": {
                "text": "TCP"
            },
            "HEALTH_MONITOR_HTTP": {
                "text": "HTTP"
            },
            "HEALTH_MONITOR_HTTPS": {
                "text": "HTTPS"
            },
            "HEALTH_MONITOR_EXTERNAL": {
                "text": "External"
            },
            "HEALTH_MONITOR_UDP": {
                "text": "UDP"
            },
            "HEALTH_MONITOR_DNS": {
                "text": "DNS"
            },
            "HEALTH_MONITOR_GSLB": {
                "text": "GSLB"
            },
            "HEALTH_MONITOR_SIP": {
                "text": "SIP"
            },
            "HEALTH_MONITOR_RADIUS": {
                "text": "RADIUS"
            },
            "HEALTH_MONITOR_SMTP": {
                "text": "SMTP"
            },
            "HEALTH_MONITOR_SMTPS": {
                "text": "SMTPS"
            },
            "HEALTH_MONITOR_POP3": {
                "text": "POP3"
            },
            "HEALTH_MONITOR_POP3S": {
                "text": "POP3S"
            },
            "HEALTH_MONITOR_IMAP": {
                "text": "IMAP"
            },
            "HEALTH_MONITOR_IMAPS": {
                "text": "IMAPS"
            },
            "HEALTH_MONITOR_FTP": {
                "text": "FTP"
            },
            "HEALTH_MONITOR_FTPS": {
                "text": "FTPS"
            },
            "HEALTH_MONITOR_LDAP": {
                "text": "LDAP"
            },
            "HEALTH_MONITOR_LDAPS": {
                "text": "LDAPS"
            },
            "HEALTH_MONITOR_SCTP": {
                "text": "SCTP",
                "description": "SCTP health monitor."
            },
            "HEALTH_MONITOR_HTTP2": {
                "text": "HTTP2",
                "description": "HTTP2 health monitor."
            },
            "HEALTH_MONITOR_HTTP2S": {
                "text": "HTTP2S",
                "description": "HTTP2S health monitor."
            }
        },
        "HttpResponseCode": {
            "HTTP_ANY": {
                "text": "ANY"
            },
            "HTTP_1XX": {
                "text": "1XX"
            },
            "HTTP_2XX": {
                "text": "2XX"
            },
            "HTTP_3XX": {
                "text": "3XX"
            },
            "HTTP_4XX": {
                "text": "4XX"
            },
            "HTTP_5XX": {
                "text": "5XX"
            }
        },
        "HealthMonitorAuthType": {
            "AUTH_BASIC": {
                "text": "Basic",
                "description": "Basic authentication."
            },
            "AUTH_NTLM": {
                "text": "NTLM",
                "description": "NTLM (New Technology LAN Manager) authentication."
            }
        },
        "LdapScopeType": {
            "LDAP_BASE_MODE": {
                "text": "Base",
                "description": "Ldap base scope search for information only about base_dn specified inside directory."
            },
            "LDAP_ONE_MODE": {
                "text": "One",
                "description": "Ldap one scope search for information at one level below the base_dn specified inside directory."
            },
            "LDAP_SUB_MODE": {
                "text": "Sub",
                "description": "Ldap sub scope search for information at all levels below the base_dn specified inside directory."
            }
        },
        "FtpModeType": {
            "FTP_PASSIVE_MODE": {
                "text": "Passive",
                "description": "FTP passive data transfer mode."
            },
            "FTP_PORT_MODE": {
                "text": "Port",
                "description": "FTP port data transfer mode."
            }
        },
        "SipRequestCode": {
            "SIP_OPTIONS": {
                "text": "OPTIONS"
            }
        },
        "SipMonTransport": {
            "SIP_UDP_PROTO": {
                "text": "UDP",
                "description": "Use UDP as transport protocol for SIP health monitoring."
            },
            "SIP_TCP_PROTO": {
                "text": "TCP",
                "description": "Use TCP as transport protocol for SIP health monitoring."
            }
        },
        "HealthMonitorDNSQueryType": {
            "DNS_QUERY_TYPE": {
                "text": "Query Type"
            },
            "DNS_ANY_TYPE": {
                "text": "Any Type"
            },
            "DNS_ANY_THING": {
                "text": "Anything"
            }
        },
        "HealthMonitorDNSRcode": {
            "RCODE_NO_ERROR": {
                "text": "No Error"
            },
            "RCODE_ANYTHING": {
                "text": "Anything"
            }
        },
        "HTTPSwitchingActionType": {
            "HTTP_SWITCHING_SELECT_POOL": {
                "description": "Select a given pool of servers to serve the request"
            },
            "HTTP_SWITCHING_SELECT_LOCAL": {
                "description": "Send local response to the request"
            },
            "HTTP_SWITCHING_SELECT_POOLGROUP": {
                "description": "Select a pool group to serve the request"
            }
        },
        "HTTPLocalResponseStatusCode": {
            "HTTP_LOCAL_RESPONSE_STATUS_CODE_200": {
                "description": "200 OK"
            },
            "HTTP_LOCAL_RESPONSE_STATUS_CODE_204": {
                "description": "204 No Content"
            },
            "HTTP_LOCAL_RESPONSE_STATUS_CODE_403": {
                "description": "403 Forbidden"
            },
            "HTTP_LOCAL_RESPONSE_STATUS_CODE_404": {
                "description": "404 Not Found"
            },
            "HTTP_LOCAL_RESPONSE_STATUS_CODE_429": {
                "description": "429 Too Many Requests (RFC 6585)"
            },
            "HTTP_LOCAL_RESPONSE_STATUS_CODE_501": {
                "description": "501 Not Implemented"
            }
        },
        "HTTPHdrActionType": {
            "HTTP_ADD_HDR": {
                "text": "Add header",
                "description": "A new header with the new value is added irrespective of the existence of an HTTP header of the given name."
            },
            "HTTP_REMOVE_HDR": {
                "text": "Remove header",
                "description": "All the headers of the given name are removed."
            },
            "HTTP_REPLACE_HDR": {
                "text": "Replace header",
                "description": "A new header with the new value is added if no header of the given name exists, else existing headers with the given name are removed and a new header with the new value is added."
            }
        },
        "HTTPRedirectStatusCode": {
            "HTTP_REDIRECT_STATUS_CODE_301": {
                "description": "301 Moved Permanently"
            },
            "HTTP_REDIRECT_STATUS_CODE_302": {
                "description": "302 Found"
            },
            "HTTP_REDIRECT_STATUS_CODE_307": {
                "description": "307 Moved Temporarily (only for HTTP/1.1)"
            }
        },
        "URIParamType": {
            "URI_PARAM_TYPE_TOKENIZED": {}
        },
        "URITokenType": {
            "URI_TOKEN_TYPE_HOST": {
                "description": "Use host component of the URI as tokens"
            },
            "URI_TOKEN_TYPE_PATH": {
                "description": "Use path component of the URI as tokens"
            },
            "URI_TOKEN_TYPE_STRING": {
                "description": "Use constant string as a token"
            },
            "URI_TOKEN_TYPE_STRING_GROUP": {
                "description": "Use result of StringGroup lookup as a token"
            },
            "URI_TOKEN_TYPE_REGEX": {
                "description": "Use regex captures from URI path as a token."
            },
            "URI_TOKEN_TYPE_REGEX_QUERY": {
                "description": "Use regex captures from URI query as a token."
            }
        },
        "HTTPSecurityActionType": {
            "HTTP_SECURITY_ACTION_CLOSE_CONN": {
                "text": "Close Connection",
                "description": "Close the TCP connection"
            },
            "HTTP_SECURITY_ACTION_SEND_RESPONSE": {
                "text": "Send Response",
                "description": "Send local HTTP response for the request"
            },
            "HTTP_SECURITY_ACTION_ALLOW": {
                "text": "Allow",
                "description": "Allow the HTTP request"
            },
            "HTTP_SECURITY_ACTION_REDIRECT_TO_HTTPS": {
                "text": "Redirect to HTTPS",
                "description": "Redirect the HTTP request to SSL/TLS port"
            },
            "HTTP_SECURITY_ACTION_RATE_LIMIT": {
                "text": "Rate Limit",
                "description": "Rate limit the flow to count per time period"
            },
            "HTTP_SECURITY_ACTION_REQUEST_CHECK_ICAP": {
                "text": "Enable ICAP",
                "description": "Enable ICAP processing for HTTP request"
            }
        },
        "RateLimiterActionType": {
            "RL_ACTION_NONE": {
                "description": "No action for rate limiting."
            },
            "RL_ACTION_DROP_CONN": {
                "description": "Drop rate limited syns."
            },
            "RL_ACTION_RESET_CONN": {
                "description": "Drop rate limited syns and send a reset in case of TCP."
            },
            "RL_ACTION_CLOSE_CONN": {
                "description": "Close connection when requests get rate limited."
            },
            "RL_ACTION_LOCAL_RSP": {
                "description": "Send local response for rate limited requests."
            },
            "RL_ACTION_REDIRECT": {
                "description": "Redirect rate limited requests."
            }
        },
        "ICAPFailAction": {
            "ICAP_FAIL_OPEN": {
                "text": "Fail Open",
                "description": "The transaction will continue despite the failed action."
            },
            "ICAP_FAIL_CLOSED": {
                "text": "Fail Closed",
                "description": "The transaction will be terminated and return an error status code to the client."
            }
        },
        "ImageType": {
            "IMAGE_TYPE_PATCH": {
                "description": "This variable tells the image is of patch type "
            },
            "IMAGE_TYPE_SYSTEM": {
                "description": "This variable tells the image is for whole system example: controller.pkg or controller_docker.tar.gz. "
            },
            "IMAGE_TYPE_MUST_CHECK": {
                "description": "This variable tells the image is for pre upgrade checks example: must_checks.pkg ."
            }
        },
        "Syserr": {
            "SYSERR_SUCCESS": {},
            "SYSERR_FAILURE": {},
            "SYSERR_OUT_OF_MEMORY": {},
            "SYSERR_NO_ENT": {},
            "SYSERR_INVAL": {},
            "SYSERR_ACCESS": {},
            "SYSERR_FAULT": {},
            "SYSERR_IO": {},
            "SYSERR_TIMEOUT": {},
            "SYSERR_NOT_SUPPORTED": {},
            "SYSERR_NOT_READY": {},
            "SYSERR_UPGRADE_IN_PROGRESS": {},
            "SYSERR_WARM_START_IN_PROGRESS": {},
            "SYSERR_TRY_AGAIN": {},
            "SYSERR_NOT_UPGRADING": {},
            "SYSERR_PENDING": {},
            "SYSERR_EVENT_GEN_FAILURE": {},
            "SYSERR_CONFIG_PARAM_MISSING": {},
            "SYSERR_RANGE": {},
            "SYSERR_FAILED": {},
            "SYSERR_BAD_REQUEST": {},
            "SYSERR_TEST1": {},
            "SYSERR_TEST2": {},
            "SYSERR_QUEUE_TRANSPORT_FAILURE": {},
            "SYSERR_QUEUE_RETRY_TASK": {},
            "SYSERR_QUEUE_FULL": {},
            "SYSERR_DATASTORE_TRANSPORT_FAILURE": {},
            "SYSERR_DATASTORE_UNKNOWN_FAILURE": {},
            "SYSERR_DATASTORE_OBJECT_DOES_NOT_EXIST": {},
            "SYSERR_DATASTORE_REFERENCE_DOES_NOT_EXIST": {},
            "SYSERR_DATASTORE_DB_LOCKED": {},
            "SYSERR_DATASTORE_LOCK_FAILURE": {},
            "SYSERR_DATASTORE_TBL_NOT_EXIST": {},
            "SYSERR_DATABASE_OBJECT_DOES_NOT_EXIST": {},
            "SYSERR_DATABASE_OBJECT_MODIFICATION_NOT_ALLOWED_FOR_NON_ADMIN": {},
            "SYSERR_SVC_COMMON_OBJECT_NOT_IN_CACHED_VIEW": {},
            "SYSERR_RPC_CANCELED_BY_CLIENT": {},
            "SYSERR_RPC_TIMED_OUT": {},
            "SYSERR_RPC_SEND_FAILED": {},
            "SYSERR_RPC_CANCELED_BY_TRANSACTION_CLEANUP": {},
            "SYSERR_NO_MULTICAST_RECEIVERS": {},
            "SYSERR_RPC_FAILED": {},
            "SYSERR_RPC_CONNECT_FAILED": {},
            "SYSERR_CONTROLLER_NOT_READY": {},
            "SYSERR_VERSION_MISMATCH": {},
            "SYSERR_ALREADY_REGISTERED": {},
            "SYSERR_SE_GRP_CHANGE_REBOOT": {},
            "SYSERR_INVALID_METHOD": {},
            "SYSERR_DESERIALIZATION": {},
            "SYSERR_SERIALIZATION": {},
            "SYSERR_ENQUEUE": {},
            "SYSERR_DEQUEUE": {},
            "SYSERR_INVALID_READ_LEVEL": {},
            "SYSERR_ADD_HM_PHM_OBJECT_NOT_FOUND": {},
            "SYSERR_CREATE_INVALID_PERSISTENCE_TYPE": {},
            "SYSERR_VS_INVALID_METHOD": {},
            "SYSERR_VS_NOT_PRESENT": {},
            "SYSERR_VS_INVALID_REQUEST": {},
            "SYSERR_VS_NOT_ENOUGH_RESOURCES": {},
            "SYSERR_VS_SE_NOT_AVAILABLE": {},
            "SYSERR_VS_VNIC_FAILURE": {},
            "SYSERR_VS_DELETE_WHILE_STILL_BEING_REFERRED": {},
            "SYSERR_INVALID_HEALTH_MONITOR_TYPE": {},
            "SYSERR_VS_SE_ASSIGNMENT_FAILED": {},
            "SYSERR_VS_INVALID_OBJECT": {},
            "SYSERR_VS_SERVICE_ENGINE_DOWN": {},
            "SYSERR_VS_RPC_FAILURE": {},
            "SYSERR_VS_NOT_BOUND": {},
            "SYSERR_VS_DISABLED": {},
            "SYSERR_VS_INTERNAL_ERROR": {},
            "SYSERR_VS_SCALEOUT_ERROR": {},
            "SYSERR_VS_SCALEIN_ERROR": {},
            "SYSERR_VS_MIGRATE_ERROR": {},
            "SYSERR_VS_MIGRATE_SCALEOUT_ERROR": {},
            "SYSERR_VS_MIGRATE_SCALEIN_ERROR": {},
            "SYSERR_VS_AWAIT_STATIC_SE": {},
            "SYSERR_VS_MIN_SE_NOT_ASSIGNED": {},
            "SYSERR_VS_SE_NOT_AT_CURRENT_VERSION": {},
            "SYSERR_VS_RUNTIME_ABSENT": {},
            "SYSERR_VS_STATEDB_ERR": {},
            "SYSERR_VS_SNI_CHILD_PARENT_SELIST_MISMATCH": {},
            "SYSERR_VS_SNI_PARENT_NOT_FOUND": {},
            "SYSERR_VS_SNI_CHILD_PARENT_SEGROUP_MISMATCH": {},
            "SYSERR_VS_STATS_INDEX_NOT_AVAILABLE": {},
            "SYSERR_VS_UPDATE_FAILED": {},
            "SYSERR_VS_CREATE_FAILED": {},
            "SYSERR_VS_GEO_DATABASES_NOT_LOADED": {},
            "SYSERR_VS_FQDN_LEN_EXCEEDED": {},
            "SYSERR_VS_STATIC_FQDN_LEN_EXCEEDED": {},
            "SYSERR_VS_DNS_TXT_RDATA_LEN_EXCEEDED": {},
            "SYSERR_SE_MGR_VNIC_ALLOC_FAIL": {},
            "SYSERR_SE_MGR_VNIC_NOT_FOUND": {},
            "SYSERR_SE_MGR_UNKNOWN_SE": {},
            "SYSERR_SE_MGR_UNKNOWN_STATE_TRANSITION": {},
            "SYSERR_SE_MGR_SE_OFFLINE_HB_FAILURE": {},
            "SYSERR_SE_UPGRADE_IN_PROGRESS": {},
            "SYSERR_SE_NOT_CONNECTED": {},
            "SYSERR_RM_RES_UNAVAIL": {},
            "SYSERR_RM_RES_UNAVAIL_NOTIFY": {},
            "SYSERR_RM_RES_NOT_INUSE": {},
            "SYSERR_RM_CONSUMER_NOT_FOUND": {},
            "SYSERR_RM_REACHABILITY_FAILED": {},
            "SYSERR_RM_RELEASE_SE_UNAVAIL": {},
            "SYSERR_RM_UNKNOWN_SE_GROUP": {},
            "SYSERR_RM_NO_SE_FOUND": {},
            "SYSERR_RM_PARTIAL_SE_FOUND": {},
            "SYSERR_RM_AWAIT_VM_CREATE": {},
            "SYSERR_RM_AWAIT_VNIC_ADD": {},
            "SYSERR_RM_AWAIT_BOOTUP": {},
            "SYSERR_RM_RESOURCE_NOT_FOUND": {},
            "SYSERR_RM_CANNOT_SPAWN_SE": {},
            "SYSERR_RM_RES_NOT_NEEDED": {},
            "SYSERR_RM_RES_INFRA_DELETED": {},
            "SYSERR_RM_RES_USER_DELETED": {},
            "SYSERR_RM_RES_USER_REBOOTED": {},
            "SYSERR_RM_RES_CRASHED": {},
            "SYSERR_RM_RES_CONN_LOST": {},
            "SYSERR_RM_RES_VIP_REACH_LOST": {},
            "SYSERR_RM_VS_PROCESSING": {},
            "SYSERR_RM_VNIC_IP_FAILURE": {},
            "SYSERR_RM_STATIC_NO_POOL": {},
            "SYSERR_RM_STATIC_POOL_EXHAUSTED": {},
            "SYSERR_RM_VIP_MULT_NETWORKS": {},
            "SYSERR_RM_SRVR_MULT_NETWORKS": {},
            "SYSERR_RM_VIP_NO_NETWORK": {},
            "SYSERR_RM_SRVR_NO_NETWORK": {},
            "SYSERR_RM_MAX_PARALLEL_SE_CREATE": {},
            "SYSERR_RM_MAX_SE_CREATE_ATTEMPTS": {},
            "SYSERR_RM_MULT_SE_CRASH": {},
            "SYSERR_RM_VS_SE_CREATE_IN_PROG": {},
            "SYSERR_RM_VS_SE_BOOTUP_IN_PROG": {},
            "SYSERR_RM_VS_SE_VNIC_ADD_IN_PROG": {},
            "SYSERR_RM_VS_SE_VNIC_IP_IN_PROG": {},
            "SYSERR_RM_NO_SUITABLE_HOST": {},
            "SYSERR_RM_NO_SE_IN_SE_GRP": {},
            "SYSERR_RM_ALL_SE_IN_SE_GRP_DOWN": {},
            "SYSERR_RM_NO_SE_IN_SE_GRP_SRVR_ACC": {},
            "SYSERR_RM_NO_SE_IN_SE_GRP_VIP_ACC": {},
            "SYSERR_RM_ALL_SE_IN_SE_GRP_MAX_VS": {},
            "SYSERR_RM_ALL_SE_IN_SE_GRP_NW_ACC_MAX_VS": {},
            "SYSERR_RM_VIP_SE_NW_ACC": {},
            "SYSERR_RM_VIP_SE_MAX_VS": {},
            "SYSERR_RM_VIP_SE_GRP_MISMATCH": {},
            "SYSERR_RM_VIP_SE_PENDING_OP": {},
            "SYSERR_RM_MULT_MGMT_SUBNET": {},
            "SYSERR_RM_MAX_SE_IN_GRP": {},
            "SYSERR_RM_BOOTUP_FAILURE": {},
            "SYSERR_RM_PENDING_VNIC_OP": {},
            "SYSERR_RM_SE_MGMT_NO_STATIC_IPS_CONFIGURED": {},
            "SYSERR_RM_SE_MGMT_STATIC_IPS_EXHAUSTED": {},
            "SYSERR_RM_NO_MGMT_SUBNET": {},
            "SYSERR_RM_MGMT_DHCP_FAILURE": {},
            "SYSERR_RM_CANNOT_ADD_VNICS": {},
            "SYSERR_RM_CONSUMER_RESOURCES_SATISFIED": {},
            "SYSERR_RM_DATA_DHCP_FAILURE": {},
            "SYSERR_RM_QUERY_HOST_IN_PROGRESS": {},
            "SYSERR_RM_INSUFFICIENT_BUFFER_SE": {},
            "SYSERR_RM_NO_DEFAULT_GW_SE_MGMT_NW": {},
            "SYSERR_RM_PARENT_SE_NW_ACC": {},
            "SYSERR_RM_PARENT_SE_MAX_VS": {},
            "SYSERR_RM_PARENT_SE_GRP_MISMATCH": {},
            "SYSERR_RM_DEF_GW_INCORRECT": {},
            "SYSERR_RM_NETWORK_NOT_FOUND": {},
            "SYSERR_RM_ALL_SE_IN_SE_GRP_USED": {},
            "SYSERR_RM_SE_GRP_PENDING_OP": {},
            "SYSERR_RM_ALL_SE_IN_SE_GRP_DISABLED": {},
            "SYSERR_RM_VS_SE_PING_CHECK_IN_PROG": {},
            "SYSERR_RM_CONSUMER_PENDING_TASK": {},
            "SYSERR_RM_SE_GRP_VIP_NW_ACC": {},
            "SYSERR_RM_SE_GRP_NW_ACC": {},
            "SYSERR_RM_SE_GRP_MAX_VS": {},
            "SYSERR_RM_ALL_SE_IN_SE_GRP_GW_DOWN": {},
            "SYSERR_RM_SE_GW_DOWN": {},
            "SYSERR_RM_SE_DISCONNECTED": {},
            "SYSERR_RM_RES_USER_DISABLED_FORCE": {},
            "SYSERR_RM_VS_SE_ATTACH_IP_IN_PROG": {},
            "SYSERR_RM_LICENSE_EXCEEDED_CANNOT_SPAWN_SE": {},
            "SYSERR_RM_RES_SWTICHOVER_FORCE": {},
            "SYSERR_RM_HA_HOST_UNAVAILABLE": {},
            "SYSERR_RM_RES_USER_DISABLED": {},
            "SYSERR_RM_NO_BGP_PEER_ADVERTISE_VIP": {},
            "SYSERR_RM_NO_BGP_PEER_ADVERTISE_SNAT": {},
            "SYSERR_RM_SRVR_NETWORK_NOT_FOUND": {},
            "SYSERR_RM_VRF_NOT_FOUND": {},
            "SYSERR_RM_BGP_NETWORK_NOT_FOUND": {},
            "SYSERR_RM_VIP_NETWORK_NOT_FOUND": {},
            "SYSERR_RM_READ_MISSING_FILTER": {},
            "SYSERR_RM_CLOUD_NOT_FOUND": {},
            "SYSERR_RM_SEGROUP_NOT_FOUND": {},
            "SYSERR_RM_SE_OFFLINE": {},
            "SYSERR_RM_SE_USED": {},
            "SYSERR_RM_SE_BGP_PEERS_DOWN": {},
            "SYSERR_RM_SE_FLAVOR_LIMIT_REACHED": {},
            "SYSERR_RM_SE_INSUFFICIENT_VNIC_SLOTS": {},
            "SYSERR_RM_SE_SHARED_VIP_INCONSISTENCY": {},
            "SYSERR_VI_MGR_SEVM_VNIC_SUCCESS": {},
            "SYSERR_VI_MGR_SEVM_CREATE_FAIL_NO_HW_INFO": {},
            "SYSERR_VI_MGR_SEVM_CREATE_FAIL_DUPLICATE_NAME": {},
            "SYSERR_VI_MGR_SEVM_CREATE_FAIL_NO_MGMT_NW": {},
            "SYSERR_VI_MGR_SEVM_CREATE_FAIL_NO_CPU": {},
            "SYSERR_VI_MGR_SEVM_CREATE_FAIL_NO_MEM": {},
            "SYSERR_VI_MGR_SEVM_CREATE_FAIL_NO_LEASE": {},
            "SYSERR_VI_MGR_SEVM_CREATE_FAIL_OVF_ERROR": {},
            "SYSERR_VI_MGR_SEVM_CREATE_NO_HOST_VM_NETWORK": {},
            "SYSERR_VI_MGR_SEVM_CREATE_FAIL_NO_PROGRESS": {},
            "SYSERR_VI_MGR_SEVM_CREATE_FAIL_ABORTED": {},
            "SYSERR_VI_MGR_SEVM_CREATE_FAILURE": {},
            "SYSERR_VI_MGR_SEVM_CREATE_FAIL_POWER_ON": {},
            "SYSERR_VI_MGR_SEVM_VNIC_NO_VM": {},
            "SYSERR_VI_MGR_SEVM_VNIC_MAC_ADDR_ERROR": {},
            "SYSERR_VI_MGR_SEVM_VNIC_FAILURE": {},
            "SYSERR_VI_MGR_SEVM_VNIC_NO_PG_PORTS": {},
            "SYSERR_VI_MGR_SEVM_DELETE_FAILURE": {},
            "SYSERR_VI_MGR_SEVM_CREATE_LIMIT_REACHED": {},
            "SYSERR_VI_MGR_SEVM_SET_MGMT_IP_FAILED": {},
            "SYSERR_VI_MGR_SEVM_CREATE_ACCESS_ERROR": {},
            "SYSERR_VI_MGR_SEVM_CREATE_NO_IMAGE": {},
            "SYSERR_VI_MGR_SEVM_VINFRA_UNINITIALIZED": {},
            "SYSERR_VI_MGR_SEVM_CREATE_NO_HOST": {},
            "SYSERR_VI_MGR_SEVM_CREATE_FAIL_NO_MGMT_NW_PORTS": {},
            "SYSERR_VI_MGR_SEVM_INVALID_DATA": {},
            "SYSERR_VI_MGR_SEVM_CREATE_FAIL_MULTIPLE_MGMT_NW": {},
            "SYSERR_VI_MGR_SEVM_VCENTER_CONN_FAIL": {},
            "SYSERR_VI_MGR_SEVM_TIMED_OUT": {},
            "SYSERR_VI_MGR_SEVM_NO_SOURCE_CLONE": {},
            "SYSERR_VI_MGR_SEVM_NO_AVAILABILITY_ZONE": {},
            "SYSERR_VI_MGR_SEVM_FLAVOR_UNAVAIL": {},
            "SYSERR_VI_MGR_SEVM_DELETED": {},
            "SYSERR_VI_MGR_SEVM_VINFRA_FAILURE": {},
            "SYSERR_VI_MGR_SEVM_VNIC_FAILURE_QUESTION": {},
            "SYSERR_VI_MGR_LOGIN_FAIL_NO_VCENTER": {},
            "SYSERR_VI_MGR_LOGIN_FAIL_USER_CREDENTIALS": {},
            "SYSERR_VI_MGR_VCENTER_VERSION_MISMATCH": {},
            "SYSERR_RM_LICENSE_QUOTA_LIMIT_EXCEEDED_CANNOT_SPAWN_SE": {},
            "SYSERR_DB_CACHE_TBL_NOT_FOUND": {},
            "SYSERR_DB_CACHE_OBJ_NOT_FOUND": {},
            "SYSERR_DB_QUERY_QUEUED": {},
            "SYSERR_DB_QUERY_BATCHED": {},
            "SYSERR_DB_UPDATE_FAILED": {},
            "SYSERR_DB_QUERY_FAILED": {},
            "SYSERR_DB_ENQUEUE_FULL": {},
            "SYSERR_OS_AGENT_Q_FULL": {},
            "SYSERR_OS_AGENT_OPENSTACK_UNINITIALIZED": {},
            "SYSERR_OS_AGENT_OPENSTACK_ACCESSERR": {},
            "SYSERR_OS_AGENT_OPENSTACK_RESOURCEERR": {},
            "SYSERR_OS_AGENT_TENANT_ABSENT": {},
            "SYSERR_OS_AGENT_INVALID_DATA": {},
            "SYSERR_CC_SVC_Q_FULL": {},
            "SYSERR_CC_AGENT_UNINITIALIZED": {},
            "SYSERR_CC_AGENT_ACCESSERR": {},
            "SYSERR_CC_AGENT_RESOURCEERR": {},
            "SYSERR_CC_AGENT_TENANT_ACCESSERR": {},
            "SYSERR_CC_AGENT_TENANT_ABSENT": {},
            "SYSERR_CC_SVC_INVALID_DATA": {},
            "SYSERR_CC_OS_AGENT_NEUTRON_HOST_ACCESSERR": {},
            "SYSERR_CC_NO_FLAVOR": {},
            "SYSERR_CC_AGENT_ABSENT": {},
            "SYSERR_CC_AGENT_CONFIG_FAILURE": {},
            "SYSERR_CC_AGENT_DECONFIG_FAILURE": {},
            "SYSERR_CC_AGENT_NON_INFRA_SEVM": {},
            "SYSERR_MESOS_DISCOVERY_DEPLOYMENT_FAIL": {},
            "SYSERR_MESOS_DISCOVERY_TIMEOUT": {},
            "SYSERR_MARATHON_APP_TERMINATED": {},
            "SYSERR_MARATHON_INACCESSIBLE": {},
            "SYSERR_FLEET_API_ERROR": {},
            "SYSERR_MESOS_SSH_CMD_TIMEOUT": {},
            "SYSERR_MESOS_SSH_ABORTED": {},
            "SYSERR_MESOS_SSH_FAILURE": {},
            "SYSERR_MESOS_SSH_NOTFOUND": {},
            "SYSERR_CC_AGENT_VNIC_NO_IPS_AVAILABLE": {},
            "SYSERR_CC_AGENT_VNIC_NO_SUBNETWORK": {},
            "SYSERR_CC_AGENT_VNIC_FAILURE": {},
            "SYSERR_CC_AGENT_SCALE_IN_FAILED": {},
            "SYSERR_CC_AGENT_DS_FAILED": {},
            "SYSERR_CC_AGENT_SCALE_OUT_FAILED": {},
            "SYSERR_CC_TOO_BUSY": {},
            "SYSERR_CC_AGENT_NOT_IMPLEMENTED": {},
            "SYSERR_CC_AGENT_METHOD_NOT_IMPLEMENTED": {},
            "SYSERR_CC_AGENT_GENERIC_FAILURE": {},
            "SYSERR_RUM_TOOMANYSAMPLES": {},
            "SYSERR_METRICS_TOO_MANY_MSG": {},
            "SYSERR_METRICS_TOO_MANY_MSG_ACROSS_ENTITIES": {},
            "SYSERR_ANOMALYZER_NOT_ENOUGH_SAMPLES": {},
            "SYSERR_AUTOSCALE_REASON_INTELLIGENT_AUTOSCALE": {},
            "SYSERR_AUTOSCALE_REASON_CONFIG_UPDATE": {},
            "SYSERR_AUTOSCALE_REASON_POOL_STATE_CHANGE": {},
            "SYSERR_AUTOSCALE_REASON_ALERT": {},
            "SYSERR_AUTOSCALEIN_FAILED_LIMIT_EXCEEDED": {},
            "SYSERR_AUTOSCALEOUT_FAILED_LIMIT_EXCEEDED": {},
            "SYSERR_AUTOSCALE_IGNORED_AS_WITHIN_COOLDOWN": {},
            "SYSERR_AUTOSCALE_ORCHESTRATION_TIMEOUT": {},
            "SYSERR_AUTOSCALE_REASON_NOT_ENOUGH_SERVERS": {},
            "SYSERR_AUTOSCALE_REASON_TOO_MANY_SERVERS": {},
            "SYSERR_AUTOSCALE_REASON_ORCHESTRATION_FAILED": {},
            "SYSERR_AUTOSCALE_REASON_MANUAL": {},
            "SYSERR_AUTOSCALE_POLICY_NOT_FOUND": {},
            "SYSERR_AUTOSCALE_REASON_GARBAGE_COLLECTION": {},
            "SYSERR_AUTOSCALE_SCHEDULED_SCALEIN": {},
            "SYSERR_AUTOSCALE_SCHEDULED_SCALEOUT": {},
            "SYSERR_LICENSE_FIELD_NAME_NOT_SET": {},
            "SYSERR_LICENSE_FILE_NOT_FOUND": {},
            "SYSERR_LICENSE_FIELD_VALID_UNTIL_NOT_SET": {},
            "SYSERR_LICENSE_INVALID_TIERS": {},
            "SYSERR_LICENSE_FIELD_LICENSE_ID_NOT_PRESENT": {},
            "SYSERR_LICENSE_INVALID_VERSION": {},
            "SYSERR_LICENSE_DECRYPTION_FAILED": {},
            "SYSERR_LICENSE_ENFORCEMENT_KEY_NOT_VALID": {},
            "SYSERR_LICENSE_INVALID_SERIALKEY": {},
            "SYSERR_LICENSE_INVALID_METRICS": {},
            "SYSERR_LICENSE_GRPC_NOT_READY": {},
            "SYSERR_LATEST_LICENSE_ALREADY_DEPLOYED": {},
            "SYSERR_LICENSE_MGR_GRPC_NOT_READY": {},
            "SYSERR_LICENSE_TRANSACTION_TENANT_REQUIRED": {},
            "SYSERR_LICENSE_TRANSACTION_INSUFFICIENT_RESOURCES": {},
            "SYSERR_LICENSE_TRANSACTION_PER_TENANT_NOT_SUPPORTED": {},
            "SYSERR_FLOATING_LICENSE_NOT_SUPPORTED": {},
            "SYSERR_LICENSE_MGR_CANNOT_DELETE_LICENSE": {},
            "SYSERR_LICENSE_MGR_LICENSE_TIER_NOT_FOUND": {},
            "SYSERR_LICENSE_EXPIRED": {},
            "SYSERR_LICENSE_LEDGER_UPDATE_FAILED": {},
            "SYSERR_LICENSE_TRANSACTION_INSUFFICIENT_SAAS_LICENSE": {},
            "SYSERR_LICENSE_TRANSACTION_MAX_SERVICE_UNITS_LIMIT": {},
            "SYSERR_LICENSE_SAAS_UNSUBSCRIBED": {},
            "SYSERR_LICENSE_SAAS_SYNC_RPC_ERROR": {},
            "SYSERR_LICENSE_SAAS_SYNC_CONNECT_ERROR": {},
            "SYSERR_LICENSE_SAAS_SYNC_SERVER_ERROR": {},
            "SYSERR_LICENSE_SAAS_SYNC_INSUFFICIENT_LICENSE": {},
            "SYSERR_LICENSE_TRANSACTION_INCORRECT_TIER": {},
            "SYSERR_LICENSE_TRANSACTION_DATASTORE_ERROR": {},
            "SYSERR_LICENSE_INVALID_TIER": {},
            "SYSERR_TRIAL_OR_EVAL_LICENSE_ADDITION_NOT_ALLOWED": {},
            "SYSERR_LICENSE_INVALID_CLUSTER_UUID": {},
            "SYSERR_LICENSE_SAAS_LICENSE_INSTALLATION_FAILED": {},
            "SYSERR_LICENSE_TRANSACTION_SERVICE_UNITS_REQUIRED": {},
            "SYSERR_LICENSE_TRANSACTION_SEGROUP_LIMIT_EXCEEDED": {},
            "SYSERR_LICENSE_TRANSACTION_TENANT_LIMIT_EXCEEDED": {},
            "SYSERR_LICENSE_TRANSACTION_SYSTEM_LIMIT_EXCEEDED": {},
            "SYSERR_LICENSE_TRANSACTION_RESERVATION_VIOLATION": {},
            "SYSERR_LICENSE_CLS_ID_NOT_SET": {},
            "SYSERR_INVALID_LICENSE_WARNING_DATE": {},
            "SYSERR_INVALID_LICENSE_EXPIRATION_DATE": {},
            "SYSERR_LICENSE_SERIAL_KEY_DEPRECATED": {},
            "SYSERR_SEAGENT_OBJ_INACTIVE": {},
            "SYSERR_SEAGENT_OBJ_AWAITING_DP_PROGRAMMING": {},
            "SYSERR_SEAGENT_OBJ_ACTIVE": {},
            "SYSERR_SEAGENT_OBJ_GRAPHDB_ERROR": {},
            "SYSERR_SEAGENT_OBJ_DP_ERROR": {},
            "SYSERR_SEAGENT_OBJ_DISABLED_RULE_POOL": {},
            "SYSERR_SEAGENT_EASTWEST_VS_SUBNET_ERROR": {},
            "SYSERR_SEAGENT_OBJ_NOT_FOUND": {},
            "SYSERR_SEAGENT_VS_NOT_FOUND": {},
            "SYSERR_SEAGENT_VS_VRF_ERROR": {},
            "SYSERR_SEAGENT_VS_SELIST_LIMIT_ERROR": {},
            "SYSERR_SEAGENT_VS_SELIST_SE_INTF_ERROR": {},
            "SYSERR_SEAGENT_VS_CHILD_PARENT_UUID_MISSING": {},
            "SYSERR_SEDP_PARENT_VS_NOT_EXIST_FOR_CHILD": {},
            "SYSERR_SEAGENT_TENANT_CREATE_FAILED": {},
            "SYSERR_SEAGENT_TENANT_UPDATE_FAILED": {},
            "SYSERR_SEAGENT_VS_INTERFACE_ERROR": {},
            "SYSERR_SEAGENT_INSUFFICIENT_MEMORY": {},
            "SYSERR_SEDP_VNIC_CREATION_FAILURE": {},
            "SYSERR_SEDP_VNIC_ATTACH_FAILURE": {},
            "SYSERR_SEDP_VNIC_IF_CREATION_FAILURE": {},
            "SYSERR_SEDP_VNIC_START_FAILURE": {},
            "SYSERR_SEDP_VNIC_NOT_FOUND": {},
            "SYSERR_SEDP_VNIC_MISMATCH_VRF": {},
            "SYSERR_SEDP_VNIC_IP_ADDR_ADD_FAILURE": {},
            "SYSERR_SEDP_VNIC_IP_ADDR_DEL_FAILURE": {},
            "SYSERR_SEDP_VNIC_OWNER_CORE_NOT_FOUND": {},
            "SYSERR_SEDP_VNIC_MAIN_VNIC_NOT_FOUND": {},
            "SYSERR_SEDP_VNIC_MEMBER_VNIC_NOT_FOUND": {},
            "SYSERR_SEDP_VNIC_VLAN_FILTER_ADD_FAILURE": {},
            "SYSERR_SEDP_VNIC_VLAN_FILTER_REMOVE_FAILURE": {},
            "SYSERR_SEDP_VNIC_UNKNOWN_MSG_TYPE": {},
            "SYSERR_SEDP_VNIC_PCAP_INIT_FAILURE": {},
            "SYSERR_GSLB_INVALID_MTYPE": {},
            "SYSERR_GSLB_INVALID_SITE_CREDENTIALS": {},
            "SYSERR_GSLB_OBJECT_NOT_FOUND": {},
            "SYSERR_GSLB_INVALID_OPS": {},
            "SYSERR_GSLB_PARTIAL_SUCCESS": {},
            "SYSERR_GSLB_FQDN_CONFLICT": {},
            "SYSERR_GSLB_CLEANUP_IN_PROGRESS": {},
            "SYSERR_GSLB_METHOD_NOP": {},
            "SYSERR_GSLB_API_NOT_SUPPORTED_FOR_UNFEDERATED_OBJECTS": {},
            "SYSERR_GSLB_STATEDB_ERR": {},
            "SYSERR_GSLB_SERVICE_MEMBER_VIPS_NOT_IN_SYNC": {},
            "SYSERR_GSLB_SERVICE_MEMBER_DISABLED": {},
            "SYSERR_GSLB_SITE_DISABLED": {},
            "SYSERR_GSLB_SERVICE_DISABLED": {},
            "SYSERR_GSLB_HM_PROXY_DOWN": {},
            "SYSERR_GSLB_DNS_DISABLED": {},
            "SYSERR_GSLB_SERVICE_NON_AVI_VIP_INFO_UNAVAILABLE": {},
            "SYSERR_GSLB_SERVICE_DATAPATH_STATUS_UNAVAILABLE": {},
            "SYSERR_GSLB_SERVICE_MEMBER_SERVICES_NOT_IN_SYNC": {},
            "SYSERR_GSLB_SERVICE_INCONSISTENT_APPLICATION_PROFILE": {},
            "SYSERR_GSLB_SERVICE_INVALID_APPLICATION_PROFILE": {},
            "SYSERR_GSLB_SERVICE_SP_INCONSISTENT_CONFIGURED_SERVERS": {},
            "SYSERR_GSLB_SERVICE_SP_INCONSISTENT_OPERATIONAL_SERVERS": {},
            "SYSERR_GSLB_SERVICE_SP_ALL_SERVERS_DOWN": {},
            "SYSERR_GSLB_SERVICE_SP_SOME_SERVERS_DOWN": {},
            "SYSERR_GSLB_CONFIGURED_VS_IS_NOT_A_DNS_VS": {},
            "SYSERR_GSLB_NOT_CONFIGURED": {},
            "SYSERR_GSLB_INVALID_SENDER": {},
            "SYSERR_GSLB_INVALID_SENDER_STATE": {},
            "SYSERR_GSLB_INVALID_RX_ID": {},
            "SYSERR_GSLB_INVALID_VIEW_ID": {},
            "SYSERR_GSLB_GROUP_CONFLICT": {},
            "SYSERR_GSLB_INVALID_MTYPE_AT_FOLLOWER": {},
            "SYSERR_GSLB_LEADER_NOT_IN_LIST": {},
            "SYSERR_GSLB_SERVICE_CTRL_STATUS_UNAVAILABLE": {},
            "SYSERR_GSLB_SITE_FSM_NULL": {},
            "SYSERR_GSLB_SITE_FSM_DISABLE_IN_PROGRESS": {},
            "SYSERR_GSLB_SITE_FSM_DISABLED": {},
            "SYSERR_GSLB_SITE_FSM_JOIN_IN_PROGRESS": {},
            "SYSERR_GSLB_SITE_FSM_INIT": {},
            "SYSERR_GSLB_SITE_FSM_UNREACHABLE": {},
            "SYSERR_GSLB_SITE_FSM_LEAVE_IN_PROGRESS": {},
            "SYSERR_GSLB_SITE_FSM_MMODE": {},
            "SYSERR_GSLB_SITE_ACTIVE_TO_PASSIVE_TRANSITION": {},
            "SYSERR_GSLB_SITE_PASSIVE_TO_ACTIVE_TRANSITION": {},
            "SYSERR_GSLB_SITE_MAX_RETRIES_DONE": {},
            "SYSERR_GSLB_TIMEOUT": {},
            "SYSERR_GSLB_CONNECTION_TIMEOUT": {},
            "SYSERR_GSLB_CONNECTION_REFUSED_ERROR": {},
            "SYSERR_GSLB_SERVICE_CTRL_STATUS_NA_DUE_TO_UNREACHABLE_SITE": {},
            "SYSERR_GSLB_SERVICE_SP_NO_CONFIGURED_SERVERS": {},
            "SYSERR_GSLB_INVALID_OBJECT": {},
            "SYSERR_GSLB_SERVICE_POOL_DISABLED": {},
            "SYSERR_GSLB_SERVICE_CREATE_FAILED": {},
            "SYSERR_GSLB_SERVICE_UPDATE_FAILED": {},
            "SYSERR_GSLB_GSLB_GEO_FILE_NOT_PRESENT": {},
            "SYSERR_GSLB_SERVICE_MEMBER_VS_SERVICES_NOT_IN_SYNC": {},
            "SYSERR_GSLB_SERVICE_MEMBER_VS_SP_POOL_NOT_IN_SYNC": {},
            "SYSERR_FILE_NOT_PRESENT": {},
            "SYSERR_GSLB_SERVICE_STATUS_UNKNOWN_IN_PASSIVE_SITE": {},
            "SYSERR_DNS_POLICY_CREATE_FAIL": {},
            "SYSERR_DNS_POLICY_UPDATE_FAIL": {},
            "SYSERR_LCM_CORE_NOT_COPIED_DUE_TO_MAX_LIMIT": {},
            "SYSERR_LCM_CORE_NOT_COPIED_INSUFFICIENT_DISK_SIZE": {},
            "SYSERR_LCM_SKIP_SIMILAR_CORE": {},
            "SYSERR_LCM_CORE_NOT_COPIED_DUE_TO_ERRORS": {},
            "SYSERR_LCM_STOP": {},
            "SYSERR_POOL_SERVER_CAPEST_BREACHED": {},
            "SYSERR_POOL_CREATE_FAILED": {},
            "SYSERR_POOL_UPDATE_FAILED_INCONSISTENT": {},
            "SYSERR_POOL_UPDATE_FAILED": {},
            "SYSERR_POOL_SERVER_STATE_UPDATE_FAILED": {},
            "SYSERR_POOL_UPDATE_SERVER_FAILED": {},
            "SYSERR_POOL_UPDATE_LB_ALGO_NO_STATE": {},
            "SYSERR_SHM_HASH_INSERT_FAILED": {},
            "SYSERR_SE_RPC_PROXY_STREAM_NOT_CONNECTED": {},
            "SYSERR_SE_RPC_PROXY_STREAM_WRITE_FAILED": {},
            "SYSERR_SE_RPC_PROXY_UNABLE_TO_FIND_SYNC_RPC": {},
            "SYSERR_PRST_PROF_OBJECT_TYPE_MISMATCH": {},
            "SYSERR_PRST_PROF_OBJECT_NOT_FOUND": {},
            "SYSERR_PRST_PROF_NULL": {},
            "SYSERR_PRST_PROF_OBJECT_PRESENT": {},
            "SYSERR_MS_OBJECT_EXISTS": {},
            "SYSERR_MS_OBJECT_NOT_FOUND": {},
            "SYSERR_MS_GRP_OBJECT_EXISTS": {},
            "SYSERR_MS_GRP_OBJECT_NOT_FOUND": {},
            "SYSERR_HTTP_POLICY_CREATE_FAILED": {},
            "SYSERR_HTTP_POLICY_CREATE_EXISTS": {},
            "SYSERR_HTTP_POLICY_CREATE_SHM_INSERT": {},
            "SYSERR_HTTP_POLICY_UPDATE_FAILED": {},
            "SYSERR_STR_GRP_REGISTER_INVAL": {},
            "SYSERR_STR_GRP_DEREGISTER_INVAL": {},
            "SYSERR_AG_CREATE_POST_FAILED": {},
            "SYSERR_AG_CREATE_PRE_FAILED": {},
            "SYSERR_AG_UPDATE_FAILED": {},
            "SYSERR_APP_PROF_UPDATE_TYPE_MISMATCH": {},
            "SYSERR_APP_PROF_CREATE_INVALID_TYPE": {},
            "SYSERR_APP_PROF_UPDATE_PRESERVE_CLIENT_IP_CHANGED": {},
            "SYSERR_APP_PROF_NOT_FOUND": {},
            "SYSERR_POOL_GRP_MEMBER_NOT_FOUND": {},
            "SYSERR_POOL_GRP_UPDATE_FAILED": {},
            "SYSERR_POOL_GRP_CREATE_FAILED": {},
            "SYSERR_POOL_GRP_UPDATE_FAILED_INCONSISTENT": {},
            "SYSERR_L4PS_CONNPOL_POOL_FAILED": {},
            "SYSERR_L4PS_CONNPOL_POOL_GRP_FAILED": {},
            "SYSERR_L4PS_CONNPOL_IP_GRP_FAILED": {},
            "SYSERR_L4PS_CREATE_FAILED": {},
            "SYSERR_ANT_PROF_NOT_FOUND": {},
            "SYSERR_LB_CHASH_INVALID_TYPE": {},
            "SYSERR_SEC_POLICY_NOT_FOUND": {},
            "SYSERR_TECH_SUPPORT_COLLECTION_NOT_DONE": {},
            "SYSERR_TECH_SUPPORT_COLLECTION_SUCCESS": {},
            "SYSERR_TECH_SUPPORT_COLLECTION_STARTED": {},
            "SYSERR_TECH_SUPPORT_COLLECTION_ONGOING": {},
            "SYSERR_TECH_SUPPORT_COLLECTION_IN_PROGRESS": {},
            "SYSERR_TECH_SUPPORT_COLLECTION_SUCCESS_WITH_ERRORS": {},
            "SYSERR_TECH_SUPPORT_COLLECTION_ABORTED": {},
            "SYSERR_TECH_SUPPORT_COLLECTION_STATUS_FILE_NOT_FOUND": {},
            "SYSERR_TECH_SUPPORT_INVALID_FILENAME": {},
            "SYSERR_TECH_SUPPORT_COLLECTION_STATUS_IN_PROGRESS": {},
            "SYSERR_TECH_SUPPORT_INPUT_INVALID_LEVEL": {},
            "SYSERR_TECH_SUPPORT_INPUT_INVALID_SLUG": {},
            "SYSERR_DATASCRIPT_FAILED": {},
            "SYSERR_TECH_SUPPORT_COLLECTION_PREMATURELY_STOPPED": {},
            "SYSERR_TECH_SUPPORT_V1_DEPRECATED": {},
            "SYSERR_TECHSUPPORT_COLLECTION_STARTED": {},
            "SYSERR_TECH_SUPPORT_V2_DEPRECATED": {},
            "SYSERR_TECH_SUPPORT_FOLLOWER_NOT_SUPPORTED": {},
            "SYSERR_TECH_SUPPORT_INVALID_DURATION_FORMAT": {},
            "SYSERR_NET_PROF_NOT_FOUND": {},
            "SYSERR_ALBSVC_FILE_UPLOAD_IN_PROGRESS": {},
            "SYSERR_ALBSVC_FILE_UPLOAD_SUCCESS": {},
            "SYSERR_ALBSVC_FILE_UPLOAD_FAILED": {},
            "SYSERR_ALBSVC_FILE_UPLOAD_STARTED": {},
            "SYSERR_ALBSVC_CASE_ID_MISSING": {},
            "SYSERR_ALBSVC_ASSET_ID_MISSING": {},
            "SYSERR_ALBSVC_AUTH_FAILURE": {},
            "SYSERR_ALBSVC_REMOTE_SERVER_ERROR": {},
            "SYSERR_ALBSVC_DISCONNECTED": {},
            "SYSERR_ALBSVC_DEREGISTERED": {},
            "SYSERR_ALBSVC_CANNOT_READ_RESPONSE": {},
            "SYSERR_ALBSVC_CONTROLLER_ALREADY_REGISTERED": {},
            "SYSERR_ALBSVC_SESSION_NOT_SET": {},
            "SYSERR_ALBSVC_CLIENT_TIME_OUT": {},
            "SYSERR_ALBSVC_CONNECTION_REFUSED": {},
            "SYSERR_ALBSVC_HTTP_CLIENT_ERROR": {},
            "SYSERR_ALBSVC_RESOURCE_NOT_FOUND": {},
            "SYSERR_ALBSVC_INVALID_QUERY_PARAM_VALUE": {},
            "SYSERR_ALBSVC_INVALID_QUERY_PARAM": {},
            "SYSERR_ALBSVC_FILE_UPLOAD_CONFLICT": {},
            "SYSERR_ALBSVC_INTERNAL_ERROR": {},
            "SYSERR_ALBSVC_PROXY_AUTH_FAILURE": {},
            "SYSERR_ALBSVC_LOGIN_URL_NOT_FOUND": {},
            "SYSERR_ALBSVC_PROXY_CONFIG_PARSE_FAILURE": {},
            "SYSERR_ALBSVC_LOGIN_REQ_FAILED": {},
            "SYSERR_ALBSVC_REGISTRATION_FAILED": {},
            "SYSERR_ALBSVC_DATABASE_WRITE_ERROR": {},
            "SYSERR_ALBSVC_DEREGISTRATION_FAILED": {},
            "SYSERR_ALBSVC_MALFORMED_PAYLOAD": {},
            "SYSERR_ALBSVC_CASE_GET_FAILED": {},
            "SYSERR_ALBSVC_CASE_CREATE_FAILED": {},
            "SYSERR_ALBSVC_CASES_GET_FAILED": {},
            "SYSERR_ALBSVC_CASE_UPDATE_FAILED": {},
            "SYSERR_ALBSVC_STATUS_REQ_FAILED": {},
            "SYSERR_ALBSVC_CRS_DOWNLOAD_FAILED": {},
            "SYSERR_ALBSVC_CRS_DEPLOY_FAILED": {},
            "SYSERR_ALBSVC_CRS_DATA_NOT_FOUND": {},
            "SYSERR_ALBSVC_DATASTORE_READ_ERROR": {},
            "SYSERR_ALBSVC_CRS_AUTO_DEPLOY_MALFORMED_URL": {},
            "SYSERR_ALBSVC_CRS_DOWNLOAD_SIG_MISMATCH": {},
            "SYSERR_ALBSVC_CRS_DOWNLOAD_FORBIDDEN": {},
            "SYSERR_ALBSVC_DATABASE_READ_ERROR": {},
            "SYSERR_ALBSVC_AVICLIENT_ERROR": {},
            "SYSERR_ALBSVC_CRS_AUTODEPLOY_SUCCESS": {},
            "SYSERR_ALBSVC_EMPTY_METADATA": {},
            "SYSERR_ALBSVC_USERS_REQ_FAILED": {},
            "SYSERR_ALBSVC_USER_DETAIL_REQ_FAILED": {},
            "SYSERR_ALBSVC_CRS_URL_DECODE_FAILED": {},
            "SYSERR_ALBSVC_NAME_RESOLUTION_FAILED": {},
            "SYSERR_ALBSVC_x509_ERROR": {},
            "SYSERR_ALBSVC_REGISTRATION_DISABLED": {},
            "SYSERR_ALBSVC_FEATURE_OPT_IN_NOT_ENABLED": {},
            "SYSERR_ALBSVC_USER_AGENT_DB_BATCH_SIZE_EXCEEDED": {},
            "SYSERR_ALBSVC_LICENSE_STATUS_CHECK_FAILED": {},
            "SYSERR_ALBSVC_FEATURE_NOT_ALLOWED": {},
            "SYSERR_ALBSVC_NO_TENANT_INFO_IN_CTX": {},
            "SYSERR_ALBSVC_DATABASE_UPDATE_ERROR": {},
            "SYSERR_ALBSVC_ALREADY_DEREGISTERED": {},
            "SYSERR_ALBSVC_FILE_DOWNLOAD_IN_PROGRESS": {},
            "SYSERR_ALBSVC_FILE_DOWNLOAD_SUCCESS": {},
            "SYSERR_ALBSVC_FILE_DOWNLOAD_FAILED": {},
            "SYSERR_ALBSVC_FILE_DOWNLOAD_STARTED": {},
            "SYSERR_ALBSVC_CLOUD_LICENSING_ENABLED": {},
            "SYSERR_ALBSVC_SITE_ID_MISSING": {},
            "SYSERR_UPGRADE_SYSTEM_STARTED": {},
            "SYSERR_UPGRADE_CONTROLLER_STARTED": {},
            "SYSERR_UPGRADE_SEGROUP_STARTED": {},
            "SYSERR_RESUME_SEGROUP_STARTED": {},
            "SYSERR_PATCH_SYSTEM_STARTED": {},
            "SYSERR_PATCH_CONTROLLER_STARTED": {},
            "SYSERR_PATCH_SEGROUP_STARTED": {},
            "SYSERR_PATCHSEGROUP_RESUME_STARTED": {},
            "SYSERR_ROLLBACK_SYSTEM_STARTED": {},
            "SYSERR_ROLLBACK_CONTROLLER_STARTED": {},
            "SYSERR_ROLLBACK_SEGROUP_STARTED": {},
            "SYSERR_ROLLBACKPATCH_SYSTEM_STARTED": {},
            "SYSERR_ROLLBACKPATCH_CONTROLLER_STARTED": {},
            "SYSERR_ROLLBACKPATCH_SEGROUP_STARTED": {},
            "SYSERR_UPGRADE_OPS_VS_DISRUPTION_WARNINGS": {},
            "SYSERR_UPGRADE_OPS_COMPLIANCE_MODE_TRANSITION_STARTED": {},
            "SYSERR_UPGRADE_OPS_COMPLIANCE_MODE_ERROR_RECOVERY_STARTED": {},
            "SYSERR_CONCURRENT_UPGRADE": {},
            "SYSERR_RESTORE_CONTROLLER_STARTED": {},
            "SYSERR_EVAL_UPGRADE_SYSTEM_STARTED": {},
            "SYSERR_EVAL_UPGRADE_CONTROLLER_STARTED": {},
            "SYSERR_EVAL_UPGRADE_SEGROUP_STARTED": {},
            "SYSERR_EVAL_RESUME_SEGROUP_STARTED": {},
            "SYSERR_EVAL_PATCH_SYSTEM_STARTED": {},
            "SYSERR_EVAL_PATCH_CONTROLLER_STARTED": {},
            "SYSERR_EVAL_PATCH_SEGROUP_STARTED": {},
            "SYSERR_EVAL_PATCHSEGROUP_RESUME_STARTED": {},
            "SYSERR_EVAL_ROLLBACK_SYSTEM_STARTED": {},
            "SYSERR_EVAL_ROLLBACK_CONTROLLER_STARTED": {},
            "SYSERR_EVAL_ROLLBACK_SEGROUP_STARTED": {},
            "SYSERR_EVAL_ROLLBACKPATCH_SYSTEM_STARTED": {},
            "SYSERR_EVAL_ROLLBACKPATCH_CONTROLLER_STARTED": {},
            "SYSERR_EVAL_ROLLBACKPATCH_SEGROUP_STARTED": {},
            "SYSERR_EVAL_RESTORE_CONTROLLER_STARTED": {},
            "SYSERR_UPGRADE_OPS_IN_PROGRESS": {},
            "SYSERR_UPGRADE_OPS_CHECK_LICENSE": {},
            "SYSERR_UPGRADE_OPS_CHECK_CLUSTER_STATE": {},
            "SYSERR_UPGRADE_OPS_CHECK_CLUSTER_DISK_SPACE": {},
            "SYSERR_UPGRADE_OPS_CHECK_SE_GROUP_INPROGRESS": {},
            "SYSERR_UPGRADE_OPS_CHECK_VERSION_COMPATIBILITY": {},
            "SYSERR_UPGRADE_OPS_CHECK_SE_REACHABILITY": {},
            "SYSERR_UPGRADE_OPS_CHECK_SE_GROUP_CLOUD_READY": {},
            "SYSERR_UPGRADE_OPS_CHECK_SE_DISK_SPACE": {},
            "SYSERR_UPGRADE_OPS_CHECK_VS_DISRUPUTION": {},
            "SYSERR_UPGRADE_OPS_CHECK_ROLLBACK_BASICS": {},
            "SYSERR_UPGRADE_OPS_CHECK_CONTROLLER_VERSION_ROLLBACK": {},
            "SYSERR_UPGRADE_OPS_CHECK_SE_VERSION_ROLLBACK": {},
            "SYSERR_UPGRADE_OPS_CHECK_CONTROLLER_ROLLBACK": {},
            "SYSERR_UPGRADE_OPS_CHECK_SE_GROUP_ROLLBACK": {},
            "SYSERR_UPGRADE_OPS_CHECK_SYSTEM_ROLLBACK": {},
            "SYSERR_UPGRADE_OPS_CHECK_IMAGE_VERSION": {},
            "SYSERR_UPGRADE_OPS_CHECK_DOCKER_DISK_SPACE": {},
            "SYSERR_UPGRADE_OPS_CHECK_ACTIVE_VERSIONS": {},
            "SYSERR_UPGRADE_OPS_CHECK_BACKUP": {},
            "SYSERR_UPGRADE_OPS_CHECK_SE_GROUP_ERROR_RECOVERY": {},
            "SYSERR_UPGRADE_OPS_CHECK_SE_GROUP_SUSPENDED": {},
            "SYSERR_UPGRADE_OPS_CHECK_SYSTEM_FLAG": {},
            "SYSERR_UPGRADE_OPS_PREVIEW_RESPONSE": {},
            "SYSERR_UPGRADE_OPS_CHECK_PREVIOUS_PARTITION_COMPATIBILITY": {},
            "SYSERR_UPGRADE_OPS_CHECK_IMAGE_COMPATIBILITY": {},
            "SYSERR_UPGRADE_OPS_CHECK_CONTROLLER_PATCH_COMPATIBILITY": {},
            "SYSERR_UPGRADE_OPS_CHECK_SE_PATCH_COMPATIBILITY": {},
            "SYSERR_UPGRADE_OPS_CHECK_SE_ROLLBACK_V1": {},
            "SYSERR_UPGRADE_OPS_CHECK_ALERTS": {},
            "SYSERR_UPGRADE_OPS_CHECK_DOCKER_IMAGE": {},
            "SYSERR_UPGRADE_OPS_CHECK_UPGRADE_STATE_FOR_RESUME_OPS": {},
            "SYSERR_UPGRADE_OPS_CHECK_PATCH_IMAGE": {},
            "SYSERR_UPGRADE_OPS_CHECK_ALLOW_SE_GROUP_ROLLBACK": {},
            "SYSERR_UPGRADE_OPS_CHECK_SKIP_SE_GROUPS": {},
            "SYSERR_UPGRADE_OPS_CHECK_CLOUD_COMPATIBILITY": {},
            "SYSERR_UPGRADE_OPS_CHECK_SKIP_ALL_SE_GROUPS": {},
            "SYSERR_UPGRADE_OPS_CHECK_MAND_PATCH_ROLLBACK": {},
            "SYSERR_UPGRADE_OPS_GSLB_FEATURE_CHECK": {},
            "SYSERR_UPGRADE_OPS_CONFIGURATION_CHECK": {},
            "SYSERR_UPGRADE_OPS_AVI_ESSENTIALS_CHECK": {},
            "SYSERR_ROLLBACK_OPS_CHECK_VS_DISRUPUTION": {},
            "SYSERR_UPGRADE_OPS_CHECK_SE_LINUX_ENABLED": {},
            "SYSERR_UPGRADE_OPS_CHECK_PREVIOUS_DOCKER_IMAGE": {},
            "SYSERR_UPGRADE_OPS_DOCKER_VERSION_CHECK": {},
            "SYSERR_UPGRADE_OPS_IP_TYPE_CHECK": {},
            "SYSERR_UPGRADE_OPS_CHECK_SE_LICENSE": {},
            "SYSERR_UPGRADE_OPS_AVI_CLOUD_SERVICES_CHECK": {},
            "SYSERR_CHECK_LICENSE": {},
            "SYSERR_CHECK_CLUSTER_STATE": {},
            "SYSERR_CHECK_CLUSTER_DISK_SPACE": {},
            "SYSERR_CHECK_SE_GROUP_UPGRADE_OPS_INPROGRESS": {},
            "SYSERR_CHECK_VERSION_COMPATIBILITY": {},
            "SYSERR_CHECK_SE_REACHABILITY": {},
            "SYSERR_CHECK_SE_GROUP_CLOUD_READY": {},
            "SYSERR_CHECK_SE_DISK_SPACE": {},
            "SYSERR_CHECK_VS_DISRUPUTION": {},
            "SYSERR_CHECK_ROLLBACK_BASICS": {},
            "SYSERR_CHECK_CONTROLLER_VERSION_ROLLBACK": {},
            "SYSERR_CHECK_SE_VERSION_ROLLBACK": {},
            "SYSERR_CHECK_CONTROLLER_ROLLBACK": {},
            "SYSERR_CHECK_SE_GROUP_ROLLBACK": {},
            "SYSERR_CHECK_SYSTEM_ROLLBACK": {},
            "SYSERR_CHECK_IMAGE_VERSION": {},
            "SYSERR_CHECK_DOCKER_DISK_SPACE": {},
            "SYSERR_CHECK_ACTIVE_VERSIONS": {},
            "SYSERR_CHECK_BACKUP": {},
            "SYSERR_CHECK_SE_GROUP_ERROR_RECOVERY": {},
            "SYSERR_CHECK_SE_GROUP_SUSPENDED": {},
            "SYSERR_CHECK_SYSTEM_FLAG": {},
            "SYSERR_CHECK_PREVIOUS_PARTITION_COMPATIBILITY": {},
            "SYSERR_CHECK_IMAGE_COMPATIBILITY": {},
            "SYSERR_CHECK_CONTROLLER_PATCH_COMPATIBILITY": {},
            "SYSERR_CHECK_SE_PATCH_COMPATIBILITY": {},
            "SYSERR_CHECK_SE_ROLLBACK_V1": {},
            "SYSERR_CHECK_ALERTS": {},
            "SYSERR_CHECK_DOCKER_IMAGE": {},
            "SYSERR_CHECK_UPGRADE_STATE_FOR_RESUME_OPS": {},
            "SYSERR_CHECK_PATCH_IMAGE": {},
            "SYSERR_CHECK_ALLOW_SE_GROUP_ROLLBACK": {},
            "SYSERR_CHECK_SKIP_SE_GROUPS": {},
            "SYSERR_CHECK_CLOUD_COMPATIBILITY": {},
            "SYSERR_CHECK_SKIP_ALL_SE_GROUPS": {},
            "SYSERR_CHECK_MAND_PATCH_ROLLBACK": {},
            "SYSERR_GSLB_FEATURE_CHECK": {},
            "SYSERR_CONFIGURATION_CHECK": {},
            "SYSERR_AVI_ESSENTIALS_CHECK": {},
            "SYSERR_CHECK_SE_LINUX_ENABLED": {},
            "SYSERR_CHECK_PREVIOUS_DOCKER_IMAGE": {},
            "SYSERR_DOCKER_VERSION_CHECK": {},
            "SYSERR_IP_TYPE_CHECK": {},
            "SYSERR_CHECK_SE_LICENSE": {},
            "SYSERR_CONFIG_CHECK": {},
            "SYSERR_GSLB_MANUAL_RESUME_CHECK": {},
            "SYSERR_CHECK_K8S_ACCESS": {},
            "SYSERR_CHECK_IMAGE_AVAILABILITY": {},
            "SYSERR_CHECK_POD_IMAGE": {},
            "SYSERR_CHECK_REMOTE_IMAGE_REF": {},
            "SYSERR_CHECK_CONTROLLER_PACKAGE": {},
            "SYSERR_CHECK_PATCH_PACKAGE": {},
            "SYSERR_CHECK_CONSENT": {},
            "SYSERR_CHECK_CONFIG_VERSION": {},
            "SYSERR_CHECK_CONFIG_FIPS": {},
            "SYSERR_CHECK_CONFIG_FILES": {},
            "SYSERR_CHECK_CONFIG_IMAGES": {},
            "SYSERR_CHECK_CONFIG": {},
            "SYSERR_CHECK_CONFIG_SE": {},
            "SYSERR_CHECK_CONFIG_ENV": {},
            "SYSERR_CHECK_CONFIG_ACTIVE_VERSIONS": {},
            "SYSERR_CHECK_RESTORE_PATCH": {},
            "SYSERR_GSLB_MAINTENANCE_MODE_CHECK": {},
            "SYSERR_CHECK_VERSION_MIGRATION": {},
            "SYSERR_CHECK_CLUSTER_SINGLE_NODE": {},
            "SYSERR_CONTROLLER_SE_SECURE_CHANNEL_CERTIFICATE_VALIDATION": {},
            "SYSERR_CHECK_DRYRUN_CAPABILITY": {},
            "SYSERR_CHECK_DRYRUN_FIPS_MODE": {},
            "SYSERR_CHECK_CONFIG_BUNDLE": {},
            "SYSERR_CHECK_ROLLBACK_FIPS_MODE": {},
            "SYSERR_CHECK_TIME_SYNC": {},
            "SYSERR_CHECK_ROLLBACK_SYSTEM": {},
            "SYSERR_CHECK_LICENSE_CONSUMPTION": {},
            "SYSERR_CHECK_LINUX_INFRA_HEALTH": {},
            "SYSERR_CHECK_GSLBSERVICE_DISRUPTION": {},
            "SYSERR_CHECK_MAX_DISK_SIZE_PERCENT_TS": {},
            "SYSERR_CHECK_MIN_FREE_DISK_REQUIRED_TS": {},
            "SYSERR_CHECK_SE_REACHABILITY_TS": {},
            "SYSERR_MC_UPGRADE_LICENSE_ERR": {},
            "SYSERR_MC_UPGRADE_CLUSTER_NOT_READY": {},
            "SYSERR_MC_DISK_INSUFFICIENT_ERR": {},
            "SYSERR_MC_CLUSTER_INPROGRESS_ERR": {},
            "SYSERR_MC_SEGROUP_INPROGRESS_ERR": {},
            "SYSERR_MC_UPGRADE_INCOMPATIBLE_IMAGE_AND_PATCH": {},
            "SYSERR_MC_UPGRADE_INCOMPATIBLE_FROM_TO_IMAGE": {},
            "SYSERR_MC_UPGRADE_INCOMPATIBLE_PATCH": {},
            "SYSERR_MC_UPGRADE_INCOMPATIBLE_SE_GROUP_IMAGE": {},
            "SYSERR_MC_SE_UNREACHABLE_ERR": {},
            "SYSERR_MC_SE_GROUP_CLOUD_NOT_READY_ERR": {},
            "SYSERR_MC_UPGRADE_VS_DISRUPTED_ERR": {},
            "SYSERR_MC_ROLLBACK_NOT_POSSIBLE": {},
            "SYSERR_MC_SE_ROLLBACK_NOT_POSSIBLE": {},
            "SYSERR_MC_ROLLBACK_INFO_ERR": {},
            "SYSERR_MC_CONTROLLER_ROLLBACK_NOT_POSSIBLE": {},
            "SYSERR_MC_SYSTEM_ROLLBACK_NOT_POSSIBLE": {},
            "SYSERR_MC_IMAGE_INVALID_ERR": {},
            "SYSERR_MC_ACTIVE_VERSIONS_ERR": {},
            "SYSERR_MC_BACKUP_ERR": {},
            "SYSERR_MC_ROLLBACK_ON_ERR": {},
            "SYSERR_MC_SUSPENDED_ERR": {},
            "SYSERR_MC_SYSTEM_FLAG_ERR": {},
            "SYSERR_MC_PREVIOUS_PARTITION_INCOMPATIBLE_ERR": {},
            "SYSERR_MC_IMAGE_VALIDATION_ERR": {},
            "SYSERR_MC_CONTROLLER_PATCH_ERR": {},
            "SYSERR_MC_SE_PATCH_ERR": {},
            "SYSERR_MC_SE_ROLLBACK_V1_ERR": {},
            "SYSERR_MC_ALERTS": {},
            "SYSERR_MC_ROLLBACK_DOCKER_IMAGE_ERR": {},
            "SYSERR_MC_RESUME_OPS_ERR": {},
            "SYSERR_MC_CHECK_PATCH_IMAGE_ERR": {},
            "SYSERR_MC_CHECK_SE_GROUP_ROLLBACK_ERR": {},
            "SYSERR_MC_SKIP_SE_GROUPS_ERR": {},
            "SYSERR_MC_CHECK_CLOUD_COMPATIBILITY_ERR": {},
            "SYSERR_MC_SKIP_ALL_SE_GROUPS_ERR": {},
            "SYSERR_MC_MAND_PATCH_ROLLBACK_ERR": {},
            "SYSERR_MC_GSLB_LEADER_ERR": {},
            "SYSERR_MC_SYSTEM_CONFIGURATION_ERR": {},
            "SYSERR_MC_AVI_ESSENTIALS_OPERATION_NOT_SUPPORTED_ERROR": {},
            "SYSERR_MC_ROLLBACK_VS_DISRUPTED_ERR": {},
            "SYSERR_MC_SE_LINUX_ENABLED_ERR": {},
            "SYSERR_MC_PREVIOUS_DOCKER_IMAGE_NOT_PRESENT_ERR": {},
            "SYSERR_MC_DOCKER_VERSION_INCOMPATIBLE_ERROR": {},
            "SYSERR_MC_IP_TYPE_ERR": {},
            "SYSERR_MC_INVALID_SE_LICENSE_ERR": {},
            "SYSERR_MC_AVI_CLOUD_SERVICES_OPERATION_NOT_SUPPORTED_ERROR": {},
            "SYSERR_MC_CONFIG_CHK_ERR": {},
            "SYSERR_MC_GSLB_MANUAL_RESUME_ERR": {},
            "SYSERR_MC_K8S_ACCESS_ERR": {},
            "SYSERR_MC_IMAGE_AVAILABILITY_ERR": {},
            "SYSERR_MC_POD_IMAGE_ERR": {},
            "SYSERR_MC_REMOTE_IMAGE_REF_ERR": {},
            "SYSERR_MC_CONTROLLER_PACKAGE_ERR": {},
            "SYSERR_MC_PATCH_PACKAGE_ERR": {},
            "SYSERR_MC_CONSENT_ERR": {},
            "SYSERR_MC_CONFIG_VERSION_ERR": {},
            "SYSERR_MC_CONFIG_FIPS_ERR": {},
            "SYSERR_MC_CONFIG_FILES_ERR": {},
            "SYSERR_MC_CONFIG_IMAGES_ERR": {},
            "SYSERR_MC_CONFIG_ERR": {},
            "SYSERR_CHECK_CONFIG_SE_ERR": {},
            "SYSERR_CHECK_CONFIG_ENV_ERR": {},
            "SYSERR_CHECK_CONFIG_ACTIVE_VERSIONS_ERR": {},
            "SYSERR_CHECK_RESTORE_PATCH_ERR": {},
            "SYSERR_MC_GSLB_MAINTENANCE_MODE_ERR": {},
            "SYSERR_CHECK_VERSION_MIGRATION_ERR": {},
            "SYSERR_CHECK_CLUSTER_SINGLE_NODE_ERR": {},
            "SYSERR_CONTROLLER_SE_SECURE_CHANNEL_CERTIFICATE_VALIDATION_ERR": {},
            "SYSERR_CHECK_DRYRUN_CAPABILITY_ERR": {},
            "SYSERR_CHECK_SE_AVAILABLE_MEMORY": {},
            "SYSERR_CHECK_SE_AVAILABLE_MEMORY_ERR": {},
            "SYSERR_CHECK_DRYRUN_FIPS_MODE_ERR": {},
            "SYSERR_CHECK_CONFIG_BUNDLE_ERR": {},
            "SYSERR_CHECK_ROLLBACK_FIPS_ERR": {},
            "SYSERR_MC_CHECK_TIME_SYNC_ERR": {},
            "SYSERR_CHECK_ROLLBACK_SYSTEM_ERR": {},
            "SYSERR_MC_CHECK_LICENSE_CONSUMPTION_ERR": {},
            "SYSERR_MC_LINUX_INFRA_HEALTH_ERR": {},
            "SYSERR_GSLBSERVICE_DISRUPTED_ERR": {},
            "SYSERR_CHECK_MAX_DISK_SIZE_PERCENT_TS_ERR": {},
            "SYSERR_CHECK_MIN_FREE_DISK_REQUIRED_TS_ERR": {},
            "SYSERR_CHECK_SE_REACHABILITY_TS_ERR": {},
            "SYSERR_VS_NOT_FOUND": {},
            "SYSERR_DEFAULT_POOL_NOT_FOUND": {},
            "SYSERR_PROXY_POOL_NOT_FOUND": {},
            "SYSERR_MISSING_APPLICATION_PROFILE": {},
            "SYSERR_APP_PROFILE_NOT_FOUND": {},
            "SYSERR_WAF_POLICY_NOT_FOUND": {},
            "SYSERR_DUPLICATE_VS": {},
            "SYSERR_WRONG_VS_TYPE": {},
            "SYSERR_POOL_IN_PG_NOT_FOUND": {},
            "SYSERR_PG_IN_PG": {},
            "SYSERR_LB_MODULE_INIT_FAILED": {},
            "SYSERR_CONNPOOL_MODULE_INIT_FAILED": {},
            "SYSERR_LBACTION_MODULE_INIT_FAILED": {},
            "SYSERR_PG_NOT_FOUND": {},
            "SYSERR_DUPLICATE_POOL": {},
            "SYSERR_SSL_PROFILE_NOT_FOUND": {},
            "SYSERR_PKI_PROFILE_NOT_FOUND": {},
            "SYSERR_SSL_CERTKEY_NOT_FOUND": {},
            "SYSERR_SET_CIPHER_LIST_FAILED": {},
            "SYSERR_SET_CIPHER_SUITES_FAILED": {},
            "SYSERR_WRONG_TLS_VERSION": {},
            "SYSERR_ERR_PAGE_PROFILE_NO_PAGES": {},
            "SYSERR_ERR_PAGE_PROFILE_NOT_FOUND": {},
            "SYSERR_ERR_PAGE_NOT_FOUND": {},
            "SYSERR_ERR_PAGE_REDIRECT_NOT_CONFIGURED": {},
            "SYSERR_HM_NOT_FOUND": {},
            "SYSERR_HTTPS_HM_MISSING_CONFIG": {},
            "SYSERR_SNI_PARENT_UNCONFIGURED": {},
            "SYSERR_SNI_PARENT_NOT_FOUND": {},
            "SYSERR_HTTP_POLICYSET_NOT_FOUND": {},
            "SYSERR_VSDS_NOT_FOUND": {},
            "SYSERR_MULTIPLE_SP_POOLS_CONFIGURED": {},
            "SYSERR_L4SSL_VS_INVALID_CLIENT_CERT": {},
            "SYSERR_CR_PROFILE_NOT_FOUND": {},
            "SYSERR_POOL_NOT_FOUND": {},
            "SYSERR_LISTEN_PORTS_CFG_FAILED": {},
            "SYSERR_STRGRP_NOT_FOUND": {},
            "SYSERR_SSOPOLICY_NULL": {},
            "SYSERR_SSOPOLICY_NO_AUTHN_POLICY": {},
            "SYSERR_SSOPOLICY_NO_AUTH_PROFILE": {},
            "SYSERR_AUTHPROFILE_NULL": {},
            "SYSERR_SSOPOLICY_INVALID_AUTH_TYPE": {},
            "SYSERR_SSOPOLICY_MISSING_SAML_IDP_SP_CONF": {},
            "SYSERR_SAML_SP_CONFIG_NULL": {},
            "SYSERR_SAML_SINGLE_SIGNON_URL_NULL": {},
            "SYSERR_SAML_SP_METADATA_NULL": {},
            "SYSERR_SAML_COOKIE_NAME_OR_KEY_NULL": {},
            "SYSERR_LASSO_SERVER_CONFIG_FAILURE": {},
            "SYSERR_SAML_ENTITY_ID_NULL": {},
            "SYSERR_BASIC_AUTH_CONF_NULL": {},
            "SYSERR_LDAP_REQUIRE_FIELD_EMPTY": {},
            "SYSERR_LDAP_URL_INVALID_PARAMETER": {},
            "SYSERR_LDAP_BAD_SCHEME": {},
            "SYSERR_LDAP_BAD_ENCLOSURE": {},
            "SYSERR_LDAP_BAD_EXTNS": {},
            "SYSERR_LDAP_BAD_FILTER": {},
            "SYSERR_LDAP_BAD_SCOPE": {},
            "SYSERR_LDAP_BAD_ATTRS": {},
            "SYSERR_LDAP_BAD_HOST": {},
            "SYSERR_LDAP_USER_ATTRIBUTE_NULL": {},
            "SYSERR_LDAP_URL_PARSE_FAIL": {},
            "SYSERR_LDAP_INVALID_URL": {},
            "SYSERR_AUTH_PROFILE_NOT_FOUND": {},
            "SYSERR_SSO_TYPE_MISMATCH": {},
            "SYSERR_NULL_CACHE_CONFIG": {},
            "SYSERR_SSOPOLICY_NOT_FOUND": {},
            "SYSERR_CLIENT_AUTH_PROFILE_NOT_FOUND": {},
            "SYSERR_CLIENT_AUTH_PROFILE_NULL": {},
            "SYSERR_SAML_IDP_METADATA_NULL": {},
            "SYSERR_INVALID_OAUTH_LOGOUT_URI_HTTP_SCHEME": {},
            "SYSERR_LASSO_SERVER_ERROR_ADD_PROVIDER_FAILED": {},
            "SYSERR_LASSO_SERVER_ERROR_ADD_PROVIDER_PROTOCOL_MISMATCH": {},
            "SYSERR_LASSO_PARAMS_PROVIDERS_UNAVAILABLE": {},
            "SYSERR_JWTPROFILE_NULL": {},
            "SYSERR_JWTSERVER_PROFILE_NOT_FOUND": {},
            "SYSERR_AUTH_PROFILE_JWTSERVER_PROFILE_OBJECT_NULL": {},
            "SYSERR_JWT_NAME_NULL": {},
            "SYSERR_JWT_LOCATION_NULL": {},
            "SYSERR_JWT_VS_AUDIENCE_NULL": {},
            "SYSERR_SSO_JWT_VS_INFO_NULL": {},
            "SYSERR_SUB_CONFIG_FAILURE": {},
            "SYSERR_BIND_WAF_FAILURE": {},
            "SYSERR_PROXY_INIT_FAILURE": {},
            "SYSERR_GRPC_CONFIG_FAILURE": {},
            "SYSERR_BIND_POLICY_FAILURE": {},
            "SYSERR_BIND_PROFILE_FAILURE": {},
            "SYSERR_BIND_LUA_SCRIPT_FAILURE": {},
            "SYSERR_LUA_SCRIPT_SYNTAX": {},
            "SYSERR_MISSING_LDAP_VS_CONF": {},
            "SYSERR_SECPOL_RATE_LIMITER_HTTP_LOC_ERR": {},
            "SYSERR_BIND_CSRF_FAILURE": {},
            "SYSERR_COMPR_FLTR_UNKNOWN_LEVEL": {},
            "SYSERR_COMPR_MIME_TYPE_NOT_INITED": {},
            "SYSERR_IPADDRGRP_NOT_FOUND": {},
            "SYSERR_DUPLICATE_UPSTREAM": {},
            "SYSERR_UPSTREAM_COMPLEX_COMPILATION_FAILED": {},
            "SYSERR_UPSTREAM_INIT_NO_SERVERS": {},
            "SYSERR_UPSTREAM_INVALID_ADDRESS": {},
            "SYSERR_UPSTREAM_INVALID_HOST": {},
            "SYSERR_UPSTREAM_WITHOUT_PORT": {},
            "SYSERR_UPSTREAM_INVALID_PARAMETER": {},
            "SYSERR_UPSTREAM_INVALID_VALUE": {},
            "SYSERR_UPSTREAM_LB_NO_PEERS": {},
            "SYSERR_UPSTREAM_LB_NULL_CONF": {},
            "SYSERR_UPSTREAM_PARSE_URL_FAILED": {},
            "SYSERR_UPSTREAM_UNSUPPORTED_PARAMETER": {},
            "SYSERR_PAA_NO_OBJECT": {},
            "SYSERR_PAA_FILESYSTEM_CREATE_FAIL": {},
            "SYSERR_PAA_CACHE_CREATE_FAIL": {},
            "SYSERR_WAF_INIT_FAIL": {},
            "SYSERR_WAF_INIT_SIGNATURES_FAIL": {},
            "SYSERR_WAF_WHITELIST_INIT_FAIL": {},
            "SYSERR_WAF_PSM_INIT_FAIL": {},
            "SYSERR_WAF_INIT_APP_SIGNATURES_FAIL": {},
            "SYSERR_WAF_POSTPROCESS_SIGNATURES_FAIL": {},
            "SYSERR_WAF_ALLOWLIST_INIT_FAIL": {},
            "SYSERR_WAF_POLICY_INIT_FAIL": {},
            "SYSERR_WAF_INIT_CRS_OVERRIDE_FAIL": {},
            "SYSERR_WAF_INIT_INSUFFICIENT_APP_LEARNING_MEMORY": {},
            "SYSERR_BOT_INIT_FAIL": {},
            "SYSERR_BOT_ALLOWLIST_INIT_FAIL": {},
            "SYSERR_BOT_POLICY_NOT_FOUND": {},
            "SYSERR_BIND_BOT_FAILURE": {},
            "SYSERR_BOT_MAPPING_NOT_FOUND": {},
            "SYSERR_BOT_CONSOLIDATOR_NOT_FOUND": {},
            "SYSERR_APPLICATION_INSIGHTS_NOT_FOUND": {},
            "SYSERR_POLICY_HASH_REMOVE": {},
            "SYSERR_POLICY_V4_TREE_CREATION": {},
            "SYSERR_POLICY_V6_TREE_CREATION": {},
            "SYSERR_POLICY_APPLOG_PROV": {},
            "SYSERR_POLICY_CLIENT_IP_GROUP_UUID": {},
            "SYSERR_POLICY_PATH_MATCH_GROUP_UUID": {},
            "SYSERR_POLICY_QUERY_MATCH_GROUP_UUID": {},
            "SYSERR_POLICY_UNKOWN_MATCH_ACTION": {},
            "SYSERR_POLICY_INVALID_HDR_ACTIONS": {},
            "SYSERR_POLICY_RWH_COOKIE_OPER": {},
            "SYSERR_POLICY_HASH_INSERT": {},
            "SYSERR_SSL_CERT_NOT_PRESENT": {},
            "SYSERR_SSL_CERT_KEY_NOT_PRESENT": {},
            "SYSERR_SSL_CTX_CREATION_ERR": {},
            "SYSERR_SSL_CERT_READ_FAILURE": {},
            "SYSERR_SSL_CERT_LOAD_TO_CTX": {},
            "SYSERR_SSL_CERT_IDX_TO_CTX": {},
            "SYSERR_SSL_KEY_LOAD_TO_CTX": {},
            "SYSERR_SSL_CERT_CHAIN_READ_FAILURE": {},
            "SYSERR_SSL_CERT_CHAIN_ADD_FAILURE": {},
            "SYSERR_SSL_KEY_READ_FAILURE": {},
            "SYSERR_SSL_CERTIFICATE_AND_KEY_MISMATCH": {},
            "SYSERR_SSL_CIPHER_LIST_NOT_SET": {},
            "SYSERR_SSL_CIPHER_SUITES_NOT_SET": {},
            "SYSERR_SSL_PKI_CLIENT_CA": {},
            "SYSERR_SSL_DHPARAM_FAILURE": {},
            "SYSERR_SSL_ECDH_FAILURE": {},
            "SYSERR_SSL_HOSTMAP_FAILURE": {},
            "SYSERR_SSL_SESSION_CACHE_INIT": {},
            "SYSERR_SSL_SESSION_TIX_KEYS_INIT": {},
            "SYSERR_SSL_PKI_CRL": {},
            "SYSERR_PKI_PROFILE_CONFIG_NO_CA_CERT": {},
            "SYSERR_DUPLICATE_PKI_PROFILE": {},
            "SYSERR_SET_SSL_STAPLE_FAILURE": {},
            "SYSERR_ICAP_PROFILE_NOT_FOUND": {},
            "SYSERR_SSL_EVH_PARENT_NOT_FOUND": {},
            "SYSERR_SSL_MEMPOOL_NAME_LEN_EXCEEDED": {},
            "SYSERR_SSL_MEMPOOL_UUID_LEN_EXCEEDED": {},
            "SYSERR_CONFIG_OBJ_NAME_LEN_EXCEEDED": {},
            "SYSERR_SSL_EVH_PARENT_IN_FAULT_STATE": {},
            "SYSERR_SPL_OBJ_NAME_LEN_EXCEEDED": {},
            "SYSERR_SSL_PKI_CRL_FILEOBJECT_NOT_FOUND": {},
            "SYSERR_AUTH_MISSING_OAUTH_PROFILE": {},
            "SYSERR_OAUTH_MISSING_AUTHZ_EP": {},
            "SYSERR_OAUTH_MISSING_TOKEN_EP": {},
            "SYSERR_OAUTH_MISSING_INTROSPECTION_EP": {},
            "SYSERR_INVALID_JWT_PROFILE_OBJECT": {},
            "SYSERR_OAUTH_MISSING_POOL_OBJECT": {},
            "SYSERR_MISSING_OAUTH_VS_CONF": {},
            "SYSERR_OAUTH_MISSING_REDIRECT_URI": {},
            "SYSERR_OAUTH_MISSING_CLIENT_CREDENTIALS": {},
            "SYSERR_OAUTH_MISSING_RS_CREDENTIALS": {},
            "SYSERR_OAUTH_MISSING_ISSUER": {},
            "SYSERR_OAUTH_MISSING_USERINFO_EP": {},
            "SYSERR_CSRF_POLICY_NOT_FOUND": {},
            "SYSERR_CSRF_INIT_FAIL": {},
            "SYSERR_LIC_CONVERT_METERED_BANDWIDTH_NON_AZURE_FAILED": {},
            "SYSERR_LIC_RESERVE_LEDGER_METADATA_REQ_UNIDENTIFIED": {},
            "SYSERR_LIC_CONVERT_FORMULA_NOT_DEFINED": {},
            "SYSERR_LIC_CONVERT_MALFORMED_PAYLOAD": {},
            "SYSERR_FILE_CONTENT_DECODE_FAILED": {},
            "SYSERR_RETENTION_POLICY_ERR": {},
            "SYSERR_RETENTION_POLICY_SERVICE_UNAVAILABLE": {},
            "SYSERR_RETENTION_POLICY_INVALID_ACTION": {},
            "SYSERR_SVC_FAILURE": {},
            "SYSERR_SVC_SUCCESS": {},
            "SYSERR_PROTOBUF_MEM_CHUNK_SIZE_EXCEEDED": {},
            "SYSERR_REPORT_GENERATION_STARTED": {},
            "SYSERR_REPORT_GENERATION_FAILED": {},
            "SYSERR_CHECK_MIN_FREE_DISK_REQUIRED_REPORTING": {},
            "SYSERR_CHECK_MIN_FREE_DISK_REQUIRED_REPORTING_ERR": {},
            "SYSERR_CHECK_CLUSTER_REPORTING": {},
            "SYSERR_CHECK_CLUSTER_REPORTING_ERR": {},
            "SYSERR_CHECK_UPGRADE_IN_PROGRESS": {},
            "SYSERR_CHECK_UPGRADE_IN_PROGRESS_ERR": {},
            "SYSERR_CHECK_WAF_ENABLED_REPORTING": {},
            "SYSERR_CHECK_WAF_ENABLED_REPORTING_ERR": {},
            "SYSERR_CHECK_REPORT_SE_GROUP_VERSION": {},
            "SYSERR_CHECK_REPORT_LOWER_SE_GROUP_VERSION": {},
            "SYSERR_CHECK_REPORT_DATA_SAMPLES": {},
            "SYSERR_CHECK_REPORT_DATA_SAMPLES_ERR": {}
        },
        "ImageFsmState": {
            "IMAGE_FSM_STARTED": {
                "text": "Image upload started.",
                "description": "Indicates that image upload has started."
            },
            "IMAGE_FSM_IN_PROGRESS": {
                "text": "Image upload in progress.",
                "description": "Indicates that image upload is in progress."
            },
            "IMAGE_FSM_COMPLETED": {
                "text": "Image upload completed.",
                "description": "Indicates that image upload is completed."
            },
            "IMAGE_FSM_FAILED": {
                "text": "Image upload failed.",
                "description": "Indicates that image upload has failed."
            }
        },
        "IpamDnsType": {
            "IPAMDNS_TYPE_INFOBLOX": {
                "text": "Infoblox IPAM",
                "description": "Infoblox is the IPAM provider"
            },
            "IPAMDNS_TYPE_AWS": {
                "text": "AWS IPAM",
                "description": "AWS is the IPAM provider"
            },
            "IPAMDNS_TYPE_INFOBLOX_DNS": {
                "text": "Infoblox DNS",
                "description": "Infoblox is the DNS provider"
            },
            "IPAMDNS_TYPE_CUSTOM": {
                "text": "Custom IPAM",
                "description": "Customary backend IPAM provider like Men & Mice, British Telecom and any other provider with REST API."
            },
            "IPAMDNS_TYPE_CUSTOM_DNS": {
                "text": "Custom DNS",
                "description": "Customary backend DNS provider like Men & Mice, British Telecom and any other provider with REST API"
            },
            "IPAMDNS_TYPE_TENCENT": {
                "text": "Tencent IPAM",
                "description": "Tencent is the IPAM provider"
            },
            "IPAMDNS_TYPE_INTERNAL": {
                "text": "Avi IPAM",
                "description": "Avi is the IPAM provider"
            },
            "IPAMDNS_TYPE_INTERNAL_DNS": {
                "text": "Avi DNS",
                "description": "Avi is the DNS provider"
            },
            "IPAMDNS_TYPE_AWS_DNS": {
                "text": "AWS Route 53 DNS",
                "description": "AWS is the DNS provider"
            },
            "IPAMDNS_TYPE_AZURE_DNS": {
                "text": "Azure DNS",
                "description": "Azure is the DNS provider"
            }
        },
        "IPReputationVendor": {
            "IP_REPUTATION_VENDOR_WEBROOT": {
                "text": "Webroot",
                "description": "IP reputation information from Webroot."
            }
        },
        "JWTProfileType": {
            "CLIENT_AUTH": {
                "text": "JWT SERVER Profile for Client Auth",
                "description": "JWT Server Profile to be used for client authorization."
            },
            "CONTROLLER_INTERNAL_AUTH": {
                "text": "JWT Server profile for internal Controller communication use case using symmetric keys.",
                "description": "JWT Server Profile to be used for Controller to Controller communication using symmetric keys."
            }
        },
        "L4RuleActionSelectPoolType": {
            "L4_RULE_ACTION_SELECT_POOL": {
                "text": "Pool",
                "description": "Select a pool of servers to serve client connect request"
            },
            "L4_RULE_ACTION_SELECT_POOLGROUP": {
                "text": "Pool Group",
                "description": "Select a pool group to serve client connect request"
            }
        },
        "NatPolicyActionType": {
            "NAT_POLICY_ACTION_TYPE_DYNAMIC_IP_PORT": {
                "text": "Dynamic IP and Port",
                "description": "Nat both Source IP and Port"
            },
            "NAT_POLICY_ACTION_TYPE_DYNAMIC_IP_PRESERVE_PORT": {
                "text": "Dynamic IP and Preserve Port",
                "description": "Nat only Source IP and Preserve Port"
            }
        },
        "StaticIpType": {
            "STATIC_IPS_FOR_SE": {
                "text": "SE vNIC",
                "description": "Static IPs are used for Service Engine vNIC IP allocation only"
            },
            "STATIC_IPS_FOR_VIP": {
                "text": "VIP",
                "description": "Static IPs are used for VIP allocation only"
            },
            "STATIC_IPS_FOR_VIP_AND_SE": {
                "text": "VIP and SE vNIC",
                "description": "Static IPs are used for both VIP and Service Engine vNIC IP allocation"
            }
        },
        "ProtocolType": {
            "PROTOCOL_TYPE_TCP_PROXY": {
                "text": "TCP Proxy"
            },
            "PROTOCOL_TYPE_TCP_FAST_PATH": {
                "text": "TCP Fast Path"
            },
            "PROTOCOL_TYPE_UDP_FAST_PATH": {
                "text": "UDP Fast Path"
            },
            "PROTOCOL_TYPE_UDP_PROXY": {
                "text": "UDP Proxy"
            },
            "PROTOCOL_TYPE_SCTP_PROXY": {
                "text": "SCTP Proxy",
                "description": "SCTP Proxy."
            },
            "PROTOCOL_TYPE_SCTP_FAST_PATH": {
                "text": "SCTP Fast Path",
                "description": "SCTP Fast Path."
            }
        },
        "DsrType": {
            "DSR_TYPE_L2": {
                "description": "L2 Direct Server Return"
            },
            "DSR_TYPE_L3": {
                "description": "L3 Direct Server Return"
            }
        },
        "EncapType": {
            "ENCAP_IPINIP": {
                "text": "Encapsulation type IP-in-IP.",
                "description": "Encapsulation type IP-in-IP"
            },
            "ENCAP_GRE": {
                "text": "Encapsulation type GRE.",
                "description": "Encapsulation type GRE."
            }
        },
        "IdleConnectionType": {
            "KEEP_ALIVE": {},
            "CLOSE_IDLE": {}
        },
        "CongestionAlgo": {
            "CC_ALGO_NEW_RENO": {},
            "CC_ALGO_CUBIC": {},
            "CC_ALGO_HTCP": {}
        },
        "NetworkSecurityPolicyActionType": {
            "NETWORK_SECURITY_POLICY_ACTION_TYPE_ALLOW": {},
            "NETWORK_SECURITY_POLICY_ACTION_TYPE_DENY": {},
            "NETWORK_SECURITY_POLICY_ACTION_TYPE_RATE_LIMIT": {}
        },
        "OsLbProvOpType": {
            "POT_GET": {
                "description": "All configured LBaaS provider plugins"
            },
            "POT_POST": {
                "description": "Create new LBaaS provider plugin"
            },
            "POT_PUT": {
                "description": "Update existing LBaaS provider plugin"
            },
            "POT_DELETE": {
                "description": "Delete existing LBaaS provider plugin"
            }
        },
        "AllowedPKIErrors": {
            "ALLOW_EXPIRED_CRL": {
                "text": "ALLOW EXPIRED CRL.",
                "description": "Allow expired CRL error during mutual auth."
            },
            "ALLOW_ALL_ERRORS": {
                "text": "ALLOW ALL ERRORS.",
                "description": "Allow all errors during mutual auth."
            }
        },
        "LbAlgorithm": {
            "LB_ALGORITHM_LEAST_CONNECTIONS": {
                "description": "Direct traffic to the servers with the fewest concurrent connections."
            },
            "LB_ALGORITHM_ROUND_ROBIN": {
                "description": "Direct traffic by linearly cycling through the list of available servers."
            },
            "LB_ALGORITHM_FASTEST_RESPONSE": {
                "description": "Direct traffic to servers with the fastest response time."
            },
            "LB_ALGORITHM_CONSISTENT_HASH": {
                "description": "Use a consistent hash to load balance and persist based on the chosen hash key."
            },
            "LB_ALGORITHM_LEAST_LOAD": {
                "description": "Direct traffic to the servers with the least load."
            },
            "LB_ALGORITHM_FEWEST_SERVERS": {
                "description": "Direct traffic to the fewest servers."
            },
            "LB_ALGORITHM_CORE_AFFINITY": {
                "description": "Direct traffic to a subset of servers on a core."
            },
            "LB_ALGORITHM_TOPOLOGY": {
                "description": "Direct traffic to the best server based on the topology policy."
            }
        },
        "LbAlgorithmConsistentHash": {
            "LB_ALGORITHM_CONSISTENT_HASH_SOURCE_IP_ADDRESS": {
                "description": "Hash based on the client source IP Address."
            },
            "LB_ALGORITHM_CONSISTENT_HASH_SOURCE_IP_ADDRESS_AND_PORT": {
                "description": "Hash based on the client source IP Address and port."
            },
            "LB_ALGORITHM_CONSISTENT_HASH_URI": {
                "description": "Hash based on the URI path."
            },
            "LB_ALGORITHM_CONSISTENT_HASH_CUSTOM_HEADER": {
                "description": "Hash based on a custom HTTP header."
            },
            "LB_ALGORITHM_CONSISTENT_HASH_CUSTOM_STRING": {
                "description": "Hash based on a custom string."
            },
            "LB_ALGORITHM_CONSISTENT_HASH_CALLID": {
                "description": "Hash based on CallId."
            }
        },
        "AppendPortEnum": {
            "NON_DEFAULT_80_443": {
                "text": "Append port to hostname in the host header, if the port is not 80 or 443.",
                "description": "Append port to hostname in the host header, if the port is not 80 or 443."
            },
            "NEVER": {
                "text": "Never include port to the hostname in the host header.",
                "description": "Never include port to the hostname in the host header."
            },
            "ALWAYS": {
                "text": "Always append port to the hostname in the host header.",
                "description": "Always append port to the hostname in the host header."
            }
        },
        "ServerDisableType": {
            "DISALLOW_NEW_CONNECTION": {
                "text": "Allows existing connections to time out according to gracefull disable timeout, but no new connections are allowed.",
                "description": "Allows existing connections to time out according to gracefull disable timeout, but no new connections are allowed."
            },
            "ALLOW_NEW_CONNECTION_IF_PERSISTENCE_PRESENT": {
                "text": "Accept new connections only if a persistence entry is present until persistence entry times out. Disallow new connections without a matching persistence entry.",
                "description": "Accept new connections only if a persistence entry is present until persistence entry times out. Disallow new connections without a matching persistence entry."
            }
        },
        "PoolType": {
            "POOL_TYPE_GENERIC_APP": {
                "text": "Generic Application",
                "description": "The Pool is used for Generic Applications."
            },
            "POOL_TYPE_OAUTH": {
                "text": "OAuth",
                "description": "The Pool is used for configuring Oauth Endpoint Servers."
            }
        },
        "HttpReselectRespCodeBlock": {
            "HTTP_RSP_4XX": {
                "text": "4XX"
            },
            "HTTP_RSP_5XX": {
                "text": "5XX"
            }
        },
        "FailActionEnum": {
            "FAIL_ACTION_HTTP_REDIRECT": {
                "description": "Send HTTP redirect when pool experiences a failure"
            },
            "FAIL_ACTION_HTTP_LOCAL_RSP": {
                "description": "Send HTTP local response when pool experiences a failure"
            },
            "FAIL_ACTION_CLOSE_CONN": {
                "description": "Close Tcp connection when pool experiences a failure"
            }
        },
        "PoolDeploymentState": {
            "EVALUATION_IN_PROGRESS": {
                "description": "Pool is under evaluation. Once the evaluation is over it will be transitioned to either ACTIVE, DISABLED, or EVALUATION FAILED state"
            },
            "IN_SERVICE": {
                "description": "Pool passed the evaluation. It is actively placed in service with ratio 100"
            },
            "OUT_OF_SERVICE": {
                "description": "Pool had previously passed the evaluation. But it is out of service as its traffic ratio is 0"
            },
            "EVALUATION_FAILED": {
                "description": "Pool failed its evaluation. Its traffic ratio is set to zero."
            }
        },
        "PoolGroupDeploymentScheme": {
            "BLUE_GREEN": {
                "description": "Blue-Green based deployment option. In this caseonly one pool is considered the main pool and it has ratio of 100 All other pools will have ratio of 0 if they have been evaluated for deployment and found not fit. Pools that are  under observation will have ratio between 1-99 as autoscale mgr completes the evaluation"
            },
            "CANARY": {
                "description": "Canary based deployment option. In this caseonly one pool is considered the main pool and it has ratio of 100 All other pools will have ratio of 0 if they have been evaluated for deployment and found not fit. Pools that are  under observation will have ratio between 1-99 as autoscale mgr completes the evaluation"
            }
        },
        "ComparisonOperator": {
            "CO_EQ": {},
            "CO_GT": {},
            "CO_GE": {},
            "CO_LT": {},
            "CO_LE": {},
            "CO_NE": {}
        },
        "ReportPeriod": {
            "REPORT_PERIOD_LAST_24_HOURS": {
                "text": "Last 24 hours.",
                "description": "Last 24 hours."
            },
            "REPORT_PERIOD_LAST_7_DAYS": {
                "text": "Last 7 days.",
                "description": "Last 7 days."
            },
            "REPORT_PERIOD_LAST_30_DAYS": {
                "text": "Last 30 days.",
                "description": "Last 30 days."
            }
        },
        "PreCheckFsmState": {
            "PRECHECK_FSM_STARTED": {
                "text": "Pre-check operations request accepted.",
                "description": "Pre-check operations request accepted."
            },
            "PRECHECK_FSM_IN_PROGRESS": {
                "text": "Pre-check operations request in progress.",
                "description": "Pre-check operations request in progress."
            },
            "PRECHECK_FSM_SUCCESS": {
                "text": "Pre-check operations completed successfully.",
                "description": "Pre-check operations completed successfully."
            },
            "PRECHECK_FSM_WARNING": {
                "text": "Pre-check operations completed with warnings.",
                "description": "Pre-check operations completed with warnings."
            },
            "PRECHECK_FSM_ERROR": {
                "text": "Pre-check operations is in error.",
                "description": "Pre-check operations is in error."
            }
        },
        "ReportFsmState": {
            "REPORT_FSM_STARTED": {
                "text": "Report generation started.",
                "description": "Report generation started."
            },
            "REPORT_FSM_IN_PROGRESS": {
                "text": "Report generation in progress.",
                "description": "Report generation in progress."
            },
            "REPORT_FSM_COMPLETED": {
                "text": "Report generation completed.",
                "description": "Report generation completed."
            },
            "REPORT_FSM_FAILED": {
                "text": "Report generation failed.",
                "description": "Report generation failed."
            }
        },
        "AviPermissionResource": {
            "PERMISSION_CONTROLLER": {
                "text": "System"
            },
            "PERMISSION_INTERNAL": {
                "text": "Internal"
            },
            "PERMISSION_VIRTUALSERVICE": {
                "text": "Virtual Service"
            },
            "PERMISSION_POOL": {
                "text": "Pool"
            },
            "PERMISSION_HEALTHMONITOR": {
                "text": "Health Monitor"
            },
            "PERMISSION_NETWORKPROFILE": {
                "text": "Network Profile"
            },
            "PERMISSION_APPLICATIONPROFILE": {
                "text": "Application Profile"
            },
            "PERMISSION_HTTPPOLICYSET": {
                "text": "HTTP Policy Set"
            },
            "PERMISSION_IPADDRGROUP": {
                "text": "IP Address Group"
            },
            "PERMISSION_STRINGGROUP": {
                "text": "String Group"
            },
            "PERMISSION_SSLPROFILE": {
                "text": "SSL Profile"
            },
            "PERMISSION_SSLKEYANDCERTIFICATE": {
                "text": "SSL Key And Certificate"
            },
            "PERMISSION_NETWORKSECURITYPOLICY": {
                "text": "Network Security Policy"
            },
            "PERMISSION_APPLICATIONPERSISTENCEPROFILE": {
                "text": "Application Persistence Profile"
            },
            "PERMISSION_ANALYTICSPROFILE": {
                "text": "Analytics Profile"
            },
            "PERMISSION_VSDATASCRIPTSET": {
                "text": "VS Data Script Set"
            },
            "PERMISSION_TENANT": {
                "text": "Tenant"
            },
            "PERMISSION_PKIPROFILE": {
                "text": "PKI Profile"
            },
            "PERMISSION_AUTHPROFILE": {
                "text": "Auth Profile"
            },
            "PERMISSION_CLOUD": {
                "text": "Cloud"
            },
            "PERMISSION_SERVICEENGINE": {
                "text": "Service Engine"
            },
            "PERMISSION_SERVICEENGINEGROUP": {
                "text": "Service Engine Group"
            },
            "PERMISSION_NETWORK": {
                "text": "Network"
            },
            "PERMISSION_SYSTEMCONFIGURATION": {
                "text": "System Configuration"
            },
            "PERMISSION_VRFCONTEXT": {
                "text": "VRF Context"
            },
            "PERMISSION_USER": {
                "text": "User"
            },
            "PERMISSION_ROLE": {
                "text": "Role"
            },
            "PERMISSION_ALERT": {
                "text": "Alert"
            },
            "PERMISSION_ALERTCONFIG": {
                "text": "Alert Config"
            },
            "PERMISSION_ALERTEMAILCONFIG": {
                "text": "Alert Email Config"
            },
            "PERMISSION_ALERTSYSLOGCONFIG": {
                "text": "Alert Syslog Config"
            },
            "PERMISSION_ACTIONGROUPCONFIG": {
                "text": "Action Group Config"
            },
            "PERMISSION_SNMPTRAPPROFILE": {
                "text": "SNMP Trap Profile"
            },
            "PERMISSION_UPGRADE": {
                "text": "Upgrade"
            },
            "PERMISSION_REBOOT": {
                "text": "Reboot"
            },
            "PERMISSION_TECHSUPPORT": {
                "text": "Techsupport"
            },
            "PERMISSION_EXEMPT": {
                "text": "No Permission Check"
            },
            "PERMISSION_TRAFFIC_CAPTURE": {
                "text": "Traffic Capture"
            },
            "PERMISSION_MICROSERVICEGROUP": {
                "text": "MicroService Group"
            },
            "PERMISSION_IPAMDNSPROVIDERPROFILE": {
                "text": "IPAM DNS Provider Profile"
            },
            "PERMISSION_CERTIFICATEMANAGEMENTPROFILE": {
                "text": "Certificate management profile"
            },
            "PERMISSION_POOLGROUP": {
                "text": "Pool Group"
            },
            "PERMISSION_PRIORITYLABELS": {
                "text": "Priority Labels"
            },
            "PERMISSION_POOLGROUPDEPLOYMENTPOLICY": {
                "text": "Pool Group Deployment Policy"
            },
            "PERMISSION_GSLB": {
                "text": "Gslb"
            },
            "PERMISSION_GSLBSERVICE": {
                "text": "Gslb Service"
            },
            "PERMISSION_GSLBGEODBPROFILE": {
                "text": "Gslb GeoDb Profile"
            },
            "PERMISSION_DNSPOLICY": {
                "text": "DNS Policy"
            },
            "PERMISSION_TRAFFICCLONEPROFILE": {
                "text": "Traffic Clone Profile"
            },
            "PERMISSION_SE_TOKEN": {
                "text": "Cloud SE token"
            },
            "PERMISSION_WAFPOLICY": {
                "text": "WAF Policy"
            },
            "PERMISSION_WAFPROFILE": {
                "text": "WAF Profile"
            },
            "PERMISSION_USER_CREDENTIAL": {
                "text": "User Credential"
            },
            "PERMISSION_AUTOSCALE": {
                "text": "AutoScale"
            },
            "PERMISSION_CUSTOMIPAMDNSPROFILE": {
                "text": "Custom IPAM DNS Profile"
            },
            "PERMISSION_ERRORPAGEPROFILE": {
                "text": "Error Page Profile"
            },
            "PERMISSION_ERRORPAGEBODY": {
                "text": "Error Page Body"
            },
            "PERMISSION_L4POLICYSET": {
                "text": "L4 Policy Set"
            },
            "PERMISSION_MICROSERVICE": {
                "text": "MicroService"
            },
            "PERMISSION_HARDWARESECURITYMODULEGROUP": {
                "text": "Hardware Security Module Group"
            },
            "PERMISSION_SECURITYPOLICY": {
                "text": "SECURITY Policy"
            },
            "PERMISSION_WAFPOLICYPSMGROUP": {
                "text": "WafPolicy PSM Group",
                "description": "Permission for WafPolicy PSM Group."
            },
            "PERMISSION_NETWORKSERVICE": {
                "text": "Network Service"
            },
            "PERMISSION_NATPOLICY": {
                "text": "Nat Policy"
            },
            "PERMISSION_PROTOCOLPARSER": {
                "text": "Protocol Parser",
                "description": "Permission for Protocol Parser."
            },
            "PERMISSION_SSOPOLICY": {
                "text": "SSO Policy",
                "description": "Permission for SSO Policy."
            },
            "PERMISSION_CONTROLLERSITE": {
                "text": "Controller Site",
                "description": "Permissions for ControllerSite"
            },
            "PERMISSION_IMAGE": {
                "text": "Image upload Operations",
                "description": "Permissions for Image upload operations. "
            },
            "PERMISSION_UPGRADE_OPS": {
                "text": "Upgrade Operations @ system level",
                "description": "Permissions for Upgrade operations such as Upgrade, Patch and Rollback applied to controller and se-groups."
            },
            "PERMISSION_UPGRADE_SEGROUP_OPS": {
                "text": "Upgrade Operations @ se group level",
                "description": "Permissions for Upgrade operations such as Upgrade, Patch and Rollback applied to se-groups."
            },
            "PERMISSION_TESTSEDATASTORELEVEL1": {
                "text": "Test SE Datastore Level 1"
            },
            "PERMISSION_TESTSEDATASTORELEVEL2": {
                "text": "Test SE Datastore Level 2"
            },
            "PERMISSION_TESTSEDATASTORELEVEL3": {
                "text": "Test SE Datastore Level 3"
            },
            "PERMISSION_FILE_OBJECT": {
                "text": "Uploaded files",
                "description": "Permissions for accessing File Objects/Files"
            },
            "PERMISSION_IPREPUTATIONDB": {
                "text": "IP reputation DB",
                "description": "Permissions for accessing IP reputation DB."
            },
            "PERMISSION_ICAP": {
                "text": "ICAP configuration",
                "description": "Permission for ICAP configuration."
            },
            "PERMISSION_GSLBSERVICE_GROUP": {
                "text": "Gslb Service Group",
                "description": "Permission to enable/disable GslbServicePool or PoolMembers."
            },
            "PERMISSION_JWTSERVERPROFILE": {
                "text": "JWT Server profile configuration",
                "description": "Permission for JWT Server profile configuration."
            },
            "PERMISSION_GEODB": {
                "text": "Geo DB",
                "description": "Permissions for accessing Geo DB."
            },
            "PERMISSION_BOTDETECTIONPOLICY": {
                "text": "Bot Detection Policy configuration",
                "description": "Permission for BotDetectionPolicy configuration."
            },
            "PERMISSION_LABELGROUP": {
                "text": "Label Group",
                "description": "Permission for Label Group."
            },
            "PERMISSION_WAFCRS": {
                "text": "WAF CRS"
            },
            "PERMISSION_AUTHMAPPINGPROFILE": {
                "text": "Auth Mapping Profile",
                "description": "Permission for AuthMappingProfile configuration."
            },
            "PERMISSION_ALBSERVICESCONFIG": {
                "text": "ALB Services Configuration",
                "description": "Permission for accessing albservicesconfig DB object."
            },
            "PERMISSION_ALBSERVICESSTATUS": {
                "text": "ALB Cloud Services status",
                "description": "Permission for accessing ALB cloud services connectivity and registration status."
            },
            "PERMISSION_ALBSERVICESREG": {
                "text": "ALB Cloud Services registration",
                "description": "Permission for registering controller with ALB cloud services."
            },
            "PERMISSION_LICENSING": {
                "text": "Controller licensing",
                "description": "Permission to access controller licensing information."
            },
            "PERMISSION_ALBSERVICESUSERINFO": {
                "text": "ALB Cloud Services user info",
                "description": "Permission to access user info/details of ALB Cloud Services user."
            },
            "PERMISSION_TENANT_SYSTEM_CONFIGURATION": {
                "text": "Tenant System Configuration",
                "description": "Permission for TenantSystemConfiguration object."
            },
            "PERMISSION_CSRFPOLICY": {
                "text": "CSRF Policy",
                "description": "Permission for CSRFPolicy Configuration."
            },
            "PERMISSION_SERVICEAUTHPROFILE": {
                "text": "Service Auth Profile",
                "description": "Permission for ServiceAuthProfile configuration."
            },
            "PERMISSION_SYSTEMREPORT": {
                "text": "System Report",
                "description": "Permission for accessing System Report."
            },
            "PERMISSION_CLOUD_API": {
                "text": "Cloud APIs",
                "description": "Permission for accessing objects from cloud while creating Virtual Services, Pools etc."
            },
            "PERMISSION_TASKJOURNAL": {
                "text": "Task journal",
                "description": "Permission for accessing Task Journal."
            },
            "PERMISSION_TELEMETRY_API": {
                "text": "Telemetry APIs.",
                "description": "Permission for accessing objects from Telemetry service."
            },
            "PERMISSION_UPGRADEPROFILE": {
                "text": "Upgrade Profile",
                "description": "Permission for accessing Upgrade Profile."
            },
            "PERMISSION_RETENTIONPOLICY": {
                "text": "Retention Policy",
                "description": "Permission for accessing Retention Policy."
            },
            "PERMISSION_APIRATELIMITPROFILE": {
                "text": "Api Rate Limit Profile",
                "description": "Permission for accessing Api Rate Limit Profile."
            },
            "PERMISSION_TECHSUPPORTPROFILE": {
                "text": "TechSupport Profile",
                "description": "Permission for accessing Techsupport profile."
            },
            "PERMISSION_TECHSUPPORTMESSAGE": {
                "text": "TechSupport message",
                "description": "Permission for accessing Techsupport message."
            },
            "PERMISSION_ALERTSCRIPTCONFIG": {
                "text": "Alert Script Config",
                "description": "Permission for accessing Alert Script Config."
            },
            "PERMISSION_REPORT": {
                "text": "Report",
                "description": "Permission for accessing Report."
            },
            "PERMISSION_REPORTPROFILE": {
                "text": "Report Profile",
                "description": "Permission for accessing Report Profile."
            },
            "PERMISSION_APPLICATIONINSIGHTSPOLICY": {
                "text": "Application Insights Policy",
                "description": "Permission for accessing Application Insights Policy."
            },
            "PERMISSION_POSITIVESECURITYPOLICY": {
                "text": "Positive Security Policy",
                "description": "Permission for accessing Positive Security Policy."
            },
            "PERMISSION_TENANTBINDING": {
                "text": "Tenant Binding",
                "description": "Permission for accessing tenant binding."
            }
        },
        "AviPermissionSubResource": {
            "SUBRESOURCE_POOL_ENABLED": {
                "text": "Pool Enabled",
                "description": "Allows users to enable/disable the Pool objects"
            },
            "SUBRESOURCE_POOL_SERVERS": {
                "text": "Pool Servers",
                "description": "Allows users to add/update/remove Pool servers"
            },
            "SUBRESOURCE_POOL_SERVER_ENABLED": {
                "text": "Pool Server Enabled",
                "description": "Allows users to enable/disable pool servers"
            },
            "SUBRESOURCE_VIRTUALSERVICE_ENABLED": {
                "text": "Virtual Service Enabled",
                "description": "Allows users to enable/disable VirtualServices"
            },
            "SUBRESOURCE_VIRTUALSERVICE_AUTO_ALLOCATE_FLOATING_IP": {
                "text": "VsVip auto_allocate_floating_ip",
                "description": "Allows users to auto-allocate floating/elastic IP from the Cloud infrastructure."
            },
            "SUBRESOURCE_GSLBSERVICE_ENABLED": {
                "text": "Gslb Service Enabled",
                "description": "Allows users to enable/disable GslbService objects"
            },
            "SUBRESOURCE_GSLBSERVICE_GROUPS": {
                "text": "Gslb Service Groups",
                "description": "Allows users to update GslbService groups"
            },
            "SUBRESOURCE_GSLBSERVICE_GROUP_ENABLED": {
                "text": "Gslb Service Group Enabled",
                "description": "Allows users to enable/disable GslbService groups"
            },
            "SUBRESOURCE_GSLBSERVICE_GROUP_MEMBERS": {
                "text": "Gslb Service Group Members",
                "description": "Allows users to update GslbService group members"
            },
            "SUBRESOURCE_GSLBSERVICE_GROUP_MEMBER_ENABLED": {
                "text": "Gslb Service Group Member Enabled",
                "description": "Allows users to enable/disable GslbService group members"
            }
        },
        "SchedulerRunMode": {
            "RUN_MODE_PERIODIC": {
                "text": "Periodic Scheduler"
            },
            "RUN_MODE_AT": {
                "text": "One Time Scheduler"
            },
            "RUN_MODE_NOW": {
                "text": "Schedule Now"
            }
        },
        "SchedulerFrequencyUnit": {
            "SCHEDULER_FREQUENCY_UNIT_MIN": {
                "text": "Minute(s)"
            },
            "SCHEDULER_FREQUENCY_UNIT_HOUR": {
                "text": "Hour(s)"
            },
            "SCHEDULER_FREQUENCY_UNIT_DAY": {
                "text": "Day(s)"
            },
            "SCHEDULER_FREQUENCY_UNIT_WEEK": {
                "text": "Week(s)"
            },
            "SCHEDULER_FREQUENCY_UNIT_MONTH": {
                "text": "Month(s)"
            }
        },
        "SchedulerAction": {
            "SCHEDULER_ACTION_RUN_A_SCRIPT": {
                "text": "A script is executed when the scheduler is triggered"
            },
            "SCHEDULER_ACTION_BACKUP": {
                "text": "Backup is taken when the scheduler is triggered "
            }
        },
        "OperationMode": {
            "DETECTION": {
                "description": "Perform detection of the various attacks on the Virtual Service."
            },
            "MITIGATION": {
                "description": "Perform detection and mitigation of the various attacks on the Virtual Service."
            }
        },
        "SeGroupErrorRecovery": {
            "ROLLBACK_UPGRADE_OPS_ON_ERROR": {
                "description": "Whenever an SE in a SE group hits an error during the upgrade operations, then the upgrade operation is stopped. Automatic rollback is initiated to recover from the errors. "
            },
            "SUSPEND_UPGRADE_OPS_ON_ERROR": {
                "description": "Whenever an SE in a SE group hits an error during the upgrade operations, then the upgrade operation is stopped. User will have to correct the error and resume the upgrade operations. "
            },
            "CONTINUE_UPGRADE_OPS_ON_ERROR": {
                "description": "Whenever an SE in a SE group hits an error during the upgrade operations, then the upgrade operation continues to completion. "
            }
        },
        "Hypervisor": {
            "DEFAULT": {},
            "VMWARE_ESX": {
                "text": "VMWARE_ESX",
                "description": "VMware ESX Hypervisor"
            },
            "KVM": {
                "text": "KVM",
                "description": "KVM Hypervisor"
            },
            "VMWARE_VSAN": {
                "text": "VMWARE_VSAN",
                "description": "VMware ESX Hypervisor with VSAN"
            },
            "XEN": {
                "text": "Xen",
                "description": "Xen Hypervisor"
            }
        },
        "ServiceEngineEnableState": {
            "SE_STATE_ENABLED": {
                "description": "New Virtual services can be placed"
            },
            "SE_STATE_DISABLED_FOR_PLACEMENT": {
                "description": "New Virtual services cannot be placed"
            },
            "SE_STATE_DISABLED": {
                "description": "New Virtual services cannot be placed and existing ones would be migrated"
            },
            "SE_STATE_DISABLED_FORCE": {
                "description": "New Virtual services cannot be placed and existing ones would be migrated or scaled in. Any left over Virtual Services would be forcefully removed from the SE."
            },
            "SE_STATE_DISABLED_WITH_SCALEIN": {
                "description": "New Virtual services cannot be placed and existing ones would be scaled in."
            },
            "SE_STATE_DISABLED_NO_TRAFFIC": {
                "description": "New Virtual services cannot be placed and existing ones would be scaled in."
            },
            "SE_STATE_DISABLED_FORCE_WITH_MIGRATE": {
                "description": "New Virtual services cannot be placed and existing ones would be migrated. Any VIPs which cannot be migrated will be forcibly removed from the SE."
            }
        },
        "ContainerType": {
            "CONTAINER_TYPE_BRIDGE": {},
            "CONTAINER_TYPE_HOST": {},
            "CONTAINER_TYPE_HOST_DPDK": {}
        },
        "ServiceEngineQATMode": {
            "QAT_OFF": {
                "description": "QAT unavailable."
            },
            "QAT_SW_ACCELERATION": {
                "description": "QAT using software acceleration on CPU."
            },
            "QAT_HW_OFFLOAD": {
                "description": "QAT using hardware offload on QAT co-processors."
            }
        },
        "ServiceEngineQATOperMode": {
            "QAT_OPER_MODE_LEGACY": {
                "description": "QAT using legacy mode."
            },
            "QAT_OPER_MODE_PERF": {
                "description": "QAT using performance mode."
            },
            "QAT_OPER_MODE_UNKNOWN": {
                "description": "Unknown."
            }
        },
        "VcenterDatastoreMode": {
            "VCENTER_DATASTORE_ANY": {},
            "VCENTER_DATASTORE_LOCAL": {},
            "VCENTER_DATASTORE_SHARED": {}
        },
        "HaMode": {
            "HA_MODE_SHARED_PAIR": {
                "text": "Shared Pair"
            },
            "HA_MODE_SHARED": {
                "text": "Shared"
            },
            "HA_MODE_LEGACY_ACTIVE_STANDBY": {
                "text": "Legacy Active Standby"
            }
        },
        "PlacementAlgorithm": {
            "PLACEMENT_ALGO_PACKED": {},
            "PLACEMENT_ALGO_DISTRIBUTED": {}
        },
        "PlacementMode": {
            "PLACEMENT_MODE_AUTO": {}
        },
        "AutoRebalanceCriterion": {
            "SE_AUTO_REBALANCE_CPU": {},
            "SE_AUTO_REBALANCE_PPS": {},
            "SE_AUTO_REBALANCE_MBPS": {},
            "SE_AUTO_REBALANCE_OPEN_CONNS": {},
            "SE_AUTO_REBALANCE_CPS": {}
        },
        "SecurityGroupIngressAccess": {
            "SG_INGRESS_ACCESS_NONE": {
                "text": "No ingress access",
                "description": "No ingress access."
            },
            "SG_INGRESS_ACCESS_ALL": {
                "text": "Ingress access from 0/0",
                "description": "Ingress access from 0/0."
            },
            "SG_INGRESS_ACCESS_VPC": {
                "text": "Ingress access from VPC CIDR (only on Clouds that support VPC construct)",
                "description": "Ingress access from VPC CIDR (only on Clouds that support VPC construct)."
            }
        },
        "SEBandwidthType": {
            "SE_BANDWIDTH_UNLIMITED": {
                "text": "SE Bandwidth Unlimited",
                "description": "SE with Unlimited Bandwidth."
            },
            "SE_BANDWIDTH_25M": {
                "text": "SE Bandwidth 25 Mbps",
                "description": "SE with 25 Mbps Bandwidth."
            },
            "SE_BANDWIDTH_200M": {
                "text": "SE Bandwidth 200 Mbps",
                "description": "SE with 200 Mbps Bandwidth."
            }
        },
        "PcapTxMode": {
            "PCAP_TX_AUTO": {
                "description": "Automatically determine transmit mode of either socket or tx_ring based on SE resources."
            },
            "PCAP_TX_SOCKET": {
                "description": "PCAP_TX_SOCKET: Use socket mode."
            },
            "PCAP_TX_RING": {
                "description": "PCAP_TX_RING: Use transmit ring mode."
            }
        },
        "SeCpuHtMode": {
            "SE_CPU_HT_AUTO": {
                "text": "Default mode.",
                "description": "SE automatically determines the best placement. This mode preserves existing behavior in accordance with CPU hyper-threading topology. If the number of data path processes is less than the number of CPUs, this is equivalent to sparse proxy priority mode. For more details, please refer to the SE-Placement KB."
            },
            "SE_CPU_HT_SPARSE_DISPATCHER_PRIORITY": {
                "text": "Sparse mode for dispatcher cores.",
                "description": "This setting provides more priority to dispatcher cores by attempting to place only one data-path process in the physical CPU. Useful when the number of data path processes is less than the number of CPUs. Starts exhausting physical cores and then hyper-threads in numerically descending order of CPU number. For more details, please refer to the SE-Placement KB."
            },
            "SE_CPU_HT_SPARSE_PROXY_PRIORITY": {
                "text": "Sparse mode for proxy cores.",
                "description": "This setting provides more priority to proxy (non-dispatcher) cores by attempting to place only one data-path process in the physical CPU. Useful when the number of data path processes is less than the number of CPUs. Starts exhausting physical cores and then hyper-threads in numerically ascending order of CPU number. For more details, please refer to the SE-Placement KB."
            },
            "SE_CPU_HT_PACKED_CORES": {
                "text": "Dense mode.",
                "description": "This setting places dispatcher siblings on the same physical CPU. Each CPU can have two dispatchers or two proxy cores being adjacent to each other. Useful when the number of data path processes is less than the number of CPUs. Starts exhausting hyper-threads serially on each core before moving on to the next physical core. For more details, please refer to the SE-Placement KB."
            }
        },
        "SeGroupObjsyncMode": {
            "OBJSYNC_DISABLED": {
                "text": "Disabled",
                "description": "Disables SE-SE object syncing."
            },
            "OBJSYNC_ENABLED": {
                "text": "Enabled",
                "description": "Enables SE-SE object syncing."
            },
            "OBJSYNC_AUTO": {
                "text": "Auto",
                "description": "If set, it will automatically change to 1(enable) if SE group is on 31.2.1 or higher."
            }
        },
        "SeQatHugePageMemPerProcess": {
            "QAT_HPAGE_MEM_8MB": {
                "text": "8 MB QAT Hugepage Memory",
                "description": "QAT Hugepage memory reservation of 8MB."
            },
            "QAT_HPAGE_MEM_16MB": {
                "text": "16 MB QAT Hugepage Memory",
                "description": "QAT Hugepage memory reservation of 16MB."
            },
            "QAT_HPAGE_MEM_32MB": {
                "text": "32 MB QAT Hugepage Memory",
                "description": "QAT Hugepage memory reservation of 32MB."
            }
        },
        "SETTAuditMode": {
            "SE_TT_AUDIT_OFF": {
                "text": "Turn Off.",
                "description": "Turn off Time Tracker."
            },
            "SE_TT_AUDIT_ON": {
                "text": "Turn On.",
                "description": "Turn on Time Tracker. Only audit counters are updated, events are suppressed."
            },
            "SE_TT_AUDIT_ON_WITH_EVENT": {
                "text": "Turn on with event gen.",
                "description": "Turn on Time Tracker, audit counters are updated, cumulative events are generated if configured threshold is breached."
            }
        },
        "KniTransportProtocol": {
            "KNI_PROTO_TCP": {
                "text": "TCP",
                "description": "TCP Protocol."
            },
            "KNI_PROTO_UDP": {
                "text": "UDP",
                "description": "UDP Protocol."
            }
        },
        "MetricsEventThresholdType": {
            "THRESHOLD_TYPE_STATIC": {
                "text": "Threshold_type_static is the default metrics event type threshold for all MetricsRule objects.",
                "description": "This value denotes static threshold type for metrics rules."
            },
            "SE_CPU_THRESHOLD": {
                "text": "SE cpu usage threshold",
                "description": "This value denotes dynamic threshold type for metrics rules for ServiceEngine CPU usage."
            },
            "SE_MEM_THRESHOLD": {
                "text": "SE memory usage threshold",
                "description": "This value denotes dynamic threshold type for metrics rules for ServiceEngine Memory usage."
            },
            "SE_DISK_THRESHOLD": {
                "text": "SE disk usage threshold",
                "description": "This value denotes dynamic threshold type for metrics rules for ServiceEngine Disk usage."
            },
            "CONTROLLER_CPU_THRESHOLD": {
                "text": "Controller CPU usage threshold",
                "description": "This value denotes dynamic threshold type for metrics rules for Controller CPU usage."
            },
            "CONTROLLER_MEM_THRESHOLD": {
                "text": "Controller memory usage threshold",
                "description": "This value denotes dynamic threshold type for metrics rules for Controller Memory usage."
            },
            "CONTROLLER_DISK_THRESHOLD": {
                "text": "Controller disk usage threshold",
                "description": "This value denotes dynamic threshold type for metrics rules for Controller Disk usage."
            },
            "SE_SHM_MEM_THRESHOLD": {
                "text": "SE shared memory usage threshold",
                "description": "This value denotes dynamic threshold type for metrics rules for ServiceEngine shared memory usage."
            },
            "SE_CONN_MEM_THRESHOLD": {
                "text": "SE connection memory usage threshold",
                "description": "This value denotes dynamic threshold type for metrics rules for ServiceEngine connection memory usage."
            }
        },
        "IptableRuleProtocol": {
            "PROTO_TCP": {},
            "PROTO_UDP": {},
            "PROTO_ICMP": {},
            "PROTO_ALL": {}
        },
        "IptableRuleAction": {
            "ACCEPT": {},
            "DROP": {},
            "REJECT": {},
            "DNAT": {},
            "MASQUERADE": {}
        },
        "SNMP_VER": {
            "SNMP_VER2": {
                "text": "SNMP_VER2",
                "description": "SNMP version 2"
            },
            "SNMP_VER3": {
                "text": "SNMP_VER3",
                "description": "SNMP version 3"
            }
        },
        "SNMP_V3_AUTH": {
            "SNMP_V3_AUTH_MD5": {
                "text": "MD5",
                "description": "MD5 SNMP v3 authentication"
            },
            "SNMP_V3_AUTH_SHA": {
                "text": "SHA",
                "description": "SHA SNMP v3 authentication"
            },
            "SNMP_V3_AUTH_SHA_224": {
                "text": "SHA-224",
                "description": "SHA-224 SNMP v3 authentication"
            },
            "SNMP_V3_AUTH_SHA_256": {
                "text": "SHA-256",
                "description": "SHA-256 SNMP v3 authentication"
            },
            "SNMP_V3_AUTH_SHA_384": {
                "text": "SHA-384",
                "description": "SHA-384 SNMP v3 authentication"
            },
            "SNMP_V3_AUTH_SHA_512": {
                "text": "SHA-512",
                "description": "SHA-512 SNMP v3 authentication"
            }
        },
        "SNMP_V3_PRIV": {
            "SNMP_V3_PRIV_DES": {
                "text": "DES",
                "description": "DES privacy for SNMP v3 payload"
            },
            "SNMP_V3_PRIV_AES": {
                "text": "AES",
                "description": "AES privacy for SNMP v3 payload"
            }
        },
        "SSLKeyAlgorithm": {
            "SSL_KEY_ALGORITHM_RSA": {
                "text": "RSA"
            },
            "SSL_KEY_ALGORITHM_EC": {
                "text": "EC"
            },
            "SSL_KEY_ALGORITHM_MLDSA": {
                "text": "MLDSA"
            }
        },
        "SSLKeyMldsaAlgorithm": {
            "SSL_KEY_MLDSA44": {
                "text": "MLDSA44"
            },
            "SSL_KEY_MLDSA65": {
                "text": "MLDSA65"
            },
            "SSL_KEY_MLDSA87": {
                "text": "MLDSA87"
            }
        },
        "SSLKeyECCurve": {
            "SSL_KEY_EC_CURVE_SECP256R1": {
                "text": "SECP256R1"
            },
            "SSL_KEY_EC_CURVE_SECP384R1": {
                "text": "SECP384R1"
            },
            "SSL_KEY_EC_CURVE_SECP521R1": {
                "text": "SECP521R1"
            }
        },
        "SSLRSAKeySize": {
            "SSL_KEY_1024_BITS": {},
            "SSL_KEY_2048_BITS": {},
            "SSL_KEY_3072_BITS": {},
            "SSL_KEY_4096_BITS": {},
            "SSL_KEY_8192_BITS": {}
        },
        "SSLCertificateType": {
            "SSL_CERTIFICATE_TYPE_VIRTUALSERVICE": {},
            "SSL_CERTIFICATE_TYPE_SYSTEM": {},
            "SSL_CERTIFICATE_TYPE_CA": {},
            "SSL_CERTIFICATE_TYPE_CLIENT": {
                "text": "Client Certificate",
                "description": "Client Certificate Type"
            },
            "SSL_CERTIFICATE_TYPE_SECURE_CHANNEL": {
                "text": "Secure Channel Certificate",
                "description": "Secure Channel Certificate Type"
            }
        },
        "SSLCertificateStatus": {
            "SSL_CERTIFICATE_FINISHED": {
                "description": "SSL Certificate is good"
            },
            "SSL_CERTIFICATE_PENDING": {
                "description": "Awaiting Certificate import"
            }
        },
        "SSLFormat": {
            "SSL_PEM": {},
            "SSL_PKCS12": {}
        },
        "OCSPErrorStatus": {
            "OCSP_ERR_CERTSTATUS_GOOD": {
                "text": "OCSP Certificate Status: Certificate is good.",
                "description": "Certificate status is Good as indicated by OCSP Responder."
            },
            "OCSP_ERR_CERTSTATUS_REVOKED": {
                "text": "OCSP Certificate Status: Certificate is revoked.",
                "description": "Certificate status is Revoked as indicated by OCSP Responder."
            },
            "OCSP_ERR_CERTSTATUS_UNKNOWN": {
                "text": "OCSP Certificate Status: Certificate is unknown.",
                "description": "Certificate status is unknown as indicated by OCSP Responder."
            },
            "OCSP_ERR_CERTSTATUS_SERVERFAIL_ERR": {
                "text": "OCSP Certificate Status: OCSP Responder Error.",
                "description": "A failure was detected in the OCSP Responder."
            },
            "OCSP_ERR_CERTSTATUS_JOBDB": {
                "text": "OCSP Certificate Status: Job DB Error.",
                "description": "A failure was detected in job DB."
            },
            "OCSP_ERR_CERTSTATUS_DISABLED": {
                "text": "OCSP Certificate Status: OCSP is disabled.",
                "description": "OCSP Stapling is disabled on this certificate."
            },
            "OCSP_ERR_CERTSTATUS_GETCERT": {
                "text": "OCSP Certificate Status: Certificate Chain Error.",
                "description": "Issuer certificate chain is not complete for this certificate."
            },
            "OCSP_ERR_CERTSTATUS_NONVSCERT": {
                "text": "OCSP Certificate Status: Non Application Certificate Error.",
                "description": "Certificate is not a Application Certificate."
            },
            "OCSP_ERR_CERTSTATUS_SELFSIGNED": {
                "text": "OCSP Certificate Status: Certificate Self-signed Error.",
                "description": "Certificate is self signed."
            },
            "OCSP_ERR_CERTSTATUS_CERTFINISH": {
                "text": "OCSP Certificate Status: Certificate not SSL_CERTIFICATE_FINISHED.",
                "description": "Certificate status is not SSL_CERTIFICATE_FINISHED."
            },
            "OCSP_ERR_CERTSTATUS_CACERT": {
                "text": "OCSP Certificate Status: Root Certificate Error.",
                "description": "Certificate is a root certificate."
            },
            "OCSP_ERR_CERTSTATUS_REQUEST": {
                "text": "OCSP Certificate Status: OCSP Request Creation Error.",
                "description": "Error during OCSP request creation."
            },
            "OCSP_ERR_CERTSTATUS_ISSUER_REVOKED": {
                "text": "OCSP Certificate Status: Issuer certificate is Revoked.",
                "description": "Issuer certificate is Revoked."
            },
            "OCSP_ERR_CERTSTATUS_PARSE_CERT": {
                "text": "OCSP Certificate Status: Error during Certificate parsing.",
                "description": "Error during Certificate parsing."
            },
            "OCSP_ERR_CERTSTATUS_HTTP_REQ": {
                "text": "OCSP Certificate Status: OCSP HTTP Request Creation Error.",
                "description": "Error during creation of HTTP request."
            },
            "OCSP_ERR_CERTSTATUS_URL_LIST": {
                "text": "OCSP Certificate Status: OCSP responder URL list Parse Error.",
                "description": "Error during parsing of responder URL list."
            },
            "OCSP_ERR_CERTSTATUS_HTTP_SEND": {
                "text": "OCSP Certificate Status: OCSP HTTP Request Send Error.",
                "description": "Error while sending of HTTP request."
            },
            "OCSP_ERR_CERTSTATUS_HTTP_RECV": {
                "text": "OCSP Certificate Status: OCSP HTTP Response Read Error.",
                "description": "Error while reading of HTTP response."
            },
            "OCSP_ERR_CERTSTATUS_HTTP_RESP": {
                "text": "OCSP Certificate Status: OCSP HTTP Response Parse Error.",
                "description": "Error while parsing of HTTP response."
            }
        },
        "CertificateStatus": {
            "OCSP_CERTSTATUS_GOOD": {
                "text": "GOOD"
            },
            "OCSP_CERTSTATUS_REVOKED": {
                "text": "REVOKED"
            },
            "OCSP_CERTSTATUS_UNKNOWN": {
                "text": "UNKNOWN"
            }
        },
        "CertificateRevocationReason": {
            "OCSP_REVOCATION_REASON_UNSPECIFIED": {
                "text": "Unspecified.",
                "description": "OCSP Revocation reason for the certificate is not specified."
            },
            "OCSP_REVOCATION_REASON_KEY_COMPROMISE": {
                "text": "Key Compromise.",
                "description": "It is suspected that the subject's private key, or other aspects of the subject validated in the certificate, have been compromised."
            },
            "OCSP_REVOCATION_REASON_CA_COMPROMISE": {
                "text": "CA Compromise.",
                "description": "CA certificate is revoked as it is suspected that the subject's private key, or other aspects of the subject validated in the certificate, have been compromised."
            },
            "OCSP_REVOCATION_REASON_AFFILIATION_CHANGED": {
                "text": "Affiliation changed.",
                "description": "Subject's name or other information in the certificate has been modified."
            },
            "OCSP_REVOCATION_REASON_SUPERSEDED": {
                "text": "Superseded.",
                "description": "Certificate has been superseded but there is no cause to suspect that the private key has been compromised."
            },
            "OCSP_REVOCATION_REASON_CESSATION_OF_OPERATION": {
                "text": "Cessation of Operation.",
                "description": "Certificate is no longer needed for the purpose for which it was issued."
            },
            "OCSP_REVOCATION_REASON_CERTIFICATE_HOLD": {
                "text": "Certificate on Hold.",
                "description": "Certificate is temporarilty invalidated until more information is made available."
            },
            "OCSP_REVOCATION_REASON_REMOVE_FROM_CRL": {
                "text": "Remove from CRL.",
                "description": "Certificate is not revoked."
            },
            "OCSP_REVOCATION_REASON_PRIVILEGE_WITHDRAWN": {
                "text": "Privilege withdrawn.",
                "description": "Certificate was revoked because a privilege contained within that certificate has been withdrawn."
            },
            "OCSP_REVOCATION_REASON_AA_COMPROMISE": {
                "text": "AA Compromise.",
                "description": "OCSP Revocation reason for the certificate is AA Compromise."
            }
        },
        "OCSPResponderUrlAction": {
            "OCSP_RESPONDER_URL_FAILOVER": {
                "text": "FAILOVER",
                "description": "Used as a Failover URL to the AIA extension contained in the certificate."
            },
            "OCSP_RESPONDER_URL_OVERRIDE": {
                "text": "OVERRIDE",
                "description": "URL configured is used instead of the URL contained in the AIA extension of the certificate."
            }
        },
        "AcceptedCipherEnums": {
            "TLS_ECDHE_ECDSA_WITH_AES_128_GCM_SHA256": {
                "text": "ECDHE-ECDSA-AES128-GCM-SHA256",
                "description": "TLS ECDHE ECDSA WITH AES 128 GCM SHA 256",
                "ssl_performance": "SSL_SCORE_EXCELLENT",
                "ssl_compatibility": "SSL_SCORE_GOOD",
                "ssl_security": "SSL_SCORE_EXCELLENT",
                "ssl_security_score": 100
            },
            "TLS_ECDHE_ECDSA_WITH_AES_256_GCM_SHA384": {
                "text": "ECDHE-ECDSA-AES256-GCM-SHA384",
                "description": "TLS ECDHE ECDSA WITH AES 256 GCM SHA384",
                "ssl_performance": "SSL_SCORE_EXCELLENT",
                "ssl_compatibility": "SSL_SCORE_GOOD",
                "ssl_security": "SSL_SCORE_EXCELLENT",
                "ssl_security_score": 100
            },
            "TLS_ECDHE_RSA_WITH_AES_128_GCM_SHA256": {
                "text": "ECDHE-RSA-AES128-GCM-SHA256",
                "description": "TLS ECDHE RSA WITH AES 128 GCM SHA256",
                "ssl_performance": "SSL_SCORE_AVERAGE",
                "ssl_compatibility": "SSL_SCORE_GOOD",
                "ssl_security": "SSL_SCORE_EXCELLENT",
                "ssl_security_score": 100
            },
            "TLS_ECDHE_RSA_WITH_AES_256_GCM_SHA384": {
                "text": "ECDHE-RSA-AES256-GCM-SHA384",
                "description": "TLS ECDHE RSA WITH AES 256 GCM SHA384",
                "ssl_performance": "SSL_SCORE_AVERAGE",
                "ssl_compatibility": "SSL_SCORE_GOOD",
                "ssl_security": "SSL_SCORE_EXCELLENT",
                "ssl_security_score": 100
            },
            "TLS_ECDHE_ECDSA_WITH_AES_128_CBC_SHA256": {
                "text": "ECDHE-ECDSA-AES128-SHA256",
                "description": "TLS ECDHE ECDSA WITH AES 128 CBC SHA256",
                "ssl_performance": "SSL_SCORE_GOOD",
                "ssl_compatibility": "SSL_SCORE_GOOD",
                "ssl_security": "SSL_SCORE_BAD",
                "ssl_security_score": 40
            },
            "TLS_ECDHE_ECDSA_WITH_AES_256_CBC_SHA384": {
                "text": "ECDHE-ECDSA-AES256-SHA384",
                "description": "TLS ECDHE ECDSA WITH AES 256 CBC SHA384",
                "ssl_performance": "SSL_SCORE_GOOD",
                "ssl_compatibility": "SSL_SCORE_BAD",
                "ssl_security": "SSL_SCORE_BAD",
                "ssl_security_score": 40
            },
            "TLS_ECDHE_RSA_WITH_AES_128_CBC_SHA256": {
                "text": "ECDHE-RSA-AES128-SHA256",
                "description": "TLS ECDHE RSA WITH AES 128 CBC SHA256",
                "ssl_performance": "SSL_SCORE_BAD",
                "ssl_compatibility": "SSL_SCORE_GOOD",
                "ssl_security": "SSL_SCORE_BAD",
                "ssl_security_score": 40
            },
            "TLS_ECDHE_RSA_WITH_AES_256_CBC_SHA384": {
                "text": "ECDHE-RSA-AES256-SHA384",
                "description": "TLS ECDHE RSA WITH AES 256 CBC SHA384",
                "ssl_performance": "SSL_SCORE_AVERAGE",
                "ssl_compatibility": "SSL_SCORE_BAD",
                "ssl_security": "SSL_SCORE_BAD",
                "ssl_security_score": 40
            },
            "TLS_RSA_WITH_AES_128_GCM_SHA256": {
                "text": "AES128-GCM-SHA256",
                "description": "TLS RSA WITH AES 128 GCM SHA256",
                "ssl_performance": "SSL_SCORE_GOOD",
                "ssl_compatibility": "SSL_SCORE_GOOD",
                "ssl_security": "SSL_SCORE_BAD",
                "ssl_security_score": 40
            },
            "TLS_RSA_WITH_AES_256_GCM_SHA384": {
                "text": "AES256-GCM-SHA384",
                "description": "TLS RSA WITH AES 256 GCM SHA384",
                "ssl_performance": "SSL_SCORE_GOOD",
                "ssl_compatibility": "SSL_SCORE_GOOD",
                "ssl_security": "SSL_SCORE_BAD",
                "ssl_security_score": 40
            },
            "TLS_RSA_WITH_AES_128_CBC_SHA256": {
                "text": "AES128-SHA256",
                "description": "TLS RSA WITH AES 128 CBC SHA256",
                "ssl_performance": "SSL_SCORE_BAD",
                "ssl_compatibility": "SSL_SCORE_GOOD",
                "ssl_security": "SSL_SCORE_BAD",
                "ssl_security_score": 40
            },
            "TLS_RSA_WITH_AES_256_CBC_SHA256": {
                "text": "AES256-SHA256",
                "description": "TLS RSA WITH AES 256 CBC SHA256",
                "ssl_performance": "SSL_SCORE_BAD",
                "ssl_compatibility": "SSL_SCORE_GOOD",
                "ssl_security": "SSL_SCORE_BAD",
                "ssl_security_score": 40
            },
            "TLS_ECDHE_ECDSA_WITH_AES_128_CBC_SHA": {
                "text": "ECDHE-ECDSA-AES128-SHA",
                "description": "TLS ECDHE ECDSA WITH AES 128 CBC SHA",
                "ssl_performance": "SSL_SCORE_EXCELLENT",
                "ssl_compatibility": "SSL_SCORE_EXCELLENT",
                "ssl_security": "SSL_SCORE_BAD",
                "ssl_security_score": 40
            },
            "TLS_ECDHE_ECDSA_WITH_AES_256_CBC_SHA": {
                "text": "ECDHE-ECDSA-AES256-SHA",
                "description": "TLS ECDHE ECDSA WITH AES 256 CBC SHA",
                "ssl_performance": "SSL_SCORE_EXCELLENT",
                "ssl_compatibility": "SSL_SCORE_EXCELLENT",
                "ssl_security": "SSL_SCORE_BAD",
                "ssl_security_score": 40
            },
            "TLS_ECDHE_RSA_WITH_AES_128_CBC_SHA": {
                "text": "ECDHE-RSA-AES128-SHA",
                "description": "TLS ECDHE RSA WITH AES 128 CBC SHA",
                "ssl_performance": "SSL_SCORE_AVERAGE",
                "ssl_compatibility": "SSL_SCORE_EXCELLENT",
                "ssl_security": "SSL_SCORE_BAD",
                "ssl_security_score": 40
            },
            "TLS_ECDHE_RSA_WITH_AES_256_CBC_SHA": {
                "text": "ECDHE-RSA-AES256-SHA",
                "description": "TLS ECDHE RSA WITH AES 256 CBC SHA",
                "ssl_performance": "SSL_SCORE_BAD",
                "ssl_compatibility": "SSL_SCORE_EXCELLENT",
                "ssl_security": "SSL_SCORE_BAD",
                "ssl_security_score": 40
            },
            "TLS_RSA_WITH_AES_128_CBC_SHA": {
                "text": "AES128-SHA",
                "description": "TLS RSA WITH AES 128 CBC SHA",
                "ssl_performance": "SSL_SCORE_AVERAGE",
                "ssl_compatibility": "SSL_SCORE_EXCELLENT",
                "ssl_security": "SSL_SCORE_BAD",
                "ssl_security_score": 40
            },
            "TLS_RSA_WITH_AES_256_CBC_SHA": {
                "text": "AES256-SHA",
                "description": "TLS RSA WITH AES 256 CBC SHA",
                "ssl_performance": "SSL_SCORE_AVERAGE",
                "ssl_compatibility": "SSL_SCORE_EXCELLENT",
                "ssl_security": "SSL_SCORE_BAD",
                "ssl_security_score": 40
            },
            "TLS_AES_256_GCM_SHA384": {
                "text": "TLS_AES_256_GCM_SHA384",
                "description": "TLS WITH AES 256 GCM SHA384",
                "ssl_performance": "SSL_SCORE_EXCELLENT",
                "ssl_compatibility": "SSL_SCORE_GOOD",
                "ssl_security": "SSL_SCORE_EXCELLENT",
                "ssl_security_score": 100
            },
            "TLS_CHACHA20_POLY1305_SHA256": {
                "text": "TLS_CHACHA20_POLY1305_SHA256",
                "description": "TLS WITH CHACHA20 POLY1305 SHA256",
                "ssl_performance": "SSL_SCORE_EXCELLENT",
                "ssl_compatibility": "SSL_SCORE_VERY_BAD",
                "ssl_security": "SSL_SCORE_EXCELLENT",
                "ssl_security_score": 100
            },
            "TLS_AES_128_GCM_SHA256": {
                "text": "TLS_AES_128_GCM_SHA256",
                "description": "TLS WITH AES 128 GCM SHA256",
                "ssl_performance": "SSL_SCORE_EXCELLENT",
                "ssl_compatibility": "SSL_SCORE_GOOD",
                "ssl_security": "SSL_SCORE_EXCELLENT",
                "ssl_security_score": 100
            },
            "TLS_DHE_RSA_WITH_AES_128_GCM_SHA256": {
                "text": "TLS_DHE_RSA_WITH_AES_128_GCM_SHA256",
                "description": "TLS DHE RSA WITH AES 128 GCM SHA256",
                "ssl_performance": "SSL_SCORE_EXCELLENT",
                "ssl_compatibility": "SSL_SCORE_GOOD",
                "ssl_security": "SSL_SCORE_GOOD",
                "ssl_security_score": 80
            },
            "TLS_DHE_RSA_WITH_AES_256_GCM_SHA384": {
                "text": "TLS_DHE_RSA_WITH_AES_256_GCM_SHA384",
                "description": "TLS DHE RSA WITH AES 256 GCM SHA384",
                "ssl_performance": "SSL_SCORE_EXCELLENT",
                "ssl_compatibility": "SSL_SCORE_GOOD",
                "ssl_security": "SSL_SCORE_GOOD",
                "ssl_security_score": 80
            }
        },
        "SSLProfileType": {
            "SSL_PROFILE_TYPE_APPLICATION": {
                "text": "Application specific SSL Profile"
            },
            "SSL_PROFILE_TYPE_SYSTEM": {
                "text": "Controller Portal specific SSL Profile"
            }
        },
        "TagType": {
            "AVI_DEFINED": {},
            "USER_DEFINED": {},
            "VCENTER_DEFINED": {}
        },
        "SSLVersionType": {
            "SSL_VERSION_TLS1": {
                "text": "TLS 1.0"
            },
            "SSL_VERSION_TLS1_1": {
                "text": "TLS 1.1"
            },
            "SSL_VERSION_TLS1_2": {
                "text": "TLS 1.2"
            },
            "SSL_VERSION_TLS1_3": {
                "text": "TLS 1.3"
            }
        },
        "SSOPolicyType": {
            "SSO_TYPE_SAML": {
                "text": "SAML",
                "description": "SSO Policy Type: SAML"
            },
            "SSO_TYPE_JWT": {
                "text": "JWT",
                "description": "SSO Policy Type: JWT."
            },
            "SSO_TYPE_LDAP": {
                "text": "LDAP",
                "description": "SSO Policy Type: LDAP."
            },
            "SSO_TYPE_OAUTH": {
                "text": "OAuth/OIDC",
                "description": "SSO Policy Type: OAuth/OIDC"
            }
        },
        "StringGroupType": {
            "SG_TYPE_STRING": {
                "text": "String",
                "description": "StringGroup is a collection of Strings"
            },
            "SG_TYPE_KEYVAL": {
                "text": "Key & Value",
                "description": "StringGroup is a collection of (Key,Value) pairs"
            }
        },
        "SMTPType": {
            "SMTP_NONE": {
                "text": "No SMTP"
            },
            "SMTP_LOCAL_HOST": {
                "text": "Local Host"
            },
            "SMTP_SERVER": {
                "text": "SMTP Server"
            },
            "SMTP_ANONYMOUS_SERVER": {
                "text": "Anonymous SMTP Server"
            }
        },
        "EmailTimezone": {
            "UTC": {
                "text": "UTC",
                "description": "UTC"
            },
            "AFRICA_ABIDJAN": {
                "text": "Africa/Abidjan",
                "description": "Africa/Abidjan"
            },
            "AFRICA_ACCRA": {
                "text": "Africa/Accra",
                "description": "Africa/Accra"
            },
            "AFRICA_ADDIS_ABABA": {
                "text": "Africa/Addis_Ababa",
                "description": "Africa/Addis_Ababa"
            },
            "AFRICA_ALGIERS": {
                "text": "Africa/Algiers",
                "description": "Africa/Algiers"
            },
            "AFRICA_ASMARA": {
                "text": "Africa/Asmara",
                "description": "Africa/Asmara"
            },
            "AFRICA_ASMERA": {
                "text": "Africa/Asmera",
                "description": "Africa/Asmera"
            },
            "AFRICA_BAMAKO": {
                "text": "Africa/Bamako",
                "description": "Africa/Bamako"
            },
            "AFRICA_BANGUI": {
                "text": "Africa/Bangui",
                "description": "Africa/Bangui"
            },
            "AFRICA_BANJUL": {
                "text": "Africa/Banjul",
                "description": "Africa/Banjul"
            },
            "AFRICA_BISSAU": {
                "text": "Africa/Bissau",
                "description": "Africa/Bissau"
            },
            "AFRICA_BLANTYRE": {
                "text": "Africa/Blantyre",
                "description": "Africa/Blantyre"
            },
            "AFRICA_BRAZZAVILLE": {
                "text": "Africa/Brazzaville",
                "description": "Africa/Brazzaville"
            },
            "AFRICA_BUJUMBURA": {
                "text": "Africa/Bujumbura",
                "description": "Africa/Bujumbura"
            },
            "AFRICA_CAIRO": {
                "text": "Africa/Cairo",
                "description": "Africa/Cairo"
            },
            "AFRICA_CASABLANCA": {
                "text": "Africa/Casablanca",
                "description": "Africa/Casablanca"
            },
            "AFRICA_CEUTA": {
                "text": "Africa/Ceuta",
                "description": "Africa/Ceuta"
            },
            "AFRICA_CONAKRY": {
                "text": "Africa/Conakry",
                "description": "Africa/Conakry"
            },
            "AFRICA_DAKAR": {
                "text": "Africa/Dakar",
                "description": "Africa/Dakar"
            },
            "AFRICA_DAR_ES_SALAAM": {
                "text": "Africa/Dar_es_Salaam",
                "description": "Africa/Dar_es_Salaam"
            },
            "AFRICA_DJIBOUTI": {
                "text": "Africa/Djibouti",
                "description": "Africa/Djibouti"
            },
            "AFRICA_DOUALA": {
                "text": "Africa/Douala",
                "description": "Africa/Douala"
            },
            "AFRICA_EL_AAIUN": {
                "text": "Africa/El_Aaiun",
                "description": "Africa/El_Aaiun"
            },
            "AFRICA_FREETOWN": {
                "text": "Africa/Freetown",
                "description": "Africa/Freetown"
            },
            "AFRICA_GABORONE": {
                "text": "Africa/Gaborone",
                "description": "Africa/Gaborone"
            },
            "AFRICA_HARARE": {
                "text": "Africa/Harare",
                "description": "Africa/Harare"
            },
            "AFRICA_JOHANNESBURG": {
                "text": "Africa/Johannesburg",
                "description": "Africa/Johannesburg"
            },
            "AFRICA_JUBA": {
                "text": "Africa/Juba",
                "description": "Africa/Juba"
            },
            "AFRICA_KAMPALA": {
                "text": "Africa/Kampala",
                "description": "Africa/Kampala"
            },
            "AFRICA_KHARTOUM": {
                "text": "Africa/Khartoum",
                "description": "Africa/Khartoum"
            },
            "AFRICA_KIGALI": {
                "text": "Africa/Kigali",
                "description": "Africa/Kigali"
            },
            "AFRICA_KINSHASA": {
                "text": "Africa/Kinshasa",
                "description": "Africa/Kinshasa"
            },
            "AFRICA_LAGOS": {
                "text": "Africa/Lagos",
                "description": "Africa/Lagos"
            },
            "AFRICA_LIBREVILLE": {
                "text": "Africa/Libreville",
                "description": "Africa/Libreville"
            },
            "AFRICA_LOME": {
                "text": "Africa/Lome",
                "description": "Africa/Lome"
            },
            "AFRICA_LUANDA": {
                "text": "Africa/Luanda",
                "description": "Africa/Luanda"
            },
            "AFRICA_LUBUMBASHI": {
                "text": "Africa/Lubumbashi",
                "description": "Africa/Lubumbashi"
            },
            "AFRICA_LUSAKA": {
                "text": "Africa/Lusaka",
                "description": "Africa/Lusaka"
            },
            "AFRICA_MALABO": {
                "text": "Africa/Malabo",
                "description": "Africa/Malabo"
            },
            "AFRICA_MAPUTO": {
                "text": "Africa/Maputo",
                "description": "Africa/Maputo"
            },
            "AFRICA_MASERU": {
                "text": "Africa/Maseru",
                "description": "Africa/Maseru"
            },
            "AFRICA_MBABANE": {
                "text": "Africa/Mbabane",
                "description": "Africa/Mbabane"
            },
            "AFRICA_MOGADISHU": {
                "text": "Africa/Mogadishu",
                "description": "Africa/Mogadishu"
            },
            "AFRICA_MONROVIA": {
                "text": "Africa/Monrovia",
                "description": "Africa/Monrovia"
            },
            "AFRICA_NAIROBI": {
                "text": "Africa/Nairobi",
                "description": "Africa/Nairobi"
            },
            "AFRICA_NDJAMENA": {
                "text": "Africa/Ndjamena",
                "description": "Africa/Ndjamena"
            },
            "AFRICA_NIAMEY": {
                "text": "Africa/Niamey",
                "description": "Africa/Niamey"
            },
            "AFRICA_NOUAKCHOTT": {
                "text": "Africa/Nouakchott",
                "description": "Africa/Nouakchott"
            },
            "AFRICA_OUAGADOUGOU": {
                "text": "Africa/Ouagadougou",
                "description": "Africa/Ouagadougou"
            },
            "AFRICA_PORTO_MINUS_NOVO": {
                "text": "Africa/Porto-Novo",
                "description": "Africa/Porto-Novo"
            },
            "AFRICA_SAO_TOME": {
                "text": "Africa/Sao_Tome",
                "description": "Africa/Sao_Tome"
            },
            "AFRICA_TIMBUKTU": {
                "text": "Africa/Timbuktu",
                "description": "Africa/Timbuktu"
            },
            "AFRICA_TRIPOLI": {
                "text": "Africa/Tripoli",
                "description": "Africa/Tripoli"
            },
            "AFRICA_TUNIS": {
                "text": "Africa/Tunis",
                "description": "Africa/Tunis"
            },
            "AFRICA_WINDHOEK": {
                "text": "Africa/Windhoek",
                "description": "Africa/Windhoek"
            },
            "AMERICA_ADAK": {
                "text": "America/Adak",
                "description": "America/Adak"
            },
            "AMERICA_ANCHORAGE": {
                "text": "America/Anchorage",
                "description": "America/Anchorage"
            },
            "AMERICA_ANGUILLA": {
                "text": "America/Anguilla",
                "description": "America/Anguilla"
            },
            "AMERICA_ANTIGUA": {
                "text": "America/Antigua",
                "description": "America/Antigua"
            },
            "AMERICA_ARAGUAINA": {
                "text": "America/Araguaina",
                "description": "America/Araguaina"
            },
            "AMERICA_ARGENTINA_BUENOS_AIRES": {
                "text": "America/Argentina/Buenos_Aires",
                "description": "America/Argentina/Buenos_Aires"
            },
            "AMERICA_ARGENTINA_CATAMARCA": {
                "text": "America/Argentina/Catamarca",
                "description": "America/Argentina/Catamarca"
            },
            "AMERICA_ARGENTINA_COMODRIVADAVIA": {
                "text": "America/Argentina/ComodRivadavia",
                "description": "America/Argentina/ComodRivadavia"
            },
            "AMERICA_ARGENTINA_CORDOBA": {
                "text": "America/Argentina/Cordoba",
                "description": "America/Argentina/Cordoba"
            },
            "AMERICA_ARGENTINA_JUJUY": {
                "text": "America/Argentina/Jujuy",
                "description": "America/Argentina/Jujuy"
            },
            "AMERICA_ARGENTINA_LA_RIOJA": {
                "text": "America/Argentina/La_Rioja",
                "description": "America/Argentina/La_Rioja"
            },
            "AMERICA_ARGENTINA_MENDOZA": {
                "text": "America/Argentina/Mendoza",
                "description": "America/Argentina/Mendoza"
            },
            "AMERICA_ARGENTINA_RIO_GALLEGOS": {
                "text": "America/Argentina/Rio_Gallegos",
                "description": "America/Argentina/Rio_Gallegos"
            },
            "AMERICA_ARGENTINA_SALTA": {
                "text": "America/Argentina/Salta",
                "description": "America/Argentina/Salta"
            },
            "AMERICA_ARGENTINA_SAN_JUAN": {
                "text": "America/Argentina/San_Juan",
                "description": "America/Argentina/San_Juan"
            },
            "AMERICA_ARGENTINA_SAN_LUIS": {
                "text": "America/Argentina/San_Luis",
                "description": "America/Argentina/San_Luis"
            },
            "AMERICA_ARGENTINA_TUCUMAN": {
                "text": "America/Argentina/Tucuman",
                "description": "America/Argentina/Tucuman"
            },
            "AMERICA_ARGENTINA_USHUAIA": {
                "text": "America/Argentina/Ushuaia",
                "description": "America/Argentina/Ushuaia"
            },
            "AMERICA_ARUBA": {
                "text": "America/Aruba",
                "description": "America/Aruba"
            },
            "AMERICA_ASUNCION": {
                "text": "America/Asuncion",
                "description": "America/Asuncion"
            },
            "AMERICA_ATIKOKAN": {
                "text": "America/Atikokan",
                "description": "America/Atikokan"
            },
            "AMERICA_ATKA": {
                "text": "America/Atka",
                "description": "America/Atka"
            },
            "AMERICA_BAHIA": {
                "text": "America/Bahia",
                "description": "America/Bahia"
            },
            "AMERICA_BAHIA_BANDERAS": {
                "text": "America/Bahia_Banderas",
                "description": "America/Bahia_Banderas"
            },
            "AMERICA_BARBADOS": {
                "text": "America/Barbados",
                "description": "America/Barbados"
            },
            "AMERICA_BELEM": {
                "text": "America/Belem",
                "description": "America/Belem"
            },
            "AMERICA_BELIZE": {
                "text": "America/Belize",
                "description": "America/Belize"
            },
            "AMERICA_BLANC_MINUS_SABLON": {
                "text": "America/Blanc-Sablon",
                "description": "America/Blanc-Sablon"
            },
            "AMERICA_BOA_VISTA": {
                "text": "America/Boa_Vista",
                "description": "America/Boa_Vista"
            },
            "AMERICA_BOGOTA": {
                "text": "America/Bogota",
                "description": "America/Bogota"
            },
            "AMERICA_BOISE": {
                "text": "America/Boise",
                "description": "America/Boise"
            },
            "AMERICA_BUENOS_AIRES": {
                "text": "America/Buenos_Aires",
                "description": "America/Buenos_Aires"
            },
            "AMERICA_CAMBRIDGE_BAY": {
                "text": "America/Cambridge_Bay",
                "description": "America/Cambridge_Bay"
            },
            "AMERICA_CAMPO_GRANDE": {
                "text": "America/Campo_Grande",
                "description": "America/Campo_Grande"
            },
            "AMERICA_CANCUN": {
                "text": "America/Cancun",
                "description": "America/Cancun"
            },
            "AMERICA_CARACAS": {
                "text": "America/Caracas",
                "description": "America/Caracas"
            },
            "AMERICA_CATAMARCA": {
                "text": "America/Catamarca",
                "description": "America/Catamarca"
            },
            "AMERICA_CAYENNE": {
                "text": "America/Cayenne",
                "description": "America/Cayenne"
            },
            "AMERICA_CAYMAN": {
                "text": "America/Cayman",
                "description": "America/Cayman"
            },
            "AMERICA_CHICAGO": {
                "text": "America/Chicago",
                "description": "America/Chicago"
            },
            "AMERICA_CHIHUAHUA": {
                "text": "America/Chihuahua",
                "description": "America/Chihuahua"
            },
            "AMERICA_CORAL_HARBOUR": {
                "text": "America/Coral_Harbour",
                "description": "America/Coral_Harbour"
            },
            "AMERICA_CORDOBA": {
                "text": "America/Cordoba",
                "description": "America/Cordoba"
            },
            "AMERICA_COSTA_RICA": {
                "text": "America/Costa_Rica",
                "description": "America/Costa_Rica"
            },
            "AMERICA_CRESTON": {
                "text": "America/Creston",
                "description": "America/Creston"
            },
            "AMERICA_CUIABA": {
                "text": "America/Cuiaba",
                "description": "America/Cuiaba"
            },
            "AMERICA_CURACAO": {
                "text": "America/Curacao",
                "description": "America/Curacao"
            },
            "AMERICA_DANMARKSHAVN": {
                "text": "America/Danmarkshavn",
                "description": "America/Danmarkshavn"
            },
            "AMERICA_DAWSON": {
                "text": "America/Dawson",
                "description": "America/Dawson"
            },
            "AMERICA_DAWSON_CREEK": {
                "text": "America/Dawson_Creek",
                "description": "America/Dawson_Creek"
            },
            "AMERICA_DENVER": {
                "text": "America/Denver",
                "description": "America/Denver"
            },
            "AMERICA_DETROIT": {
                "text": "America/Detroit",
                "description": "America/Detroit"
            },
            "AMERICA_DOMINICA": {
                "text": "America/Dominica",
                "description": "America/Dominica"
            },
            "AMERICA_EDMONTON": {
                "text": "America/Edmonton",
                "description": "America/Edmonton"
            },
            "AMERICA_EIRUNEPE": {
                "text": "America/Eirunepe",
                "description": "America/Eirunepe"
            },
            "AMERICA_EL_SALVADOR": {
                "text": "America/El_Salvador",
                "description": "America/El_Salvador"
            },
            "AMERICA_ENSENADA": {
                "text": "America/Ensenada",
                "description": "America/Ensenada"
            },
            "AMERICA_FORT_NELSON": {
                "text": "America/Fort_Nelson",
                "description": "America/Fort_Nelson"
            },
            "AMERICA_FORT_WAYNE": {
                "text": "America/Fort_Wayne",
                "description": "America/Fort_Wayne"
            },
            "AMERICA_FORTALEZA": {
                "text": "America/Fortaleza",
                "description": "America/Fortaleza"
            },
            "AMERICA_GLACE_BAY": {
                "text": "America/Glace_Bay",
                "description": "America/Glace_Bay"
            },
            "AMERICA_GODTHAB": {
                "text": "America/Godthab",
                "description": "America/Godthab"
            },
            "AMERICA_GOOSE_BAY": {
                "text": "America/Goose_Bay",
                "description": "America/Goose_Bay"
            },
            "AMERICA_GRAND_TURK": {
                "text": "America/Grand_Turk",
                "description": "America/Grand_Turk"
            },
            "AMERICA_GRENADA": {
                "text": "America/Grenada",
                "description": "America/Grenada"
            },
            "AMERICA_GUADELOUPE": {
                "text": "America/Guadeloupe",
                "description": "America/Guadeloupe"
            },
            "AMERICA_GUATEMALA": {
                "text": "America/Guatemala",
                "description": "America/Guatemala"
            },
            "AMERICA_GUAYAQUIL": {
                "text": "America/Guayaquil",
                "description": "America/Guayaquil"
            },
            "AMERICA_GUYANA": {
                "text": "America/Guyana",
                "description": "America/Guyana"
            },
            "AMERICA_HALIFAX": {
                "text": "America/Halifax",
                "description": "America/Halifax"
            },
            "AMERICA_HAVANA": {
                "text": "America/Havana",
                "description": "America/Havana"
            },
            "AMERICA_HERMOSILLO": {
                "text": "America/Hermosillo",
                "description": "America/Hermosillo"
            },
            "AMERICA_INDIANA_INDIANAPOLIS": {
                "text": "America/Indiana/Indianapolis",
                "description": "America/Indiana/Indianapolis"
            },
            "AMERICA_INDIANA_KNOX": {
                "text": "America/Indiana/Knox",
                "description": "America/Indiana/Knox"
            },
            "AMERICA_INDIANA_MARENGO": {
                "text": "America/Indiana/Marengo",
                "description": "America/Indiana/Marengo"
            },
            "AMERICA_INDIANA_PETERSBURG": {
                "text": "America/Indiana/Petersburg",
                "description": "America/Indiana/Petersburg"
            },
            "AMERICA_INDIANA_TELL_CITY": {
                "text": "America/Indiana/Tell_City",
                "description": "America/Indiana/Tell_City"
            },
            "AMERICA_INDIANA_VEVAY": {
                "text": "America/Indiana/Vevay",
                "description": "America/Indiana/Vevay"
            },
            "AMERICA_INDIANA_VINCENNES": {
                "text": "America/Indiana/Vincennes",
                "description": "America/Indiana/Vincennes"
            },
            "AMERICA_INDIANA_WINAMAC": {
                "text": "America/Indiana/Winamac",
                "description": "America/Indiana/Winamac"
            },
            "AMERICA_INDIANAPOLIS": {
                "text": "America/Indianapolis",
                "description": "America/Indianapolis"
            },
            "AMERICA_INUVIK": {
                "text": "America/Inuvik",
                "description": "America/Inuvik"
            },
            "AMERICA_IQALUIT": {
                "text": "America/Iqaluit",
                "description": "America/Iqaluit"
            },
            "AMERICA_JAMAICA": {
                "text": "America/Jamaica",
                "description": "America/Jamaica"
            },
            "AMERICA_JUJUY": {
                "text": "America/Jujuy",
                "description": "America/Jujuy"
            },
            "AMERICA_JUNEAU": {
                "text": "America/Juneau",
                "description": "America/Juneau"
            },
            "AMERICA_KENTUCKY_LOUISVILLE": {
                "text": "America/Kentucky/Louisville",
                "description": "America/Kentucky/Louisville"
            },
            "AMERICA_KENTUCKY_MONTICELLO": {
                "text": "America/Kentucky/Monticello",
                "description": "America/Kentucky/Monticello"
            },
            "AMERICA_KNOX_IN": {
                "text": "America/Knox_IN",
                "description": "America/Knox_IN"
            },
            "AMERICA_KRALENDIJK": {
                "text": "America/Kralendijk",
                "description": "America/Kralendijk"
            },
            "AMERICA_LA_PAZ": {
                "text": "America/La_Paz",
                "description": "America/La_Paz"
            },
            "AMERICA_LIMA": {
                "text": "America/Lima",
                "description": "America/Lima"
            },
            "AMERICA_LOS_ANGELES": {
                "text": "America/Los_Angeles",
                "description": "America/Los_Angeles"
            },
            "AMERICA_LOUISVILLE": {
                "text": "America/Louisville",
                "description": "America/Louisville"
            },
            "AMERICA_LOWER_PRINCES": {
                "text": "America/Lower_Princes",
                "description": "America/Lower_Princes"
            },
            "AMERICA_MACEIO": {
                "text": "America/Maceio",
                "description": "America/Maceio"
            },
            "AMERICA_MANAGUA": {
                "text": "America/Managua",
                "description": "America/Managua"
            },
            "AMERICA_MANAUS": {
                "text": "America/Manaus",
                "description": "America/Manaus"
            },
            "AMERICA_MARIGOT": {
                "text": "America/Marigot",
                "description": "America/Marigot"
            },
            "AMERICA_MARTINIQUE": {
                "text": "America/Martinique",
                "description": "America/Martinique"
            },
            "AMERICA_MATAMOROS": {
                "text": "America/Matamoros",
                "description": "America/Matamoros"
            },
            "AMERICA_MAZATLAN": {
                "text": "America/Mazatlan",
                "description": "America/Mazatlan"
            },
            "AMERICA_MENDOZA": {
                "text": "America/Mendoza",
                "description": "America/Mendoza"
            },
            "AMERICA_MENOMINEE": {
                "text": "America/Menominee",
                "description": "America/Menominee"
            },
            "AMERICA_MERIDA": {
                "text": "America/Merida",
                "description": "America/Merida"
            },
            "AMERICA_METLAKATLA": {
                "text": "America/Metlakatla",
                "description": "America/Metlakatla"
            },
            "AMERICA_MEXICO_CITY": {
                "text": "America/Mexico_City",
                "description": "America/Mexico_City"
            },
            "AMERICA_MIQUELON": {
                "text": "America/Miquelon",
                "description": "America/Miquelon"
            },
            "AMERICA_MONCTON": {
                "text": "America/Moncton",
                "description": "America/Moncton"
            },
            "AMERICA_MONTERREY": {
                "text": "America/Monterrey",
                "description": "America/Monterrey"
            },
            "AMERICA_MONTEVIDEO": {
                "text": "America/Montevideo",
                "description": "America/Montevideo"
            },
            "AMERICA_MONTREAL": {
                "text": "America/Montreal",
                "description": "America/Montreal"
            },
            "AMERICA_MONTSERRAT": {
                "text": "America/Montserrat",
                "description": "America/Montserrat"
            },
            "AMERICA_NASSAU": {
                "text": "America/Nassau",
                "description": "America/Nassau"
            },
            "AMERICA_NEW_YORK": {
                "text": "America/New_York",
                "description": "America/New_York"
            },
            "AMERICA_NIPIGON": {
                "text": "America/Nipigon",
                "description": "America/Nipigon"
            },
            "AMERICA_NOME": {
                "text": "America/Nome",
                "description": "America/Nome"
            },
            "AMERICA_NORONHA": {
                "text": "America/Noronha",
                "description": "America/Noronha"
            },
            "AMERICA_NORTH_DAKOTA_BEULAH": {
                "text": "America/North_Dakota/Beulah",
                "description": "America/North_Dakota/Beulah"
            },
            "AMERICA_NORTH_DAKOTA_CENTER": {
                "text": "America/North_Dakota/Center",
                "description": "America/North_Dakota/Center"
            },
            "AMERICA_NORTH_DAKOTA_NEW_SALEM": {
                "text": "America/North_Dakota/New_Salem",
                "description": "America/North_Dakota/New_Salem"
            },
            "AMERICA_OJINAGA": {
                "text": "America/Ojinaga",
                "description": "America/Ojinaga"
            },
            "AMERICA_PANAMA": {
                "text": "America/Panama",
                "description": "America/Panama"
            },
            "AMERICA_PANGNIRTUNG": {
                "text": "America/Pangnirtung",
                "description": "America/Pangnirtung"
            },
            "AMERICA_PARAMARIBO": {
                "text": "America/Paramaribo",
                "description": "America/Paramaribo"
            },
            "AMERICA_PHOENIX": {
                "text": "America/Phoenix",
                "description": "America/Phoenix"
            },
            "AMERICA_PORT_MINUS_AU_MINUS_PRINCE": {
                "text": "America/Port-au-Prince",
                "description": "America/Port-au-Prince"
            },
            "AMERICA_PORT_OF_SPAIN": {
                "text": "America/Port_of_Spain",
                "description": "America/Port_of_Spain"
            },
            "AMERICA_PORTO_ACRE": {
                "text": "America/Porto_Acre",
                "description": "America/Porto_Acre"
            },
            "AMERICA_PORTO_VELHO": {
                "text": "America/Porto_Velho",
                "description": "America/Porto_Velho"
            },
            "AMERICA_PUERTO_RICO": {
                "text": "America/Puerto_Rico",
                "description": "America/Puerto_Rico"
            },
            "AMERICA_PUNTA_ARENAS": {
                "text": "America/Punta_Arenas",
                "description": "America/Punta_Arenas"
            },
            "AMERICA_RAINY_RIVER": {
                "text": "America/Rainy_River",
                "description": "America/Rainy_River"
            },
            "AMERICA_RANKIN_INLET": {
                "text": "America/Rankin_Inlet",
                "description": "America/Rankin_Inlet"
            },
            "AMERICA_RECIFE": {
                "text": "America/Recife",
                "description": "America/Recife"
            },
            "AMERICA_REGINA": {
                "text": "America/Regina",
                "description": "America/Regina"
            },
            "AMERICA_RESOLUTE": {
                "text": "America/Resolute",
                "description": "America/Resolute"
            },
            "AMERICA_RIO_BRANCO": {
                "text": "America/Rio_Branco",
                "description": "America/Rio_Branco"
            },
            "AMERICA_ROSARIO": {
                "text": "America/Rosario",
                "description": "America/Rosario"
            },
            "AMERICA_SANTA_ISABEL": {
                "text": "America/Santa_Isabel",
                "description": "America/Santa_Isabel"
            },
            "AMERICA_SANTAREM": {
                "text": "America/Santarem",
                "description": "America/Santarem"
            },
            "AMERICA_SANTIAGO": {
                "text": "America/Santiago",
                "description": "America/Santiago"
            },
            "AMERICA_SANTO_DOMINGO": {
                "text": "America/Santo_Domingo",
                "description": "America/Santo_Domingo"
            },
            "AMERICA_SAO_PAULO": {
                "text": "America/Sao_Paulo",
                "description": "America/Sao_Paulo"
            },
            "AMERICA_SCORESBYSUND": {
                "text": "America/Scoresbysund",
                "description": "America/Scoresbysund"
            },
            "AMERICA_SHIPROCK": {
                "text": "America/Shiprock",
                "description": "America/Shiprock"
            },
            "AMERICA_SITKA": {
                "text": "America/Sitka",
                "description": "America/Sitka"
            },
            "AMERICA_ST_BARTHELEMY": {
                "text": "America/St_Barthelemy",
                "description": "America/St_Barthelemy"
            },
            "AMERICA_ST_JOHNS": {
                "text": "America/St_Johns",
                "description": "America/St_Johns"
            },
            "AMERICA_ST_KITTS": {
                "text": "America/St_Kitts",
                "description": "America/St_Kitts"
            },
            "AMERICA_ST_LUCIA": {
                "text": "America/St_Lucia",
                "description": "America/St_Lucia"
            },
            "AMERICA_ST_THOMAS": {
                "text": "America/St_Thomas",
                "description": "America/St_Thomas"
            },
            "AMERICA_ST_VINCENT": {
                "text": "America/St_Vincent",
                "description": "America/St_Vincent"
            },
            "AMERICA_SWIFT_CURRENT": {
                "text": "America/Swift_Current",
                "description": "America/Swift_Current"
            },
            "AMERICA_TEGUCIGALPA": {
                "text": "America/Tegucigalpa",
                "description": "America/Tegucigalpa"
            },
            "AMERICA_THULE": {
                "text": "America/Thule",
                "description": "America/Thule"
            },
            "AMERICA_THUNDER_BAY": {
                "text": "America/Thunder_Bay",
                "description": "America/Thunder_Bay"
            },
            "AMERICA_TIJUANA": {
                "text": "America/Tijuana",
                "description": "America/Tijuana"
            },
            "AMERICA_TORONTO": {
                "text": "America/Toronto",
                "description": "America/Toronto"
            },
            "AMERICA_TORTOLA": {
                "text": "America/Tortola",
                "description": "America/Tortola"
            },
            "AMERICA_VANCOUVER": {
                "text": "America/Vancouver",
                "description": "America/Vancouver"
            },
            "AMERICA_VIRGIN": {
                "text": "America/Virgin",
                "description": "America/Virgin"
            },
            "AMERICA_WHITEHORSE": {
                "text": "America/Whitehorse",
                "description": "America/Whitehorse"
            },
            "AMERICA_WINNIPEG": {
                "text": "America/Winnipeg",
                "description": "America/Winnipeg"
            },
            "AMERICA_YAKUTAT": {
                "text": "America/Yakutat",
                "description": "America/Yakutat"
            },
            "AMERICA_YELLOWKNIFE": {
                "text": "America/Yellowknife",
                "description": "America/Yellowknife"
            },
            "ANTARCTICA_CASEY": {
                "text": "Antarctica/Casey",
                "description": "Antarctica/Casey"
            },
            "ANTARCTICA_DAVIS": {
                "text": "Antarctica/Davis",
                "description": "Antarctica/Davis"
            },
            "ANTARCTICA_DUMONTDURVILLE": {
                "text": "Antarctica/DumontDUrville",
                "description": "Antarctica/DumontDUrville"
            },
            "ANTARCTICA_MACQUARIE": {
                "text": "Antarctica/Macquarie",
                "description": "Antarctica/Macquarie"
            },
            "ANTARCTICA_MAWSON": {
                "text": "Antarctica/Mawson",
                "description": "Antarctica/Mawson"
            },
            "ANTARCTICA_MCMURDO": {
                "text": "Antarctica/McMurdo",
                "description": "Antarctica/McMurdo"
            },
            "ANTARCTICA_PALMER": {
                "text": "Antarctica/Palmer",
                "description": "Antarctica/Palmer"
            },
            "ANTARCTICA_ROTHERA": {
                "text": "Antarctica/Rothera",
                "description": "Antarctica/Rothera"
            },
            "ANTARCTICA_SOUTH_POLE": {
                "text": "Antarctica/South_Pole",
                "description": "Antarctica/South_Pole"
            },
            "ANTARCTICA_SYOWA": {
                "text": "Antarctica/Syowa",
                "description": "Antarctica/Syowa"
            },
            "ANTARCTICA_TROLL": {
                "text": "Antarctica/Troll",
                "description": "Antarctica/Troll"
            },
            "ANTARCTICA_VOSTOK": {
                "text": "Antarctica/Vostok",
                "description": "Antarctica/Vostok"
            },
            "ARCTIC_LONGYEARBYEN": {
                "text": "Arctic/Longyearbyen",
                "description": "Arctic/Longyearbyen"
            },
            "ASIA_ADEN": {
                "text": "Asia/Aden",
                "description": "Asia/Aden"
            },
            "ASIA_ALMATY": {
                "text": "Asia/Almaty",
                "description": "Asia/Almaty"
            },
            "ASIA_AMMAN": {
                "text": "Asia/Amman",
                "description": "Asia/Amman"
            },
            "ASIA_ANADYR": {
                "text": "Asia/Anadyr",
                "description": "Asia/Anadyr"
            },
            "ASIA_AQTAU": {
                "text": "Asia/Aqtau",
                "description": "Asia/Aqtau"
            },
            "ASIA_AQTOBE": {
                "text": "Asia/Aqtobe",
                "description": "Asia/Aqtobe"
            },
            "ASIA_ASHGABAT": {
                "text": "Asia/Ashgabat",
                "description": "Asia/Ashgabat"
            },
            "ASIA_ASHKHABAD": {
                "text": "Asia/Ashkhabad",
                "description": "Asia/Ashkhabad"
            },
            "ASIA_ATYRAU": {
                "text": "Asia/Atyrau",
                "description": "Asia/Atyrau"
            },
            "ASIA_BAGHDAD": {
                "text": "Asia/Baghdad",
                "description": "Asia/Baghdad"
            },
            "ASIA_BAHRAIN": {
                "text": "Asia/Bahrain",
                "description": "Asia/Bahrain"
            },
            "ASIA_BAKU": {
                "text": "Asia/Baku",
                "description": "Asia/Baku"
            },
            "ASIA_BANGKOK": {
                "text": "Asia/Bangkok",
                "description": "Asia/Bangkok"
            },
            "ASIA_BARNAUL": {
                "text": "Asia/Barnaul",
                "description": "Asia/Barnaul"
            },
            "ASIA_BEIRUT": {
                "text": "Asia/Beirut",
                "description": "Asia/Beirut"
            },
            "ASIA_BISHKEK": {
                "text": "Asia/Bishkek",
                "description": "Asia/Bishkek"
            },
            "ASIA_BRUNEI": {
                "text": "Asia/Brunei",
                "description": "Asia/Brunei"
            },
            "ASIA_CALCUTTA": {
                "text": "Asia/Calcutta",
                "description": "Asia/Calcutta"
            },
            "ASIA_CHITA": {
                "text": "Asia/Chita",
                "description": "Asia/Chita"
            },
            "ASIA_CHOIBALSAN": {
                "text": "Asia/Choibalsan",
                "description": "Asia/Choibalsan"
            },
            "ASIA_CHONGQING": {
                "text": "Asia/Chongqing",
                "description": "Asia/Chongqing"
            },
            "ASIA_CHUNGKING": {
                "text": "Asia/Chungking",
                "description": "Asia/Chungking"
            },
            "ASIA_COLOMBO": {
                "text": "Asia/Colombo",
                "description": "Asia/Colombo"
            },
            "ASIA_DACCA": {
                "text": "Asia/Dacca",
                "description": "Asia/Dacca"
            },
            "ASIA_DAMASCUS": {
                "text": "Asia/Damascus",
                "description": "Asia/Damascus"
            },
            "ASIA_DHAKA": {
                "text": "Asia/Dhaka",
                "description": "Asia/Dhaka"
            },
            "ASIA_DILI": {
                "text": "Asia/Dili",
                "description": "Asia/Dili"
            },
            "ASIA_DUBAI": {
                "text": "Asia/Dubai",
                "description": "Asia/Dubai"
            },
            "ASIA_DUSHANBE": {
                "text": "Asia/Dushanbe",
                "description": "Asia/Dushanbe"
            },
            "ASIA_FAMAGUSTA": {
                "text": "Asia/Famagusta",
                "description": "Asia/Famagusta"
            },
            "ASIA_GAZA": {
                "text": "Asia/Gaza",
                "description": "Asia/Gaza"
            },
            "ASIA_HARBIN": {
                "text": "Asia/Harbin",
                "description": "Asia/Harbin"
            },
            "ASIA_HEBRON": {
                "text": "Asia/Hebron",
                "description": "Asia/Hebron"
            },
            "ASIA_HO_CHI_MINH": {
                "text": "Asia/Ho_Chi_Minh",
                "description": "Asia/Ho_Chi_Minh"
            },
            "ASIA_HONG_KONG": {
                "text": "Asia/Hong_Kong",
                "description": "Asia/Hong_Kong"
            },
            "ASIA_HOVD": {
                "text": "Asia/Hovd",
                "description": "Asia/Hovd"
            },
            "ASIA_IRKUTSK": {
                "text": "Asia/Irkutsk",
                "description": "Asia/Irkutsk"
            },
            "ASIA_ISTANBUL": {
                "text": "Asia/Istanbul",
                "description": "Asia/Istanbul"
            },
            "ASIA_JAKARTA": {
                "text": "Asia/Jakarta",
                "description": "Asia/Jakarta"
            },
            "ASIA_JAYAPURA": {
                "text": "Asia/Jayapura",
                "description": "Asia/Jayapura"
            },
            "ASIA_JERUSALEM": {
                "text": "Asia/Jerusalem",
                "description": "Asia/Jerusalem"
            },
            "ASIA_KABUL": {
                "text": "Asia/Kabul",
                "description": "Asia/Kabul"
            },
            "ASIA_KAMCHATKA": {
                "text": "Asia/Kamchatka",
                "description": "Asia/Kamchatka"
            },
            "ASIA_KARACHI": {
                "text": "Asia/Karachi",
                "description": "Asia/Karachi"
            },
            "ASIA_KASHGAR": {
                "text": "Asia/Kashgar",
                "description": "Asia/Kashgar"
            },
            "ASIA_KATHMANDU": {
                "text": "Asia/Kathmandu",
                "description": "Asia/Kathmandu"
            },
            "ASIA_KATMANDU": {
                "text": "Asia/Katmandu",
                "description": "Asia/Katmandu"
            },
            "ASIA_KHANDYGA": {
                "text": "Asia/Khandyga",
                "description": "Asia/Khandyga"
            },
            "ASIA_KOLKATA": {
                "text": "Asia/Kolkata",
                "description": "Asia/Kolkata"
            },
            "ASIA_KRASNOYARSK": {
                "text": "Asia/Krasnoyarsk",
                "description": "Asia/Krasnoyarsk"
            },
            "ASIA_KUALA_LUMPUR": {
                "text": "Asia/Kuala_Lumpur",
                "description": "Asia/Kuala_Lumpur"
            },
            "ASIA_KUCHING": {
                "text": "Asia/Kuching",
                "description": "Asia/Kuching"
            },
            "ASIA_KUWAIT": {
                "text": "Asia/Kuwait",
                "description": "Asia/Kuwait"
            },
            "ASIA_MACAO": {
                "text": "Asia/Macao",
                "description": "Asia/Macao"
            },
            "ASIA_MACAU": {
                "text": "Asia/Macau",
                "description": "Asia/Macau"
            },
            "ASIA_MAGADAN": {
                "text": "Asia/Magadan",
                "description": "Asia/Magadan"
            },
            "ASIA_MAKASSAR": {
                "text": "Asia/Makassar",
                "description": "Asia/Makassar"
            },
            "ASIA_MANILA": {
                "text": "Asia/Manila",
                "description": "Asia/Manila"
            },
            "ASIA_MUSCAT": {
                "text": "Asia/Muscat",
                "description": "Asia/Muscat"
            },
            "ASIA_NICOSIA": {
                "text": "Asia/Nicosia",
                "description": "Asia/Nicosia"
            },
            "ASIA_NOVOKUZNETSK": {
                "text": "Asia/Novokuznetsk",
                "description": "Asia/Novokuznetsk"
            },
            "ASIA_NOVOSIBIRSK": {
                "text": "Asia/Novosibirsk",
                "description": "Asia/Novosibirsk"
            },
            "ASIA_OMSK": {
                "text": "Asia/Omsk",
                "description": "Asia/Omsk"
            },
            "ASIA_ORAL": {
                "text": "Asia/Oral",
                "description": "Asia/Oral"
            },
            "ASIA_PHNOM_PENH": {
                "text": "Asia/Phnom_Penh",
                "description": "Asia/Phnom_Penh"
            },
            "ASIA_PONTIANAK": {
                "text": "Asia/Pontianak",
                "description": "Asia/Pontianak"
            },
            "ASIA_PYONGYANG": {
                "text": "Asia/Pyongyang",
                "description": "Asia/Pyongyang"
            },
            "ASIA_QATAR": {
                "text": "Asia/Qatar",
                "description": "Asia/Qatar"
            },
            "ASIA_QOSTANAY": {
                "text": "Asia/Qostanay",
                "description": "Asia/Qostanay"
            },
            "ASIA_QYZYLORDA": {
                "text": "Asia/Qyzylorda",
                "description": "Asia/Qyzylorda"
            },
            "ASIA_RANGOON": {
                "text": "Asia/Rangoon",
                "description": "Asia/Rangoon"
            },
            "ASIA_RIYADH": {
                "text": "Asia/Riyadh",
                "description": "Asia/Riyadh"
            },
            "ASIA_SAIGON": {
                "text": "Asia/Saigon",
                "description": "Asia/Saigon"
            },
            "ASIA_SAKHALIN": {
                "text": "Asia/Sakhalin",
                "description": "Asia/Sakhalin"
            },
            "ASIA_SAMARKAND": {
                "text": "Asia/Samarkand",
                "description": "Asia/Samarkand"
            },
            "ASIA_SEOUL": {
                "text": "Asia/Seoul",
                "description": "Asia/Seoul"
            },
            "ASIA_SHANGHAI": {
                "text": "Asia/Shanghai",
                "description": "Asia/Shanghai"
            },
            "ASIA_SINGAPORE": {
                "text": "Asia/Singapore",
                "description": "Asia/Singapore"
            },
            "ASIA_SREDNEKOLYMSK": {
                "text": "Asia/Srednekolymsk",
                "description": "Asia/Srednekolymsk"
            },
            "ASIA_TAIPEI": {
                "text": "Asia/Taipei",
                "description": "Asia/Taipei"
            },
            "ASIA_TASHKENT": {
                "text": "Asia/Tashkent",
                "description": "Asia/Tashkent"
            },
            "ASIA_TBILISI": {
                "text": "Asia/Tbilisi",
                "description": "Asia/Tbilisi"
            },
            "ASIA_TEHRAN": {
                "text": "Asia/Tehran",
                "description": "Asia/Tehran"
            },
            "ASIA_TEL_AVIV": {
                "text": "Asia/Tel_Aviv",
                "description": "Asia/Tel_Aviv"
            },
            "ASIA_THIMBU": {
                "text": "Asia/Thimbu",
                "description": "Asia/Thimbu"
            },
            "ASIA_THIMPHU": {
                "text": "Asia/Thimphu",
                "description": "Asia/Thimphu"
            },
            "ASIA_TOKYO": {
                "text": "Asia/Tokyo",
                "description": "Asia/Tokyo"
            },
            "ASIA_TOMSK": {
                "text": "Asia/Tomsk",
                "description": "Asia/Tomsk"
            },
            "ASIA_UJUNG_PANDANG": {
                "text": "Asia/Ujung_Pandang",
                "description": "Asia/Ujung_Pandang"
            },
            "ASIA_ULAANBAATAR": {
                "text": "Asia/Ulaanbaatar",
                "description": "Asia/Ulaanbaatar"
            },
            "ASIA_ULAN_BATOR": {
                "text": "Asia/Ulan_Bator",
                "description": "Asia/Ulan_Bator"
            },
            "ASIA_URUMQI": {
                "text": "Asia/Urumqi",
                "description": "Asia/Urumqi"
            },
            "ASIA_UST_MINUS_NERA": {
                "text": "Asia/Ust-Nera",
                "description": "Asia/Ust-Nera"
            },
            "ASIA_VIENTIANE": {
                "text": "Asia/Vientiane",
                "description": "Asia/Vientiane"
            },
            "ASIA_VLADIVOSTOK": {
                "text": "Asia/Vladivostok",
                "description": "Asia/Vladivostok"
            },
            "ASIA_YAKUTSK": {
                "text": "Asia/Yakutsk",
                "description": "Asia/Yakutsk"
            },
            "ASIA_YANGON": {
                "text": "Asia/Yangon",
                "description": "Asia/Yangon"
            },
            "ASIA_YEKATERINBURG": {
                "text": "Asia/Yekaterinburg",
                "description": "Asia/Yekaterinburg"
            },
            "ASIA_YEREVAN": {
                "text": "Asia/Yerevan",
                "description": "Asia/Yerevan"
            },
            "ATLANTIC_AZORES": {
                "text": "Atlantic/Azores",
                "description": "Atlantic/Azores"
            },
            "ATLANTIC_BERMUDA": {
                "text": "Atlantic/Bermuda",
                "description": "Atlantic/Bermuda"
            },
            "ATLANTIC_CANARY": {
                "text": "Atlantic/Canary",
                "description": "Atlantic/Canary"
            },
            "ATLANTIC_CAPE_VERDE": {
                "text": "Atlantic/Cape_Verde",
                "description": "Atlantic/Cape_Verde"
            },
            "ATLANTIC_FAEROE": {
                "text": "Atlantic/Faeroe",
                "description": "Atlantic/Faeroe"
            },
            "ATLANTIC_FAROE": {
                "text": "Atlantic/Faroe",
                "description": "Atlantic/Faroe"
            },
            "ATLANTIC_JAN_MAYEN": {
                "text": "Atlantic/Jan_Mayen",
                "description": "Atlantic/Jan_Mayen"
            },
            "ATLANTIC_MADEIRA": {
                "text": "Atlantic/Madeira",
                "description": "Atlantic/Madeira"
            },
            "ATLANTIC_REYKJAVIK": {
                "text": "Atlantic/Reykjavik",
                "description": "Atlantic/Reykjavik"
            },
            "ATLANTIC_SOUTH_GEORGIA": {
                "text": "Atlantic/South_Georgia",
                "description": "Atlantic/South_Georgia"
            },
            "ATLANTIC_ST_HELENA": {
                "text": "Atlantic/St_Helena",
                "description": "Atlantic/St_Helena"
            },
            "ATLANTIC_STANLEY": {
                "text": "Atlantic/Stanley",
                "description": "Atlantic/Stanley"
            },
            "AUSTRALIA_ACT": {
                "text": "Australia/ACT",
                "description": "Australia/ACT"
            },
            "AUSTRALIA_ADELAIDE": {
                "text": "Australia/Adelaide",
                "description": "Australia/Adelaide"
            },
            "AUSTRALIA_BRISBANE": {
                "text": "Australia/Brisbane",
                "description": "Australia/Brisbane"
            },
            "AUSTRALIA_BROKEN_HILL": {
                "text": "Australia/Broken_Hill",
                "description": "Australia/Broken_Hill"
            },
            "AUSTRALIA_CANBERRA": {
                "text": "Australia/Canberra",
                "description": "Australia/Canberra"
            },
            "AUSTRALIA_CURRIE": {
                "text": "Australia/Currie",
                "description": "Australia/Currie"
            },
            "AUSTRALIA_DARWIN": {
                "text": "Australia/Darwin",
                "description": "Australia/Darwin"
            },
            "AUSTRALIA_EUCLA": {
                "text": "Australia/Eucla",
                "description": "Australia/Eucla"
            },
            "AUSTRALIA_HOBART": {
                "text": "Australia/Hobart",
                "description": "Australia/Hobart"
            },
            "AUSTRALIA_LHI": {
                "text": "Australia/LHI",
                "description": "Australia/LHI"
            },
            "AUSTRALIA_LINDEMAN": {
                "text": "Australia/Lindeman",
                "description": "Australia/Lindeman"
            },
            "AUSTRALIA_LORD_HOWE": {
                "text": "Australia/Lord_Howe",
                "description": "Australia/Lord_Howe"
            },
            "AUSTRALIA_MELBOURNE": {
                "text": "Australia/Melbourne",
                "description": "Australia/Melbourne"
            },
            "AUSTRALIA_NSW": {
                "text": "Australia/NSW",
                "description": "Australia/NSW"
            },
            "AUSTRALIA_NORTH": {
                "text": "Australia/North",
                "description": "Australia/North"
            },
            "AUSTRALIA_PERTH": {
                "text": "Australia/Perth",
                "description": "Australia/Perth"
            },
            "AUSTRALIA_QUEENSLAND": {
                "text": "Australia/Queensland",
                "description": "Australia/Queensland"
            },
            "AUSTRALIA_SOUTH": {
                "text": "Australia/South",
                "description": "Australia/South"
            },
            "AUSTRALIA_SYDNEY": {
                "text": "Australia/Sydney",
                "description": "Australia/Sydney"
            },
            "AUSTRALIA_TASMANIA": {
                "text": "Australia/Tasmania",
                "description": "Australia/Tasmania"
            },
            "AUSTRALIA_VICTORIA": {
                "text": "Australia/Victoria",
                "description": "Australia/Victoria"
            },
            "AUSTRALIA_WEST": {
                "text": "Australia/West",
                "description": "Australia/West"
            },
            "AUSTRALIA_YANCOWINNA": {
                "text": "Australia/Yancowinna",
                "description": "Australia/Yancowinna"
            },
            "BRAZIL_ACRE": {
                "text": "Brazil/Acre",
                "description": "Brazil/Acre"
            },
            "BRAZIL_DENORONHA": {
                "text": "Brazil/DeNoronha",
                "description": "Brazil/DeNoronha"
            },
            "BRAZIL_EAST": {
                "text": "Brazil/East",
                "description": "Brazil/East"
            },
            "BRAZIL_WEST": {
                "text": "Brazil/West",
                "description": "Brazil/West"
            },
            "CET": {
                "text": "CET",
                "description": "CET"
            },
            "CST6CDT": {
                "text": "CST6CDT",
                "description": "CST6CDT"
            },
            "CANADA_ATLANTIC": {
                "text": "Canada/Atlantic",
                "description": "Canada/Atlantic"
            },
            "CANADA_CENTRAL": {
                "text": "Canada/Central",
                "description": "Canada/Central"
            },
            "CANADA_EASTERN": {
                "text": "Canada/Eastern",
                "description": "Canada/Eastern"
            },
            "CANADA_MOUNTAIN": {
                "text": "Canada/Mountain",
                "description": "Canada/Mountain"
            },
            "CANADA_NEWFOUNDLAND": {
                "text": "Canada/Newfoundland",
                "description": "Canada/Newfoundland"
            },
            "CANADA_PACIFIC": {
                "text": "Canada/Pacific",
                "description": "Canada/Pacific"
            },
            "CANADA_SASKATCHEWAN": {
                "text": "Canada/Saskatchewan",
                "description": "Canada/Saskatchewan"
            },
            "CANADA_YUKON": {
                "text": "Canada/Yukon",
                "description": "Canada/Yukon"
            },
            "CHILE_CONTINENTAL": {
                "text": "Chile/Continental",
                "description": "Chile/Continental"
            },
            "CHILE_EASTERISLAND": {
                "text": "Chile/EasterIsland",
                "description": "Chile/EasterIsland"
            },
            "CUBA": {
                "text": "Cuba",
                "description": "Cuba"
            },
            "EET": {
                "text": "EET",
                "description": "EET"
            },
            "EST": {
                "text": "EST",
                "description": "EST"
            },
            "EST5EDT": {
                "text": "EST5EDT",
                "description": "EST5EDT"
            },
            "EGYPT": {
                "text": "Egypt",
                "description": "Egypt"
            },
            "EIRE": {
                "text": "Eire",
                "description": "Eire"
            },
            "ETC_GMT": {
                "text": "Etc/GMT",
                "description": "Etc/GMT"
            },
            "ETC_GMT_PLUS_0": {
                "text": "Etc/GMT+0",
                "description": "Etc/GMT+0"
            },
            "ETC_GMT_PLUS_1": {
                "text": "Etc/GMT+1",
                "description": "Etc/GMT+1"
            },
            "ETC_GMT_PLUS_10": {
                "text": "Etc/GMT+10",
                "description": "Etc/GMT+10"
            },
            "ETC_GMT_PLUS_11": {
                "text": "Etc/GMT+11",
                "description": "Etc/GMT+11"
            },
            "ETC_GMT_PLUS_12": {
                "text": "Etc/GMT+12",
                "description": "Etc/GMT+12"
            },
            "ETC_GMT_PLUS_2": {
                "text": "Etc/GMT+2",
                "description": "Etc/GMT+2"
            },
            "ETC_GMT_PLUS_3": {
                "text": "Etc/GMT+3",
                "description": "Etc/GMT+3"
            },
            "ETC_GMT_PLUS_4": {
                "text": "Etc/GMT+4",
                "description": "Etc/GMT+4"
            },
            "ETC_GMT_PLUS_5": {
                "text": "Etc/GMT+5",
                "description": "Etc/GMT+5"
            },
            "ETC_GMT_PLUS_6": {
                "text": "Etc/GMT+6",
                "description": "Etc/GMT+6"
            },
            "ETC_GMT_PLUS_7": {
                "text": "Etc/GMT+7",
                "description": "Etc/GMT+7"
            },
            "ETC_GMT_PLUS_8": {
                "text": "Etc/GMT+8",
                "description": "Etc/GMT+8"
            },
            "ETC_GMT_PLUS_9": {
                "text": "Etc/GMT+9",
                "description": "Etc/GMT+9"
            },
            "ETC_GMT_MINUS_0": {
                "text": "Etc/GMT-0",
                "description": "Etc/GMT-0"
            },
            "ETC_GMT_MINUS_1": {
                "text": "Etc/GMT-1",
                "description": "Etc/GMT-1"
            },
            "ETC_GMT_MINUS_10": {
                "text": "Etc/GMT-10",
                "description": "Etc/GMT-10"
            },
            "ETC_GMT_MINUS_11": {
                "text": "Etc/GMT-11",
                "description": "Etc/GMT-11"
            },
            "ETC_GMT_MINUS_12": {
                "text": "Etc/GMT-12",
                "description": "Etc/GMT-12"
            },
            "ETC_GMT_MINUS_13": {
                "text": "Etc/GMT-13",
                "description": "Etc/GMT-13"
            },
            "ETC_GMT_MINUS_14": {
                "text": "Etc/GMT-14",
                "description": "Etc/GMT-14"
            },
            "ETC_GMT_MINUS_2": {
                "text": "Etc/GMT-2",
                "description": "Etc/GMT-2"
            },
            "ETC_GMT_MINUS_3": {
                "text": "Etc/GMT-3",
                "description": "Etc/GMT-3"
            },
            "ETC_GMT_MINUS_4": {
                "text": "Etc/GMT-4",
                "description": "Etc/GMT-4"
            },
            "ETC_GMT_MINUS_5": {
                "text": "Etc/GMT-5",
                "description": "Etc/GMT-5"
            },
            "ETC_GMT_MINUS_6": {
                "text": "Etc/GMT-6",
                "description": "Etc/GMT-6"
            },
            "ETC_GMT_MINUS_7": {
                "text": "Etc/GMT-7",
                "description": "Etc/GMT-7"
            },
            "ETC_GMT_MINUS_8": {
                "text": "Etc/GMT-8",
                "description": "Etc/GMT-8"
            },
            "ETC_GMT_MINUS_9": {
                "text": "Etc/GMT-9",
                "description": "Etc/GMT-9"
            },
            "ETC_GMT0": {
                "text": "Etc/GMT0",
                "description": "Etc/GMT0"
            },
            "ETC_GREENWICH": {
                "text": "Etc/Greenwich",
                "description": "Etc/Greenwich"
            },
            "ETC_UCT": {
                "text": "Etc/UCT",
                "description": "Etc/UCT"
            },
            "ETC_UTC": {
                "text": "Etc/UTC",
                "description": "Etc/UTC"
            },
            "ETC_UNIVERSAL": {
                "text": "Etc/Universal",
                "description": "Etc/Universal"
            },
            "ETC_ZULU": {
                "text": "Etc/Zulu",
                "description": "Etc/Zulu"
            },
            "EUROPE_AMSTERDAM": {
                "text": "Europe/Amsterdam",
                "description": "Europe/Amsterdam"
            },
            "EUROPE_ANDORRA": {
                "text": "Europe/Andorra",
                "description": "Europe/Andorra"
            },
            "EUROPE_ASTRAKHAN": {
                "text": "Europe/Astrakhan",
                "description": "Europe/Astrakhan"
            },
            "EUROPE_ATHENS": {
                "text": "Europe/Athens",
                "description": "Europe/Athens"
            },
            "EUROPE_BELFAST": {
                "text": "Europe/Belfast",
                "description": "Europe/Belfast"
            },
            "EUROPE_BELGRADE": {
                "text": "Europe/Belgrade",
                "description": "Europe/Belgrade"
            },
            "EUROPE_BERLIN": {
                "text": "Europe/Berlin",
                "description": "Europe/Berlin"
            },
            "EUROPE_BRATISLAVA": {
                "text": "Europe/Bratislava",
                "description": "Europe/Bratislava"
            },
            "EUROPE_BRUSSELS": {
                "text": "Europe/Brussels",
                "description": "Europe/Brussels"
            },
            "EUROPE_BUCHAREST": {
                "text": "Europe/Bucharest",
                "description": "Europe/Bucharest"
            },
            "EUROPE_BUDAPEST": {
                "text": "Europe/Budapest",
                "description": "Europe/Budapest"
            },
            "EUROPE_BUSINGEN": {
                "text": "Europe/Busingen",
                "description": "Europe/Busingen"
            },
            "EUROPE_CHISINAU": {
                "text": "Europe/Chisinau",
                "description": "Europe/Chisinau"
            },
            "EUROPE_COPENHAGEN": {
                "text": "Europe/Copenhagen",
                "description": "Europe/Copenhagen"
            },
            "EUROPE_DUBLIN": {
                "text": "Europe/Dublin",
                "description": "Europe/Dublin"
            },
            "EUROPE_GIBRALTAR": {
                "text": "Europe/Gibraltar",
                "description": "Europe/Gibraltar"
            },
            "EUROPE_GUERNSEY": {
                "text": "Europe/Guernsey",
                "description": "Europe/Guernsey"
            },
            "EUROPE_HELSINKI": {
                "text": "Europe/Helsinki",
                "description": "Europe/Helsinki"
            },
            "EUROPE_ISLE_OF_MAN": {
                "text": "Europe/Isle_of_Man",
                "description": "Europe/Isle_of_Man"
            },
            "EUROPE_ISTANBUL": {
                "text": "Europe/Istanbul",
                "description": "Europe/Istanbul"
            },
            "EUROPE_JERSEY": {
                "text": "Europe/Jersey",
                "description": "Europe/Jersey"
            },
            "EUROPE_KALININGRAD": {
                "text": "Europe/Kaliningrad",
                "description": "Europe/Kaliningrad"
            },
            "EUROPE_KIEV": {
                "text": "Europe/Kiev",
                "description": "Europe/Kiev"
            },
            "EUROPE_KIROV": {
                "text": "Europe/Kirov",
                "description": "Europe/Kirov"
            },
            "EUROPE_LISBON": {
                "text": "Europe/Lisbon",
                "description": "Europe/Lisbon"
            },
            "EUROPE_LJUBLJANA": {
                "text": "Europe/Ljubljana",
                "description": "Europe/Ljubljana"
            },
            "EUROPE_LONDON": {
                "text": "Europe/London",
                "description": "Europe/London"
            },
            "EUROPE_LUXEMBOURG": {
                "text": "Europe/Luxembourg",
                "description": "Europe/Luxembourg"
            },
            "EUROPE_MADRID": {
                "text": "Europe/Madrid",
                "description": "Europe/Madrid"
            },
            "EUROPE_MALTA": {
                "text": "Europe/Malta",
                "description": "Europe/Malta"
            },
            "EUROPE_MARIEHAMN": {
                "text": "Europe/Mariehamn",
                "description": "Europe/Mariehamn"
            },
            "EUROPE_MINSK": {
                "text": "Europe/Minsk",
                "description": "Europe/Minsk"
            },
            "EUROPE_MONACO": {
                "text": "Europe/Monaco",
                "description": "Europe/Monaco"
            },
            "EUROPE_MOSCOW": {
                "text": "Europe/Moscow",
                "description": "Europe/Moscow"
            },
            "EUROPE_NICOSIA": {
                "text": "Europe/Nicosia",
                "description": "Europe/Nicosia"
            },
            "EUROPE_OSLO": {
                "text": "Europe/Oslo",
                "description": "Europe/Oslo"
            },
            "EUROPE_PARIS": {
                "text": "Europe/Paris",
                "description": "Europe/Paris"
            },
            "EUROPE_PODGORICA": {
                "text": "Europe/Podgorica",
                "description": "Europe/Podgorica"
            },
            "EUROPE_PRAGUE": {
                "text": "Europe/Prague",
                "description": "Europe/Prague"
            },
            "EUROPE_RIGA": {
                "text": "Europe/Riga",
                "description": "Europe/Riga"
            },
            "EUROPE_ROME": {
                "text": "Europe/Rome",
                "description": "Europe/Rome"
            },
            "EUROPE_SAMARA": {
                "text": "Europe/Samara",
                "description": "Europe/Samara"
            },
            "EUROPE_SAN_MARINO": {
                "text": "Europe/San_Marino",
                "description": "Europe/San_Marino"
            },
            "EUROPE_SARAJEVO": {
                "text": "Europe/Sarajevo",
                "description": "Europe/Sarajevo"
            },
            "EUROPE_SARATOV": {
                "text": "Europe/Saratov",
                "description": "Europe/Saratov"
            },
            "EUROPE_SIMFEROPOL": {
                "text": "Europe/Simferopol",
                "description": "Europe/Simferopol"
            },
            "EUROPE_SKOPJE": {
                "text": "Europe/Skopje",
                "description": "Europe/Skopje"
            },
            "EUROPE_SOFIA": {
                "text": "Europe/Sofia",
                "description": "Europe/Sofia"
            },
            "EUROPE_STOCKHOLM": {
                "text": "Europe/Stockholm",
                "description": "Europe/Stockholm"
            },
            "EUROPE_TALLINN": {
                "text": "Europe/Tallinn",
                "description": "Europe/Tallinn"
            },
            "EUROPE_TIRANE": {
                "text": "Europe/Tirane",
                "description": "Europe/Tirane"
            },
            "EUROPE_TIRASPOL": {
                "text": "Europe/Tiraspol",
                "description": "Europe/Tiraspol"
            },
            "EUROPE_ULYANOVSK": {
                "text": "Europe/Ulyanovsk",
                "description": "Europe/Ulyanovsk"
            },
            "EUROPE_UZHGOROD": {
                "text": "Europe/Uzhgorod",
                "description": "Europe/Uzhgorod"
            },
            "EUROPE_VADUZ": {
                "text": "Europe/Vaduz",
                "description": "Europe/Vaduz"
            },
            "EUROPE_VATICAN": {
                "text": "Europe/Vatican",
                "description": "Europe/Vatican"
            },
            "EUROPE_VIENNA": {
                "text": "Europe/Vienna",
                "description": "Europe/Vienna"
            },
            "EUROPE_VILNIUS": {
                "text": "Europe/Vilnius",
                "description": "Europe/Vilnius"
            },
            "EUROPE_VOLGOGRAD": {
                "text": "Europe/Volgograd",
                "description": "Europe/Volgograd"
            },
            "EUROPE_WARSAW": {
                "text": "Europe/Warsaw",
                "description": "Europe/Warsaw"
            },
            "EUROPE_ZAGREB": {
                "text": "Europe/Zagreb",
                "description": "Europe/Zagreb"
            },
            "EUROPE_ZAPOROZHYE": {
                "text": "Europe/Zaporozhye",
                "description": "Europe/Zaporozhye"
            },
            "EUROPE_ZURICH": {
                "text": "Europe/Zurich",
                "description": "Europe/Zurich"
            },
            "GB_": {
                "text": "GB",
                "description": "GB"
            },
            "GB_MINUS_EIRE": {
                "text": "GB-Eire",
                "description": "GB-Eire"
            },
            "GMT": {
                "text": "GMT",
                "description": "GMT"
            },
            "GMT_PLUS_0": {
                "text": "GMT+0",
                "description": "GMT+0"
            },
            "GMT_MINUS_0": {
                "text": "GMT-0",
                "description": "GMT-0"
            },
            "GMT0": {
                "text": "GMT0",
                "description": "GMT0"
            },
            "GREENWICH": {
                "text": "Greenwich",
                "description": "Greenwich"
            },
            "HST": {
                "text": "HST",
                "description": "HST"
            },
            "HONGKONG": {
                "text": "Hongkong",
                "description": "Hongkong"
            },
            "ICELAND": {
                "text": "Iceland",
                "description": "Iceland"
            },
            "INDIAN_ANTANANARIVO": {
                "text": "Indian/Antananarivo",
                "description": "Indian/Antananarivo"
            },
            "INDIAN_CHAGOS": {
                "text": "Indian/Chagos",
                "description": "Indian/Chagos"
            },
            "INDIAN_CHRISTMAS": {
                "text": "Indian/Christmas",
                "description": "Indian/Christmas"
            },
            "INDIAN_COCOS": {
                "text": "Indian/Cocos",
                "description": "Indian/Cocos"
            },
            "INDIAN_COMORO": {
                "text": "Indian/Comoro",
                "description": "Indian/Comoro"
            },
            "INDIAN_KERGUELEN": {
                "text": "Indian/Kerguelen",
                "description": "Indian/Kerguelen"
            },
            "INDIAN_MAHE": {
                "text": "Indian/Mahe",
                "description": "Indian/Mahe"
            },
            "INDIAN_MALDIVES": {
                "text": "Indian/Maldives",
                "description": "Indian/Maldives"
            },
            "INDIAN_MAURITIUS": {
                "text": "Indian/Mauritius",
                "description": "Indian/Mauritius"
            },
            "INDIAN_MAYOTTE": {
                "text": "Indian/Mayotte",
                "description": "Indian/Mayotte"
            },
            "INDIAN_REUNION": {
                "text": "Indian/Reunion",
                "description": "Indian/Reunion"
            },
            "IRAN": {
                "text": "Iran",
                "description": "Iran"
            },
            "ISRAEL": {
                "text": "Israel",
                "description": "Israel"
            },
            "JAMAICA": {
                "text": "Jamaica",
                "description": "Jamaica"
            },
            "JAPAN": {
                "text": "Japan",
                "description": "Japan"
            },
            "KWAJALEIN": {
                "text": "Kwajalein",
                "description": "Kwajalein"
            },
            "LIBYA": {
                "text": "Libya",
                "description": "Libya"
            },
            "MET": {
                "text": "MET",
                "description": "MET"
            },
            "MST": {
                "text": "MST",
                "description": "MST"
            },
            "MST7MDT": {
                "text": "MST7MDT",
                "description": "MST7MDT"
            },
            "MEXICO_BAJANORTE": {
                "text": "Mexico/BajaNorte",
                "description": "Mexico/BajaNorte"
            },
            "MEXICO_BAJASUR": {
                "text": "Mexico/BajaSur",
                "description": "Mexico/BajaSur"
            },
            "MEXICO_GENERAL": {
                "text": "Mexico/General",
                "description": "Mexico/General"
            },
            "NZ": {
                "text": "NZ",
                "description": "NZ"
            },
            "NZ_MINUS_CHAT": {
                "text": "NZ-CHAT",
                "description": "NZ-CHAT"
            },
            "NAVAJO": {
                "text": "Navajo",
                "description": "Navajo"
            },
            "PRC": {
                "text": "PRC",
                "description": "PRC"
            },
            "PST8PDT": {
                "text": "PST8PDT",
                "description": "PST8PDT"
            },
            "PACIFIC_APIA": {
                "text": "Pacific/Apia",
                "description": "Pacific/Apia"
            },
            "PACIFIC_AUCKLAND": {
                "text": "Pacific/Auckland",
                "description": "Pacific/Auckland"
            },
            "PACIFIC_BOUGAINVILLE": {
                "text": "Pacific/Bougainville",
                "description": "Pacific/Bougainville"
            },
            "PACIFIC_CHATHAM": {
                "text": "Pacific/Chatham",
                "description": "Pacific/Chatham"
            },
            "PACIFIC_CHUUK": {
                "text": "Pacific/Chuuk",
                "description": "Pacific/Chuuk"
            },
            "PACIFIC_EASTER": {
                "text": "Pacific/Easter",
                "description": "Pacific/Easter"
            },
            "PACIFIC_EFATE": {
                "text": "Pacific/Efate",
                "description": "Pacific/Efate"
            },
            "PACIFIC_ENDERBURY": {
                "text": "Pacific/Enderbury",
                "description": "Pacific/Enderbury"
            },
            "PACIFIC_FAKAOFO": {
                "text": "Pacific/Fakaofo",
                "description": "Pacific/Fakaofo"
            },
            "PACIFIC_FIJI": {
                "text": "Pacific/Fiji",
                "description": "Pacific/Fiji"
            },
            "PACIFIC_FUNAFUTI": {
                "text": "Pacific/Funafuti",
                "description": "Pacific/Funafuti"
            },
            "PACIFIC_GALAPAGOS": {
                "text": "Pacific/Galapagos",
                "description": "Pacific/Galapagos"
            },
            "PACIFIC_GAMBIER": {
                "text": "Pacific/Gambier",
                "description": "Pacific/Gambier"
            },
            "PACIFIC_GUADALCANAL": {
                "text": "Pacific/Guadalcanal",
                "description": "Pacific/Guadalcanal"
            },
            "PACIFIC_GUAM": {
                "text": "Pacific/Guam",
                "description": "Pacific/Guam"
            },
            "PACIFIC_HONOLULU": {
                "text": "Pacific/Honolulu",
                "description": "Pacific/Honolulu"
            },
            "PACIFIC_JOHNSTON": {
                "text": "Pacific/Johnston",
                "description": "Pacific/Johnston"
            },
            "PACIFIC_KIRITIMATI": {
                "text": "Pacific/Kiritimati",
                "description": "Pacific/Kiritimati"
            },
            "PACIFIC_KOSRAE": {
                "text": "Pacific/Kosrae",
                "description": "Pacific/Kosrae"
            },
            "PACIFIC_KWAJALEIN": {
                "text": "Pacific/Kwajalein",
                "description": "Pacific/Kwajalein"
            },
            "PACIFIC_MAJURO": {
                "text": "Pacific/Majuro",
                "description": "Pacific/Majuro"
            },
            "PACIFIC_MARQUESAS": {
                "text": "Pacific/Marquesas",
                "description": "Pacific/Marquesas"
            },
            "PACIFIC_MIDWAY": {
                "text": "Pacific/Midway",
                "description": "Pacific/Midway"
            },
            "PACIFIC_NAURU": {
                "text": "Pacific/Nauru",
                "description": "Pacific/Nauru"
            },
            "PACIFIC_NIUE": {
                "text": "Pacific/Niue",
                "description": "Pacific/Niue"
            },
            "PACIFIC_NORFOLK": {
                "text": "Pacific/Norfolk",
                "description": "Pacific/Norfolk"
            },
            "PACIFIC_NOUMEA": {
                "text": "Pacific/Noumea",
                "description": "Pacific/Noumea"
            },
            "PACIFIC_PAGO_PAGO": {
                "text": "Pacific/Pago_Pago",
                "description": "Pacific/Pago_Pago"
            },
            "PACIFIC_PALAU": {
                "text": "Pacific/Palau",
                "description": "Pacific/Palau"
            },
            "PACIFIC_PITCAIRN": {
                "text": "Pacific/Pitcairn",
                "description": "Pacific/Pitcairn"
            },
            "PACIFIC_POHNPEI": {
                "text": "Pacific/Pohnpei",
                "description": "Pacific/Pohnpei"
            },
            "PACIFIC_PONAPE": {
                "text": "Pacific/Ponape",
                "description": "Pacific/Ponape"
            },
            "PACIFIC_PORT_MORESBY": {
                "text": "Pacific/Port_Moresby",
                "description": "Pacific/Port_Moresby"
            },
            "PACIFIC_RAROTONGA": {
                "text": "Pacific/Rarotonga",
                "description": "Pacific/Rarotonga"
            },
            "PACIFIC_SAIPAN": {
                "text": "Pacific/Saipan",
                "description": "Pacific/Saipan"
            },
            "PACIFIC_SAMOA": {
                "text": "Pacific/Samoa",
                "description": "Pacific/Samoa"
            },
            "PACIFIC_TAHITI": {
                "text": "Pacific/Tahiti",
                "description": "Pacific/Tahiti"
            },
            "PACIFIC_TARAWA": {
                "text": "Pacific/Tarawa",
                "description": "Pacific/Tarawa"
            },
            "PACIFIC_TONGATAPU": {
                "text": "Pacific/Tongatapu",
                "description": "Pacific/Tongatapu"
            },
            "PACIFIC_TRUK": {
                "text": "Pacific/Truk",
                "description": "Pacific/Truk"
            },
            "PACIFIC_WAKE": {
                "text": "Pacific/Wake",
                "description": "Pacific/Wake"
            },
            "PACIFIC_WALLIS": {
                "text": "Pacific/Wallis",
                "description": "Pacific/Wallis"
            },
            "PACIFIC_YAP": {
                "text": "Pacific/Yap",
                "description": "Pacific/Yap"
            },
            "POLAND": {
                "text": "Poland",
                "description": "Poland"
            },
            "PORTUGAL": {
                "text": "Portugal",
                "description": "Portugal"
            },
            "ROC": {
                "text": "ROC",
                "description": "ROC"
            },
            "ROK": {
                "text": "ROK",
                "description": "ROK"
            },
            "SINGAPORE": {
                "text": "Singapore",
                "description": "Singapore"
            },
            "TURKEY": {
                "text": "Turkey",
                "description": "Turkey"
            },
            "UCT": {
                "text": "UCT",
                "description": "UCT"
            },
            "US_ALASKA": {
                "text": "US/Alaska",
                "description": "US/Alaska"
            },
            "US_ALEUTIAN": {
                "text": "US/Aleutian",
                "description": "US/Aleutian"
            },
            "US_ARIZONA": {
                "text": "US/Arizona",
                "description": "US/Arizona"
            },
            "US_CENTRAL": {
                "text": "US/Central",
                "description": "US/Central"
            },
            "US_EAST_MINUS_INDIANA": {
                "text": "US/East-Indiana",
                "description": "US/East-Indiana"
            },
            "US_EASTERN": {
                "text": "US/Eastern",
                "description": "US/Eastern"
            },
            "US_HAWAII": {
                "text": "US/Hawaii",
                "description": "US/Hawaii"
            },
            "US_INDIANA_MINUS_STARKE": {
                "text": "US/Indiana-Starke",
                "description": "US/Indiana-Starke"
            },
            "US_MICHIGAN": {
                "text": "US/Michigan",
                "description": "US/Michigan"
            },
            "US_MOUNTAIN": {
                "text": "US/Mountain",
                "description": "US/Mountain"
            },
            "US_PACIFIC": {
                "text": "US/Pacific",
                "description": "US/Pacific"
            },
            "US_SAMOA": {
                "text": "US/Samoa",
                "description": "US/Samoa"
            },
            "UNIVERSAL": {
                "text": "Universal",
                "description": "Universal"
            },
            "W_MINUS_SU": {
                "text": "W-SU",
                "description": "W-SU"
            },
            "WET": {
                "text": "WET",
                "description": "WET"
            },
            "ZULU": {
                "text": "Zulu",
                "description": "Zulu"
            }
        },
        "UpgradeFsmState": {
            "UPGRADE_FSM_INIT": {
                "description": "Initial State before any Upgrade Operations."
            },
            "UPGRADE_FSM_STARTED": {
                "description": "Upgrade operations request accepted."
            },
            "UPGRADE_FSM_WAITING": {
                "description": "Upgrade operations request waiting to be picked up by upgrade service."
            },
            "UPGRADE_FSM_IN_PROGRESS": {
                "description": "Upgrade operations request in progress. "
            },
            "UPGRADE_FSM_ENQUEUED": {
                "description": "Upgrade operations request enqueued to workers."
            },
            "UPGRADE_FSM_ERROR": {
                "description": "Upgrade operations is in error. "
            },
            "UPGRADE_FSM_SUSPENDED": {
                "description": "Upgrade operations is suspended."
            },
            "UPGRADE_FSM_ENQUEUE_FAILED": {
                "description": "Upgrade operations request enqueue failed to workers."
            },
            "UPGRADE_FSM_PAUSED": {
                "description": "Upgrade operations have been paused."
            },
            "UPGRADE_FSM_COMPLETED": {
                "description": "Upgrade operations completed for the requested node."
            },
            "UPGRADE_FSM_ABORT_IN_PROGRESS": {
                "description": "Upgrade abort in progress due to error encountered."
            },
            "UPGRADE_FSM_ABORTED": {
                "description": "Upgrade abort complete."
            },
            "UPGRADE_FSM_SE_UPGRADE_IN_PROGRESS": {
                "description": "Upgrade FSM State when controller is waiting for se upgrade to complete."
            },
            "UPGRADE_FSM_CONTROLLER_COMPLETED": {
                "description": "Upgrade FSM State when basic controller upgrade is completed."
            },
            "UPGRADE_PRE_CHECK_STARTED": {
                "text": "Upgrade Readiness check operations request accepted.",
                "description": "Upgrade Readiness check operations request accepted."
            },
            "UPGRADE_PRE_CHECK_IN_PROGRESS": {
                "text": "Upgrade readiness check operations request is in progress.",
                "description": "Upgrade readiness check operations request is in progress."
            },
            "UPGRADE_PRE_CHECK_SUCCESS": {
                "text": "Upgrade readiness check operations request is completed.",
                "description": "Upgrade readiness check operations request is completed."
            },
            "UPGRADE_PRE_CHECK_ERROR": {
                "text": "Upgrade readiness check operations request is in error state.",
                "description": "Upgrade readiness check operations request is in error state."
            },
            "UPGRADE_PRE_CHECK_WARNING": {
                "text": "Upgrade readiness check operations request is in warning state.",
                "description": "Upgrade readiness check operations request is in warning state."
            }
        },
        "CloudState": {
            "CLOUD_STATE_UNKNOWN": {
                "text": "Unknown",
                "description": "Cloud state unknown"
            },
            "CLOUD_STATE_IN_PROGRESS": {
                "text": "In Progress",
                "description": "Cloud configuration in progress"
            },
            "CLOUD_STATE_FAILED": {
                "text": "Failed",
                "description": "Cloud configuration failed"
            },
            "CLOUD_STATE_PLACEMENT_READY": {
                "text": "Ready",
                "description": "Cloud ready for Virtual Service placement"
            },
            "CLOUD_STATE_DELETING": {
                "text": "Deleting",
                "description": "Cloud is in the process of deconfiguration"
            },
            "CLOUD_STATE_NOT_CONNECTED": {
                "text": "Not Connected",
                "description": "Cloud Infrastructure connection closed"
            }
        },
        "PNIC_SWITCH_INFO": {
            "CDP": {},
            "LLDP": {},
            "NOT_APPLICABLE": {}
        },
        "VirtualServiceType": {
            "VS_TYPE_NORMAL": {},
            "VS_TYPE_VH_PARENT": {},
            "VS_TYPE_VH_CHILD": {}
        },
        "SeFlowDist": {
            "LOAD_AWARE": {
                "description": "Distribute flows based on SE load."
            },
            "CONSISTENT_HASH_SOURCE_IP_ADDRESS": {
                "description": "Distribute flows based on consistent hash of client IP."
            },
            "CONSISTENT_HASH_SOURCE_IP_ADDRESS_AND_PORT": {
                "description": "Distribute flows based on consistent hash of client IP and Port."
            }
        },
        "ActiveStandbySeTag": {
            "ACTIVE_STANDBY_SE_1": {},
            "ACTIVE_STANDBY_SE_2": {}
        },
        "FlowLabelType": {
            "NO_LABEL": {
                "description": "No label."
            },
            "APPLICATION_LABEL": {
                "description": "Application logic based label."
            },
            "SERVICE_LABEL": {
                "description": "Use Service label."
            }
        },
        "VHType": {
            "VS_TYPE_VH_SNI": {
                "text": "SNI",
                "description": "Virtual Hosting VS of type SNI."
            },
            "VS_TYPE_VH_ENHANCED": {
                "text": "Enhanced Virtual Hosting",
                "description": "Virtual Hosting VS of type Enhanced."
            }
        },
        "AccessTokenType": {
            "ACCESS_TOKEN_TYPE_JWT": {
                "text": "JWT access token.",
                "description": "Access token is a JWT."
            },
            "ACCESS_TOKEN_TYPE_OPAQUE": {
                "text": "Opaque access token.",
                "description": "Access token is opaque."
            }
        },
        "JWTLocation": {
            "JWT_LOCATION_AUTHORIZATION_HEADER": {
                "text": "Authorization Header",
                "description": "JWT sent in the authorizarion header of the request as a bearer token."
            },
            "JWT_LOCATION_QUERY_PARAM": {
                "text": "Query Param",
                "description": "JWT sent in the request query params."
            }
        },
        "SAMLAuthNRequestACSType": {
            "SAML_AUTHN_REQ_ACS_TYPE_URL": {
                "text": "Use AssertionConsumerServiceURL",
                "description": "Use AssertionConsumerServiceURL in Authentication Request"
            },
            "SAML_AUTHN_REQ_ACS_TYPE_INDEX": {
                "text": "Use AssertionConsumerServiceIndex",
                "description": "Use AssertionConsumerServiceIndex in Authentication Request"
            },
            "SAML_AUTHN_REQ_ACS_TYPE_NONE": {
                "text": "No AssertionConsumerService attribute",
                "description": "No AssertionConsumerService attribute in Authentication Request"
            }
        },
        "IpAddressVersions": {
            "V4_ONLY": {},
            "V6_ONLY": {},
            "V4_V6": {}
        },
        "DnsRecordResponseAlgorithm": {
            "DNS_RECORD_RESPONSE_ROUND_ROBIN": {
                "description": "Linearly cycle through the list of configured entries in the DNS record to provide in response to DNS requests."
            },
            "DNS_RECORD_RESPONSE_CONSISTENT_HASH": {
                "description": "Use a hash of the source IP (LDNS) to pick from the list of configured entries in the DNS record to provide in response to DNS requests."
            }
        },
        "ClientInsights": {
            "NO_INSIGHTS": {
                "text": "No Insights"
            },
            "PASSIVE": {
                "text": "Passive"
            },
            "ACTIVE": {
                "text": "Active"
            }
        },
        "DebugVrfFlag": {
            "DEBUG_VRF_BGP": {
                "text": "bgp",
                "description": "BGP protocol debug logs"
            },
            "DEBUG_VRF_QUAGGA": {
                "text": "quagga",
                "description": "Quagga config debug logs"
            },
            "DEBUG_VRF_ALL": {
                "text": "all",
                "description": "Turn on all logs for this vrf"
            },
            "DEBUG_VRF_NONE": {
                "text": "none",
                "description": "Turn off all logs for this vrf"
            }
        },
        "SelectorType": {
            "SELECTOR_IPAM": {
                "text": "IPAM",
                "description": "Selector for IPAM networks"
            }
        },
        "WafMode": {
            "WAF_MODE_DETECTION_ONLY": {
                "text": "Detection",
                "description": "WAF rules are processed but HTTP transactions are not intercepted, even when rules are configured to do so."
            },
            "WAF_MODE_ENFORCEMENT": {
                "text": "Enforcement",
                "description": "WAF rules are processed and HTTP transactions are intercepted, as per the rules."
            },
            "WAF_MODE_EVALUATION": {
                "text": "Evaluation",
                "description": "WAF rules are processed but HTTP transactions are not intercepted, even when rules are configured to do so. From a functional point, this is the same as WAF_MODE_DETECTION_ONLY."
            }
        },
        "WafPhase": {
            "WAF_PHASE_CONNECTION": {
                "text": "connection phase",
                "description": "Executed before request header phase. Only the client IP is available."
            },
            "WAF_PHASE_REQUEST_HEADER": {
                "text": "request header phase",
                "description": "Executed when the HTTP request headers are available."
            },
            "WAF_PHASE_REQUEST_BODY": {
                "text": "request body phase",
                "description": "Executed when the HTTP request body is available."
            },
            "WAF_PHASE_RESPONSE_HEADER": {
                "text": "response header phase",
                "description": "Executed when the HTTP response headers are available."
            },
            "WAF_PHASE_RESPONSE_BODY": {
                "text": "request body phase",
                "description": "Executed when the HTTP response body is available."
            },
            "WAF_PHASE_LOGGING": {
                "text": "logging phase",
                "description": "Executed after full is HTTP request is handled."
            }
        },
        "WafParanoiaLevel": {
            "WAF_PARANOIA_LEVEL_LOW": {
                "text": "Low (1)",
                "description": "All rules with a paranoia-level tag greater than 1 will be excluded."
            },
            "WAF_PARANOIA_LEVEL_MEDIUM": {
                "text": "Medium (2)",
                "description": "All rules with a paranoia-level tag greater than 2 will be excluded."
            },
            "WAF_PARANOIA_LEVEL_HIGH": {
                "text": "High (3)",
                "description": "All rules with a paranoia-level tag greater than 3 will be excluded."
            },
            "WAF_PARANOIA_LEVEL_EXTREME": {
                "text": "Extreme (4)",
                "description": "All rules with a paranoia-level tag greater than 4 will be excluded."
            }
        },
        "WafDataFileType": {
            "WAF_DATAFILE_PM_FROM_FILE": {
                "text": "WAF pmFromFile operator data",
                "description": "File to be used with WAF pmFromFile operator."
            },
            "WAF_DATAFILE_DTD": {
                "text": "DTD",
                "description": "File to be used with WAF validateDTD operator."
            },
            "WAF_DATAFILE_XSD": {
                "text": "XSD",
                "description": "File to be used with WAF validateSchema operator."
            },
            "WAF_DATAFILE_IP_MATCH_FROM_FILE": {
                "text": "WAF ipMatchFromFile operator data",
                "description": "File to be used with WAF ipMatchFromFile operator."
            }
        },
        "WafRequestParser": {
            "WAF_REQUEST_PARSER_URLENCODED": {
                "text": "URL Encoded",
                "description": "WAF request body parser for URL encoded data (application/x-www-form-urlencoded Content-Type)."
            },
            "WAF_REQUEST_PARSER_MULTIPART": {
                "text": "Multipart",
                "description": "WAF request body parser for multipart form data (Content-Type multipart/form-data)."
            },
            "WAF_REQUEST_PARSER_JSON": {
                "text": "JSON",
                "description": "WAF request body parser for JSON data."
            },
            "WAF_REQUEST_PARSER_XML": {
                "text": "XML",
                "description": "WAF request body parser for XML data."
            },
            "WAF_REQUEST_PARSER_HANDLE_AS_STRING": {
                "text": "As String",
                "description": "WAF request body parser that does not attempt to interpret the body of incoming requests in any way and does not set ARGS WAF variables. However REQUEST_BODY variable is set to the value of request body data."
            },
            "WAF_REQUEST_PARSER_DO_NOT_PARSE": {
                "text": "Do Not Parse",
                "description": "WAF request body parser that does not attempt to parse incoming requests and does not set any WAF variables, effectively turning off WAF protection for a given content type. Use ctl:forceRequestBodyVariable in custom signature rule to set REQUEST_BODY variable if it is needed."
            },
            "WAF_REQUEST_PARSER_AUTO_DETECT": {
                "text": "Auto Detect",
                "description": "WAF detects the needed parser itself by applying the following rules: If the first bytes of the request body matches the content type description of multipart/data, JSON or XML, then specified parser will be used. If the body starts with '<', the XML parser will be used. If the body starts with '{' or '[', the JSON parser will be used. If the body starts with '--' and can act as a multipart/form-data boundary, the MULTIPART parser will be used. In all other cases, the URLENCODED parser will be used."
            }
        },
        "WafPolicyAllowlistAction": {
            "WAF_POLICY_ALLOWLIST_ACTION_BYPASS": {
                "text": "Bypass",
                "description": "Unconditionally allow the request in WAF. This will deactivate WAF processing for this request."
            },
            "WAF_POLICY_ALLOWLIST_ACTION_DETECTION_MODE": {
                "text": "Detection Mode",
                "description": "Run WAF policy, but never block the request. This effectively behaves as if the whole policy and all rules were in DETECTION mode."
            },
            "WAF_POLICY_ALLOWLIST_ACTION_CONTINUE": {
                "text": "Continue",
                "description": "Stop allowlist processing and continue with WAF policy."
            }
        },
        "WafAction": {
            "WAF_ACTION_NO_OP": {
                "text": "No operation",
                "description": "No operation."
            },
            "WAF_ACTION_BLOCK": {
                "text": "Flag or Reject",
                "description": "Depending on the WAF mode, the request is either flagged or rejected."
            },
            "WAF_ACTION_ALLOW_PARAMETER": {
                "text": "Allow parameter",
                "description": "The parameter is marked as good."
            }
        },
        "WafFailureMode": {
            "WAF_FAILURE_MODE_OPEN": {
                "text": "Open",
                "description": "When WAF processing of a request fails, allow the request."
            },
            "WAF_FAILURE_MODE_CLOSED": {
                "text": "Closed",
                "description": "When WAF processing of a request fails, reject/flag the request."
            }
        },
        "WafSamplingMode": {
            "WAF_SAMPLING_MODE_NO_SAMPLING": {
                "text": "Off",
                "description": "Sampling is disabled. All requests are subject to WAF processing."
            },
            "WAF_SAMPLING_MODE_ADAPTIVE_SAMPLING": {
                "text": "Adaptive",
                "description": "A varying percentage of requests will be subject to WAF processing. The SE-group property max_cpu_load_adaptive_sampling limits the maximum load on the CPU allowed for adaptive sampling to take place."
            },
            "WAF_SAMPLING_MODE_FIXED_SAMPLING": {
                "text": "Fixed percentage",
                "description": "WAF will only check a given percentage of all requests."
            }
        },
        "WafVariable": {
            "WAF_VARIABLE_ARGS": {
                "text": "ARGS",
                "description": "The ARGS collection. Can have a subelement."
            },
            "WAF_VARIABLE_ARGS_GET": {
                "text": "ARGS_GET",
                "description": "The ARGS_GET collection. Can have a subelement."
            },
            "WAF_VARIABLE_ARGS_POST": {
                "text": "ARGS_POST",
                "description": "The ARGS_POST collection. Can have a subelement."
            },
            "WAF_VARIABLE_ARGS_NAMES": {
                "text": "ARGS_NAMES",
                "description": "The ARGS_NAMES collection. Can have a subelement."
            },
            "WAF_VARIABLE_REQUEST_COOKIES": {
                "text": "REQUEST_COOKIES",
                "description": "The REQUEST_COOKIES collection. Can have a subelement."
            },
            "WAF_VARIABLE_QUERY_STRING": {
                "text": "QUERY_STRING",
                "description": "The QUERY_STRING variable."
            },
            "WAF_VARIABLE_REQUEST_BASENAME": {
                "text": "REQUEST_BASENAME",
                "description": "The REQUEST_BASENAME variable."
            },
            "WAF_VARIABLE_REQUEST_URI": {
                "text": "REQUEST_URI",
                "description": "The REQUEST_URI variable."
            },
            "WAF_VARIABLE_PATH_INFO": {
                "text": "PATH_INFO",
                "description": "The PATH_INFO variable. This is the part of the REQUEST_URI before the QUERY_ARGS."
            },
            "WAF_VARIABLE_REQUEST_HEADERS": {
                "text": "REQUEST_HEADERS",
                "description": "The REQUEST_HEADERS collection. Can have a subelement."
            }
        },
        "HTTPResponseCodes": {
            "HTTP_RESPONSE_CODE_0": {
                "text": "Not Applicable"
            },
            "HTTP_RESPONSE_CODE_100": {
                "text": "Continue"
            },
            "HTTP_RESPONSE_CODE_101": {
                "text": "Switching Protocols"
            },
            "HTTP_RESPONSE_CODE_200": {
                "text": "OK"
            },
            "HTTP_RESPONSE_CODE_201": {
                "text": "Created"
            },
            "HTTP_RESPONSE_CODE_202": {
                "text": "Accepted"
            },
            "HTTP_RESPONSE_CODE_203": {
                "text": "Non-Authoritative Information"
            },
            "HTTP_RESPONSE_CODE_204": {
                "text": "No Content"
            },
            "HTTP_RESPONSE_CODE_205": {
                "text": "Reset Content"
            },
            "HTTP_RESPONSE_CODE_206": {
                "text": "Partial Content"
            },
            "HTTP_RESPONSE_CODE_300": {
                "text": "Multiple Choices"
            },
            "HTTP_RESPONSE_CODE_301": {
                "text": "Moved Permanently"
            },
            "HTTP_RESPONSE_CODE_302": {
                "text": "Found"
            },
            "HTTP_RESPONSE_CODE_303": {
                "text": "See Other"
            },
            "HTTP_RESPONSE_CODE_304": {
                "text": "Not Modified"
            },
            "HTTP_RESPONSE_CODE_305": {
                "text": "Use Proxy"
            },
            "HTTP_RESPONSE_CODE_307": {
                "text": "Temporary Redirect"
            },
            "HTTP_RESPONSE_CODE_400": {
                "text": "Bad Request"
            },
            "HTTP_RESPONSE_CODE_401": {
                "text": "Unauthorized"
            },
            "HTTP_RESPONSE_CODE_402": {
                "text": "Payment Required"
            },
            "HTTP_RESPONSE_CODE_403": {
                "text": "Forbidden"
            },
            "HTTP_RESPONSE_CODE_404": {
                "text": "Not Found"
            },
            "HTTP_RESPONSE_CODE_405": {
                "text": "Method Not Allowed"
            },
            "HTTP_RESPONSE_CODE_406": {
                "text": "Not Acceptable"
            },
            "HTTP_RESPONSE_CODE_407": {
                "text": "Proxy Authentication Required"
            },
            "HTTP_RESPONSE_CODE_408": {
                "text": "Request Timeout"
            },
            "HTTP_RESPONSE_CODE_409": {
                "text": "Conflict"
            },
            "HTTP_RESPONSE_CODE_410": {
                "text": "Gone"
            },
            "HTTP_RESPONSE_CODE_411": {
                "text": "Length Required"
            },
            "HTTP_RESPONSE_CODE_412": {
                "text": "Precondition Failed"
            },
            "HTTP_RESPONSE_CODE_413": {
                "text": "Payload Too Large"
            },
            "HTTP_RESPONSE_CODE_414": {
                "text": "URI Too Long"
            },
            "HTTP_RESPONSE_CODE_415": {
                "text": "Unsupported Media Type"
            },
            "HTTP_RESPONSE_CODE_416": {
                "text": "Range Not Satisfiable"
            },
            "HTTP_RESPONSE_CODE_417": {
                "text": "Expectation Failed"
            },
            "HTTP_RESPONSE_CODE_426": {
                "text": "Upgrade Required"
            },
            "HTTP_RESPONSE_CODE_470": {
                "text": "Avi Closed Connection",
                "description": "Internal code used by Avi to close the TCP connection"
            },
            "HTTP_RESPONSE_CODE_475": {
                "text": "Client Closed Connection",
                "description": "Client closed the TCP connection before Avi could send any HTTP response to the HTTP request"
            },
            "HTTP_RESPONSE_CODE_500": {
                "text": "Internal Server Error"
            },
            "HTTP_RESPONSE_CODE_501": {
                "text": "Not Implemented"
            },
            "HTTP_RESPONSE_CODE_502": {
                "text": "Bad Gateway"
            },
            "HTTP_RESPONSE_CODE_503": {
                "text": "Service Unavailable"
            },
            "HTTP_RESPONSE_CODE_504": {
                "text": "Gateway Timeout"
            },
            "HTTP_RESPONSE_CODE_505": {
                "text": "HTTP Version Not Supported"
            }
        },
        "WafXmlCollection": {
            "WAF_XML_COLLECTION_XML": {
                "text": "XML collection",
                "description": "XML request body will be parsed into the 'XML' collection variable."
            },
            "WAF_XML_COLLECTION_ARGS": {
                "text": "ARGS collection",
                "description": "XML request body will be parsed into the 'ARGS' collection variable."
            }
        },
        "UpgradeOpsType": {
            "UPGRADE": {
                "text": "Upgrade requested.",
                "description": "Upgrade requested."
            },
            "PATCH": {
                "text": "Patch requested.",
                "description": "Patch requested."
            },
            "ROLLBACK": {
                "text": "Rollback requested.",
                "description": "Rollback requested."
            },
            "ROLLBACKPATCH": {
                "text": "Rollback patch requested.",
                "description": "Rollback patch requested."
            },
            "SEGROUP_RESUME": {
                "text": "SeGroup Resume requested.",
                "description": "SeGroup Resume requested."
            },
            "EVAL_UPGRADE": {
                "text": "Upgrade must check requested.",
                "description": "Upgrade must check requested."
            },
            "EVAL_PATCH": {
                "text": "Patch must check requested.",
                "description": "Patch must check requested."
            },
            "EVAL_ROLLBACK": {
                "text": "Rollback must check requested.",
                "description": "Rollback must check requested."
            },
            "EVAL_ROLLBACKPATCH": {
                "text": "Rollback patch must check requested.",
                "description": "Rollback patch must check requested."
            },
            "EVAL_SEGROUP_RESUME": {
                "text": "SeGroup Resume must check requested.",
                "description": "SeGroup Resume must check requested."
            },
            "EVAL_RESTORE": {
                "text": "Restore must check requested.",
                "description": "Restore must check requested."
            },
            "RESTORE": {
                "text": "Restore requested.",
                "description": "Restore requested."
            },
            "UPGRADE_DRYRUN": {
                "text": "Upgrade dry-run requested.",
                "description": "Upgrade dry-run requested."
            }
        },
        "UpgradeTasks": {
            "PREPARE_FOR_SHUTDOWN": {},
            "COPY_AND_VERIFY_IMAGE": {},
            "INSTALL_IMAGE": {},
            "POST_INSTALL_HOOKS": {},
            "PREPARE_CONTROLLER_FOR_SHUTDOWN": {},
            "STOP_CONTROLLER": {},
            "EXTRACT_PATCH_IMAGE": {},
            "EXECUTE_PRE_INSTALL_COMMANDS": {},
            "INSTALL_PATCH_IMAGE": {},
            "PREPARE_FOR_REBOOT_CONTROLLER_NODES": {},
            "REBOOT_CONTROLLER_NODES": {},
            "WAIT_FOR_ALL_CONTROLLER_NODES_ONLINE": {},
            "PRE_UPGRADE_HOOKS": {},
            "MIGRATE_CONFIG": {},
            "START_PRIMARY_CONTROLLER": {},
            "START_ALL_CONTROLLERS": {},
            "POST_UPGRADE_HOOKS": {},
            "EXECUTE_POST_INSTALL_COMMANDS": {},
            "SET_CONTROLLER_UPGRADE_COMPLETED": {},
            "STATE_NOT_USED_IN_V2": {},
            "COMMIT_UPGRADE": {},
            "UNKNOWN_TASK": {},
            "PATCH_CONTROLLER_HEALTH_CHECK": {}
        },
        "TaskState": {
            "TASK_STATE_SUCCESS": {
                "text": "Success",
                "description": "Task completed successfully."
            },
            "TASK_STATE_WARNING": {
                "text": "Warning",
                "description": "Task completed with warnings."
            },
            "TASK_STATE_ERROR": {
                "text": "Error",
                "description": "Task completed with errors."
            }
        },
        "ReportState": {
            "SYSTEM_REPORT_STARTED": {
                "text": "Started",
                "description": "Initial state for the report."
            },
            "SYSTEM_REPORT_IN_PROGRESS": {
                "text": "In Progress",
                "description": "Report is being generated."
            },
            "SYSTEM_REPORT_SUCCESS": {
                "text": "Success",
                "description": "Report generation completed successfully."
            },
            "SYSTEM_REPORT_WARNING": {
                "text": "Warning",
                "description": "Report generation completed with warnings."
            },
            "SYSTEM_REPORT_ERROR": {
                "text": "Error",
                "description": "Report generation completed with errors."
            }
        },
        "TechSupportFsmState": {
            "TECHSUPPORT_FSM_STARTED": {
                "text": "Techsupport operations request accepted.",
                "description": "Techsupport operations request accepted."
            },
            "TECHSUPPORT_FSM_IN_PROGRESS": {
                "text": "Techsupport operations request in progress.",
                "description": "Techsupport operations request in progress."
            },
            "TECHSUPPORT_FSM_COMPLETED": {
                "text": "Techsupport operations completed for requested level.",
                "description": "Techsupport operations completed for requested level."
            },
            "TECHSUPPORT_FSM_COMPLETED_WITH_WARNINGS": {
                "text": "Techsupport operations completed with warnings.",
                "description": "Techsupport operations completed with warnings."
            },
            "TECHSUPPORT_FSM_WARNING": {
                "text": "Techsupport operations warnings.Please review the logs",
                "description": "Techsupport operations warnings.Please review the logs"
            },
            "TECHSUPPORT_FSM_ERROR": {
                "text": "Techsupport operations failed.",
                "description": "Techsupport operations failed."
            }
        },
        "AppLearningConfidenceLabel": {
            "CONFIDENCE_VERY_HIGH": {},
            "CONFIDENCE_HIGH": {},
            "CONFIDENCE_PROBABLE": {},
            "CONFIDENCE_LOW": {},
            "CONFIDENCE_NONE": {}
        }
    },
    "permission": {
        "user": "PERMISSION_USER",
        "networkservice": "PERMISSION_NETWORKSERVICE",
        "webhook": "PERMISSION_AUTOSCALE",
        "cluster": "PERMISSION_CONTROLLER",
        "clusternodereboot": "PERMISSION_CONTROLLER",
        "clusterstate": "PERMISSION_CONTROLLER",
        "controllerversion": "PERMISSION_CONTROLLER",
        "diskusageinfo": "PERMISSION_CONTROLLER",
        "cpuusageinfo": "PERMISSION_CONTROLLER",
        "memoryusageinfo": "PERMISSION_CONTROLLER",
        "seversion": "PERMISSION_CONTROLLER",
        "segroupversion": "PERMISSION_CONTROLLER",
        "albservicesconfig": "PERMISSION_ALBSERVICESCONFIG",
        "healthmonitor": "PERMISSION_HEALTHMONITOR",
        "dnspolicy": "PERMISSION_DNSPOLICY",
        "licensestatus": "PERMISSION_CONTROLLER",
        "cloudconnectoruser": "PERMISSION_USER_CREDENTIAL",
        "shardserverstatus": "PERMISSION_INTERNAL",
        "adaptreplfaultinj": "PERMISSION_CONTROLLER",
        "cloud": "PERMISSION_CLOUD",
        "cloudruntime": "PERMISSION_CLOUD",
        "placementsystemsummary": "PERMISSION_INTERNAL",
        "testsedatastorelevel1": "PERMISSION_TESTSEDATASTORELEVEL1",
        "testsedatastorelevel2": "PERMISSION_TESTSEDATASTORELEVEL2",
        "testsedatastorelevel3": "PERMISSION_TESTSEDATASTORELEVEL3",
        "positivesecuritypolicy": "PERMISSION_POSITIVESECURITYPOLICY",
        "sspinstance": "PERMISSION_CONTROLLER",
        "serverautoscalepolicy": "PERMISSION_AUTOSCALE",
        "autoscalelaunchconfig": "PERMISSION_AUTOSCALE",
        "vsdatascriptset": "PERMISSION_VSDATASCRIPTSET",
        "dynamicdnsrecord": "PERMISSION_SYSTEMCONFIGURATION",
        "federateddatastorestatus": "PERMISSION_INTERNAL",
        "federateddiffqueuestatus": "PERMISSION_INTERNAL",
        "analyticsprofile": "PERMISSION_ANALYTICSPROFILE",
        "wafpolicy": "PERMISSION_WAFPOLICY",
        "wafapplicationsignatureprovider": "PERMISSION_WAFPOLICY",
        "ssopolicy": "PERMISSION_SSOPOLICY",
        "siteversion": "PERMISSION_CONTROLLER",
        "retentionpolicy": "PERMISSION_RETENTIONPOLICY",
        "network": "PERMISSION_NETWORK",
        "networkruntime": "PERMISSION_NETWORK",
        "ipamdnsproviderprofile": "PERMISSION_IPAMDNSPROVIDERPROFILE",
        "metricsentityruntime": "PERMISSION_INTERNAL",
        "techsupportmessage": "PERMISSION_TECHSUPPORTMESSAGE",
        "techsupport": "PERMISSION_TECHSUPPORT",
        "controllerlicense": "PERMISSION_CONTROLLER",
        "jwtserverprofile": "PERMISSION_JWTSERVERPROFILE",
        "applicationinsightspolicy": "PERMISSION_APPLICATIONINSIGHTSPOLICY",
        "pool": "PERMISSION_POOL",
        "customipamdnsprofile": "PERMISSION_CUSTOMIPAMDNSPROFILE",
        "albservicesfiledownload": "PERMISSION_CONTROLLER",
        "statediffoperation": "PERMISSION_CONTROLLER",
        "statediffsnapshot": "PERMISSION_CONTROLLER",
        "scheduler": "PERMISSION_CONTROLLER",
        "backupconfiguration": "PERMISSION_CONTROLLER",
        "labelgroup": "PERMISSION_LABELGROUP",
        "licenseledgerdetails": "PERMISSION_CONTROLLER",
        "csrfpolicy": "PERMISSION_CSRFPOLICY",
        "seproperties": "PERMISSION_CONTROLLER",
        "botdetectionpolicy": "PERMISSION_BOTDETECTIONPOLICY",
        "botmapping": "PERMISSION_BOTDETECTIONPOLICY",
        "botconfigconsolidator": "PERMISSION_BOTDETECTIONPOLICY",
        "botipreputationtypemapping": "PERMISSION_BOTDETECTIONPOLICY",
        "debugcontroller": "PERMISSION_CONTROLLER",
        "prioritylabels": "PERMISSION_PRIORITYLABELS",
        "securitymgrstate": "PERMISSION_INTERNAL",
        "securitymgrlearn": "PERMISSION_INTERNAL",
        "securitymgrtopn": "PERMISSION_INTERNAL",
        "applicationinsightsruntimestateresponse": "PERMISSION_INTERNAL",
        "natpolicy": "PERMISSION_NATPOLICY",
        "trustedhostprofile": "PERMISSION_SYSTEMCONFIGURATION",
        "transactionstats": "PERMISSION_INTERNAL",
        "poolinventory": "PERMISSION_POOL",
        "poolgroupinventory": "PERMISSION_POOLGROUP",
        "vsvipinventory": "PERMISSION_VIRTUALSERVICE",
        "vsinventory": "PERMISSION_VIRTUALSERVICE",
        "serviceengineinventory": "PERMISSION_SERVICEENGINE",
        "serviceenginegroupinventory": "PERMISSION_SERVICEENGINEGROUP",
        "networkinventory": "PERMISSION_NETWORK",
        "cloudinventory": "PERMISSION_CLOUD",
        "gslbinventory": "PERMISSION_GSLB",
        "gslbserviceinventory": "PERMISSION_GSLBSERVICE",
        "wafpolicypsmgroupinventory": "PERMISSION_WAFPOLICYPSMGROUP",
        "cloudproperties": "PERMISSION_CLOUD",
        "snmptrapprofile": "PERMISSION_SNMPTRAPPROFILE",
        "image": "PERMISSION_IMAGE",
        "icapprofile": "PERMISSION_ICAP",
        "controllerportalregistration": "PERMISSION_CONTROLLER",
        "applicationprofile": "PERMISSION_APPLICATIONPROFILE",
        "vrfcontext": "PERMISSION_VRFCONTEXT",
        "systemlimits": "PERMISSION_SYSTEMCONFIGURATION",
        "systemlimitobjectcounts": "PERMISSION_SYSTEMCONFIGURATION",
        "scvsstateinfo": "PERMISSION_CONTROLLER",
        "scpoolserverstateinfo": "PERMISSION_CONTROLLER",
        "gslb": "PERMISSION_GSLB",
        "gslbsmruntime": "PERMISSION_GSLB",
        "gslbcrmruntime": "PERMISSION_GSLB",
        "gslbhsmruntime": "PERMISSION_GSLB",
        "gslbservice": "PERMISSION_GSLBSERVICE",
        "gslbgeodbprofile": "PERMISSION_GSLBGEODBPROFILE",
        "localworkerfdsversion": "PERMISSION_GSLB",
        "taskjournal": "PERMISSION_TASKJOURNAL",
        "networkprofile": "PERMISSION_NETWORKPROFILE",
        "trafficcloneprofile": "PERMISSION_TRAFFICCLONEPROFILE",
        "wafcrs": "PERMISSION_WAFCRS",
        "applicationpersistenceprofile": "PERMISSION_APPLICATIONPERSISTENCEPROFILE",
        "tenantbinding": "PERMISSION_TENANTBINDING",
        "vcenterserver": "PERMISSION_CLOUD",
        "availabilityzone": "PERMISSION_CLOUD",
        "nsxtsegmentruntime": "PERMISSION_CLOUD",
        "nsxtagent": "PERMISSION_CLOUD_API",
        "upgradeprofile": "PERMISSION_UPGRADEPROFILE",
        "systemreport": "PERMISSION_SYSTEMREPORT",
        "role": "PERMISSION_ROLE",
        "tenant": "PERMISSION_TENANT",
        "useractivity": "PERMISSION_USER",
        "useraccountprofile": "PERMISSION_USER",
        "serviceengine": "PERMISSION_SERVICEENGINE",
        "sslprofile": "PERMISSION_SSLPROFILE",
        "sslkeyandcertificate": "PERMISSION_SSLKEYANDCERTIFICATE",
        "pkiprofile": "PERMISSION_PKIPROFILE",
        "certificatemanagementprofile": "PERMISSION_CERTIFICATEMANAGEMENTPROFILE",
        "certjwtstore": "PERMISSION_EXEMPT",
        "albservicesjob": "PERMISSION_CONTROLLER",
        "logmanagerstats": "PERMISSION_INTERNAL",
        "licensequotausagedetails": "PERMISSION_CONTROLLER",
        "controllerproperties": "PERMISSION_CONTROLLER",
        "poolgroup": "PERMISSION_POOLGROUP",
        "systemhealthgetsystemhealthclusteringresponse": "PERMISSION_INTERNAL",
        "systemhealthgetsystemhealthpostgresresponse": "PERMISSION_INTERNAL",
        "systemhealthgetservicefailedresponse": "PERMISSION_INTERNAL",
        "systemhealthgetservicerestartedresponse": "PERMISSION_INTERNAL",
        "systemhealthgetservicedetailresponse": "PERMISSION_INTERNAL",
        "metricsapisrvrstats": "PERMISSION_INTERNAL",
        "jobentry": "PERMISSION_INTERNAL",
        "protocolparser": "PERMISSION_PROTOCOLPARSER",
        "httppolicyset": "PERMISSION_HTTPPOLICYSET",
        "sedatastorestatus": "PERMISSION_INTERNAL",
        "diffqueuestatus": "PERMISSION_INTERNAL",
        "l4policyset": "PERMISSION_L4POLICYSET",
        "errorpageprofile": "PERMISSION_ERRORPAGEPROFILE",
        "errorpagebody": "PERMISSION_ERRORPAGEBODY",
        "ipreputationdb": "PERMISSION_IPREPUTATIONDB",
        "securitypolicy": "PERMISSION_SECURITYPOLICY",
        "geodb": "PERMISSION_GEODB",
        "clusterclouddetails": "PERMISSION_CONTROLLER",
        "securechannelmapping": "PERMISSION_CONTROLLER",
        "securechannelavailablelocalips": "PERMISSION_CONTROLLER",
        "securechanneltoken": "PERMISSION_CONTROLLER",
        "wafpolicypsmgroup": "PERMISSION_WAFPOLICYPSMGROUP",
        "networksecuritypolicy": "PERMISSION_NETWORKSECURITYPOLICY",
        "tenantsystemconfiguration": "PERMISSION_TENANT_SYSTEM_CONFIGURATION",
        "serviceenginegroup": "PERMISSION_SERVICEENGINEGROUP",
        "ipaddrgroup": "PERMISSION_IPADDRGROUP",
        "stringgroup": "PERMISSION_STRINGGROUP",
        "microservicegroup": "PERMISSION_MICROSERVICEGROUP",
        "albservicesfileupload": "PERMISSION_CONTROLLER",
        "webapput": "PERMISSION_CONTROLLER",
        "logcontrollermapping": "PERMISSION_CONTROLLER",
        "vsgs": "PERMISSION_GSLB",
        "hardwaresecuritymodulegroup": "PERMISSION_HARDWARESECURITYMODULEGROUP",
        "securitymanagerdata": "PERMISSION_CONTROLLER",
        "wafprofile": "PERMISSION_WAFPROFILE",
        "systemconfiguration": "PERMISSION_SYSTEMCONFIGURATION",
        "controllersite": "PERMISSION_CONTROLLERSITE",
        "alertsyslogconfig": "PERMISSION_ALERTSYSLOGCONFIG",
        "alertemailconfig": "PERMISSION_ALERTEMAILCONFIG",
        "alertscriptconfig": "PERMISSION_ALERTSCRIPTCONFIG",
        "alertconfig": "PERMISSION_ALERTCONFIG",
        "actiongroupconfig": "PERMISSION_ACTIONGROUPCONFIG",
        "alertobjectlist": "PERMISSION_ALERTCONFIG",
        "alert": "PERMISSION_ALERT",
        "inventoryfaultconfig": "PERMISSION_CONTROLLER",
        "alertparams": "PERMISSION_CONTROLLER",
        "alertperfdata": "PERMISSION_CONTROLLER",
        "alertmgrmonitoringdata": "PERMISSION_CONTROLLER",
        "segrouponetimerequestresponse": "PERMISSION_VIRTUALSERVICE",
        "eventmanagerstats": "PERMISSION_INTERNAL",
        "eventmanagersubscriptions": "PERMISSION_INTERNAL",
        "autoscalestate": "PERMISSION_VIRTUALSERVICE",
        "backup": "PERMISSION_CONTROLLER",
        "techsupportprofile": "PERMISSION_TECHSUPPORTPROFILE",
        "memorybalancerrequest": "PERMISSION_CONTROLLER",
        "seresourceproto": "PERMISSION_INTERNAL",
        "seconsumerproto": "PERMISSION_INTERNAL",
        "secreatependingproto": "PERMISSION_INTERNAL",
        "rmcloudopsproto": "PERMISSION_INTERNAL",
        "placementstats": "PERMISSION_INTERNAL",
        "sevipproto": "PERMISSION_INTERNAL",
        "placementstatus": "PERMISSION_INTERNAL",
        "rmvrfproto": "PERMISSION_INTERNAL",
        "placementglobals": "PERMISSION_INTERNAL",
        "authprofile": "PERMISSION_AUTHPROFILE",
        "serviceauthprofile": "PERMISSION_SERVICEAUTHPROFILE",
        "authmappingprofile": "PERMISSION_AUTHMAPPINGPROFILE",
        "securitymgruacachequery": "PERMISSION_INTERNAL",
        "securitymgruacachesummary": "PERMISSION_INTERNAL",
        "securitymgruacacheclear": "PERMISSION_INTERNAL",
        "fileobject": "PERMISSION_FILE_OBJECT",
        "application": "PERMISSION_INTERNAL",
        "microservice": "PERMISSION_MICROSERVICE",
        "vimgrsevmruntime": "PERMISSION_CLOUD",
        "vimgrvmruntime": "PERMISSION_CLOUD",
        "vimgrhostruntime": "PERMISSION_CLOUD",
        "vimgrnwruntime": "PERMISSION_CLOUD",
        "vimgrclusterruntime": "PERMISSION_CLOUD",
        "vidcinfo": "PERMISSION_CLOUD",
        "vipgnameinfo": "PERMISSION_CLOUD",
        "vimgrvcenterruntime": "PERMISSION_CLOUD",
        "visubfolders": "PERMISSION_CLOUD",
        "vidatastore": "PERMISSION_CLOUD",
        "vihostresources": "PERMISSION_CLOUD",
        "vinetworksubnetvms": "PERMISSION_CLOUD",
        "interestedvms": "PERMISSION_CLOUD",
        "interestedhosts": "PERMISSION_CLOUD",
        "poolgroupdeploymentpolicy": "PERMISSION_POOLGROUPDEPLOYMENTPOLICY",
        "debugserviceengine": "PERMISSION_SERVICEENGINE",
        "debugvirtualservice": "PERMISSION_TRAFFIC_CAPTURE",
        "report": "PERMISSION_REPORT",
        "apiratelimitprofile": "PERMISSION_APIRATELIMITPROFILE",
        "ratelimitconfiguration": "PERMISSION_APIRATELIMITPROFILE",
        "upgradestatusinfo": "PERMISSION_CONTROLLER",
        "upgradestatussummary": "PERMISSION_CONTROLLER",
        "upgradecontrollerparams": "PERMISSION_UPGRADE_OPS",
        "upgradesegroupparams": "PERMISSION_UPGRADE_OPS",
        "upgradesystemparams": "PERMISSION_UPGRADE_OPS",
        "resumesegroupparams": "PERMISSION_UPGRADE_OPS",
        "patchcontrollerparams": "PERMISSION_UPGRADE_OPS",
        "patchsegroupparams": "PERMISSION_UPGRADE_OPS",
        "patchsystemparams": "PERMISSION_UPGRADE_OPS",
        "rollbackcontrollerparams": "PERMISSION_UPGRADE_OPS",
        "rollbacksegroupparams": "PERMISSION_UPGRADE_OPS",
        "rollbacksystemparams": "PERMISSION_UPGRADE_OPS",
        "rollbackpatchcontrollerparams": "PERMISSION_UPGRADE_OPS",
        "rollbackpatchsegroupparams": "PERMISSION_UPGRADE_OPS",
        "rollbackpatchsystemparams": "PERMISSION_UPGRADE_OPS",
        "upgradeparams": "PERMISSION_UPGRADE_OPS",
        "restoreparams": "PERMISSION_UPGRADE_OPS",
        "reportprofile": "PERMISSION_REPORTPROFILE",
        "virtualservice": "PERMISSION_VIRTUALSERVICE",
        "vsvip": "PERMISSION_VIRTUALSERVICE"
    },
    "version": "32.1.2",
    "pb": {
        "ActionGroupConfig": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "required": true
                },
                "name": {
                    "type": "string",
                    "required": true
                },
                "email_config_uuid": {
                    "type": "string",
                    "description": "Select the Email Notification configuration to use when sending alerts via email.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "syslog_config_uuid": {
                    "type": "string",
                    "description": "Select the Syslog Notification configuration to use when sending alerts via Syslog."
                },
                "action_script_config_uuid": {
                    "type": "string",
                    "description": "reference of the action script configuration to be used"
                },
                "external_only": {
                    "type": "bool",
                    "default": false,
                    "required": true,
                    "description": "Generate Alert only to external destinations",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "snmp_trap_profile_uuid": {
                    "type": "string",
                    "description": "Select the SNMP Trap Notification to use when sending alerts via SNMP Trap.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "autoscale_trigger_notification": {
                    "type": "bool",
                    "default": false,
                    "description": "Trigger Notification to AutoScale Manager",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "level": {
                    "type": "enum",
                    "enumType": "AlertLevel",
                    "default": "ALERT_LOW",
                    "required": true,
                    "description": "When an alert is generated, mark its priority via the Alert Level."
                },
                "description": {
                    "type": "string"
                },
                "tenant_uuid": {
                    "type": "string"
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                }
            }
        },
        "ConfigPbAttributes": {
            "fields": {
                "version": {
                    "type": "uint32",
                    "default": 1,
                    "description": "Version sequence number that monotonically advances with each configuration update event."
                },
                "created_by": {
                    "type": "enum",
                    "enumType": "ConfigCreator",
                    "description": "Identifies the user type that created the configuration. Nil for non-service users.",
                    "immutable": true
                }
            }
        },
        "ALBServicesConfig": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "required": true
                },
                "portal_url": {
                    "type": "string",
                    "description": "The FQDN or IP address of the Pulse Cloud Services.",
                    "required": true
                },
                "polling_interval": {
                    "type": "uint32",
                    "default": 10,
                    "description": "Time interval in minutes.",
                    "min": 5,
                    "max": 60
                },
                "asset_contact": {
                    "type": "message",
                    "messageType": "ALBServicesUser",
                    "description": "Default contact for this controller cluster."
                },
                "feature_opt_in_status": {
                    "type": "message",
                    "messageType": "PortalFeatureOptIn",
                    "description": "Features opt-in for Pulse Cloud Services.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "required": true
                },
                "use_split_proxy": {
                    "type": "bool",
                    "default": false,
                    "description": "By default, Pulse Cloud Services uses proxy added in system configuration. If it should use a separate proxy, set this flag to true and configure split proxy configuration."
                },
                "split_proxy_configuration": {
                    "type": "message",
                    "messageType": "ProxyConfiguration",
                    "description": "Split proxy configuration to connect external Pulse Cloud Services.",
                    "required": false
                },
                "ip_reputation_config": {
                    "type": "message",
                    "messageType": "IpReputationConfig",
                    "description": "Default values to be used for IP Reputation sync.",
                    "required": true
                },
                "use_tls": {
                    "type": "bool",
                    "default": true,
                    "description": "Secure the controller to Pulse Cloud Services communication over TLS",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "mode": {
                    "type": "enum",
                    "enumType": "ALBServiceMode",
                    "default": "MYVMWARE",
                    "description": "Mode helps log collection and upload.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "SALESFORCE,MYVMWARE,SYSTEST"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "SALESFORCE,MYVMWARE,SYSTEST"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "app_signature_config": {
                    "type": "message",
                    "messageType": "AppSignatureConfig",
                    "description": "Default values for Application Signature sync.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ],
                    "required": true
                },
                "user_agent_db_config": {
                    "type": "message",
                    "messageType": "UserAgentDBConfig",
                    "description": "Default values for user agent DB Service.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ],
                    "required": true
                },
                "waf_config": {
                    "type": "message",
                    "messageType": "WafCrsConfig",
                    "description": "Default values for waf management.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ],
                    "required": true
                },
                "case_config": {
                    "type": "message",
                    "messageType": "CaseConfig",
                    "description": "Default values for case management.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ],
                    "required": true
                },
                "saas_licensing_config": {
                    "type": "message",
                    "messageType": "SaasLicensingInfo",
                    "description": "Saas licensing configuration.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ],
                    "required": true
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                },
                "tenant_uuid": {
                    "type": "string",
                    "description": "Tenant UUID associated with the Object",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ],
                    "maxStringLength": 255,
                    "required": true
                },
                "name": {
                    "type": "string",
                    "description": "Name of the ALBServicesConfig object",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ],
                    "maxStringLength": 255
                },
                "tenant_config": {
                    "type": "message",
                    "messageType": "PulseServicesTenantConfig",
                    "description": "Tenant based configuration data.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "session_config": {
                    "type": "message",
                    "messageType": "PulseServicesSessionConfig",
                    "description": "Session configuration data.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "inventory_config": {
                    "type": "message",
                    "messageType": "InventoryConfiguration",
                    "description": "Inventory Configurations for Pulse Cloud Services.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ],
                    "required": true
                }
            }
        },
        "InventoryConfiguration": {
            "fields": {
                "enable_search_info": {
                    "type": "bool",
                    "default": false,
                    "description": "Names, IP's of VS, Pool(PoolGroup) servers would be searchable on Cloud console.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                }
            }
        },
        "PulseServicesSessionConfig": {
            "fields": {
                "session_headers": {
                    "type": "message",
                    "messageType": "SessionHeaders",
                    "repeated": true,
                    "description": "Session Headers"
                }
            }
        },
        "SessionHeaders": {
            "fields": {
                "name": {
                    "type": "string",
                    "description": "Header Name",
                    "maxStringLength": 255
                },
                "value": {
                    "type": "string",
                    "description": "Header Value",
                    "maxStringLength": 255
                }
            }
        },
        "PulseServicesTenantConfig": {
            "fields": {
                "heartbeat_interval": {
                    "type": "uint32",
                    "description": "Heartbeat Interval duration"
                },
                "token_refresh_interval": {
                    "type": "uint32",
                    "description": "Token Refresh Interval duration",
                    "min": 1,
                    "max": 240
                },
                "license_escrow_interval": {
                    "type": "uint32",
                    "description": "License Escrow Interval duration"
                },
                "license_refresh_interval": {
                    "type": "uint32",
                    "description": "License Refresh Interval duration"
                },
                "license_expiry_interval": {
                    "type": "uint32",
                    "description": "License Expiry Interval duration",
                    "min": 1,
                    "max": 1440
                },
                "license_renewal_interval": {
                    "type": "uint32",
                    "description": "License Renewal Interval duration",
                    "min": 1,
                    "max": 1440
                },
                "license_reconcile_interval": {
                    "type": "uint32",
                    "description": "License Reconcile Interval duration"
                }
            }
        },
        "CaseConfig": {
            "fields": {
                "enable_auto_case_creation_on_controller_failure": {
                    "type": "bool",
                    "default": false,
                    "description": "Enable pro-active support case creation when a controller failure occurs.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "enable_auto_case_creation_on_se_failure": {
                    "type": "bool",
                    "default": false,
                    "description": "Enable pro-active support case creation when a service engine failure occurs.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "enable_cleanup_of_attached_files": {
                    "type": "bool",
                    "default": true,
                    "description": "Enable cleanup of successfully attached files to support case.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false",
                            "default_value": false
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false",
                            "default_value": false
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "additional_emails": {
                    "type": "string",
                    "repeated": true,
                    "description": "Additional emails to get notified when the case gets created.",
                    "maxStringLength": 255
                }
            }
        },
        "WafCrsConfig": {
            "fields": {
                "enable_auto_download_waf_signatures": {
                    "type": "bool",
                    "default": false,
                    "description": "Enable to automatically download new WAF signatures/CRS version to the Controller.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "enable_waf_signatures_notifications": {
                    "type": "bool",
                    "default": true,
                    "description": "Enable event notifications when new WAF signatures/CRS versions are available.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false",
                            "default_value": false
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false",
                            "default_value": false
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                }
            }
        },
        "UserAgentDBConfig": {
            "fields": {
                "allowed_batch_size": {
                    "type": "uint32",
                    "default": 500,
                    "description": "Batch query limit.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "500"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "500"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ],
                    "min": 1,
                    "max": 500
                }
            }
        },
        "AppSignatureConfig": {
            "fields": {
                "app_signature_sync_interval": {
                    "type": "uint32",
                    "default": 1440,
                    "description": "Application Signature db sync interval in minutes.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY",
                            "default_value": 1440
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY",
                            "default_value": 1440
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ],
                    "min": 1440,
                    "max": 10080
                }
            }
        },
        "IpReputationConfig": {
            "fields": {
                "ip_reputation_sync_interval": {
                    "type": "uint32",
                    "default": 60,
                    "description": "IP reputation db sync interval in minutes.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "60"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "60"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 30,
                    "max": 1440
                },
                "ip_reputation_file_object_expiry_duration": {
                    "type": "uint32",
                    "default": 3,
                    "description": "IP reputation db file object expiry duration in days.",
                    "min": 1,
                    "max": 7
                },
                "enable_ipv4_reputation": {
                    "type": "bool",
                    "description": "Enable IPv4 Reputation"
                },
                "enable_ipv6_reputation": {
                    "type": "bool",
                    "description": "Enable IPv6 Reputation"
                }
            }
        },
        "ProxyConfiguration": {
            "fields": {
                "host": {
                    "type": "string",
                    "required": true,
                    "description": "Proxy hostname or IP address"
                },
                "port": {
                    "type": "uint32",
                    "required": true,
                    "description": "Proxy port"
                },
                "username": {
                    "type": "string",
                    "description": "Username for proxy"
                },
                "password": {
                    "type": "string",
                    "description": "Password for proxy"
                }
            }
        },
        "ALBServicesUser": {
            "fields": {
                "name": {
                    "type": "string",
                    "description": "Name of the portal user."
                },
                "email": {
                    "type": "string",
                    "description": "Email ID of the portal user.",
                    "required": true
                },
                "account_name": {
                    "type": "string",
                    "description": "Name of primary account of the portal user."
                },
                "account_id": {
                    "type": "string",
                    "description": "ID of primary account of the portal user."
                },
                "managed_accounts": {
                    "type": "message",
                    "messageType": "ALBServicesAccount",
                    "repeated": true,
                    "description": "Information about all the accounts managed by user in the customer portal."
                },
                "phone": {
                    "type": "string",
                    "description": "Phone number of the user."
                }
            }
        },
        "ALBServicesAccount": {
            "fields": {
                "name": {
                    "type": "string",
                    "description": "Account to which the customer portal user belongs."
                },
                "id": {
                    "type": "string",
                    "description": "ID of an Account in the customer portal."
                },
                "users": {
                    "type": "message",
                    "messageType": "ALBServicesAccountUser",
                    "repeated": true,
                    "description": "Information about users within the account in the customer portal."
                }
            }
        },
        "ALBServicesAccountUser": {
            "fields": {
                "name": {
                    "type": "string",
                    "required": true
                },
                "email": {
                    "type": "string",
                    "required": true
                },
                "phone": {
                    "type": "string",
                    "required": true
                }
            }
        },
        "Alert": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "required": true
                },
                "name": {
                    "type": "string",
                    "required": true
                },
                "alert_config_uuid": {
                    "type": "string",
                    "required": true
                },
                "level": {
                    "type": "enum",
                    "enumType": "AlertLevel",
                    "required": true,
                    "description": "Resolved Alert Type"
                },
                "reason": {
                    "type": "string",
                    "required": true
                },
                "state": {
                    "type": "enum",
                    "enumType": "AlertState",
                    "required": true,
                    "description": "State of the alert. It would be active when createdIt would be changed to state read when read by the admin"
                },
                "timestamp": {
                    "type": "Unknown",
                    "required": true,
                    "description": "Unix Timestamp of the last throttling in seconds"
                },
                "obj_uuid": {
                    "type": "string",
                    "required": true,
                    "description": "UUID of the resource"
                },
                "obj_key": {
                    "type": "string",
                    "required": true,
                    "description": "UUID of the resource"
                },
                "obj_name": {
                    "type": "string",
                    "description": "Name of the resource"
                },
                "threshold": {
                    "type": "uint32"
                },
                "events": {
                    "type": "message",
                    "messageType": "EventLog",
                    "repeated": true
                },
                "app_events": {
                    "type": "message",
                    "messageType": "ApplicationLog",
                    "repeated": true
                },
                "conn_events": {
                    "type": "message",
                    "messageType": "ConnectionLog",
                    "repeated": true
                },
                "metric_info": {
                    "type": "message",
                    "messageType": "MetricLog",
                    "repeated": true
                },
                "throttle_count": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Number of times it was throttled"
                },
                "last_throttle_timestamp": {
                    "type": "Unknown",
                    "description": "Unix Timestamp of the last throttling in seconds"
                },
                "related_uuids": {
                    "type": "string",
                    "repeated": true,
                    "description": "related uuids for the connection log. Only Log agent needs to fill this. Server uuid should be in formatpool_uuid-ip-port. In case of no port is set for server it shouldstill be operational port for the server"
                },
                "event_pages": {
                    "type": "string",
                    "repeated": true,
                    "description": "List of event pages this alert is associated with"
                },
                "summary": {
                    "type": "string",
                    "required": true,
                    "description": "summary of alert based on alert config"
                },
                "description": {
                    "type": "string",
                    "description": "alert generation criteria"
                },
                "action_script_output": {
                    "type": "string",
                    "description": "Output of the alert action script"
                },
                "tenant_uuid": {
                    "type": "string"
                }
            }
        },
        "ApplicationLog": {
            "fields": {
                "adf": {
                    "type": "bool",
                    "default": false,
                    "required": true
                },
                "significant": {
                    "type": "uint64",
                    "required": true
                },
                "significance": {
                    "type": "string"
                },
                "udf": {
                    "type": "bool",
                    "default": false,
                    "required": true
                },
                "virtualservice": {
                    "type": "string",
                    "required": true,
                    "maxStringLength": 64
                },
                "report_timestamp": {
                    "type": "uint64",
                    "required": true
                },
                "service_engine": {
                    "type": "string",
                    "required": true,
                    "maxStringLength": 64
                },
                "vcpu_id": {
                    "type": "uint32",
                    "required": true
                },
                "log_id": {
                    "type": "uint32",
                    "required": true
                },
                "client_ip": {
                    "type": "uint32",
                    "required": true,
                    "description": "IPv4 address of the client. When true client IP feature is enabled, this will be derived from the header configured in the true client IP feature, if present in the request"
                },
                "client_location": {
                    "type": "string",
                    "maxStringLength": 16
                },
                "client_src_port": {
                    "type": "uint32",
                    "required": true
                },
                "client_dest_port": {
                    "type": "uint32",
                    "required": true
                },
                "client_rtt": {
                    "type": "uint32",
                    "required": true
                },
                "ssl_session_id": {
                    "type": "string",
                    "maxStringLength": 32
                },
                "ssl_version": {
                    "type": "string",
                    "maxStringLength": 8
                },
                "ssl_cipher": {
                    "type": "string",
                    "maxStringLength": 32
                },
                "sni_hostname": {
                    "type": "string",
                    "maxStringLength": 256
                },
                "http_version": {
                    "type": "string",
                    "maxStringLength": 8
                },
                "method": {
                    "type": "string",
                    "maxStringLength": 16
                },
                "uri_path": {
                    "type": "string",
                    "maxStringLength": 256
                },
                "orig_uri": {
                    "type": "string",
                    "description": "The actual client request URI sent before normalization. Only included if it differs from the normalized URI.",
                    "maxStringLength": 256
                },
                "rewritten_uri_path": {
                    "type": "string",
                    "maxStringLength": 256
                },
                "uri_query": {
                    "type": "string",
                    "maxStringLength": 256
                },
                "rewritten_uri_query": {
                    "type": "string",
                    "maxStringLength": 256
                },
                "redirected_uri": {
                    "type": "string",
                    "maxStringLength": 256
                },
                "server_side_redirect_uri": {
                    "type": "string",
                    "maxStringLength": 256
                },
                "referer": {
                    "type": "string",
                    "maxStringLength": 256
                },
                "user_agent": {
                    "type": "string",
                    "maxStringLength": 256
                },
                "client_device": {
                    "type": "string",
                    "maxStringLength": 16
                },
                "client_browser": {
                    "type": "string",
                    "maxStringLength": 16
                },
                "client_os": {
                    "type": "string",
                    "maxStringLength": 16
                },
                "xff": {
                    "type": "string",
                    "maxStringLength": 64
                },
                "persistence_used": {
                    "type": "bool",
                    "default": false
                },
                "host": {
                    "type": "string",
                    "maxStringLength": 128
                },
                "etag": {
                    "type": "string",
                    "maxStringLength": 128
                },
                "persistent_session_id": {
                    "type": "uint64"
                },
                "request_content_type": {
                    "type": "string",
                    "maxStringLength": 32
                },
                "response_content_type": {
                    "type": "string",
                    "maxStringLength": 32
                },
                "request_length": {
                    "type": "uint64"
                },
                "cache_hit": {
                    "type": "bool",
                    "default": false
                },
                "cacheable": {
                    "type": "bool",
                    "default": false
                },
                "network_security_policy_rule_name": {
                    "type": "string",
                    "maxStringLength": 32
                },
                "http_security_policy_rule_name": {
                    "type": "string",
                    "maxStringLength": 32
                },
                "http_request_policy_rule_name": {
                    "type": "string",
                    "maxStringLength": 32
                },
                "http_response_policy_rule_name": {
                    "type": "string",
                    "maxStringLength": 32
                },
                "pool": {
                    "type": "string",
                    "maxStringLength": 64
                },
                "pool_name": {
                    "type": "string",
                    "maxStringLength": 32
                },
                "server_ip": {
                    "type": "uint32"
                },
                "server_name": {
                    "type": "string",
                    "maxStringLength": 32
                },
                "server_conn_src_ip": {
                    "type": "uint32"
                },
                "server_dest_port": {
                    "type": "uint32"
                },
                "server_src_port": {
                    "type": "uint32"
                },
                "server_rtt": {
                    "type": "uint32"
                },
                "server_response_length": {
                    "type": "uint64"
                },
                "server_response_code": {
                    "type": "uint32"
                },
                "server_response_time_first_byte": {
                    "type": "uint64"
                },
                "server_response_time_last_byte": {
                    "type": "uint64"
                },
                "app_response_time": {
                    "type": "uint64"
                },
                "data_transfer_time": {
                    "type": "uint64"
                },
                "total_time": {
                    "type": "uint64"
                },
                "response_length": {
                    "type": "uint64"
                },
                "response_code": {
                    "type": "uint32"
                },
                "response_time_first_byte": {
                    "type": "uint64"
                },
                "response_time_last_byte": {
                    "type": "uint64"
                },
                "compression_percentage": {
                    "type": "int32"
                },
                "compression": {
                    "type": "enum",
                    "enumType": "AviCompressionStatus"
                },
                "client_insights": {
                    "type": "enum",
                    "enumType": "AviClientInsightsStatus"
                },
                "connection_error_info": {
                    "type": "message",
                    "messageType": "ConnErrorInfo"
                },
                "spdy_version": {
                    "type": "string",
                    "maxStringLength": 16
                },
                "request_headers": {
                    "type": "uint32"
                },
                "response_headers": {
                    "type": "uint32"
                },
                "request_state": {
                    "type": "enum",
                    "enumType": "AviHTTPRequestState"
                },
                "datascript_error_trace": {
                    "type": "message",
                    "messageType": "DataScriptErrorTrace"
                },
                "all_request_headers": {
                    "type": "string",
                    "maxStringLength": 6144
                },
                "all_response_headers": {
                    "type": "string",
                    "maxStringLength": 6144
                },
                "user_id": {
                    "type": "string",
                    "maxStringLength": 256
                },
                "significant_log": {
                    "type": "enum",
                    "enumType": "AviDefinedFilters",
                    "repeated": true,
                    "description": "List of enums which indicate why a log is significant"
                },
                "datascript_log": {
                    "type": "string",
                    "description": "Log created by the invocations of the DataScript api avi.vs.log()",
                    "maxStringLength": 1024
                },
                "microservice": {
                    "type": "string",
                    "maxStringLength": 128
                },
                "microservice_name": {
                    "type": "string",
                    "maxStringLength": 32
                },
                "headers_sent_to_server": {
                    "type": "string",
                    "description": "Request headers sent to backend server",
                    "maxStringLength": 6144
                },
                "headers_received_from_server": {
                    "type": "string",
                    "description": "Response headers received from backend server",
                    "maxStringLength": 6144
                },
                "server_ssl_session_id": {
                    "type": "string",
                    "description": "SSL session id for the backend connection.",
                    "maxStringLength": 32
                },
                "server_connection_reused": {
                    "type": "bool",
                    "default": false,
                    "description": "Flag to indicate if connection from the connection pool was reused"
                },
                "server_ssl_session_reused": {
                    "type": "bool",
                    "default": false,
                    "description": "Flag to indicate if SSL session was reused."
                },
                "vs_ip": {
                    "type": "uint32"
                },
                "body_updated": {
                    "type": "enum",
                    "enumType": "AviHTTPResponseBodyUpdated",
                    "default": "NOT_UPDATED"
                },
                "waf_log": {
                    "type": "message",
                    "messageType": "WafLog",
                    "description": "Presence of waf_log indicates that atleast 1 WAF rule was hit for the transaction"
                },
                "client_ip6": {
                    "type": "Unknown",
                    "description": "IPv6 address of the client."
                },
                "vs_ip6": {
                    "type": "Unknown",
                    "description": "Virtual IPv6 address of the VS."
                },
                "server_ip6": {
                    "type": "Unknown",
                    "description": "IPv6 address of the Server."
                },
                "server_conn_src_ip6": {
                    "type": "Unknown",
                    "description": "IPv6 address used to connect to Server."
                },
                "request_id": {
                    "type": "string",
                    "description": "Unique HTTP Request ID ",
                    "maxStringLength": 16
                },
                "request_served_locally_remote_site_down": {
                    "type": "bool",
                    "default": false,
                    "description": "Flag to indicate if request was served locally because the remote site was down"
                },
                "http2_stream_id": {
                    "type": "uint32",
                    "description": "Stream identifier corresponding to an HTTP2 request."
                },
                "cipher_bytes": {
                    "type": "Unknown",
                    "description": "Byte stream of client cipher list sent on SSL_R_NO_SHARED_CIPHER error.This byte stream is used to generate client_cipher_list."
                },
                "client_cipher_list": {
                    "type": "message",
                    "messageType": "SSLCipherList",
                    "description": "List of ciphers sent by client in TLS Client Hello. This field is only generated when TLS handshake fails due to no shared cipher."
                },
                "client_log_filter_name": {
                    "type": "string",
                    "description": "Name of the Client Log Filter applied",
                    "maxStringLength": 32
                },
                "saml_authentication_used": {
                    "type": "bool",
                    "default": false,
                    "description": "SAML authentication is used."
                },
                "saml_session_cookie_valid": {
                    "type": "bool",
                    "default": false,
                    "description": "SAML authentication session cookie is valid."
                },
                "saml_auth_request_generated": {
                    "type": "bool",
                    "default": false,
                    "description": "SAML authentication request is generated."
                },
                "saml_auth_response_received": {
                    "type": "bool",
                    "default": false,
                    "description": "SAML authentication response is received."
                },
                "saml_auth_session_id": {
                    "type": "uint64",
                    "description": "SAML authentication session ID."
                },
                "servers_tried": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Number of servers tried during server reselect before the response is sent back."
                },
                "paa_log": {
                    "type": "message",
                    "messageType": "PaaLog",
                    "description": "Logs for the PingAccess authentication process."
                },
                "cache_disabled_by_ds": {
                    "type": "bool",
                    "default": false,
                    "description": "Cache fetch and store is disabled by the Datascript policies."
                },
                "grpc_status": {
                    "type": "int32",
                    "description": "GRPC response status sent in the GRPC trailer.",
                    "specialValues": {
                        "-1": "No GRPC status recevied even though client sent content-type as application/grpc."
                    }
                },
                "ocsp_status_resp_sent": {
                    "type": "bool",
                    "default": false,
                    "description": "OCSP Certificate Status response sent in the SSL/TLS connection handshake."
                },
                "critical_error_encountered": {
                    "type": "bool",
                    "default": false,
                    "description": "Critical error encountered during request processing."
                },
                "grpc_service_name": {
                    "type": "string",
                    "description": "The service called by the gRPC request.",
                    "maxStringLength": 256
                },
                "grpc_method_name": {
                    "type": "string",
                    "description": "The method called by the gRPC request.",
                    "maxStringLength": 256
                },
                "grpc_status_reason_phrase": {
                    "type": "enum",
                    "enumType": "GRPCStatus",
                    "description": "The reason phrase corresponding to the gRPC status code."
                },
                "icap_log": {
                    "type": "message",
                    "messageType": "IcapLog",
                    "description": "Log for the ICAP processing."
                },
                "saml_log": {
                    "type": "message",
                    "messageType": "SamlLog",
                    "description": "Logs for the SAML authentication/authorization process."
                },
                "jwt_log": {
                    "type": "message",
                    "messageType": "JwtLog",
                    "description": "Logs for the JWT Validation process."
                },
                "ntlm_log": {
                    "type": "message",
                    "messageType": "NtlmLog",
                    "description": "NTLM auto-detection logs."
                },
                "oob_log": {
                    "type": "message",
                    "messageType": "OutOfBandRequestLog",
                    "description": "Logs for HTTP Out-Of-Band Requests"
                },
                "session_id": {
                    "type": "string",
                    "description": "If the HTTP Session module is enabled for the Virtual Service, this field will contain the session id created by the module. Later calls to the DataScript function avi.vs.set_session_id() overwrite the value of this field with the value supplied in the function call.",
                    "maxStringLength": 256
                },
                "bot_management_log": {
                    "type": "message",
                    "messageType": "BotManagementLog",
                    "description": "Logs related to Bot detection."
                },
                "max_ingress_latency_fe": {
                    "type": "uint32",
                    "description": "Maximum packet processing latency for the frontend flow."
                },
                "avg_ingress_latency_fe": {
                    "type": "uint32",
                    "description": "Average packet processing latency for the frontend flow."
                },
                "conn_est_time_fe": {
                    "type": "uint32",
                    "description": "TCP connection establishment time for the frontend flow."
                },
                "max_ingress_latency_be": {
                    "type": "uint32",
                    "description": "Maximum packet processing latency for the backend flow."
                },
                "avg_ingress_latency_be": {
                    "type": "uint32",
                    "description": "Average packet processing latency for the backend flow."
                },
                "conn_est_time_be": {
                    "type": "uint32",
                    "description": "TCP connection establishment time for the backend flow."
                },
                "source_ip": {
                    "type": "uint32",
                    "description": "Source IP of the client connection to the VS. This can be different from client IP when true client IP feature is enabled."
                },
                "source_ip6": {
                    "type": "Unknown",
                    "description": "IPv6 address of the source of the client connection to the VS. This can be different from client IPv6 address when true client IP feature is enabled."
                },
                "oauth_log": {
                    "type": "message",
                    "messageType": "OauthLog",
                    "description": "Logs related to OAuth requests."
                },
                "auth_status": {
                    "type": "enum",
                    "enumType": "AuthStatus",
                    "default": "AUTH_STATUS_NO_AUTHENTICATION",
                    "description": "Set the Session Authentication Status."
                },
                "client_fingerprints": {
                    "type": "message",
                    "messageType": "ClientFingerprints",
                    "description": "The fingerprints for this client."
                },
                "server_push_initiated": {
                    "type": "bool",
                    "description": "Request which initiates Server Push"
                },
                "server_pushed_request": {
                    "type": "bool",
                    "description": "Requests served via Server Push"
                },
                "vh_match_rule": {
                    "type": "string",
                    "description": "EVH rule matching the request.",
                    "maxStringLength": 256
                },
                "request_body_updated": {
                    "type": "enum",
                    "enumType": "AviHTTPRequestBodyUpdated",
                    "default": "REQ_BODY_NOT_UPDATED",
                    "description": "Request body modified."
                },
                "ssl_named_group": {
                    "type": "string",
                    "description": "SSl group negotitaed during SSL handhshake",
                    "maxStringLength": 128
                },
                "ssl_signature_algorithm": {
                    "type": "string",
                    "description": "SSL signature algorithm negotitaed during SSL handhshake",
                    "maxStringLength": 128
                },
                "learning_status": {
                    "type": "enum",
                    "enumType": "WafLearningStatus",
                    "default": "NOT_ACTIVE",
                    "description": "Indicate if this request is used for learning. If it is not used, this field contains the reason for this decision."
                }
            }
        },
        "ClientFingerprints": {
            "fields": {
                "tls_client_info": {
                    "type": "message",
                    "messageType": "TlsClientInfo",
                    "description": "Values of selected fields from the ClientHello."
                },
                "full_tls_fingerprint": {
                    "type": "string",
                    "description": "Message Digest (md5) of JA3 from ClientHello. Only present if the full TLS fingerprint is different from the filtered fingerprint.",
                    "maxStringLength": 32
                },
                "filtered_tls_fingerprint": {
                    "type": "string",
                    "description": "Message Digest (md5) of filtered JA3 from ClientHello. This can deviate from 'tls_fingerprint' because not all extensions are considered.",
                    "maxStringLength": 32
                },
                "normalized_tls_fingerprint": {
                    "type": "string",
                    "description": "Message Digest (md5) of normalized JA3 from ClientHello. This can deviate from 'full_tls_fingerprint' because extensions 21 and 35 are removed and the remaining values are sorted numerically before the MD5 is calculated.",
                    "maxStringLength": 32
                }
            }
        },
        "TlsClientInfo": {
            "fields": {
                "client_hello_tls_version": {
                    "type": "uint32",
                    "description": "The TLS version in the ClientHello as integer. For example, TLSv1.2 (0x0303) will be shown as 771."
                },
                "cipher_suites": {
                    "type": "uint32",
                    "repeated": true,
                    "description": "The list of Cipher Suites in the ClientHello as integers. For example, TLS_ECDHE_ECDSA_WITH_AES_128_CBC_SHA (0xc009) will be shown as 49161."
                },
                "tls_extensions": {
                    "type": "uint32",
                    "repeated": true,
                    "description": "The list of TLS Extensions in the ClientHello as integers. For example, signature_algorithms will be shown as 13."
                },
                "supported_groups": {
                    "type": "uint32",
                    "repeated": true,
                    "description": "The list of TLS Supported Groups in the ClientHello as integers. For example, secp256r1 will be shown as 23."
                },
                "point_formats": {
                    "type": "uint32",
                    "repeated": true,
                    "description": "The list of supported EC Point Formats in the ClientHello as integers. For example, uncompressed will be shown as 0 (zero)."
                },
                "uses_grease": {
                    "type": "bool",
                    "description": "Indicates whether the ClientHello contained GREASE ciphers, extensions or groups."
                }
            }
        },
        "OauthLog": {
            "fields": {
                "token_exchange_subrequest": {
                    "type": "message",
                    "messageType": "OauthSubRequestLog",
                    "description": "Subrequest info related to the code exchange flow."
                },
                "token_introspection_subrequest": {
                    "type": "message",
                    "messageType": "OauthSubRequestLog",
                    "description": "Subrequest info related to Token Introspection."
                },
                "token_refresh_subrequest": {
                    "type": "message",
                    "messageType": "OauthSubRequestLog",
                    "description": "Subrequest info related to refresh access Token flow."
                },
                "jwks_subrequest": {
                    "type": "message",
                    "messageType": "OauthSubRequestLog",
                    "description": "Subrequest info related to fetching jwks keys from jwks uri endpoint."
                },
                "oauth_state": {
                    "type": "enum",
                    "enumType": "OauthState",
                    "description": "OAuth state."
                },
                "is_session_cookie_expired": {
                    "type": "bool",
                    "description": "OAuth SessionCookie expired."
                },
                "authn_rule_match": {
                    "type": "message",
                    "messageType": "AuthnRuleMatch",
                    "description": "Authentication policy rule match."
                },
                "authz_rule_match": {
                    "type": "message",
                    "messageType": "AuthzRuleMatch",
                    "description": "Authorization policy rule match."
                },
                "state": {
                    "type": "string",
                    "description": "OAuth request State to avoid CSRF atatcks.",
                    "maxStringLength": 64
                },
                "userinfo_subrequest": {
                    "type": "message",
                    "messageType": "OauthSubRequestLog",
                    "description": "Subrequest info related to fetching userinfo from userinfo endpoint."
                }
            }
        },
        "OauthSubRequestLog": {
            "fields": {
                "sub_request_log": {
                    "type": "message",
                    "messageType": "SubRequestLog",
                    "description": "Subrequest info related to the Oauth flow."
                },
                "error_code": {
                    "type": "string",
                    "description": "Error code.",
                    "maxStringLength": 64
                },
                "error_description": {
                    "type": "string",
                    "description": "Error description.",
                    "maxStringLength": 256
                }
            }
        },
        "SubRequestLog": {
            "fields": {
                "method": {
                    "type": "enum",
                    "enumType": "HTTPMethod",
                    "description": "The HTTP method of the sub-request."
                },
                "http_version": {
                    "type": "enum",
                    "enumType": "HTTPVersion",
                    "description": "The HTTP version of the sub-request."
                },
                "uri_path": {
                    "type": "string",
                    "description": "The URI path of the sub-request.",
                    "maxStringLength": 256
                },
                "uri_query": {
                    "type": "string",
                    "description": "The URI query of the sub-request.",
                    "maxStringLength": 256
                },
                "http_response_code": {
                    "type": "uint32",
                    "description": "The HTTP response code received from the server."
                },
                "pool_name": {
                    "type": "string",
                    "description": "The name of the pool that was used for the sub-request.",
                    "maxStringLength": 32
                },
                "pool_uuid": {
                    "type": "string",
                    "description": "The uuid of the pool that was used for the sub-request.",
                    "maxStringLength": 64
                },
                "server_name": {
                    "type": "string",
                    "description": "The name of the server that was used for the sub-request.",
                    "maxStringLength": 32
                },
                "server_ip": {
                    "type": "uint32",
                    "description": "The IP of the server that was used for the sub-request."
                },
                "server_port": {
                    "type": "uint32",
                    "description": "The port of the server that was used for the sub-request."
                },
                "source_port": {
                    "type": "uint32",
                    "description": "The source port for this request."
                },
                "headers_sent_to_server": {
                    "type": "string",
                    "description": "Request headers sent to the server",
                    "maxStringLength": 6144
                },
                "headers_received_from_server": {
                    "type": "string",
                    "description": "Response headers received from the server",
                    "maxStringLength": 6144
                },
                "request_length": {
                    "type": "uint64",
                    "description": "Length of the request sent in bytes."
                },
                "response_length": {
                    "type": "uint64",
                    "description": "Length of the response received in bytes."
                },
                "total_time": {
                    "type": "uint64",
                    "description": "Total time taken to process the Oauth Subrequest. This is the time taken from the 1st byte of the request sent to the last byte of the response received."
                }
            }
        },
        "AuthzRuleMatch": {
            "fields": {
                "rule_name": {
                    "type": "string",
                    "description": "Name of the matched Authorization rule."
                },
                "rule_action": {
                    "type": "enum",
                    "enumType": "AuthorizationActionEnum",
                    "description": "Name of the executed Authorization rule Action."
                }
            }
        },
        "AuthnRuleMatch": {
            "fields": {
                "rule_name": {
                    "type": "string",
                    "description": "Name of the matched Authentication rule."
                },
                "rule_action": {
                    "type": "enum",
                    "enumType": "AuthenticationActionEnum",
                    "description": "Name of the executed Authentication rule Action."
                }
            }
        },
        "BotManagementLog": {
            "fields": {
                "results": {
                    "type": "message",
                    "messageType": "BotEvaluationResult",
                    "repeated": true,
                    "description": "The evaluation results of the various bot module components."
                },
                "classification": {
                    "type": "message",
                    "messageType": "BotClassification",
                    "description": "The final classification of the bot management module."
                },
                "mapping_decision": {
                    "type": "message",
                    "messageType": "BotMappingDecision",
                    "description": "Bot Mapping details."
                }
            }
        },
        "BotMappingDecision": {
            "fields": {
                "mapping_name": {
                    "type": "string",
                    "description": "The name of the Bot Mapping that made the decision.",
                    "maxStringLength": 256
                },
                "mapping_rule_name": {
                    "type": "string",
                    "description": "The name of the Bot Mapping Rule that made the decision.",
                    "maxStringLength": 256
                }
            }
        },
        "BotClassification": {
            "fields": {
                "type": {
                    "type": "enum",
                    "enumType": "BotClassificationTypes",
                    "description": "One of the system-defined Bot classification types.",
                    "required": true
                },
                "user_defined_type": {
                    "type": "string",
                    "description": "If 'type' has BotClassificationTypes value 'USER_DEFINED', this is the user-defined value."
                }
            }
        },
        "BotEvaluationResult": {
            "fields": {
                "component": {
                    "type": "enum",
                    "enumType": "BotDecisionComponent",
                    "description": "The component of the bot module that made this evaluation."
                },
                "identification": {
                    "type": "message",
                    "messageType": "BotIdentification",
                    "description": "The resulting Bot Identification."
                },
                "confidence": {
                    "type": "enum",
                    "enumType": "BotConfidence",
                    "description": "The confidence of this evaluation."
                },
                "notes": {
                    "type": "string",
                    "repeated": true,
                    "description": "Additional notes for this result."
                }
            }
        },
        "BotIdentification": {
            "fields": {
                "class": {
                    "type": "enum",
                    "enumType": "BotClientClass",
                    "description": "The Bot Client Class of this identification."
                },
                "type": {
                    "type": "enum",
                    "enumType": "BotClientType",
                    "description": "The Bot Client Type of this identification."
                },
                "identifier": {
                    "type": "string",
                    "description": "A free-form string to identify the client."
                }
            }
        },
        "OutOfBandRequestLog": {
            "fields": {
                "ds_req_logs": {
                    "type": "message",
                    "messageType": "DSRequestLog",
                    "repeated": true,
                    "description": "Logs for out-of-band requests sent from the DataScript."
                }
            }
        },
        "DSRequestLog": {
            "fields": {
                "ds_name": {
                    "type": "string",
                    "description": "Name of the DataScript where this request was called."
                },
                "event": {
                    "type": "enum",
                    "enumType": "VSDataScriptEvent",
                    "description": "DataScript event where out-of-band request was sent."
                },
                "http_response_code": {
                    "type": "uint32",
                    "description": "The HTTP response code received from the external server."
                },
                "http_version": {
                    "type": "string",
                    "description": "The HTTP version of the out-of-band request.",
                    "maxStringLength": 8
                },
                "method": {
                    "type": "string",
                    "description": "The HTTP method of the out-of-band request.",
                    "maxStringLength": 16
                },
                "uri_path": {
                    "type": "string",
                    "description": "The URI path of the out-of-band request.",
                    "maxStringLength": 256
                },
                "uri_query": {
                    "type": "string",
                    "description": "The URI query of the out-of-band request.",
                    "maxStringLength": 256
                },
                "pool_name": {
                    "type": "string",
                    "description": "The name of the pool that was used for the request.",
                    "maxStringLength": 32
                },
                "pool_uuid": {
                    "type": "string",
                    "description": "The uuid of the pool that was used for the request.",
                    "maxStringLength": 64
                },
                "server_name": {
                    "type": "string",
                    "description": "The name of the server that was used for the request.",
                    "maxStringLength": 32
                },
                "server_ip": {
                    "type": "uint32",
                    "description": "The IP of the server that was used for the request."
                },
                "server_port": {
                    "type": "uint32",
                    "description": "The port of the server that was used for the request."
                },
                "source_port": {
                    "type": "uint32",
                    "description": "The source port for this request."
                },
                "servers_tried": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Number of servers tried during server reselect before the response is sent back."
                },
                "headers_sent_to_server": {
                    "type": "string",
                    "description": "Request headers sent to the server",
                    "maxStringLength": 6144
                },
                "headers_received_from_server": {
                    "type": "string",
                    "description": "Response headers received from the server",
                    "maxStringLength": 6144
                },
                "request_length": {
                    "type": "uint64",
                    "description": "Length of the request sent in bytes."
                },
                "response_length": {
                    "type": "uint64",
                    "description": "Length of the response received in bytes."
                },
                "total_time": {
                    "type": "uint64",
                    "description": "Total time taken to process the Out-of-Band request. This is the time taken from the 1st byte of the request sent to the last byte of the response received."
                }
            }
        },
        "NtlmLog": {
            "fields": {
                "ntlm_detected": {
                    "type": "bool",
                    "description": "Set to true, if request is detected to be NTLM."
                },
                "ntlm_status": {
                    "type": "enum",
                    "enumType": "NtlmStatus",
                    "description": "Set the NTLM Status."
                }
            }
        },
        "JwtLog": {
            "fields": {
                "is_jwt_verified": {
                    "type": "bool",
                    "description": "Set to true, if JWT validation is successful."
                },
                "authn_rule_match": {
                    "type": "message",
                    "messageType": "AuthnRuleMatch",
                    "description": "Authentication policy rule match."
                },
                "authz_rule_match": {
                    "type": "message",
                    "messageType": "AuthzRuleMatch",
                    "description": "Authorization policy rule match."
                },
                "token_payload": {
                    "type": "string",
                    "description": "JWT token payload."
                }
            }
        },
        "SamlLog": {
            "fields": {
                "is_saml_authentication_used": {
                    "type": "bool",
                    "description": "Set to True if SAML Authentication is used."
                },
                "saml_authn_rule_match": {
                    "type": "message",
                    "messageType": "SamlAuthnRuleMatch",
                    "description": "SAML Authentication rule match."
                },
                "saml_authz_rule_match": {
                    "type": "message",
                    "messageType": "SamlAuthzRuleMatch",
                    "description": "SAML Authorization rule match."
                },
                "saml_auth_status": {
                    "type": "enum",
                    "enumType": "SamlAuthStatus",
                    "description": "Saml Authentication Status."
                },
                "saml_session_cookie_expired": {
                    "type": "bool",
                    "description": "Is set when SAML session cookie is expired."
                },
                "userid": {
                    "type": "string",
                    "description": "SAML userid."
                },
                "saml_attribute_lists": {
                    "type": "message",
                    "messageType": "SamlAttribute",
                    "repeated": true,
                    "description": "SAML Attribute list."
                }
            }
        },
        "SamlAttribute": {
            "fields": {
                "attr_name": {
                    "type": "string",
                    "description": "SAML Attribute name."
                },
                "attr_values": {
                    "type": "string",
                    "repeated": true,
                    "description": "SAML Attribute values."
                }
            }
        },
        "SamlAuthzRuleMatch": {
            "fields": {
                "saml_authz_matched_rule_name": {
                    "type": "string",
                    "description": "Name of the matched SAML Authorization rule."
                },
                "saml_authz_matched_rule_action": {
                    "type": "enum",
                    "enumType": "AuthorizationActionEnum",
                    "description": "Name of the executed SAML Authorization rule Action."
                }
            }
        },
        "SamlAuthnRuleMatch": {
            "fields": {
                "saml_authn_matched_rule_name": {
                    "type": "string",
                    "description": "Name of the matched SAML Authentication rule."
                },
                "saml_authn_matched_rule_action": {
                    "type": "enum",
                    "enumType": "AuthenticationActionEnum",
                    "description": "Name of the executed SAML Authentication rule Action."
                }
            }
        },
        "IcapLog": {
            "fields": {
                "action": {
                    "type": "enum",
                    "enumType": "IcapAction",
                    "description": "Denotes whether the content was processed by ICAP server and an action was taken."
                },
                "request_logs": {
                    "type": "message",
                    "messageType": "IcapRequestLog",
                    "repeated": true,
                    "description": "Logs for the HTTP request's content sent to the ICAP server."
                }
            }
        },
        "IcapRequestLog": {
            "fields": {
                "icap_response_code": {
                    "type": "uint32",
                    "description": "The response code received from the ICAP server."
                },
                "icap_method": {
                    "type": "enum",
                    "enumType": "ICAPMethod",
                    "description": "The ICAP method of the request.",
                    "maxStringLength": 16
                },
                "http_response_code": {
                    "type": "uint32",
                    "description": "The HTTP response code received from the ICAP server. HTTP response code is only available if content is blocked."
                },
                "http_method": {
                    "type": "enum",
                    "enumType": "HTTPMethod",
                    "description": "The HTTP method of the request.",
                    "maxStringLength": 16
                },
                "icap_absolute_uri": {
                    "type": "string",
                    "description": "The absolute ICAP uri of the request.",
                    "maxStringLength": 256
                },
                "complete_body_sent": {
                    "type": "bool",
                    "description": "Complete request body from client was sent to The ICAP server."
                },
                "modified_content_length": {
                    "type": "uint32",
                    "description": "Content-Length of the modified content from ICAP server."
                },
                "pool_name": {
                    "type": "string",
                    "description": "The name of the pool that was used for the request.",
                    "maxStringLength": 32
                },
                "pool_uuid": {
                    "type": "string",
                    "description": "The uuid of the pool that was used for the request.",
                    "maxStringLength": 64
                },
                "source_port": {
                    "type": "uint32",
                    "description": "Source port for this connection"
                },
                "latency": {
                    "type": "uint64",
                    "description": "Latency added due to ICAP processing. This is the time taken from 1st byte of ICAP request sent to last byte of ICAP response received."
                },
                "icap_headers_sent_to_server": {
                    "type": "string",
                    "description": "ICAP request headers sent to ICAP server.",
                    "maxStringLength": 6144
                },
                "icap_headers_received_from_server": {
                    "type": "string",
                    "description": "ICAP response headers received from ICAP server.",
                    "maxStringLength": 6144
                },
                "action": {
                    "type": "enum",
                    "enumType": "IcapAction",
                    "description": "Denotes whether the content was processed by ICAP server and an action was taken."
                },
                "icap_server_port": {
                    "type": "uint32",
                    "description": "ICAP server port for this connection."
                },
                "icap_server_ip": {
                    "type": "uint32",
                    "description": "ICAP server IP for this connection."
                },
                "vendor": {
                    "type": "enum",
                    "enumType": "ICAPVendor",
                    "description": "Selected ICAP vendor for the request."
                },
                "opswat_log": {
                    "type": "message",
                    "messageType": "IcapOPSWATLog",
                    "description": "ICAP log specific to OPSWAT."
                },
                "nsx_defender_log": {
                    "type": "message",
                    "messageType": "IcapNSXDefenderLog",
                    "description": "ICAP log specific to NSX Defender."
                }
            }
        },
        "IcapNSXDefenderLog": {
            "fields": {
                "score": {
                    "type": "uint32",
                    "description": "Score associated with the uploaded file, if known, value is in between 0 and 100."
                },
                "task_uuid": {
                    "type": "string",
                    "description": "The NSX Defender task UUID associated with the analysis of the file. It is possible to use this UUID in order to access the analysis details from the NSX Defender Portal/Manager Web UI. URL to access this information is https://user.lastline.com/portal#/analyst/task/<uuid>/overview."
                },
                "status_url": {
                    "type": "string",
                    "description": "URL to get details from NSXDefender for the request"
                }
            }
        },
        "IcapOPSWATLog": {
            "fields": {
                "reason": {
                    "type": "string",
                    "description": "Blocking reason for the content. It is available only if content was scanned by ICAP server and some violations were found."
                },
                "threat_id": {
                    "type": "string",
                    "description": "Short description of the threat found in the content. Available only if content was scanned by ICAP server and some violations were found."
                },
                "violations": {
                    "type": "message",
                    "messageType": "IcapViolation",
                    "repeated": true,
                    "description": "Threat found in the content. Available only if content was scanned by ICAP server and some violations were found."
                }
            }
        },
        "ConnErrorInfo": {
            "fields": {
                "out_of_orders": {
                    "type": "uint32"
                },
                "retransmits": {
                    "type": "uint32"
                },
                "timeouts": {
                    "type": "uint32"
                },
                "rx_pkts": {
                    "type": "uint64"
                },
                "tx_pkts": {
                    "type": "uint64"
                },
                "zero_window_size_events": {
                    "type": "uint64"
                },
                "server_out_of_orders": {
                    "type": "uint32"
                },
                "server_retransmits": {
                    "type": "uint32"
                },
                "server_timeouts": {
                    "type": "uint32"
                },
                "server_rx_pkts": {
                    "type": "uint64"
                },
                "server_tx_pkts": {
                    "type": "uint64"
                },
                "server_zero_window_size_events": {
                    "type": "uint64"
                },
                "num_window_shrink": {
                    "type": "uint32"
                },
                "server_num_window_shrink": {
                    "type": "uint32"
                },
                "num_syn_retransmit": {
                    "type": "uint32"
                }
            }
        },
        "EventLog": {
            "fields": {
                "report_timestamp": {
                    "type": "uint64",
                    "required": true
                },
                "obj_type": {
                    "type": "enum",
                    "enumType": "AviObjectType"
                },
                "event_id": {
                    "type": "enum",
                    "enumType": "EventId",
                    "required": true
                },
                "module": {
                    "type": "enum",
                    "enumType": "EventModule",
                    "required": true
                },
                "internal": {
                    "type": "enum",
                    "enumType": "EventInternalType",
                    "default": "EVENT_INTERNAL"
                },
                "context": {
                    "type": "enum",
                    "enumType": "EventContext"
                },
                "obj_uuid": {
                    "type": "string"
                },
                "obj_name": {
                    "type": "string"
                },
                "event_details": {
                    "type": "message",
                    "messageType": "EventDetails"
                },
                "details_summary": {
                    "type": "string",
                    "description": "Summary of event details"
                },
                "related_uuids": {
                    "type": "string",
                    "repeated": true,
                    "description": "related objects corresponding to the events"
                },
                "event_description": {
                    "type": "string",
                    "description": "Event Description for each Event  in the table view"
                },
                "event_pages": {
                    "type": "string",
                    "repeated": true,
                    "description": "Pages in which event should come up"
                },
                "ignore_event_details_display": {
                    "type": "bool",
                    "default": false
                },
                "is_security_event": {
                    "type": "bool",
                    "default": false
                },
                "tenant_name": {
                    "type": "string"
                },
                "tenant": {
                    "type": "string"
                }
            }
        },
        "AlertConfig": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "required": true
                },
                "name": {
                    "type": "string",
                    "required": true,
                    "description": "Name of the alert configuration"
                },
                "summary": {
                    "type": "string",
                    "description": "Summary of reason why alert is generated"
                },
                "description": {
                    "type": "string",
                    "description": "A custom description field."
                },
                "alert_rule": {
                    "type": "message",
                    "messageType": "AlertRule",
                    "required": true,
                    "description": "list of filters matching on events or client logs used for triggering alerts."
                },
                "threshold": {
                    "type": "uint32",
                    "default": 1,
                    "description": "An alert is created only when the number of events meets or exceeds this number within the chosen time frame.",
                    "min": 1,
                    "max": 65536
                },
                "throttle": {
                    "type": "uint32",
                    "default": 600,
                    "description": "Alerts are suppressed (throttled) for this duration of time since the last alert was raised for this alert config.",
                    "min": 0,
                    "max": 31536000
                },
                "rolling_window": {
                    "type": "uint32",
                    "default": 300,
                    "description": "Only if the Number of Events is reached or exceeded within the Time Window will an alert be generated.",
                    "min": 1,
                    "max": 31536000
                },
                "expiry_time": {
                    "type": "uint32",
                    "default": 86400,
                    "description": "An alert is expired and deleted after the expiry time has elapsed.  The original event triggering the alert remains in the event's log.",
                    "min": 1,
                    "max": 31536000
                },
                "source": {
                    "type": "enum",
                    "enumType": "AlertSource",
                    "required": true,
                    "description": "Signifies system events or the type of client logsused in this alert configuration"
                },
                "obj_uuid": {
                    "type": "string",
                    "description": "Instance of the resource for which alert was raised"
                },
                "category": {
                    "type": "enum",
                    "enumType": "AlertCategory",
                    "default": "REALTIME",
                    "required": true,
                    "description": "Determines whether an alert is raised immediately when event occurs (realtime) or after specified number of events occurs within rolling time window."
                },
                "recommendation": {
                    "type": "string",
                    "description": ""
                },
                "enabled": {
                    "type": "bool",
                    "default": true,
                    "description": "Enable or disable this alert config from generating new alerts."
                },
                "action_group_uuid": {
                    "type": "string",
                    "description": "The alert config will trigger the selected alert action, which can send notifications and execute a controlscript."
                },
                "autoscale_alert": {
                    "type": "bool",
                    "description": "This alert config applies to auto scale alerts"
                },
                "object_type": {
                    "type": "enum",
                    "enumType": "AviObjectType",
                    "description": "The object type to which the Alert Config is associated with. Valid object types are - Virtual Service, Pool, Service Engine"
                },
                "tenant_uuid": {
                    "type": "string"
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                }
            }
        },
        "AlertEmailConfig": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "required": true
                },
                "name": {
                    "type": "string",
                    "required": true,
                    "description": "A user-friendly name of the email notification service"
                },
                "to_emails": {
                    "type": "string",
                    "required": true,
                    "description": "Alerts are sent to the comma separated list of  email recipients"
                },
                "cc_emails": {
                    "type": "string",
                    "description": "Alerts are copied to the comma separated list of  email recipients"
                },
                "description": {
                    "type": "string"
                },
                "tenant_uuid": {
                    "type": "string"
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                }
            }
        },
        "AlertRule": {
            "fields": {
                "sys_event_rule": {
                    "type": "message",
                    "messageType": "AlertRuleEvent",
                    "repeated": true
                },
                "conn_app_log_rule": {
                    "type": "message",
                    "messageType": "AlertFilter"
                },
                "event_match_filter": {
                    "type": "string"
                },
                "metrics_rule": {
                    "type": "message",
                    "messageType": "AlertRuleMetric",
                    "repeated": true
                },
                "operator": {
                    "type": "enum",
                    "enumType": "AlertRuleOperator",
                    "default": "OPERATOR_AND"
                }
            }
        },
        "AlertFilter": {
            "fields": {
                "filter_string": {
                    "type": "string",
                    "required": true
                },
                "filter_action": {
                    "type": "string"
                }
            }
        },
        "AlertRuleEvent": {
            "fields": {
                "event_id": {
                    "type": "enum",
                    "enumType": "EventId",
                    "description": "When the selected event occurs, trigger this alert."
                },
                "not_cond": {
                    "type": "bool",
                    "default": false
                },
                "event_details": {
                    "type": "message",
                    "messageType": "EventDetailsFilter",
                    "repeated": true
                }
            }
        },
        "EventDetailsFilter": {
            "fields": {
                "event_details_key": {
                    "type": "string",
                    "required": true
                },
                "event_details_value": {
                    "type": "string",
                    "required": true
                },
                "comparator": {
                    "type": "enum",
                    "enumType": "AlertOperation",
                    "default": "ALERT_OP_EQ",
                    "required": true
                }
            }
        },
        "AlertRuleMetric": {
            "fields": {
                "metric_id": {
                    "type": "string",
                    "description": "Metric Id for the Alert. Eg. l4_client.avg_complete_conns"
                },
                "metric_threshold": {
                    "type": "message",
                    "messageType": "AlertMetricThreshold",
                    "required": true
                },
                "duration": {
                    "type": "uint32",
                    "description": "Evaluation window for the Metrics"
                }
            }
        },
        "AlertMetricThreshold": {
            "fields": {
                "threshold": {
                    "type": "uint32",
                    "description": "Metric threshold for comparison"
                },
                "comparator": {
                    "type": "enum",
                    "enumType": "AlertOperation",
                    "default": "ALERT_OP_GT",
                    "required": true
                }
            }
        },
        "AlertScriptConfig": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "required": true
                },
                "name": {
                    "type": "string",
                    "required": true,
                    "description": "A user-friendly name of the Script"
                },
                "action_script": {
                    "type": "string",
                    "description": "User Defined Alert Action Script. Please refer to kb.avinetworks.com for more information."
                },
                "tenant_uuid": {
                    "type": "string"
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                },
                "timeout": {
                    "type": "int32",
                    "description": "controlscript excution timeout"
                },
                "user_id": {
                    "type": "string",
                    "description": "Uuid of last editor user",
                    "maxStringLength": 256
                }
            }
        },
        "AlertSyslogConfig": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "required": true
                },
                "name": {
                    "type": "string",
                    "required": true,
                    "description": "A user-friendly name of the syslog notification"
                },
                "syslog_servers": {
                    "type": "message",
                    "messageType": "AlertSyslogServer",
                    "repeated": true,
                    "description": "The list of syslog servers"
                },
                "description": {
                    "type": "string",
                    "description": "User defined description for alert syslog config"
                },
                "tenant_uuid": {
                    "type": "string"
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                },
                "sender_hostname": {
                    "type": "string",
                    "description": "User defined sender hostname in syslog message",
                    "maxStringLength": 128
                }
            }
        },
        "AlertSyslogServer": {
            "fields": {
                "syslog_server": {
                    "type": "string",
                    "required": true,
                    "description": "The destination Syslog server IP(v4/v6) address or FQDN."
                },
                "syslog_server_port": {
                    "type": "uint32",
                    "default": 514,
                    "description": "The destination Syslog server's service port."
                },
                "udp": {
                    "type": "bool",
                    "default": true,
                    "required": true,
                    "description": "Network protocol to establish syslog session"
                },
                "format": {
                    "type": "enum",
                    "enumType": "SyslogFormat",
                    "default": "SYSLOG_LEGACY",
                    "description": "Syslog output format - legacy, RFC 5424, JSON"
                },
                "tls_enable": {
                    "type": "bool",
                    "default": false,
                    "description": "Enable TLS to the syslog server"
                },
                "ssl_key_and_certificate_uuid": {
                    "type": "string",
                    "description": "Select a certificate and key which will be used to authenticate to the syslog server"
                },
                "pkiprofile_uuid": {
                    "type": "string",
                    "description": "Select the PKIProfile containing a CA or list of CA chainswhich will validate the certificate of the syslog server"
                },
                "anon_auth": {
                    "type": "bool",
                    "default": false,
                    "description": "Enable anonymous authentication of Syslog Serverwhich will disable server certificate authentication"
                },
                "strict_cert_verify": {
                    "type": "bool",
                    "default": false,
                    "description": "strict verificiation of certificate given by the server"
                }
            }
        },
        "AnalyticsProfile": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "required": true,
                    "description": "UUID of the analytics profile."
                },
                "name": {
                    "type": "string",
                    "required": true,
                    "description": "The name of the analytics profile.",
                    "maxStringLength": 256
                },
                "tenant_uuid": {
                    "type": "string",
                    "required": true
                },
                "description": {
                    "type": "string"
                },
                "apdex_response_threshold": {
                    "type": "uint32",
                    "default": 500,
                    "description": "If a client receives an HTTP response in less than the Satisfactory Latency Threshold, the request is considered Satisfied. It is considered Tolerated if it is not Satisfied and less than Tolerated Latency Factor multiplied by the Satisfactory Latency Threshold. Greater than this number and the client's request is considered Frustrated.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "500"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "500"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 1,
                    "max": 30000
                },
                "apdex_response_tolerated_factor": {
                    "type": "Unknown",
                    "default": 4,
                    "description": "Client tolerated response latency factor. Client must receive a response within this factor times the satisfactory threshold (apdex_response_threshold) to be considered tolerated",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "4"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "4"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 1,
                    "max": 1000
                },
                "apdex_server_response_threshold": {
                    "type": "uint32",
                    "default": 400,
                    "description": "A server HTTP response is considered Satisfied if latency is less than the Satisfactory Latency Threshold. The response is considered tolerated when it is greater than Satisfied but less than the Tolerated Latency Factor * S_Latency.  Greater than this number and the server response is considered Frustrated.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "400"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "400"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 1,
                    "max": 30000
                },
                "apdex_server_response_tolerated_factor": {
                    "type": "Unknown",
                    "default": 4,
                    "description": "Server tolerated response latency factor. Servermust response within this factor times the satisfactory threshold (apdex_server_response_threshold) to be considered tolerated",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "4"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "4"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 1,
                    "max": 1000
                },
                "apdex_rtt_threshold": {
                    "type": "uint32",
                    "default": 250,
                    "description": "Satisfactory client to Avi Round Trip Time(RTT).",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "250"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "250"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 1,
                    "max": 2000
                },
                "apdex_rtt_tolerated_factor": {
                    "type": "Unknown",
                    "default": 4,
                    "description": "Tolerated client to Avi Round Trip Time(RTT) factor.  It is a multiple of apdex_rtt_tolerated_factor.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "4"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "4"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 1,
                    "max": 1000
                },
                "apdex_server_rtt_threshold": {
                    "type": "uint32",
                    "default": 125,
                    "description": "Satisfactory client to Avi Round Trip Time(RTT).",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "125"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "125"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 1,
                    "max": 2000
                },
                "apdex_server_rtt_tolerated_factor": {
                    "type": "Unknown",
                    "default": 4,
                    "description": "Tolerated client to Avi Round Trip Time(RTT) factor.  It is a multiple of apdex_rtt_tolerated_factor.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "4"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "4"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 1,
                    "max": 1000
                },
                "apdex_rum_threshold": {
                    "type": "uint32",
                    "default": 5000,
                    "description": "If a client is able to load a page in less than the Satisfactory Latency Threshold, the PageLoad is considered Satisfied.  It is considered tolerated if it is greater than Satisfied but less than the Tolerated Latency multiplied by Satisifed Latency. Greater than this number and the client's request is considered Frustrated.  A PageLoad includes the time for DNS lookup, download of all HTTP objects, and page render time.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "5000"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "5000"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 1,
                    "max": 30000
                },
                "apdex_rum_tolerated_factor": {
                    "type": "Unknown",
                    "default": 4,
                    "description": "Virtual service threshold factor for tolerated Page Load Time (PLT) as multiple of apdex_rum_threshold.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "4"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "4"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 1,
                    "max": 1000
                },
                "conn_lossy_total_rexmt_threshold": {
                    "type": "uint32",
                    "default": 50,
                    "description": "A connection between client and Avi is considered lossy when more than this percentage of packets are retransmitted.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "50"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "50"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 1,
                    "max": 100
                },
                "conn_lossy_timeo_rexmt_threshold": {
                    "type": "uint32",
                    "default": 20,
                    "description": "A connection between client and Avi is considered lossy when more than this percentage of packets are retransmitted due to timeout.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "20"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "20"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 1,
                    "max": 100
                },
                "conn_lossy_ooo_threshold": {
                    "type": "uint32",
                    "default": 50,
                    "description": "A connection between client and Avi is considered lossy when more than this percentage of out of order packets are received.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "50"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "50"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 1,
                    "max": 100
                },
                "conn_lossy_zero_win_size_event_threshold": {
                    "type": "uint32",
                    "default": 2,
                    "description": "A client connection is considered lossy when percentage of times a packet could not be trasmitted due to TCP zero window is above this threshold.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "2"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "2"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 0,
                    "max": 100
                },
                "conn_server_lossy_total_rexmt_threshold": {
                    "type": "uint32",
                    "default": 50,
                    "description": "A connection between Avi and server is considered lossy when more than this percentage of packets are retransmitted.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "50"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "50"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 1,
                    "max": 100
                },
                "conn_server_lossy_timeo_rexmt_threshold": {
                    "type": "uint32",
                    "default": 20,
                    "description": "A connection between Avi and server is considered lossy when more than this percentage of packets are retransmitted due to timeout.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "20"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "20"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 1,
                    "max": 100
                },
                "conn_server_lossy_ooo_threshold": {
                    "type": "uint32",
                    "default": 50,
                    "description": "A connection between Avi and server is considered lossy when more than this percentage of out of order packets are received.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "50"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "50"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 1,
                    "max": 100
                },
                "conn_server_lossy_zero_win_size_event_threshold": {
                    "type": "uint32",
                    "default": 2,
                    "description": "A server connection is considered lossy when percentage of times a packet could not be trasmitted due to TCP zero window is above this threshold.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "2"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "2"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 0,
                    "max": 100
                },
                "exclude_client_close_before_request_as_error": {
                    "type": "bool",
                    "default": false,
                    "description": "Exclude client closed connection before an HTTP request could be completed from being classified as an error.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "exclude_tcp_reset_as_error": {
                    "type": "bool",
                    "default": false,
                    "description": "Exclude TCP resets by client from the list of potential errors.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "exclude_server_tcp_reset_as_error": {
                    "type": "bool",
                    "default": false,
                    "description": "Exclude server TCP reset from errors.  It is common for applications like MS Exchange.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "exclude_persistence_change_as_error": {
                    "type": "bool",
                    "default": false,
                    "description": "Exclude persistence server changed while load balancing' from the list of errors.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "exclude_syn_retransmit_as_error": {
                    "type": "bool",
                    "default": false,
                    "description": "Exclude 'server unanswered syns' from the list of errors.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "exclude_invalid_dns_query_as_error": {
                    "type": "bool",
                    "default": false,
                    "description": "Exclude invalid dns queries from the list of errors.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "exclude_invalid_dns_domain_as_error": {
                    "type": "bool",
                    "default": false,
                    "description": "Exclude dns queries to domains outside the domains configured in the DNS application profile from the list of errors.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "exclude_no_dns_record_as_error": {
                    "type": "bool",
                    "default": false,
                    "description": "Exclude queries to domains that did not have configured services/records from the list of errors.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "exclude_unsupported_dns_query_as_error": {
                    "type": "bool",
                    "default": false,
                    "description": "Exclude unsupported dns queries from the list of errors.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "hs_performance_boost": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Adds free performance score credits to health score. It can be used for compensating health score for known slow applications.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "0"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "0"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 0,
                    "max": 100
                },
                "hs_max_anomaly_penalty": {
                    "type": "uint32",
                    "default": 10,
                    "description": "Maximum penalty that may be deducted from health score for anomalies.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "10"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "10"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 0,
                    "max": 100
                },
                "hs_max_resources_penalty": {
                    "type": "uint32",
                    "default": 25,
                    "description": "Maximum penalty that may be deducted from health score for high resource utilization.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "25"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "25"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 0,
                    "max": 100
                },
                "hs_max_security_penalty": {
                    "type": "uint32",
                    "default": 100,
                    "description": "Maximum penalty that may be deducted from health score based on security assessment.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "100"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "100"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 0,
                    "max": 100
                },
                "hs_security_nonpfs_penalty": {
                    "type": "Unknown",
                    "default": 1,
                    "description": "Penalty for allowing non-PFS handshakes.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "1.0"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "1.0"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 0,
                    "max": 5
                },
                "hs_security_weak_signature_algo_penalty": {
                    "type": "Unknown",
                    "default": 1,
                    "description": "Penalty for allowing weak signature algorithm(s).",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "1.0"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "1.0"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 0,
                    "max": 5
                },
                "hs_security_ssl30_score": {
                    "type": "Unknown",
                    "default": 3.5,
                    "description": "Score assigned when supporting SSL3.0 encryption protocol",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "3.5"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "3.5"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 0,
                    "max": 5
                },
                "hs_security_tls10_score": {
                    "type": "Unknown",
                    "default": 5,
                    "description": "Score assigned when supporting TLS1.0 encryption protocol",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "5.0"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "5.0"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 0,
                    "max": 5
                },
                "hs_security_tls11_score": {
                    "type": "Unknown",
                    "default": 5,
                    "description": "Score assigned when supporting TLS1.1 encryption protocol",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "5.0"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "5.0"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 0,
                    "max": 5
                },
                "hs_security_tls12_score": {
                    "type": "Unknown",
                    "default": 5,
                    "description": "Score assigned when supporting TLS1.2 encryption protocol",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "5.0"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "5.0"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 0,
                    "max": 5
                },
                "hs_event_throttle_window": {
                    "type": "uint32",
                    "default": 1209600,
                    "description": "Time window (in secs) within which only unique health change events should occur",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "1209600"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "1209600"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "hs_min_dos_rate": {
                    "type": "uint32",
                    "default": 1000,
                    "description": "DoS connection rate below which the DoS security assessment will not kick in.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "1000"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "1000"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "hs_security_certscore_expired": {
                    "type": "Unknown",
                    "default": 0,
                    "description": "Score assigned when the certificate has expired",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "0.0"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "0.0"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 0,
                    "max": 5
                },
                "hs_security_certscore_le07d": {
                    "type": "Unknown",
                    "default": 2,
                    "description": "Score assigned when the certificate expires in less than or equal to 7 days",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "2.0"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "2.0"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 0,
                    "max": 5
                },
                "hs_security_certscore_le30d": {
                    "type": "Unknown",
                    "default": 4,
                    "description": "Score assigned when the certificate expires in less than or equal to 30 days",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "4.0"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "4.0"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 0,
                    "max": 5
                },
                "hs_security_certscore_gt30d": {
                    "type": "Unknown",
                    "default": 5,
                    "description": "Score assigned when the certificate expires in more than 30 days",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "5.0"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "5.0"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 0,
                    "max": 5
                },
                "hs_security_cipherscore_eq000b": {
                    "type": "Unknown",
                    "default": 0,
                    "description": "Score assigned when the minimum cipher strength is 0 bits",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "0.0"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "0.0"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 0,
                    "max": 5
                },
                "hs_security_cipherscore_lt128b": {
                    "type": "Unknown",
                    "default": 3.5,
                    "description": "Score assigned when the minimum cipher strength is less than 128 bits",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "3.5"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "3.5"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 0,
                    "max": 5
                },
                "hs_security_cipherscore_ge128b": {
                    "type": "Unknown",
                    "default": 5,
                    "description": "Score assigned when the minimum cipher strength is greater than equal to 128 bits",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "5.0"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "5.0"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 0,
                    "max": 5
                },
                "hs_security_selfsignedcert_penalty": {
                    "type": "Unknown",
                    "default": 1,
                    "description": "Deprecated",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "1.0"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "1.0"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 0,
                    "max": 5
                },
                "hs_security_encalgo_score_rc4": {
                    "type": "Unknown",
                    "default": 2.5,
                    "description": "Score assigned when RC4 algorithm is used for encryption.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "2.5"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "2.5"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 0,
                    "max": 5
                },
                "hs_security_encalgo_score_none": {
                    "type": "Unknown",
                    "default": 0,
                    "description": "Score assigned when no algorithm is used for encryption.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "0.0"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "0.0"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 0,
                    "max": 5
                },
                "hs_security_chain_invalidity_penalty": {
                    "type": "Unknown",
                    "default": 1,
                    "description": "Penalty for allowing certificates with invalid chain.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "1.0"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "1.0"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 0,
                    "max": 5
                },
                "hs_security_hsts_penalty": {
                    "type": "Unknown",
                    "default": 1,
                    "description": "Penalty for not enabling HSTS.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "1.0"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "1.0"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 0,
                    "max": 5
                },
                "hs_pscore_traffic_threshold_l4_client": {
                    "type": "Unknown",
                    "default": 10,
                    "description": "Threshold number of connections in 5min, below which apdexr, apdexc, rum_apdex, and other network quality metrics are not computed.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "10"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "10"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "hs_pscore_traffic_threshold_l4_server": {
                    "type": "Unknown",
                    "default": 10,
                    "description": "Threshold number of connections in 5min, below which apdexr, apdexc, rum_apdex, and other network quality metrics are not computed.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "10"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "10"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "exclude_gs_down_as_error": {
                    "type": "bool",
                    "default": false,
                    "description": "Exclude queries to GSLB services that are operationally down from the list of errors.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "exclude_no_valid_gs_member_as_error": {
                    "type": "bool",
                    "default": false,
                    "description": "Exclude queries to GSLB services that have no available members from the list of errors.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "client_log_config": {
                    "type": "message",
                    "messageType": "ClientLogConfiguration",
                    "description": "Configure which logs are sent to the Avi Controller from SEs and how they are processed."
                },
                "client_log_streaming_config": {
                    "type": "message",
                    "messageType": "ClientLogStreamingConfig",
                    "description": "Configure to stream logs to an external server.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "exclude_http_error_codes": {
                    "type": "int32",
                    "repeated": true,
                    "description": "List of HTTP status codes to be excluded from being classified as an error.  Error connections or responses impacts health score, are included as significant logs, and may be classified as part of a DoS attack.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "ranges": {
                    "type": "message",
                    "messageType": "HTTPStatusRange",
                    "repeated": true,
                    "description": "List of HTTP status code ranges to be excluded from being classified as an error.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "resp_code_block": {
                    "type": "enum",
                    "enumType": "AnalyticsProfileRespCodeBlock",
                    "repeated": true,
                    "description": "Block of HTTP response codes to be excluded from being classified as an error.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "exclude_server_dns_error_as_error": {
                    "type": "bool",
                    "default": false,
                    "description": "Exclude server dns error response from the list of errors.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "exclude_dns_policy_drop_as_significant": {
                    "type": "bool",
                    "default": false,
                    "description": "Exclude dns policy drops from the list of errors.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "ondemand_metrics_idle_timeout": {
                    "type": "uint32",
                    "default": 1800,
                    "description": "This flag sets the time duration of no live data traffic after which Virtual Service metrics processing is suspended. It is applicable only when enable_ondemand_metrics is set to false."
                },
                "sensitive_log_profile": {
                    "type": "message",
                    "messageType": "SensitiveLogProfile",
                    "description": "Rules applied to the HTTP application log for filtering sensitive information.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "sip_log_depth": {
                    "type": "uint32",
                    "default": 20,
                    "description": "Maximum number of SIP messages added in logs for a SIP transaction. By default, this value is 20.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "20"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "20"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 1,
                    "max": 1000
                },
                "exclude_sip_error_codes": {
                    "type": "uint32",
                    "repeated": true,
                    "description": "List of SIP status codes to be excluded from being classified as an error.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "healthscore_max_server_limit": {
                    "type": "uint32",
                    "default": 20,
                    "description": "Skips health score computation of pool servers when number of servers in a pool is more than this setting.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "0",
                            "default_value": 0
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "0",
                            "default_value": 0
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 0,
                    "max": 5000,
                    "specialValues": {
                        "0": "server health score is deactivated"
                    }
                },
                "enable_advanced_analytics": {
                    "type": "bool",
                    "default": true,
                    "description": "Enables Advanced Analytics features like Anomaly detection. If set to false, anomaly computation (and associated rules/events) for VS, Pool and Server metrics will be deactivated. However, setting it to false reduces cpu and memory requirements for Analytics subsystem.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false",
                            "default_value": false
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false",
                            "default_value": false
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "hs_security_tls13_score": {
                    "type": "Unknown",
                    "default": 5,
                    "description": "Score assigned when supporting TLS1.3 encryption protocol.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "5.0"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "5.0"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 0,
                    "max": 5
                },
                "exclude_revoked_ocsp_responses_as_error": {
                    "type": "bool",
                    "default": true,
                    "description": "Exclude the Revoked OCSP certificate status responses from the list of errors.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "true"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "true"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "exclude_stale_ocsp_responses_as_error": {
                    "type": "bool",
                    "default": true,
                    "description": "Exclude the Stale OCSP certificate status responses from the list of errors.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "true"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "true"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "exclude_issuer_revoked_ocsp_responses_as_error": {
                    "type": "bool",
                    "default": true,
                    "description": "Exclude the Issuer-Revoked OCSP Responses from the list of errors.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "true"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "true"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "exclude_unavailable_ocsp_responses_as_error": {
                    "type": "bool",
                    "default": true,
                    "description": "Exclude the unavailable OCSP Responses from the list of errors.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "true"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "true"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "hs_security_ocsp_revoked_score": {
                    "type": "Unknown",
                    "default": 0,
                    "description": "Score assigned when OCSP Certificate Status is set to Revoked or Issuer Revoked.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "0.0"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "0.0"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 0,
                    "max": 5
                },
                "enable_adaptive_config": {
                    "type": "bool",
                    "default": true,
                    "description": "Enable adaptive configuration for optimizing resource usage."
                },
                "enable_vs_analytics": {
                    "type": "bool",
                    "default": true,
                    "description": "Enable VirtualService (frontend) Analytics. This flag enables metrics and healthscore for Virtualservice."
                },
                "enable_server_analytics": {
                    "type": "bool",
                    "default": true,
                    "description": "Enables analytics on backend servers. This may be desired in container environment when there are large number of ephemeral servers. Additionally, no healthscore of servers is computed when server analytics is enabled."
                },
                "enable_se_analytics": {
                    "type": "bool",
                    "default": true,
                    "description": "Enable node (service engine) level analytics forvs metrics"
                },
                "enable_ondemand_metrics": {
                    "type": "bool",
                    "default": true,
                    "description": "Virtual Service (VS) metrics are processed only when there is live data traffic on the VS. In case, VS is idle for a period of time as specified by ondemand_metrics_idle_timeout then metrics processing is suspended for that VS."
                },
                "markers": {
                    "type": "message",
                    "messageType": "RoleFilterMatchLabel",
                    "repeated": true,
                    "description": "List of labels to be used for granular RBAC.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                },
                "latency_audit_props": {
                    "type": "message",
                    "messageType": "LatencyAuditProperties",
                    "description": "Deprecated in 22.1.1"
                },
                "time_tracker_props": {
                    "type": "message",
                    "messageType": "TimeTrackerProperties",
                    "description": "Time Tracker Properties for connection establishment audit."
                },
                "exclude_conn_drop_client_small_window_as_error": {
                    "type": "bool",
                    "default": true,
                    "description": "Exclude Connection dropped by VS due to client advertises a very small window size from the errors.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "true"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "true"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                }
            }
        },
        "TimeTrackerProperties": {
            "fields": {
                "fe_conn_est_audit_mode": {
                    "type": "enum",
                    "enumType": "TTAuditMode",
                    "description": "Audit TCP connection establishment time on client-side."
                },
                "fe_conn_est_threshold": {
                    "type": "uint32",
                    "description": "Maximum threshold for TCP connection establishment time on client-side."
                },
                "be_conn_est_audit_mode": {
                    "type": "enum",
                    "enumType": "TTAuditMode",
                    "description": "Audit TCP connection establishment time on server-side."
                },
                "be_conn_est_threshold": {
                    "type": "uint32",
                    "description": "Maximum threshold for TCP connection establishment time on server-side."
                },
                "ingress_sig_log": {
                    "type": "bool",
                    "description": "Add significance if ingress latency from dispatcher to proxy is breached on any flow."
                }
            }
        },
        "LatencyAuditProperties": {
            "fields": {
                "latency_audit_mode": {
                    "type": "enum",
                    "enumType": "LatencyAuditMode",
                    "description": "Deprecated in 22.1.1"
                },
                "latency_threshold": {
                    "type": "uint32",
                    "description": "Deprecated in 22.1.1"
                },
                "conn_est_audit_mode": {
                    "type": "enum",
                    "enumType": "LatencyAuditMode",
                    "description": "Deprecated in 22.1.1"
                },
                "conn_est_threshold": {
                    "type": "uint32",
                    "description": "Deprecated in 22.1.1"
                }
            }
        },
        "RoleFilterMatchLabel": {
            "fields": {
                "key": {
                    "type": "string",
                    "description": "Key for filter match.",
                    "required": true
                },
                "values": {
                    "type": "string",
                    "repeated": true,
                    "description": "Values for filter match. Multiple values will be evaluated as OR. Example: key = value1 OR key = value2. Behavior for match is key = * if this field is empty."
                }
            },
            "repeatedKey": "key"
        },
        "SensitiveLogProfile": {
            "fields": {
                "header_field_rules": {
                    "type": "message",
                    "messageType": "SensitiveFieldRule",
                    "repeated": true,
                    "description": "Match sensitive header fields in HTTP application log."
                },
                "waf_field_rules": {
                    "type": "message",
                    "messageType": "SensitiveFieldRule",
                    "repeated": true,
                    "description": "Match sensitive WAF log fields in HTTP application log."
                },
                "uri_query_field_rules": {
                    "type": "message",
                    "messageType": "SensitiveFieldRule",
                    "repeated": true,
                    "description": "Match sensitive URI query params in HTTP application log. Query params from the URI are extracted and checked for matching sensitive parameter names. A successful match will mask the parameter values in accordance with this rule action."
                }
            }
        },
        "SensitiveFieldRule": {
            "fields": {
                "name": {
                    "type": "string",
                    "description": "Name of the rule"
                },
                "index": {
                    "type": "int32",
                    "description": "Index of the rule"
                },
                "enabled": {
                    "type": "bool",
                    "default": false,
                    "description": "Enable rule to match the sensitive fields."
                },
                "match": {
                    "type": "message",
                    "messageType": "StringMatch",
                    "description": "Criterion to use for matching in the Log.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "action": {
                    "type": "enum",
                    "enumType": "LogAction",
                    "default": "LOG_FIELD_REMOVE",
                    "description": "Action for the matched log field, for instance the matched field can be removed or masked off."
                }
            },
            "repeatedKey": "name"
        },
        "StringMatch": {
            "fields": {
                "match_criteria": {
                    "type": "enum",
                    "enumType": "StringOperation",
                    "required": true,
                    "description": "Criterion to use for string matching the HTTP request",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "BEGINS_WITH,DOES_NOT_BEGIN_WITH,CONTAINS,DOES_NOT_CONTAIN,ENDS_WITH,DOES_NOT_END_WITH,EQUALS,DOES_NOT_EQUAL"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "BEGINS_WITH,DOES_NOT_BEGIN_WITH,CONTAINS,DOES_NOT_CONTAIN,ENDS_WITH,DOES_NOT_END_WITH,EQUALS,DOES_NOT_EQUAL"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "match_str": {
                    "type": "string",
                    "repeated": true,
                    "description": "String value(s)"
                },
                "string_group_uuids": {
                    "type": "string",
                    "repeated": true,
                    "description": "UUID of the string group(s)"
                }
            }
        },
        "HTTPStatusRange": {
            "fields": {
                "begin": {
                    "type": "int32",
                    "required": true,
                    "description": "Starting HTTP response status code"
                },
                "end": {
                    "type": "int32",
                    "required": true,
                    "description": "Ending HTTP response status code"
                }
            }
        },
        "ClientLogStreamingConfig": {
            "fields": {
                "external_server": {
                    "type": "string",
                    "description": "IP address or hostnames (FQDNs) of destination servers. If an FQDN is provided, this should be resolvable on Avi Service Engines. Multiple servers are supported by furnishing a comma-separated list of IP addresses or host names, for example, 11.11.11.11,23.12.12.4,2001:123::1. Optionally, a separate port can be specified for each external server in the list, for example,11.11.11.11:234,12.12.12.12:343,[2001:123::1]:234.",
                    "required": true
                },
                "external_server_port": {
                    "type": "uint32",
                    "default": 514,
                    "description": "The service port to use for the external servers. If multiple external servers have been specified, the single port number specified here will apply to all those servers for which an explicit port number has not been specified in the external server list."
                },
                "protocol": {
                    "type": "enum",
                    "enumType": "ClientLogStreamingProtocol",
                    "default": "LOG_STREAMING_PROTOCOL_UDP",
                    "description": "Protocol to use for streaming logs."
                },
                "log_types_to_send": {
                    "type": "enum",
                    "enumType": "LogsType",
                    "default": "LOGS_ALL",
                    "description": "Type of logs to stream to the external server. Default is LOGS_ALL, i.e., send all logs."
                },
                "max_logs_per_second": {
                    "type": "uint32",
                    "default": 100,
                    "description": "This setting limits the number of logs streamed per VS from each SE to the external server. By default, 100 logs per second are streamed. Set this to zero(0) to not enforce any limit. Note that the SE group's throttle value takes precedence over this setting."
                },
                "syslog_config": {
                    "type": "message",
                    "messageType": "StreamingSyslogConfig",
                    "description": "Syslog configuration if a Syslog-based protocol is specified for streaming."
                },
                "format_config": {
                    "type": "message",
                    "messageType": "ClientLogStreamingFormat",
                    "description": "Configuration to specify the format of streamed logs. By default, each log is encoded in JSON format."
                },
                "marker_keys": {
                    "type": "message",
                    "messageType": "RoleFilterMatchLabel",
                    "repeated": true,
                    "description": "One or more keys which should exist in VirtualService RBAC markers. Key along with values will be streamed out in log. If key is not found in RBAC markers, it will not be streamed."
                }
            }
        },
        "StreamingSyslogConfig": {
            "fields": {
                "facility": {
                    "type": "uint32",
                    "default": 16,
                    "description": "Facility value, as defined in RFC5424, must be between 0 and 23 inclusive.",
                    "min": 0,
                    "max": 23
                },
                "significant_log_severity": {
                    "type": "uint32",
                    "default": 4,
                    "description": "Severity code, as defined in RFC5424, for significant logs. This must be between 0 and 7 inclusive.",
                    "min": 0,
                    "max": 7
                },
                "filtered_log_severity": {
                    "type": "uint32",
                    "default": 5,
                    "description": "Severity code, as defined in RFC5424, for filtered logs. This must be between 0 and 7 inclusive.",
                    "min": 0,
                    "max": 7
                },
                "non_significant_log_severity": {
                    "type": "uint32",
                    "default": 6,
                    "description": "Severity code, as defined in RFC5424, for non-significant logs. This must be between 0 and 7 inclusive.",
                    "min": 0,
                    "max": 7
                },
                "hostname": {
                    "type": "string",
                    "default": "AviVantage",
                    "description": "String to use as the hostname in the syslog messages. This string can contain only printable ASCII characters (hex 21 to hex 7E; no space allowed).",
                    "maxStringLength": 255
                },
                "proc_id": {
                    "type": "string",
                    "default": "NILVALUE",
                    "description": "As per RFC, if there is a change in value indicated there has been discontinuity in syslog reporting.",
                    "maxStringLength": 255
                },
                "msg_id": {
                    "type": "string",
                    "default": "NILVALUE",
                    "description": "As per RFC, Constant string to identify the type of message.",
                    "maxStringLength": 255
                }
            }
        },
        "ClientLogConfiguration": {
            "fields": {
                "enable_significant_log_collection": {
                    "type": "bool",
                    "default": true,
                    "description": "Enable significant log collection. By default, this flag is enabled, which means that Avi SEs collect significant logs and forward them to Controller for further processing. For example, these logs correspond to error conditions such as when the response code for a request is 500. Users can deactivate this flag to turn off default significant log collection.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false",
                            "default_value": false
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false",
                            "default_value": false
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "significant_log_processing": {
                    "type": "enum",
                    "enumType": "LogsProcessingType",
                    "default": "LOGS_PROCESSING_SYNC_AND_INDEX_ON_DEMAND",
                    "description": "Significant logs are processed by the Logs Analytics system according to this setting."
                },
                "filtered_log_processing": {
                    "type": "enum",
                    "enumType": "LogsProcessingType",
                    "default": "LOGS_PROCESSING_SYNC_AND_INDEX_ON_DEMAND",
                    "description": "Filtered logs are logs that match any client log filters or rules with logging enabled. Such logs are processed by the Logs Analytics system according to this setting."
                },
                "non_significant_log_processing": {
                    "type": "enum",
                    "enumType": "LogsProcessingType",
                    "default": "LOGS_PROCESSING_SYNC_AND_INDEX_ON_DEMAND",
                    "description": "Logs that are neither significant nor filtered, are processed by the Logs Analytics system according to this setting."
                }
            }
        },
        "ApplicationPersistenceProfile": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "required": true,
                    "description": "UUID of the persistence profile."
                },
                "name": {
                    "type": "string",
                    "required": true,
                    "description": "A user-friendly name for the persistence profile.",
                    "maxStringLength": 256
                },
                "server_hm_down_recovery": {
                    "type": "enum",
                    "enumType": "PersistentServerHMDownRecovery",
                    "default": "HM_DOWN_PICK_NEW_SERVER",
                    "description": "Specifies behavior when a persistent server has been marked down by a health monitor.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "HM_DOWN_PICK_NEW_SERVER"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "HM_DOWN_PICK_NEW_SERVER"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "persistence_type": {
                    "type": "enum",
                    "enumType": "PersistenceProfileType",
                    "default": "PERSISTENCE_TYPE_CLIENT_IP_ADDRESS",
                    "required": true,
                    "description": "Method used to persist clients to the same server for a duration of time or a session.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "PERSISTENCE_TYPE_CLIENT_IP_ADDRESS,PERSISTENCE_TYPE_HTTP_COOKIE"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "PERSISTENCE_TYPE_CLIENT_IP_ADDRESS,PERSISTENCE_TYPE_HTTP_COOKIE"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "immutable": true
                },
                "ip_persistence_profile": {
                    "type": "message",
                    "messageType": "IPPersistenceProfile",
                    "description": "Specifies the Client IP Persistence profile parameters."
                },
                "hdr_persistence_profile": {
                    "type": "message",
                    "messageType": "HdrPersistenceProfile",
                    "description": "Specifies the custom HTTP Header Persistence profile parameters.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "app_cookie_persistence_profile": {
                    "type": "message",
                    "messageType": "AppCookiePersistenceProfile",
                    "description": "Specifies the Application Cookie Persistence profile parameters."
                },
                "http_cookie_persistence_profile": {
                    "type": "message",
                    "messageType": "HttpCookiePersistenceProfile",
                    "description": "Specifies the HTTP Cookie Persistence profile parameters."
                },
                "markers": {
                    "type": "message",
                    "messageType": "RoleFilterMatchLabel",
                    "repeated": true,
                    "description": "List of labels to be used for granular RBAC.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "is_federated": {
                    "type": "bool",
                    "default": false,
                    "description": "This field describes the object's replication scope. If the field is set to false, then the object is visible within the controller-cluster and its associated service-engines.  If the field is set to true, then the object is replicated across the federation.  ",
                    "immutable": true
                },
                "description": {
                    "type": "string"
                },
                "tenant_uuid": {
                    "type": "string"
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                },
                "diameter_app_persistence_profile": {
                    "type": "message",
                    "messageType": "DiameterAVPPersistenceProfile",
                    "description": "Specifies the Diameter Persistence profile parameters."
                },
                "persistence_update_interval": {
                    "type": "uint32",
                    "description": "Interval in minutes at which refreshed persistence entries are synced to peer SEs. If not set, it willsync at an interval of timeout/2",
                    "min": 1,
                    "max": 30
                }
            }
        },
        "DiameterAVPPersistenceProfile": {
            "fields": {
                "timeout": {
                    "type": "uint32",
                    "description": "The maximum lifetime of diameter cookie. No value or 'zero' indicates no timeout."
                },
                "avp_key_type": {
                    "type": "enum",
                    "enumType": "AvpKey",
                    "default": "SESSION_ID",
                    "description": "AvpKey type."
                }
            }
        },
        "HttpCookiePersistenceProfile": {
            "fields": {
                "encryption_key": {
                    "type": "string",
                    "description": "Key name to use for cookie encryption",
                    "maxStringLength": 1024
                },
                "cookie_name": {
                    "type": "string",
                    "description": "HTTP cookie name for cookie persistence",
                    "maxStringLength": 128
                },
                "key": {
                    "type": "message",
                    "messageType": "HttpCookiePersistenceKey",
                    "repeated": true
                },
                "timeout": {
                    "type": "int32",
                    "description": "The maximum lifetime of any session cookie. No value or 'zero' indicates no timeout.",
                    "min": 1,
                    "max": 14400,
                    "specialValues": {
                        "0": "No Timeout"
                    }
                },
                "always_send_cookie": {
                    "type": "bool",
                    "default": false,
                    "description": "If no persistence cookie was received from the client, always send it."
                },
                "http_only": {
                    "type": "bool",
                    "default": false,
                    "description": "Sets the HttpOnly attribute in the cookie. Setting this helps to prevent the client side scripts from accessing this cookie, if supported by browser."
                },
                "is_persistent_cookie": {
                    "type": "bool",
                    "default": false,
                    "description": "When True, the cookie used is a persistent cookie, i.e. the cookie shouldn't be used at the end of the timeout. By default, it is set to false, making the cookie a session cookie, which allows clients to use it even after the timeout, if the session is still open."
                }
            }
        },
        "AppCookiePersistenceProfile": {
            "fields": {
                "prst_hdr_name": {
                    "type": "string",
                    "required": true,
                    "description": "Header or cookie name for application cookie persistence",
                    "maxStringLength": 128
                },
                "timeout": {
                    "type": "int32",
                    "default": 20,
                    "description": "The length of time after a client's connections have closed before expiring the client's persistence to a server.",
                    "min": 1,
                    "max": 720
                },
                "encryption_key": {
                    "type": "string",
                    "description": "Key to use for cookie encryption",
                    "maxStringLength": 1024
                }
            }
        },
        "HdrPersistenceProfile": {
            "fields": {
                "prst_hdr_name": {
                    "type": "string",
                    "description": "Header name for custom header persistence",
                    "maxStringLength": 128
                }
            }
        },
        "IPPersistenceProfile": {
            "fields": {
                "ip_persistent_timeout": {
                    "type": "int32",
                    "default": 5,
                    "description": "The length of time after a client's connections have closed before expiring the client's persistence to a server.",
                    "min": 1,
                    "max": 720
                },
                "ip_mask": {
                    "type": "uint32",
                    "description": "Mask to be applied on client IP. This may be used to persist clients from a subnet to the same server. When set to 0, all requests are sent to the same server.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 0,
                    "max": 128
                }
            }
        },
        "ApplicationProfile": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "required": true,
                    "description": "UUID of the application profile."
                },
                "name": {
                    "type": "string",
                    "required": true,
                    "description": "The name of the application profile.",
                    "maxStringLength": 256
                },
                "type": {
                    "type": "enum",
                    "enumType": "ApplicationProfileType",
                    "required": true,
                    "description": "Specifies which application layer proxy is enabled for the virtual service.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "APPLICATION_PROFILE_TYPE_L4"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "APPLICATION_PROFILE_TYPE_L4,APPLICATION_PROFILE_TYPE_HTTP"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "immutable": true
                },
                "http_profile": {
                    "type": "message",
                    "messageType": "HTTPApplicationProfile",
                    "description": "Specifies the HTTP application proxy profile parameters.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "dos_rl_profile": {
                    "type": "message",
                    "messageType": "DosRateLimitProfile",
                    "description": "Specifies various security related controls for virtual service.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "tcp_app_profile": {
                    "type": "message",
                    "messageType": "TCPApplicationProfile",
                    "description": "Specifies the TCP application proxy profile parameters."
                },
                "dns_service_profile": {
                    "type": "message",
                    "messageType": "DnsServiceApplicationProfile",
                    "description": "Specifies various DNS service related controls for virtual service.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "preserve_client_ip": {
                    "type": "bool",
                    "default": false,
                    "description": "Specifies if client IP needs to be preserved for backend connection. Not compatible with Connection Multiplexing."
                },
                "preserve_client_port": {
                    "type": "bool",
                    "description": "Specifies if we need to preserve client port while preserving client IP for backend connections."
                },
                "sip_service_profile": {
                    "type": "message",
                    "messageType": "SipServiceApplicationProfile",
                    "description": "Specifies various SIP service related controls for virtual service.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "cloud_config_cksum": {
                    "type": "string",
                    "description": "Checksum of application profiles. Internally set by cloud connector."
                },
                "created_by": {
                    "type": "string",
                    "description": "Name of the application profile creator."
                },
                "preserve_dest_ip_port": {
                    "type": "bool",
                    "default": false,
                    "description": "Specifies if destination IP and port needs to be preserved for backend connection.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "markers": {
                    "type": "message",
                    "messageType": "RoleFilterMatchLabel",
                    "repeated": true,
                    "description": "List of labels to be used for granular RBAC.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "l4_ssl_profile": {
                    "type": "message",
                    "messageType": "L4SSLApplicationProfile",
                    "description": "Specifies various L4 SSL service related controls for virtual service.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "diameter_service_profile": {
                    "type": "message",
                    "messageType": "DiameterServiceApplicationProfile",
                    "description": "Specifies various Diameter service related controls for virtual service.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "description": {
                    "type": "string"
                },
                "tenant_uuid": {
                    "type": "string",
                    "required": true
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                },
                "app_service_type": {
                    "type": "enum",
                    "enumType": "AppServiceType",
                    "description": "Specifies app service type for an application.",
                    "immutable": true
                }
            }
        },
        "DiameterServiceApplicationProfile": {
            "fields": {
                "host_ip_addr_rewrite": {
                    "type": "bool",
                    "default": false,
                    "description": "Rwrite Host-IP-Address AVP."
                },
                "req_timeout": {
                    "type": "uint32",
                    "default": 60,
                    "description": "Response waiting time for the request sent.",
                    "min": 1,
                    "max": 1800
                },
                "max_outstanding_req": {
                    "type": "uint32",
                    "default": 4096,
                    "description": "Max number of outstanding request waiting for response.",
                    "min": 1,
                    "max": 1048576
                },
                "client_origin_host": {
                    "type": "string",
                    "description": "Origin-Host AVP towards client.",
                    "maxStringLength": 255
                },
                "client_origin_realm": {
                    "type": "string",
                    "description": "Origin-Realm AVP towards client.",
                    "maxStringLength": 255
                },
                "server_origin_host": {
                    "type": "string",
                    "description": "Origin-Host AVP towards server.",
                    "maxStringLength": 255
                },
                "server_origin_realm": {
                    "type": "string",
                    "description": "Origin-Realm AVP towards server.",
                    "maxStringLength": 255
                }
            }
        },
        "L4SSLApplicationProfile": {
            "fields": {
                "ssl_stream_idle_timeout": {
                    "type": "uint32",
                    "default": 3600,
                    "description": "L4 stream idle connection timeout in seconds.",
                    "min": 60,
                    "max": 86400
                }
            }
        },
        "SipServiceApplicationProfile": {
            "fields": {
                "transaction_timeout": {
                    "type": "uint32",
                    "default": 32,
                    "description": "SIP transaction timeout in seconds.",
                    "min": 2,
                    "max": 512
                }
            }
        },
        "DnsServiceApplicationProfile": {
            "fields": {
                "num_dns_ip": {
                    "type": "uint32",
                    "default": 1,
                    "description": "Specifies the number of IP addresses returned by the DNS Service. Enter 0 to return all IP addresses",
                    "min": 1,
                    "max": 20,
                    "specialValues": {
                        "0": "Return all IP addresses"
                    }
                },
                "ttl": {
                    "type": "uint32",
                    "default": 30,
                    "description": "Specifies the TTL value (in seconds) for records served by DNS Service",
                    "min": 0,
                    "max": 86400
                },
                "error_response": {
                    "type": "enum",
                    "enumType": "DnsErrorResponseType",
                    "default": "DNS_ERROR_RESPONSE_NONE",
                    "description": "Drop or respond to client when the DNS service encounters an error processing a client query. By default, such a request is dropped without any response, or passed through to a passthrough pool, if configured. When set to respond, an appropriate response is sent to client, e.g. NXDOMAIN response for non-existent records, empty NOERROR response for unsupported queries, etc."
                },
                "domain_names": {
                    "type": "string",
                    "repeated": true,
                    "description": "Subdomain names serviced by this Virtual Service. These are configured as Ends-With semantics",
                    "maxRepeatedLength": 100
                },
                "edns": {
                    "type": "bool",
                    "default": true,
                    "description": "Enable DNS service to be aware of EDNS (Extension mechanism for DNS). EDNS extensions are parsed and shown in logs. For GSLB services, the EDNS client subnet option can be used to influence Load Balancing."
                },
                "edns_client_subnet_prefix_len": {
                    "type": "uint32",
                    "description": "Specifies the IP address prefix length to use in the EDNS client subnet (ECS) option. When the incoming request does not have any ECS option and the prefix length is specified, an ECS option is inserted in the request passed to upstream server. If the incoming request already has an ECS option, the prefix length (and correspondingly the address) in the ECS option is updated, with the minimum of the prefix length present in the incoming and the configured prefix length, before passing the request to upstream server.",
                    "min": 1,
                    "max": 32
                },
                "dns_over_tcp_enabled": {
                    "type": "bool",
                    "default": true,
                    "description": "Enable DNS query/response over TCP. This enables analytics for pass-through queries as well."
                },
                "aaaa_empty_response": {
                    "type": "bool",
                    "default": true,
                    "description": "Respond to AAAA queries with empty response when there are only IPV4 records"
                },
                "ecs_stripping_enabled": {
                    "type": "bool",
                    "default": true,
                    "description": "Enable stripping of EDNS client subnet (ecs) option towards client if DNS service inserts ecs option in the DNS query towards upstream servers."
                },
                "negative_caching_ttl": {
                    "type": "uint32",
                    "default": 30,
                    "description": "Specifies the TTL value (in seconds) for SOA (Start of Authority) (corresponding to a authoritative domain owned by this DNS Virtual Service) record's minimum TTL served by the DNS Virtual Service",
                    "min": 0,
                    "max": 86400
                },
                "name_server": {
                    "type": "string",
                    "description": "The <domain-name>  of the name server that was the original or primary source of data for this zone. This field is used in SOA records (mname) pertaining to all domain names specified as authoritative domain names. If not configured, domain name is used as name server in SOA response.",
                    "maxStringLength": 255
                },
                "admin_email": {
                    "type": "string",
                    "default": "hostmaster",
                    "description": "Email address of the administrator responsible for this zone . This field is used in SOA records (rname) pertaining to all domain names specified as authoritative domain names. If not configured, the default value 'hostmaster' is used in SOA responses.",
                    "maxStringLength": 255
                },
                "dns_zones": {
                    "type": "message",
                    "messageType": "DnsZone",
                    "repeated": true,
                    "description": "DNS zones hosted on this Virtual Service.",
                    "maxRepeatedLength": 100
                },
                "close_tcp_connection_post_response": {
                    "type": "bool",
                    "default": false,
                    "description": "If enabled, the Service Engine initiates closure of client TCP connections after the first DNS response, for pass-through/proxy cases. This behavior applies to all DNS request types other than AX-FR."
                },
                "client_dns_tcp_request_timeout": {
                    "type": "uint32",
                    "default": 10000,
                    "description": "The maximum time allowed for a client to transmit an entire DNS request over TCP. This helps mitigate various forms of SlowLoris attacks.",
                    "min": 10,
                    "max": 100000000
                }
            }
        },
        "DnsZone": {
            "fields": {
                "domain_name": {
                    "type": "string",
                    "description": "Domain name authoritatively serviced by this Virtual Service. Queries for FQDNs that are sub domains of this domain and do not have any DNS record in Avi are dropped or NXDomain response sent. For domains which are present, SOA parameters are sent in answer section of response if query type is SOA.",
                    "maxStringLength": 255,
                    "required": true
                },
                "name_server": {
                    "type": "string",
                    "description": "The primary name server for this zone. This field is used in SOA records as mname (RFC 1035). If not configured, it is inherited from the DNS service profile. If even that is not configured, the domain name is used instead.",
                    "maxStringLength": 255
                },
                "admin_email": {
                    "type": "string",
                    "description": "Email address of the administrator responsible for this zone. This field is used in SOA records as rname (RFC 1035). If not configured, it is inherited from the DNS service profile.",
                    "maxStringLength": 255
                }
            }
        },
        "TCPApplicationProfile": {
            "fields": {
                "proxy_protocol_enabled": {
                    "type": "bool",
                    "default": false,
                    "description": "Enable/Disable the usage of proxy protocol to convey client connection information to the back-end servers.  Valid only for L4 application profiles and TCP proxy.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "proxy_protocol_version": {
                    "type": "enum",
                    "enumType": "ProxyProtocolVersion",
                    "default": "PROXY_PROTOCOL_VERSION_1",
                    "description": "Version of proxy protocol to be used to convey client connection information to the back-end servers.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "PROXY_PROTOCOL_VERSION_1"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "PROXY_PROTOCOL_VERSION_1"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "ssl_client_certificate_mode": {
                    "type": "enum",
                    "enumType": "SSLClientCertificateMode",
                    "default": "SSL_CLIENT_CERTIFICATE_NONE",
                    "description": "Specifies whether the client side verification is set to none, request or require.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "SSL_CLIENT_CERTIFICATE_NONE"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "SSL_CLIENT_CERTIFICATE_NONE"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "pki_profile_uuid": {
                    "type": "string",
                    "description": "Select the PKI profile to be associated with the Virtual Service. This profile defines the Certificate Authority and Revocation List.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "ftp_profile": {
                    "type": "message",
                    "messageType": "FTPProfile",
                    "description": "FTP profile configuration."
                }
            }
        },
        "FTPProfile": {
            "fields": {
                "deactivate_active": {
                    "type": "bool",
                    "default": false,
                    "description": "Deactivate active FTP mode."
                },
                "deactivate_passive": {
                    "type": "bool",
                    "default": false,
                    "description": "Deactivate passive FTP mode."
                }
            }
        },
        "HTTPApplicationProfile": {
            "fields": {
                "connection_multiplexing_enabled": {
                    "type": "bool",
                    "default": true,
                    "description": "Allows HTTP requests, not just TCP connections, to be load balanced across servers.  Proxied TCP connections to servers may be reused by multiple clients to improve performance. Not compatible with Preserve Client IP."
                },
                "xff_enabled": {
                    "type": "bool",
                    "default": true,
                    "description": "The client's original IP address is inserted into an HTTP request header sent to the server.  Servers may use this address for logging or other purposes, rather than Avi's source NAT address used in the Avi to server IP connection."
                },
                "xff_alternate_name": {
                    "type": "string",
                    "default": "X-Forwarded-For",
                    "description": "Provide a custom name for the X-Forwarded-For header sent to the servers."
                },
                "xff_update": {
                    "type": "enum",
                    "enumType": "XFFUpdate",
                    "default": "REPLACE_XFF_HEADERS",
                    "description": "Configure how incoming X-Forwarded-For headers from the client are handled."
                },
                "hsts_enabled": {
                    "type": "bool",
                    "default": false,
                    "description": "Inserts HTTP Strict-Transport-Security header in the HTTPS response.  HSTS can help mitigate man-in-the-middle attacks by telling browsers that support HSTS that they should only access this site via HTTPS.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "hsts_max_age": {
                    "type": "uint64",
                    "default": 365,
                    "description": "Number of days for which the client should regard this virtual service as a known HSTS host.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "365"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "365"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 0,
                    "max": 10000
                },
                "hsts_subdomains_enabled": {
                    "type": "bool",
                    "default": true,
                    "description": "Insert the 'includeSubdomains' directive in the HTTP Strict-Transport-Security header. Adding the includeSubdomains directive signals the User-Agent that the HSTS Policy applies to this HSTS Host as well as any subdomains of the host's domain name.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false",
                            "default_value": false
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false",
                            "default_value": false
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "secure_cookie_enabled": {
                    "type": "bool",
                    "default": false,
                    "description": "Mark server cookies with the 'Secure' attribute.  Client browsers will not send a cookie marked as secure over an unencrypted connection.  If Avi is terminating SSL from clients and passing it as HTTP to the server, the server may return cookies without the secure flag set.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "httponly_enabled": {
                    "type": "bool",
                    "default": false,
                    "description": "Mark HTTP cookies as HTTPonly.  This helps mitigate cross site scripting attacks as browsers will not allow these cookies to be read by third parties, such as javascript.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "http_to_https": {
                    "type": "bool",
                    "default": false,
                    "description": "Client requests received via HTTP will be redirected to HTTPS.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "server_side_redirect_to_https": {
                    "type": "bool",
                    "default": false,
                    "description": "When terminating client SSL sessions at Avi, servers may incorrectly send redirect to clients as HTTP.  This option will rewrite the server's redirect responses for this virtual service from HTTP to HTTPS.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "x_forwarded_proto_enabled": {
                    "type": "bool",
                    "default": false,
                    "description": "Insert an X-Forwarded-Proto header in the request sent to the server.  When the client connects via SSL, Avi terminates the SSL, and then forwards the requests to the servers via HTTP, so the servers can determine the original protocol via this header.  In this example, the value will be 'https'.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "compression_profile": {
                    "type": "message",
                    "messageType": "CompressionProfile",
                    "description": "HTTP Compression settings to use with this HTTP Profile.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "post_accept_timeout": {
                    "type": "int32",
                    "default": 30000,
                    "description": "The max allowed length of time between a client establishing a TCP connection and Avi receives the first byte of the client's HTTP request.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "30000"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "30000"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 10,
                    "max": 100000000
                },
                "client_header_timeout": {
                    "type": "int32",
                    "default": 10000,
                    "description": "The maximum length of time allowed for a client to transmit an entire request header. This helps mitigate various forms of SlowLoris attacks.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "10000"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "10000"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 10,
                    "max": 100000000
                },
                "client_body_timeout": {
                    "type": "int32",
                    "default": 30000,
                    "description": "The maximum length of time allowed between consecutive read operations for a client request body. The value '0' specifies no timeout. This setting generally impacts the length of time allowed for a client to send a POST.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "30000"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 0,
                    "max": 100000000
                },
                "keepalive_timeout": {
                    "type": "int32",
                    "default": 30000,
                    "description": "The max idle time allowed between HTTP requests over a Keep-alive connection.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "30000"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 10,
                    "max": 100000000
                },
                "client_max_header_size": {
                    "type": "int32",
                    "default": 12,
                    "description": "Maximum size in Kbytes of a single HTTP header in the client request.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "12"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 1,
                    "max": 64
                },
                "client_max_request_size": {
                    "type": "int32",
                    "default": 48,
                    "description": "Maximum size in Kbytes of all the client HTTP request headers.This value can be overriden by client_max_header_size if that is larger.",
                    "min": 1,
                    "max": 256
                },
                "client_max_body_size": {
                    "type": "Unknown",
                    "default": 0,
                    "description": "Maximum size for the client request body.  This limits the size of the client data that can be uploaded/posted as part of a single HTTP Request.  Default 0 => Unlimited."
                },
                "cache_config": {
                    "type": "message",
                    "messageType": "HttpCacheConfig",
                    "description": "HTTP Caching config to use with this HTTP Profile.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "max_rps_unknown_uri": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Maximum unknown URIs per second.",
                    "min": 10,
                    "max": 1000,
                    "specialValues": {
                        "0": "unlimited"
                    }
                },
                "max_rps_cip": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Maximum requests per second per client IP.",
                    "min": 10,
                    "max": 1000,
                    "specialValues": {
                        "0": "unlimited"
                    }
                },
                "max_rps_uri": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Maximum requests per second per URI.",
                    "min": 10,
                    "max": 1000,
                    "specialValues": {
                        "0": "unlimited"
                    }
                },
                "max_rps_cip_uri": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Maximum requests per second per client IP and URI.",
                    "min": 10,
                    "max": 1000,
                    "specialValues": {
                        "0": "unlimited"
                    }
                },
                "ssl_client_certificate_action": {
                    "type": "message",
                    "messageType": "SSLClientCertificateAction",
                    "description": "Set of match/action rules that govern what happens when the client certificate request is enabled",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "ssl_client_certificate_mode": {
                    "type": "enum",
                    "enumType": "SSLClientCertificateMode",
                    "default": "SSL_CLIENT_CERTIFICATE_NONE",
                    "description": "Specifies whether the client side verification is set to none, request or require.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "SSL_CLIENT_CERTIFICATE_NONE,SSL_CLIENT_CERTIFICATE_REQUIRE"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "SSL_CLIENT_CERTIFICATE_NONE,SSL_CLIENT_CERTIFICATE_REQUIRE"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "pki_profile_uuid": {
                    "type": "string",
                    "description": "Select the PKI profile to be associated with the Virtual Service. This profile defines the Certificate Authority and Revocation List."
                },
                "websockets_enabled": {
                    "type": "bool",
                    "default": true,
                    "description": "Enable Websockets proxy for traffic from clients to the virtual service. Connections to this VS start in HTTP mode. If the client requests an Upgrade to Websockets, and the server responds back with success, then the connection is upgraded to WebSockets mode. "
                },
                "max_rps_unknown_cip": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Maximum unknown client IPs per second.",
                    "min": 10,
                    "max": 1000,
                    "specialValues": {
                        "0": "unlimited"
                    }
                },
                "max_bad_rps_cip": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Maximum bad requests per second per client IP.",
                    "min": 10,
                    "max": 1000,
                    "specialValues": {
                        "0": "unlimited"
                    }
                },
                "max_bad_rps_uri": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Maximum bad requests per second per URI.",
                    "min": 10,
                    "max": 1000,
                    "specialValues": {
                        "0": "unlimited"
                    }
                },
                "max_bad_rps_cip_uri": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Maximum bad requests per second per client IP and URI.",
                    "min": 10,
                    "max": 1000,
                    "specialValues": {
                        "0": "unlimited"
                    }
                },
                "keepalive_header": {
                    "type": "bool",
                    "default": false,
                    "description": "Send HTTP 'Keep-Alive' header to the client. By default, the timeout specified in the 'Keep-Alive Timeout' field will be used unless the 'Use App Keepalive Timeout' flag is set, in which case the timeout sent by the application will be honored."
                },
                "use_app_keepalive_timeout": {
                    "type": "bool",
                    "default": false,
                    "description": "Use 'Keep-Alive' header timeout sent by application instead of sending the HTTP Keep-Alive Timeout.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "allow_dots_in_header_name": {
                    "type": "bool",
                    "default": false,
                    "description": "Allow use of dot (.) in HTTP header names, for instance Header.app.special: PickAppVersionX.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "disable_keepalive_posts_msie6": {
                    "type": "bool",
                    "default": true,
                    "description": "Disable keep-alive client side connections for older browsers based off MS Internet Explorer 6.0 (MSIE6). For some applications, this might break NTLM authentication for older clients based off MSIE6. For such applications, set this option to false to allow keep-alive connections.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "true"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "true"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "enable_request_body_buffering": {
                    "type": "bool",
                    "default": false,
                    "description": "Enable request body buffering for POST requests. If enabled, max buffer size is set to lower of 32M or the value (non-zero) configured in client_max_body_size."
                },
                "enable_fire_and_forget": {
                    "type": "bool",
                    "default": false,
                    "description": "Enable support for fire and forget feature. If enabled, request from client is forwarded to server even if client prematurely closes the connection",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "max_response_headers_size": {
                    "type": "int32",
                    "default": 48,
                    "description": "Maximum size in Kbytes of all the HTTP response headers.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "48"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 1,
                    "max": 256
                },
                "respond_with_100_continue": {
                    "type": "bool",
                    "default": true,
                    "description": "Avi will respond with 100-Continue response if Expect: 100-Continue header received from client"
                },
                "enable_request_body_metrics": {
                    "type": "bool",
                    "default": false,
                    "description": "Enable HTTP request body metrics. If enabled, requests from clients are parsed and relevant statistics about them are gathered. Currently, it processes HTTP POST requests with Content-Type application/x-www-form-urlencoded or multipart/form-data, and adds the number of detected parameters to the l7_client.http_params_count. This is an experimental feature and it may have performance impact. Use it when detailed information about the number of HTTP POST parameters is needed, e.g. for WAF sizing.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "fwd_close_hdr_for_bound_connections": {
                    "type": "bool",
                    "default": true,
                    "description": "Forward the Connection: Close header coming from backend server to the client if connection-switching is enabled, i.e. front-end and backend connections are bound together"
                },
                "max_keepalive_requests": {
                    "type": "int32",
                    "default": 100,
                    "description": "The max number of HTTP requests that can be sent over a Keep-Alive connection. '0' means unlimited.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "100"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "100"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 0,
                    "max": 1000000,
                    "specialValues": {
                        "0": "Unlimited requests on a connection"
                    }
                },
                "disable_sni_hostname_check": {
                    "type": "bool",
                    "default": false,
                    "description": "Disable strict check between TLS servername and HTTP Host name"
                },
                "reset_conn_http_on_ssl_port": {
                    "type": "bool",
                    "default": false,
                    "description": "If enabled, an HTTP request on an SSL port will result in connection close instead of a 400 response.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "http_upstream_buffer_size": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Size of HTTP buffer in kB.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "0"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "0"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 1,
                    "max": 256,
                    "specialValues": {
                        "0": "Auto compute the size of buffer"
                    }
                },
                "enable_chunk_merge": {
                    "type": "bool",
                    "default": true,
                    "description": "Enable chunk body merge for chunked transfer encoding response."
                },
                "http2_profile": {
                    "type": "message",
                    "messageType": "HTTP2ApplicationProfile",
                    "description": "Specifies the HTTP/2 specific application profile parameters.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "detect_ntlm_app": {
                    "type": "bool",
                    "default": true,
                    "description": "Detect NTLM apps based on the HTTP Response from the server. Once detected, connection multiplexing will be disabled for that connection.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "use_true_client_ip": {
                    "type": "bool",
                    "default": false,
                    "description": "Detect client IP from user specified header."
                },
                "true_client_ip": {
                    "type": "message",
                    "messageType": "TrueClientIPConfig",
                    "description": "Detect client IP from user specified header at the configured index in the specified direction."
                },
                "pass_through_x_accel_headers": {
                    "type": "bool",
                    "default": false,
                    "description": "Pass through X-ACCEL headers."
                },
                "collect_client_tls_fingerprint": {
                    "type": "bool",
                    "default": false,
                    "description": "If enabled, the client's TLS fingerprint will be collected and included in the Application Log. For Virtual Services with Bot Detection enabled, TLS fingerprints are always computed if 'use_tls_fingerprint' is enabled in the Bot Detection Policy's User-Agent detection component."
                },
                "max_header_count": {
                    "type": "int32",
                    "default": 256,
                    "description": "Maximum number of headers allowed in HTTP request and response.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "0",
                            "default_value": 0
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "0",
                            "default_value": 0
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ],
                    "min": 0,
                    "max": 4096,
                    "specialValues": {
                        "0": "unlimited headers in request and response"
                    }
                },
                "session_config": {
                    "type": "message",
                    "messageType": "HTTPSessionConfig",
                    "description": "HTTP session configuration."
                },
                "close_server_side_connection_on_error": {
                    "type": "bool",
                    "default": false,
                    "description": "Close server-side connection when an error response is received."
                }
            }
        },
        "HTTPSessionConfig": {
            "fields": {
                "session_cookie_name": {
                    "type": "string",
                    "default": "albsessid",
                    "description": "HTTP session cookie name to use.",
                    "maxStringLength": 64
                },
                "session_cookie_samesite": {
                    "type": "enum",
                    "enumType": "HTTPCookieSameSite",
                    "default": "SAMESITE_LAX",
                    "description": "HTTP session cookie SameSite attribute."
                },
                "session_cookie_secure": {
                    "type": "bool",
                    "default": true,
                    "description": "If set, HTTP session cookie will use 'Secure' attribute."
                },
                "session_cookie_httponly": {
                    "type": "bool",
                    "default": true,
                    "description": "If set, HTTP session cookie will use 'HttpOnly' attribute."
                },
                "session_establishment_timeout": {
                    "type": "uint32",
                    "default": 300,
                    "description": "Maximum allowed time between creating a session and the client coming back. Value in seconds.",
                    "min": 120,
                    "max": 3600
                },
                "session_idle_timeout": {
                    "type": "uint32",
                    "default": 1800,
                    "description": "Maximum allowed time to expire the session after establishment on client inactivity. Value in seconds.",
                    "min": 120,
                    "max": 604800
                },
                "session_maximum_timeout": {
                    "type": "uint32",
                    "default": 28800,
                    "description": "Maximum allowed time to expire the session, even if it is still active. Value in seconds.",
                    "min": 120,
                    "max": 604800
                }
            }
        },
        "TrueClientIPConfig": {
            "fields": {
                "headers": {
                    "type": "string",
                    "repeated": true,
                    "description": "HTTP Headers to derive client IP from. If none specified and use_true_client_ip is set to true, it will use X-Forwarded-For header, if present.",
                    "maxRepeatedLength": 1,
                    "maxStringLength": 128
                },
                "index_in_header": {
                    "type": "uint32",
                    "default": 1,
                    "description": "Position in the configured direction, in the specified header's value, to be used to set true client IP. If the value is greater than the number of IP addresses in the header, then the last IP address in the configured direction in the header will be used.",
                    "min": 1,
                    "max": 1000
                },
                "direction": {
                    "type": "enum",
                    "enumType": "TrueClientIPIndexDirection",
                    "default": "LEFT",
                    "description": "Denotes the end from which to count the IPs in the specified header value."
                }
            }
        },
        "SSLClientCertificateAction": {
            "fields": {
                "headers": {
                    "type": "message",
                    "messageType": "SSLClientRequestHeader",
                    "repeated": true
                },
                "close_connection": {
                    "type": "bool",
                    "default": false
                }
            }
        },
        "SSLClientRequestHeader": {
            "fields": {
                "request_header": {
                    "type": "string",
                    "description": "If this header exists, reset the connection. If the ssl variable is specified, add a header with this value"
                },
                "request_header_value": {
                    "type": "enum",
                    "enumType": "HTTPPolicyVar",
                    "description": "Set the request header with the value as indicated by this SSL variable. Eg. send the whole certificate in PEM format"
                }
            }
        },
        "HttpCacheConfig": {
            "fields": {
                "enabled": {
                    "type": "bool",
                    "default": false,
                    "description": "Enable/disable HTTP object caching.When enabling caching for the first time, SE Group app_cache_percent must be set to allocate shared memory required for caching (A service engine restart is needed after setting/resetting the SE group value)."
                },
                "xcache_header": {
                    "type": "bool",
                    "default": true,
                    "description": "Add an X-Cache header to content served from cache, which indicates to the client that the object was served from an intermediate cache."
                },
                "age_header": {
                    "type": "bool",
                    "default": true,
                    "description": "Add an Age header to content served from cache, which indicates to the client the number of seconds the object has been in the cache."
                },
                "date_header": {
                    "type": "bool",
                    "default": true,
                    "description": "If a Date header was not added by the server, add a Date header to the object served from cache.  This indicates to the client when the object was originally sent by the server to the cache."
                },
                "min_object_size": {
                    "type": "uint32",
                    "default": 100,
                    "description": "Minimum size of an object to store in the cache."
                },
                "max_object_size": {
                    "type": "uint32",
                    "default": 4194304,
                    "description": "Maximum size of an object to store in the cache."
                },
                "default_expire": {
                    "type": "uint32",
                    "default": 600,
                    "description": "Default expiration time of cache objects received from the server without a Cache-Control expiration header.  This value may be overwritten by the Heuristic Expire setting."
                },
                "heuristic_expire": {
                    "type": "bool",
                    "default": false,
                    "description": "If a response object from the server does not include the Cache-Control header, but does include a Last-Modified header, the system will use this time to calculate the Cache-Control expiration.  If unable to solicit an Last-Modified header, then the system will fall back to the Cache Expire Time value."
                },
                "max_cache_size": {
                    "type": "uint64",
                    "default": 0,
                    "description": "Max size, in bytes, of the cache.  The default, zero, indicates auto configuration."
                },
                "query_cacheable": {
                    "type": "bool",
                    "default": false,
                    "description": "Allow caching of objects whose URI included a query argument.  When disabled, these objects are not cached.  When enabled, the request must match the URI query to be considered a hit."
                },
                "mime_types_list": {
                    "type": "string",
                    "repeated": true,
                    "description": "Allowlist of cacheable mime types. If both Cacheable Mime Types string list and string group are empty, this defaults to */*"
                },
                "mime_types_group_uuids": {
                    "type": "string",
                    "repeated": true,
                    "description": "Allowlist string group of cacheable mime types. If both Cacheable Mime Types string list and string group are empty, this defaults to */*"
                },
                "aggressive": {
                    "type": "bool",
                    "default": false,
                    "description": "Enable/disable caching objects without Cache-Control headers"
                },
                "uri_non_cacheable": {
                    "type": "message",
                    "messageType": "PathMatch",
                    "description": "Non-cacheable URI configuration with match criteria."
                },
                "ignore_request_cache_control": {
                    "type": "bool",
                    "default": false,
                    "description": "Ignore client's cache control headers when fetching or storing from and to the cache."
                },
                "mime_types_block_lists": {
                    "type": "string",
                    "repeated": true,
                    "description": "Blocklist of non-cacheable mime types"
                },
                "mime_types_block_group_uuids": {
                    "type": "string",
                    "repeated": true,
                    "description": "Blocklist string group of non-cacheable mime types"
                }
            }
        },
        "PathMatch": {
            "fields": {
                "match_criteria": {
                    "type": "enum",
                    "enumType": "StringOperation",
                    "default": "CONTAINS",
                    "required": true,
                    "description": "Criterion to use for matching the path in the HTTP request URI.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "BEGINS_WITH,DOES_NOT_BEGIN_WITH,CONTAINS,DOES_NOT_CONTAIN,ENDS_WITH,DOES_NOT_END_WITH,EQUALS,DOES_NOT_EQUAL"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "BEGINS_WITH,DOES_NOT_BEGIN_WITH,CONTAINS,DOES_NOT_CONTAIN,ENDS_WITH,DOES_NOT_END_WITH,EQUALS,DOES_NOT_EQUAL"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "match_case": {
                    "type": "enum",
                    "enumType": "MatchCase",
                    "default": "INSENSITIVE",
                    "description": "Case sensitivity to use for the matching"
                },
                "match_str": {
                    "type": "string",
                    "repeated": true,
                    "description": "String values"
                },
                "string_group_uuids": {
                    "type": "string",
                    "repeated": true,
                    "description": "UUID of the string group(s)"
                },
                "match_decoded_string": {
                    "type": "bool",
                    "default": true,
                    "description": "Match against the decoded URI path."
                }
            }
        },
        "CompressionProfile": {
            "fields": {
                "compression": {
                    "type": "bool",
                    "default": false,
                    "required": true,
                    "description": "Compress HTTP response content if it wasn't already compressed."
                },
                "remove_accept_encoding_header": {
                    "type": "bool",
                    "default": true,
                    "required": true,
                    "description": "Offload compression from the servers to AVI. Saves compute cycles on the servers."
                },
                "compressible_content_uuid": {
                    "type": "string",
                    "default": "System-Compressible-Content-Types",
                    "description": "Compress only content types listed in this string group. Content types not present in this list are not compressed."
                },
                "type": {
                    "type": "enum",
                    "enumType": "CompressionType",
                    "default": "AUTO_COMPRESSION",
                    "required": true,
                    "description": "Compress content automatically or add custom filters to define compressible content and compression levels."
                },
                "filter": {
                    "type": "message",
                    "messageType": "CompressionFilter",
                    "repeated": true,
                    "description": "Custom filters used when auto compression is not selected."
                },
                "buf_num": {
                    "type": "int32",
                    "default": 128,
                    "description": "Number of buffers to use for compression output."
                },
                "buf_size": {
                    "type": "int32",
                    "default": 4096,
                    "description": "Size of each buffer used for compression output, this should ideally be a multiple of pagesize."
                },
                "level_normal": {
                    "type": "int32",
                    "default": 1,
                    "description": "Level of compression to apply on content selected for normal compression."
                },
                "level_aggressive": {
                    "type": "int32",
                    "default": 5,
                    "description": "Level of compression to apply on content selected for aggressive compression."
                },
                "window_size": {
                    "type": "int32",
                    "default": 4096,
                    "description": "window size used by compression, rounded to the last power of 2."
                },
                "hash_size": {
                    "type": "int32",
                    "default": 16384,
                    "description": "hash size used by compression, rounded to the last power of 2."
                },
                "min_length": {
                    "type": "int32",
                    "default": 128,
                    "description": "Minimum response content length to enable compression"
                },
                "max_low_rtt": {
                    "type": "int32",
                    "default": 10,
                    "description": "If client RTT is higher than this threshold, enable normal compression on the response."
                },
                "min_high_rtt": {
                    "type": "int32",
                    "default": 200,
                    "description": "If client RTT is higher than this threshold, enable aggressive compression on the response.  "
                },
                "mobile_str_uuid": {
                    "type": "string",
                    "default": "System-Devices-Mobile",
                    "description": "Values that identify mobile browsers in order to enable aggressive compression."
                }
            }
        },
        "CompressionFilter": {
            "fields": {
                "name": {
                    "type": "string",
                    "required": true
                },
                "index": {
                    "type": "int32",
                    "required": true
                },
                "match": {
                    "type": "enum",
                    "enumType": "MatchOperation",
                    "default": "IS_IN",
                    "description": "Whether to apply Filter when group criteria is matched or not"
                },
                "ip_addrs_uuid": {
                    "type": "string"
                },
                "ip_addrs": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "repeated": true
                },
                "ip_addr_ranges": {
                    "type": "message",
                    "messageType": "IpAddrRange",
                    "repeated": true
                },
                "ip_addr_prefixes": {
                    "type": "message",
                    "messageType": "IpAddrPrefix",
                    "repeated": true
                },
                "devices_uuid": {
                    "type": "string"
                },
                "user_agent": {
                    "type": "string",
                    "repeated": true
                },
                "level": {
                    "type": "enum",
                    "enumType": "CompressionFilterLevel",
                    "default": "NORMAL_COMPRESSION",
                    "required": true
                }
            },
            "repeatedKey": "index"
        },
        "IpAddrPrefix": {
            "fields": {
                "ip_addr": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "required": true
                },
                "mask": {
                    "type": "int32",
                    "required": true
                }
            },
            "repeatedKey": "ip_addr,mask"
        },
        "IpAddrRange": {
            "fields": {
                "begin": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "required": true,
                    "description": "Starting IP address of the range"
                },
                "end": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "required": true,
                    "description": "Ending IP address of the range"
                }
            },
            "repeatedKey": "begin,end"
        },
        "IpAddr": {
            "fields": {
                "addr": {
                    "type": "string",
                    "required": true,
                    "description": "IP address"
                },
                "type": {
                    "type": "enum",
                    "enumType": "IpAddrType",
                    "required": true
                }
            },
            "repeatedKey": "addr"
        },
        "AuthorizationPolicy": {
            "fields": {
                "authz_rules": {
                    "type": "message",
                    "messageType": "AuthorizationRule",
                    "repeated": true,
                    "description": "Authorization Policy Rules"
                }
            }
        },
        "AuthorizationRule": {
            "fields": {
                "name": {
                    "type": "string",
                    "description": "Name of the rule",
                    "required": true
                },
                "index": {
                    "type": "int32",
                    "description": "Index of the Authorization Policy rule",
                    "required": true
                },
                "enable": {
                    "type": "bool",
                    "default": true,
                    "description": "Enable or disable the rule",
                    "required": true
                },
                "match": {
                    "type": "message",
                    "messageType": "AuthorizationMatch",
                    "description": "Authorization match criteria for the rule.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "required": true
                },
                "action": {
                    "type": "message",
                    "messageType": "AuthorizationAction",
                    "description": "Authorization action when rule is matched.",
                    "required": true
                }
            },
            "repeatedKey": "index"
        },
        "AuthorizationAction": {
            "fields": {
                "type": {
                    "type": "enum",
                    "enumType": "AuthorizationActionEnum",
                    "default": "ALLOW_ACCESS",
                    "description": "Defines the action taken when an authorization policy rule is matched. By default, access is allowed to the requested resource."
                },
                "status_code": {
                    "type": "enum",
                    "enumType": "AuthorizationActionHttpStatusCode",
                    "description": "HTTP status code to use for local response when an policy rule is matched."
                }
            }
        },
        "AuthorizationMatch": {
            "fields": {
                "attr_matches": {
                    "type": "message",
                    "messageType": "AuthAttributeMatch",
                    "repeated": true,
                    "description": "Attributes whose values need to be matched ",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "path": {
                    "type": "message",
                    "messageType": "PathMatch",
                    "description": "Paths/URLs to be matched."
                },
                "host_hdr": {
                    "type": "message",
                    "messageType": "HostHdrMatch",
                    "description": "Host header value to be matched."
                },
                "method": {
                    "type": "message",
                    "messageType": "MethodMatch",
                    "description": "HTTP methods to be matched."
                },
                "access_token": {
                    "type": "message",
                    "messageType": "JWTMatch",
                    "description": "Access Token claims to be matched."
                }
            }
        },
        "JWTMatch": {
            "fields": {
                "token_name": {
                    "type": "string",
                    "description": "Token for which the claims need to be validated."
                },
                "matches": {
                    "type": "message",
                    "messageType": "JWTClaimMatch",
                    "repeated": true,
                    "description": "Claims whose values need to be matched."
                }
            }
        },
        "JWTClaimMatch": {
            "fields": {
                "name": {
                    "type": "string",
                    "description": "JWT Claim name to be validated.",
                    "required": true
                },
                "is_mandatory": {
                    "type": "bool",
                    "description": "Specified Claim should be present in the JWT.",
                    "required": true
                },
                "validate": {
                    "type": "bool",
                    "description": "Specifies whether to validate the Claim value.",
                    "required": true
                },
                "type": {
                    "type": "enum",
                    "enumType": "JWTClaimType",
                    "description": "Specifies the type of the Claim.",
                    "required": true
                },
                "int_match": {
                    "type": "uint32",
                    "description": "Integer value against which the claim is matched."
                },
                "bool_match": {
                    "type": "bool",
                    "description": "Boolean value against which the claim is matched."
                },
                "string_match": {
                    "type": "message",
                    "messageType": "StringMatch",
                    "description": "String values against which the claim is matched."
                }
            },
            "repeatedKey": "name"
        },
        "MethodMatch": {
            "fields": {
                "match_criteria": {
                    "type": "enum",
                    "enumType": "MatchOperation",
                    "required": true,
                    "description": "Criterion to use for HTTP method matching the method in the HTTP request"
                },
                "methods": {
                    "type": "enum",
                    "enumType": "HTTPMethod",
                    "repeated": true,
                    "description": "Configure HTTP method(s)",
                    "maxRepeatedLength": 16,
                    "minRepeatedLength": 1,
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "HTTP_METHOD_GET,HTTP_METHOD_PUT,HTTP_METHOD_POST,HTTP_METHOD_HEAD,HTTP_METHOD_OPTIONS"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "HTTP_METHOD_GET,HTTP_METHOD_PUT,HTTP_METHOD_POST,HTTP_METHOD_HEAD,HTTP_METHOD_OPTIONS"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                }
            }
        },
        "HostHdrMatch": {
            "fields": {
                "match_criteria": {
                    "type": "enum",
                    "enumType": "HdrMatchOperation",
                    "required": true,
                    "description": "Criterion to use for the host header value match"
                },
                "match_case": {
                    "type": "enum",
                    "enumType": "MatchCase",
                    "default": "INSENSITIVE",
                    "description": "Case sensitivity to use for the match"
                },
                "value": {
                    "type": "string",
                    "repeated": true,
                    "description": "String value(s) in the host header"
                }
            }
        },
        "AuthAttributeMatch": {
            "fields": {
                "attribute_name": {
                    "type": "string",
                    "description": "Attribute name whose values will be looked up in the access lists.",
                    "required": true
                },
                "attribute_value_list": {
                    "type": "message",
                    "messageType": "StringMatch",
                    "description": "Attribute Values used to determine access when authentication applies.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "required": true
                }
            },
            "repeatedKey": "attribute_name"
        },
        "AuthProfile": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "required": true,
                    "description": "UUID of the Auth Profile."
                },
                "name": {
                    "type": "string",
                    "required": true,
                    "description": "Name of the Auth Profile.",
                    "maxStringLength": 256
                },
                "type": {
                    "type": "enum",
                    "enumType": "AuthProfileType",
                    "required": true,
                    "description": "Type of the Auth Profile.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "AUTH_PROFILE_LDAP,AUTH_PROFILE_TACACS_PLUS,AUTH_PROFILE_SAML,AUTH_PROFILE_JWT,AUTH_PROFILE_OAUTH,AUTH_PROFILE_CLIENT_CERT"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "AUTH_PROFILE_LDAP,AUTH_PROFILE_TACACS_PLUS,AUTH_PROFILE_SAML,AUTH_PROFILE_JWT,AUTH_PROFILE_OAUTH,AUTH_PROFILE_CLIENT_CERT"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "immutable": true
                },
                "ldap": {
                    "type": "message",
                    "messageType": "LdapAuthSettings",
                    "description": "LDAP server and directory settings."
                },
                "http": {
                    "type": "message",
                    "messageType": "AuthProfileHTTPClientParams",
                    "description": "HTTP user authentication params."
                },
                "tacacs_plus": {
                    "type": "message",
                    "messageType": "TacacsPlusAuthSettings",
                    "description": "TACACS+ settings",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "saml": {
                    "type": "message",
                    "messageType": "SamlSettings",
                    "description": "SAML settings"
                },
                "jwt_profile_uuid": {
                    "type": "string",
                    "description": "JWTServerProfile to be used for authentication."
                },
                "oauth_profile": {
                    "type": "message",
                    "messageType": "OAuthProfile",
                    "description": "OAuth Profile - Common endpoint information."
                },
                "client_cert": {
                    "type": "message",
                    "messageType": "ClientCertAuthSettings",
                    "description": "Client Cert settings"
                },
                "markers": {
                    "type": "message",
                    "messageType": "RoleFilterMatchLabel",
                    "repeated": true,
                    "description": "List of labels to be used for granular RBAC.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "description": {
                    "type": "string"
                },
                "tenant_uuid": {
                    "type": "string",
                    "required": true
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                }
            }
        },
        "ClientCertAuthSettings": {
            "fields": {
                "client_cert_uuids": {
                    "type": "string",
                    "repeated": true,
                    "description": "Client Certs to be used for authentication.",
                    "maxStringLength": 256
                }
            }
        },
        "OAuthProfile": {
            "fields": {
                "authorization_endpoint": {
                    "type": "string",
                    "description": "URL of authorization server.",
                    "maxStringLength": 128,
                    "required": true
                },
                "token_endpoint": {
                    "type": "string",
                    "description": "URL of token exchange server.",
                    "maxStringLength": 128
                },
                "introspection_endpoint": {
                    "type": "string",
                    "description": "URL of token introspection server.",
                    "maxStringLength": 128
                },
                "jwks_uri": {
                    "type": "string",
                    "description": "JWKS URL of the endpoint that hosts the public keys that can be used to verify any JWT issued by the authorization server.",
                    "maxStringLength": 128
                },
                "jwks_timeout": {
                    "type": "int32",
                    "default": 0,
                    "description": "Lifetime of the cached JWKS keys.",
                    "min": 0,
                    "max": 1440
                },
                "issuer": {
                    "type": "string",
                    "description": "Uniquely identifiable name of the Token Issuer.",
                    "maxStringLength": 128
                },
                "pool_uuid": {
                    "type": "string",
                    "description": "Pool object to interface with Authorization Server endpoints.",
                    "maxStringLength": 128
                },
                "oauth_resp_buffer_sz": {
                    "type": "int32",
                    "default": 102400,
                    "description": "Buffering size for the responses from the OAUTH enpoints.",
                    "min": 0,
                    "max": 32768000
                },
                "userinfo_endpoint": {
                    "type": "string",
                    "description": "URL of the Userinfo Endpoint.",
                    "maxStringLength": 128
                },
                "end_session_endpoint": {
                    "type": "string",
                    "description": "Logout URI of IDP server.",
                    "maxStringLength": 128
                },
                "redirect_uri": {
                    "type": "string",
                    "description": "Redirect URI specified in the request to Authorization Server.",
                    "maxStringLength": 300
                },
                "oauth_profile_type": {
                    "type": "enum",
                    "enumType": "OAuthProfileType",
                    "default": "CLIENT_OAUTH",
                    "description": "Type of OAuth profile which defines the usage type."
                },
                "oauth_controller_settings": {
                    "type": "message",
                    "messageType": "OAuthAppSettings",
                    "description": "OAuth App Settings for controller authentication"
                },
                "oauth_provider": {
                    "type": "enum",
                    "enumType": "OauthProvider",
                    "description": "Type of OAuth Provider when using controller oauth as oauth profile type"
                },
                "audience": {
                    "type": "string",
                    "description": "Audience parameter used for JWT token validation",
                    "maxStringLength": 128
                }
            }
        },
        "OAuthAppSettings": {
            "fields": {
                "scopes": {
                    "type": "string",
                    "repeated": true,
                    "description": "Scope specified to give limited access to the app.",
                    "maxStringLength": 128
                },
                "oidc_config": {
                    "type": "message",
                    "messageType": "OIDCConfig",
                    "description": "OpenID Connect specific configuration."
                },
                "client_id": {
                    "type": "string",
                    "description": "Application specific identifier.",
                    "maxStringLength": 128,
                    "required": true
                },
                "client_secret": {
                    "type": "string",
                    "description": "Application specific identifier secret.",
                    "maxStringLength": 128,
                    "required": false
                }
            }
        },
        "OIDCConfig": {
            "fields": {
                "oidc_enable": {
                    "type": "bool",
                    "description": "Adds openid as one of the scopes enabling OpenID Connect flow."
                },
                "profile": {
                    "type": "bool",
                    "default": true,
                    "description": "Fetch profile information by enabling profile scope."
                },
                "userinfo": {
                    "type": "bool",
                    "description": "Fetch profile information from Userinfo Endpoint."
                },
                "userid_claim_name": {
                    "type": "string",
                    "description": "Claim name from id token to be used as User ID",
                    "maxStringLength": 128
                }
            }
        },
        "SamlSettings": {
            "fields": {
                "idp": {
                    "type": "message",
                    "messageType": "SamlIdentityProviderSettings",
                    "description": "Configure remote Identity provider settings",
                    "required": true
                },
                "sp": {
                    "type": "message",
                    "messageType": "SamlServiceProviderSettings",
                    "description": "Configure service provider settings for the Controller",
                    "required": true
                }
            }
        },
        "SamlServiceProviderSettings": {
            "fields": {
                "saml_entity_type": {
                    "type": "enum",
                    "enumType": "AuthSamlEntityType",
                    "description": "Type of SAML endpoint",
                    "immutable": true
                },
                "fqdn": {
                    "type": "string",
                    "description": "FQDN if entity type is DNS_FQDN "
                },
                "sp_nodes": {
                    "type": "message",
                    "messageType": "SamlServiceProviderNode",
                    "repeated": true,
                    "description": "Service Provider node information"
                },
                "org_name": {
                    "type": "string",
                    "description": "Service Provider Organization Name"
                },
                "org_display_name": {
                    "type": "string",
                    "description": "Service Provider Organization Display Name"
                },
                "org_url": {
                    "type": "string",
                    "description": "Service Provider Organization URL"
                },
                "tech_contact_name": {
                    "type": "string",
                    "description": "Service Provider technical contact name"
                },
                "tech_contact_email": {
                    "type": "string",
                    "description": "Service Provider technical contact email"
                }
            }
        },
        "SamlServiceProviderNode": {
            "fields": {
                "name": {
                    "type": "string",
                    "required": true,
                    "description": "Refers to the Cluster name identifier (Virtual IP or FQDN)."
                },
                "entity_id": {
                    "type": "string",
                    "description": "Globally unique entityID for this node. Entity ID on the IDP should match this."
                },
                "single_signon_url": {
                    "type": "string",
                    "description": "Single Signon URL to be programmed on the IDP."
                },
                "signing_ssl_key_and_certificate_uuid": {
                    "type": "string",
                    "description": "Service Engines will use this SSL certificate to sign assertions going to the IdP."
                }
            },
            "repeatedKey": "name"
        },
        "SamlIdentityProviderSettings": {
            "fields": {
                "metadata": {
                    "type": "string",
                    "description": "SAML IDP metadata"
                },
                "metadata_url": {
                    "type": "string",
                    "description": "SAML IDP Federation Metadata Url",
                    "maxStringLength": 512
                },
                "meta_data_download_interval": {
                    "type": "int32",
                    "default": 60,
                    "description": "The interval to query and download SAML IDP metadata using the metadata URL",
                    "min": 1,
                    "max": 10080
                },
                "periodic_download": {
                    "type": "bool",
                    "default": false,
                    "description": "Enable Periodic Metadata Download."
                }
            }
        },
        "TacacsPlusAuthSettings": {
            "fields": {
                "server": {
                    "type": "string",
                    "repeated": true,
                    "description": "TACACS+ server IP address or FQDN.",
                    "minRepeatedLength": 1
                },
                "port": {
                    "type": "uint32",
                    "default": 49,
                    "description": "TACACS+ server listening port"
                },
                "password": {
                    "type": "string",
                    "description": "TACACS+ server shared secret"
                },
                "service": {
                    "type": "enum",
                    "enumType": "AuthTacacsPlusService",
                    "default": "AUTH_TACACS_PLUS_SERVICE_LOGIN",
                    "description": "TACACS+ service"
                },
                "authorization_attrs": {
                    "type": "message",
                    "messageType": "AuthTacacsPlusAttributeValuePair",
                    "repeated": true,
                    "description": "TACACS+ authorization attribute value pairs"
                }
            }
        },
        "AuthTacacsPlusAttributeValuePair": {
            "fields": {
                "name": {
                    "type": "string",
                    "description": "attribute name"
                },
                "value": {
                    "type": "string",
                    "description": "attribute value"
                },
                "mandatory": {
                    "type": "bool",
                    "description": "mandatory"
                }
            }
        },
        "AuthProfileHTTPClientParams": {
            "fields": {
                "request_header": {
                    "type": "string",
                    "description": "Insert an HTTP header.  This field is used to define the header name.  The value of the header is set to the client's HTTP Auth user ID."
                },
                "cache_expiration_time": {
                    "type": "int32",
                    "default": 5,
                    "description": "The max allowed length of time a clients authentication is cached",
                    "min": 1,
                    "max": 30
                },
                "require_user_groups": {
                    "type": "string",
                    "repeated": true,
                    "description": "A user should be a member of these groups.  Each group is defined by the DN.  For example, CN=testgroup,OU=groups,dc=example,dc=avinetworks,DC=com"
                }
            }
        },
        "LdapAuthSettings": {
            "fields": {
                "server": {
                    "type": "string",
                    "repeated": true,
                    "description": "LDAP server IP(v4/v6) address or FQDN. Use IP address if an auth profile is used to configure Virtual Service.",
                    "minRepeatedLength": 1
                },
                "port": {
                    "type": "uint32",
                    "default": 389,
                    "description": "Query the LDAP servers on this port."
                },
                "security_mode": {
                    "type": "enum",
                    "enumType": "AuthLdapSecurityMode",
                    "default": "AUTH_LDAP_SECURE_USE_LDAPS",
                    "description": "LDAP connection security mode.",
                    "required": true
                },
                "base_dn": {
                    "type": "string",
                    "description": "The LDAP base DN.  For example, avinetworks.com would be DC=avinetworks,DC=com"
                },
                "bind_as_administrator": {
                    "type": "bool",
                    "default": true,
                    "description": "LDAP administrator credentials are used to search for users and group memberships."
                },
                "settings": {
                    "type": "message",
                    "messageType": "LdapDirectorySettings",
                    "description": "LDAP full directory configuration with administrator credentials"
                },
                "user_bind": {
                    "type": "message",
                    "messageType": "LdapUserBindSettings",
                    "description": "LDAP anonymous bind configuration"
                },
                "email_attribute": {
                    "type": "string",
                    "default": "email",
                    "description": "LDAP attribute that refers to user email"
                },
                "full_name_attribute": {
                    "type": "string",
                    "default": "name",
                    "description": "LDAP attribute that refers to user's full name"
                }
            }
        },
        "LdapUserBindSettings": {
            "fields": {
                "dn_template": {
                    "type": "string",
                    "description": "LDAP user DN pattern is used to bind LDAP user after replacing the user token with real username.",
                    "required": true
                },
                "token": {
                    "type": "string",
                    "default": "<user>",
                    "description": "LDAP token is replaced with real user name in the user DN pattern.",
                    "required": true
                },
                "user_id_attribute": {
                    "type": "string",
                    "description": "LDAP user id attribute is the login attribute that uniquely identifies a single user record.",
                    "required": true
                },
                "user_attributes": {
                    "type": "string",
                    "repeated": true,
                    "description": "LDAP user attributes to fetch on a successful user bind."
                }
            }
        },
        "LdapDirectorySettings": {
            "fields": {
                "admin_bind_dn": {
                    "type": "string",
                    "description": "LDAP Admin User DN. Administrator credentials are required to search for users under user search DN or groups under group search DN.",
                    "required": true
                },
                "password": {
                    "type": "string",
                    "description": "LDAP Admin User Password",
                    "required": true
                },
                "user_search_dn": {
                    "type": "string",
                    "description": "LDAP user search DN is the root of search for a given user in the LDAP directory. Only user records present in this LDAP directory sub-tree will be validated."
                },
                "user_search_scope": {
                    "type": "enum",
                    "enumType": "AuthLdapSearchScope",
                    "default": "AUTH_LDAP_SCOPE_ONE",
                    "description": "LDAP user search scope defines how deep to search for the user starting from user search DN."
                },
                "user_id_attribute": {
                    "type": "string",
                    "description": "LDAP user id attribute is the login attribute that uniquely identifies a single user record.",
                    "required": true
                },
                "user_attributes": {
                    "type": "string",
                    "repeated": true,
                    "description": "LDAP user attributes to fetch on a successful user bind."
                },
                "group_search_dn": {
                    "type": "string",
                    "description": "LDAP group search DN is the root of search for a given group in the LDAP directory. Only matching groups present in this LDAP directory sub-tree will be checked for user membership."
                },
                "group_member_attribute": {
                    "type": "string",
                    "default": "member",
                    "description": "LDAP group attribute that identifies each of the group members."
                },
                "group_search_scope": {
                    "type": "enum",
                    "enumType": "AuthLdapSearchScope",
                    "default": "AUTH_LDAP_SCOPE_SUBTREE",
                    "description": "LDAP group search scope defines how deep to search for the group starting from the group search DN."
                },
                "group_member_is_full_dn": {
                    "type": "bool",
                    "default": true,
                    "description": "Group member entries contain full DNs instead of just user id attribute values"
                },
                "group_filter": {
                    "type": "string",
                    "default": "(objectClass=*)",
                    "description": "Group filter is used to identify groups during search"
                },
                "ignore_referrals": {
                    "type": "bool",
                    "default": false,
                    "description": "During user or group search, ignore searching referrals."
                }
            }
        },
        "AuthMappingProfile": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "description": "UUID of the AuthMappingProfile.",
                    "maxStringLength": 255,
                    "required": true
                },
                "name": {
                    "type": "string",
                    "description": "Name of the AuthMappingProfile.",
                    "maxStringLength": 255,
                    "required": true
                },
                "type": {
                    "type": "enum",
                    "enumType": "AuthProfileType",
                    "description": "Type of the Auth Profile for which these rules can be linked.",
                    "immutable": true,
                    "required": true
                },
                "mapping_rules": {
                    "type": "message",
                    "messageType": "AuthMappingRule",
                    "repeated": true,
                    "description": "Rules list for tenant or role mapping.",
                    "minRepeatedLength": 1
                },
                "description": {
                    "type": "string",
                    "description": "Description for the AuthMappingProfile",
                    "maxStringLength": 255
                },
                "tenant_uuid": {
                    "type": "string",
                    "description": "Tenant ref for the auth mapping profile",
                    "maxStringLength": 255,
                    "required": true
                },
                "allow_unlabelled_access": {
                    "type": "bool",
                    "default": true,
                    "description": "Allow access to unlabelled objects."
                },
                "dynamic_role_filters": {
                    "type": "message",
                    "messageType": "RoleFilter",
                    "repeated": true,
                    "description": "Filters for granular object access control based on object labels. Multiple filters are merged using the AND operator. If empty, all objects according to the privileges will be accessible to the user.",
                    "maxRepeatedLength": 4,
                    "minRepeatedLength": 0
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                }
            }
        },
        "RoleFilter": {
            "fields": {
                "name": {
                    "type": "string",
                    "description": "Name for the filter."
                },
                "match_operation": {
                    "type": "enum",
                    "enumType": "RoleFilterMatchOperation",
                    "default": "ROLE_FILTER_EQUALS",
                    "description": "Label match operation criteria."
                },
                "match_label": {
                    "type": "message",
                    "messageType": "RoleFilterMatchLabel",
                    "description": "Label key to match against objects for values.",
                    "required": true
                },
                "enabled": {
                    "type": "bool",
                    "default": true,
                    "description": "Enable this filter."
                }
            },
            "repeatedKey": "name"
        },
        "AuthMappingRule": {
            "fields": {
                "index": {
                    "type": "int32",
                    "required": true
                },
                "group_match": {
                    "type": "message",
                    "messageType": "AuthMatchGroupMembership"
                },
                "attribute_match": {
                    "type": "message",
                    "messageType": "AuthMatchAttribute"
                },
                "assign_tenant": {
                    "type": "enum",
                    "enumType": "AuthRuleAssignment"
                },
                "tenant_attribute_name": {
                    "type": "string"
                },
                "tenant_uuids": {
                    "type": "string",
                    "repeated": true
                },
                "assign_role": {
                    "type": "enum",
                    "enumType": "AuthRuleAssignment"
                },
                "role_attribute_name": {
                    "type": "string"
                },
                "role_uuids": {
                    "type": "string",
                    "repeated": true
                },
                "is_superuser": {
                    "type": "bool"
                },
                "assign_policy": {
                    "type": "enum",
                    "enumType": "AuthRuleAssignment",
                    "description": "Assignment rule for the Object Access Policy."
                },
                "policy_attribute_name": {
                    "type": "string",
                    "description": "Attribute name for Object Access Policy assignment."
                },
                "assign_userprofile": {
                    "type": "enum",
                    "enumType": "AuthRuleAssignment",
                    "description": "Assignment rule for the User Account Profile."
                },
                "userprofile_attribute_name": {
                    "type": "string",
                    "description": "Attribute name for User Account Profile assignment."
                },
                "userprofile_uuid": {
                    "type": "string",
                    "description": "User Account Profile to assign to user on successful match."
                },
                "default_tenant_uuid": {
                    "type": "string",
                    "description": "Default tenant ref to assign to user",
                    "maxStringLength": 255
                }
            },
            "repeatedKey": "index"
        },
        "AuthMatchAttribute": {
            "fields": {
                "criteria": {
                    "type": "enum",
                    "enumType": "AuthMatchOperation",
                    "description": "rule match criteria",
                    "required": true
                },
                "name": {
                    "type": "string"
                },
                "values": {
                    "type": "string",
                    "repeated": true
                }
            }
        },
        "AuthMatchGroupMembership": {
            "fields": {
                "criteria": {
                    "type": "enum",
                    "enumType": "AuthMatchOperation",
                    "description": "rule match criteria",
                    "required": true
                },
                "groups": {
                    "type": "string",
                    "repeated": true
                }
            }
        },
        "AutoScaleLaunchConfig": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "required": true
                },
                "name": {
                    "type": "string",
                    "required": true,
                    "maxStringLength": 256
                },
                "image_id": {
                    "type": "string",
                    "description": "Unique ID of the Amazon Machine Image (AMI)  or OpenStack VM ID."
                },
                "openstack": {
                    "type": "message",
                    "messageType": "AutoScaleOpenStackSettings"
                },
                "mesos": {
                    "type": "message",
                    "messageType": "AutoScaleMesosSettings"
                },
                "markers": {
                    "type": "message",
                    "messageType": "RoleFilterMatchLabel",
                    "repeated": true,
                    "description": "List of labels to be used for granular RBAC.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "description": {
                    "type": "string"
                },
                "tenant_uuid": {
                    "type": "string",
                    "required": true
                },
                "use_external_asg": {
                    "type": "bool",
                    "default": true,
                    "description": "If set to True, ServerAutoscalePolicy will use the autoscaling group (external_autoscaling_groups) from Pool to perform scale up and scale down. Pool should have single autoscaling group configured."
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                }
            }
        },
        "AutoScaleMesosSettings": {
            "fields": {
                "force": {
                    "type": "bool",
                    "default": true,
                    "description": "Apply scale-out even when there are deployments inprogress."
                }
            }
        },
        "AutoScaleOpenStackSettings": {
            "fields": {
                "heat_scale_up_url": {
                    "type": "string",
                    "description": "Avi Controller will use this URL to scale upthe pool. Cloud connector will automatically update the membership. This is an alpha feature."
                },
                "heat_scale_down_url": {
                    "type": "string",
                    "description": "Avi Controller will use this URL to scale downthe pool. Cloud connector will automatically update the membership. This is an alpha feature."
                }
            }
        },
        "AvailabilityZone": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "description": "Availability zone config UUID."
                },
                "name": {
                    "type": "string",
                    "description": "Availabilty zone where VCenter list belongs to",
                    "immutable": true,
                    "maxStringLength": 256,
                    "required": true
                },
                "tenant_uuid": {
                    "type": "string",
                    "description": "Availabilityzone belongs to tenant."
                },
                "cloud_uuid": {
                    "type": "string",
                    "description": "Availability zone belongs to cloud.",
                    "immutable": true,
                    "required": true
                },
                "az_clusters": {
                    "type": "message",
                    "messageType": "AZCluster",
                    "repeated": true,
                    "description": "Group of clusters belongs to the AZ."
                },
                "az_hosts": {
                    "type": "message",
                    "messageType": "AZHost",
                    "repeated": true,
                    "description": "Group of hosts associated with the AZ."
                },
                "az_datastores": {
                    "type": "message",
                    "messageType": "AZDatastore",
                    "repeated": true,
                    "description": "Group of datastores associated with the AZ."
                },
                "vsphere_zones": {
                    "type": "message",
                    "messageType": "VSphereZone",
                    "repeated": true,
                    "description": "VSphere Zone associated with the AZ.",
                    "maxRepeatedLength": 1
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                }
            }
        },
        "VSphereZone": {
            "fields": {
                "vcenter_uuid": {
                    "type": "string",
                    "description": "The UUID of the vCenter Server where the vSphere zone belongs.",
                    "maxStringLength": 256
                },
                "zone_name": {
                    "type": "string",
                    "description": "Name of the vSphere zone in vCenter.",
                    "immutable": true,
                    "maxStringLength": 256,
                    "required": true
                }
            }
        },
        "AZDatastore": {
            "fields": {
                "ds_ids": {
                    "type": "string",
                    "repeated": true,
                    "description": "List of Managed object id of datastores.",
                    "maxStringLength": 256
                },
                "include": {
                    "type": "bool",
                    "default": false,
                    "description": "Include or exclude the datastores from the list."
                },
                "vcenter_uuid": {
                    "type": "string",
                    "description": "Vcenter Id of the datastores.",
                    "maxStringLength": 256
                }
            }
        },
        "AZHost": {
            "fields": {
                "vcenter_uuid": {
                    "type": "string",
                    "description": "The UUID of the vCenter Server that manages the hosts associated with this AvailabilityZone.",
                    "maxStringLength": 256
                },
                "host_ids": {
                    "type": "string",
                    "repeated": true,
                    "description": "A list of Managed Object IDs (MOIDs) of vCenter hosts that are part of this Availability Zone.",
                    "minRepeatedLength": 1,
                    "maxStringLength": 256
                }
            }
        },
        "AZCluster": {
            "fields": {
                "vcenter_uuid": {
                    "type": "string",
                    "description": "The UUID of the vCenter Server that manages the clusters associated with this AvailabilityZone.",
                    "maxStringLength": 256
                },
                "cluster_ids": {
                    "type": "string",
                    "repeated": true,
                    "description": "A list of Managed Object IDs (MOIDs) of vCenter clusters that are part of this Availability Zone.",
                    "maxStringLength": 256
                }
            }
        },
        "Backup": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "required": true
                },
                "file_name": {
                    "type": "string",
                    "required": true,
                    "description": "The file name of backup."
                },
                "timestamp": {
                    "type": "string",
                    "description": "Unix Timestamp of when the backup file is created"
                },
                "local_file_url": {
                    "type": "string",
                    "description": "URL to download the backup file"
                },
                "remote_file_url": {
                    "type": "string",
                    "description": "URL to download the backup file"
                },
                "scheduler_uuid": {
                    "type": "string",
                    "description": "Scheduler Information"
                },
                "backup_config_uuid": {
                    "type": "string",
                    "description": "BackupConfiguration Information"
                },
                "tenant_uuid": {
                    "type": "string",
                    "default": "admin"
                }
            }
        },
        "BackupConfiguration": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "required": true
                },
                "name": {
                    "type": "string",
                    "required": true,
                    "description": "Name of backup configuration.",
                    "maxStringLength": 256
                },
                "save_local": {
                    "type": "bool",
                    "description": "Local Backup"
                },
                "maximum_backups_stored": {
                    "type": "uint32",
                    "default": 4,
                    "description": "Rotate the backup files based on this count.",
                    "min": 1,
                    "max": 20
                },
                "upload_to_remote_host": {
                    "type": "bool",
                    "description": "Remote Backup"
                },
                "ssh_user_uuid": {
                    "type": "string",
                    "description": "Access Credentials for remote destination."
                },
                "remote_directory": {
                    "type": "string",
                    "description": "Directory at remote destination with write permission for ssh user."
                },
                "remote_hostname": {
                    "type": "string",
                    "description": "Remote Destination."
                },
                "backup_passphrase": {
                    "type": "string",
                    "description": "Default passphrase to encrypt sensitive fields for configuration export and periodic backup. The same passphrase must be provided to import the configuration."
                },
                "backup_file_prefix": {
                    "type": "string",
                    "description": "Prefix of the exported configuration file"
                },
                "upload_to_s3": {
                    "type": "bool",
                    "description": "Cloud Backup",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "aws_access_key": {
                    "type": "string",
                    "description": "AWS Access Key ID.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "aws_secret_access": {
                    "type": "string",
                    "description": "AWS Secret Access Key.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "aws_bucket_id": {
                    "type": "string",
                    "description": "AWS bucket.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "remote_file_transfer_protocol": {
                    "type": "enum",
                    "enumType": "RemoteFileTransferProtocol",
                    "default": "SCP",
                    "description": "Remote file transfer protocol type.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "SCP,SFTP"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "aws_bucket_region": {
                    "type": "string",
                    "description": "The name of the AWS region associated with the bucket.",
                    "maxStringLength": 64
                },
                "s3_bucket_folder": {
                    "type": "string",
                    "description": "The folder name in s3 bucket where backup will be stored.",
                    "maxStringLength": 64
                },
                "bundle_mode": {
                    "type": "bool",
                    "default": false,
                    "description": "By default, JSON Backups are generated. When this flag is enabled, bundle backups will be generated."
                },
                "tenant_uuid": {
                    "type": "string"
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                }
            }
        },
        "BotDetectionPolicy": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "description": "A unique identifier to this Bot Detection Policy.",
                    "required": true
                },
                "tenant_uuid": {
                    "type": "string",
                    "description": "The unique identifier of the tenant to which this policy belongs."
                },
                "name": {
                    "type": "string",
                    "description": "The name of this Bot Detection Policy.",
                    "maxStringLength": 256,
                    "required": true
                },
                "description": {
                    "type": "string",
                    "description": "Human-readable description of this Bot Detection Policy."
                },
                "allow_list": {
                    "type": "message",
                    "messageType": "BotAllowList",
                    "description": "Allow the user to skip BotManagement for selected requests."
                },
                "ip_reputation_detector": {
                    "type": "message",
                    "messageType": "BotConfigIPReputation",
                    "description": "The IP reputation configuration used in this policy.",
                    "required": true
                },
                "ip_location_detector": {
                    "type": "message",
                    "messageType": "BotConfigIPLocation",
                    "description": "The IP location configuration used in this policy.",
                    "required": true
                },
                "user_agent_detector": {
                    "type": "message",
                    "messageType": "BotConfigUserAgent",
                    "description": "The User-Agent configuration used in this policy.",
                    "required": true
                },
                "client_behavior_detector": {
                    "type": "message",
                    "messageType": "BotConfigClientBehavior",
                    "description": "The client behavior configuration used in this policy."
                },
                "user_consolidator_uuid": {
                    "type": "string",
                    "description": "The user-provided ruleset for consolidating the results of different decider phases. This runs before the system consolidator. If it successfully sets a consolidation, the system consolidator will not change it."
                },
                "system_consolidator_uuid": {
                    "type": "string",
                    "default": "System-BotConfigConsolidator",
                    "description": "The installation provides an updated ruleset for consolidating the results of different decider phases."
                },
                "user_bot_mapping_uuid": {
                    "type": "string",
                    "description": "User-defined rules for classification. These are applied before the system classification rules. If a rule matches, processing terminates and the system-defined rules will not run."
                },
                "system_bot_mapping_uuid": {
                    "type": "string",
                    "description": "System-defined rules for classification."
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                }
            }
        },
        "BotConfigClientBehavior": {
            "fields": {
                "enabled": {
                    "type": "bool",
                    "default": false,
                    "description": "Whether client behavior based Bot detection is enabled."
                },
                "minimum_requests": {
                    "type": "uint64",
                    "default": 3,
                    "description": "Minimum requests for the client behavior component to make a decision.",
                    "min": 2,
                    "max": 1000
                },
                "minimum_requests_with_referer": {
                    "type": "uint64",
                    "default": 1,
                    "description": "Minimum requests with a referer header for the client behavior component to not identify as a bot. Setting this to zero means the component never identifies a client as bot based on missing referer headers.",
                    "min": 0,
                    "max": 100
                },
                "bad_request_percent": {
                    "type": "uint32",
                    "default": 20,
                    "description": "Minimum percentage of bad requests for the client behavior component to identify as a bot.",
                    "min": 1,
                    "max": 100
                }
            }
        },
        "BotConfigUserAgent": {
            "fields": {
                "enabled": {
                    "type": "bool",
                    "default": true,
                    "description": "Whether User Agent-based Bot detection is enabled."
                },
                "use_tls_fingerprint": {
                    "type": "bool",
                    "default": true,
                    "description": "Whether to match the TLS fingerprint observed on the request against TLS fingerprints expected for the user agent."
                }
            }
        },
        "BotConfigIPLocation": {
            "fields": {
                "enabled": {
                    "type": "bool",
                    "default": true,
                    "description": "If this is enabled, IP location information is used to determine if a client is a known search engine bot, comes from the cloud, etc."
                },
                "ip_location_db_uuid": {
                    "type": "string",
                    "default": "System-GeoDB",
                    "description": "The UUID of the Geo-IP database to use."
                },
                "system_cloud_providers_uuid": {
                    "type": "string",
                    "default": "System-BotCloudProviders",
                    "description": "The system-defined cloud providers."
                },
                "system_search_engines_uuid": {
                    "type": "string",
                    "default": "System-BotSearchEngines",
                    "description": "The system-defined search engines."
                }
            }
        },
        "BotConfigIPReputation": {
            "fields": {
                "enabled": {
                    "type": "bool",
                    "default": true,
                    "description": "Whether IP reputation-based Bot detection is enabled."
                },
                "ip_reputation_db_uuid": {
                    "type": "string",
                    "default": "System-IPReputation-Webroot-DB",
                    "description": "The UUID of the IP reputation DB to use."
                },
                "system_ip_reputation_mapping_uuid": {
                    "type": "string",
                    "default": "System-BotIPReputationTypeMapping",
                    "description": "The system-provided mapping from IP reputation types to Bot types."
                }
            }
        },
        "BotAllowList": {
            "fields": {
                "rules": {
                    "type": "message",
                    "messageType": "BotAllowRule",
                    "repeated": true,
                    "description": "Allow rules to control which requests undergo BOT detection."
                }
            }
        },
        "BotAllowRule": {
            "fields": {
                "index": {
                    "type": "uint32",
                    "description": "Rules are processed in order of this index field.",
                    "required": true
                },
                "name": {
                    "type": "string",
                    "description": "A name describing the rule in a short form."
                },
                "condition": {
                    "type": "message",
                    "messageType": "MatchTarget",
                    "description": "The condition to match.",
                    "required": true
                },
                "action": {
                    "type": "enum",
                    "enumType": "BotAction",
                    "description": "The action to take.",
                    "required": true
                }
            },
            "repeatedKey": "index"
        },
        "MatchTarget": {
            "fields": {
                "client_ip": {
                    "type": "message",
                    "messageType": "IpAddrMatch",
                    "description": "Configure client ip addresses"
                },
                "vs_port": {
                    "type": "message",
                    "messageType": "PortMatch",
                    "description": "Configure virtual service ports"
                },
                "protocol": {
                    "type": "message",
                    "messageType": "ProtocolMatch",
                    "description": "Configure the type of HTTP protocol"
                },
                "method": {
                    "type": "message",
                    "messageType": "MethodMatch",
                    "description": "Configure HTTP methods"
                },
                "version": {
                    "type": "message",
                    "messageType": "HTTPVersionMatch",
                    "description": "Configure versions of the HTTP protocol"
                },
                "path": {
                    "type": "message",
                    "messageType": "PathMatch",
                    "description": "Configure request paths"
                },
                "query": {
                    "type": "message",
                    "messageType": "QueryMatch",
                    "description": "Configure request query"
                },
                "hdrs": {
                    "type": "message",
                    "messageType": "HdrMatch",
                    "repeated": true,
                    "description": "Configure HTTP header(s). All configured headers must match."
                },
                "cookie": {
                    "type": "message",
                    "messageType": "CookieMatch",
                    "description": "Configure HTTP cookie(s)"
                },
                "host_hdr": {
                    "type": "message",
                    "messageType": "HostHdrMatch",
                    "description": "Configure the host header"
                },
                "ip_reputation_type": {
                    "type": "message",
                    "messageType": "IPReputationTypeMatch",
                    "description": "Configure IP reputation"
                },
                "geo_matches": {
                    "type": "message",
                    "messageType": "GeoMatch",
                    "repeated": true,
                    "description": "Configure the geo information",
                    "maxRepeatedLength": 1
                },
                "bot_detection_result": {
                    "type": "message",
                    "messageType": "BotDetectionMatch",
                    "description": "Configure the bot classification result"
                },
                "source_ip": {
                    "type": "message",
                    "messageType": "IpAddrMatch",
                    "description": "Configure source ip addresses."
                },
                "tls_fingerprint_match": {
                    "type": "message",
                    "messageType": "TlsFingerprintMatch",
                    "description": "Configure the TLS fingerprint."
                }
            }
        },
        "TlsFingerprintMatch": {
            "fields": {
                "match_operation": {
                    "type": "enum",
                    "enumType": "MatchOperation",
                    "description": "Match criteria.",
                    "required": true
                },
                "fingerprints": {
                    "type": "string",
                    "repeated": true,
                    "description": "The list of fingerprints.",
                    "maxStringLength": 32
                },
                "string_group_uuids": {
                    "type": "string",
                    "repeated": true,
                    "description": "UUIDs of the string groups.",
                    "maxStringLength": 128
                }
            }
        },
        "IpAddrMatch": {
            "fields": {
                "match_criteria": {
                    "type": "enum",
                    "enumType": "MatchOperation",
                    "required": true,
                    "description": "Criterion to use for IP address matching the HTTP request"
                },
                "addrs": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "repeated": true,
                    "description": "IP address(es)"
                },
                "ranges": {
                    "type": "message",
                    "messageType": "IpAddrRange",
                    "repeated": true,
                    "description": "IP address range(s)"
                },
                "prefixes": {
                    "type": "message",
                    "messageType": "IpAddrPrefix",
                    "repeated": true,
                    "description": "IP address prefix(es)"
                },
                "group_uuids": {
                    "type": "string",
                    "repeated": true,
                    "description": "UUID of IP address group(s)"
                }
            }
        },
        "BotDetectionMatch": {
            "fields": {
                "match_operation": {
                    "type": "enum",
                    "enumType": "MatchOperation",
                    "description": "Match criteria.",
                    "required": true
                },
                "classifications": {
                    "type": "message",
                    "messageType": "BotClassification",
                    "repeated": true,
                    "description": "Bot classification types."
                }
            }
        },
        "GeoMatch": {
            "fields": {
                "match_operation": {
                    "type": "enum",
                    "enumType": "MatchOperation",
                    "description": "Match criteria.",
                    "required": true
                },
                "attribute": {
                    "type": "enum",
                    "enumType": "GeoMappingAttribute",
                    "description": "The Geo data type to match on.",
                    "required": true
                },
                "values": {
                    "type": "string",
                    "repeated": true,
                    "description": "The values to match.",
                    "required": true
                }
            }
        },
        "IPReputationTypeMatch": {
            "fields": {
                "match_operation": {
                    "type": "enum",
                    "enumType": "MatchOperation",
                    "description": "Match criteria.",
                    "required": true
                },
                "reputation_types": {
                    "type": "enum",
                    "enumType": "IPReputationType",
                    "repeated": true,
                    "description": "IP reputation type.",
                    "minRepeatedLength": 1
                }
            }
        },
        "CookieMatch": {
            "fields": {
                "match_criteria": {
                    "type": "enum",
                    "enumType": "HdrMatchOperation",
                    "required": true,
                    "description": "Criterion to use for matching the cookie in the HTTP request"
                },
                "name": {
                    "type": "string",
                    "required": true,
                    "description": "Name of the cookie"
                },
                "match_case": {
                    "type": "enum",
                    "enumType": "MatchCase",
                    "default": "INSENSITIVE",
                    "description": "Case sensitivity to use for the match"
                },
                "value": {
                    "type": "string",
                    "description": "String value in the cookie"
                }
            }
        },
        "HdrMatch": {
            "fields": {
                "match_criteria": {
                    "type": "enum",
                    "enumType": "HdrMatchOperation",
                    "required": true,
                    "description": "Criterion to use for matching headers in the HTTP request"
                },
                "hdr": {
                    "type": "string",
                    "required": true,
                    "description": "Name of the HTTP header whose value is to be matched"
                },
                "match_case": {
                    "type": "enum",
                    "enumType": "MatchCase",
                    "default": "INSENSITIVE",
                    "description": "Case sensitivity to use for the match"
                },
                "value": {
                    "type": "string",
                    "repeated": true,
                    "description": "String values to match in the HTTP header"
                },
                "string_group_uuids": {
                    "type": "string",
                    "repeated": true,
                    "description": "UUID of the string group(s)",
                    "maxStringLength": 128
                }
            }
        },
        "QueryMatch": {
            "fields": {
                "match_criteria": {
                    "type": "enum",
                    "enumType": "QueryMatchOperation",
                    "required": true,
                    "description": "Criterion to use for matching the query in HTTP request URI"
                },
                "match_case": {
                    "type": "enum",
                    "enumType": "MatchCase",
                    "default": "INSENSITIVE",
                    "description": "Case sensitivity to use for the match"
                },
                "match_str": {
                    "type": "string",
                    "repeated": true,
                    "description": "String value(s)"
                },
                "string_group_uuids": {
                    "type": "string",
                    "repeated": true,
                    "description": "UUID of the string group(s)"
                },
                "match_decoded_string": {
                    "type": "bool",
                    "default": true,
                    "description": "Match against the decoded URI query."
                }
            }
        },
        "HTTPVersionMatch": {
            "fields": {
                "match_criteria": {
                    "type": "enum",
                    "enumType": "MatchOperation",
                    "required": true,
                    "description": "Criterion to use for HTTP version matching the version used in the HTTP request"
                },
                "versions": {
                    "type": "enum",
                    "enumType": "HTTPVersion",
                    "repeated": true,
                    "description": "HTTP protocol version",
                    "maxRepeatedLength": 8,
                    "minRepeatedLength": 1,
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "ONE_ZERO,ONE_ONE"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "ONE_ZERO,ONE_ONE"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                }
            }
        },
        "ProtocolMatch": {
            "fields": {
                "match_criteria": {
                    "type": "enum",
                    "enumType": "MatchOperation",
                    "required": true,
                    "description": "Criterion to use for protocol matching the HTTP request"
                },
                "protocols": {
                    "type": "enum",
                    "enumType": "HTTPProtocol",
                    "required": true,
                    "description": "HTTP or HTTPS protocol"
                }
            }
        },
        "PortMatch": {
            "fields": {
                "match_criteria": {
                    "type": "enum",
                    "enumType": "MatchOperation",
                    "required": true,
                    "description": "Criterion to use for port matching the HTTP request"
                },
                "ports": {
                    "type": "uint32",
                    "repeated": true,
                    "description": "Listening TCP port(s)",
                    "minRepeatedLength": 1,
                    "min": 1,
                    "max": 65535
                }
            }
        },
        "BotIPReputationTypeMapping": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "description": "A unique identifier of this mapping."
                },
                "tenant_uuid": {
                    "type": "string",
                    "description": "The unique identifier of the tenant to which this mapping belongs."
                },
                "name": {
                    "type": "string",
                    "description": "The name of this mapping.",
                    "maxStringLength": 256,
                    "required": true
                },
                "ip_reputation_mappings": {
                    "type": "message",
                    "messageType": "IPReputationTypeMapping",
                    "repeated": true,
                    "description": "Map every IPReputationType to a bot type (can be unknown)."
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                }
            }
        },
        "IPReputationTypeMapping": {
            "fields": {
                "ip_reputation_type": {
                    "type": "enum",
                    "enumType": "IPReputationType",
                    "description": "The type of IP reputation that is mapped to a Bot Identification.",
                    "required": true
                },
                "bot_identification": {
                    "type": "message",
                    "messageType": "BotIdentification",
                    "description": "The Bot Identification to which the IP reputation type is mapped.",
                    "required": true
                }
            }
        },
        "BotMapping": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "description": "A unique identifier for this mapping."
                },
                "tenant_uuid": {
                    "type": "string",
                    "description": "The unique identifier of the tenant to which this mapping belongs."
                },
                "name": {
                    "type": "string",
                    "description": "The name of this mapping.",
                    "maxStringLength": 256,
                    "required": true
                },
                "mapping_rules": {
                    "type": "message",
                    "messageType": "BotMappingRule",
                    "repeated": true,
                    "description": "Rules for bot classification."
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                }
            }
        },
        "BotMappingRule": {
            "fields": {
                "index": {
                    "type": "uint32",
                    "description": "Rules are processed in order of this index field.",
                    "required": true
                },
                "name": {
                    "type": "string",
                    "description": "A name describing the rule in a short form.",
                    "maxStringLength": 256,
                    "required": true
                },
                "classification": {
                    "type": "message",
                    "messageType": "BotClassification",
                    "description": "The assigned classification for this client.",
                    "required": true
                },
                "match": {
                    "type": "message",
                    "messageType": "BotMappingRuleMatchTarget",
                    "description": "How to match the request: all the specified properties must be fulfilled.",
                    "required": true
                }
            },
            "repeatedKey": "index"
        },
        "BotMappingRuleMatchTarget": {
            "fields": {
                "component_matcher": {
                    "type": "enum",
                    "enumType": "BotDecisionComponent",
                    "description": "The component for which this mapping is used."
                },
                "class_matcher": {
                    "type": "message",
                    "messageType": "BotClassMatcher",
                    "description": "How to match the BotClientClass."
                },
                "type_matcher": {
                    "type": "message",
                    "messageType": "BotTypeMatcher",
                    "description": "How to match the BotClientType."
                },
                "identifier_matcher": {
                    "type": "message",
                    "messageType": "StringMatch",
                    "description": "The list of bot identifier names and how they're matched."
                },
                "client_ip": {
                    "type": "message",
                    "messageType": "IpAddrMatch",
                    "description": "Configure client ip addresses."
                },
                "method": {
                    "type": "message",
                    "messageType": "MethodMatch",
                    "description": "Configure HTTP methods."
                },
                "path": {
                    "type": "message",
                    "messageType": "PathMatch",
                    "description": "Configure request paths."
                },
                "hdrs": {
                    "type": "message",
                    "messageType": "HdrMatch",
                    "repeated": true,
                    "description": "Configure HTTP header(s). All configured headers must match."
                },
                "host_hdr": {
                    "type": "message",
                    "messageType": "HostHdrMatch",
                    "description": "Configure the host header."
                }
            }
        },
        "BotTypeMatcher": {
            "fields": {
                "op": {
                    "type": "enum",
                    "enumType": "MatchOperation",
                    "default": "IS_IN",
                    "description": "The match operation."
                },
                "client_types": {
                    "type": "enum",
                    "enumType": "BotClientType",
                    "repeated": true,
                    "description": "The list of client types.",
                    "minRepeatedLength": 1
                }
            }
        },
        "BotClassMatcher": {
            "fields": {
                "op": {
                    "type": "enum",
                    "enumType": "MatchOperation",
                    "default": "IS_IN",
                    "description": "The match operation."
                },
                "client_classes": {
                    "type": "enum",
                    "enumType": "BotClientClass",
                    "repeated": true,
                    "description": "The list of client classes.",
                    "minRepeatedLength": 1
                }
            }
        },
        "CaptureFileSize": {
            "fields": {
                "absolute_size": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Maximum size in MB. Set 0 for avi default size.",
                    "min": 100,
                    "max": 512000,
                    "specialValues": {
                        "0": "AVI_DEFAULT"
                    }
                },
                "percentage_size": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Limits capture to percentage of free disk space. Set 0 for avi default size.",
                    "min": 0,
                    "max": 75
                }
            }
        },
        "CertificateManagementProfile": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "required": true
                },
                "name": {
                    "type": "string",
                    "required": true,
                    "description": "Name of the PKI Profile",
                    "maxStringLength": 256
                },
                "script_params": {
                    "type": "message",
                    "messageType": "CustomParams",
                    "repeated": true
                },
                "run_script_uuid": {
                    "type": "string",
                    "description": "Alert script config object for certificate management profile.",
                    "required": true
                },
                "markers": {
                    "type": "message",
                    "messageType": "RoleFilterMatchLabel",
                    "repeated": true,
                    "description": "List of labels to be used for granular RBAC.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "tenant_uuid": {
                    "type": "string",
                    "required": true
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                }
            }
        },
        "CustomParams": {
            "fields": {
                "name": {
                    "type": "string",
                    "required": true
                },
                "value": {
                    "type": "string"
                },
                "is_sensitive": {
                    "type": "bool",
                    "default": false
                },
                "is_dynamic": {
                    "type": "bool",
                    "default": false
                }
            }
        },
        "ClientLogStreamingFormat": {
            "fields": {
                "format": {
                    "type": "enum",
                    "enumType": "LogStreamingFormatType",
                    "description": "Format for the streamed logs",
                    "required": true
                },
                "included_fields": {
                    "type": "string",
                    "repeated": true,
                    "description": "List of log fields to be streamed, when selective fields (LOG_STREAMING_FORMAT_JSON_SELECTED) option is chosen. Only top-level fields in application or connection logs are supported."
                }
            }
        },
        "Cloud": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "required": true
                },
                "name": {
                    "type": "string",
                    "required": true,
                    "maxStringLength": 256
                },
                "vtype": {
                    "type": "enum",
                    "enumType": "CloudType",
                    "default": "CLOUD_NONE",
                    "required": true,
                    "description": "Cloud type",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "CLOUD_NONE,CLOUD_VCENTER"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "CLOUD_NONE,CLOUD_NSXT"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "vcenter_configuration": {
                    "type": "message",
                    "messageType": "vCenterConfiguration",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "aws_configuration": {
                    "type": "message",
                    "messageType": "AwsConfiguration",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "cloudstack_configuration": {
                    "type": "message",
                    "messageType": "CloudStackConfiguration",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "vca_configuration": {
                    "type": "message",
                    "messageType": "vCloudAirConfiguration",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "proxy_configuration": {
                    "type": "message",
                    "messageType": "ProxyConfiguration",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "linuxserver_configuration": {
                    "type": "message",
                    "messageType": "LinuxServerConfiguration",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "docker_configuration": {
                    "type": "message",
                    "messageType": "DockerConfiguration",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "rancher_configuration": {
                    "type": "message",
                    "messageType": "RancherConfiguration",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "azure_configuration": {
                    "type": "message",
                    "messageType": "AzureConfiguration",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "gcp_configuration": {
                    "type": "message",
                    "messageType": "GCPConfiguration",
                    "description": "Google Cloud Platform Configuration",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "nsxt_configuration": {
                    "type": "message",
                    "messageType": "NsxtConfiguration",
                    "description": "NSX-T Cloud Platform Configuration",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "dhcp_enabled": {
                    "type": "bool",
                    "default": true,
                    "description": "Select the IP address management scheme"
                },
                "mtu": {
                    "type": "uint32",
                    "default": 1500,
                    "description": "MTU setting for the cloud"
                },
                "prefer_static_routes": {
                    "type": "bool",
                    "default": false,
                    "description": "Prefer static routes over interface routes during VirtualService placement."
                },
                "enable_vip_static_routes": {
                    "type": "bool",
                    "default": false,
                    "description": "Use static routes for VIP side network resolution during VirtualService placement."
                },
                "obj_name_prefix": {
                    "type": "string",
                    "description": "Default prefix for all automatically created objects in this cloud. "
                },
                "license_type": {
                    "type": "enum",
                    "enumType": "LicenseType",
                    "description": "If no license type is specified then default license enforcement for the cloud type is chosen. The default mappings are Container Cloud is Max Ses, OpenStack and VMware is cores and linux it is Sockets."
                },
                "ipam_provider_uuid": {
                    "type": "string",
                    "description": "Ipam Profile for the cloud."
                },
                "dns_provider_uuid": {
                    "type": "string",
                    "description": "DNS Profile for the cloud.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "east_west_ipam_provider_uuid": {
                    "type": "string",
                    "description": "Ipam Profile for East-West services. Warning - Please use virtual subnets in this IPAM profile that do not conflict with the underlay networks or any overlay networks in the cluster. For example in AWS and GCP, 169.254.0.0/16 is used for storing instance metadata. Hence, it should not be used in this profile.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "east_west_dns_provider_uuid": {
                    "type": "string",
                    "description": "DNS Profile for East-West services.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "custom_tags": {
                    "type": "message",
                    "messageType": "CustomTag",
                    "repeated": true,
                    "description": "Custom tags for all Avi created resources in the cloud infrastructure."
                },
                "state_based_dns_registration": {
                    "type": "bool",
                    "default": true,
                    "description": "DNS records for VIPs are added/deleted based on the operational state of the VIPs.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "true"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "true"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "ip6_autocfg_enabled": {
                    "type": "bool",
                    "default": true,
                    "description": "Enable IPv6 auto configuration"
                },
                "dns_resolution_on_se": {
                    "type": "bool",
                    "default": false,
                    "description": "By default, pool member FQDNs are resolved on the Controller. When this is set, pool member FQDNs are instead resolved on Service Engines in this cloud. This is useful in scenarios where pool member FQDNs can only be resolved from Service Engines and not from the Controller.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "enable_vip_on_all_interfaces": {
                    "type": "bool",
                    "default": false,
                    "description": "Enable VIP on all data interfaces for the Cloud."
                },
                "maintenance_mode": {
                    "type": "bool",
                    "default": false,
                    "description": "Cloud is in maintenance mode."
                },
                "resolve_fqdn_to_ipv6": {
                    "type": "bool",
                    "default": false,
                    "description": "Resolve IPv6 address for pool member FQDNs."
                },
                "mgmt_ip_v4_enabled": {
                    "type": "bool",
                    "default": true,
                    "description": "Enable IPv4 on the Management interface of the ServiceEngine. Defaults to dhcp if no static config on Network present."
                },
                "mgmt_ip_v6_enabled": {
                    "type": "bool",
                    "default": true,
                    "description": "Enable IPv6 on the Management interface of the ServiceEngine. Defaults to autocfg if no static config on Network present."
                },
                "tenant_uuid": {
                    "type": "string",
                    "required": true
                },
                "license_tier": {
                    "type": "enum",
                    "enumType": "LicenseTierType",
                    "description": "Specifies the default license tier which would be used by new SE Groups. This field by default inherits the value from system configuration."
                },
                "autoscale_polling_interval": {
                    "type": "uint32",
                    "default": 60,
                    "description": "CloudConnector polling interval in seconds for external autoscale groups, minimum 60 seconds.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "60"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "60"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 60,
                    "max": 3600
                },
                "se_group_template_uuid": {
                    "type": "string",
                    "description": "The Service Engine Group to use as template."
                },
                "vmc_deployment": {
                    "type": "bool",
                    "default": false,
                    "description": "This deployment is VMware on AWS cloud."
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                },
                "dns_resolvers": {
                    "type": "message",
                    "messageType": "DnsResolver",
                    "repeated": true,
                    "description": "DNS resolver for the cloud.",
                    "maxRepeatedLength": 1
                },
                "markers": {
                    "type": "message",
                    "messageType": "RoleFilterMatchLabel",
                    "repeated": true,
                    "description": "List of labels to be used for granular RBAC.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "metrics_polling_interval": {
                    "type": "uint32",
                    "default": 300,
                    "description": "Cloud metrics collector polling interval in seconds.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "ntp_configuration": {
                    "type": "message",
                    "messageType": "NTPConfiguration",
                    "description": "NTP Configuration for the cloud."
                },
                "disable_metrics_polling": {
                    "type": "bool",
                    "default": false,
                    "description": "To disable metrics collection."
                }
            }
        },
        "NTPConfiguration": {
            "fields": {
                "ntp_server_list": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "repeated": true,
                    "description": "List of NTP server FQDNs or IP(v4/v6) addresses"
                },
                "ntp_authentication_keys": {
                    "type": "message",
                    "messageType": "NTPAuthenticationKey",
                    "repeated": true,
                    "description": "NTP Authentication keys"
                },
                "ntp_servers": {
                    "type": "message",
                    "messageType": "NTPServer",
                    "repeated": true,
                    "description": "List of NTP Servers"
                }
            }
        },
        "NTPServer": {
            "fields": {
                "server": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "description": "IP Address of the NTP Server",
                    "required": true
                },
                "key_number": {
                    "type": "uint32",
                    "description": "Key number from the list of trusted keys used to authenticate this server",
                    "min": 1,
                    "max": 65534
                }
            }
        },
        "NTPAuthenticationKey": {
            "fields": {
                "key_number": {
                    "type": "uint32",
                    "description": "Key number to be assigned to the authentication-key.",
                    "required": true,
                    "min": 1,
                    "max": 65534
                },
                "algorithm": {
                    "type": "enum",
                    "enumType": "NTPAuthAlgorithm",
                    "default": "NTP_AUTH_ALGORITHM_MD5",
                    "description": "Message Digest Algorithm used for NTP authentication. Default is NTP_AUTH_ALGORITHM_MD5"
                },
                "key": {
                    "type": "string",
                    "description": "NTP Authentication key",
                    "required": true
                }
            },
            "repeatedKey": "key_number"
        },
        "DnsResolver": {
            "fields": {
                "resolver_name": {
                    "type": "string",
                    "description": "Unique name for resolver config.",
                    "maxStringLength": 128,
                    "required": true
                },
                "nameserver_ips": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "repeated": true,
                    "description": "Name server IPv4 addresses",
                    "maxRepeatedLength": 10,
                    "minRepeatedLength": 1
                },
                "fixed_ttl": {
                    "type": "uint32",
                    "description": "If configured, this value used for refreshing the DNS entries.Overrides both received_ttl and min_ttl. The entries are refreshed only on fixed_ttleven when received_ttl is less than fixed_ttl.",
                    "min": 5,
                    "max": 2147483647
                },
                "min_ttl": {
                    "type": "uint32",
                    "default": 5,
                    "description": "If configured, the min_ttl overrides the ttl from responses when ttl < min_ttl,effectively ttl = max(recieved_ttl, min_ttl)",
                    "min": 5,
                    "max": 2147483647
                },
                "use_mgmt": {
                    "type": "bool",
                    "default": false,
                    "description": "If enabled, DNS resolution is performed via management network."
                }
            },
            "repeatedKey": "resolver_name"
        },
        "CustomTag": {
            "fields": {
                "tag_key": {
                    "type": "string",
                    "required": true
                },
                "tag_val": {
                    "type": "string"
                }
            }
        },
        "NsxtConfiguration": {
            "fields": {
                "nsxt_url": {
                    "type": "string",
                    "description": "NSX-T manager hostname or IP address. URL changes are allowed only between IP and FQDN formats that resolve to the same NSX-T manager."
                },
                "nsxt_credentials_uuid": {
                    "type": "string",
                    "description": "Credentials to access NSX-T manager"
                },
                "site_id": {
                    "type": "string",
                    "default": "default",
                    "description": "Site where transport zone belongs to."
                },
                "enforcementpoint_id": {
                    "type": "string",
                    "default": "default",
                    "description": "Enforcement point is where the rules of a policy to apply."
                },
                "domain_id": {
                    "type": "string",
                    "default": "default",
                    "description": "Domain where NSGroup objects belongs to."
                },
                "automate_dfw_rules": {
                    "type": "bool",
                    "default": false,
                    "description": "Automatically create DFW rules for VirtualService in NSX-T Manager.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "management_network_config": {
                    "type": "message",
                    "messageType": "ManagementNetworkConfig",
                    "description": "Management network configuration for Avi Service Engines.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "data_network_config": {
                    "type": "message",
                    "messageType": "DataNetworkConfig",
                    "description": "Data network configuration for Avi Service Engines.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "vpc_mode": {
                    "type": "bool",
                    "description": "VPC Mode.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "vmc_mode": {
                    "type": "bool",
                    "default": false,
                    "description": "VMC mode."
                },
                "automate_dfw_objects": {
                    "type": "bool",
                    "default": true,
                    "description": "Automatically create/delete DFW objects such as NSGroups and NSServices in NSX-T Manager."
                },
                "verify_certificate": {
                    "type": "bool",
                    "default": false,
                    "description": "Flag is used to indicate whether TLS certificate verificationbe done when establishing a connection to a vCenter and NSX-T Manager."
                },
                "streamline_dfw_objects": {
                    "type": "bool",
                    "default": true,
                    "description": "Flag to identify the DFW scheme implemented by cloud connector,  If enabled, the DFW scheme will group and reduce the number of DFW objects created on NSX. The objects will be grouped per Tier-1/Segment"
                },
                "onboard_avi_into_nsx": {
                    "type": "bool",
                    "default": false,
                    "description": "Enable to automatically register the Avi Controller with NSX-T Manager. This triggers the NSX onboarding workflow API to configure the ALB cluster and create an enforcement point. Note: This flag must be enabled on exactly one NSX-T Cloud to avoid conflicts."
                },
                "auto_import_nsx_projects": {
                    "type": "bool",
                    "default": true,
                    "description": "Set this flag to true to enable automatic import of NSX projects into Avi.This flag is only applicable when VPC mode is enabled for this cloud; it is ignored when VPC mode is disabled.NSX projects under VCF-A management are excluded from this automatic import process, as VCF-A creates these projects in Avi through its own integration workflow."
                }
            }
        },
        "DataNetworkConfig": {
            "fields": {
                "tz_type": {
                    "type": "enum",
                    "enumType": "NsxtTransportZoneType",
                    "description": "Data transport zone type overlay or vlan.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "transport_zone": {
                    "type": "string",
                    "description": "Data transport zone path for Avi Service Engines. Example- /infra/sites/default/enforcement-points/default/transport-zones/xxx-xxx-xxxx.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "vlan_segments": {
                    "type": "string",
                    "repeated": true,
                    "description": "Data vlan segments path to use for Avi Service Engines. Example- /infra/segments/vlanls. This should be set only when transport zone is of type VLAN."
                },
                "tier1_segment_config": {
                    "type": "message",
                    "messageType": "NsxtTier1SegmentConfig",
                    "description": "Nsxt tier1 segment configuration for Avi Service Engine data path. This should be set only when transport zone is of type OVERLAY.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                }
            }
        },
        "NsxtTier1SegmentConfig": {
            "fields": {
                "segment_config_mode": {
                    "type": "enum",
                    "enumType": "NsxtTier1SegmentConfigMode",
                    "default": "TIER1_SEGMENT_MANUAL",
                    "description": "Config Mode for selecting the placement logical segments for Avi ServiceEngine data path",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "TIER1_SEGMENT_MANUAL"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "required": true
                },
                "manual": {
                    "type": "message",
                    "messageType": "NsxtTier1SegmentManualMode",
                    "description": "Avi Admin selects an available logical segment (created by NSX-T admin) associated with a Tier-1 LR."
                },
                "automatic": {
                    "type": "message",
                    "messageType": "NsxtTier1SegmentAutomaticMode",
                    "description": "Avi controller creates and manages logical segments for a Tier-1 LR.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                }
            }
        },
        "NsxtTier1SegmentAutomaticMode": {
            "fields": {
                "tier1_lr_ids": {
                    "type": "string",
                    "repeated": true,
                    "description": "Tier1 logical router IDs",
                    "minRepeatedLength": 1
                },
                "nsxt_segment_subnet": {
                    "type": "message",
                    "messageType": "IpAddrPrefix",
                    "description": "Uber IP subnet for the logical segments created automatically by Avi controller.",
                    "required": true
                },
                "num_se_per_segment": {
                    "type": "uint32",
                    "default": 16,
                    "description": "The number of SE data vNic's that can be connected to the Avi logical segment."
                }
            }
        },
        "NsxtTier1SegmentManualMode": {
            "fields": {
                "tier1_lrs": {
                    "type": "message",
                    "messageType": "Tier1LogicalRouterInfo",
                    "repeated": true,
                    "description": "Tier1 logical router placement information.",
                    "minRepeatedLength": 1
                }
            }
        },
        "ManagementNetworkConfig": {
            "fields": {
                "tz_type": {
                    "type": "enum",
                    "enumType": "NsxtTransportZoneType",
                    "description": "Management transport zone type overlay or vlan.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ],
                    "required": true
                },
                "transport_zone": {
                    "type": "string",
                    "description": "Management transport zone path for Avi Service Engines. Example- /infra/sites/default/enforcement-points/default/transport-zones/xxx-xxx-xxxx.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ],
                    "required": true
                },
                "vlan_segment": {
                    "type": "string",
                    "description": "Management vlan segment path to use for Avi Service Engines. Example- /infra/segments/vlanls. This should be set only when transport zone is of type VLAN."
                },
                "overlay_segment": {
                    "type": "message",
                    "messageType": "Tier1LogicalRouterInfo",
                    "description": "Management overlay segment to use for Avi Service Engines. This should be set only when transport zone is of type OVERLAY.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                }
            }
        },
        "Tier1LogicalRouterInfo": {
            "fields": {
                "tier1_lr_id": {
                    "type": "string",
                    "description": "Tier1 logical router path. Example- /infra/tier-1s/T1-01.",
                    "required": true
                },
                "segment_id": {
                    "type": "string",
                    "description": "Overlay segment path. Example- /infra/segments/Seg-Web-T1-01."
                },
                "locale_service": {
                    "type": "string",
                    "description": "Locale-services configuration, holds T1 edge-cluster information. When VirtualService is enabled with preserve client IP, ServiceInsertion VirtualEndpoint will be created in this locale-service. By default Avi controller picks default locale-service on T1. If more than one locale-services are present, this will be used for resolving the same. Example locale-service path - /infra/tier-1s/London_Tier1Gateway1/locale-services/London_Tier1LocalServices-1.",
                    "maxStringLength": 1024
                }
            },
            "repeatedKey": "tier1_lr_id"
        },
        "GCPConfiguration": {
            "fields": {
                "cloud_credentials_uuid": {
                    "type": "string",
                    "description": "Credentials to access Google Cloud Platform APIs"
                },
                "region_name": {
                    "type": "string",
                    "description": "Google Cloud Platform Region Name where Service Engines will be spawned.",
                    "required": true
                },
                "zones": {
                    "type": "string",
                    "repeated": true,
                    "description": "Google Cloud Platform Zones where Service Engines will be distributed for HA.",
                    "minRepeatedLength": 1,
                    "required": true
                },
                "se_project_id": {
                    "type": "string",
                    "description": "Google Cloud Platform Project ID where Service Engines will be spawned.",
                    "required": true
                },
                "network_config": {
                    "type": "message",
                    "messageType": "GCPNetworkConfig",
                    "description": "Google Cloud Platform VPC Network configuration for the Service Engines.",
                    "required": true
                },
                "firewall_target_tags": {
                    "type": "string",
                    "repeated": true,
                    "description": "Firewall rule network target tags which will be applied on Service Engines to allow ingress and egress traffic for Service Engines."
                },
                "gcs_project_id": {
                    "type": "string",
                    "description": "Google Cloud Storage Project ID where Service Engine image will be uploaded. This image will be deleted once the image is created in Google compute images. By default, Service Engine Project ID will be used."
                },
                "gcs_bucket_name": {
                    "type": "string",
                    "description": "Google Cloud Storage Bucket Name where Service Engine image will be uploaded. This image will be deleted once the image is created in Google compute images. By default, a bucket will be created if this field is not specified."
                },
                "vip_allocation_strategy": {
                    "type": "message",
                    "messageType": "GCPVIPAllocation",
                    "description": "VIP allocation strategy defines how the VIPs will be created in Google Cloud.",
                    "required": true
                },
                "encryption_keys": {
                    "type": "message",
                    "messageType": "GCPEncryptionKeys",
                    "description": "Encryption Keys for Google Cloud Services."
                },
                "gcp_service_account_email": {
                    "type": "string",
                    "description": "Email of GCP Service Account to be associated to the Service Engines.",
                    "maxStringLength": 255
                }
            }
        },
        "GCPNetworkConfig": {
            "fields": {
                "config": {
                    "type": "enum",
                    "enumType": "GCPNetworkConfigMode",
                    "description": "Config Mode for Google Cloud network configuration",
                    "required": true
                },
                "inband": {
                    "type": "message",
                    "messageType": "GCPInBandManagement",
                    "description": "Configure InBand Management as Google Cloud network configuration. In this configuration the data network and management network for Service Engines will be same."
                },
                "one_arm": {
                    "type": "message",
                    "messageType": "GCPOneArmMode",
                    "description": "Configure One Arm Mode as Google Cloud network configuration. In this configuration the data network and the management network for the Service Engines will be separated."
                },
                "two_arm": {
                    "type": "message",
                    "messageType": "GCPTwoArmMode",
                    "description": "Configure Two Arm Mode as Google Cloud network configuration. In this configuration the frontend data network, backend data network and the management network for the Service Engines will be separated."
                }
            }
        },
        "GCPTwoArmMode": {
            "fields": {
                "frontend_data_vpc_subnet_name": {
                    "type": "string",
                    "description": "Service Engine Frontend Data Network Subnet Name.",
                    "required": true
                },
                "frontend_data_vpc_project_id": {
                    "type": "string",
                    "description": "Project ID of the Service Engine Frontend Data Network. By default, Service Engine Project ID will be used."
                },
                "management_vpc_subnet_name": {
                    "type": "string",
                    "description": "Service Engine Management Network Subnet Name.",
                    "required": true
                },
                "backend_data_vpc_subnet_name": {
                    "type": "string",
                    "description": "Service Engine Backend Data Network Subnet Name.",
                    "required": true
                },
                "frontend_data_vpc_network_name": {
                    "type": "string",
                    "description": "Service Engine Frontend Data Network Name.",
                    "required": true
                },
                "management_vpc_network_name": {
                    "type": "string",
                    "description": "Service Engine Management Network Name.",
                    "required": true
                },
                "backend_data_vpc_network_name": {
                    "type": "string",
                    "description": "Service Engine Backend Data Network Name.",
                    "required": true
                },
                "management_vpc_project_id": {
                    "type": "string",
                    "description": "Project ID of the Service Engine Management Network. By default, Service Engine Project ID will be used."
                },
                "backend_data_vpc_project_id": {
                    "type": "string",
                    "description": "Project ID of the Service Engine Backend Data Network. By default, Service Engine Project ID will be used."
                }
            }
        },
        "GCPOneArmMode": {
            "fields": {
                "data_vpc_subnet_name": {
                    "type": "string",
                    "description": "Service Engine Data Network Subnet Name.",
                    "required": true
                },
                "data_vpc_project_id": {
                    "type": "string",
                    "description": "Project ID of the Service Engine Data Network. By default, Service Engine Project ID will be used."
                },
                "management_vpc_subnet_name": {
                    "type": "string",
                    "description": "Service Engine Management Network Subnet Name.",
                    "required": true
                },
                "data_vpc_network_name": {
                    "type": "string",
                    "description": "Service Engine Data Network Name.",
                    "required": true
                },
                "management_vpc_network_name": {
                    "type": "string",
                    "description": "Service Engine Management Network Name.",
                    "required": true
                },
                "management_vpc_project_id": {
                    "type": "string",
                    "description": "Project ID of the Service Engine Management Network. By default, Service Engine Project ID will be used."
                }
            }
        },
        "GCPInBandManagement": {
            "fields": {
                "vpc_subnet_name": {
                    "type": "string",
                    "description": "Service Engine Network Subnet Name.",
                    "required": true
                },
                "vpc_project_id": {
                    "type": "string",
                    "description": "Project ID of the Service Engine Network. By default, Service Engine Project ID will be used."
                },
                "vpc_network_name": {
                    "type": "string",
                    "description": "Service Engine Network Name.",
                    "required": true
                }
            }
        },
        "AzureConfiguration": {
            "fields": {
                "subscription_id": {
                    "type": "string",
                    "description": "Subscription Id for the Azure subscription"
                },
                "cloud_credentials_uuid": {
                    "type": "string",
                    "description": "Credentials to access azure cloud"
                },
                "location": {
                    "type": "string",
                    "description": "Azure location where this cloud will be located"
                },
                "network_info": {
                    "type": "message",
                    "messageType": "AzureNetworkInfo",
                    "repeated": true,
                    "description": "Azure virtual network and subnet information",
                    "maxRepeatedLength": 1,
                    "minRepeatedLength": 1
                },
                "resource_group": {
                    "type": "string",
                    "description": "Azure resource group dedicated for Avi Controller. Avi Controller will create all its resources in this resource group."
                },
                "use_azure_dns": {
                    "type": "bool",
                    "default": false,
                    "description": "Azure is the DNS provider"
                },
                "use_enhanced_ha": {
                    "type": "bool",
                    "default": false,
                    "description": "Use Azure's enhanced HA features. This needs a public IP to be associated with the VIP. "
                },
                "use_managed_disks": {
                    "type": "bool",
                    "default": true,
                    "description": "Use Azure managed disks for SE storage"
                },
                "availability_zones": {
                    "type": "string",
                    "repeated": true,
                    "description": "Availability zones to be used in Azure"
                },
                "use_standard_alb": {
                    "type": "bool",
                    "default": true,
                    "description": "Use Standard SKU Azure Load Balancer. By default Standard SKU Load Balancer is used."
                },
                "des_id": {
                    "type": "string",
                    "description": "Disks Encryption Set resource-id (des_id) to encrypt se image and managed disk using customer-managed-keys."
                },
                "se_storage_account": {
                    "type": "string",
                    "description": "Storage Account to be used for uploading SE VHD images to Azure. Must include the resource group name. Format '<resource-group>:<storage-account-name>'.",
                    "maxStringLength": 128
                }
            }
        },
        "AzureNetworkInfo": {
            "fields": {
                "virtual_network_id": {
                    "type": "string",
                    "description": "Virtual network where Virtual IPs will belong."
                },
                "se_network_id": {
                    "type": "string",
                    "description": "Id of the Azure subnet where Avi Controller will create the Service Engines. "
                },
                "management_network_id": {
                    "type": "string",
                    "description": "Id of the Azure subnet used as management network for the Service Engines. If set, Service Engines will have a dedicated management NIC, otherwise, they operate in inband mode."
                }
            }
        },
        "DockerConfiguration": {
            "fields": {
                "ucp_nodes": {
                    "type": "string",
                    "repeated": true,
                    "description": "List of Docker UCP nodes; In case of a load balanced UCP cluster, use Virtual IP of the cluster"
                },
                "client_tls_key_and_certificate_uuid": {
                    "type": "string",
                    "description": "UUID of the client TLS cert and key"
                },
                "ca_tls_key_and_certificate_uuid": {
                    "type": "string",
                    "description": "UUID of the UCP CA TLS cert and key"
                },
                "container_port_match_http_service": {
                    "type": "bool",
                    "default": true,
                    "description": "Perform container port matching to create a HTTP Virtualservice instead of a TCP/UDP VirtualService"
                },
                "http_container_ports": {
                    "type": "uint32",
                    "repeated": true,
                    "description": "List of container ports that create a HTTP Virtualservice instead of a TCP/UDP VirtualService. Defaults to 80"
                },
                "east_west_placement_subnet": {
                    "type": "message",
                    "messageType": "IpAddrPrefix",
                    "description": "Match against this prefix when placing east-west VSs on SEs "
                },
                "se_deployment_method": {
                    "type": "enum",
                    "enumType": "SeCreateMethodContainer",
                    "default": "SE_CREATE_SSH",
                    "description": "Use Fleet/SSH for SE deployment"
                },
                "fleet_endpoint": {
                    "type": "string",
                    "description": "Optional fleet remote endpoint if fleet is used for SE deployment"
                },
                "docker_registry_se": {
                    "type": "message",
                    "messageType": "DockerRegistry",
                    "description": "Docker registry for ServiceEngine image"
                },
                "se_spawn_rate": {
                    "type": "uint32",
                    "default": 25,
                    "description": "New SE spawn rate per minute"
                },
                "app_sync_frequency": {
                    "type": "uint32",
                    "default": 60,
                    "description": "Sync frequency in seconds with frameworks"
                },
                "disable_auto_se_creation": {
                    "type": "bool",
                    "default": false,
                    "description": "Disable SE creation"
                },
                "disable_auto_frontend_service_sync": {
                    "type": "bool",
                    "default": false,
                    "description": "Disable auto service sync for front end services"
                },
                "disable_auto_backend_service_sync": {
                    "type": "bool",
                    "default": false,
                    "description": "Disable auto service sync for back end services"
                },
                "use_container_ip_port": {
                    "type": "bool",
                    "default": false,
                    "description": "Use container IP address:port for pool instead of host IP address:hostport. This mode is applicable if the container IP is reachable (not a private NATed IP) from other hosts in a routed environment for containers"
                },
                "se_volume": {
                    "type": "string",
                    "default": "/opt/avi",
                    "description": "Host volume to be used as a disk for Avi SE, This is a disruptive change"
                },
                "coredump_directory": {
                    "type": "string",
                    "default": "/var/lib/systemd/coredump",
                    "description": "Directory to mount to check for core dumps on Service Engines. This will be mapped read only to /var/crash on any new Service Engines. This is a disruptive change"
                },
                "enable_event_subscription": {
                    "type": "bool",
                    "default": true,
                    "description": "Enable Docker event subscription"
                },
                "feproxy_container_port_as_service": {
                    "type": "bool",
                    "default": false,
                    "description": "For Front End proxies, use container port as service port"
                },
                "services_accessible_all_interfaces": {
                    "type": "bool",
                    "default": false,
                    "description": "Make service ports accessible on all Host interfaces in addition to East-West VIP and/or bridge IP. Usually enabled AWS clusters to export East-West services on Host interface"
                },
                "feproxy_vips_enable_proxy_arp": {
                    "type": "bool",
                    "default": true,
                    "description": "Enable proxy ARP from Host interface for Front End  proxies"
                },
                "se_exclude_attributes": {
                    "type": "message",
                    "messageType": "MesosAttribute",
                    "repeated": true,
                    "description": "Exclude hosts with attributes for SE creation"
                },
                "se_include_attributes": {
                    "type": "message",
                    "messageType": "MesosAttribute",
                    "repeated": true,
                    "description": "Create SEs just on hosts with include attributes"
                },
                "use_controller_image": {
                    "type": "bool",
                    "default": false,
                    "description": "If true, use controller generated SE docker image via fileservice, else use docker repository image as defined by docker_registry_se"
                },
                "ssh_user_uuid": {
                    "type": "string",
                    "description": "Cloud connector user uuid for SSH to hosts"
                }
            }
        },
        "MesosAttribute": {
            "fields": {
                "attribute": {
                    "type": "string",
                    "required": true,
                    "description": "Attribute to match"
                },
                "value": {
                    "type": "string",
                    "description": "Attribute value. If not set, match any value"
                }
            },
            "repeatedKey": "attribute,value"
        },
        "DockerRegistry": {
            "fields": {
                "registry": {
                    "type": "string",
                    "default": "avinetworks/se",
                    "description": "Avi ServiceEngine repository name. For private registry, it's registry:port/repository, for public registry, it's registry/repository, for openshift registry, it's registry:port/namespace/repo"
                },
                "private": {
                    "type": "bool",
                    "default": false,
                    "description": "Set if docker registry is private. Avi controller will not attempt to push SE image to the registry, unless se_repository_push is set"
                },
                "username": {
                    "type": "string",
                    "description": "Username for docker registry. Authorized 'regular user' if registry is Openshift integrated registry."
                },
                "password": {
                    "type": "string",
                    "description": "Password for docker registry. Authorized 'regular user' password if registry is Openshift integrated registry."
                },
                "oshift_registry": {
                    "type": "message",
                    "messageType": "OshiftDockerRegistryMetaData",
                    "description": "Openshift integrated registry config."
                }
            }
        },
        "OshiftDockerRegistryMetaData": {
            "fields": {
                "registry_service": {
                    "type": "string",
                    "default": "docker-registry",
                    "description": "Name of the Integrated registry Service in Openshift."
                },
                "registry_namespace": {
                    "type": "string",
                    "default": "default",
                    "description": "Namespace for the ServiceEngine image to be hosted in Openshift Integrated registry."
                },
                "registry_vip": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "description": "Static VIP for 'docker-registry' service in Openshift if Avi is proxying for this service.This VIP should be outside the cluster IP subnet in Kubernetes and within the subnet configured (but outside the available pool of IPs) in the East West IPAM profile configuration for this Cloud. For example, if kubernetes cluster VIP range is 172.30.0.0/16 and subnet configured in East West IPAM profile is 172.50.0.0/16, then 172.50.0.2 can be used for this vip and IP pool can start from 172.50.0.3 onwards. Use this static VIP in '--insecure-registry <this-vip>:5000' docker config if using an insecure registry or add this to the list of IPs/hostnames when generating certificates if using a secure TLS registry."
                }
            }
        },
        "LinuxServerConfiguration": {
            "fields": {
                "hosts": {
                    "type": "message",
                    "messageType": "LinuxServerHost",
                    "repeated": true
                },
                "se_sys_disk_path": {
                    "type": "string",
                    "description": "SE System Logs disk path for cloud"
                },
                "se_sys_disk_size_GB": {
                    "type": "uint32",
                    "default": 10,
                    "description": "SE System Logs disk size for cloud"
                },
                "se_log_disk_path": {
                    "type": "string",
                    "description": "SE Client Logs disk path for cloud"
                },
                "se_log_disk_size_GB": {
                    "type": "uint32",
                    "default": 5,
                    "description": "SE Client Log disk size for cloud"
                },
                "se_inband_mgmt": {
                    "type": "bool",
                    "default": false,
                    "description": "Flag to notify the SE's in this cloud have an inband management interface, this can be overridden at SE host level by setting host_attr attr_key as SE_INBAND_MGMT with value of true or false"
                },
                "ssh_user_uuid": {
                    "type": "string",
                    "description": "Cloud connector user uuid for SSH to hosts"
                }
            }
        },
        "LinuxServerHost": {
            "fields": {
                "host_ip": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "required": true
                },
                "host_attr": {
                    "type": "message",
                    "messageType": "HostAttributes",
                    "repeated": true
                },
                "node_availability_zone": {
                    "type": "string",
                    "description": "Node's availability zone. ServiceEngines belonging to the availability zone will be rebooted during a manual DR failover"
                },
                "se_group_uuid": {
                    "type": "string",
                    "description": "The SE Group association for the SE. If None, then 'Default-Group' SEGroup is associated with the SE"
                }
            },
            "repeatedKey": "host_ip"
        },
        "HostAttributes": {
            "fields": {
                "attr_key": {
                    "type": "string",
                    "required": true
                },
                "attr_val": {
                    "type": "string"
                }
            }
        },
        "vCloudAirConfiguration": {
            "fields": {
                "vca_username": {
                    "type": "string",
                    "required": true,
                    "description": "vCloudAir username"
                },
                "vca_password": {
                    "type": "string",
                    "required": true,
                    "description": "vCloudAir password"
                },
                "vca_host": {
                    "type": "string",
                    "required": true,
                    "description": "vCloudAir host address"
                },
                "privilege": {
                    "type": "enum",
                    "enumType": "Privilege",
                    "default": "WRITE_ACCESS",
                    "required": true,
                    "description": "vCloudAir access mode"
                },
                "vca_instance": {
                    "type": "string",
                    "required": true,
                    "description": "vCloudAir instance ID"
                },
                "vca_orgnization": {
                    "type": "string",
                    "required": true,
                    "description": "vCloudAir orgnization ID"
                },
                "vca_vdc": {
                    "type": "string",
                    "required": true,
                    "description": "vCloudAir virtual data center name"
                },
                "vca_mgmt_network": {
                    "type": "string",
                    "required": true,
                    "description": "vCloudAir management network"
                }
            }
        },
        "AwsConfiguration": {
            "fields": {
                "access_key_id": {
                    "type": "string",
                    "description": "AWS access key ID"
                },
                "secret_access_key": {
                    "type": "string",
                    "description": "AWS secret access key"
                },
                "region": {
                    "type": "string",
                    "default": "us-west-1",
                    "description": "AWS region"
                },
                "vpc": {
                    "type": "string",
                    "description": "VPC name"
                },
                "vpc_id": {
                    "type": "string",
                    "required": true,
                    "description": "VPC ID"
                },
                "zones": {
                    "type": "message",
                    "messageType": "AwsZoneConfig",
                    "repeated": true
                },
                "route53_integration": {
                    "type": "bool",
                    "default": false,
                    "description": "If enabled, create/update DNS entries in Amazon Route 53 zones"
                },
                "free_elasticips": {
                    "type": "bool",
                    "default": true,
                    "description": "Free unused elastic IP addresses."
                },
                "use_iam_roles": {
                    "type": "bool",
                    "default": false,
                    "description": "Use IAM roles instead of access and secret key."
                },
                "iam_assume_role": {
                    "type": "string",
                    "description": "IAM assume role for cross-account access."
                },
                "ttl": {
                    "type": "uint32",
                    "default": 60,
                    "description": "Default TTL for all records",
                    "min": 1,
                    "max": 172800
                },
                "use_sns_sqs": {
                    "type": "bool",
                    "default": false,
                    "description": "Use SNS/SQS based notifications for monitoring Auto Scaling Groups."
                },
                "asg_poll_interval": {
                    "type": "uint32",
                    "default": 600,
                    "description": "Time interval between periodic polling of all Auto Scaling Groups.",
                    "min": 60,
                    "max": 1800
                },
                "ebs_encryption": {
                    "type": "message",
                    "messageType": "AwsEncryption",
                    "description": "EBS encryption mode and the master key to be used for encrypting SE AMI, Volumes, and Snapshots."
                },
                "s3_encryption": {
                    "type": "message",
                    "messageType": "AwsEncryption",
                    "description": "S3 encryption mode and the master key to be used for encrypting S3 buckets during SE AMI upload. Only SSE-KMS mode is supported."
                },
                "sqs_encryption": {
                    "type": "message",
                    "messageType": "AwsEncryption",
                    "description": "Server Side Encryption to be used for encrypting SQS Queues"
                },
                "publish_vip_to_public_zone": {
                    "type": "bool",
                    "default": false,
                    "description": "If enabled and the virtual service is not floating ip capable, vip will be published to both private and public zones."
                }
            }
        },
        "AwsEncryption": {
            "fields": {
                "mode": {
                    "type": "enum",
                    "enumType": "AwsEncryptionMode",
                    "default": "AWS_ENCRYPTION_MODE_NONE",
                    "description": "AWS encryption mode."
                },
                "master_key": {
                    "type": "string",
                    "description": "AWS KMS ARN ID of the master key for encryption."
                }
            }
        },
        "AwsZoneConfig": {
            "fields": {
                "availability_zone": {
                    "type": "string",
                    "required": true,
                    "description": "Availability zone"
                },
                "mgmt_network_name": {
                    "type": "string",
                    "required": true,
                    "description": "Name or CIDR of the network in the Availability Zone that will be used as management network."
                },
                "mgmt_network_uuid": {
                    "type": "string",
                    "description": "UUID of the network in the Availability Zone that will be used as management network."
                }
            }
        },
        "vCenterConfiguration": {
            "fields": {
                "username": {
                    "type": "string",
                    "description": "The username Avi Vantage will use when authenticating with vCenter."
                },
                "password": {
                    "type": "string",
                    "description": "The password Avi Vantage will use when authenticating with vCenter."
                },
                "vcenter_url": {
                    "type": "string",
                    "description": "vCenter hostname or IP address."
                },
                "privilege": {
                    "type": "enum",
                    "enumType": "Privilege",
                    "default": "WRITE_ACCESS",
                    "required": true,
                    "description": "Set the access mode to vCenter as either Read, which allows Avi to discover networks and servers, or Write, which also allows Avi to create Service Engines and configure their network properties."
                },
                "datacenter": {
                    "type": "string",
                    "description": "Datacenter for virtual infrastructure discovery"
                },
                "management_network": {
                    "type": "string",
                    "description": "Management network to use for Avi Service Engines"
                },
                "management_ip_subnet": {
                    "type": "message",
                    "messageType": "IpAddrPrefix",
                    "description": "Management subnet to use for Avi Service Engines"
                },
                "vcenter_template_se_location": {
                    "type": "string",
                    "description": "Avi Service Engine Template in vCenter to be used for creating Service Engines"
                },
                "use_content_lib": {
                    "type": "bool",
                    "default": true,
                    "description": "If false, Service Engine image will not be pushed to content library.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "content_lib": {
                    "type": "message",
                    "messageType": "ContentLibConfig",
                    "description": "vCenter content library where Service Engine images are stored."
                },
                "is_nsx_environment": {
                    "type": "bool",
                    "default": false,
                    "description": "If true, NSX-T segment spanning multiple VDS with vCenter cloud are merged to a single network in Avi."
                },
                "datacenter_managed_object_id": {
                    "type": "string",
                    "description": "Managed object id of the datacenter.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ],
                    "maxStringLength": 256
                },
                "verify_certificate": {
                    "type": "bool",
                    "default": false,
                    "description": "Flag is used to indicate whether TLS certificate verificationbe done when establishing a connection to a vCenter server"
                }
            }
        },
        "ContentLibConfig": {
            "fields": {
                "name": {
                    "type": "string",
                    "description": "Content Library name"
                },
                "id": {
                    "type": "string",
                    "description": "Content Library Id"
                }
            }
        },
        "CloudConnectorUser": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "required": true
                },
                "name": {
                    "type": "string",
                    "required": true,
                    "maxStringLength": 256
                },
                "private_key": {
                    "type": "string"
                },
                "public_key": {
                    "type": "string"
                },
                "password": {
                    "type": "string"
                },
                "azure_userpass": {
                    "type": "message",
                    "messageType": "AzureUserPassCredentials",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "azure_serviceprincipal": {
                    "type": "message",
                    "messageType": "AzureServicePrincipalCredentials",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "gcp_credentials": {
                    "type": "message",
                    "messageType": "GCPCredentials",
                    "description": "Credentials for Google Cloud Platform.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "tencent_credentials": {
                    "type": "message",
                    "messageType": "TencentCredentials",
                    "description": "Credentials for Tencent Cloud.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "nsxt_credentials": {
                    "type": "message",
                    "messageType": "NsxtCredentials",
                    "description": "Credentials to talk to NSX-T manager.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "vcenter_credentials": {
                    "type": "message",
                    "messageType": "VCenterCredentials",
                    "description": "Credentials to talk to VCenter."
                },
                "last_password_rotation": {
                    "type": "uint64",
                    "description": "Timestamp (Unix epoch in seconds) of last successful password rotation. Used to determine when next rotation is due based on cc_user_password_expiry_days."
                },
                "new_password_enc": {
                    "type": "string",
                    "description": "New password stored temporarily during rotation. Cleared after successful rotation.",
                    "maxStringLength": 512
                },
                "tenant_uuid": {
                    "type": "string",
                    "required": true
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                }
            }
        },
        "VCenterCredentials": {
            "fields": {
                "username": {
                    "type": "string",
                    "description": "Username to talk to VCenter server."
                },
                "password": {
                    "type": "string",
                    "description": "Password to talk to VCenter server."
                }
            }
        },
        "NsxtCredentials": {
            "fields": {
                "username": {
                    "type": "string",
                    "description": "Username to talk to Nsx-t manager."
                },
                "password": {
                    "type": "string",
                    "description": "Password to talk to Nsx-t manager."
                }
            }
        },
        "GCPCredentials": {
            "fields": {
                "service_account_keyfile_data": {
                    "type": "string",
                    "description": "Google Cloud Platform Service Account keyfile data in JSON format."
                }
            }
        },
        "AzureServicePrincipalCredentials": {
            "fields": {
                "application_id": {
                    "type": "string",
                    "description": "Application Id created for Avi Controller. Required for application id based authentication only."
                },
                "authentication_token": {
                    "type": "string",
                    "description": "Authentication token created for the Avi Controller application. Required for application id based authentication only."
                },
                "tenant_id": {
                    "type": "string",
                    "description": "Tenant ID for the subscription. Required for application id based authentication only."
                }
            }
        },
        "AzureUserPassCredentials": {
            "fields": {
                "username": {
                    "type": "string",
                    "description": "Username for Azure subscription. Required only for username password based authentication."
                },
                "password": {
                    "type": "string",
                    "description": "Password for Azure subscription. Required only if username is provided."
                },
                "tenant_name": {
                    "type": "string",
                    "description": "Tenant or the active directory associated with the subscription. Required for user name password authentication."
                }
            }
        },
        "Cluster": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "required": true
                },
                "name": {
                    "type": "string",
                    "required": true,
                    "maxStringLength": 256
                },
                "virtual_ip": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "description": "A V4 virtual IP address for the Cluster that always points to the V4 IP of the leader node in Cluster."
                },
                "nodes": {
                    "type": "message",
                    "messageType": "ClusterNode",
                    "repeated": true,
                    "maxRepeatedLength": 7,
                    "minRepeatedLength": 1
                },
                "rejoin_nodes_automatically": {
                    "type": "bool",
                    "default": true,
                    "description": "Re-join cluster nodes automatically in the event one of the node is reset to factory."
                },
                "virtual_ip6": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "description": "A V6 virtual IP address for the Cluster that always points to the V6 IP of the leader node in Cluster."
                },
                "tenant_uuid": {
                    "type": "string"
                }
            }
        },
        "ClusterNode": {
            "fields": {
                "name": {
                    "type": "string",
                    "default": "node"
                },
                "ip": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "description": "V4 IP address of controller VM."
                },
                "vm_uuid": {
                    "type": "string",
                    "description": "UUID on the controller VM"
                },
                "vm_name": {
                    "type": "string",
                    "description": "Name of the controller VM"
                },
                "vm_mor": {
                    "type": "string",
                    "description": "Managed object reference of this controller VM"
                },
                "vm_hostname": {
                    "type": "string",
                    "description": "Hostname assigned to this controller VM"
                },
                "public_ip_or_name": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "description": "Public IP address or hostname of the controller VM"
                },
                "categories": {
                    "type": "string",
                    "repeated": true,
                    "description": "Optional service categories that a node can be assigned (e.g. SYSTEM, INFRASTRUCTURE or ANALYTICS)"
                },
                "password": {
                    "type": "string",
                    "description": "The password we will use when authenticating with this node (Not persisted)"
                },
                "interfaces": {
                    "type": "message",
                    "messageType": "ControllerInterface",
                    "repeated": true,
                    "description": "Interface details of the controller node"
                },
                "static_routes": {
                    "type": "message",
                    "messageType": "StaticRoute",
                    "repeated": true,
                    "description": "Static routes configured on the controller node"
                },
                "ip6": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "description": "V6 IP address of controller VM."
                }
            }
        },
        "ControllerInterface": {
            "fields": {
                "if_name": {
                    "type": "string",
                    "description": "Interface name",
                    "maxStringLength": 64
                },
                "mac_address": {
                    "type": "string",
                    "description": "Mac address of interface",
                    "maxStringLength": 64
                },
                "mode": {
                    "type": "enum",
                    "enumType": "IpAddrMode",
                    "description": "IPv4 address mode DHCP/STATIC"
                },
                "ip": {
                    "type": "message",
                    "messageType": "IpAddrPrefix",
                    "description": "IPv4 prefix of the interface"
                },
                "gateway": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "description": "IPv4 default gateway of the interface"
                },
                "labels": {
                    "type": "enum",
                    "enumType": "InterfaceLabel",
                    "repeated": true,
                    "description": "Interface label like mgmt, secure channel or HSM"
                },
                "public_ip_or_name": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "description": "Public IP of interface"
                },
                "mode6": {
                    "type": "enum",
                    "enumType": "IpAddrMode",
                    "description": "IPv6 address mode STATIC"
                },
                "ip6": {
                    "type": "message",
                    "messageType": "IpAddrPrefix",
                    "description": "IPv6 prefix of the interface"
                },
                "gateway6": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "description": "IPv6 default gateway of the interface"
                },
                "v4_enabled": {
                    "type": "bool",
                    "description": "Enable V4 IP on this interface"
                },
                "v6_enabled": {
                    "type": "bool",
                    "description": "Enable V6 IP on this interface"
                }
            }
        },
        "ConnectionLog": {
            "fields": {
                "adf": {
                    "type": "bool",
                    "default": false,
                    "required": true
                },
                "significant": {
                    "type": "uint64",
                    "required": true
                },
                "significance": {
                    "type": "string"
                },
                "udf": {
                    "type": "bool",
                    "default": false,
                    "required": true
                },
                "virtualservice": {
                    "type": "string",
                    "required": true,
                    "maxStringLength": 64
                },
                "vs_ip": {
                    "type": "uint32"
                },
                "client_ip": {
                    "type": "uint32",
                    "required": true
                },
                "client_location": {
                    "type": "string"
                },
                "client_src_port": {
                    "type": "uint32",
                    "required": true
                },
                "client_dest_port": {
                    "type": "uint32",
                    "required": true
                },
                "start_timestamp": {
                    "type": "uint64",
                    "required": true
                },
                "report_timestamp": {
                    "type": "uint64",
                    "required": true
                },
                "total_time": {
                    "type": "uint64",
                    "default": 0
                },
                "connection_ended": {
                    "type": "bool",
                    "default": true,
                    "required": true
                },
                "client_rtt": {
                    "type": "uint32",
                    "required": true
                },
                "mss": {
                    "type": "uint32",
                    "default": 1500,
                    "required": true
                },
                "rx_bytes": {
                    "type": "uint64",
                    "required": true
                },
                "tx_bytes": {
                    "type": "uint64",
                    "required": true
                },
                "total_bytes": {
                    "type": "uint64",
                    "default": 0
                },
                "rx_pkts": {
                    "type": "uint64",
                    "required": true
                },
                "tx_pkts": {
                    "type": "uint64",
                    "required": true
                },
                "total_pkts": {
                    "type": "uint64",
                    "default": 0
                },
                "out_of_orders": {
                    "type": "uint32",
                    "default": 0,
                    "required": true
                },
                "retransmits": {
                    "type": "uint32",
                    "default": 0,
                    "required": true
                },
                "timeouts": {
                    "type": "uint32",
                    "default": 0,
                    "required": true
                },
                "zero_window_size_events": {
                    "type": "uint32",
                    "default": 0,
                    "required": true
                },
                "service_engine": {
                    "type": "string",
                    "maxStringLength": 64
                },
                "vcpu_id": {
                    "type": "uint32",
                    "required": true
                },
                "log_id": {
                    "type": "uint32",
                    "required": true
                },
                "network_security_policy_rule_name": {
                    "type": "string",
                    "maxStringLength": 32
                },
                "pool": {
                    "type": "string",
                    "maxStringLength": 64
                },
                "pool_name": {
                    "type": "string",
                    "maxStringLength": 32
                },
                "server_ip": {
                    "type": "uint32",
                    "required": true
                },
                "server_name": {
                    "type": "string",
                    "maxStringLength": 32
                },
                "server_conn_src_ip": {
                    "type": "uint32",
                    "required": true
                },
                "server_dest_port": {
                    "type": "uint32",
                    "required": true
                },
                "server_src_port": {
                    "type": "uint32",
                    "required": true
                },
                "server_rtt": {
                    "type": "uint32",
                    "required": true
                },
                "server_total_bytes": {
                    "type": "uint64",
                    "required": true
                },
                "server_rx_bytes": {
                    "type": "uint64",
                    "required": true
                },
                "server_tx_bytes": {
                    "type": "uint64",
                    "required": true
                },
                "server_total_pkts": {
                    "type": "uint64",
                    "required": true
                },
                "server_rx_pkts": {
                    "type": "uint64",
                    "required": true
                },
                "server_tx_pkts": {
                    "type": "uint64",
                    "required": true
                },
                "server_out_of_orders": {
                    "type": "uint32",
                    "default": 0,
                    "required": true
                },
                "server_retransmits": {
                    "type": "uint32",
                    "default": 0,
                    "required": true
                },
                "server_timeouts": {
                    "type": "uint32",
                    "default": 0,
                    "required": true
                },
                "server_zero_window_size_events": {
                    "type": "uint32",
                    "default": 0,
                    "required": true
                },
                "significant_log": {
                    "type": "enum",
                    "enumType": "AviDefinedFilters",
                    "repeated": true,
                    "description": "List of enums which indicate why a log is significant"
                },
                "num_transaction": {
                    "type": "uint32"
                },
                "average_turntime": {
                    "type": "uint32"
                },
                "num_window_shrink": {
                    "type": "uint32"
                },
                "server_num_window_shrink": {
                    "type": "uint32"
                },
                "num_syn_retransmit": {
                    "type": "uint32"
                },
                "microservice": {
                    "type": "string",
                    "maxStringLength": 128
                },
                "microservice_name": {
                    "type": "string",
                    "maxStringLength": 32
                },
                "proxy_protocol": {
                    "type": "enum",
                    "enumType": "ProxyProtocolVersion",
                    "description": "Version of proxy protocol used to convey client connection information to the back-end servers.  A value of 0 indicates that proxy protocol is not used.  A value of 1 or 2 indicates the version of proxy protocol used."
                },
                "ssl_session_id": {
                    "type": "string",
                    "maxStringLength": 32
                },
                "ssl_version": {
                    "type": "string",
                    "maxStringLength": 8
                },
                "ssl_cipher": {
                    "type": "string",
                    "maxStringLength": 32
                },
                "dns_fqdn": {
                    "type": "string",
                    "maxStringLength": 256
                },
                "dns_ips": {
                    "type": "uint32",
                    "repeated": true
                },
                "dns_qtype": {
                    "type": "enum",
                    "enumType": "DnsRecordType"
                },
                "gslbservice": {
                    "type": "string",
                    "maxStringLength": 128
                },
                "gslbservice_name": {
                    "type": "string",
                    "maxStringLength": 32
                },
                "gslbpool_name": {
                    "type": "string",
                    "maxStringLength": 32
                },
                "dns_response": {
                    "type": "message",
                    "messageType": "DnsResponse"
                },
                "dns_etype": {
                    "type": "enum",
                    "enumType": "DnsEntryType"
                },
                "protocol": {
                    "type": "enum",
                    "enumType": "Protocol"
                },
                "dns_request": {
                    "type": "message",
                    "messageType": "DnsRequest"
                },
                "client_ip6": {
                    "type": "Unknown",
                    "description": "IPv6 address of the client."
                },
                "vs_ip6": {
                    "type": "Unknown",
                    "description": "IPv6 address of the VIP of the VS."
                },
                "server_ip6": {
                    "type": "Unknown",
                    "description": "IPv6 address of the Backend Server."
                },
                "server_conn_src_ip6": {
                    "type": "Unknown",
                    "description": "IPv6 address used to connect to Backend Server."
                },
                "sni_hostname": {
                    "type": "string",
                    "maxStringLength": 256
                },
                "sip_log": {
                    "type": "message",
                    "messageType": "SipLog",
                    "description": "SIP related logging information"
                },
                "client_log_filter_name": {
                    "type": "string",
                    "description": "Name of the Client Log Filter applied",
                    "maxStringLength": 32
                },
                "ds_log": {
                    "type": "string",
                    "description": "Datascript Log",
                    "maxStringLength": 256
                },
                "persistence_used": {
                    "type": "bool",
                    "default": false,
                    "description": "Persistence applied during server selection"
                },
                "ocsp_status_resp_sent": {
                    "type": "bool",
                    "default": false,
                    "description": "OCSP Response sent in the SSL/TLS connection Handshake."
                },
                "max_ingress_latency_fe": {
                    "type": "uint32",
                    "description": "Maximum packet processing latency for the frontend flow."
                },
                "avg_ingress_latency_fe": {
                    "type": "uint32",
                    "description": "Average packet processing latency for the frontend flow."
                },
                "conn_est_time_fe": {
                    "type": "uint32",
                    "description": "TCP connection establishment time for the frontend flow."
                },
                "max_ingress_latency_be": {
                    "type": "uint32",
                    "description": "Maximum packet processing latency for the backend flow."
                },
                "avg_ingress_latency_be": {
                    "type": "uint32",
                    "description": "Average packet processing latency for the backend flow."
                },
                "conn_est_time_be": {
                    "type": "uint32",
                    "description": "TCP connection establishment time for the backend flow."
                },
                "dns_tcp_conn_close_from_se": {
                    "type": "bool",
                    "description": "Service engine closed the TCP connection after the first DNS response."
                },
                "diameter_log": {
                    "type": "message",
                    "messageType": "DiameterLog",
                    "description": "Diameter related logging information."
                },
                "dns_policy_rule_name": {
                    "type": "string",
                    "description": "DNS policy rule name which resulted in a match.",
                    "maxStringLength": 32
                },
                "topology_policy_rule_name": {
                    "type": "string",
                    "description": "Topology policy rule name which resulted in a match.",
                    "maxStringLength": 32
                },
                "dns_policy": {
                    "type": "string",
                    "description": "DNS policy or Topology policy name which resulted in a match.",
                    "maxStringLength": 32
                },
                "ssl_named_group": {
                    "type": "string",
                    "description": "SSl group negotitaed during SSL handhshake",
                    "maxStringLength": 128
                },
                "ssl_signature_algorithm": {
                    "type": "string",
                    "description": "SSL signature algorithm negotitaed during SSL handhshake",
                    "maxStringLength": 128
                }
            }
        },
        "DiameterLog": {
            "fields": {
                "command_code": {
                    "type": "uint32",
                    "description": "Field to indicate command associated with message."
                },
                "application_id": {
                    "type": "uint32",
                    "description": "Field to identify which application the message is applicable for."
                },
                "hop_by_hop_identifier": {
                    "type": "uint32",
                    "description": "Field to match requests and responses."
                },
                "end_to_end_identifier": {
                    "type": "uint32",
                    "description": "Field to detect duplicate messages."
                },
                "origin_host": {
                    "type": "string",
                    "description": "Field to identify endpoint that originated the message.",
                    "maxStringLength": 256
                },
                "origin_realm": {
                    "type": "string",
                    "description": "Field to identify realm that originated the message.",
                    "maxStringLength": 256
                },
                "destination_host": {
                    "type": "string",
                    "description": "Field to identify the target server for the message.",
                    "maxStringLength": 256
                },
                "destination_realm": {
                    "type": "string",
                    "description": "Field to identify the realm where receiving server resides.",
                    "maxStringLength": 256
                },
                "avp_key_type": {
                    "type": "enum",
                    "enumType": "AvpKey",
                    "description": "AvpKey type."
                }
            }
        },
        "DnsRequest": {
            "fields": {
                "query_or_response": {
                    "type": "bool",
                    "description": "Flag indicating request is a client query (false) or server response (true)."
                },
                "opcode": {
                    "type": "enum",
                    "enumType": "DnsOpcode",
                    "description": "DNS request operation code e.g. QUERY, NOTIFY, etc."
                },
                "recursion_desired": {
                    "type": "bool",
                    "description": "Flag indicating client request for recursive resolution."
                },
                "checking_disabled": {
                    "type": "bool",
                    "description": "Flag indicating client does not want DNSSEC validation of the response."
                },
                "authentic_data": {
                    "type": "bool",
                    "description": "Flag indicating client understands AD bit and is interested in the value of AD bit in the response."
                },
                "question_count": {
                    "type": "uint32",
                    "description": "Number of questions in the client DNS request."
                },
                "answer_records_count": {
                    "type": "uint32",
                    "description": "Number of answer records in the client DNS request."
                },
                "nameserver_records_count": {
                    "type": "uint32",
                    "description": "Number of nameserver records in the client DNS request."
                },
                "additional_records_count": {
                    "type": "uint32",
                    "description": "Number of additional records."
                },
                "opt_record": {
                    "type": "message",
                    "messageType": "DnsOptRecord",
                    "description": "Opt resource records in the request."
                },
                "client_location": {
                    "type": "message",
                    "messageType": "GeoLocation",
                    "description": "Geo Location of Client."
                },
                "identifier": {
                    "type": "uint32",
                    "description": "ID of the DNS request"
                }
            }
        },
        "GeoLocation": {
            "fields": {
                "latitude": {
                    "type": "float",
                    "description": "Latitude of the location. This is represented as degrees.minutes. The range is from -90.0 (south) to +90.0 (north).",
                    "min": -90,
                    "max": 90
                },
                "longitude": {
                    "type": "float",
                    "description": "Longitude of the location. This is represented as degrees.minutes. The range is from -180.0 (west) to +180.0 (east).",
                    "min": -180,
                    "max": 180
                },
                "name": {
                    "type": "string",
                    "description": "Location name in the format Country/State/City.",
                    "maxStringLength": 128
                },
                "tag": {
                    "type": "string",
                    "description": "Location tag string - example: USEast.",
                    "maxStringLength": 32
                }
            }
        },
        "DnsResponse": {
            "fields": {
                "response_code": {
                    "type": "enum",
                    "enumType": "DnsRcode",
                    "description": "Response code in the response"
                },
                "authoritative_answer": {
                    "type": "bool",
                    "description": "Flag to indicate the responding DNS is an authority for the requested FQDN"
                },
                "truncation": {
                    "type": "bool",
                    "description": "Flag to indicate if the answer received from DNS is truncated (original answer exceeds 512 bytes UDP limit)"
                },
                "recursion_available": {
                    "type": "bool",
                    "description": "Flag indicating the DNS query is fully answered"
                },
                "answer_records_count": {
                    "type": "uint32",
                    "description": "Number of answer records"
                },
                "nameserver_records_count": {
                    "type": "uint32",
                    "description": "Number of nameserver records"
                },
                "additional_records_count": {
                    "type": "uint32",
                    "description": "Number of additional records"
                },
                "records": {
                    "type": "message",
                    "messageType": "DnsResourceRecord",
                    "repeated": true,
                    "description": "Resource records in the response"
                },
                "opt_record": {
                    "type": "message",
                    "messageType": "DnsOptRecord",
                    "description": "Opt resource records in the response"
                },
                "query_or_response": {
                    "type": "bool",
                    "description": "Flag indicating response is a client query (false) or server response (true)."
                },
                "opcode": {
                    "type": "enum",
                    "enumType": "DnsOpcode",
                    "description": "DNS response operation code e.g. QUERY, NOTIFY, etc."
                },
                "recursion_desired": {
                    "type": "bool",
                    "description": "Flag copied from the DNS query's recursion desired field by the responding DNS."
                },
                "question_count": {
                    "type": "uint32",
                    "description": "Number of questions in the client DNS request eliciting this DNS response."
                },
                "is_wildcard": {
                    "type": "bool",
                    "description": "Resource records in the response are generated based on wildcard match"
                },
                "fallback_algorithm_used": {
                    "type": "bool",
                    "description": "Flag to indicate whether fallback algorithm was used to serve this request."
                }
            }
        },
        "DnsResourceRecord": {
            "fields": {
                "type": {
                    "type": "enum",
                    "enumType": "DnsRecordType",
                    "required": true,
                    "description": "Type of resource record"
                },
                "ttl": {
                    "type": "uint32",
                    "required": true,
                    "description": "Number of seconds the resource record can be cached"
                },
                "dclass": {
                    "type": "uint32",
                    "description": "Class of the data in the resource record"
                },
                "addr_ip": {
                    "type": "uint32",
                    "description": "IPv4 address of the requested FQDN"
                },
                "nsname": {
                    "type": "string",
                    "description": "Domain name of the name server that is authoritative for the requested FQDN"
                },
                "cname": {
                    "type": "string",
                    "description": "Canonical (real) name of the requested FQDN"
                },
                "port": {
                    "type": "uint32",
                    "description": "Service port"
                },
                "site_name": {
                    "type": "string",
                    "description": "Site controller cluster name - applicable only for Avi VS GSLB member"
                },
                "vs_name": {
                    "type": "string",
                    "description": "Virtual Service name - applicable only for Avi VS GSLB member"
                },
                "location": {
                    "type": "message",
                    "messageType": "GeoLocation",
                    "description": "Geo Location of Member."
                },
                "addr6_ip_str": {
                    "type": "string",
                    "description": "IPv6 address of the requested FQDN"
                },
                "mail_server": {
                    "type": "string",
                    "description": "Fully qualified domain name of a mail server in the MX record."
                },
                "priority": {
                    "type": "uint32",
                    "description": "The priority field identifies which mail server should be preferred."
                },
                "text_rdata": {
                    "type": "string",
                    "description": "Text resource record."
                },
                "name": {
                    "type": "string",
                    "description": "Domain name of the resource record"
                }
            }
        },
        "ContentRewriteProfile": {
            "fields": {
                "rsp_rewrite_rules": {
                    "type": "message",
                    "messageType": "RspContentRewriteRule",
                    "repeated": true,
                    "description": "Content Rewrite rules to be enabled on theresponse body.",
                    "maxRepeatedLength": 1
                },
                "req_rewrite_rules": {
                    "type": "message",
                    "messageType": "ReqContentRewriteRule",
                    "repeated": true,
                    "description": "Content Rewrite rules to be enabled on therequest body.",
                    "maxRepeatedLength": 1
                }
            }
        },
        "ReqContentRewriteRule": {
            "fields": {
                "name": {
                    "type": "string",
                    "description": "Name of the request rewrite rule",
                    "maxStringLength": 128
                },
                "enable": {
                    "type": "bool",
                    "description": "Enable rewrite rule on request body."
                },
                "index": {
                    "type": "int32",
                    "description": "Index of the request rewrite rule."
                },
                "pairs": {
                    "type": "message",
                    "messageType": "SearchReplacePair",
                    "repeated": true,
                    "description": "List of search-and-replace string pairs for the request body. For eg. Strings \"foo\" and \"bar\", where all searches of \"foo\" in the request body will be replaced with \"bar\"."
                },
                "rewritable_content_uuid": {
                    "type": "string",
                    "default": "System-Rewritable-Content-Types",
                    "description": "Rewrite only content types listed in this string group. Content types not present in this list are not rewritten.",
                    "maxStringLength": 256
                }
            }
        },
        "SearchReplacePair": {
            "fields": {
                "search_string": {
                    "type": "message",
                    "messageType": "SearchStringVar",
                    "description": "String to search for in the body.",
                    "required": true
                },
                "replacement_string": {
                    "type": "message",
                    "messageType": "ReplaceStringVar",
                    "description": "String to replace the searched value."
                }
            },
            "repeatedKey": "search_string"
        },
        "ReplaceStringVar": {
            "fields": {
                "type": {
                    "type": "enum",
                    "enumType": "ReplaceStringType",
                    "default": "LITERAL_STRING",
                    "description": "Type of replacement string - can be a variable exposed from datascript, value of an HTTP variable, a custom user-input literal string, or a string with all three combined."
                },
                "val": {
                    "type": "string",
                    "description": "Value of the replacement string - name of variable exposed from datascript, name of the HTTP header, a custom user-input literal string, or a string with all three combined",
                    "maxStringLength": 256
                }
            }
        },
        "SearchStringVar": {
            "fields": {
                "type": {
                    "type": "enum",
                    "enumType": "SearchStringType",
                    "default": "SEARCH_LITERAL_STRING",
                    "description": "Type of search string - can be a variable exposed from datascript, value of an HTTP variable, a custom user-input literal string, or a regular expression."
                },
                "val": {
                    "type": "string",
                    "description": "Value of search string - can be a variable exposed from datascript, value of an HTTP variable, a custom user-input literal string, or a regular expression.",
                    "maxStringLength": 256,
                    "required": true
                }
            }
        },
        "RspContentRewriteRule": {
            "fields": {
                "name": {
                    "type": "string",
                    "description": "Name of the response rewrite rule",
                    "maxStringLength": 128
                },
                "enable": {
                    "type": "bool",
                    "description": "Enable rewrite rule on response body."
                },
                "index": {
                    "type": "int32",
                    "description": "Index of the response rewrite rule."
                },
                "pairs": {
                    "type": "message",
                    "messageType": "SearchReplacePair",
                    "repeated": true,
                    "description": "List of search-and-replace string pairs for the response body. For eg. Strings \"foo\" and \"bar\", where all searches of \"foo\" in the response body will be replaced with \"bar\"."
                },
                "rewritable_content_uuid": {
                    "type": "string",
                    "default": "System-Rewritable-Content-Types",
                    "description": "Rewrite only content types listed in this string group. Content types not present in this list are not rewritten.",
                    "maxStringLength": 256
                }
            }
        },
        "ControllerLicense": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "required": true
                },
                "name": {
                    "type": "string",
                    "maxStringLength": 256
                },
                "start_on": {
                    "type": "string"
                },
                "valid_until": {
                    "type": "string"
                },
                "customer_name": {
                    "type": "string"
                },
                "cores": {
                    "type": "uint32",
                    "description": "Number of Service Engine cores in non-container clouds"
                },
                "license_tier": {
                    "type": "string",
                    "repeated": true
                },
                "max_ses": {
                    "type": "uint32",
                    "description": "Number of Service Engines hosts in container clouds"
                },
                "sockets": {
                    "type": "uint32",
                    "description": "Number of physical cpu sockets across Service Engines in no access and linux server clouds"
                },
                "licenses": {
                    "type": "message",
                    "messageType": "SingleLicense",
                    "repeated": true
                },
                "se_bandwidth_limits": {
                    "type": "message",
                    "messageType": "SEBandwidthLimit",
                    "repeated": true,
                    "description": "Service Engine bandwidth limits for bandwidth based licenses"
                },
                "license_tiers": {
                    "type": "message",
                    "messageType": "CumulativeLicense",
                    "repeated": true
                },
                "burst_cores": {
                    "type": "uint32",
                    "description": "Total number of Service Engine cores for burst core based licenses"
                },
                "active_burst_resources": {
                    "type": "message",
                    "messageType": "BurstResource",
                    "repeated": true,
                    "description": "List of active burst core license in use"
                },
                "expired_burst_resources": {
                    "type": "message",
                    "messageType": "BurstResource",
                    "repeated": true,
                    "description": "List of used or expired burst core licenses"
                },
                "license_id": {
                    "type": "string"
                },
                "disable_enforcement": {
                    "type": "bool"
                },
                "service_cores": {
                    "type": "Unknown",
                    "description": "Number of vmware service cores after aggregating all other license types."
                },
                "initialized": {
                    "type": "bool",
                    "description": "Flag used to track initialization."
                },
                "tenant_uuid": {
                    "type": "string",
                    "description": "Tenant uuid.",
                    "maxStringLength": 512
                }
            }
        },
        "CumulativeLicense": {
            "fields": {
                "tier_type": {
                    "type": "enum",
                    "enumType": "LicenseTierType",
                    "description": "Specifies the licensed tier"
                },
                "se_bandwidth_limits": {
                    "type": "message",
                    "messageType": "SEBandwidthLimit",
                    "repeated": true,
                    "description": "Service Engine bandwidth limits for bandwidth based licenses"
                },
                "cores": {
                    "type": "uint32",
                    "description": "Total number of Service Engine cores for core based licenses"
                },
                "sockets": {
                    "type": "uint32",
                    "description": "Total number of Service Engine sockets for socket based licenses"
                },
                "max_ses": {
                    "type": "uint32",
                    "description": "Total number of Service Engines for host based licenses"
                },
                "burst_cores": {
                    "type": "uint32",
                    "description": "Total number of Service Engine cores for burst core based licenses"
                },
                "service_cores": {
                    "type": "Unknown",
                    "description": "Total number of Service Engine cores.."
                }
            }
        },
        "SingleLicense": {
            "fields": {
                "license_name": {
                    "type": "string",
                    "required": true
                },
                "start_on": {
                    "type": "string"
                },
                "valid_until": {
                    "type": "string",
                    "required": true
                },
                "customer_name": {
                    "type": "string",
                    "required": true
                },
                "cores": {
                    "type": "Unknown",
                    "description": "Number of Service Engine cores in non-container clouds"
                },
                "max_ses": {
                    "type": "uint32",
                    "description": "Number of Service Engines hosts in container clouds"
                },
                "license_tier": {
                    "type": "string",
                    "repeated": true
                },
                "license_string": {
                    "type": "string"
                },
                "license_id": {
                    "type": "string"
                },
                "version": {
                    "type": "string"
                },
                "created_on": {
                    "type": "string"
                },
                "last_update": {
                    "type": "string"
                },
                "license_type": {
                    "type": "string"
                },
                "enforced_params": {
                    "type": "string",
                    "repeated": true
                },
                "sockets": {
                    "type": "uint32",
                    "description": "Number of physical cpu sockets across Service Engines in no access and linux server clouds"
                },
                "se_bandwidth_limits": {
                    "type": "message",
                    "messageType": "SEBandwidthLimit",
                    "repeated": true,
                    "description": "Service Engine bandwidth limits for bandwidth based licenses"
                },
                "tier_type": {
                    "type": "enum",
                    "enumType": "LicenseTierType",
                    "description": "Specifies the licensed tier"
                },
                "burst_cores": {
                    "type": "uint32",
                    "description": "Total number of Service Engine burst cores for core based licenses"
                },
                "serial_key": {
                    "type": "string",
                    "description": "Serial key (Hyphen separated 25 char wide alphanumeric key Ex: AA123-23BAS-383AS-383UD-FHSFG).",
                    "maxStringLength": 29
                },
                "service_cores": {
                    "type": "Unknown",
                    "default": 0,
                    "description": "Total number of service cores equivalent to all the resoures available in the single license."
                },
                "cpu_cores": {
                    "type": "Unknown",
                    "default": 0,
                    "description": "Total number of cpu cores."
                },
                "expired": {
                    "type": "bool",
                    "default": false,
                    "description": "Flag to track license expiry."
                },
                "ccu": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Number of concurrent VMware Horizon users."
                },
                "addons": {
                    "type": "enum",
                    "enumType": "LicenseAddon",
                    "repeated": true,
                    "description": "Features supported by the add-on license."
                },
                "capacity": {
                    "type": "Unknown",
                    "default": 0,
                    "description": "Total licensing capacity available for all the resoures available in a single license."
                },
                "unit": {
                    "type": "enum",
                    "enumType": "LicenseUnits",
                    "default": "SERVICE_UNIT",
                    "description": "Units in which resources will be licensed."
                },
                "tenant_uuid": {
                    "type": "string",
                    "description": "Tenant uuid.",
                    "maxStringLength": 512
                },
                "cls_id": {
                    "type": "string",
                    "description": "Central license service id.",
                    "maxStringLength": 512
                },
                "policy": {
                    "type": "message",
                    "messageType": "LicensePolicy",
                    "description": "License policy details."
                }
            }
        },
        "LicensePolicy": {
            "fields": {
                "expiration_date": {
                    "type": "string",
                    "description": "License expiration date.",
                    "maxStringLength": 30
                },
                "expiration_reason": {
                    "type": "string",
                    "description": "License expiration reason.",
                    "maxStringLength": 30
                },
                "grace_period": {
                    "type": "string",
                    "description": "License grace period.",
                    "maxStringLength": 30
                },
                "expiration_pre_warn": {
                    "type": "string",
                    "description": "Expiration pre warning period.",
                    "maxStringLength": 30
                },
                "license_warnings": {
                    "type": "message",
                    "messageType": "LicenseWarning",
                    "repeated": true,
                    "description": "License warnings."
                }
            }
        },
        "LicenseWarning": {
            "fields": {
                "date": {
                    "type": "string",
                    "description": "License warning date.",
                    "maxStringLength": 30
                },
                "reason": {
                    "type": "string",
                    "description": "License warning reason.",
                    "maxStringLength": 30
                },
                "pre_warn": {
                    "type": "string",
                    "description": "License pre warning period.",
                    "maxStringLength": 30
                }
            }
        },
        "ControllerProperties": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "required": true
                },
                "dummy": {
                    "type": "uint32"
                },
                "unresponsive_se_reboot": {
                    "type": "uint32",
                    "default": 300
                },
                "crashed_se_reboot": {
                    "type": "uint32",
                    "default": 900
                },
                "se_offline_del": {
                    "type": "uint32",
                    "default": 172000
                },
                "vs_se_create_fail": {
                    "type": "uint32",
                    "default": 1500
                },
                "vs_se_vnic_fail": {
                    "type": "uint32",
                    "default": 300
                },
                "vs_se_bootup_fail": {
                    "type": "uint32",
                    "default": 480
                },
                "se_vnic_cooldown": {
                    "type": "uint32",
                    "default": 120
                },
                "vs_se_vnic_ip_fail": {
                    "type": "uint32",
                    "default": 120
                },
                "fatal_error_lease_time": {
                    "type": "uint32",
                    "default": 120
                },
                "query_host_fail": {
                    "type": "uint32",
                    "default": 180
                },
                "vnic_op_fail_time": {
                    "type": "uint32",
                    "default": 180
                },
                "dns_refresh_period": {
                    "type": "uint32",
                    "default": 60,
                    "description": "Period for refresh pool and gslb DNS job",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "60"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "60"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "se_create_timeout": {
                    "type": "uint32",
                    "default": 900
                },
                "max_dead_se_in_grp": {
                    "type": "uint32",
                    "default": 1
                },
                "dead_se_detection_timer": {
                    "type": "uint32",
                    "default": 360
                },
                "api_idle_timeout": {
                    "type": "uint32",
                    "default": 15,
                    "min": 0,
                    "max": 1440
                },
                "cluster_ip_gratuitous_arp_period": {
                    "type": "uint32",
                    "default": 60,
                    "description": "Period for cluster ip gratuitous arp job",
                    "min": 1,
                    "max": 1440
                },
                "vs_key_rotate_period": {
                    "type": "uint32",
                    "default": 360,
                    "description": "Period for rotate VS keys job",
                    "min": 1,
                    "max": 1051200,
                    "specialValues": {
                        "0": "Disabled"
                    }
                },
                "secure_channel_controller_token_timeout": {
                    "type": "uint32",
                    "default": 60
                },
                "secure_channel_se_token_timeout": {
                    "type": "uint32",
                    "default": 60
                },
                "max_seq_vnic_failures": {
                    "type": "uint32",
                    "default": 3
                },
                "vs_awaiting_se_timeout": {
                    "type": "uint32",
                    "default": 60
                },
                "secure_channel_cleanup_timeout": {
                    "type": "uint32",
                    "default": 60,
                    "description": "Period for secure channel cleanup job"
                },
                "attach_ip_retry_interval": {
                    "type": "uint32",
                    "default": 360
                },
                "attach_ip_retry_limit": {
                    "type": "uint32",
                    "default": 4
                },
                "persistence_key_rotate_period": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Period for rotate app persistence keys job",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "0"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "0"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 1,
                    "max": 1051200,
                    "specialValues": {
                        "0": "Disabled"
                    }
                },
                "allow_unauthenticated_apis": {
                    "type": "bool",
                    "default": false,
                    "description": "Allow unauthenticated access for special APIs"
                },
                "warmstart_se_reconnect_wait_time": {
                    "type": "uint32",
                    "default": 480
                },
                "vs_se_ping_fail": {
                    "type": "uint32",
                    "default": 60
                },
                "se_failover_attempt_interval": {
                    "type": "uint32",
                    "default": 300,
                    "description": "Interval between attempting failovers to an SE"
                },
                "max_pcap_per_tenant": {
                    "type": "uint32",
                    "default": 4,
                    "description": "Maximum number of pcap files stored per tenant"
                },
                "ssl_certificate_expiry_warning_days": {
                    "type": "uint32",
                    "repeated": true,
                    "description": "Number of days for SSL Certificate expiry warning"
                },
                "allow_ip_forwarding": {
                    "type": "bool",
                    "default": false
                },
                "appviewx_compat_mode": {
                    "type": "bool",
                    "default": false,
                    "description": "Export configuration in appviewx compatibility mode",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "upgrade_dns_ttl": {
                    "type": "uint32",
                    "default": 5,
                    "description": "Time to account for DNS TTL during upgrade. This is in addition to vs_scalein_timeout_for_upgrade in se_group.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "5"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "5"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "portal_token": {
                    "type": "string",
                    "description": "Token used for uploading tech-support to portal"
                },
                "bm_use_ansible": {
                    "type": "bool",
                    "default": true,
                    "description": "Use Ansible for SE creation in baremetal"
                },
                "vs_se_attach_ip_fail": {
                    "type": "uint32",
                    "default": 600,
                    "description": "Time to wait before marking attach IP operation on an SE as failed"
                },
                "max_seq_attach_ip_failures": {
                    "type": "uint32",
                    "default": 3,
                    "description": "Maximum number of consecutive attach IP failures that halts VS placement"
                },
                "safenet_hsm_version": {
                    "type": "string",
                    "description": "Version of the safenet package installed on the controller"
                },
                "cleanup_expired_authtoken_timeout_period": {
                    "type": "uint32",
                    "default": 60,
                    "description": "Period for auth token cleanup job"
                },
                "cleanup_sessions_timeout_period": {
                    "type": "uint32",
                    "default": 60,
                    "description": "Period for sessions cleanup job"
                },
                "consistency_check_timeout_period": {
                    "type": "uint32",
                    "default": 60,
                    "description": "Period for consistency check job"
                },
                "process_locked_useraccounts_timeout_period": {
                    "type": "uint32",
                    "default": 1,
                    "description": "Period for process locked user accounts job"
                },
                "process_pki_profile_timeout_period": {
                    "type": "uint32",
                    "default": 1440,
                    "description": "Period for process PKI profile job"
                },
                "enable_memory_balancer": {
                    "type": "bool",
                    "default": true,
                    "description": "Enable/Disable Memory Balancer"
                },
                "warmstart_vs_resync_wait_time": {
                    "type": "uint32",
                    "default": 300,
                    "description": "Timeout for warmstart VS resync"
                },
                "api_perf_logging_threshold": {
                    "type": "uint32",
                    "default": 10000,
                    "description": "Threshold to log request timing in portal_performance.log and Server-Timing response header. Any stage taking longer than 1% of the threshold will be included in the Server-Timing header."
                },
                "se_from_marketplace": {
                    "type": "enum",
                    "enumType": "SeFromMarketplace",
                    "default": "IMAGE_SE",
                    "description": "This setting decides whether SE is to be deployed from the cloud marketplace or to be created by the controller. The setting is applicable only when BYOL license is selected."
                },
                "cloud_reconcile": {
                    "type": "bool",
                    "default": true,
                    "description": "Enable/Disable periodic reconcile for all the clouds."
                },
                "enable_api_sharding": {
                    "type": "bool",
                    "default": true,
                    "description": "This setting enables the controller leader to shard API requests to the followers (if any)."
                },
                "vs_scaleout_ready_check_interval": {
                    "type": "int32",
                    "default": 60,
                    "description": "Interval for checking scaleout_ready status while controller is waiting for ScaleOutReady RPC from the Service Engine."
                },
                "shared_ssl_certificates": {
                    "type": "bool",
                    "default": false,
                    "description": "SSL Certificates in the admin tenant can be used in non-admin tenants."
                },
                "default_minimum_api_timeout": {
                    "type": "uint32",
                    "default": 60,
                    "description": "Minimum api timeout value.If this value is not 60, it will be the default timeout for all APIs that do not have a specific timeout.If an API has a specific timeout but is less than this value, this value will become the new timeout.",
                    "min": 60,
                    "max": 3600
                },
                "permission_scoped_shared_admin_networks": {
                    "type": "bool",
                    "default": false,
                    "description": "Network and VrfContext objects from the admin tenant will not be shared to non-admin tenants unless admin permissions are granted."
                },
                "allow_admin_network_updates": {
                    "type": "bool",
                    "default": false,
                    "description": "Allow non-admin tenants to update admin VrfContext and Network objects."
                },
                "se_spawn_retry_interval": {
                    "type": "uint32",
                    "default": 300,
                    "description": "Default retry period before attempting another Service Engine spawn in SE Group."
                },
                "max_se_spawn_interval_delay": {
                    "type": "uint32",
                    "default": 1800,
                    "description": "Maximum delay possible to add to se_spawn_retry_interval after successive SE spawn failure."
                },
                "portal_request_rate_limit": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Maximum average number of requests allowed per second. 0 to disable"
                },
                "portal_request_burst_limit": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Burst limit on number of incoming requests. 0 to disable"
                },
                "federated_datastore_cleanup_duration": {
                    "type": "uint64",
                    "default": 120,
                    "description": "Federated datastore will not cleanup diffs unless they are at least this duration in the past."
                },
                "edit_system_limits": {
                    "type": "bool",
                    "default": false,
                    "description": "Allow editing of system limits. Keep in mind that these system limits have been carefully selected based on rigorous testing in our testig environments. Modifying these limits could destabilize your cluster. Do this at your own risk!"
                },
                "file_object_cleanup_period": {
                    "type": "uint32",
                    "default": 1440,
                    "description": "Period for file object cleanup job."
                },
                "upgrade_se_per_vs_scale_ops_txn_time": {
                    "type": "uint32",
                    "default": 3,
                    "description": "This parameter defines the upper-bound value of the VS scale-in or VS scale-out operation executed in the SeScaleIn and SeScale context.  User can tweak this parameter to a higher value if the Segroup gets suspended due to SeScalein or SeScaleOut timeout failure typically associated with high number of VS(es) scaled out. "
                },
                "max_threads_cc_vip_bg_worker": {
                    "type": "uint32",
                    "default": 20,
                    "description": "Maximum number of threads in threadpool used by cloud connector CCVIPBGWorker.",
                    "min": 1,
                    "max": 100
                },
                "async_patch_merge_period": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Period for which asynchronous patch requests are queued.",
                    "min": 30,
                    "max": 120,
                    "specialValues": {
                        "0": "Deactivated"
                    }
                },
                "async_patch_request_cleanup_duration": {
                    "type": "uint32",
                    "default": 60,
                    "description": "Duration for which asynchronous patch requests should be kept, after being marked as SUCCESS or FAIL.",
                    "min": 5,
                    "max": 120
                },
                "controller_resource_info_collection_period": {
                    "type": "uint32",
                    "default": 525600,
                    "description": "Periodically collect stats."
                },
                "se_vnic_gc_wait_time": {
                    "type": "uint32",
                    "default": 300,
                    "description": "Duration to wait after last vNIC addition before proceeding with vNIC garbage collection. Used for testing purposes."
                },
                "resmgr_log_caching_period": {
                    "type": "uint32",
                    "default": 21600,
                    "description": "Period for each cycle of log caching in Resource Manager. At the end of each cycle, the in memory cached log history will be cleared."
                },
                "user_agent_cache_config": {
                    "type": "message",
                    "messageType": "UserAgentCacheConfig",
                    "description": "Configuration for User-Agent Cache used in Bot Management."
                },
                "del_offline_se_after_reboot_delay": {
                    "type": "uint32",
                    "default": 300,
                    "description": "The amount of time the controller will wait before deleting an offline SE after it has been rebooted. For unresponsive SEs, the total time will be  unresponsive_se_reboot + del_offline_se_after_reboot_delay. For crashed SEs, the total time will be crashed_se_reboot + del_offline_se_after_reboot_delay."
                },
                "enable_resmgr_log_cache_print": {
                    "type": "bool",
                    "default": false,
                    "description": "Enable printing of cached logs inside Resource Manager. Used for debugging purposes only."
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                },
                "enable_per_process_stop": {
                    "type": "bool",
                    "default": false,
                    "description": "Enable stopping of individual processes if process cross the given threshold limit, even when the total controller memory usage is belowits threshold limit."
                },
                "check_vsvip_fqdn_syntax": {
                    "type": "bool",
                    "default": true,
                    "description": "Enforce VsVip FQDN syntax checks",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "vsphere_ha_timer_interval": {
                    "type": "uint32",
                    "default": 20,
                    "description": "vSphere HA monitor timer interval for sending cc_check_se_status to Cloud Connector"
                },
                "vsphere_ha_detection_timeout": {
                    "type": "uint32",
                    "default": 120,
                    "description": "vSphere HA monitor detection timeout. If vsphere_ha_enabled is true and the controller is not able to reach the SE, placement will wait for this duration for vsphere_ha_inprogress to be marked true before taking corrective action"
                },
                "vsphere_ha_recovery_timeout": {
                    "type": "uint32",
                    "default": 480,
                    "description": "vSphere HA monitor recovery timeout. Once vsphere_ha_inprogress is set to true (meaning host failure detected and vSphere HA will recover the Service Engine), placement will wait for at least this duration for the SE to reconnect to the controller before taking corrective action."
                },
                "detach_ip_retry_interval": {
                    "type": "uint32",
                    "default": 60,
                    "description": "Amount of time to wait after last Detach IP failure before attempting next Detach IP retry"
                },
                "detach_ip_retry_limit": {
                    "type": "uint32",
                    "default": 4,
                    "description": "Maximum number of Detach IP retries"
                },
                "detach_ip_timeout": {
                    "type": "uint32",
                    "default": 300,
                    "description": "Time to wait before marking Detach IP as failed"
                },
                "restrict_cloud_read_access": {
                    "type": "bool",
                    "default": false,
                    "description": "Restrict read access to cloud."
                },
                "update_dns_entry_timeout": {
                    "type": "uint32",
                    "default": 120,
                    "description": "Timeout period for a DNS entry update/delete operation"
                },
                "update_dns_entry_retry_limit": {
                    "type": "uint32",
                    "default": 3,
                    "description": "Number of times to retry a DNS entry update/delete operation"
                },
                "se_upgrade_flow_cleanup_timeout": {
                    "type": "uint32",
                    "default": 90,
                    "description": "Timeout for flows cleanup by ServiceEngine during Upgrade.Internal knob: to be exercised under the surveillance of VMware AVI support team."
                },
                "false_positive_learning_config": {
                    "type": "message",
                    "messageType": "FalsePositiveLearningConfig",
                    "description": "False Positive learning configuration."
                },
                "gslb_purge_batch_size": {
                    "type": "uint32",
                    "default": 1000,
                    "description": "Batch size for the vs_mgr to perform datastrorecleanup during a GSLB purge.",
                    "min": 50,
                    "max": 1200
                },
                "gslb_purge_sleep_time_ms": {
                    "type": "uint32",
                    "default": 50,
                    "description": "Sleep time in the vs_mgr during a FederatedPurge RPC call.",
                    "min": 50,
                    "max": 100
                },
                "postgres_vacuum_period": {
                    "type": "uint32",
                    "default": 20160,
                    "description": "Period for which postgres vacuum are executed.",
                    "min": 30,
                    "max": 40320,
                    "specialValues": {
                        "0": "Deactivated"
                    }
                },
                "ignore_vrf_in_networksubnetlist": {
                    "type": "bool",
                    "default": false,
                    "description": "Ignore the vrf_context filter for /networksubnetlist API."
                },
                "vs_se_bootup_fail_patch": {
                    "type": "uint32",
                    "default": 600,
                    "description": "Wait for longer for patch SEs to boot up"
                },
                "soft_min_mem_per_se_limit": {
                    "type": "uint32",
                    "default": 1900,
                    "description": "Soft Limit on the minimum SE Memory that an SE needs to have on SE Register."
                },
                "cloud_reconcile_interval": {
                    "type": "uint32",
                    "default": 5,
                    "description": "Time in minutes to wait between consecutive cloud reconcile cycles.",
                    "min": 1,
                    "max": 1440
                },
                "cloud_discovery_interval": {
                    "type": "uint32",
                    "default": 5,
                    "description": "Time in minutes to wait between consecutive cloud discovery cycles.",
                    "min": 1,
                    "max": 1440
                },
                "fileobject_max_file_versions": {
                    "type": "uint32",
                    "default": 3,
                    "description": "This is the max number of file versions that will be retained for a file referenced by the local FileObject. Subsequent uploads of file will result in the file rotation of the older version and the latest version retained. Example: When a file Upload is done for the first time, there will be a v1 version. Subsequent uploads will get mapped to v1, v2 and v3 versions. On the fourth upload of the file, the v1 will be file rotated and v2, v3 and v4 will be retained.",
                    "min": 1,
                    "max": 5
                },
                "event_manager_processing_time_threshold": {
                    "type": "uint32",
                    "default": 4,
                    "description": "Log instances for event manager processing delay; recorded whenever event processing delay exceeds configured interval specified in seconds.",
                    "min": 1,
                    "max": 5,
                    "specialValues": {
                        "0": "Disabled"
                    }
                },
                "event_manager_max_subscribers": {
                    "type": "uint32",
                    "default": 5,
                    "description": "Maximum number of subscribers for event manager process.",
                    "min": 1,
                    "max": 6,
                    "specialValues": {
                        "0": "Disabled"
                    }
                },
                "event_manager_max_goroutines": {
                    "type": "uint32",
                    "default": 8,
                    "description": "Maximum number of goroutines for event manager process.",
                    "min": 1,
                    "max": 64
                },
                "alert_manager_use_evms": {
                    "type": "bool",
                    "default": true,
                    "description": "Enable to use event manager as source of eventsDisable to use log manager as source of events"
                },
                "enable_nsx_streaming_agent": {
                    "type": "bool",
                    "default": true,
                    "description": "When set to true, Avi Controller will connect to Dynamic Config Streaming Agent on NSX Manager to get live updates. If it cannot connect, it will fallback to using REST APIs based periodic polling. Dynamic streaming is supported from NSX version 4.2.1 onwards."
                },
                "statecache_properties": {
                    "type": "message",
                    "messageType": "SCProperties",
                    "description": "Configure statecache behavior for Config, SE, ResMgr."
                },
                "skip_beego_perf_collection": {
                    "type": "bool",
                    "default": false,
                    "description": "Skip API Performance collection for requests going through the Apiserver."
                },
                "archive_retention_framework_period": {
                    "type": "uint32",
                    "default": 60,
                    "description": "Period for archive and retention framework job.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ],
                    "min": 1,
                    "max": 240
                },
                "gslb_fileobject_max_version_count": {
                    "type": "uint32",
                    "default": 3,
                    "description": "Number of version copies for a givenfile object of GSLB_GEO_DB type.",
                    "min": 2,
                    "max": 50000
                },
                "telemetry_interval": {
                    "type": "uint32",
                    "default": 1440,
                    "description": "Period for telemetry job.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ],
                    "min": 1,
                    "max": 1440
                },
                "log_records_allocated_size": {
                    "type": "uint32",
                    "description": "Disk size to be allocated [1MB to 500GB] to store logs on a controller vm.",
                    "min": 1000,
                    "max": 500000000
                },
                "log_records_purge_interval": {
                    "type": "uint32",
                    "default": 300,
                    "description": "Frequency (in seconds) to clean up log files on Controller node.",
                    "min": 10,
                    "max": 100000
                },
                "async_cert_chaining_interval": {
                    "type": "uint32",
                    "default": 2,
                    "description": "Time in seconds to wait before starting async certificate chaining.",
                    "min": 0,
                    "max": 120
                },
                "log_records_frequent_cleanup_event_generation_threshold": {
                    "type": "uint32",
                    "default": 2,
                    "description": "The threshold for raising an event on frequent cleanup of logs system. By default if two consecutive purger/ clean up runs find logs beyond allocated size then an event in raised.",
                    "min": 2,
                    "max": 100
                },
                "log_records_cleanup_target_percentage": {
                    "type": "uint32",
                    "default": 90,
                    "description": "Target percentage of allocated disk quota to reduce log file consumption to when cleanup is triggered. When disk usage exceeds 100% of the allocated quota, cleanup will reduce consumption to this percentage of the allocation.",
                    "min": 30,
                    "max": 90
                },
                "log_records_allocation_percentage_for_events": {
                    "type": "uint32",
                    "default": 50,
                    "description": "Percentage of allocation (log_records_allocated_size)  for events on controller node.",
                    "min": 10,
                    "max": 70
                },
                "event_manager_file_modified_ts_filter": {
                    "type": "uint32",
                    "default": 180,
                    "description": "Stated time duration beyond which Event manager disregards files whose modified timestamp from current time is later.",
                    "min": 1,
                    "max": 1800
                },
                "cert_rotation_jwt_retention_days": {
                    "type": "uint32",
                    "default": 180,
                    "description": "Number of days to retain JWT tokens generated during certificate rotation. Use multiples of 30 for months (e.g., 30 = 1 month, 60 = 2 months, 180 = 6 months).",
                    "min": 1,
                    "max": 3650
                },
                "cc_user_password_rotation_job_period": {
                    "type": "uint32",
                    "default": 24,
                    "description": "Period in hours for CloudConnectorUser (service account) password rotation check job. Default is 24 hours (1 day). Range is 1-168 hours (1 hour to 7 days).",
                    "min": 1,
                    "max": 168
                },
                "cc_user_password_expiry_days": {
                    "type": "uint32",
                    "default": 30,
                    "description": "Number of days after which CloudConnectorUser (service account) password expires. Rotation is triggered 5 days before expiry. Set to 0 to disable automatic rotation.",
                    "min": 1,
                    "max": 730,
                    "specialValues": {
                        "0": "Disabled"
                    }
                },
                "enable_streaming_based_nsx_ip_group_sync": {
                    "type": "bool",
                    "default": true,
                    "description": "When set to true, Avi Controller will attempt to automatically sync NSX Groups with AVI IP Groups provided the IP group is configured with an NSX Group path and NSX Dynamic streaming is enabled and active"
                }
            }
        },
        "SCProperties": {
            "fields": {
                "delay_injections": {
                    "type": "message",
                    "messageType": "SCFaultOptions",
                    "repeated": true,
                    "description": "Introduce delay faults in SCM Config, SE, ResMgrGo paths."
                }
            }
        },
        "SCFaultOptions": {
            "fields": {
                "fault_type": {
                    "type": "enum",
                    "enumType": "SCFaultType",
                    "description": "Type of fault to injection."
                },
                "object_type": {
                    "type": "enum",
                    "enumType": "AviObjectType",
                    "description": "Introduce faults for objects of specified type."
                },
                "obj": {
                    "type": "string",
                    "description": "Introduce faults for specific object UUID.",
                    "maxStringLength": 255
                },
                "se": {
                    "type": "string",
                    "description": "Introduce faults in SE path of specific SE UUID.",
                    "maxStringLength": 255
                },
                "delay_create": {
                    "type": "uint32",
                    "description": "Delay CREATE in config path (seconds)."
                },
                "delay_update": {
                    "type": "uint32",
                    "description": "Delay UPDATES in ResMgr, Config, SE paths (seconds)."
                },
                "delay_delete": {
                    "type": "uint32",
                    "description": "Delay DELETES in Config, SE paths (seconds)."
                }
            }
        },
        "FalsePositiveLearningConfig": {
            "fields": {
                "min_trans_per_application": {
                    "type": "uint64",
                    "default": 1000000,
                    "description": "Minimum number of transactions in one application required to automatically detect false positive."
                },
                "min_trans_per_uri": {
                    "type": "uint64",
                    "default": 10000,
                    "description": "Minimum number of transactions in one URI required to automatically detect false positive."
                },
                "min_monitor_time": {
                    "type": "uint64",
                    "default": 10080,
                    "description": "Minimum monitor time required to automatically detect false positive. Unit is minutes."
                },
                "max_apps_supported": {
                    "type": "uint64",
                    "default": 2,
                    "description": "Max number of applications supported to detect false positive."
                }
            }
        },
        "UserAgentCacheConfig": {
            "fields": {
                "se_cache_size": {
                    "type": "uint32",
                    "default": 20000,
                    "description": "The number of User-Agent entries to cache on each Service Engine.",
                    "min": 500,
                    "max": 10000000
                },
                "controller_cache_size": {
                    "type": "uint32",
                    "default": 300000,
                    "description": "The number of User-Agent entries to cache on the Controller.",
                    "min": 500,
                    "max": 10000000
                },
                "percent_reserved_for_outstanding": {
                    "type": "uint32",
                    "default": 10,
                    "description": "How much space to reserve in percent for outstanding upstream requests."
                },
                "percent_reserved_for_browsers": {
                    "type": "uint32",
                    "default": 50,
                    "description": "How much space to reserve in percent for browsers."
                },
                "percent_reserved_for_good_bots": {
                    "type": "uint32",
                    "default": 20,
                    "description": "How much space to reserve in percent for known good bots."
                },
                "percent_reserved_for_bad_bots": {
                    "type": "uint32",
                    "default": 20,
                    "description": "How much space to reserve in percent for known bad bots."
                },
                "batch_size": {
                    "type": "uint32",
                    "default": 100,
                    "description": "How many unknown User-Agents to batch up before querying Controller - unless max_wait_time is reached first.",
                    "min": 1,
                    "max": 500
                },
                "max_wait_time": {
                    "type": "uint32",
                    "default": 60,
                    "description": "The time interval in seconds after which to make a request to the Controller, even if the 'batch_size' hasn't been reached yet.",
                    "min": 20,
                    "max": 100000
                },
                "upstream_update_interval": {
                    "type": "uint32",
                    "default": 3600,
                    "description": "How often in seconds to send updates about User-Agent cache entries to the next upstream cache."
                },
                "num_entries_upstream_update": {
                    "type": "uint32",
                    "default": 100,
                    "description": "How many BotUACacheResult elements to include in an upstream update message.",
                    "min": 1,
                    "max": 10000
                },
                "max_upstream_queries": {
                    "type": "uint32",
                    "default": 5,
                    "description": "How often at most to query controller for a given User-Agent.",
                    "min": 2,
                    "max": 100
                },
                "max_age": {
                    "type": "uint32",
                    "default": 86400,
                    "description": "Time interval in seconds after which an existing entry is refreshed from upstream if it has been accessed during max_last_hit_time.",
                    "min": 60,
                    "max": 604800
                },
                "max_last_hit_time": {
                    "type": "uint32",
                    "default": 86400,
                    "description": "Time interval in seconds backwards from now during which an existing entry must have been hit for refresh from upstream. Entries that have last been accessed further in the past than max_last_hit time are not included in upstream refresh requests even if they are older than 'max_age'.",
                    "min": 60,
                    "max": 604800
                }
            }
        },
        "ControllerSite": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "description": "Reference for the Site Controller Cluster."
                },
                "name": {
                    "type": "string",
                    "description": "Name for the Site Controller Cluster.",
                    "maxStringLength": 256,
                    "required": true
                },
                "address": {
                    "type": "string",
                    "description": "IP Address or a DNS resolvable, fully qualified domain name of the Site Controller Cluster.",
                    "required": true
                },
                "port": {
                    "type": "uint32",
                    "default": 443,
                    "description": "The Controller Site Cluster's REST API port number.",
                    "min": 1,
                    "max": 65535
                },
                "tenant_uuid": {
                    "type": "string",
                    "description": "Reference for the Tenant."
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                }
            }
        },
        "CSRFPolicy": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "description": "A unique identifier to this CSRF Protection Policy.",
                    "maxStringLength": 128,
                    "required": true
                },
                "tenant_uuid": {
                    "type": "string",
                    "description": "The unique identifier of the tenant to which this policy belongs.",
                    "maxStringLength": 128
                },
                "name": {
                    "type": "string",
                    "description": "The name of this CSRF Protection Policy.",
                    "maxStringLength": 128,
                    "required": true
                },
                "description": {
                    "type": "string",
                    "description": "Human-readable description of this CSRF Protection Policy.",
                    "maxStringLength": 256
                },
                "token_validity_time_min": {
                    "type": "uint32",
                    "default": 360,
                    "description": "A CSRF token is rotated when this amount of time has passed. Even after that, tokens will be accepted until twice this amount of time has passed. Note, however, that other timeouts from the underlying session layer also affect how long a given token can be used. A token will be invalidated (rotated or deleted) after one of 'token_validity_time_min' (this value), 'session_establishment_timeout', 'session_idle_timeout', 'session_maximum_timeout' is reached, whichever occurs first.",
                    "min": 10,
                    "max": 1440,
                    "specialValues": {
                        "0": "unlimited"
                    }
                },
                "rules": {
                    "type": "message",
                    "messageType": "CSRFRule",
                    "repeated": true,
                    "description": "Rules to control which requests undergo CSRF Protection.If the client's request doesn't match with any rules MatchTarget, BYPASS_CSRF action is applied",
                    "minRepeatedLength": 1
                },
                "cookie_name": {
                    "type": "string",
                    "default": "X-CSRF-TOKEN",
                    "description": "Name of the cookie to be used for CSRF token.",
                    "maxStringLength": 128
                },
                "csrf_file_uuid": {
                    "type": "string",
                    "default": "System-CSRF-JS-File",
                    "description": "The file object that contains csrf javascript content. Must be of type 'CSRF'.",
                    "maxStringLength": 128
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                }
            }
        },
        "CSRFRule": {
            "fields": {
                "index": {
                    "type": "uint32",
                    "description": "Rules are processed in order of this index field.",
                    "required": true
                },
                "name": {
                    "type": "string",
                    "description": "A name describing the rule in a short form.",
                    "maxStringLength": 128,
                    "required": true
                },
                "enable": {
                    "type": "bool",
                    "default": true,
                    "description": "Enable or deactivate the rule."
                },
                "match": {
                    "type": "message",
                    "messageType": "MatchTarget",
                    "description": "Match criteria for requests to apply CSRF Action.",
                    "required": true
                },
                "action": {
                    "type": "enum",
                    "enumType": "CSRFAction",
                    "default": "VERIFY_ORIGIN_AND_CSRF_TOKEN",
                    "description": "CSRF Action to be applied for matched target."
                }
            },
            "repeatedKey": "index"
        },
        "CustomIpamDnsProfile": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "required": true
                },
                "name": {
                    "type": "string",
                    "description": "Name of the Custom IPAM DNS Profile.",
                    "maxStringLength": 256,
                    "required": true
                },
                "script_uri": {
                    "type": "string",
                    "description": "Script URI of form controller://ipamdnsscripts/<file-name>, file-name must have a .py extension and conform to PEP8 naming convention.",
                    "required": true
                },
                "script_params": {
                    "type": "message",
                    "messageType": "CustomParams",
                    "repeated": true,
                    "description": "Parameters that are always passed to the IPAM/DNS script."
                },
                "tenant_uuid": {
                    "type": "string",
                    "required": true
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                }
            }
        },
        "DebugServiceEngine": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "required": true
                },
                "name": {
                    "type": "string",
                    "default": "VM name unknown",
                    "maxStringLength": 256
                },
                "seagent_debug": {
                    "type": "message",
                    "messageType": "DebugSeAgent",
                    "repeated": true
                },
                "flags": {
                    "type": "message",
                    "messageType": "DebugSeDataplane",
                    "repeated": true
                },
                "cpu_shares": {
                    "type": "message",
                    "messageType": "DebugSeCpuShares",
                    "repeated": true
                },
                "fault": {
                    "type": "message",
                    "messageType": "DebugSeFault",
                    "description": "Params for SE fault injection."
                },
                "debug_ip": {
                    "type": "message",
                    "messageType": "DebugIpAddr",
                    "description": "Per packet IP filter for Service Engine PCAP. Matches with source and destination address."
                },
                "capture_params": {
                    "type": "message",
                    "messageType": "DebugVirtualServiceCapture",
                    "description": "Params for SE pcap"
                },
                "capture": {
                    "type": "bool",
                    "description": "Enable/disable packet capture."
                },
                "capture_filters": {
                    "type": "message",
                    "messageType": "CaptureFilters",
                    "description": "Per packet capture filters for Debug Service Engine. Not applicable for DOS pcap capture. "
                },
                "selogagent_debug": {
                    "type": "message",
                    "messageType": "DebugSeAgent",
                    "description": "Debug knob for se_log_agent process."
                },
                "enable_kdump": {
                    "type": "bool",
                    "default": false,
                    "description": "Enables the use of kdump on SE. Requires SE Reboot. Applicable only in case of VM Based deployments"
                },
                "benchmark_layer": {
                    "type": "enum",
                    "enumType": "SeBenchmarkLayer",
                    "default": "SE_BENCHMARK_LAYER_NONE",
                    "description": "Toggle and configure the layer to benchmark performance. This can be done at a specific point in the SE packet processing pipeline."
                },
                "benchmark_action": {
                    "type": "enum",
                    "enumType": "SeBenchmarkMode",
                    "default": "SE_BENCHMARK_MODE_DROP",
                    "description": "Action to be invoked at configured layer."
                },
                "benchmark_option": {
                    "type": "enum",
                    "enumType": "SeBenchmarkReflectOption",
                    "default": "SE_BENCHMARK_REFLECT_SWAP_L4",
                    "description": "Configure different reflect modes."
                },
                "benchmark_rss_hash": {
                    "type": "enum",
                    "enumType": "SeBenchmarkRssHash",
                    "default": "SE_BENCHMARK_DISABLE_HASH",
                    "description": "RSS Hash function to be used for packet reflect in TX path."
                },
                "trace_memory": {
                    "type": "message",
                    "messageType": "DebugTraceMemory",
                    "description": "Trace the functions calling memory allocation and free APIs"
                },
                "enable_rpc_timing_profiler": {
                    "type": "bool",
                    "default": false,
                    "description": "Enable profiling time for certain RPC calls"
                },
                "capture_pkt_filter": {
                    "type": "message",
                    "messageType": "CapturePacketFilter",
                    "description": "Per packet capture filters for Debug Service Engine. Not applicable for DOS pcap capture. "
                },
                "objsync": {
                    "type": "message",
                    "messageType": "DebugServiceEngineObjSync",
                    "description": "Objsync specific debug options."
                },
                "mock_dl_fail_obj": {
                    "type": "message",
                    "messageType": "DebugServiceEngineSeDataStoreMockDlFail",
                    "description": "Internal: Mark a specific Incoming Stream Object to be failed."
                },
                "high_cpu_script_config": {
                    "type": "message",
                    "messageType": "DebugServiceEngineSustainedCpuSpike",
                    "description": "Internal: Sustained CPU Data Collection config"
                },
                "tenant_uuid": {
                    "type": "string"
                }
            }
        },
        "DebugServiceEngineSustainedCpuSpike": {
            "fields": {
                "spike_duration": {
                    "type": "uint32",
                    "description": "Time Duration ( in seconds ) to be considered for CPU to be consistently under high load. Should be >= 60s. CPU usage data is collected every 5s",
                    "min": 60,
                    "max": 864000
                },
                "cpu_spike_percent": {
                    "type": "uint32",
                    "description": "Average Percent usage of CPU ( either total and/or percpu ) to be considered for CPU to be under high load",
                    "min": 0,
                    "max": 100
                },
                "sample_duration": {
                    "type": "uint32",
                    "description": "Duration of debug data to be collected. Should be >= 11",
                    "min": 11,
                    "max": 864000
                },
                "sample_cooldown": {
                    "type": "uint32",
                    "description": "Interval between each such script invocation. Should be >= 60",
                    "min": 60,
                    "max": 864000
                },
                "process_names": {
                    "type": "string",
                    "repeated": true,
                    "description": "List of process' name(s) for which debug data should be recorded.",
                    "maxStringLength": 256
                },
                "pids": {
                    "type": "uint32",
                    "repeated": true,
                    "description": "List of process' pid(s) for which debug data should be recorded"
                },
                "cpu_filter": {
                    "type": "string",
                    "description": "cpu(s) filter for which high load will trigger debug data collection. Should be comma seperated with no space ( eg: 0,1,4 ). Ranges can be given ( eg: 2,4-6 )",
                    "maxStringLength": 256
                },
                "dis_enable": {
                    "type": "bool",
                    "default": false,
                    "description": "Toggle High CPU Trigger action. Set to true, to dis-enable High CPU Data Collection Script invocation"
                },
                "manual_start": {
                    "type": "bool",
                    "description": "Invokes High CPU Data Collection on SE for duration of an hour. Alert: Operator will have to manually dis-enable this and manage SE disk-space!"
                }
            }
        },
        "DebugServiceEngineSeDataStoreMockDlFail": {
            "fields": {
                "object_type": {
                    "type": "string",
                    "description": "Incoming Stream Response Object Type to be failed. Eg: 'VirtualServiceSe', 'Pool', 'FileObject', etc",
                    "maxStringLength": 256
                },
                "is_sedatastore_update_rpc": {
                    "type": "bool",
                    "description": "Se Datastore Notification RPC type to be failed. Set true for UPDATE and false for CREATE"
                }
            }
        },
        "DebugServiceEngineObjSync": {
            "fields": {
                "publish_packet_drops": {
                    "type": "uint32",
                    "description": "Drop 1 packet in every n packets."
                },
                "log_level": {
                    "type": "enum",
                    "enumType": "OsyncLogLevel",
                    "default": "LOG_LVL_INFO",
                    "description": "Objsync Logging Verbosity"
                }
            }
        },
        "CapturePacketFilter": {
            "fields": {
                "capture_tcp_filters": {
                    "type": "message",
                    "messageType": "CaptureTCPFilter",
                    "repeated": true,
                    "description": "TCP Params filter. And'ed internally and Or'ed amongst each other. ",
                    "maxRepeatedLength": 20
                }
            }
        },
        "CaptureTCPFilter": {
            "fields": {
                "tcpflag": {
                    "type": "message",
                    "messageType": "CaptureTCPFlags",
                    "description": "TCP flags filter. Or'ed internally and And'ed amongst each other. "
                },
                "host_ip": {
                    "type": "message",
                    "messageType": "DebugIpAddr",
                    "description": "Per packet IP filter for Service Engine PCAP. Matches with source and destination address."
                },
                "eth_proto": {
                    "type": "enum",
                    "enumType": "EtherTypes",
                    "default": "ETH_TYPE_IPV4",
                    "description": "Ethernet Proto filter."
                },
                "src_port_range": {
                    "type": "message",
                    "messageType": "SourcePortAddr",
                    "description": "Source Port range filter."
                },
                "dst_port_range": {
                    "type": "message",
                    "messageType": "DestinationPortAddr",
                    "description": "Destination Port range filter."
                }
            }
        },
        "DestinationPortAddr": {
            "fields": {
                "dst_port_start": {
                    "type": "uint32",
                    "description": "TCP/UDP port range start (inclusive).",
                    "min": 1,
                    "max": 65535
                },
                "dst_port_end": {
                    "type": "uint32",
                    "description": "TCP/UDP port range end (inclusive).",
                    "min": 1,
                    "max": 65535
                },
                "match_operation": {
                    "type": "enum",
                    "enumType": "MatchOperation",
                    "default": "IS_IN",
                    "description": "Match criteria."
                }
            }
        },
        "SourcePortAddr": {
            "fields": {
                "src_port_start": {
                    "type": "uint32",
                    "description": "TCP/UDP port range start (inclusive).",
                    "min": 1,
                    "max": 65535
                },
                "src_port_end": {
                    "type": "uint32",
                    "description": "TCP/UDP port range end (inclusive).",
                    "min": 1,
                    "max": 65535
                },
                "match_operation": {
                    "type": "enum",
                    "enumType": "MatchOperation",
                    "default": "IS_IN",
                    "description": "Match criteria."
                }
            }
        },
        "DebugIpAddr": {
            "fields": {
                "addrs": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "repeated": true
                },
                "ranges": {
                    "type": "message",
                    "messageType": "IpAddrRange",
                    "repeated": true
                },
                "prefixes": {
                    "type": "message",
                    "messageType": "IpAddrPrefix",
                    "repeated": true
                },
                "match_operation": {
                    "type": "enum",
                    "enumType": "MatchOperation",
                    "default": "IS_IN",
                    "description": "Match criteria."
                }
            }
        },
        "CaptureTCPFlags": {
            "fields": {
                "tcp_syn": {
                    "type": "bool",
                    "description": "TCP SYN flag filter."
                },
                "tcp_ack": {
                    "type": "bool",
                    "description": "TCP ACK flag filter."
                },
                "tcp_fin": {
                    "type": "bool",
                    "description": "TCP FIN flag filter."
                },
                "tcp_push": {
                    "type": "bool",
                    "description": "TCP PUSH flag filter."
                },
                "match_operation": {
                    "type": "enum",
                    "enumType": "MatchOperation",
                    "default": "IS_IN",
                    "description": "Match criteria."
                },
                "tcp_rst": {
                    "type": "bool",
                    "description": "TCP RST flag filter."
                },
                "filter_op": {
                    "type": "enum",
                    "enumType": "LogicalOperation",
                    "default": "OR",
                    "description": "Logical operation based filter criteria."
                }
            }
        },
        "DebugTraceMemory": {
            "fields": {
                "trace_malloc_types": {
                    "type": "message",
                    "messageType": "DebugTraceMallocTypes",
                    "repeated": true,
                    "description": "Memory type to be traced for se_malloc and se_free"
                },
                "trace_shm_malloc_types": {
                    "type": "message",
                    "messageType": "DebugTraceShmMallocTypes",
                    "repeated": true,
                    "description": "Memory type to be traced for se_shm_malloc and se_shm_free"
                }
            }
        },
        "DebugTraceShmMallocTypes": {
            "fields": {
                "shm_malloc_type_index": {
                    "type": "uint32",
                    "description": "Memory type to be traced for se_shmalloc and se_shmfree"
                }
            }
        },
        "DebugTraceMallocTypes": {
            "fields": {
                "malloc_type_index": {
                    "type": "uint32",
                    "description": "Memory type to be traced for se_malloc and se_free"
                }
            }
        },
        "DebugSeAgent": {
            "fields": {
                "sub_module": {
                    "type": "enum",
                    "enumType": "DebugControllerModuleType",
                    "required": true
                },
                "trace_level": {
                    "type": "enum",
                    "enumType": "TraceLevel",
                    "required": true
                },
                "log_level": {
                    "type": "enum",
                    "enumType": "LogLevel",
                    "required": true
                },
                "log_every_n": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Log every nth message"
                }
            },
            "repeatedKey": "sub_module"
        },
        "CaptureFilters": {
            "fields": {
                "capture_ip": {
                    "type": "message",
                    "messageType": "DebugIpAddr",
                    "description": "Per packet IP filter. Matches with source and destination address. Curently not applicable for DebugServiceEngine."
                },
                "eth_proto": {
                    "type": "enum",
                    "enumType": "EtherTypes",
                    "description": "Ethernet Proto filter."
                },
                "ip_proto": {
                    "type": "enum",
                    "enumType": "IPTypes",
                    "description": "IP Proto filter. Support for TCP only for now."
                },
                "src_port": {
                    "type": "uint32",
                    "description": "Source Port filter.",
                    "min": 1,
                    "max": 65535
                },
                "dst_port_start": {
                    "type": "uint32",
                    "description": "Destination Port range filter.",
                    "min": 1,
                    "max": 65535
                },
                "dst_port_end": {
                    "type": "uint32",
                    "description": "Destination Port range filter.",
                    "min": 1,
                    "max": 65535
                },
                "tcp_syn": {
                    "type": "bool",
                    "description": "TCP SYN flag filter."
                },
                "tcp_ack": {
                    "type": "bool",
                    "description": "TCP ACK flag filter."
                },
                "tcp_fin": {
                    "type": "bool",
                    "description": "TCP FIN flag filter."
                },
                "tcp_push": {
                    "type": "bool",
                    "description": "TCP PUSH flag filter."
                },
                "capture_ipc": {
                    "type": "message",
                    "messageType": "CaptureIPC",
                    "description": "Capture filter for SE IPC. Not applicable for Debug Virtual Service."
                },
                "src_port_range_end": {
                    "type": "uint32",
                    "description": "Source Port range end filter. If specified, the source port filter will be a range. The filter range will be between src_port and src_port_range_end.",
                    "min": 1,
                    "max": 65535
                }
            }
        },
        "DebugVirtualServiceCapture": {
            "fields": {
                "pkt_size": {
                    "type": "uint32",
                    "default": 128,
                    "description": "Number of bytes of each packet to capture. Use 0 to capture the entire packet.",
                    "min": 64,
                    "max": 1514,
                    "specialValues": {
                        "0": "full capture"
                    }
                },
                "duration": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Number of minutes to capture packets. Use 0 to capture until manually stopped.",
                    "specialValues": {
                        "0": "infinite"
                    }
                },
                "num_pkts": {
                    "type": "uint32",
                    "description": "Total number of packets to capture."
                },
                "enable_ssl_session_key_capture": {
                    "type": "bool",
                    "default": false,
                    "description": "Enable SSL session key capture."
                },
                "pcap_ng": {
                    "type": "bool",
                    "default": true,
                    "description": "Enable PcapNg for packet capture."
                },
                "capture_file_size": {
                    "type": "message",
                    "messageType": "CaptureFileSize",
                    "description": "Maximum allowed size of PCAP Capture File per SE. Max(absolute_size, percentage_size) will be final value. Set both to 0 for avi default size. DOS, IPC and DROP pcaps not applicaple."
                },
                "file_count": {
                    "type": "uint32",
                    "default": 2,
                    "description": "Number of files to maintain for SE pcap file rotation.file count set to 1 indicates no rotate.",
                    "min": 1,
                    "max": 10
                }
            }
        },
        "DebugSeFault": {
            "fields": {
                "se_malloc_fail_type": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Fail this SE malloc type."
                },
                "se_malloc_fail_frequency": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Fail SE malloc type at this frequency."
                },
                "se_shm_malloc_fail_type": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Fail this SE SHM malloc type."
                },
                "se_shm_malloc_fail_frequency": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Fail SE SHM malloc type at this frequency."
                },
                "se_waf_alloc_fail_frequency": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Fail SE WAF allocation at this frequency."
                },
                "se_waf_learning_alloc_fail_frequency": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Fail SE WAF learning allocation at this frequency."
                },
                "se_mbuf_cl_sanity": {
                    "type": "bool",
                    "default": false,
                    "description": "Toggle assert on mbuf cluster sanity check fail."
                },
                "faults": {
                    "type": "message",
                    "messageType": "SeFault",
                    "repeated": true,
                    "description": "Set of faults to enable/disable."
                }
            }
        },
        "SeFault": {
            "fields": {
                "fault_name": {
                    "type": "string",
                    "description": "The name of the target fault.",
                    "required": true
                },
                "function_name": {
                    "type": "string",
                    "description": "The name of the function that contains the target fault."
                },
                "num_executions": {
                    "type": "uint32",
                    "default": 1,
                    "description": "Number of times the fault should be executed.",
                    "min": 1,
                    "max": 4294967295
                },
                "arg": {
                    "type": "uint64",
                    "description": "Optional 64 bit unsigned integer that can be used within the enabled fault."
                },
                "num_skips": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Number of times the fault should be skipped before executing."
                }
            }
        },
        "DebugSeCpuShares": {
            "fields": {
                "cpu": {
                    "type": "uint32",
                    "required": true
                },
                "shares": {
                    "type": "int32",
                    "required": true
                }
            },
            "repeatedKey": "cpu"
        },
        "DebugSeDataplane": {
            "fields": {
                "flag": {
                    "type": "enum",
                    "enumType": "DebugSeDataplaneFlags",
                    "required": true
                }
            },
            "repeatedKey": "flag"
        },
        "DebugVirtualService": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "required": true
                },
                "name": {
                    "type": "string",
                    "required": true,
                    "maxStringLength": 256
                },
                "flags": {
                    "type": "message",
                    "messageType": "DebugVsDataplane",
                    "repeated": true
                },
                "debug_ip": {
                    "type": "message",
                    "messageType": "DebugIpAddr",
                    "description": "Filters all packets of a complete transaction (client and server side), based on client ip."
                },
                "capture": {
                    "type": "bool"
                },
                "capture_params": {
                    "type": "message",
                    "messageType": "DebugVirtualServiceCapture"
                },
                "se_params": {
                    "type": "message",
                    "messageType": "DebugVirtualServiceSeParams"
                },
                "debug_hm": {
                    "type": "enum",
                    "enumType": "DebugVirtualServiceHM",
                    "default": "DEBUG_VS_HM_NONE",
                    "description": "This option controls the capture of Health Monitor flows."
                },
                "dns_options": {
                    "type": "message",
                    "messageType": "DebugDnsOptions",
                    "description": "Dns debug options"
                },
                "capture_filters": {
                    "type": "message",
                    "messageType": "CaptureFilters",
                    "description": "Per packet capture filters for Debug Virtual Service. Applies to both frontend and backend packets."
                },
                "objsync": {
                    "type": "message",
                    "messageType": "DebugVirtualServiceObjSync",
                    "description": "Object sync debug options."
                },
                "capture_pkt_filter": {
                    "type": "message",
                    "messageType": "CapturePacketFilter",
                    "description": "Per packet capture filters for Debug Virtual Service. Applies to both frontend and backend packets."
                },
                "tenant_uuid": {
                    "type": "string"
                },
                "cloud_uuid": {
                    "type": "string",
                    "default": "Default-Cloud",
                    "immutable": true
                },
                "resync_flows": {
                    "type": "bool",
                    "default": false,
                    "description": "This option re-synchronizes flows between Active-Standby service engines for all the virtual services placed on them. It should be used with caution because as it can cause a flood between Active-Standby."
                },
                "latency_audit_filters": {
                    "type": "message",
                    "messageType": "CaptureFilters",
                    "description": "Deprecated in 22.1.1"
                }
            }
        },
        "DebugVirtualServiceObjSync": {
            "fields": {
                "trigger_initial_sync": {
                    "type": "bool",
                    "default": false,
                    "description": "Triggers Initial Sync on all the SEs of this VS."
                }
            }
        },
        "DosRateLimitProfile": {
            "fields": {
                "rl_profile": {
                    "type": "message",
                    "messageType": "RateLimiterProfile",
                    "description": "Profile for Connections/Requests rate limiting."
                },
                "dos_profile": {
                    "type": "message",
                    "messageType": "DosThresholdProfile",
                    "description": "Profile for DoS attack detection."
                }
            }
        },
        "DosThresholdProfile": {
            "fields": {
                "thresh_period": {
                    "type": "int32",
                    "default": 5,
                    "required": true,
                    "description": "Timer value in seconds to collect DoS attack metrics based on threshold on the Service Engine for this Virtual Service."
                },
                "thresh_info": {
                    "type": "message",
                    "messageType": "DosThreshold",
                    "repeated": true,
                    "description": "Attack type, min and max values for DoS attack detection."
                }
            }
        },
        "DosThreshold": {
            "fields": {
                "attack": {
                    "type": "enum",
                    "enumType": "AttackType",
                    "required": true,
                    "description": "Attack type."
                },
                "min_value": {
                    "type": "int32",
                    "required": true,
                    "description": "Minimum number of packets or connections or requests in a given interval of time to be deemed as attack."
                },
                "max_value": {
                    "type": "int32",
                    "required": true,
                    "description": "Maximum number of packets or connections or requests in a given interval of time to be deemed as attack."
                }
            }
        },
        "DnsPolicy": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "description": "UUID of the DNS Policy",
                    "required": true
                },
                "name": {
                    "type": "string",
                    "description": "Name of the DNS Policy",
                    "maxStringLength": 280,
                    "required": true
                },
                "rule": {
                    "type": "message",
                    "messageType": "DnsRule",
                    "repeated": true,
                    "description": "DNS rules"
                },
                "internal": {
                    "type": "bool",
                    "description": "The DNS policy is created and modified by internal modules only. This should not be modified by users."
                },
                "created_by": {
                    "type": "string",
                    "description": "Creator name"
                },
                "markers": {
                    "type": "message",
                    "messageType": "RoleFilterMatchLabel",
                    "repeated": true,
                    "description": "List of labels to be used for granular RBAC.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "description": {
                    "type": "string"
                },
                "tenant_uuid": {
                    "type": "string",
                    "required": true
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                }
            }
        },
        "DnsRule": {
            "fields": {
                "name": {
                    "type": "string",
                    "description": "Name of the rule",
                    "required": true
                },
                "index": {
                    "type": "int32",
                    "description": "Index of the rule",
                    "required": true
                },
                "enable": {
                    "type": "bool",
                    "default": true,
                    "description": "Enable or disable the rule"
                },
                "match": {
                    "type": "message",
                    "messageType": "DnsRuleMatchTarget",
                    "description": "Add match criteria to the rule"
                },
                "action": {
                    "type": "message",
                    "messageType": "DnsRuleAction",
                    "description": "Action to be performed upon successful matching"
                },
                "log": {
                    "type": "bool",
                    "description": "Log DNS query upon rule match"
                }
            },
            "repeatedKey": "index"
        },
        "DnsRuleMatchTarget": {
            "fields": {
                "protocol": {
                    "type": "message",
                    "messageType": "DnsTransportProtocolMatch",
                    "description": "DNS transport protocol match"
                },
                "query_name": {
                    "type": "message",
                    "messageType": "DnsQueryNameMatch",
                    "description": "Domain names to match against query name"
                },
                "query_type": {
                    "type": "message",
                    "messageType": "DnsQueryTypeMatch",
                    "description": "DNS query types to match against request query type"
                },
                "geo_location": {
                    "type": "message",
                    "messageType": "DnsGeoLocationMatch",
                    "description": "Geographical location attribute to match against that of the client IP"
                },
                "client_ip_address": {
                    "type": "message",
                    "messageType": "DnsClientIpMatch",
                    "description": "IP addresses to match against client IP or the EDNS client subnet IP"
                },
                "client_port_numbers": {
                    "type": "message",
                    "messageType": "DnsClientPortMatch",
                    "description": "Port number to match against client port number."
                }
            }
        },
        "DnsClientPortMatch": {
            "fields": {
                "client_ports": {
                    "type": "message",
                    "messageType": "PortMatchGeneric",
                    "description": "Port number to match against client port number in request",
                    "required": true
                }
            }
        },
        "PortMatchGeneric": {
            "fields": {
                "match_criteria": {
                    "type": "enum",
                    "enumType": "MatchOperation",
                    "description": "Criterion to use for src/dest port in a TCP/UDP packet",
                    "required": true
                },
                "ports": {
                    "type": "uint32",
                    "repeated": true,
                    "description": "Listening TCP port(s)",
                    "min": 1,
                    "max": 65535
                },
                "ranges": {
                    "type": "message",
                    "messageType": "PortRange",
                    "repeated": true,
                    "description": "A port range defined by a start and end, including both"
                }
            }
        },
        "DnsClientIpMatch": {
            "fields": {
                "client_ip": {
                    "type": "message",
                    "messageType": "IpAddrMatch",
                    "description": "IP addresses to match against client IP",
                    "required": true
                },
                "use_edns_client_subnet_ip": {
                    "type": "bool",
                    "default": true,
                    "description": "Use the IP address from the EDNS client subnet option, if available, as the source IP address of the client. It should be noted that the edns subnet IP may not be a /32 IP address."
                }
            }
        },
        "DnsGeoLocationMatch": {
            "fields": {
                "match_criteria": {
                    "type": "enum",
                    "enumType": "MatchOperation",
                    "description": "Criterion to use for matching the client IP's geographical location",
                    "required": true
                },
                "use_edns_client_subnet_ip": {
                    "type": "bool",
                    "default": true,
                    "description": "Use the IP address from the EDNS client subnet option, if available, to derive geo location of the DNS query"
                },
                "geolocation_name": {
                    "type": "string",
                    "description": "Geographical location of the client IP to be used in the match. This location is of the format Country/State/City e.g. US/CA/Santa Clara."
                },
                "geolocation_tag": {
                    "type": "string",
                    "description": "Geolocation tag for the client IP. This could be any string value for the client IP, e.g. client IPs from US East Coast geolocation would be tagged as 'East Coast'."
                }
            }
        },
        "DnsQueryTypeMatch": {
            "fields": {
                "match_criteria": {
                    "type": "enum",
                    "enumType": "MatchOperation",
                    "description": "Criterion to use for matching the DNS query typein the question section",
                    "required": true
                },
                "query_type": {
                    "type": "enum",
                    "enumType": "DnsRecordType",
                    "repeated": true,
                    "description": "DNS query types in the request query "
                }
            }
        },
        "DnsQueryNameMatch": {
            "fields": {
                "match_criteria": {
                    "type": "enum",
                    "enumType": "StringOperation",
                    "description": "Criterion to use for string matching the DNS query domain name in the question section",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "BEGINS_WITH,DOES_NOT_BEGIN_WITH,CONTAINS,DOES_NOT_CONTAIN,ENDS_WITH,DOES_NOT_END_WITH,EQUALS,DOES_NOT_EQUAL"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "BEGINS_WITH,DOES_NOT_BEGIN_WITH,CONTAINS,DOES_NOT_CONTAIN,ENDS_WITH,DOES_NOT_END_WITH,EQUALS,DOES_NOT_EQUAL"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "required": true
                },
                "query_domain_names": {
                    "type": "string",
                    "repeated": true,
                    "description": "Domain name to match against that specified in the question section of the DNS query"
                },
                "string_group_uuids": {
                    "type": "string",
                    "repeated": true,
                    "description": "UUID of the string group(s) for matching against DNS query domain name in the question section"
                }
            }
        },
        "DnsTransportProtocolMatch": {
            "fields": {
                "match_criteria": {
                    "type": "enum",
                    "enumType": "MatchOperation",
                    "description": "Criterion to use for matching the DNS transport protocol",
                    "required": true
                },
                "protocol": {
                    "type": "enum",
                    "enumType": "DnsTransportProtocol",
                    "description": "Protocol to match against transport protocol used by DNS query",
                    "required": true
                }
            }
        },
        "DnsRuleAction": {
            "fields": {
                "allow": {
                    "type": "message",
                    "messageType": "DnsRuleActionAllowDrop",
                    "description": "Allow or drop the DNS query"
                },
                "response": {
                    "type": "message",
                    "messageType": "DnsRuleActionResponse",
                    "description": "Generate a response for the DNS query"
                },
                "gslb_site_selection": {
                    "type": "message",
                    "messageType": "DnsRuleActionGslbSiteSelection",
                    "description": "Select a specific GSLB site for the DNS query. This action should be used only when GSLB services have been configured for the DNS virtual service."
                },
                "pool_switching": {
                    "type": "message",
                    "messageType": "DnsRuleActionPoolSwitching",
                    "description": "Select a pool or pool group for the passthrough DNS query which cannot be served locally but could be served by upstream servers."
                },
                "dns_rate_limiter": {
                    "type": "message",
                    "messageType": "DnsRateLimiter",
                    "description": "Rate limits the DNS requests."
                },
                "gs_group_selection": {
                    "type": "message",
                    "messageType": "DnsRuleActionGsGroupSelection",
                    "description": "GSLB Service group to be selected."
                }
            }
        },
        "DnsRuleActionGsGroupSelection": {
            "fields": {
                "group_name": {
                    "type": "string",
                    "description": "GSLB Service group name.",
                    "maxStringLength": 256,
                    "required": true
                }
            }
        },
        "DnsRateLimiter": {
            "fields": {
                "rate_limiter_object": {
                    "type": "message",
                    "messageType": "RateLimiter",
                    "description": "Rate limiting object.",
                    "required": true
                },
                "action": {
                    "type": "message",
                    "messageType": "DnsRuleRLAction",
                    "description": "Action to perform upon rate limiting.",
                    "required": true
                }
            }
        },
        "DnsRuleRLAction": {
            "fields": {
                "type": {
                    "type": "enum",
                    "enumType": "DnsRuleRLActionType",
                    "default": "DNS_RL_ACTION_NONE",
                    "description": "Type of action to be enforced upon hitting the rate limit."
                }
            }
        },
        "RateLimiter": {
            "fields": {
                "count": {
                    "type": "uint32",
                    "default": 1000000000,
                    "description": "Maximum number of connections, requests or packets permitted each period.",
                    "required": true,
                    "min": 1,
                    "max": 1000000000
                },
                "period": {
                    "type": "uint32",
                    "default": 1,
                    "description": "Time value in seconds to enforce rate count.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "1"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "required": true,
                    "min": 1,
                    "max": 1000000000
                },
                "burst_sz": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Maximum number of connections, requests or packets to be let through instantaneously.  If this is less than count, it will have no effect.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "0"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 0,
                    "max": 1000000000
                },
                "name": {
                    "type": "string",
                    "description": "Identifier for Rate Limit. Constructed according to context."
                }
            }
        },
        "DnsRuleActionPoolSwitching": {
            "fields": {
                "pool_uuid": {
                    "type": "string",
                    "description": "Reference of the pool to serve the passthrough DNS query which cannot be served locally."
                },
                "pool_group_uuid": {
                    "type": "string",
                    "description": "Reference of the pool group to serve the passthrough DNS query which cannot be served locally."
                }
            }
        },
        "DnsRuleActionGslbSiteSelection": {
            "fields": {
                "site_name": {
                    "type": "string",
                    "description": "GSLB site name",
                    "required": true
                },
                "is_site_preferred": {
                    "type": "bool",
                    "default": true,
                    "description": "When set to true, GSLB site is a preferred site. This setting comes into play when the site is down, as well as no configured fallback site is available (all fallback sites are also down), then any one available site is selected based on the default algorithm for GSLB pool member selection."
                },
                "fallback_site_names": {
                    "type": "string",
                    "repeated": true,
                    "description": "GSLB fallback sites to use in case the desired site is down.",
                    "maxRepeatedLength": 64
                }
            }
        },
        "DnsRuleActionResponse": {
            "fields": {
                "rcode": {
                    "type": "enum",
                    "enumType": "DnsRcode",
                    "default": "DNS_RCODE_NOERROR",
                    "description": "DNS response code"
                },
                "truncation": {
                    "type": "bool",
                    "default": false,
                    "description": "DNS response is truncated"
                },
                "authoritative": {
                    "type": "bool",
                    "default": true,
                    "description": "DNS response is authoritative"
                },
                "resource_record_sets": {
                    "type": "message",
                    "messageType": "DnsRuleDnsRrSet",
                    "repeated": true,
                    "description": "DNS resource record sets - (resource record set share the DNS domain name, type, and class)"
                }
            }
        },
        "DnsRuleDnsRrSet": {
            "fields": {
                "resource_record_set": {
                    "type": "message",
                    "messageType": "DnsRrSet",
                    "description": "DNS resource record set - (records in the resource record set share the DNS domain name, type, and class)",
                    "required": true
                },
                "section": {
                    "type": "enum",
                    "enumType": "DnsMessageSection",
                    "default": "DNS_MESSAGE_SECTION_ANSWER",
                    "description": "DNS message section for the resource record set"
                }
            }
        },
        "DnsRrSet": {
            "fields": {
                "fqdn": {
                    "type": "string",
                    "description": "Fully Qualified Domain Name",
                    "required": true
                },
                "type": {
                    "type": "enum",
                    "enumType": "DnsRecordType",
                    "description": "DNS record type",
                    "required": true
                },
                "ttl": {
                    "type": "uint32",
                    "description": "Time To Live for this DNS record",
                    "required": true,
                    "min": 0,
                    "max": 2147483647
                },
                "ip_addresses": {
                    "type": "message",
                    "messageType": "DnsARdata",
                    "repeated": true,
                    "description": "IP address in A record"
                },
                "cname": {
                    "type": "message",
                    "messageType": "DnsCnameRdata",
                    "description": "Canonical name in CNAME record"
                },
                "nses": {
                    "type": "message",
                    "messageType": "DnsNsRdata",
                    "repeated": true,
                    "description": "Name Server information in NS record"
                },
                "ip6_addresses": {
                    "type": "message",
                    "messageType": "DnsAAAARdata",
                    "repeated": true,
                    "description": "IPv6 address in AAAA record"
                }
            }
        },
        "DnsAAAARdata": {
            "fields": {
                "ip6_address": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "required": true,
                    "description": "IPv6 address for FQDN"
                }
            }
        },
        "DnsNsRdata": {
            "fields": {
                "nsname": {
                    "type": "string",
                    "required": true,
                    "description": "Name Server name"
                },
                "ip_address": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "description": "IP address for Name Server"
                },
                "ip6_address": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "description": "IPv6 address for Name Server"
                }
            }
        },
        "DnsCnameRdata": {
            "fields": {
                "cname": {
                    "type": "string",
                    "required": true,
                    "description": "Canonical name"
                }
            }
        },
        "DnsARdata": {
            "fields": {
                "ip_address": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "required": true,
                    "description": "IP address for FQDN"
                }
            }
        },
        "DnsRuleActionAllowDrop": {
            "fields": {
                "allow": {
                    "type": "bool",
                    "default": true,
                    "description": "Allow the DNS query"
                },
                "reset_conn": {
                    "type": "bool",
                    "default": true,
                    "description": "Reset the TCP connection of the DNS query, if allow is set to false to drop the query"
                }
            }
        },
        "ErrorPageBody": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "required": true
                },
                "name": {
                    "type": "string",
                    "maxStringLength": 256,
                    "required": true
                },
                "tenant_uuid": {
                    "type": "string"
                },
                "error_page_body": {
                    "type": "string",
                    "description": "Error page body sent to client when match",
                    "required": true
                },
                "format": {
                    "type": "enum",
                    "enumType": "ErrorPageFormat",
                    "default": "ERROR_PAGE_FORMAT_HTML",
                    "description": "Format of an error page body HTML or JSON"
                },
                "markers": {
                    "type": "message",
                    "messageType": "RoleFilterMatchLabel",
                    "repeated": true,
                    "description": "List of labels to be used for granular RBAC.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                }
            }
        },
        "ErrorPageProfile": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "required": true
                },
                "name": {
                    "type": "string",
                    "maxStringLength": 256,
                    "required": true
                },
                "tenant_uuid": {
                    "type": "string"
                },
                "error_pages": {
                    "type": "message",
                    "messageType": "ErrorPage",
                    "repeated": true,
                    "description": "Defined Error Pages for HTTP status codes"
                },
                "markers": {
                    "type": "message",
                    "messageType": "RoleFilterMatchLabel",
                    "repeated": true,
                    "description": "List of labels to be used for granular RBAC.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                }
            }
        },
        "ErrorPage": {
            "fields": {
                "index": {
                    "type": "int32",
                    "description": "Index of the error page"
                },
                "enable": {
                    "type": "bool",
                    "default": true,
                    "description": "Enable or disable the error page"
                },
                "match": {
                    "type": "message",
                    "messageType": "HTTPStatusMatch",
                    "description": "Add match criteria for http status codes to the error page",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "error_page_body_uuid": {
                    "type": "string",
                    "description": "Custom error page body used to sent to the client"
                },
                "error_redirect": {
                    "type": "string",
                    "description": "Redirect sent to client when match"
                }
            },
            "repeatedKey": "index"
        },
        "HTTPStatusMatch": {
            "fields": {
                "match_criteria": {
                    "type": "enum",
                    "enumType": "MatchOperation",
                    "required": true,
                    "description": "Criterion to use for matching the HTTP response status code(s)"
                },
                "status_codes": {
                    "type": "int32",
                    "repeated": true,
                    "description": "HTTP response status code(s)"
                },
                "ranges": {
                    "type": "message",
                    "messageType": "HTTPStatusRange",
                    "repeated": true,
                    "description": "HTTP response status code range(s)"
                }
            }
        },
        "FileObject": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "description": "UUID of the file",
                    "required": true
                },
                "tenant_uuid": {
                    "type": "string",
                    "description": "Tenant that this object belongs to.",
                    "immutable": true,
                    "required": true
                },
                "name": {
                    "type": "string",
                    "description": "Name of the file object. ",
                    "immutable": true,
                    "maxStringLength": 256,
                    "required": true
                },
                "path": {
                    "type": "string",
                    "description": "Path to the file. "
                },
                "size": {
                    "type": "uint64",
                    "description": "Size of the file. "
                },
                "checksum": {
                    "type": "string",
                    "description": "SHA1 checksum of the file. "
                },
                "type": {
                    "type": "enum",
                    "enumType": "FileType",
                    "description": "Type of the file. ",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "OTHER_FILE_TYPES"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "OTHER_FILE_TYPES"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "immutable": true,
                    "required": true
                },
                "read_only": {
                    "type": "bool",
                    "description": "Enforce Read-Only on the file."
                },
                "version": {
                    "type": "string",
                    "description": "Version of the file. "
                },
                "description": {
                    "type": "string",
                    "description": "Description of the file. "
                },
                "created": {
                    "type": "string",
                    "description": "Timestamp of creation for the file. "
                },
                "restrict_download": {
                    "type": "bool",
                    "description": "Flag to allow/restrict download of the file.",
                    "immutable": true
                },
                "is_federated": {
                    "type": "bool",
                    "default": false,
                    "description": "This field describes the object's replication scope. If the field is set to false, then the object is visible within the controller-cluster and its associated service-engines. If the field is set to true, then the object is replicated across the Gslb federation.",
                    "immutable": true
                },
                "compressed": {
                    "type": "bool",
                    "default": false,
                    "description": "This field indicates whether the file is gzip-compressed.",
                    "immutable": true
                },
                "expires_at": {
                    "type": "string",
                    "description": "Timestamp when the CRL contents are no longer valid and hence CRL-file will be no longer needed and can be removed by the system. If this is set, a garbage collector process shall remove the CRL-file after this time. This field is applicable in the CRL context."
                },
                "crl_info": {
                    "type": "message",
                    "messageType": "CRL",
                    "description": "This field contains CRL metadata. "
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                },
                "child_uuids": {
                    "type": "string",
                    "repeated": true,
                    "description": "AVI internal formatted/converted files.",
                    "maxStringLength": 1024
                },
                "events": {
                    "type": "message",
                    "messageType": "FileObjectEventMap",
                    "repeated": true,
                    "description": "List of all FileObject events."
                },
                "has_parent": {
                    "type": "bool",
                    "default": false,
                    "description": "This field indicates if the the given FileObjecthas a parent FileObject or not. ",
                    "immutable": true
                },
                "gslb_geodb_format": {
                    "type": "enum",
                    "enumType": "GslbGeoDbFileFormat",
                    "description": "This field indicates the file format(Avi/Maxmind and v4/v6/v4-v6) of GSLB geodb file type. "
                }
            }
        },
        "FileObjectEventMap": {
            "fields": {
                "task_name": {
                    "type": "string",
                    "description": "Name of the event task",
                    "maxStringLength": 512
                },
                "task_event": {
                    "type": "message",
                    "messageType": "FileObjectEvent",
                    "repeated": true,
                    "description": "Actual event informations"
                }
            }
        },
        "FileObjectEvent": {
            "fields": {
                "start_time": {
                    "type": "string",
                    "description": "Start time of the event. ",
                    "maxStringLength": 512
                },
                "end_time": {
                    "type": "string",
                    "description": "End time of the event. ",
                    "maxStringLength": 512
                },
                "duration": {
                    "type": "uint32",
                    "description": "Time taken to complete the event in seconds."
                },
                "status": {
                    "type": "string",
                    "description": "Event status.",
                    "maxStringLength": 256
                },
                "message": {
                    "type": "string",
                    "description": "Event message if any.",
                    "maxStringLength": 512
                }
            }
        },
        "CRL": {
            "fields": {
                "server_url": {
                    "type": "string",
                    "description": "URL of a server that issues the Certificate Revocation list. If this is configured, CRL will be periodically downloaded either based on the configured update interval or the next update interval in the CRL. CRL itself is stored in the body.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "last_update": {
                    "type": "string",
                    "description": "The date when this CRL was last issued"
                },
                "next_update": {
                    "type": "string",
                    "description": "The date when a newer CRL will be available. Also conveys the date after which the CRL should be considered obsolete."
                },
                "update_interval": {
                    "type": "int32",
                    "default": 1440,
                    "description": "Interval in minutes to check for CRL update. If not specified, interval will be 1 day",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 30,
                    "max": 525600
                },
                "etag": {
                    "type": "string",
                    "description": "Cached etag to optimize the download of the CRL"
                },
                "text": {
                    "type": "string",
                    "description": "Certificate Revocation list in plain text for readability"
                },
                "common_name": {
                    "type": "string",
                    "description": "Common name of the issuer in the Certificate Revocation list"
                },
                "fingerprint": {
                    "type": "string",
                    "description": "Fingerprint of the CRL. Used to avoid configuring duplicates"
                },
                "distinguished_name": {
                    "type": "string",
                    "description": "Distinguished name of the issuer in the Certificate Revocation list"
                },
                "last_refreshed": {
                    "type": "string",
                    "description": "Last time CRL was refreshed by the system. This is an internal field used by the system"
                }
            }
        },
        "GatewayMonitor": {
            "fields": {
                "gateway_ip": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "required": true,
                    "description": "IP address of next hop gateway to be monitored"
                },
                "gateway_monitor_interval": {
                    "type": "uint32",
                    "default": 1000,
                    "description": "The interval between two ping requests sent by the gateway monitor in milliseconds. If a value is not specified, requests are sent every second.",
                    "min": 100,
                    "max": 60000
                },
                "gateway_monitor_fail_threshold": {
                    "type": "uint32",
                    "default": 10,
                    "description": "The number of consecutive failed gateway health checks before a gateway is marked down.",
                    "min": 3,
                    "max": 50
                },
                "gateway_monitor_success_threshold": {
                    "type": "uint32",
                    "default": 15,
                    "description": "The number of consecutive successful gateway health checks before a gateway that was marked down by the gateway monitor is marked up.",
                    "min": 3,
                    "max": 50
                },
                "subnet": {
                    "type": "message",
                    "messageType": "IpAddrPrefix",
                    "description": "Subnet providing reachability for Multi-hop Gateway"
                }
            },
            "repeatedKey": "gateway_ip"
        },
        "GCPEncryptionKeys": {
            "fields": {
                "se_image_kms_key_id": {
                    "type": "string",
                    "description": "CMEK Resource ID to encrypt Service Engine GCE Image."
                },
                "se_disk_kms_key_id": {
                    "type": "string",
                    "description": "CMEK Resource ID to encrypt Service Engine Disks."
                },
                "gcs_bucket_kms_key_id": {
                    "type": "string",
                    "description": "CMEK Resource ID to encrypt Google Cloud Storage Bucket. This Bucket is used to upload Service Engine raw image."
                },
                "gcs_objects_kms_key_id": {
                    "type": "string",
                    "description": "CMEK Resource ID to encrypt Service Engine raw image. The raw image is a Google Cloud Storage Object."
                }
            }
        },
        "GCPVIPAllocation": {
            "fields": {
                "mode": {
                    "type": "enum",
                    "enumType": "GCPVIPAllocationMode",
                    "default": "ROUTES",
                    "description": "VIP Allocation Mode.",
                    "required": true
                },
                "routes": {
                    "type": "message",
                    "messageType": "GCPVIPRoutes",
                    "description": "Configure Google Cloud VPC Routes for VIP. The VIP can either be a static IP or auto allocted from AVI Internal Network. The VIP should not overlap with any of the subnet ranges in Google Cloud VPC."
                },
                "ilb": {
                    "type": "message",
                    "messageType": "GCPVIPILB",
                    "description": "Configure Google Cloud Internal LoadBalancer for VIP. The VIP will be auto allocated from a Google Cloud VPC Subnet."
                }
            }
        },
        "GCPVIPILB": {
            "fields": {
                "cloud_router_names": {
                    "type": "string",
                    "repeated": true,
                    "description": "Google Cloud Router Names to advertise BYOIP."
                }
            }
        },
        "GCPVIPRoutes": {
            "fields": {
                "match_se_group_subnet": {
                    "type": "bool",
                    "default": false,
                    "description": "Match SE group subnets for VIP placement. Default is to not match SE group subnets."
                },
                "route_priority": {
                    "type": "uint32",
                    "default": 2000,
                    "description": "Priority of the routes created in GCP."
                }
            }
        },
        "GeoDB": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "description": "UUID of this object.",
                    "required": true
                },
                "tenant_uuid": {
                    "type": "string",
                    "description": "Tenant that this object belongs to.",
                    "immutable": true,
                    "required": true
                },
                "name": {
                    "type": "string",
                    "description": "Geo Database name.",
                    "maxStringLength": 256,
                    "required": true
                },
                "description": {
                    "type": "string",
                    "description": "Description."
                },
                "is_federated": {
                    "type": "bool",
                    "default": false,
                    "description": "This field indicates that this object is replicated across GSLB federation.",
                    "immutable": true
                },
                "files": {
                    "type": "message",
                    "messageType": "GeoDBFile",
                    "repeated": true,
                    "description": "Geo Database files."
                },
                "mappings": {
                    "type": "message",
                    "messageType": "GeoDBMapping",
                    "repeated": true,
                    "description": "Custom mappings of geo values. All mappings which start with the prefix 'System-' (any case) are reserved for system default objects and may be overwritten."
                }
            }
        },
        "GeoDBMapping": {
            "fields": {
                "name": {
                    "type": "string",
                    "description": "The unique name of the user mapping.",
                    "required": true
                },
                "description": {
                    "type": "string",
                    "description": "Description of the mapping."
                },
                "elements": {
                    "type": "message",
                    "messageType": "GeoDBMappingElement",
                    "repeated": true,
                    "description": "The set of mapping elements.",
                    "required": true
                }
            },
            "repeatedKey": "name"
        },
        "GeoDBMappingElement": {
            "fields": {
                "attribute": {
                    "type": "enum",
                    "enumType": "GeoMappingAttribute",
                    "description": "The attribute to map.",
                    "required": true
                },
                "values": {
                    "type": "string",
                    "repeated": true,
                    "description": "The values to map.",
                    "required": true
                }
            }
        },
        "GeoDBFile": {
            "fields": {
                "index": {
                    "type": "uint32",
                    "description": "Priority of the file - larger number takes precedence.",
                    "required": true
                },
                "name": {
                    "type": "string",
                    "description": "Name of the file.",
                    "required": true
                },
                "enabled": {
                    "type": "bool",
                    "default": true,
                    "description": "If set to false, this file is ignored."
                },
                "vendor": {
                    "type": "enum",
                    "enumType": "GeoDBFileVendor",
                    "description": "Source of the file data.",
                    "required": true
                },
                "file_uuid": {
                    "type": "string",
                    "description": "The file object that contains the geo data. Must be of type 'GeoDB'.",
                    "required": true
                }
            },
            "repeatedKey": "index"
        },
        "Gslb": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "required": true,
                    "description": "UUID of the GSLB object."
                },
                "name": {
                    "type": "string",
                    "required": true,
                    "description": "Name for the GSLB object.",
                    "maxStringLength": 256
                },
                "dns_configs": {
                    "type": "message",
                    "messageType": "DNSConfig",
                    "repeated": true,
                    "description": "Sub domain configuration for the GSLB.  GSLB service's FQDN must be a match one of these subdomains. "
                },
                "sites": {
                    "type": "message",
                    "messageType": "GslbSite",
                    "repeated": true,
                    "description": "Select Avi site member belonging to this Gslb.",
                    "minRepeatedLength": 1
                },
                "leader_cluster_uuid": {
                    "type": "string",
                    "description": "Mark this Site as leader of GSLB configuration. This site is the one among the Avi sites.",
                    "required": true
                },
                "send_interval": {
                    "type": "uint32",
                    "default": 15,
                    "description": "Frequency with which group members communicate.",
                    "min": 1,
                    "max": 3600
                },
                "clear_on_max_retries": {
                    "type": "uint32",
                    "default": 20,
                    "description": "Max retries after which the remote site is treated as a fresh start. In fresh start all the configs are downloaded.",
                    "min": 1,
                    "max": 1024
                },
                "view_id": {
                    "type": "uint64",
                    "default": 0,
                    "description": "The view-id is used in change-leader mode to differentiate partitioned groups while they have the same GSLB namespace. Each partitioned group will be able to operate independently by using the view-id.",
                    "immutable": true
                },
                "third_party_sites": {
                    "type": "message",
                    "messageType": "GslbThirdPartySite",
                    "repeated": true,
                    "description": "Third party site member belonging to this Gslb."
                },
                "client_ip_addr_group": {
                    "type": "message",
                    "messageType": "GslbClientIpAddrGroup",
                    "description": "Group to specify if the client ip addresses are public or private."
                },
                "async_interval": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Frequency with which messages are propagated to Vs Mgr. Value of 0 disables async behavior and RPC are sent inline.",
                    "min": 0,
                    "max": 5
                },
                "error_resync_interval": {
                    "type": "uint32",
                    "default": 300,
                    "description": "Frequency with which errored messages are resynced to follower sites. Value of 0 disables resync behavior.",
                    "min": 60,
                    "max": 3600,
                    "specialValues": {
                        "0": "Disable"
                    }
                },
                "send_interval_prior_to_maintenance_mode": {
                    "type": "uint32",
                    "default": 120,
                    "description": "The user can specify a send-interval while entering maintenance mode. The validity of this 'maintenance send-interval' is only during maintenance mode. When the user leaves maintenance mode, the original send-interval is reinstated. This internal variable is used to store the original send-interval. "
                },
                "maintenance_mode": {
                    "type": "bool",
                    "default": false,
                    "description": "This field disables the configuration operations on the leader for all federated objects.  CUD operations on Gslb, GslbService, GslbGeoDbProfile and other federated objects will be rejected. The rest-api disabling helps in upgrade scenarios where we don't want configuration sync operations to the Gslb member when the member is being upgraded.  This configuration programmatically blocks the leader from accepting new Gslb configuration when member sites are undergoing upgrade. ",
                    "immutable": true
                },
                "is_federated": {
                    "type": "bool",
                    "default": true,
                    "description": "This field indicates that this object is replicated across GSLB federation.",
                    "immutable": true
                },
                "description": {
                    "type": "string"
                },
                "tenant_uuid": {
                    "type": "string",
                    "required": true
                },
                "tenant_scoped": {
                    "type": "bool",
                    "default": true,
                    "description": "This field indicates tenant visibility for GS pool member selection across the Gslb federated objects.Tenant scope can be set only during the Gslb create and cannot be changed once it is set",
                    "immutable": true
                },
                "enable_config_by_members": {
                    "type": "bool",
                    "default": false,
                    "description": "Allows enable/disable of GslbService pool groups and pool members from the gslb follower members."
                },
                "fileobject_max_file_versions": {
                    "type": "uint32",
                    "default": 3,
                    "description": "This is the max number of file versions that will be retained for a file referenced by the federated FileObject. Subsequent uploads of file will result in the file rotation of the older version and the latest version retained. Example: When a file Upload is done for the first time, there will be a v1 version. Subsequent uploads will get mapped to v1, v2 and v3 versions. On the fourth upload of the file, the v1 will be file rotated and v2, v3 and v4 will be retained.",
                    "min": 1,
                    "max": 5
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                },
                "gs_member_fqdn_resolution_on_se": {
                    "type": "bool",
                    "default": false,
                    "description": "If this knob is enabled, GSLB Service member FQDN will be resolved by the service engines hosting the GSLB service. Each service engine will resolve and consume the resolved IP addresses locally."
                },
                "short_probe_interval": {
                    "type": "uint32",
                    "default": 30,
                    "description": "Wait time between two consecutive short probe health checks.",
                    "min": 1,
                    "max": 3600
                },
                "auto_tune_send_interval": {
                    "type": "message",
                    "messageType": "AutoTuneSendInterval",
                    "description": "Automatically set the send interval value based on the load."
                },
                "leader_change_info": {
                    "type": "message",
                    "messageType": "LeaderChangeInfo",
                    "description": "This field has leader change configuration info including mode, leader designate sites and other configurations for auto leader change like max short probe failures"
                }
            }
        },
        "LeaderChangeInfo": {
            "fields": {
                "leader_candidates": {
                    "type": "message",
                    "messageType": "SiteInfo",
                    "repeated": true,
                    "description": "Sites that can be the future Gslb Leader in federation. These sites should be enabled active follower sites.A site that is deactivated or passive or a third-party site cannot be a leader candidate.",
                    "maxRepeatedLength": 1,
                    "maxStringLength": 256
                },
                "leader_change_mode": {
                    "type": "enum",
                    "enumType": "GslbLeaderChangeMode",
                    "default": "GSLB_LC_MODE_MANUAL",
                    "description": "Leader change mode, can be auto or manual"
                },
                "enabled": {
                    "type": "bool",
                    "default": true,
                    "description": "Leader change mechanism can be disabled in the federation for administration purposes. This would effectively disable Gslb disaster recovery possibilities. The best practice is to change the mode (Auto to manual or vice-versa) rather than disabling the leader change mechanism."
                },
                "max_unsuccessful_probes": {
                    "type": "uint32",
                    "default": 15,
                    "description": "Maximum number of probe failures before considering other site as down for auto leader change.",
                    "min": 1,
                    "max": 3600
                }
            }
        },
        "SiteInfo": {
            "fields": {
                "cluster_id": {
                    "type": "string",
                    "description": "Cluster_uuid of a member configured in gslb federation.",
                    "maxStringLength": 256
                },
                "site_name": {
                    "type": "string",
                    "description": "Site name of a member configured in gslb federation",
                    "maxStringLength": 256
                }
            }
        },
        "AutoTuneSendInterval": {
            "fields": {
                "enabled": {
                    "type": "bool",
                    "default": true,
                    "description": "Set the flag to enable auto tune send interval."
                },
                "auto_tune_send_interval_timeout": {
                    "type": "uint32",
                    "default": 300,
                    "description": "Time period to check if the send interval is valid.",
                    "min": 100,
                    "max": 3600
                }
            }
        },
        "GslbClientIpAddrGroup": {
            "fields": {
                "type": {
                    "type": "enum",
                    "enumType": "GslbIpAddrType",
                    "default": "GSLB_IP_PUBLIC",
                    "description": "Specify whether this client IP address range is public or private.",
                    "required": true
                },
                "addrs": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "repeated": true,
                    "description": "Configure IP address(es)"
                },
                "ranges": {
                    "type": "message",
                    "messageType": "IpAddrRange",
                    "repeated": true,
                    "description": "Configure IP address range(s)"
                },
                "prefixes": {
                    "type": "message",
                    "messageType": "IpAddrPrefix",
                    "repeated": true,
                    "description": "Configure IP address prefix(es)"
                }
            }
        },
        "GslbThirdPartySite": {
            "fields": {
                "cluster_uuid": {
                    "type": "string",
                    "description": "Third-party-site identifier generated by Avi."
                },
                "name": {
                    "type": "string",
                    "description": "Name of the third-party Site.",
                    "maxStringLength": 256,
                    "required": true
                },
                "enabled": {
                    "type": "bool",
                    "default": true,
                    "description": "Enable or disable the third-party Site.  This is useful in maintenance scenarios such as upgrade and routine maintenance. A disabled site's configuration shall be retained  but it will not get any new configuration updates.   VIPs associated with the disabled site shall not be sent in DNS response. "
                },
                "location": {
                    "type": "message",
                    "messageType": "GslbGeoLocation",
                    "description": "Geographic location of the site."
                },
                "hm_proxies": {
                    "type": "message",
                    "messageType": "GslbHealthMonitorProxy",
                    "repeated": true,
                    "description": "User can designate certain Avi sites to run health monitor probes for VIPs/VS(es) for this site. This is useful in network deployments where the VIPs/VS(es) are reachable only from certain sites. A typical scenario is a firewall between two GSLB sites. User may want to run health monitor probes from sites on either side of the firewall so that each designated site can derive a datapath view of the reachable members. If the health monitor proxies are not configured, then the default behavior is to run health monitor probes from all the active sites."
                },
                "ratio": {
                    "type": "uint32",
                    "description": "User can overide the individual GslbPoolMember ratio for all the VIPs of this site. If this field is not configured, then the GslbPoolMember ratio gets applied. ",
                    "min": 1,
                    "max": 20
                },
                "uuid": {
                    "type": "string",
                    "description": "This field is used as a key in the datastore for the GslbThirdPartySite table to encapsulate site-related info. "
                }
            },
            "repeatedKey": "name"
        },
        "GslbHealthMonitorProxy": {
            "fields": {
                "proxy_type": {
                    "type": "enum",
                    "enumType": "GslbHealthMonitorProxyType",
                    "default": "GSLB_HEALTH_MONITOR_PROXY_PRIVATE_MEMBERS",
                    "description": "This field identifies the health monitor proxy behavior. The designated site for health monitor proxy can monitor public or private or all the members of a given site. "
                },
                "site_uuid": {
                    "type": "string",
                    "description": "This field identifies the site that will health monitor on behalf of the current site. i.e. it will be a health monitor proxy and monitor members of the current site. "
                }
            }
        },
        "GslbGeoLocation": {
            "fields": {
                "source": {
                    "type": "enum",
                    "enumType": "GslbGeoLocationSource",
                    "description": "This field describes the source of the GeoLocation. ",
                    "required": true
                },
                "location": {
                    "type": "message",
                    "messageType": "GeoLocation",
                    "description": "Geographic location of the site."
                }
            }
        },
        "DNSConfig": {
            "fields": {
                "domain_name": {
                    "type": "string",
                    "description": "GSLB subdomain used for GSLB service FQDN match and placement. ",
                    "required": true
                }
            }
        },
        "GslbIpAddr": {
            "fields": {
                "ip": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "description": "Public IP address of the pool member."
                }
            }
        },
        "GslbGeoDbProfile": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "required": true,
                    "description": "UUID of the geodb profile."
                },
                "name": {
                    "type": "string",
                    "required": true,
                    "description": "A user-friendly name for the geodb profile.",
                    "maxStringLength": 256
                },
                "entries": {
                    "type": "message",
                    "messageType": "GslbGeoDbEntry",
                    "repeated": true,
                    "description": "List of Geodb entries. An entry can either be a geodb file or an ip address group with geo properties. ",
                    "minRepeatedLength": 1
                },
                "markers": {
                    "type": "message",
                    "messageType": "RoleFilterMatchLabel",
                    "repeated": true,
                    "description": "List of labels to be used for granular RBAC.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "is_federated": {
                    "type": "bool",
                    "default": true,
                    "description": "This field indicates that this object is replicated across GSLB federation.",
                    "immutable": true
                },
                "description": {
                    "type": "string"
                },
                "tenant_uuid": {
                    "type": "string",
                    "required": true
                },
                "distance_computation_algorithm": {
                    "type": "enum",
                    "enumType": "GslbDistanceAlgorithm",
                    "default": "GSLB_DISTANCE_AVI_OPTIMISED",
                    "description": "Algorithm to be used for computing distance between geo locations.Only applicable when load balancing algorithm is GSLB_ALGORITHM_GEO."
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                }
            }
        },
        "GslbGeoDbEntry": {
            "fields": {
                "priority": {
                    "type": "uint32",
                    "default": 10,
                    "description": "Priority of this geodb entry. This value should be unique in a repeated list of geodb entries.  Higher the value, then greater is the priority.  ",
                    "min": 1,
                    "max": 100
                },
                "file_obj_uuid": {
                    "type": "string",
                    "description": "This is referred to FileObject that is associtated with the giveb geodb profile.",
                    "maxStringLength": 256
                }
            },
            "repeatedKey": "priority"
        },
        "GslbPoolMember": {
            "fields": {
                "cluster_uuid": {
                    "type": "string",
                    "description": "The Cluster UUID of the Site."
                },
                "vs_uuid": {
                    "type": "string",
                    "description": "Select local virtual service in the specified controller cluster belonging to this GSLB service. The virtual service may have multiple IP addresses and FQDNs.  User will have to choose IP address or FQDN and configure it in the respective field. "
                },
                "fqdn": {
                    "type": "string",
                    "description": "The pool member is configured with a fully qualified domain name.  The FQDN is resolved to an IP address by the controller. DNS service shall health monitor the resolved IP address while it will return the fqdn(cname) in the DNS response.If the user has configured an IP address (in addition to the FQDN), then the IP address will get overwritten whenever periodic FQDN refresh is done by the controller. For GSLB Service of type SRV, this field is treated as target of SRV record data as defined in SRV record specification."
                },
                "ip": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "description": "IP address of the pool member. If this IP address is hosted via an AVI virtual service, then the user should configure the cluster uuid and virtual service uuid. If this IP address is hosted on a third-party device and the device is tagged/tethered to a third-party site, then user can configure the third-party site uuid.  User may configure the IP address without the cluster uuid or the virtual service uuid.  In this option, some advanced site related features cannot be enabled. If the user has configured a fqdn for the pool member, then it takes precedence and will overwrite the configured IP address. "
                },
                "ratio": {
                    "type": "uint32",
                    "default": 1,
                    "description": "Overrides the default ratio of 1.  Reduces the percentage the LB algorithm would pick the server in relation to its peers.  Range is 1-20.",
                    "min": 1,
                    "max": 20
                },
                "enabled": {
                    "type": "bool",
                    "default": true,
                    "description": "Enable or Disable member to decide if this address should be provided in DNS responses."
                },
                "location": {
                    "type": "message",
                    "messageType": "GslbGeoLocation",
                    "description": "Geographic location of the pool member"
                },
                "cloud_uuid": {
                    "type": "string",
                    "description": "The Cloud UUID of the Site."
                },
                "public_ip": {
                    "type": "message",
                    "messageType": "GslbIpAddr",
                    "description": "Alternate IP addresses of the pool member. In usual deployments, the VIP in the virtual service is a private IP address. This gets configured in the 'ip' field of the GSLB service. This field is used to host the public IP address for the VIP, which gets NATed to the private IP by a firewall. Client DNS requests coming in from within the intranet should have the private IP served in the A record, and requests from outside this should be served the public IP address."
                },
                "hostname": {
                    "type": "string",
                    "description": "Hostname to be used as host header for http health monitors and as TLS server name for https health monitors.(By default, the fqdn of the GSLB pool member or GSLB service is used.) Note: this field is not used as http host header when exact_http_request is set in the health monitor. "
                },
                "resolve_fqdn_to_v6": {
                    "type": "bool",
                    "default": false,
                    "description": "This field indicates if the fqdn should be resolved to a v6 or a v4 address family. "
                },
                "description": {
                    "type": "string",
                    "description": "User provided information that records member details such as application owner name, contact, etc."
                },
                "preference_order": {
                    "type": "uint32",
                    "default": 1,
                    "description": "Preference order of this member in the group. The DNS Service chooses the member with the lowest preference that is operationally up.",
                    "min": 1,
                    "max": 128
                },
                "srv_rdata": {
                    "type": "message",
                    "messageType": "GslbServiceSrvRdata",
                    "description": "SRV resource record data for the GSLB service member member."
                }
            },
            "repeatedKey": "fqdn,ip"
        },
        "GslbServiceSrvRdata": {
            "fields": {
                "priority": {
                    "type": "uint32",
                    "description": "Priority of the target hosting the service, low value implies higher priority for this service record.",
                    "required": true,
                    "min": 0,
                    "max": 65535
                },
                "weight": {
                    "type": "uint32",
                    "description": "Relative weight for service records with same priority, high value implies higher preference for this service record.",
                    "required": true,
                    "min": 0,
                    "max": 65535
                },
                "port": {
                    "type": "uint32",
                    "description": "Service port.",
                    "required": true,
                    "min": 0,
                    "max": 65535
                }
            }
        },
        "GslbService": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "required": true,
                    "description": "UUID of the GSLB service."
                },
                "name": {
                    "type": "string",
                    "required": true,
                    "description": "Name for the GSLB service.",
                    "maxStringLength": 256
                },
                "domain_names": {
                    "type": "string",
                    "repeated": true,
                    "description": "Fully qualified domain name of the GSLB service.",
                    "minRepeatedLength": 1
                },
                "groups": {
                    "type": "message",
                    "messageType": "GslbPool",
                    "repeated": true,
                    "description": "Select list of pools belonging to this GSLB service.",
                    "minRepeatedLength": 1
                },
                "num_dns_ip": {
                    "type": "uint32",
                    "description": "Number of IP addresses of this GSLB service to be returned by the DNS Service. Enter 0 to return all IP addresses.",
                    "min": 1,
                    "max": 20,
                    "specialValues": {
                        "0": "Return all IP addresses"
                    }
                },
                "ttl": {
                    "type": "uint32",
                    "description": "TTL value (in seconds) for records served for this GSLB service by the DNS Service.",
                    "min": 0,
                    "max": 86400
                },
                "down_response": {
                    "type": "message",
                    "messageType": "GslbServiceDownResponse",
                    "description": "Response to the client query when the GSLB service is DOWN."
                },
                "health_monitor_uuids": {
                    "type": "string",
                    "repeated": true,
                    "description": "Verify VS health by applying one or more health monitors.  Active monitors generate synthetic traffic from DNS Service Engine and to mark a VS up or down based on the response. ",
                    "maxRepeatedLength": 6
                },
                "controller_health_status_enabled": {
                    "type": "bool",
                    "default": true,
                    "description": "GS member's overall health status is derived based on a combination of controller and datapath health-status inputs. Note that the datapath status is determined by the association of health monitor profiles. Only the controller provided status is determined through this configuration. "
                },
                "health_monitor_scope": {
                    "type": "enum",
                    "enumType": "GslbServiceHealthMonitorScope",
                    "default": "GSLB_SERVICE_HEALTH_MONITOR_ALL_MEMBERS",
                    "description": "Health monitor probe can be executed for all the members or it can be executed only for third-party members. This operational mode is useful to reduce the number of health monitor probes in case of a hybrid scenario. In such a case, Avi members can have controller derived status while Non-Avi members can be probed by via health monitor probes in dataplane."
                },
                "enabled": {
                    "type": "bool",
                    "default": true,
                    "description": "Enable or disable the GSLB service. If the GSLB service is enabled, then the VIPs are sent in the DNS responses based on reachability and configured algorithm. If the GSLB service is disabled, then the VIPs are no longer available in the DNS response."
                },
                "use_edns_client_subnet": {
                    "type": "bool",
                    "default": true,
                    "description": "Use the client ip subnet from the EDNS option as source IPaddress for client geo-location and consistent hash algorithm. Default is true."
                },
                "wildcard_match": {
                    "type": "bool",
                    "default": false,
                    "description": "Enable wild-card match of fqdn: if an exact match is not found in the DNS table, the longest match is chosen by wild-carding the fqdn in the DNS request. Default is false."
                },
                "site_persistence_enabled": {
                    "type": "bool",
                    "default": false,
                    "description": "Enable site-persistence for the GslbService. "
                },
                "application_persistence_profile_uuid": {
                    "type": "string",
                    "description": "The federated application persistence associated with GslbService site persistence functionality. "
                },
                "pool_algorithm": {
                    "type": "enum",
                    "enumType": "GslbServiceAlgorithm",
                    "default": "GSLB_SERVICE_ALGORITHM_PRIORITY",
                    "description": "The load balancing algorithm will pick a GSLB pool within the GSLB service list of available pools."
                },
                "min_members": {
                    "type": "uint32",
                    "default": 0,
                    "description": "The minimum number of members to distribute traffic to.",
                    "min": 1,
                    "max": 65535,
                    "specialValues": {
                        "0": "Disable"
                    }
                },
                "hm_off": {
                    "type": "bool",
                    "description": "This field is an internal field and is used in SE."
                },
                "resolve_cname": {
                    "type": "bool",
                    "default": false,
                    "description": "This field indicates that for a CNAME query, respond with resolved CNAMEs in the additional section with A records."
                },
                "pki_profile_uuid": {
                    "type": "string",
                    "description": "PKI profile associated with the Gslb Service.",
                    "maxStringLength": 256
                },
                "markers": {
                    "type": "message",
                    "messageType": "RoleFilterMatchLabel",
                    "repeated": true,
                    "description": "List of labels to be used for granular RBAC.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "is_federated": {
                    "type": "bool",
                    "default": true,
                    "description": "This field indicates that this object is replicated across GSLB federation.",
                    "immutable": true
                },
                "created_by": {
                    "type": "string",
                    "description": "Creator name"
                },
                "description": {
                    "type": "string"
                },
                "tenant_uuid": {
                    "type": "string",
                    "required": true
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                },
                "topology_policy_enabled": {
                    "type": "bool",
                    "default": false,
                    "description": "When enabled, topology policy rules are used for member selection first. If no valid member is found using the topology policy rules, configured GSLB algorithms for pool selection and member selection are used."
                },
                "record_type": {
                    "type": "enum",
                    "enumType": "GslbServiceRecordType",
                    "default": "GSLB_SERVICE_RECORD_TYPE_A_AAAA_CNAME",
                    "description": "Field to specify the type of GSLB service.",
                    "immutable": true
                },
                "include_additional_records": {
                    "type": "bool",
                    "default": false,
                    "description": "If enabled, provide the SRV target's resolved IP in the response SRV GSLB service."
                },
                "vrf_uuid_for_gs": {
                    "type": "string",
                    "description": "VRF name of the DNS VS to which this GS is bound to. In case it is bound to multiple DNS VSes on the SE, this field will be inherited from the first DNS VS in the configuration order.",
                    "maxStringLength": 128
                }
            }
        },
        "GslbServiceDownResponse": {
            "fields": {
                "type": {
                    "type": "enum",
                    "enumType": "GslbServiceDownResponseType",
                    "default": "GSLB_SERVICE_DOWN_RESPONSE_NONE",
                    "description": "Response from DNS service towards the client when the GSLB service is DOWN.",
                    "required": true
                },
                "fallback_ip": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "description": "Fallback IP address to use in A response to the client query when the GSLB service is DOWN."
                },
                "fallback_ip6": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "description": "Fallback IPV6 address to use in AAAA response to the client query when the GSLB service is DOWN."
                },
                "fallback_cname": {
                    "type": "string",
                    "description": "Fallback CNAME to use in response to the client query when the GSLB service is DOWN.",
                    "maxStringLength": 253
                },
                "public_fallback_ip": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "description": "Fallback IP address to use in A response to the client having public IP when the GSLB service is DOWN or when no public pool is available."
                },
                "public_fallback_ip6": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "description": "Fallback IPV6 address to use in AAAA response to the client having public IP when the GSLB service is DOWN or when no public pool is available."
                }
            }
        },
        "GslbPool": {
            "fields": {
                "name": {
                    "type": "string",
                    "description": "Name of the GSLB service pool.",
                    "required": true
                },
                "priority": {
                    "type": "uint32",
                    "default": 10,
                    "description": "Priority of this pool of Members. The higher the number, the higher is the priority of the pool. The DNS Service chooses the pool with the highest priority that is operationally up.",
                    "min": 0,
                    "max": 100,
                    "specialValues": {
                        "0": "Do not choose members from this pool.A priority of 0 is equivalent to disabling the pool."
                    }
                },
                "algorithm": {
                    "type": "enum",
                    "enumType": "GslbAlgorithm",
                    "default": "GSLB_ALGORITHM_ROUND_ROBIN",
                    "description": "The load balancing algorithm will pick a local member within the GSLB service list of available Members.",
                    "required": true
                },
                "consistent_hash_mask": {
                    "type": "uint32",
                    "description": "Mask to be applied on client IP for consistent hash algorithm.",
                    "min": 1,
                    "max": 31
                },
                "members": {
                    "type": "message",
                    "messageType": "GslbPoolMember",
                    "repeated": true,
                    "description": "Select list of VIPs belonging to this GSLB service.",
                    "minRepeatedLength": 1
                },
                "enabled": {
                    "type": "bool",
                    "default": true,
                    "description": "Enable or disable a GSLB service pool."
                },
                "fallback_algorithm": {
                    "type": "enum",
                    "enumType": "GslbAlgorithm",
                    "description": "The fallback load balancing algorithm used to pick a member when the pool algorithm fails to find a valid member. For instance when algorithm is Geo and client/server do not have valid geo location."
                },
                "consistent_hash_mask6": {
                    "type": "uint32",
                    "description": "Mask to be applied on client IPV6 address for consistent hash algorithm.",
                    "min": 1,
                    "max": 127
                },
                "min_health_monitors_up": {
                    "type": "uint32",
                    "description": "Minimum number of health monitors in UP state to mark the member UP."
                },
                "manual_resume": {
                    "type": "bool",
                    "default": false,
                    "description": "Manually resume traffic to a pool member once it goes down. If enabled a pool member once goes down is kept in admin down state unless admin re enables it"
                },
                "gslb_pool_type": {
                    "type": "enum",
                    "enumType": "GslbPoolType",
                    "default": "GSLB_POOL_TYPE_GENERIC",
                    "description": "Specifies the pool type (GENERIC/PRIVATE/PUBLIC). The public IPs of the members can be specified in seperate pool of type PUBLIC.This would allow features like health monitoring to be enabled independently for the public IPs."
                },
                "description": {
                    "type": "string",
                    "description": "User provided information that records member details such as application owner name, contact, etc."
                }
            }
        },
        "GslbSite": {
            "fields": {
                "cluster_uuid": {
                    "type": "string",
                    "description": "UUID of the 'Cluster' object of the Controller Cluster in this site.",
                    "required": true
                },
                "name": {
                    "type": "string",
                    "description": "Name for the Site Controller Cluster. After any changes to site name, references to GSLB site name should be updated manually. Ex: Site name used in DNS policies or Topology policies should be updated to use the new site name.",
                    "maxStringLength": 256,
                    "required": true
                },
                "address": {
                    "type": "string",
                    "description": "IP Address or a DNS resolvable, fully qualified domain name of the Site Controller Cluster."
                },
                "ip_addresses": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "repeated": true,
                    "description": "IP Address(es) of the Site's Cluster. For a 3-node cluster, either the cluster vIP is provided, or the list of controller IPs in the cluster are provided.",
                    "maxRepeatedLength": 3,
                    "minRepeatedLength": 0
                },
                "port": {
                    "type": "uint32",
                    "default": 443,
                    "description": "The Site Controller Cluster's REST API port number.",
                    "min": 1,
                    "max": 65535
                },
                "username": {
                    "type": "string",
                    "description": "The username used when authenticating with the Site. ",
                    "required": true
                },
                "password": {
                    "type": "string",
                    "description": "The password used when authenticating with the Site.",
                    "required": true
                },
                "member_type": {
                    "type": "enum",
                    "enumType": "SiteMemberType",
                    "default": "GSLB_PASSIVE_MEMBER",
                    "description": "The site's member type: A leader is set to ACTIVE while allmembers are set to passive. "
                },
                "enabled": {
                    "type": "bool",
                    "default": true,
                    "description": "Enable or disable the Site.  This is useful in maintenance scenarios such as upgrade and routine maintenance.  A disabled site's configuration shall be retained but it will not get any new configuration updates.  It shall not participate in Health-Status monitoring.  VIPs of the Virtual Services on the disabled site shall not be sent in DNS response.  When a site transitions from disabled to enabled, it is treated similar to the addition of a new site."
                },
                "location": {
                    "type": "message",
                    "messageType": "GslbGeoLocation",
                    "description": "Geographic location of the site."
                },
                "hm_proxies": {
                    "type": "message",
                    "messageType": "GslbHealthMonitorProxy",
                    "repeated": true,
                    "description": "User can designate certain Avi sites to run health monitor probes for VIPs/VS(es) for this site. This is useful in network deployments where the VIPs/VS(es) are reachable only from certain sites. A typical scenario is a firewall between two GSLB sites. User may want to run health monitor probes from sites on either side of the firewall so that each designated site can derive a datapath view of the reachable members. If the health monitor proxies are not configured, then the default behavior is to run health monitor probes from all the active sites."
                },
                "ratio": {
                    "type": "uint32",
                    "description": "User can overide the individual GslbPoolMember ratio for all the VIPs/VS(es) of this site. If this field is not  configured then the GslbPoolMember ratio gets applied. ",
                    "min": 1,
                    "max": 20
                },
                "dns_vses": {
                    "type": "message",
                    "messageType": "GslbSiteDnsVs",
                    "repeated": true,
                    "description": "This field identifies the DNS VS and the subdomains it hosts for Gslb services. "
                },
                "uuid": {
                    "type": "string",
                    "description": "This field is used as a key in the datastore for the GslbSite table to encapsulate site-related info. "
                },
                "hm_shard_enabled": {
                    "type": "bool",
                    "default": false,
                    "description": "This field enables the health monitor shard functionality on a site-basis."
                },
                "suspend_mode": {
                    "type": "bool",
                    "default": false,
                    "description": "This modes applies to follower sites. When an active site is in suspend mode, the site does not receive any further federated objects."
                },
                "replication_policy": {
                    "type": "message",
                    "messageType": "ReplicationPolicy",
                    "description": "Policy for replicating configuration to the follower sites."
                }
            },
            "repeatedKey": "cluster_uuid"
        },
        "ReplicationPolicy": {
            "fields": {
                "replication_mode": {
                    "type": "enum",
                    "enumType": "ReplicationMode",
                    "default": "REPLICATION_MODE_CONTINUOUS",
                    "description": "Replication mode."
                }
            }
        },
        "GslbSiteDnsVs": {
            "fields": {
                "dns_vs_uuid": {
                    "type": "string",
                    "description": "This field identifies the DNS VS uuid for this site.",
                    "required": true
                },
                "domain_names": {
                    "type": "string",
                    "repeated": true,
                    "description": "This field identifies the subdomains that are hosted on the DNS VS. GslbService(s) whose FQDNs map to one of the subdomains will be hosted on this DNS VS. If no subdomains are configured, then the default behavior is to host all the GslbServices on this DNS VS."
                }
            }
        },
        "HardwareSecurityModuleGroup": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "required": true,
                    "description": "UUID of the HSM Group configuration object"
                },
                "name": {
                    "type": "string",
                    "required": true,
                    "description": "Name of the HSM Group configuration object",
                    "maxStringLength": 256
                },
                "hsm": {
                    "type": "message",
                    "messageType": "HardwareSecurityModule",
                    "required": true,
                    "description": "Hardware Security Module configuration"
                },
                "markers": {
                    "type": "message",
                    "messageType": "RoleFilterMatchLabel",
                    "repeated": true,
                    "description": "List of labels to be used for granular RBAC.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "tenant_uuid": {
                    "type": "string",
                    "required": true
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                },
                "ca_certs": {
                    "type": "message",
                    "messageType": "SSLCertificate",
                    "repeated": true,
                    "description": "List of certificates present in the CA chain that were used to sign custom client certificate"
                }
            }
        },
        "HardwareSecurityModule": {
            "fields": {
                "type": {
                    "type": "enum",
                    "enumType": "HSMType",
                    "default": "HSM_TYPE_SAFENET_LUNA",
                    "required": true,
                    "description": "HSM type to use"
                },
                "rfs": {
                    "type": "message",
                    "messageType": "HSMThalesRFS",
                    "description": "Thales Remote File Server (RFS), used for the netHSMs, configuration"
                },
                "nethsm": {
                    "type": "message",
                    "messageType": "HSMThalesNetHsm",
                    "repeated": true,
                    "description": "Thales netHSM specific configuration"
                },
                "sluna": {
                    "type": "message",
                    "messageType": "HSMSafenetLuna",
                    "description": "Thales Luna HSM/Gem specific configuration"
                },
                "cloudhsm": {
                    "type": "message",
                    "messageType": "HSMAwsCloudHsm",
                    "description": "AWS CloudHSM specific configuration"
                }
            }
        },
        "HSMAwsCloudHsm": {
            "fields": {
                "cluster_cert": {
                    "type": "string",
                    "description": "AWS CloudHSM Cluster Certificate"
                },
                "hsm_ip": {
                    "type": "string",
                    "repeated": true,
                    "description": "IP address of the HSM in the cluster. If there are more than one HSMs, only one is sufficient"
                },
                "client_config": {
                    "type": "string"
                },
                "mgmt_config": {
                    "type": "string"
                },
                "crypto_user_name": {
                    "type": "string",
                    "description": "Username of the Crypto User. This will be used to access the keys on the HSM "
                },
                "crypto_user_password": {
                    "type": "string",
                    "description": "Password of the Crypto User. This will be used to access the keys on the HSM "
                }
            }
        },
        "HSMSafenetLuna": {
            "fields": {
                "server": {
                    "type": "message",
                    "messageType": "HSMSafenetLunaServer",
                    "repeated": true,
                    "description": "SafeNet/Gemalto HSM Servers used for crypto operations"
                },
                "is_ha": {
                    "type": "bool",
                    "default": false,
                    "required": true,
                    "description": "Set to indicate HA across more than one servers"
                },
                "ha_group_num": {
                    "type": "uint64",
                    "description": "Group Number of generated HA Group",
                    "immutable": true
                },
                "node_info": {
                    "type": "message",
                    "messageType": "HSMSafenetClientInfo",
                    "repeated": true,
                    "description": "Node specific information"
                },
                "server_pem": {
                    "type": "string",
                    "description": "Generated File - server.pem"
                },
                "use_dedicated_network": {
                    "type": "bool",
                    "default": false,
                    "description": "If enabled, dedicated network is used to communicate with HSM,else, the management network is used."
                }
            }
        },
        "HSMSafenetClientInfo": {
            "fields": {
                "client_priv_key": {
                    "type": "string",
                    "description": "Client Private Key generated by createCert. User can also add their own CA-signed certificate's private key"
                },
                "client_cert": {
                    "type": "string",
                    "description": "Client Certificate generated by createCert. User can also add their own CA-signed client certificate"
                },
                "client_ip": {
                    "type": "string",
                    "required": true,
                    "description": "Name prepended to client key and certificate filename"
                },
                "chrystoki_conf": {
                    "type": "string",
                    "description": "Generated File - Chrystoki.conf ",
                    "immutable": true
                },
                "session_major_number": {
                    "type": "uint32",
                    "description": "Major number of the sesseion",
                    "immutable": true
                },
                "session_minor_number": {
                    "type": "uint32",
                    "description": "Minor number of the sesseion",
                    "immutable": true
                }
            },
            "repeatedKey": "client_ip"
        },
        "HSMSafenetLunaServer": {
            "fields": {
                "remote_ip": {
                    "type": "string",
                    "required": true,
                    "description": "IP address of the Thales Luna HSM device"
                },
                "server_cert": {
                    "type": "string",
                    "required": true,
                    "description": "CA certificate of the server"
                },
                "partition_passwd": {
                    "type": "string",
                    "description": "Password of the partition assigned to this client"
                },
                "partition_serial_number": {
                    "type": "string",
                    "description": "Serial number of the partition assigned to this client."
                },
                "index": {
                    "type": "uint32",
                    "required": true
                }
            },
            "repeatedKey": "index"
        },
        "HSMThalesNetHsm": {
            "fields": {
                "remote_ip": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "required": true,
                    "description": "IP address of the netHSM device"
                },
                "remote_port": {
                    "type": "uint32",
                    "default": 9004,
                    "description": "Port at which the netHSM device accepts the connection",
                    "min": 1,
                    "max": 65535
                },
                "esn": {
                    "type": "string",
                    "required": true,
                    "description": "Electronic serial number of the netHSM device. Use Thales anonkneti utility to find the netHSM ESN"
                },
                "module_id": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Local module id of the netHSM device"
                },
                "keyhash": {
                    "type": "string",
                    "required": true,
                    "description": "Hash of the key that netHSM device uses to authenticate itself. Use Thales anonkneti utility to find the netHSM keyhash"
                },
                "priority": {
                    "type": "uint32",
                    "default": 100,
                    "required": true,
                    "description": "Priority class of the nethsm in an high availability setup. 1 is the highest priority and 100 is the lowest priority",
                    "min": 1,
                    "max": 100
                }
            }
        },
        "HSMThalesRFS": {
            "fields": {
                "ip": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "required": true,
                    "description": "IP address of the RFS server from where to sync the Thales encrypted private key"
                },
                "port": {
                    "type": "uint32",
                    "default": 9004,
                    "description": "Port at which the RFS server accepts the sync request from clients for Thales encrypted private key",
                    "min": 1,
                    "max": 65535
                }
            }
        },
        "HealthMonitor": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "required": true,
                    "description": "UUID of the health monitor."
                },
                "name": {
                    "type": "string",
                    "required": true,
                    "description": "A user friendly name for this health monitor.",
                    "maxStringLength": 256
                },
                "send_interval": {
                    "type": "int32",
                    "default": 10,
                    "description": "Frequency, in seconds, that monitors are sent to a server.",
                    "min": 1,
                    "max": 3600
                },
                "receive_timeout": {
                    "type": "int32",
                    "default": 4,
                    "description": "A valid response from the server is expected within the receive timeout window.  This timeout must be less than the send interval.  If server status is regularly flapping up and down, consider increasing this value.",
                    "min": 1,
                    "max": 2400
                },
                "successful_checks": {
                    "type": "int32",
                    "default": 2,
                    "description": "Number of continuous successful health checks before server is marked up.",
                    "min": 1,
                    "max": 50
                },
                "failed_checks": {
                    "type": "int32",
                    "default": 2,
                    "description": "Number of continuous failed health checks before the server is marked down.",
                    "min": 1,
                    "max": 50
                },
                "type": {
                    "type": "enum",
                    "enumType": "HealthMonitorType",
                    "required": true,
                    "description": "Type of the health monitor.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "HEALTH_MONITOR_PING,HEALTH_MONITOR_TCP,HEALTH_MONITOR_UDP"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "HEALTH_MONITOR_PING,HEALTH_MONITOR_TCP,HEALTH_MONITOR_UDP,HEALTH_MONITOR_HTTP,HEALTH_MONITOR_HTTPS"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "immutable": true
                },
                "tcp_monitor": {
                    "type": "message",
                    "messageType": "HealthMonitorTcp"
                },
                "http_monitor": {
                    "type": "message",
                    "messageType": "HealthMonitorHttp",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "https_monitor": {
                    "type": "message",
                    "messageType": "HealthMonitorHttp",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "external_monitor": {
                    "type": "message",
                    "messageType": "HealthMonitorExternal"
                },
                "udp_monitor": {
                    "type": "message",
                    "messageType": "HealthMonitorUdp"
                },
                "dns_monitor": {
                    "type": "message",
                    "messageType": "HealthMonitorDNS",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "monitor_port": {
                    "type": "int32",
                    "description": "Use this port instead of the port defined for the server in the Pool. If the monitor succeeds to this port, the load balanced traffic will still be sent to the port of the server defined within the Pool.",
                    "immutable": true,
                    "min": 1,
                    "max": 65535,
                    "specialValues": {
                        "0": "Use server port"
                    }
                },
                "sip_monitor": {
                    "type": "message",
                    "messageType": "HealthMonitorSIP",
                    "description": "Health monitor for SIP.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "radius_monitor": {
                    "type": "message",
                    "messageType": "HealthMonitorRadius",
                    "description": "Health monitor for Radius.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "disable_quickstart": {
                    "type": "bool",
                    "description": "During addition of a server or healthmonitors or during bootup, Avi performs sequential health checks rather than waiting for send-interval to kick in, to mark the server up as soon as possible. This knob may be used to turn this feature off.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "allow_duplicate_monitors": {
                    "type": "bool",
                    "description": "By default, multiple instances of the same healthmonitor to the same server are suppressed intelligently. In rare cases, the monitor may have specific constructs that go beyond the server keys (ip, port, etc.) during which such suppression is not desired. Use this knob to allow duplicates.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "true"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "true"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "immutable": true
                },
                "authentication": {
                    "type": "message",
                    "messageType": "HealthMonitorAuthInfo",
                    "description": "Authentication information for username/password.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "smtp_monitor": {
                    "type": "message",
                    "messageType": "HealthMonitorSmtp",
                    "description": "Health monitor for SMTP."
                },
                "smtps_monitor": {
                    "type": "message",
                    "messageType": "HealthMonitorSmtp",
                    "description": "Health monitor for SMTPS."
                },
                "pop3_monitor": {
                    "type": "message",
                    "messageType": "HealthMonitorPop3",
                    "description": "Health monitor for POP3."
                },
                "pop3s_monitor": {
                    "type": "message",
                    "messageType": "HealthMonitorPop3",
                    "description": "Health monitor for POP3S."
                },
                "imap_monitor": {
                    "type": "message",
                    "messageType": "HealthMonitorImap",
                    "description": "Health monitor for IMAP."
                },
                "imaps_monitor": {
                    "type": "message",
                    "messageType": "HealthMonitorImap",
                    "description": "Health monitor for IMAPS."
                },
                "markers": {
                    "type": "message",
                    "messageType": "RoleFilterMatchLabel",
                    "repeated": true,
                    "description": "List of labels to be used for granular RBAC.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "ftp_monitor": {
                    "type": "message",
                    "messageType": "HealthMonitorFtp",
                    "description": "Health monitor for FTP."
                },
                "ftps_monitor": {
                    "type": "message",
                    "messageType": "HealthMonitorFtp",
                    "description": "Health monitor for FTPS."
                },
                "ldap_monitor": {
                    "type": "message",
                    "messageType": "HealthMonitorLdap",
                    "description": "Health monitor for LDAP."
                },
                "ldaps_monitor": {
                    "type": "message",
                    "messageType": "HealthMonitorLdap",
                    "description": "Health monitor for LDAPS."
                },
                "http2_monitor": {
                    "type": "message",
                    "messageType": "HealthMonitorHttp",
                    "description": "Health monitor for HTTP2."
                },
                "http2s_monitor": {
                    "type": "message",
                    "messageType": "HealthMonitorHttp",
                    "description": "Health monitor for HTTP2S."
                },
                "is_federated": {
                    "type": "bool",
                    "default": false,
                    "description": "This field describes the object's replication scope. If the field is set to false, then the object is visible within the controller-cluster and its associated service-engines.  If the field is set to true, then the object is replicated across the federation.  ",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "immutable": true
                },
                "description": {
                    "type": "string"
                },
                "tenant_uuid": {
                    "type": "string",
                    "required": true
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                },
                "sctp_monitor": {
                    "type": "message",
                    "messageType": "HealthMonitorSctp",
                    "description": "Health monitor for SCTP."
                },
                "monitor_ip": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "description": "Destination IP Address to be monitored instead of the pool member IP.",
                    "immutable": true
                }
            }
        },
        "HealthMonitorSctp": {
            "fields": {
                "sctp_request": {
                    "type": "string",
                    "description": "Request data to send after completing the SCTP handshake.",
                    "maxStringLength": 1024
                },
                "sctp_response": {
                    "type": "string",
                    "description": "Match for the desired keyword in the first 2Kb of the server's SCTP response. If this field is left blank, no server response is required.",
                    "maxStringLength": 512
                }
            }
        },
        "HealthMonitorHttp": {
            "fields": {
                "http_request": {
                    "type": "string",
                    "default": "GET / HTTP/1.0",
                    "description": "Send an HTTP request to the server.  The default GET / HTTP/1.0 may be extended with additional headers or information.  For instance, GET /index.htm HTTP/1.1 Host: www.site.com Connection: Close",
                    "maxStringLength": 1024
                },
                "http_response_code": {
                    "type": "enum",
                    "enumType": "HttpResponseCode",
                    "repeated": true,
                    "description": "List of HTTP response codes to match as successful.  Default is 2xx.",
                    "minRepeatedLength": 1
                },
                "http_response": {
                    "type": "string",
                    "description": "Match for a keyword in the first 2Kb of the server header and body response.",
                    "maxStringLength": 512
                },
                "maintenance_code": {
                    "type": "uint32",
                    "repeated": true,
                    "description": "Match or look for this HTTP response code indicating server maintenance.  A successful match results in the server being marked down.",
                    "maxRepeatedLength": 4,
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 101,
                    "max": 599
                },
                "maintenance_response": {
                    "type": "string",
                    "description": "Match or look for this keyword in the first 2KB of server header and body response indicating server maintenance.  A successful match results in the server being marked down.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "maxStringLength": 512
                },
                "ssl_attributes": {
                    "type": "message",
                    "messageType": "HealthMonitorSSLAttributes",
                    "description": "SSL attributes for HTTPS health monitor."
                },
                "exact_http_request": {
                    "type": "bool",
                    "default": false,
                    "description": "Use the exact http_request string as specified by user, without any automatic insert of headers like Host header."
                },
                "auth_type": {
                    "type": "enum",
                    "enumType": "HealthMonitorAuthType",
                    "description": "Type of the authentication method.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "http_request_body": {
                    "type": "string",
                    "description": "HTTP request body.",
                    "maxStringLength": 5120
                },
                "response_size": {
                    "type": "uint32",
                    "description": "Expected http/https response page size.",
                    "min": 2048,
                    "max": 16384
                },
                "http_method": {
                    "type": "enum",
                    "enumType": "HTTPMethod",
                    "description": "HTTP method for HTTP2 and HTTP2S health monitor.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "HTTP_METHOD_GET,HTTP_METHOD_POST,HTTP_METHOD_HEAD"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "HTTP_METHOD_GET,HTTP_METHOD_POST,HTTP_METHOD_HEAD"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "http_request_header_path": {
                    "type": "string",
                    "description": "HTTP client request header path for HTTP2 and HTTP2S health monitor",
                    "maxStringLength": 1024
                },
                "http_headers": {
                    "type": "string",
                    "repeated": true,
                    "description": "For HTTP2 and HTTP2S health monitor, send an HTTP request to the server. Extended with additional headers or information when exact request is marked false. For instance Host: www.site.com Connection: Close",
                    "maxStringLength": 1024
                }
            }
        },
        "HealthMonitorSSLAttributes": {
            "fields": {
                "ssl_profile_uuid": {
                    "type": "string",
                    "description": "SSL profile defines ciphers and SSL versions to be used for healthmonitor traffic to the back-end servers.",
                    "required": true
                },
                "pki_profile_uuid": {
                    "type": "string",
                    "description": "PKI profile used to validate the SSL certificate presented by a server."
                },
                "ssl_key_and_certificate_uuid": {
                    "type": "string",
                    "description": "Service engines will present this SSL certificate to the server."
                },
                "server_name": {
                    "type": "string",
                    "description": "Fully qualified DNS hostname which will be used in the TLS SNI extension in server connections indicating SNI is enabled."
                },
                "use_pool_sni_server_name": {
                    "type": "bool",
                    "description": "Use the SNI server name configured in the Pool. This will override the server_name configured in the Health Monitor."
                }
            }
        },
        "HealthMonitorLdap": {
            "fields": {
                "base_dn": {
                    "type": "string",
                    "description": "DN(Distinguished Name) of a directory entry. which will be starting point of the search.",
                    "maxStringLength": 256,
                    "required": true
                },
                "attributes": {
                    "type": "string",
                    "description": "Attributes which will be retrieved. commas can be used to delimit more than one attributes (example- cn,address,email).",
                    "maxStringLength": 256
                },
                "scope": {
                    "type": "enum",
                    "enumType": "LdapScopeType",
                    "description": "Search scope which can be base, one, sub.",
                    "maxStringLength": 256
                },
                "filter": {
                    "type": "string",
                    "description": "Filter to search entries in specified scope.",
                    "maxStringLength": 256
                },
                "ssl_attributes": {
                    "type": "message",
                    "messageType": "HealthMonitorSSLAttributes",
                    "description": "SSL attributes for LDAPS monitor"
                }
            }
        },
        "HealthMonitorFtp": {
            "fields": {
                "filename": {
                    "type": "string",
                    "description": "Filename to download with full path.",
                    "maxStringLength": 256,
                    "required": true
                },
                "mode": {
                    "type": "enum",
                    "enumType": "FtpModeType",
                    "default": "FTP_PASSIVE_MODE",
                    "description": "FTP data transfer process mode.",
                    "required": true
                },
                "ssl_attributes": {
                    "type": "message",
                    "messageType": "HealthMonitorSSLAttributes",
                    "description": "SSL attributes for FTPS monitor."
                }
            }
        },
        "HealthMonitorImap": {
            "fields": {
                "folder": {
                    "type": "string",
                    "description": "Folder to access",
                    "maxStringLength": 128
                },
                "ssl_attributes": {
                    "type": "message",
                    "messageType": "HealthMonitorSSLAttributes",
                    "description": "SSL attributes for IMAPS monitor"
                }
            }
        },
        "HealthMonitorPop3": {
            "fields": {
                "ssl_attributes": {
                    "type": "message",
                    "messageType": "HealthMonitorSSLAttributes",
                    "description": "SSL attributes for POP3S monitor"
                }
            }
        },
        "HealthMonitorSmtp": {
            "fields": {
                "sender_id": {
                    "type": "string",
                    "description": "Mail sender",
                    "maxStringLength": 128
                },
                "recipients_ids": {
                    "type": "string",
                    "repeated": true,
                    "description": "Mail recipients",
                    "minRepeatedLength": 0,
                    "maxStringLength": 128
                },
                "mail_data": {
                    "type": "string",
                    "description": "Mail data",
                    "maxStringLength": 1024
                },
                "domainname": {
                    "type": "string",
                    "description": "Sender domain name",
                    "maxStringLength": 256
                },
                "ssl_attributes": {
                    "type": "message",
                    "messageType": "HealthMonitorSSLAttributes",
                    "description": "SSL attributes for SMTPS monitor"
                }
            }
        },
        "HealthMonitorAuthInfo": {
            "fields": {
                "username": {
                    "type": "string",
                    "description": "Username for server authentication.",
                    "maxStringLength": 128,
                    "required": true
                },
                "password": {
                    "type": "string",
                    "description": "Password for server authentication.",
                    "maxStringLength": 128,
                    "required": true
                }
            }
        },
        "HealthMonitorRadius": {
            "fields": {
                "username": {
                    "type": "string",
                    "description": "Radius monitor will query Radius server with this username.",
                    "maxStringLength": 128,
                    "required": true
                },
                "password": {
                    "type": "string",
                    "description": "Radius monitor will query Radius server with this password.",
                    "maxStringLength": 128,
                    "required": true
                },
                "shared_secret": {
                    "type": "string",
                    "description": "Radius monitor will query Radius server with this shared secret.",
                    "maxStringLength": 128,
                    "required": true
                }
            }
        },
        "HealthMonitorSIP": {
            "fields": {
                "sip_request_code": {
                    "type": "enum",
                    "enumType": "SipRequestCode",
                    "default": "SIP_OPTIONS",
                    "description": "Specify the SIP request to be sent to the server. By default, SIP OPTIONS request will be sent."
                },
                "sip_response": {
                    "type": "string",
                    "default": "SIP/2.0",
                    "description": "Match for a keyword in the first 2KB of the server header and body response. By default, it matches for SIP/2.0.",
                    "maxStringLength": 512
                },
                "sip_monitor_transport": {
                    "type": "enum",
                    "enumType": "SipMonTransport",
                    "default": "SIP_UDP_PROTO",
                    "description": "Specify the transport protocol TCP or UDP, to be used for SIP health monitor. The default transport is UDP."
                }
            }
        },
        "HealthMonitorDNS": {
            "fields": {
                "query_name": {
                    "type": "string",
                    "required": true,
                    "description": "The DNS monitor will query the DNS server for the fully qualified name in this field.",
                    "maxStringLength": 255
                },
                "qtype": {
                    "type": "enum",
                    "enumType": "HealthMonitorDNSQueryType",
                    "default": "DNS_QUERY_TYPE",
                    "description": "  Query_Type: Response has atleast one answer of which      the resource record type matches the query type   Any_Type: Response should contain atleast one answer  AnyThing: An empty answer is enough"
                },
                "rcode": {
                    "type": "enum",
                    "enumType": "HealthMonitorDNSRcode",
                    "default": "RCODE_NO_ERROR",
                    "description": "When No Error is selected, a DNS query will be marked failed is any error code is returned by the server.  With Any selected, the monitor ignores error code in the responses."
                },
                "response_string": {
                    "type": "string",
                    "description": "The resource record of the queried DNS server's response for the Request Name must include the IP address defined in this field. ",
                    "maxStringLength": 64
                },
                "record_type": {
                    "type": "enum",
                    "enumType": "DnsRecordType",
                    "default": "DNS_RECORD_A",
                    "description": "Resource record type used in the healthmonitor DNS query, only A or AAAA type supported."
                }
            }
        },
        "HealthMonitorUdp": {
            "fields": {
                "udp_request": {
                    "type": "string",
                    "description": "Send UDP request.",
                    "maxStringLength": 1024
                },
                "udp_response": {
                    "type": "string",
                    "description": "Match for keyword in the UDP response.",
                    "maxStringLength": 512
                },
                "maintenance_response": {
                    "type": "string",
                    "description": "Match or look for this keyword in the first 2KB of server's response indicating server maintenance.  A successful match results in the server being marked down.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "maxStringLength": 512
                }
            }
        },
        "HealthMonitorExternal": {
            "fields": {
                "command_path": {
                    "type": "string",
                    "description": "Path of external health monitor script.",
                    "maxStringLength": 128
                },
                "command_parameters": {
                    "type": "string",
                    "description": "Optional arguments to feed into the script.",
                    "maxStringLength": 1024
                },
                "command_code": {
                    "type": "string",
                    "required": true,
                    "description": "Command script provided inline."
                },
                "command_variables": {
                    "type": "string",
                    "description": "Environment variables to be fed into the script.",
                    "maxStringLength": 1024
                }
            }
        },
        "HealthMonitorTcp": {
            "fields": {
                "tcp_request": {
                    "type": "string",
                    "description": "Request data to send after completing the TCP handshake.",
                    "maxStringLength": 1024
                },
                "tcp_response": {
                    "type": "string",
                    "description": "Match for the desired keyword in the first 2Kb of the server's TCP response. If this field is left blank, no server response is required.",
                    "maxStringLength": 512
                },
                "maintenance_response": {
                    "type": "string",
                    "description": "Match or look for this keyword in the first 2KB of server's response indicating server maintenance.  A successful match results in the server being marked down.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "maxStringLength": 512
                },
                "tcp_half_open": {
                    "type": "bool",
                    "default": false,
                    "description": "Configure TCP health monitor to use half-open TCP connections to monitor the health of backend servers thereby avoiding consumption of a full fledged server side connection and the overhead and logs associated with it.  This method is light-weight as it makes use of listener in server's kernel layer to measure the health and a child socket or user thread is not created on the server side.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                }
            }
        },
        "HTTP2ApplicationProfile": {
            "fields": {
                "max_http2_control_frames_per_connection": {
                    "type": "uint32",
                    "default": 1000,
                    "description": "Maximum number of control frames that client can send over an HTTP/2 connection. '0' means unlimited.",
                    "min": 0,
                    "max": 10000,
                    "specialValues": {
                        "0": "Unlimited control frames on a client side HTTP/2 connection"
                    }
                },
                "max_http2_queued_frames_to_client_per_connection": {
                    "type": "uint32",
                    "default": 1000,
                    "description": "Maximum number of frames that can be queued waiting to be sent over a client side HTTP/2 connection at any given time. '0' means unlimited.",
                    "min": 0,
                    "max": 10000,
                    "specialValues": {
                        "0": "Unlimited frames can be queued on a client side HTTP/2 connection"
                    }
                },
                "max_http2_empty_data_frames_per_connection": {
                    "type": "uint32",
                    "default": 1000,
                    "description": "Maximum number of empty data frames that client can send over an HTTP/2 connection. '0' means unlimited.",
                    "min": 0,
                    "max": 10000,
                    "specialValues": {
                        "0": "Unlimited empty data frames over a client side HTTP/2 connection"
                    }
                },
                "max_http2_concurrent_streams_per_connection": {
                    "type": "uint32",
                    "default": 128,
                    "description": "Maximum number of concurrent streams over a client side HTTP/2 connection.",
                    "min": 1,
                    "max": 256
                },
                "max_http2_requests_per_connection": {
                    "type": "uint32",
                    "default": 1000,
                    "description": "Maximum number of requests over a client side HTTP/2 connection.",
                    "min": 0,
                    "max": 10000,
                    "specialValues": {
                        "0": "Unlimited requests on a client side HTTP/2 connection"
                    }
                },
                "max_http2_header_field_size": {
                    "type": "uint32",
                    "default": 4096,
                    "description": "Maximum size in bytes of the compressed request header field. The limit applies equally to both name and value.",
                    "min": 1,
                    "max": 8192
                },
                "http2_initial_window_size": {
                    "type": "uint32",
                    "default": 64,
                    "description": "The initial flow control window size in KB for HTTP/2 streams.",
                    "min": 64,
                    "max": 32768
                },
                "enable_http2_server_push": {
                    "type": "bool",
                    "default": false,
                    "description": "Enables automatic conversion of preload links specified in the \"Link\" response header fields into Server push requests."
                },
                "max_http2_concurrent_pushes_per_connection": {
                    "type": "uint32",
                    "default": 10,
                    "description": "Maximum number of concurrent push streams over a client side HTTP/2 connection.",
                    "min": 1,
                    "max": 256
                }
            }
        },
        "HttpCookiePersistenceKey": {
            "fields": {
                "name": {
                    "type": "string",
                    "description": "name to use for cookie encryption"
                },
                "aes_key": {
                    "type": "Unknown"
                },
                "hmac_key": {
                    "type": "Unknown"
                }
            }
        },
        "HTTPPolicySet": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "required": true,
                    "description": "UUID of the HTTP Policy Set"
                },
                "name": {
                    "type": "string",
                    "required": true,
                    "description": "Name of the HTTP Policy Set",
                    "maxStringLength": 280
                },
                "http_security_policy": {
                    "type": "message",
                    "messageType": "HTTPSecurityPolicy",
                    "description": "HTTP security policy for the virtual service."
                },
                "http_request_policy": {
                    "type": "message",
                    "messageType": "HTTPRequestPolicy",
                    "description": "HTTP request policy for the virtual service."
                },
                "http_response_policy": {
                    "type": "message",
                    "messageType": "HTTPResponsePolicy",
                    "description": "HTTP response policy for the virtual service."
                },
                "created_by": {
                    "type": "string",
                    "description": "Creator name"
                },
                "cloud_config_cksum": {
                    "type": "string",
                    "description": "Checksum of cloud configuration for Pool. Internally set by cloud connector"
                },
                "ip_reputation_db_uuid": {
                    "type": "string",
                    "description": "IP reputation database."
                },
                "geo_db_uuid": {
                    "type": "string",
                    "description": "Geo database."
                },
                "markers": {
                    "type": "message",
                    "messageType": "RoleFilterMatchLabel",
                    "repeated": true,
                    "description": "List of labels to be used for granular RBAC.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "is_internal_policy": {
                    "type": "bool",
                    "default": false
                },
                "description": {
                    "type": "string"
                },
                "tenant_uuid": {
                    "type": "string",
                    "required": true
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                }
            }
        },
        "HTTPRequestPolicy": {
            "fields": {
                "rules": {
                    "type": "message",
                    "messageType": "HTTPRequestRule",
                    "repeated": true,
                    "description": "Add rules to the HTTP request policy"
                }
            }
        },
        "HTTPRequestRule": {
            "fields": {
                "name": {
                    "type": "string",
                    "required": true,
                    "description": "Name of the rule"
                },
                "index": {
                    "type": "int32",
                    "required": true,
                    "description": "Index of the rule"
                },
                "enable": {
                    "type": "bool",
                    "default": true,
                    "required": true,
                    "description": "Enable or disable the rule"
                },
                "match": {
                    "type": "message",
                    "messageType": "MatchTarget",
                    "description": "Add match criteria to the rule"
                },
                "redirect_action": {
                    "type": "message",
                    "messageType": "HTTPRedirectAction",
                    "description": "HTTP redirect action"
                },
                "hdr_action": {
                    "type": "message",
                    "messageType": "HTTPHdrAction",
                    "repeated": true,
                    "description": "HTTP header rewrite action"
                },
                "rewrite_url_action": {
                    "type": "message",
                    "messageType": "HTTPRewriteURLAction",
                    "description": "HTTP request URL rewrite action"
                },
                "switching_action": {
                    "type": "message",
                    "messageType": "HTTPSwitchingAction",
                    "description": "Content switching action"
                },
                "log": {
                    "type": "bool",
                    "description": "Log HTTP request upon rule match",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "all_headers": {
                    "type": "bool",
                    "description": "Log all HTTP headers upon rule match",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                }
            },
            "repeatedKey": "name"
        },
        "HTTPSwitchingAction": {
            "fields": {
                "action": {
                    "type": "enum",
                    "enumType": "HTTPSwitchingActionType",
                    "required": true,
                    "description": "Content switching action type",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "HTTP_SWITCHING_SELECT_POOL,HTTP_SWITCHING_SELECT_LOCAL"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "pool_uuid": {
                    "type": "string",
                    "description": "UUID of the pool of servers to serve the request"
                },
                "status_code": {
                    "type": "enum",
                    "enumType": "HTTPLocalResponseStatusCode",
                    "description": "HTTP status code to use when serving local response"
                },
                "file": {
                    "type": "message",
                    "messageType": "HTTPLocalFile",
                    "description": "File from which to serve local response to the request"
                },
                "server": {
                    "type": "message",
                    "messageType": "PoolServer",
                    "description": "Specific pool server to select",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "pool_group_uuid": {
                    "type": "string",
                    "description": "UUID of the pool group to serve the request",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "other_status_code": {
                    "type": "uint32",
                    "description": "User-defined HTTP status code to use when serving the local response. Use this to provide codes not available in the list within status_code.",
                    "min": 200,
                    "max": 599
                }
            }
        },
        "PoolServer": {
            "fields": {
                "ip": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "required": true,
                    "description": "IP address of the server in the poool"
                },
                "hostname": {
                    "type": "string",
                    "description": "DNS resolvable name of the server.  May be used in place of the IP address."
                },
                "port": {
                    "type": "uint32",
                    "description": "Port of the pool server listening for HTTP/HTTPS. Default value is the default port in the pool.",
                    "min": 1,
                    "max": 65535
                }
            }
        },
        "HTTPLocalFile": {
            "fields": {
                "content_type": {
                    "type": "string",
                    "required": true,
                    "description": "Mime-type of the content in the file."
                },
                "file_content": {
                    "type": "string",
                    "required": true,
                    "description": "File content to used in the local HTTP response body."
                },
                "file_length": {
                    "type": "uint32",
                    "default": 0,
                    "description": "File content length."
                }
            }
        },
        "HTTPHdrAction": {
            "fields": {
                "action": {
                    "type": "enum",
                    "enumType": "HTTPHdrActionType",
                    "required": true,
                    "description": "ADD: A new header with the new value is added irrespective of the existence of an HTTP header of the given name. REPLACE: A new header with the new value is added if no header of the given name exists, else existing headers with the given name are removed and a new header with the new value is added. REMOVE: All the headers of the given name are removed.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "HTTP_REMOVE_HDR,HTTP_REPLACE_HDR"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "HTTP_REMOVE_HDR,HTTP_REPLACE_HDR"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "hdr": {
                    "type": "message",
                    "messageType": "HTTPHdrData",
                    "description": "HTTP header information"
                },
                "cookie": {
                    "type": "message",
                    "messageType": "HTTPCookieData",
                    "description": "Cookie information"
                },
                "hdr_index": {
                    "type": "uint32",
                    "description": "Index to identify the header actions.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                }
            },
            "repeatedKey": "hdr_index"
        },
        "HTTPCookieData": {
            "fields": {
                "name": {
                    "type": "string",
                    "description": "Cookie name"
                },
                "value": {
                    "type": "string",
                    "description": "Cookie value"
                }
            }
        },
        "HTTPHdrData": {
            "fields": {
                "name": {
                    "type": "string",
                    "description": "HTTP header name"
                },
                "value": {
                    "type": "message",
                    "messageType": "HTTPHdrValue",
                    "description": "HTTP header value"
                }
            }
        },
        "HTTPHdrValue": {
            "fields": {
                "var": {
                    "type": "enum",
                    "enumType": "HTTPPolicyVar",
                    "description": "Variable"
                },
                "val": {
                    "type": "string",
                    "description": "HTTP header value or variable representing an HTTP header"
                },
                "is_sensitive": {
                    "type": "bool",
                    "default": false,
                    "description": "The Custom Value field is sensitive and will not be displayed.",
                    "immutable": true
                }
            }
        },
        "HTTPRedirectAction": {
            "fields": {
                "protocol": {
                    "type": "enum",
                    "enumType": "HTTPProtocol",
                    "required": true,
                    "description": "Protocol type"
                },
                "host": {
                    "type": "message",
                    "messageType": "URIParam",
                    "description": "Host config"
                },
                "port": {
                    "type": "uint32",
                    "description": "Port to which redirect the request",
                    "min": 1,
                    "max": 65535
                },
                "path": {
                    "type": "message",
                    "messageType": "URIParam",
                    "description": "Path config"
                },
                "keep_query": {
                    "type": "bool",
                    "default": true,
                    "description": "Keep or drop the query of the incoming request URI in the redirected URI"
                },
                "status_code": {
                    "type": "enum",
                    "enumType": "HTTPRedirectStatusCode",
                    "default": "HTTP_REDIRECT_STATUS_CODE_302",
                    "description": "HTTP redirect status code"
                },
                "add_string": {
                    "type": "string",
                    "description": "Add a query string to the redirect URI. If keep_query is set, concatenates the add_string to the query of the incoming request."
                }
            }
        },
        "URIParam": {
            "fields": {
                "type": {
                    "type": "enum",
                    "enumType": "URIParamType",
                    "required": true,
                    "description": "URI param type"
                },
                "tokens": {
                    "type": "message",
                    "messageType": "URIParamToken",
                    "repeated": true,
                    "description": "Token config either for the URI components or a constant string",
                    "minRepeatedLength": 1
                }
            }
        },
        "URIParamToken": {
            "fields": {
                "type": {
                    "type": "enum",
                    "enumType": "URITokenType",
                    "required": true,
                    "description": "Token type for constructing the URI"
                },
                "start_index": {
                    "type": "uint32",
                    "description": "Index of the starting token in the incoming URI"
                },
                "end_index": {
                    "type": "uint32",
                    "description": "Index of the ending token in the incoming URI",
                    "min": 0,
                    "max": 65534,
                    "specialValues": {
                        "65535": "end of string"
                    }
                },
                "str_value": {
                    "type": "string",
                    "description": "Constant string to use as a token"
                }
            }
        },
        "HTTPResponsePolicy": {
            "fields": {
                "rules": {
                    "type": "message",
                    "messageType": "HTTPResponseRule",
                    "repeated": true,
                    "description": "Add rules to the HTTP response policy"
                }
            }
        },
        "HTTPResponseRule": {
            "fields": {
                "name": {
                    "type": "string",
                    "required": true,
                    "description": "Name of the rule"
                },
                "index": {
                    "type": "int32",
                    "required": true,
                    "description": "Index of the rule"
                },
                "enable": {
                    "type": "bool",
                    "default": true,
                    "required": true,
                    "description": "Enable or disable the rule"
                },
                "match": {
                    "type": "message",
                    "messageType": "ResponseMatchTarget",
                    "description": "Add match criteria to the rule"
                },
                "hdr_action": {
                    "type": "message",
                    "messageType": "HTTPHdrAction",
                    "repeated": true,
                    "description": "HTTP header rewrite action"
                },
                "loc_hdr_action": {
                    "type": "message",
                    "messageType": "HTTPRewriteLocHdrAction",
                    "description": "Location header rewrite action",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "log": {
                    "type": "bool",
                    "description": "Log HTTP request upon rule match",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "all_headers": {
                    "type": "bool",
                    "description": "Log all HTTP headers upon rule match",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                }
            },
            "repeatedKey": "name"
        },
        "ResponseMatchTarget": {
            "fields": {
                "client_ip": {
                    "type": "message",
                    "messageType": "IpAddrMatch",
                    "description": "Configure client ip addresses"
                },
                "vs_port": {
                    "type": "message",
                    "messageType": "PortMatch",
                    "description": "Configure virtual service ports"
                },
                "protocol": {
                    "type": "message",
                    "messageType": "ProtocolMatch",
                    "description": "Configure the type of HTTP protocol"
                },
                "method": {
                    "type": "message",
                    "messageType": "MethodMatch",
                    "description": "Configure HTTP methods"
                },
                "version": {
                    "type": "message",
                    "messageType": "HTTPVersionMatch",
                    "description": "Configure versions of the HTTP protocol"
                },
                "path": {
                    "type": "message",
                    "messageType": "PathMatch",
                    "description": "Configure request paths"
                },
                "query": {
                    "type": "message",
                    "messageType": "QueryMatch",
                    "description": "Configure request query"
                },
                "hdrs": {
                    "type": "message",
                    "messageType": "HdrMatch",
                    "repeated": true,
                    "description": "Configure HTTP headers"
                },
                "cookie": {
                    "type": "message",
                    "messageType": "CookieMatch",
                    "description": "Configure HTTP cookie(s)"
                },
                "host_hdr": {
                    "type": "message",
                    "messageType": "HostHdrMatch",
                    "description": "Configure the host header"
                },
                "loc_hdr": {
                    "type": "message",
                    "messageType": "LocationHdrMatch",
                    "description": "Configure the location header"
                },
                "status": {
                    "type": "message",
                    "messageType": "HTTPStatusMatch",
                    "description": "Configure the HTTP status code(s)",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "rsp_hdrs": {
                    "type": "message",
                    "messageType": "HdrMatch",
                    "repeated": true,
                    "description": "Configure the HTTP headers in response"
                },
                "source_ip": {
                    "type": "message",
                    "messageType": "IpAddrMatch",
                    "description": "Configure source ip addresses."
                }
            }
        },
        "LocationHdrMatch": {
            "fields": {
                "match_criteria": {
                    "type": "enum",
                    "enumType": "HdrMatchOperation",
                    "required": true,
                    "description": "Criterion to use for matching location header value in the HTTP response"
                },
                "match_case": {
                    "type": "enum",
                    "enumType": "MatchCase",
                    "default": "INSENSITIVE",
                    "description": "Case sensitivity to use for the match"
                },
                "value": {
                    "type": "string",
                    "repeated": true,
                    "description": "String value(s) in the location header"
                }
            }
        },
        "HTTPRewriteLocHdrAction": {
            "fields": {
                "protocol": {
                    "type": "enum",
                    "enumType": "HTTPProtocol",
                    "required": true,
                    "description": "HTTP protocol type"
                },
                "port": {
                    "type": "uint32",
                    "description": "Port to use in the redirected URI",
                    "min": 1,
                    "max": 65535
                },
                "host": {
                    "type": "message",
                    "messageType": "URIParam",
                    "description": "Host config"
                },
                "path": {
                    "type": "message",
                    "messageType": "URIParam",
                    "description": "Path config"
                },
                "keep_query": {
                    "type": "bool",
                    "default": true,
                    "description": "Keep or drop the query from the server side redirect URI"
                }
            }
        },
        "HTTPRewriteURLAction": {
            "fields": {
                "host_hdr": {
                    "type": "message",
                    "messageType": "URIParam",
                    "description": "Host config"
                },
                "path": {
                    "type": "message",
                    "messageType": "URIParam",
                    "description": "Path config"
                },
                "query": {
                    "type": "message",
                    "messageType": "URIParamQuery",
                    "description": "Query config"
                }
            }
        },
        "URIParamQuery": {
            "fields": {
                "keep_query": {
                    "type": "bool",
                    "default": true,
                    "description": "Use or drop the query of the incoming request URI in the request URI to the backend server"
                },
                "add_string": {
                    "type": "string",
                    "description": "Concatenate a string to the query of the incoming request URI and then use it in the request URI going to the backend server"
                }
            }
        },
        "HTTPSecurityPolicy": {
            "fields": {
                "rules": {
                    "type": "message",
                    "messageType": "HTTPSecurityRule",
                    "repeated": true,
                    "description": "Add rules to the HTTP security policy"
                }
            }
        },
        "HTTPSecurityRule": {
            "fields": {
                "name": {
                    "type": "string",
                    "required": true,
                    "description": "Name of the rule"
                },
                "index": {
                    "type": "int32",
                    "required": true,
                    "description": "Index of the rule"
                },
                "enable": {
                    "type": "bool",
                    "default": true,
                    "required": true,
                    "description": "Enable or disable the rule"
                },
                "match": {
                    "type": "message",
                    "messageType": "MatchTarget",
                    "description": "Add match criteria to the rule"
                },
                "action": {
                    "type": "message",
                    "messageType": "HTTPSecurityAction",
                    "description": "Action to be performed upon successful matching"
                },
                "log": {
                    "type": "bool",
                    "description": "Log HTTP request upon rule match",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                }
            },
            "repeatedKey": "name"
        },
        "HTTPSecurityAction": {
            "fields": {
                "action": {
                    "type": "enum",
                    "enumType": "HTTPSecurityActionType",
                    "required": true,
                    "description": "Type of the security action to perform",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "HTTP_SECURITY_ACTION_CLOSE_CONN,HTTP_SECURITY_ACTION_SEND_RESPONSE,HTTP_SECURITY_ACTION_REDIRECT_TO_HTTPS"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "HTTP_SECURITY_ACTION_CLOSE_CONN,HTTP_SECURITY_ACTION_SEND_RESPONSE,HTTP_SECURITY_ACTION_REDIRECT_TO_HTTPS"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "status_code": {
                    "type": "enum",
                    "enumType": "HTTPLocalResponseStatusCode",
                    "description": "HTTP status code to use for local response"
                },
                "https_port": {
                    "type": "uint32",
                    "description": "Secure SSL/TLS port to redirect the HTTP request to",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 1,
                    "max": 65535
                },
                "file": {
                    "type": "message",
                    "messageType": "HTTPLocalFile",
                    "description": "File to be used for generating HTTP local response",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "rate_profile": {
                    "type": "message",
                    "messageType": "HTTPSecurityActionRateProfile",
                    "description": "Rate limiting configuration for this action.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                }
            }
        },
        "HTTPSecurityActionRateProfile": {
            "fields": {
                "rate_limiter": {
                    "type": "message",
                    "messageType": "RateLimiter",
                    "description": "The rate limiter used when this action is triggered.",
                    "required": true
                },
                "action": {
                    "type": "message",
                    "messageType": "RateLimiterAction",
                    "description": "The action to take when the rate limit has been reached.",
                    "required": true
                },
                "per_client_ip": {
                    "type": "bool",
                    "description": "Rate limiting should be done on a per client ip basis."
                },
                "per_uri_path": {
                    "type": "bool",
                    "description": "Rate limiting should be done on a per request uri path basis."
                }
            }
        },
        "RateLimiterAction": {
            "fields": {
                "type": {
                    "type": "enum",
                    "enumType": "RateLimiterActionType",
                    "default": "RL_ACTION_NONE",
                    "description": "Type of action to be enforced upon hitting the rate limit.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "RL_ACTION_NONE,RL_ACTION_DROP_CONN"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "redirect": {
                    "type": "message",
                    "messageType": "HTTPRedirectAction",
                    "description": "Parameters for HTTP Redirect rate limit action.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "status_code": {
                    "type": "enum",
                    "enumType": "HTTPLocalResponseStatusCode",
                    "default": "HTTP_LOCAL_RESPONSE_STATUS_CODE_429",
                    "description": "HTTP status code for Local Response rate limit action.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "HTTP_LOCAL_RESPONSE_STATUS_CODE_429"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "file": {
                    "type": "message",
                    "messageType": "HTTPLocalFile",
                    "description": "File to be used for HTTP Local response rate limit action.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                }
            }
        },
        "IcapProfile": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "description": "UUID of the ICAP profile.",
                    "required": true
                },
                "name": {
                    "type": "string",
                    "description": "Name of the ICAP profile.",
                    "maxStringLength": 256,
                    "required": true
                },
                "tenant_uuid": {
                    "type": "string",
                    "description": "Tenant which this object belongs to.",
                    "required": true
                },
                "cloud_uuid": {
                    "type": "string",
                    "default": "Default-Cloud",
                    "description": "The cloud where this object belongs to. This must match the cloud referenced in the pool group below.",
                    "immutable": true
                },
                "description": {
                    "type": "string",
                    "description": "A description for this ICAP profile."
                },
                "pool_group_uuid": {
                    "type": "string",
                    "description": "The pool group which is used to connect to ICAP servers.",
                    "required": true
                },
                "vendor": {
                    "type": "enum",
                    "enumType": "ICAPVendor",
                    "default": "ICAP_VENDOR_OPSWAT",
                    "description": "The vendor of the ICAP server."
                },
                "service_uri": {
                    "type": "string",
                    "description": "The path and query component of the ICAP URL. Host name and port will be taken from the pool.",
                    "required": true
                },
                "buffer_size": {
                    "type": "uint32",
                    "default": 51200,
                    "description": "The maximum buffer size for the HTTP request body. If the request body exceeds this size, the request will not be checked by the ICAP server. In this case, the configured action will be executed and a significant log entry will be generated.",
                    "min": 1,
                    "max": 51200
                },
                "buffer_size_exceed_action": {
                    "type": "enum",
                    "enumType": "ICAPFailAction",
                    "default": "ICAP_FAIL_OPEN",
                    "description": "Decide what should happen if the request body size exceeds the configured buffer size. If this is set to Fail Open, the request will not be checked by the ICAP server. If this is set to Fail Closed, the request will be rejected with 413 status code."
                },
                "enable_preview": {
                    "type": "bool",
                    "default": true,
                    "description": "Use the ICAP preview feature as described in RFC 3507 section 4.5."
                },
                "preview_size": {
                    "type": "uint32",
                    "default": 5000,
                    "description": "The ICAP preview size as described in RFC 3507 section 4.5. This should not exceed the size supported by the ICAP server. If this is set to 0, only the HTTP header will be sent to the ICAP server as a preview. To disable preview completely, set the enable-preview option to false.If vendor is LASTLINE, recommended preview size is 1000 bytes,minimum preview size is 10 bytes.",
                    "min": 0,
                    "max": 5000
                },
                "response_timeout": {
                    "type": "uint32",
                    "default": 60000,
                    "description": "Maximum time, client's request will be paused for ICAP processing. If this timeout is exceeded, the request to the ICAP server will be aborted and the configured fail action is executed.",
                    "min": 50,
                    "max": 3600000
                },
                "slow_response_warning_threshold": {
                    "type": "uint32",
                    "default": 10000,
                    "description": "If the ICAP request takes longer than this value, this request will generate a significant log entry.",
                    "min": 50,
                    "max": 3600000
                },
                "fail_action": {
                    "type": "enum",
                    "enumType": "ICAPFailAction",
                    "default": "ICAP_FAIL_OPEN",
                    "description": "Decide what should happen if there is a problem with the ICAP server like communication timeout, protocol error, pool error, etc. If the ICAP server responds with 4xx-5xx error code the configured fail action is performed. If this is set to Fail Open, the request will continue, but will create a significant log entry. If this is set to Fail Closed, the request will be rejected with a 500 status code."
                },
                "allow_204": {
                    "type": "bool",
                    "default": true,
                    "description": "Allow ICAP server to send 204 response as described in RFC 3507 section 4.5. Service Engine will buffer the complete request if alllow_204 is enabled. If disabled, preview_size request body will be buffered if enable_preview is set to true, and rest of the request body will be streamed to the ICAP server."
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                },
                "nsx_defender_config": {
                    "type": "message",
                    "messageType": "IcapNsxDefenderConfig",
                    "description": "NSXDefender specific ICAP configurations."
                }
            }
        },
        "IcapNsxDefenderConfig": {
            "fields": {
                "status_url": {
                    "type": "string",
                    "default": "https://user.lastline.com/portal#/analyst/task/$uuid/overview",
                    "description": "URL to get details from NSXDefender using task_uuid for a particular request."
                }
            }
        },
        "Image": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "description": "UUID of the image.",
                    "required": true
                },
                "name": {
                    "type": "string",
                    "description": "Name of the image.",
                    "required": true
                },
                "controller_info": {
                    "type": "message",
                    "messageType": "PackageDetails",
                    "description": "Controller package details."
                },
                "se_info": {
                    "type": "message",
                    "messageType": "PackageDetails",
                    "description": "SE package details."
                },
                "migrations": {
                    "type": "message",
                    "messageType": "SupportedMigrations",
                    "description": "This field describes the api migration related information."
                },
                "type": {
                    "type": "enum",
                    "enumType": "ImageType",
                    "description": "Type of the image patch/system."
                },
                "uber_bundle": {
                    "type": "bool",
                    "default": false,
                    "description": "Status to check if the image is an uber bundle."
                },
                "controller_patch_uuid": {
                    "type": "string",
                    "description": "It references the controller-patch associated with the Uber image."
                },
                "se_patch_uuid": {
                    "type": "string",
                    "description": "It references the Service Engine patch associated with the Uber Image."
                },
                "cloud_info_values": {
                    "type": "message",
                    "messageType": "ImageCloudData",
                    "repeated": true,
                    "description": "This field describes the cloud info specific to the base image."
                },
                "controller_patch_name": {
                    "type": "string",
                    "description": "Mandatory Controller patch name that is applied along with this base image."
                },
                "se_patch_name": {
                    "type": "string",
                    "description": "Mandatory ServiceEngine patch name that is applied along with this base image."
                },
                "img_state": {
                    "type": "message",
                    "messageType": "ImageUploadOpsStatus",
                    "description": "Status of the image."
                },
                "events": {
                    "type": "message",
                    "messageType": "ImageEventMap",
                    "repeated": true,
                    "description": "Image events for image upload operation."
                },
                "tasks_completed": {
                    "type": "int32",
                    "default": 0,
                    "description": "Completed set of tasks for Image upload."
                },
                "total_tasks": {
                    "type": "int32",
                    "default": 0,
                    "description": "Total number of tasks for Image upload."
                },
                "progress": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Image upload progress which holds value between 0-100",
                    "min": 0,
                    "max": 100
                },
                "start_time": {
                    "type": "string",
                    "description": "Image upload start time.",
                    "maxStringLength": 512
                },
                "end_time": {
                    "type": "string",
                    "description": "Image upload end time.",
                    "maxStringLength": 512
                },
                "duration": {
                    "type": "uint32",
                    "description": "Time taken to upload the image in seconds."
                },
                "fips_mode_transition_applicable": {
                    "type": "bool",
                    "default": true,
                    "description": "Specifies whether FIPS mode can be enabled on this image."
                },
                "dryrun_info": {
                    "type": "message",
                    "messageType": "PackageDetails",
                    "description": "Dry-run package details."
                },
                "tenant_uuid": {
                    "type": "string",
                    "description": "Tenant that this object belongs to.",
                    "required": true
                }
            }
        },
        "ImageEventMap": {
            "fields": {
                "task_name": {
                    "type": "string",
                    "description": "Name representing the task.",
                    "maxStringLength": 512
                },
                "nodes_events": {
                    "type": "message",
                    "messageType": "ImageEvent",
                    "repeated": true,
                    "description": "List of all events node wise."
                },
                "sub_events": {
                    "type": "message",
                    "messageType": "ImageEvent",
                    "repeated": true,
                    "description": "List of all events node wise."
                }
            }
        },
        "ImageEvent": {
            "fields": {
                "ip": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "description": "Ip of the node."
                },
                "start_time": {
                    "type": "string",
                    "description": "Task start time.",
                    "maxStringLength": 512
                },
                "end_time": {
                    "type": "string",
                    "description": "Task end time.",
                    "maxStringLength": 512
                },
                "duration": {
                    "type": "uint32",
                    "description": "Time taken to complete event in seconds."
                },
                "status": {
                    "type": "enum",
                    "enumType": "Syserr",
                    "description": "Event status."
                },
                "message": {
                    "type": "string",
                    "description": "Event message if any.",
                    "maxStringLength": 512
                },
                "sub_tasks": {
                    "type": "string",
                    "repeated": true,
                    "description": "Sub tasks executed on each node.",
                    "maxStringLength": 512
                }
            }
        },
        "ImageUploadOpsStatus": {
            "fields": {
                "state": {
                    "type": "enum",
                    "enumType": "ImageFsmState",
                    "description": "Current fsm-state of image upload operation."
                },
                "reason": {
                    "type": "string",
                    "description": "Descriptive reason for the state of the image.",
                    "maxStringLength": 512
                },
                "last_changed_time": {
                    "type": "message",
                    "messageType": "TimeStamp",
                    "description": "The last time the state changed."
                }
            }
        },
        "TimeStamp": {
            "fields": {
                "secs": {
                    "type": "Unknown",
                    "required": true
                },
                "usecs": {
                    "type": "Unknown",
                    "required": true
                }
            }
        },
        "ImageCloudData": {
            "fields": {
                "cloud_name": {
                    "type": "string",
                    "description": "Contains the name of the cloud."
                },
                "cloud_data_values": {
                    "type": "message",
                    "messageType": "ImageCloudSpecificData",
                    "repeated": true,
                    "description": "Cloud Data specific to a particular cloud."
                }
            }
        },
        "ImageCloudSpecificData": {
            "fields": {
                "key": {
                    "type": "string",
                    "description": "Each cloud has specific parameters."
                },
                "values": {
                    "type": "string",
                    "repeated": true,
                    "description": "Each parameter can have multiple values."
                }
            }
        },
        "IpAddrGroup": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "required": true,
                    "description": "UUID of the IP address group"
                },
                "name": {
                    "type": "string",
                    "required": true,
                    "description": "Name of the IP address group",
                    "maxStringLength": 256
                },
                "addrs": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "repeated": true,
                    "description": "Configure IP address(es)"
                },
                "ranges": {
                    "type": "message",
                    "messageType": "IpAddrRange",
                    "repeated": true,
                    "description": "Configure IP address range(s)"
                },
                "prefixes": {
                    "type": "message",
                    "messageType": "IpAddrPrefix",
                    "repeated": true,
                    "description": "Configure IP address prefix(es)"
                },
                "country_codes": {
                    "type": "string",
                    "repeated": true,
                    "description": "Populate the IP address ranges from the geo database for this country"
                },
                "ip_ports": {
                    "type": "message",
                    "messageType": "IpAddrPort",
                    "repeated": true,
                    "description": "Configure (IP address, port) tuple(s)"
                },
                "marathon_app_name": {
                    "type": "string",
                    "description": "Populate IP addresses from tasks of this Marathon app"
                },
                "marathon_service_port": {
                    "type": "uint32",
                    "description": "Task port associated with marathon service port. If Marathon app has multiple service ports, this is required. Else, the first task port is used"
                },
                "markers": {
                    "type": "message",
                    "messageType": "RoleFilterMatchLabel",
                    "repeated": true,
                    "description": "List of labels to be used for granular RBAC.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "nsx_groups": {
                    "type": "string",
                    "repeated": true,
                    "description": "An NSX Group that maps to a dynamic collection of IP addresses, derived from its definition in NSX",
                    "maxRepeatedLength": 1,
                    "maxStringLength": 512
                },
                "description": {
                    "type": "string"
                },
                "tenant_uuid": {
                    "type": "string",
                    "required": true
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                }
            }
        },
        "IpamDnsProviderProfile": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "required": true,
                    "description": "UUID of the IPAM/DNS Provider profile"
                },
                "name": {
                    "type": "string",
                    "required": true,
                    "description": "Name for the IPAM/DNS Provider profile",
                    "maxStringLength": 256
                },
                "type": {
                    "type": "enum",
                    "enumType": "IpamDnsType",
                    "required": true,
                    "description": "Provider Type for the IPAM/DNS Provider profile",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "IPAMDNS_TYPE_INTERNAL"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "IPAMDNS_TYPE_INTERNAL"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "immutable": true
                },
                "infoblox_profile": {
                    "type": "message",
                    "messageType": "IpamDnsInfobloxProfile",
                    "description": "Provider details if type is Infoblox"
                },
                "aws_profile": {
                    "type": "message",
                    "messageType": "IpamDnsAwsProfile",
                    "description": "Provider details if type is AWS"
                },
                "openstack_profile": {
                    "type": "message",
                    "messageType": "IpamDnsOpenstackProfile",
                    "description": "Provider details if type is OpenStack"
                },
                "internal_profile": {
                    "type": "message",
                    "messageType": "IpamDnsInternalProfile",
                    "description": "Provider details if type is Avi"
                },
                "gcp_profile": {
                    "type": "message",
                    "messageType": "IpamDnsGCPProfile",
                    "description": "Provider details if type is Google Cloud"
                },
                "custom_profile": {
                    "type": "message",
                    "messageType": "IpamDnsCustomProfile",
                    "description": "Provider details if type is Custom"
                },
                "azure_profile": {
                    "type": "message",
                    "messageType": "IpamDnsAzureProfile",
                    "description": "Provider details if type is Microsoft Azure"
                },
                "oci_profile": {
                    "type": "message",
                    "messageType": "IpamDnsOCIProfile",
                    "description": "Provider details for Oracle Cloud"
                },
                "tencent_profile": {
                    "type": "message",
                    "messageType": "IpamDnsTencentProfile",
                    "description": "Provider details for Tencent Cloud"
                },
                "proxy_configuration": {
                    "type": "message",
                    "messageType": "ProxyConfiguration"
                },
                "allocate_ip_in_vrf": {
                    "type": "bool",
                    "default": false,
                    "description": "If this flag is set, only allocate IP from networks in the Virtual Service VRF. Applicable for Avi IPAM only"
                },
                "markers": {
                    "type": "message",
                    "messageType": "RoleFilterMatchLabel",
                    "repeated": true,
                    "description": "List of labels to be used for granular RBAC.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "tenant_uuid": {
                    "type": "string",
                    "required": true
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                }
            }
        },
        "IpamDnsAzureProfile": {
            "fields": {
                "subscription_id": {
                    "type": "string",
                    "description": "Subscription Id for the Azure subscription"
                },
                "azure_userpass": {
                    "type": "message",
                    "messageType": "AzureUserPassCredentials",
                    "description": "User name password based credentials for azure. Only one of azure_userpass or azure_serviceprincipal is allowed."
                },
                "azure_serviceprincipal": {
                    "type": "message",
                    "messageType": "AzureServicePrincipalCredentials",
                    "description": "Service principal based credentials for azure. Only one of azure_userpass or azure_serviceprincipal is allowed."
                },
                "virtual_network_ids": {
                    "type": "string",
                    "repeated": true,
                    "description": "Virtual networks where Virtual IPs will belong.",
                    "maxRepeatedLength": 1
                },
                "resource_group": {
                    "type": "string",
                    "description": "Azure resource group dedicated for Avi Controller. Avi Controller will create all its resources in this resource group."
                },
                "usable_network_uuids": {
                    "type": "string",
                    "repeated": true,
                    "description": "Usable networks for Virtual IP. If VirtualService does not specify a network and auto_allocate_ip is set, then the first available network from this list will be chosen for IP allocation.",
                    "maxRepeatedLength": 128
                },
                "use_enhanced_ha": {
                    "type": "bool",
                    "default": false,
                    "description": "Use Azure's enhanced HA features. This needs a public IP to be associated with the VIP."
                },
                "usable_domains": {
                    "type": "string",
                    "repeated": true,
                    "description": "Usable domains to pick from Azure DNS"
                },
                "use_standard_alb": {
                    "type": "bool",
                    "default": false,
                    "description": "Use Standard SKU Azure Load Balancer. By default Basic SKU Load Balancer is used."
                },
                "egress_service_subnets": {
                    "type": "string",
                    "repeated": true,
                    "description": "Used for allocating egress service source IPs.",
                    "maxRepeatedLength": 1
                }
            }
        },
        "IpamDnsCustomProfile": {
            "fields": {
                "custom_ipam_dns_profile_uuid": {
                    "type": "string"
                },
                "dynamic_params": {
                    "type": "message",
                    "messageType": "CustomParams",
                    "repeated": true,
                    "description": "Custom parameters that will passed to the IPAM/DNS provider including but not limited to provider credentials and API version."
                },
                "usable_domains": {
                    "type": "string",
                    "repeated": true,
                    "description": "Usable domains"
                },
                "usable_alloc_subnets": {
                    "type": "message",
                    "messageType": "CustomIpamSubnet",
                    "repeated": true,
                    "description": "Networks or Subnets to use for Custom IPAM IP allocation."
                }
            }
        },
        "CustomIpamSubnet": {
            "fields": {
                "network_id": {
                    "type": "string",
                    "description": "Network to use for Custom IPAM IP allocation.",
                    "required": true
                },
                "subnet": {
                    "type": "message",
                    "messageType": "IpAddrPrefix",
                    "description": "IPv4 subnet to use for Custom IPAM IP allocation."
                },
                "subnet6": {
                    "type": "message",
                    "messageType": "IpAddrPrefix",
                    "description": "IPv6 subnet to use for Custom IPAM IP allocation."
                }
            }
        },
        "IpamDnsGCPProfile": {
            "fields": {
                "usable_network_uuids": {
                    "type": "string",
                    "repeated": true,
                    "description": "Usable networks for Virtual IP. If VirtualService does not specify a network and auto_allocate_ip is set, then the first available network from this list will be chosen for IP allocation."
                },
                "match_se_group_subnet": {
                    "type": "bool",
                    "default": false,
                    "description": "Match SE group subnets for VIP placement. Default is to not match SE group subnets."
                },
                "use_gcp_network": {
                    "type": "bool",
                    "default": false,
                    "description": "Use Google Cloud Platform Network for Private VIP allocation. By default Avi Network is used for Private VIP allocation."
                },
                "network_host_project_id": {
                    "type": "string",
                    "description": "Google Cloud Platform Network Host Project ID. This is the host project in which Google Cloud Platform Network resides."
                },
                "se_project_id": {
                    "type": "string",
                    "description": "Google Cloud Platform Project ID. This is the project where service engines are hosted. This field is optional. By default it will use the value of the field network_host_project_id."
                },
                "region_name": {
                    "type": "string",
                    "description": "Google Cloud Platform Region Name."
                },
                "vpc_network_name": {
                    "type": "string",
                    "description": "Google Cloud Platform VPC Network Name."
                }
            }
        },
        "IpamDnsInternalProfile": {
            "fields": {
                "dns_service_domain": {
                    "type": "message",
                    "messageType": "DnsServiceDomain",
                    "repeated": true,
                    "description": "List of service domains",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "ttl": {
                    "type": "uint32",
                    "default": 30,
                    "description": "Default TTL for all records, overridden by TTL value for each service domain configured in DnsServiceDomain.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "30"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "30"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 1,
                    "max": 604800
                },
                "dns_virtualservice_uuid": {
                    "type": "string",
                    "description": "Avi VirtualService to be used for serving DNS records.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "usable_networks": {
                    "type": "message",
                    "messageType": "IpamUsableNetwork",
                    "repeated": true,
                    "description": "Usable networks for Virtual IP. If VirtualService does not specify a network and auto_allocate_ip is set, then the first available network from this list will be chosen for IP allocation.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                }
            }
        },
        "IpamUsableNetwork": {
            "fields": {
                "nw_uuid": {
                    "type": "string",
                    "description": "Network",
                    "required": true
                },
                "labels": {
                    "type": "message",
                    "messageType": "KeyValueTuple",
                    "repeated": true,
                    "description": "Labels as key value pairs, used for selection of IPAM networks",
                    "maxRepeatedLength": 1
                }
            }
        },
        "KeyValueTuple": {
            "fields": {
                "key": {
                    "type": "string",
                    "description": "Key",
                    "required": true
                },
                "value": {
                    "type": "string",
                    "description": "Value"
                }
            },
            "repeatedKey": "key,value"
        },
        "DnsServiceDomain": {
            "fields": {
                "domain_name": {
                    "type": "string",
                    "required": true,
                    "description": "Service domain string used for FQDN"
                },
                "record_ttl": {
                    "type": "uint32",
                    "description": "TTL value for DNS records",
                    "min": 1,
                    "max": 604800
                },
                "pass_through": {
                    "type": "bool",
                    "default": true,
                    "description": "Third-party Authoritative domain requests are delegated toDNS VirtualService's pool of nameservers."
                }
            },
            "repeatedKey": "domain_name"
        },
        "IpamDnsOpenstackProfile": {
            "fields": {
                "username": {
                    "type": "string",
                    "description": "The username Avi will use when authenticating to Keystone."
                },
                "password": {
                    "type": "string",
                    "description": "The password Avi will use when authenticating to Keystone."
                },
                "tenant": {
                    "type": "string",
                    "description": "OpenStack tenant name"
                },
                "keystone_host": {
                    "type": "string",
                    "description": "Keystone's hostname or IP address."
                },
                "vip_network_name": {
                    "type": "string",
                    "description": "Network to be used for VIP allocation"
                },
                "region": {
                    "type": "string",
                    "description": "Region name"
                }
            }
        },
        "IpamDnsAwsProfile": {
            "fields": {
                "region": {
                    "type": "string",
                    "description": "AWS region"
                },
                "vpc": {
                    "type": "string",
                    "description": "VPC name"
                },
                "vpc_id": {
                    "type": "string",
                    "required": true,
                    "description": "VPC ID"
                },
                "use_iam_roles": {
                    "type": "bool",
                    "default": false,
                    "description": "Use IAM roles instead of access and secret key."
                },
                "access_key_id": {
                    "type": "string",
                    "description": "AWS access key ID"
                },
                "secret_access_key": {
                    "type": "string",
                    "description": "AWS secret access key"
                },
                "usable_network_uuids": {
                    "type": "string",
                    "repeated": true,
                    "description": "Usable networks for Virtual IP. If VirtualService does not specify a network and auto_allocate_ip is set, then the first available network from this list will be chosen for IP allocation."
                },
                "usable_domains": {
                    "type": "string",
                    "repeated": true,
                    "description": "Usable domains to pick from Amazon Route 53"
                },
                "iam_assume_role": {
                    "type": "string",
                    "description": "IAM assume role for cross-account access."
                },
                "zones": {
                    "type": "message",
                    "messageType": "AwsZoneNetwork",
                    "repeated": true,
                    "description": "Network configuration for Virtual IP per AZ."
                },
                "ttl": {
                    "type": "uint32",
                    "default": 60,
                    "description": "Default TTL for all records",
                    "min": 1,
                    "max": 172800
                },
                "publish_vip_to_public_zone": {
                    "type": "bool",
                    "default": false,
                    "description": "If enabled and the virtual service is not floating ip capable, vip will be published to both private and public zones. This flag is applicable only for AWS DNS profile."
                },
                "egress_service_subnets": {
                    "type": "string",
                    "repeated": true,
                    "description": "A list of subnets used for source IP allocation for egress services in Openshift/k8s on Aws.",
                    "maxRepeatedLength": 1
                }
            }
        },
        "AwsZoneNetwork": {
            "fields": {
                "availability_zone": {
                    "type": "string",
                    "required": true,
                    "description": "Availability zone"
                },
                "usable_network_uuids": {
                    "type": "string",
                    "repeated": true,
                    "description": "Usable networks for Virtual IP. If VirtualService does not specify a network and auto_allocate_ip is set, then the first available network from this list will be chosen for IP allocation."
                }
            }
        },
        "IpamDnsInfobloxProfile": {
            "fields": {
                "ip_address": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "description": "IPv4 Address of Infoblox appliance"
                },
                "username": {
                    "type": "string",
                    "required": true,
                    "description": "Username for API access for Infoblox appliance"
                },
                "password": {
                    "type": "string",
                    "required": true,
                    "description": "Password for API access for Infoblox appliance"
                },
                "wapi_version": {
                    "type": "string",
                    "default": "2.0",
                    "description": "WAPI version"
                },
                "dns_view": {
                    "type": "string",
                    "description": "DNS view used for Infoblox host record creation, If this field is not configured by the user, then its value will be set to 'default'"
                },
                "network_view": {
                    "type": "string",
                    "description": "Network view used for Infoblox host record creation, If this field is not configured by the user, then its value will be set to 'default'"
                },
                "usable_domains": {
                    "type": "string",
                    "repeated": true,
                    "description": "Usable domains to pick from Infoblox"
                },
                "extensible_attributes": {
                    "type": "message",
                    "messageType": "CustomParams",
                    "repeated": true,
                    "description": "Custom parameters that will passed to the Infoblox provider as extensible attributes."
                },
                "usable_alloc_subnets": {
                    "type": "message",
                    "messageType": "InfobloxSubnet",
                    "repeated": true,
                    "description": "Subnets to use for Infoblox IP allocation."
                },
                "ip6_address": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "description": "IPv6 Address of Infoblox appliance"
                }
            }
        },
        "InfobloxSubnet": {
            "fields": {
                "subnet": {
                    "type": "message",
                    "messageType": "IpAddrPrefix",
                    "description": "IPv4 subnet to use for Infoblox allocation."
                },
                "subnet6": {
                    "type": "message",
                    "messageType": "IpAddrPrefix",
                    "description": "IPv6 subnet to use for Infoblox allocation."
                }
            }
        },
        "IPReputationDB": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "description": "UUID of this object.",
                    "required": true
                },
                "tenant_uuid": {
                    "type": "string",
                    "description": "Tenant that this object belongs to.",
                    "immutable": true,
                    "required": true
                },
                "name": {
                    "type": "string",
                    "description": "IP reputation DB name.",
                    "maxStringLength": 256,
                    "required": true
                },
                "description": {
                    "type": "string",
                    "description": "Description."
                },
                "base_file_uuids": {
                    "type": "string",
                    "repeated": true,
                    "description": "IP reputation DB base file.",
                    "maxRepeatedLength": 1
                },
                "incremental_file_uuids": {
                    "type": "string",
                    "repeated": true,
                    "description": "IP reputation DB incremental update files."
                },
                "vendor": {
                    "type": "enum",
                    "enumType": "IPReputationVendor",
                    "description": "Organization providing IP reputation data.",
                    "immutable": true,
                    "required": true
                },
                "version": {
                    "type": "string",
                    "description": "A version number for this database object. This is informal for the consumer of this API only, a tool which manages this object can store version information here."
                },
                "service_status": {
                    "type": "message",
                    "messageType": "IPReputationServiceStatus",
                    "description": "If this object is managed by the IP reputation service, this field contain the status of this syncronization."
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                },
                "markers": {
                    "type": "message",
                    "messageType": "RoleFilterMatchLabel",
                    "repeated": true,
                    "description": "List of labels to be used for granular RBAC.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "base_file_v6_uuids": {
                    "type": "string",
                    "repeated": true,
                    "description": "IP reputation DB base file for IPv6.",
                    "maxRepeatedLength": 1,
                    "maxStringLength": 128
                },
                "incremental_file_v6_uuids": {
                    "type": "string",
                    "repeated": true,
                    "description": "IP reputation DB incremental update files for IPv6.",
                    "maxStringLength": 128
                },
                "v6_version": {
                    "type": "string",
                    "description": "A version number for IPv6 files for the object.",
                    "maxStringLength": 64
                }
            }
        },
        "IPReputationServiceStatus": {
            "fields": {
                "error": {
                    "type": "string",
                    "description": "If the last attempted update failed, this is a more detailed error message."
                },
                "last_successful_update_check": {
                    "type": "message",
                    "messageType": "TimeStamp",
                    "description": "The time when the IP reputation service last successfull attemped to update this object. This is the case when either this file references in this object got updated or when the IP reputation service knows positively that there are no newer versions for these files. It will be not update, if an error occurs during an update attempt. In this case, the errror will be set."
                }
            }
        },
        "JWTServerProfile": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "description": "UUID of the JWTProfile.",
                    "required": true
                },
                "name": {
                    "type": "string",
                    "description": "Name of the JWT Profile.",
                    "maxStringLength": 256,
                    "required": true
                },
                "jwks_keys": {
                    "type": "string",
                    "description": "JWKS key set used for validating the JWT, only allowed with profile_type CLIENT_AUTH."
                },
                "issuer": {
                    "type": "string",
                    "description": "Uniquely identifiable name of the Token Issuer, only allowed with profile_type CLIENT_AUTH."
                },
                "tenant_uuid": {
                    "type": "string",
                    "description": "UUID of the Tenant.",
                    "required": true
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                },
                "is_federated": {
                    "type": "bool",
                    "default": false,
                    "description": "This field describes the object's replication scope. If the field is set to false, then the object is visible within the controller-cluster.  If the field is set to true, then the object is replicated across the federation.  ",
                    "immutable": true
                },
                "jwt_profile_type": {
                    "type": "enum",
                    "enumType": "JWTProfileType",
                    "default": "CLIENT_AUTH",
                    "description": "Type of JWT Server profile which defines the usage type."
                },
                "controller_internal_auth": {
                    "type": "message",
                    "messageType": "ControllerInternalAuth",
                    "description": "JWT Auth configuration for profile_type CONTROLLER_INTERNAL_AUTH."
                },
                "protected_resource_config": {
                    "type": "message",
                    "messageType": "JWTProtectedResourceConfig",
                    "description": "OAuth 2.0 Protected Resource Metadata configuration (RFC 9728). Only applicable when jwt_profile_type is CLIENT_AUTH."
                }
            }
        },
        "JWTProtectedResourceConfig": {
            "fields": {
                "enable_protected_resource_metadata": {
                    "type": "bool",
                    "default": false,
                    "description": "Enable OAuth 2.0 Protected Resource Metadata (RFC 9728) support."
                },
                "metadata_url_path": {
                    "type": "string",
                    "default": "/.well-known/oauth-protected-resource",
                    "description": "URL path where OAuth 2.0 protected resource metadata is published. This is relative to the Virtual Service.",
                    "maxStringLength": 512,
                    "required": true
                },
                "authorization_servers": {
                    "type": "string",
                    "repeated": true,
                    "description": "List of authorization server issuer URLs that can issue tokens for this protected resource.",
                    "maxRepeatedLength": 1,
                    "maxStringLength": 1024
                },
                "supported_scopes": {
                    "type": "string",
                    "repeated": true,
                    "description": "List of OAuth 2.0 scopes supported by this protected resource.",
                    "maxRepeatedLength": 20,
                    "maxStringLength": 256
                },
                "resource_documentation": {
                    "type": "string",
                    "description": "URL of documentation for this protected resource.",
                    "maxStringLength": 1024
                }
            }
        },
        "ControllerInternalAuth": {
            "fields": {
                "symmetric_jwks_keys": {
                    "type": "message",
                    "messageType": "JWSKey",
                    "repeated": true,
                    "description": "Symmetric keys used for signing/validating the JWT, only allowed with profile_type CONTROLLER_INTERNAL_AUTH.",
                    "maxRepeatedLength": 1,
                    "minRepeatedLength": 1
                }
            }
        },
        "JWSKey": {
            "fields": {
                "alg": {
                    "type": "string",
                    "default": "HS256",
                    "description": "Algorithm that need to be used while signing/validation, allowed values: HS256, HS384, HS512."
                },
                "kty": {
                    "type": "string",
                    "default": "oct",
                    "description": "Secret key type/format, allowed value: octet(oct)."
                },
                "kid": {
                    "type": "string",
                    "description": "Unique key id across all keys.",
                    "required": true
                },
                "key": {
                    "type": "string",
                    "description": "Secret JWK for signing/validation, length of the key varies depending upon the type of algorithm used for key generation {HS256: 32 bytes, HS384: 48bytes, HS512: 64 bytes}.",
                    "required": true
                }
            }
        },
        "L4ConnectionPolicy": {
            "fields": {
                "rules": {
                    "type": "message",
                    "messageType": "L4Rule",
                    "repeated": true,
                    "description": "Rules to apply when a new transport connection is setup"
                }
            }
        },
        "L4Rule": {
            "fields": {
                "name": {
                    "type": "string",
                    "description": "Name of the rule",
                    "required": true
                },
                "index": {
                    "type": "int32",
                    "description": "Index of the rule",
                    "required": true
                },
                "enable": {
                    "type": "bool",
                    "default": true,
                    "description": "Enable or disable the rule"
                },
                "match": {
                    "type": "message",
                    "messageType": "L4RuleMatchTarget",
                    "description": "Match criteria of the rule"
                },
                "action": {
                    "type": "message",
                    "messageType": "L4RuleAction",
                    "description": "Action to be performed upon successful rule match"
                }
            },
            "repeatedKey": "index"
        },
        "L4RuleAction": {
            "fields": {
                "select_pool": {
                    "type": "message",
                    "messageType": "L4RuleActionSelectPool",
                    "description": "Indicates pool or pool-group selection on rule match"
                }
            }
        },
        "L4RuleActionSelectPool": {
            "fields": {
                "action_type": {
                    "type": "enum",
                    "enumType": "L4RuleActionSelectPoolType",
                    "description": "Indicates action to take on rule match",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "L4_RULE_ACTION_SELECT_POOL"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "L4_RULE_ACTION_SELECT_POOL"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "required": true
                },
                "pool_uuid": {
                    "type": "string",
                    "description": "ID of the pool of servers to serve the request"
                },
                "pool_group_uuid": {
                    "type": "string",
                    "description": "ID of the pool group to serve the request",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                }
            }
        },
        "L4RuleMatchTarget": {
            "fields": {
                "client_ip": {
                    "type": "message",
                    "messageType": "IpAddrMatch",
                    "description": "IP addresses to match against client IP",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "port": {
                    "type": "message",
                    "messageType": "L4RulePortMatch",
                    "description": "Port number to match against Virtual Service listner port"
                },
                "protocol": {
                    "type": "message",
                    "messageType": "L4RuleProtocolMatch",
                    "description": "TCP/UDP/ICMP protocol to match against transport protocol",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                }
            }
        },
        "L4RuleProtocolMatch": {
            "fields": {
                "match_criteria": {
                    "type": "enum",
                    "enumType": "MatchOperation",
                    "description": "Criterion to use for transport protocol matching",
                    "required": true
                },
                "protocol": {
                    "type": "enum",
                    "enumType": "Protocol",
                    "description": "Transport protocol to match",
                    "required": true
                }
            }
        },
        "L4RulePortMatch": {
            "fields": {
                "match_criteria": {
                    "type": "enum",
                    "enumType": "MatchOperation",
                    "description": "Criterion to use for Virtual Service port matching",
                    "required": true
                },
                "ports": {
                    "type": "uint32",
                    "repeated": true,
                    "description": "Virtual Service's listening port(s)",
                    "min": 1,
                    "max": 65535
                },
                "port_ranges": {
                    "type": "message",
                    "messageType": "PortRange",
                    "repeated": true,
                    "description": "Range of TCP/UDP port numbers of the Virtual Service",
                    "minRepeatedLength": 0
                }
            }
        },
        "PortRange": {
            "fields": {
                "start": {
                    "type": "uint32",
                    "required": true,
                    "description": "TCP/UDP port range start (inclusive).",
                    "min": 1,
                    "max": 65535
                },
                "end": {
                    "type": "uint32",
                    "required": true,
                    "description": "TCP/UDP port range end (inclusive).",
                    "min": 1,
                    "max": 65535
                }
            }
        },
        "L4PolicySet": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "description": "ID of the L4 Policy Set",
                    "required": true
                },
                "name": {
                    "type": "string",
                    "description": "Name of the L4 Policy Set",
                    "maxStringLength": 256,
                    "required": true
                },
                "l4_connection_policy": {
                    "type": "message",
                    "messageType": "L4ConnectionPolicy",
                    "description": "Policy to apply when a new transport connection is setup"
                },
                "created_by": {
                    "type": "string",
                    "description": "Creator name"
                },
                "markers": {
                    "type": "message",
                    "messageType": "RoleFilterMatchLabel",
                    "repeated": true,
                    "description": "List of labels to be used for granular RBAC.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "is_internal_policy": {
                    "type": "bool",
                    "default": false
                },
                "description": {
                    "type": "string"
                },
                "tenant_uuid": {
                    "type": "string",
                    "required": true
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                }
            }
        },
        "NatPolicy": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "description": "UUID of the Nat policy.",
                    "required": true
                },
                "name": {
                    "type": "string",
                    "description": "Name of the Nat policy.",
                    "maxStringLength": 256
                },
                "rules": {
                    "type": "message",
                    "messageType": "NatRule",
                    "repeated": true,
                    "description": "Nat policy Rules."
                },
                "created_by": {
                    "type": "string",
                    "description": "Creator name"
                },
                "markers": {
                    "type": "message",
                    "messageType": "RoleFilterMatchLabel",
                    "repeated": true,
                    "description": "List of labels to be used for granular RBAC.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "description": {
                    "type": "string"
                },
                "tenant_uuid": {
                    "type": "string",
                    "required": true
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                }
            }
        },
        "NatRule": {
            "fields": {
                "name": {
                    "type": "string",
                    "description": "Nat rule Name.",
                    "required": true
                },
                "index": {
                    "type": "uint32",
                    "description": "Nat rule Index.",
                    "required": true
                },
                "enable": {
                    "type": "bool",
                    "description": "Nat rule enable flag.",
                    "required": true
                },
                "match": {
                    "type": "message",
                    "messageType": "NatMatchTarget",
                    "description": "Nat rule Match Criteria.",
                    "required": true
                },
                "action": {
                    "type": "message",
                    "messageType": "NatPolicyAction",
                    "description": "Nat rule Action Information.",
                    "required": true
                },
                "created_by": {
                    "type": "string",
                    "description": "Creator name"
                }
            },
            "repeatedKey": "index"
        },
        "NatPolicyAction": {
            "fields": {
                "type": {
                    "type": "enum",
                    "enumType": "NatPolicyActionType",
                    "description": "Nat Action Type.",
                    "required": true
                },
                "nat_info": {
                    "type": "message",
                    "messageType": "NatAddrInfo",
                    "repeated": true,
                    "description": "Pool of IP Addresses used for Nat."
                }
            }
        },
        "NatAddrInfo": {
            "fields": {
                "nat_ip": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "description": "Nat IP address"
                },
                "nat_ip_range": {
                    "type": "message",
                    "messageType": "IpAddrRange",
                    "description": "Nat IP address range"
                }
            }
        },
        "NatMatchTarget": {
            "fields": {
                "source_ip": {
                    "type": "message",
                    "messageType": "IpAddrMatch",
                    "description": "Source IP of the packet"
                },
                "destination_ip": {
                    "type": "message",
                    "messageType": "IpAddrMatch",
                    "description": "Destination IP of the packet"
                },
                "services": {
                    "type": "message",
                    "messageType": "ServiceMatch",
                    "description": "Services like port-matching and protocol."
                }
            }
        },
        "ServiceMatch": {
            "fields": {
                "source_port": {
                    "type": "message",
                    "messageType": "PortMatch",
                    "description": "Source Port of the packet"
                },
                "destination_port": {
                    "type": "message",
                    "messageType": "PortMatch",
                    "description": "Destination Port of the packet"
                },
                "protocol": {
                    "type": "message",
                    "messageType": "L4RuleProtocolMatch",
                    "description": "Protocol to match. Supported protocols are TCP, UDP and ICMP."
                }
            }
        },
        "Network": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "required": true
                },
                "name": {
                    "type": "string",
                    "required": true,
                    "maxStringLength": 256
                },
                "vcenter_dvs": {
                    "type": "bool",
                    "default": true
                },
                "vimgrnw_uuid": {
                    "type": "string"
                },
                "dhcp_enabled": {
                    "type": "bool",
                    "default": true,
                    "description": "Select the IP address management scheme for this Network"
                },
                "exclude_discovered_subnets": {
                    "type": "bool",
                    "default": false,
                    "description": "When selected, excludes all discovered subnets in this network from consideration for virtual service placement."
                },
                "configured_subnets": {
                    "type": "message",
                    "messageType": "Subnet",
                    "repeated": true
                },
                "vrf_context_uuid": {
                    "type": "string"
                },
                "synced_from_se": {
                    "type": "bool",
                    "default": false
                },
                "tenant_uuid": {
                    "type": "string"
                },
                "cloud_uuid": {
                    "type": "string",
                    "default": "Default-Cloud"
                },
                "ip6_autocfg_enabled": {
                    "type": "bool",
                    "default": true,
                    "description": "Enable IPv6 auto configuration"
                },
                "attrs": {
                    "type": "message",
                    "messageType": "KeyValue",
                    "repeated": true,
                    "description": "Key/value network attributes."
                },
                "markers": {
                    "type": "message",
                    "messageType": "RoleFilterMatchLabel",
                    "repeated": true,
                    "description": "List of labels to be used for granular RBAC.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                }
            }
        },
        "KeyValue": {
            "fields": {
                "key": {
                    "type": "string",
                    "required": true,
                    "description": "Key"
                },
                "value": {
                    "type": "string",
                    "description": "Value"
                }
            },
            "repeatedKey": "key"
        },
        "Subnet": {
            "fields": {
                "prefix": {
                    "type": "message",
                    "messageType": "IpAddrPrefix",
                    "required": true,
                    "description": "Specify an IP subnet prefix for this Network"
                },
                "static_ip_ranges": {
                    "type": "message",
                    "messageType": "StaticIpRange",
                    "repeated": true,
                    "description": "Static IP ranges for this subnet"
                }
            },
            "repeatedKey": "prefix"
        },
        "StaticIpRange": {
            "fields": {
                "range": {
                    "type": "message",
                    "messageType": "IpAddrRange",
                    "description": "IP range",
                    "required": true
                },
                "type": {
                    "type": "enum",
                    "enumType": "StaticIpType",
                    "default": "STATIC_IPS_FOR_VIP_AND_SE",
                    "description": "Object type (VIP only, Service Engine only, or both) which can use this IP range"
                }
            }
        },
        "NetworkProfile": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "required": true,
                    "description": "UUID of the network profile."
                },
                "name": {
                    "type": "string",
                    "required": true,
                    "description": "The name of the network profile.",
                    "maxStringLength": 256
                },
                "profile": {
                    "type": "message",
                    "messageType": "NetworkProfileUnion",
                    "required": true
                },
                "description": {
                    "type": "string"
                },
                "tenant_uuid": {
                    "type": "string",
                    "required": true
                },
                "connection_mirror": {
                    "type": "bool",
                    "default": false,
                    "description": "When enabled, Avi mirrors all TCP fastpath connections to standby. Applicable only in Legacy HA Mode.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "markers": {
                    "type": "message",
                    "messageType": "RoleFilterMatchLabel",
                    "repeated": true,
                    "description": "List of labels to be used for granular RBAC.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                }
            }
        },
        "NetworkProfileUnion": {
            "fields": {
                "type": {
                    "type": "enum",
                    "enumType": "ProtocolType",
                    "default": "PROTOCOL_TYPE_TCP_PROXY",
                    "required": true,
                    "description": "Configure one of either proxy or fast path profiles.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "PROTOCOL_TYPE_TCP_FAST_PATH,PROTOCOL_TYPE_UDP_FAST_PATH"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "PROTOCOL_TYPE_TCP_PROXY,PROTOCOL_TYPE_TCP_FAST_PATH,PROTOCOL_TYPE_UDP_FAST_PATH"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "immutable": true
                },
                "tcp_proxy_profile": {
                    "type": "message",
                    "messageType": "TCPProxyProfile",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "tcp_fast_path_profile": {
                    "type": "message",
                    "messageType": "TCPFastPathProfile"
                },
                "udp_fast_path_profile": {
                    "type": "message",
                    "messageType": "UDPFastPathProfile"
                },
                "udp_proxy_profile": {
                    "type": "message",
                    "messageType": "UDPProxyProfile",
                    "description": "Configure UDP Proxy network profile",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "sctp_proxy_profile": {
                    "type": "message",
                    "messageType": "SCTPProxyProfile",
                    "description": "Configure SCTP Proxy network profile"
                },
                "sctp_fast_path_profile": {
                    "type": "message",
                    "messageType": "SCTPFastPathProfile",
                    "description": "Configure SCTP FastPath network profile"
                }
            }
        },
        "SCTPFastPathProfile": {
            "fields": {
                "idle_timeout": {
                    "type": "int32",
                    "default": 0,
                    "description": "SCTP autoclose timeout. 0 means autoclose deactivated.",
                    "min": 0,
                    "max": 247483647
                },
                "enable_init_chunk_protection": {
                    "type": "bool",
                    "default": false,
                    "description": "When enabled, Avi will complete the 4-way handshake with the client before forwarding any packets to the server.  This will protect the server from INIT chunks flood and half open connections."
                }
            }
        },
        "SCTPProxyProfile": {
            "fields": {
                "number_of_streams": {
                    "type": "int32",
                    "default": 10,
                    "description": "Number of incoming SCTP Streams.",
                    "min": 1,
                    "max": 100
                },
                "reset_timeout": {
                    "type": "int32",
                    "default": 0,
                    "description": "SCTP reset/shutdown guard timeout. 0 means 5 times RTO max.",
                    "min": 0,
                    "max": 247483647
                },
                "receive_window": {
                    "type": "int32",
                    "default": 1024,
                    "description": "SCTP send and receive buffer size.",
                    "min": 2,
                    "max": 65536
                },
                "cookie_expiration_timeout": {
                    "type": "int32",
                    "default": 60,
                    "description": "SCTP cookie expiration timeout.",
                    "min": 60,
                    "max": 3600
                },
                "heartbeat_interval": {
                    "type": "int32",
                    "default": 30,
                    "description": "SCTP heartbeat interval.",
                    "min": 30,
                    "max": 247483647
                },
                "idle_timeout": {
                    "type": "int32",
                    "default": 0,
                    "description": "SCTP autoclose timeout. 0 means autoclose deactivated.",
                    "min": 0,
                    "max": 247483647
                },
                "max_retransmissions_init_chunks": {
                    "type": "int32",
                    "default": 8,
                    "description": "SCTP maximum retransmissions for INIT chunks.",
                    "min": 1,
                    "max": 247483647
                },
                "max_retransmissions_association": {
                    "type": "int32",
                    "default": 10,
                    "description": "SCTP maximum retransmissions for association.",
                    "min": 1,
                    "max": 247483647
                }
            }
        },
        "UDPProxyProfile": {
            "fields": {
                "session_idle_timeout": {
                    "type": "int32",
                    "default": 10,
                    "description": "The amount of time (in sec) for which a flow needs to be idle before it is deleted.",
                    "min": 2,
                    "max": 3600
                }
            }
        },
        "UDPFastPathProfile": {
            "fields": {
                "session_idle_timeout": {
                    "type": "int32",
                    "default": 10,
                    "description": "The amount of time (in sec) for which a flow needs to be idle before it is deleted.",
                    "min": 2,
                    "max": 3600
                },
                "per_pkt_loadbalance": {
                    "type": "bool",
                    "default": false,
                    "description": "When enabled, every UDP packet is considered a new transaction and may be load balanced to a different server.  When disabled, packets from the same client source IP and port are sent to the same server.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "snat": {
                    "type": "bool",
                    "default": true,
                    "description": "When disabled, Source NAT will not be performed for all client UDP packets"
                },
                "dsr_profile": {
                    "type": "message",
                    "messageType": "DsrProfile",
                    "description": "DSR profile information",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                }
            }
        },
        "DsrProfile": {
            "fields": {
                "dsr_type": {
                    "type": "enum",
                    "enumType": "DsrType",
                    "default": "DSR_TYPE_L3",
                    "description": "DSR type L2/L3",
                    "immutable": true,
                    "required": true
                },
                "dsr_encap_type": {
                    "type": "enum",
                    "enumType": "EncapType",
                    "default": "ENCAP_IPINIP",
                    "description": "Encapsulation type to use when DSR is L3",
                    "immutable": true,
                    "required": true
                }
            }
        },
        "TCPFastPathProfile": {
            "fields": {
                "session_idle_timeout": {
                    "type": "int32",
                    "default": 300,
                    "description": "The amount of time (in sec) for which a connection needs to be idle before it is eligible to be deleted.",
                    "min": 5,
                    "max": 14400,
                    "specialValues": {
                        "0": "infinite"
                    }
                },
                "enable_syn_protection": {
                    "type": "bool",
                    "default": false,
                    "description": "When enabled, Avi will complete the 3-way handshake with the client before forwarding any packets to the server.  This will protect the server from SYN flood and half open SYN connections.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "dsr_profile": {
                    "type": "message",
                    "messageType": "DsrProfile",
                    "description": "DSR profile information",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "tcp_fastpath_options": {
                    "type": "message",
                    "messageType": "TCPOptions",
                    "description": "TCP_Fast_PATH Network profile options"
                }
            }
        },
        "TCPOptions": {
            "fields": {
                "strip_sack": {
                    "type": "bool",
                    "default": false,
                    "description": "Remove the SACK TCP option from header"
                }
            }
        },
        "TCPProxyProfile": {
            "fields": {
                "automatic": {
                    "type": "bool",
                    "default": true,
                    "description": "Dynamically pick the relevant parameters for connections.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "true"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "idle_connection_type": {
                    "type": "enum",
                    "enumType": "IdleConnectionType",
                    "default": "KEEP_ALIVE",
                    "description": "Controls the behavior of idle connections."
                },
                "idle_connection_timeout": {
                    "type": "int32",
                    "default": 600,
                    "description": "The duration for keepalive probes or session idle timeout. Max value is 14400 seconds, min is 5.  Set to 0 to allow infinite idle time.",
                    "min": 5,
                    "max": 14400,
                    "specialValues": {
                        "0": "infinite"
                    }
                },
                "ignore_time_wait": {
                    "type": "bool",
                    "default": false,
                    "description": "A new SYN is accepted from the same 4-tuple even if there is already a connection in TIME_WAIT state.  This is equivalent of setting Time Wait Delay to 0"
                },
                "time_wait_delay": {
                    "type": "int32",
                    "default": 2000,
                    "description": "The time (in millisec) to wait before closing a connection in the TIME_WAIT state.",
                    "min": 500,
                    "max": 2000,
                    "specialValues": {
                        "0": "immediate"
                    }
                },
                "max_retransmissions": {
                    "type": "int32",
                    "default": 8,
                    "description": "The number of attempts at retransmit before closing the connection.",
                    "min": 3,
                    "max": 8
                },
                "max_syn_retransmissions": {
                    "type": "int32",
                    "default": 8,
                    "description": "The maximum number of attempts at retransmitting a SYN packet before giving up.",
                    "min": 3,
                    "max": 8
                },
                "receive_window": {
                    "type": "int32",
                    "default": 64,
                    "description": "Size of the receive window.",
                    "min": 2,
                    "max": 65536
                },
                "use_interface_mtu": {
                    "type": "bool",
                    "default": true,
                    "description": "Use the interface MTU to calculate the TCP max segment size."
                },
                "max_segment_size": {
                    "type": "int32",
                    "description": "Maximum TCP segment size.",
                    "min": 512,
                    "max": 9000,
                    "specialValues": {
                        "0": "Use Interface MTU"
                    }
                },
                "nagles_algorithm": {
                    "type": "bool",
                    "default": false,
                    "description": "Consolidates small data packets to send clients fewer but larger packets.  Adversely affects real time protocols such as telnet or SSH."
                },
                "ip_dscp": {
                    "type": "int32",
                    "default": 0,
                    "description": "Controls the value of the Differentiated Services Code Point field inserted in the IP header.  This has two options:  Set to a specific value, or Pass Through, which uses the incoming DSCP value.",
                    "min": 0,
                    "max": 63,
                    "specialValues": {
                        "MAX": "Passthrough"
                    }
                },
                "cc_algo": {
                    "type": "enum",
                    "enumType": "CongestionAlgo",
                    "default": "CC_ALGO_NEW_RENO",
                    "description": "Controls the congestion control algorithm we use."
                },
                "aggressive_congestion_avoidance": {
                    "type": "bool",
                    "default": false,
                    "description": "Controls the our congestion window to send, normally it's 1 mss, If this option is turned on, we use 10 msses"
                },
                "reorder_threshold": {
                    "type": "uint32",
                    "description": "Controls the number of duplicate acks required to trigger retransmission. Setting a higher value reduces retransmission caused by packet reordering. A larger value is recommended in public cloud environments where packet reordering is quite common. The default value is 8 in public cloud platforms (AWS, Azure, GCP), and 3 in other environments.",
                    "min": 1,
                    "max": 100
                },
                "min_rexmt_timeout": {
                    "type": "uint32",
                    "description": "The minimum wait time (in millisec) to retransmit packet",
                    "min": 50,
                    "max": 5000
                },
                "slow_start_scaling_factor": {
                    "type": "uint32",
                    "default": 1,
                    "description": "Congestion window scaling factor during slow start.",
                    "min": 0,
                    "max": 8
                },
                "congestion_recovery_scaling_factor": {
                    "type": "uint32",
                    "default": 2,
                    "description": "Congestion window scaling factor after recovery.",
                    "min": 0,
                    "max": 8
                },
                "reassembly_queue_size": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Maximum number of TCP segments that can be queued for reassembly. Configuring this to 0 disables the feature and provides unlimited queuing."
                },
                "keepalive_in_halfclose_state": {
                    "type": "bool",
                    "default": true,
                    "description": "Controls whether to keep the connection alive with keepalive messages in the TCP half close state. The interval for sending keepalive messages is 30s. If a timeout is already configured in the network profile, this will not override it."
                },
                "auto_window_growth": {
                    "type": "bool",
                    "default": true,
                    "description": "Controls whether the windows are static or supports autogrowth. Maximum that it can grow to is limited to 4MB."
                },
                "ack_on_push": {
                    "type": "bool",
                    "default": false,
                    "description": "Controls whether we immediately send ack when incoming packet has PUSH flag marked"
                },
                "delayed_ack_timer_delay": {
                    "type": "uint32",
                    "default": 100,
                    "description": "The time in milliseconds for delayed timer to kick in",
                    "min": 0,
                    "max": 500,
                    "specialValues": {
                        "0": "Disable Delayed Ack"
                    }
                },
                "delayed_ack_mode": {
                    "type": "bool",
                    "description": "Determines if delayed ack mode is enabledTrue: Unconditionally use delayed ackFalse: Don't use delayed ack"
                }
            }
        },
        "NetworkSecurityPolicy": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "required": true
                },
                "name": {
                    "type": "string",
                    "maxStringLength": 280
                },
                "rules": {
                    "type": "message",
                    "messageType": "NetworkSecurityRule",
                    "repeated": true
                },
                "created_by": {
                    "type": "string",
                    "description": "Creator name"
                },
                "cloud_config_cksum": {
                    "type": "string",
                    "description": "Checksum of cloud configuration for Network Sec Policy. Internally set by cloud connector"
                },
                "ip_reputation_db_uuid": {
                    "type": "string",
                    "description": "IP reputation database.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "geo_db_uuid": {
                    "type": "string",
                    "description": "Geo database."
                },
                "markers": {
                    "type": "message",
                    "messageType": "RoleFilterMatchLabel",
                    "repeated": true,
                    "description": "List of labels to be used for granular RBAC.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "internal": {
                    "type": "bool",
                    "description": "Network Security Policy is created and modified by internal modules only. Should not be modified by users."
                },
                "description": {
                    "type": "string"
                },
                "tenant_uuid": {
                    "type": "string"
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                }
            }
        },
        "NetworkSecurityRule": {
            "fields": {
                "name": {
                    "type": "string",
                    "required": true
                },
                "index": {
                    "type": "uint32",
                    "required": true
                },
                "enable": {
                    "type": "bool",
                    "required": true
                },
                "match": {
                    "type": "message",
                    "messageType": "NetworkSecurityMatchTarget",
                    "required": true
                },
                "action": {
                    "type": "enum",
                    "enumType": "NetworkSecurityPolicyActionType",
                    "required": true,
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "NETWORK_SECURITY_POLICY_ACTION_TYPE_DENY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "NETWORK_SECURITY_POLICY_ACTION_TYPE_DENY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "log": {
                    "type": "bool",
                    "default": false,
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "rl_param": {
                    "type": "message",
                    "messageType": "NetworkSecurityPolicyActionRLParam",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "age": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Time in minutes after which rule will be deleted.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "0"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "0"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 1,
                    "max": 4294967295,
                    "specialValues": {
                        "0": "blocked for ever"
                    }
                },
                "created_by": {
                    "type": "string",
                    "description": "Creator name"
                }
            },
            "repeatedKey": "index"
        },
        "NetworkSecurityPolicyActionRLParam": {
            "fields": {
                "max_rate": {
                    "type": "uint32",
                    "required": true,
                    "description": "Maximum number of connections or requests or packets per second.",
                    "min": 1,
                    "max": 4294967295
                },
                "burst_size": {
                    "type": "uint32",
                    "default": 0,
                    "required": true,
                    "description": "Maximum number of connections or requests or packets to be rate limited instantaneously."
                }
            }
        },
        "NetworkSecurityMatchTarget": {
            "fields": {
                "client_ip": {
                    "type": "message",
                    "messageType": "IpAddrMatch"
                },
                "vs_port": {
                    "type": "message",
                    "messageType": "PortMatch"
                },
                "microservice": {
                    "type": "message",
                    "messageType": "MicroServiceMatch",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "ip_reputation_type": {
                    "type": "message",
                    "messageType": "IPReputationTypeMatch",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "client_port": {
                    "type": "message",
                    "messageType": "PortMatchGeneric",
                    "description": "Matches the source port of incoming packets in the client side traffic"
                },
                "geo_matches": {
                    "type": "message",
                    "messageType": "GeoMatch",
                    "repeated": true,
                    "description": "Matches the geo information of incoming packets in the client side traffic.",
                    "maxRepeatedLength": 1
                }
            }
        },
        "MicroServiceMatch": {
            "fields": {
                "match_criteria": {
                    "type": "enum",
                    "enumType": "MatchOperation",
                    "required": true,
                    "description": "Criterion to use for Micro Service matching the HTTP request"
                },
                "group_uuid": {
                    "type": "string",
                    "description": "UUID of Micro Service group(s)",
                    "required": true
                }
            }
        },
        "OrgServiceUnits": {
            "fields": {
                "org_id": {
                    "type": "string",
                    "description": "Organization id.",
                    "maxStringLength": 256
                },
                "available_service_units": {
                    "type": "Unknown",
                    "description": "Available service units on pulse portal."
                },
                "used_service_units": {
                    "type": "Unknown",
                    "description": "Used service units on pulse portal."
                }
            }
        },
        "OsLbProvPluginForm": {
            "fields": {
                "neutron_host_ip": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "required": true,
                    "description": "Neutron Host IP Address"
                },
                "neutron_host_user": {
                    "type": "string",
                    "required": true,
                    "description": "Neutron Host root username"
                },
                "neutron_host_passwd": {
                    "type": "string",
                    "required": true,
                    "description": "Neutron Host IP root password"
                },
                "op_type": {
                    "type": "enum",
                    "enumType": "OsLbProvOpType",
                    "required": true,
                    "description": "Operation to perform"
                },
                "prov_name": {
                    "type": "string",
                    "default": "avi_adc",
                    "description": "OpenStack LBaaS provider name"
                },
                "prov_host_ip": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "description": "Avi Controller IP Address"
                },
                "prov_svc_user": {
                    "type": "string",
                    "description": "Avi Controller service username"
                },
                "prov_svc_passwd": {
                    "type": "string",
                    "description": "Avi Controller service password"
                },
                "restart_neutron": {
                    "type": "bool",
                    "default": true,
                    "description": "restart neutron service after provider configuration"
                }
            }
        },
        "PKIProfile": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "required": true
                },
                "name": {
                    "type": "string",
                    "required": true,
                    "description": "Name of the PKI Profile",
                    "maxStringLength": 256
                },
                "ca_certs": {
                    "type": "message",
                    "messageType": "SSLCertificate",
                    "repeated": true,
                    "description": "List of Certificate Authorities (Root and Intermediate) trusted that is used for certificate validation"
                },
                "ignore_peer_chain": {
                    "type": "bool",
                    "default": false,
                    "description": "When enabled, Avi will not trust Intermediate and Root certs presented by a client.  Instead, only the chain certs configured in the Certificate Authority section will be used to verify trust of the client's cert.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "true",
                            "default_value": true
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "true",
                            "default_value": true
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "crl_check": {
                    "type": "bool",
                    "default": true,
                    "description": "When enabled, Avi will verify via CRL checks that certificates in the trust chain have not been revoked."
                },
                "validate_only_leaf_crl": {
                    "type": "bool",
                    "default": true,
                    "description": "When enabled, Avi will only validate the revocation status of the leaf certificate using CRL. To enable validation for the entire chain, disable this option and provide all the relevant CRLs",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "true"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "true"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "created_by": {
                    "type": "string",
                    "description": "Creator name"
                },
                "markers": {
                    "type": "message",
                    "messageType": "RoleFilterMatchLabel",
                    "repeated": true,
                    "description": "List of labels to be used for granular RBAC.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "crl_file_uuids": {
                    "type": "string",
                    "repeated": true,
                    "description": "Refers to FileObject containing CRL body.",
                    "maxStringLength": 255
                },
                "is_federated": {
                    "type": "bool",
                    "default": false,
                    "description": "This field describes the object's replication scope. If the field is set to false, then the object is visible within the controller-cluster and its associated service-engines.  If the field is set to true, then the object is replicated across the federation.  ",
                    "immutable": true
                },
                "tenant_uuid": {
                    "type": "string",
                    "required": true
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                },
                "allow_pki_errors": {
                    "type": "enum",
                    "enumType": "AllowedPKIErrors",
                    "repeated": true,
                    "description": "Exempt errors during certificate verification.",
                    "maxRepeatedLength": 1
                }
            }
        },
        "Pool": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "required": true,
                    "description": "UUID of the pool"
                },
                "name": {
                    "type": "string",
                    "required": true,
                    "description": "The name of the pool.",
                    "maxStringLength": 280
                },
                "default_server_port": {
                    "type": "int32",
                    "default": 80,
                    "description": "Traffic sent to servers will use this destination server port unless overridden by the server's specific port attribute. The SSL checkbox enables Avi to server encryption.",
                    "min": 1,
                    "max": 65535
                },
                "connection_ramp_duration": {
                    "type": "int32",
                    "default": 10,
                    "description": "Duration for which new connections will be gradually ramped up to a server recently brought online.  Useful for LB algorithms that are least connection based.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "0",
                            "default_value": 0
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "0",
                            "default_value": 0
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 1,
                    "max": 300,
                    "specialValues": {
                        "0": "Immediate"
                    }
                },
                "max_concurrent_connections_per_server": {
                    "type": "int32",
                    "default": 0,
                    "description": "The maximum number of concurrent connections allowed to each server within the pool. NOTE: applied value will be no less than the number of service engines that the pool is placed on. If set to 0, no limit is applied."
                },
                "health_monitor_uuids": {
                    "type": "string",
                    "repeated": true,
                    "description": "Verify server health by applying one or more health monitors.  Active monitors generate synthetic traffic from each Service Engine and mark a server up or down based on the response. The Passive monitor listens only to client to server communication. It raises or lowers the ratio of traffic destined to a server based on successful responses.",
                    "maxRepeatedLength": 50
                },
                "servers": {
                    "type": "message",
                    "messageType": "Server",
                    "repeated": true,
                    "description": "The pool directs load balanced traffic to this list of destination servers. The servers can be configured by IP address, name, network or via IP Address Group",
                    "maxRepeatedLength": 5000
                },
                "graceful_disable_timeout_sec": {
                    "type": "int32",
                    "default": 60,
                    "description": "Used to gracefully disable a server. Virtual service waits for the specified time before terminating the existing connections  to the servers that are disabled.",
                    "min": 1,
                    "max": 432000,
                    "specialValues": {
                        "0": "Immediate",
                        "-1": "Infinite"
                    }
                },
                "lb_algorithm": {
                    "type": "enum",
                    "enumType": "LbAlgorithm",
                    "default": "LB_ALGORITHM_LEAST_CONNECTIONS",
                    "description": "The load balancing algorithm will pick a server within the pool's list of available servers. Values LB_ALGORITHM_NEAREST_SERVER and LB_ALGORITHM_TOPOLOGY are only allowed for GSLB pool",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "LB_ALGORITHM_LEAST_CONNECTIONS,LB_ALGORITHM_ROUND_ROBIN,LB_ALGORITHM_CONSISTENT_HASH"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "LB_ALGORITHM_LEAST_CONNECTIONS,LB_ALGORITHM_ROUND_ROBIN,LB_ALGORITHM_CONSISTENT_HASH"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "lb_algorithm_hash": {
                    "type": "enum",
                    "enumType": "LbAlgorithmConsistentHash",
                    "default": "LB_ALGORITHM_CONSISTENT_HASH_SOURCE_IP_ADDRESS",
                    "description": "Criteria used as a key for determining the hash between the client and  server.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "LB_ALGORITHM_CONSISTENT_HASH_SOURCE_IP_ADDRESS"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "LB_ALGORITHM_CONSISTENT_HASH_SOURCE_IP_ADDRESS"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "lb_algorithm_consistent_hash_hdr": {
                    "type": "string",
                    "description": "HTTP header name to be used for the hash key.",
                    "maxStringLength": 256
                },
                "networks": {
                    "type": "message",
                    "messageType": "NetworkFilter",
                    "repeated": true,
                    "description": "(internal-use) Networks designated as containing servers for this pool.  The servers may be further narrowed down by a filter. This field is used internally by Avi, not editable by the user."
                },
                "placement_networks": {
                    "type": "message",
                    "messageType": "PlacementNetwork",
                    "repeated": true,
                    "description": "Manually select the networks and subnets used to provide reachability to the pool's servers.  Specify the Subnet using the following syntax: 10-1-1-0/24. Use static routes in VRF configuration when pool servers are not directly connected but routable from the service engine."
                },
                "application_persistence_profile_uuid": {
                    "type": "string",
                    "description": "Persistence will ensure the same user sticks to the same server for a desired duration of time."
                },
                "ssl_profile_uuid": {
                    "type": "string",
                    "description": "When enabled, Avi re-encrypts traffic to the backend servers. The specific SSL profile defines which ciphers and SSL versions will be supported."
                },
                "inline_health_monitor": {
                    "type": "bool",
                    "default": true,
                    "description": "The Passive monitor will monitor client to server connections and requests and adjust traffic load to servers based on successful responses.  This may alter the expected behavior of the LB method, such as Round Robin."
                },
                "use_service_port": {
                    "type": "bool",
                    "default": false,
                    "description": "Do not translate the client's destination port when sending the connection to the server. Monitor port needs to be specified for health monitors.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "fail_action": {
                    "type": "message",
                    "messageType": "FailAction",
                    "description": "Enable an action - Close Connection, HTTP Redirect or Local HTTP Response - when a pool failure happens. By default, a connection will be closed, in case the pool experiences a failure."
                },
                "capacity_estimation": {
                    "type": "bool",
                    "default": false,
                    "description": "Inline estimation of capacity of servers.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "capacity_estimation_ttfb_thresh": {
                    "type": "uint32",
                    "default": 0,
                    "description": "The maximum time-to-first-byte of a server.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "0"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "0"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 1,
                    "max": 5000,
                    "specialValues": {
                        "0": "Automatic"
                    }
                },
                "pki_profile_uuid": {
                    "type": "string",
                    "description": "Avi will validate the SSL certificate present by a server against the selected PKI Profile."
                },
                "ssl_key_and_certificate_uuid": {
                    "type": "string",
                    "description": "Service Engines will present a client SSL certificate to the server."
                },
                "autoscale_networks": {
                    "type": "string",
                    "repeated": true,
                    "description": "Network Ids for the launch configuration",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "autoscale_policy_uuid": {
                    "type": "string",
                    "description": "Reference to Server Autoscale Policy",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "autoscale_launch_config_uuid": {
                    "type": "string",
                    "description": "If configured then Avi will trigger orchestration of pool server creation and deletion.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "vrf_uuid": {
                    "type": "string",
                    "description": "Virtual Routing Context that the pool is bound to. This is used to provide the isolation of the set of networks the pool is attached to. The pool inherits the Virtual Routing Context of the Virtual Service, and this field is used only internally, and is set by pb-transform.",
                    "immutable": true
                },
                "ipaddrgroup_uuid": {
                    "type": "string",
                    "description": "Use list of servers from Ip Address Group"
                },
                "fewest_tasks_feedback_delay": {
                    "type": "uint32",
                    "default": 10,
                    "description": "Periodicity of feedback for fewest tasks server selection algorithm.",
                    "min": 1,
                    "max": 300
                },
                "enabled": {
                    "type": "bool",
                    "default": true,
                    "description": "Enable or disable the pool.  Disabling will terminate all open connections and pause health monitors."
                },
                "max_conn_rate_per_server": {
                    "type": "message",
                    "messageType": "RateProfile",
                    "description": "Rate Limit connections to each server.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "east_west": {
                    "type": "bool",
                    "description": "Inherited config from VirtualService."
                },
                "created_by": {
                    "type": "string",
                    "description": "Creator name",
                    "immutable": true
                },
                "cloud_config_cksum": {
                    "type": "string",
                    "description": "Checksum of cloud configuration for Pool. Internally set by cloud connector"
                },
                "request_queue_enabled": {
                    "type": "bool",
                    "default": false,
                    "description": "Enable request queue when pool is full",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "request_queue_depth": {
                    "type": "uint32",
                    "default": 128,
                    "description": "Minimum number of requests to be queued when pool is full.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "128"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "128"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "server_reselect": {
                    "type": "message",
                    "messageType": "HTTPServerReselect",
                    "description": "Server reselect configuration for HTTP requests."
                },
                "host_check_enabled": {
                    "type": "bool",
                    "default": false,
                    "description": "Enable common name check for server certificate. If enabled and no explicit domain name is specified, Avi will use the incoming host header to do the match."
                },
                "domain_name": {
                    "type": "string",
                    "repeated": true,
                    "description": "Comma separated list of domain names which will be used to verify the common names or subject alternative names presented by server certificates. It is performed only when common name check host_check_enabled is enabled."
                },
                "sni_enabled": {
                    "type": "bool",
                    "default": true,
                    "description": "Enable TLS SNI for server connections. If disabled, Avi will not send the SNI extension as part of the handshake."
                },
                "server_name": {
                    "type": "string",
                    "description": "Fully qualified DNS hostname which will be used in the TLS SNI extension in server connections if SNI is enabled. If no value is specified, Avi will use the incoming host header instead."
                },
                "rewrite_host_header_to_sni": {
                    "type": "bool",
                    "default": false,
                    "description": "If SNI server name is specified, rewrite incoming host header to the SNI server name."
                },
                "rewrite_host_header_to_server_name": {
                    "type": "bool",
                    "default": false,
                    "description": "Rewrite incoming Host Header to server name of the server to which the request is proxied.  Enabling this feature rewrites Host Header for requests to all servers in the pool."
                },
                "nsx_securitygroup": {
                    "type": "string",
                    "repeated": true,
                    "description": "A list of NSX Groups where the Servers for the Pool are created "
                },
                "external_autoscale_groups": {
                    "type": "string",
                    "repeated": true,
                    "description": "Names of external auto-scale groups for pool servers. Currently available only for AWS and Azure"
                },
                "lb_algorithm_core_nonaffinity": {
                    "type": "uint32",
                    "default": 2,
                    "description": "Degree of non-affinity for core affinity based server selection.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "2"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "2"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 1,
                    "max": 65535
                },
                "gslb_sp_enabled": {
                    "type": "bool",
                    "description": "Indicates if the pool is a site-persistence pool. ",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "lookup_server_by_name": {
                    "type": "bool",
                    "default": false,
                    "description": "Allow server lookup by name.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "analytics_profile_uuid": {
                    "type": "string",
                    "default": "System-Analytics-Profile",
                    "description": "Specifies settings related to analytics."
                },
                "analytics_policy": {
                    "type": "message",
                    "messageType": "PoolAnalyticsPolicy",
                    "description": "Determines analytics settings for the pool."
                },
                "service_metadata": {
                    "type": "string",
                    "description": "Metadata pertaining to the service provided by this Pool. In Openshift/Kubernetes environments, app metadata info is stored. Any user input to this field will be overwritten by Avi Vantage."
                },
                "markers": {
                    "type": "message",
                    "messageType": "RoleFilterMatchLabel",
                    "repeated": true,
                    "description": "List of labels to be used for granular RBAC.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "description": {
                    "type": "string",
                    "description": "A description of the pool."
                },
                "tenant_uuid": {
                    "type": "string"
                },
                "cloud_uuid": {
                    "type": "string",
                    "default": "Default-Cloud",
                    "immutable": true
                },
                "min_servers_up": {
                    "type": "uint32",
                    "description": "Minimum number of servers in UP state for marking the pool UP."
                },
                "min_health_monitors_up": {
                    "type": "uint32",
                    "description": "Minimum number of health monitors in UP state to mark server UP.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "server_timeout": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Timeout for backend server connection and data reception. This setting controls two timeouts: First, the maximum time allowed to establish a TCP connection to the backend server. Second, the maximum idle time while receiving data - the timer resets each time data arrives, so the backend can take as long as needed to send the complete response as long as it doesn't stop sending data for longer than this timeout. Value of 0 (default) inherits from the Service Engine Group's upstream_read_timeout and upstream_connect_timeout properties. It applies only to L7 (HTTP) virtual services.",
                    "min": 0,
                    "max": 21600000
                },
                "conn_pool_properties": {
                    "type": "message",
                    "messageType": "ConnPoolProperties",
                    "description": "Connnection pool properties"
                },
                "delete_server_on_dns_refresh": {
                    "type": "bool",
                    "default": true,
                    "description": "Indicates whether existing IPs are disabled(false) or deleted(true) on dns hostname refreshDetail -- On a dns refresh, some IPs set on pool may no longer be returned by the resolver. These IPs are deleted from the pool when this knob is set to true. They are disabled, if the knob is set to false",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "true"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "true"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "enable_http2": {
                    "type": "bool",
                    "default": false,
                    "description": "Enable HTTP/2 for traffic from VirtualService to all backend servers in this pool.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "ignore_server_port": {
                    "type": "bool",
                    "default": false,
                    "description": "Ignore the server port in building the load balancing state.Applicable only for consistent hash load balancing algorithm or Disable Port translation (use_service_port) use cases.",
                    "immutable": true
                },
                "routing_pool": {
                    "type": "bool",
                    "default": false,
                    "description": "Enable to do routing when this pool is selected to send traffic. No servers present in routing pool."
                },
                "tier1_lr": {
                    "type": "string",
                    "description": "This tier1_lr field should be set same as VirtualService associated for NSX-T.",
                    "immutable": true
                },
                "resolve_pool_by_dns": {
                    "type": "bool",
                    "default": false,
                    "description": "This field is used as a flag to create a job for JobManager."
                },
                "append_port": {
                    "type": "enum",
                    "enumType": "AppendPortEnum",
                    "default": "NON_DEFAULT_80_443",
                    "description": "Allows the option to append port to hostname in the host header while sending a request to the server. By default, port is appended for non-default ports. This setting will apply for Pool's 'Rewrite Host Header to Server Name', 'Rewrite Host Header to SNI' features and Server's 'Rewrite Host Header' settings as well as HTTP healthmonitors attached to pools.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "NEVER",
                            "default_value": "NEVER"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "NEVER",
                            "default_value": "NEVER"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "http2_properties": {
                    "type": "message",
                    "messageType": "HTTP2PoolProperties",
                    "description": "HTTP2 pool properties.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                },
                "server_disable_type": {
                    "type": "enum",
                    "enumType": "ServerDisableType",
                    "default": "DISALLOW_NEW_CONNECTION",
                    "description": "Server graceful disable timeout behaviour."
                },
                "use_service_ssl_mode": {
                    "type": "bool",
                    "default": false,
                    "description": "This applies only when use_service_port is set to true. If enabled, SSL mode of the connection to the server is decided by the SSL mode on the Virtualservice service port, on which the request was received."
                },
                "horizon_profile": {
                    "type": "message",
                    "messageType": "HorizonProfile",
                    "description": "Horizon UAG configuration."
                },
                "pool_type": {
                    "type": "enum",
                    "enumType": "PoolType",
                    "default": "POOL_TYPE_GENERIC_APP",
                    "description": "Type or Purpose, the Pool is to be used for.",
                    "immutable": true
                },
                "lb_algo_rr_per_se": {
                    "type": "bool",
                    "default": false,
                    "description": "Do load balancing at SE level instead of the default per core load balancing."
                },
                "sp_gs_info": {
                    "type": "message",
                    "messageType": "SpGslbServiceInfo",
                    "description": "GSLB service associated with the site persistence pool.",
                    "immutable": true
                },
                "graceful_hm_down_disable_timeout": {
                    "type": "int32",
                    "default": -1,
                    "description": "Time interval for gracefully closing the connections on server, When health monitoring marks the server down.",
                    "min": 1,
                    "max": 432000,
                    "specialValues": {
                        "0": "Immediate",
                        "-1": "Infinite"
                    }
                },
                "gslb_pool_type": {
                    "type": "enum",
                    "enumType": "GslbPoolType",
                    "default": "GSLB_POOL_TYPE_GENERIC",
                    "description": "Specifies the pool type (GENERIC/PRIVATE/PUBLIC). The public IPs of the members can be specified in seperate pool of type PUBLIC.This would allow features like health monitoring to be enabled independantly for the public IPs.This is only applicable for GSLB pools."
                }
            }
        },
        "SpGslbServiceInfo": {
            "fields": {
                "gs_uuid": {
                    "type": "string",
                    "description": "GSLB service uuid associated with the site persistence pool.",
                    "maxStringLength": 49
                },
                "fqdns": {
                    "type": "string",
                    "repeated": true,
                    "description": "FQDNs associated with the GSLB service.",
                    "maxStringLength": 253
                }
            }
        },
        "HorizonProfile": {
            "fields": {
                "blast_port": {
                    "type": "uint32",
                    "default": 8443,
                    "description": "Horizon blast port of the UAG server."
                },
                "pcoip_port": {
                    "type": "uint32",
                    "default": 4172,
                    "description": "Horizon pcoip port of the UAG server."
                }
            }
        },
        "HTTP2PoolProperties": {
            "fields": {
                "max_http2_control_frames_per_connection": {
                    "type": "uint32",
                    "default": 0,
                    "description": "The max number of control frames that server can send over an HTTP/2 connection. '0' means unlimited.",
                    "min": 0,
                    "max": 10000,
                    "specialValues": {
                        "0": "Unlimited control frames on a server side HTTP/2 connection"
                    }
                },
                "max_http2_header_field_size": {
                    "type": "uint32",
                    "default": 4096,
                    "description": "The maximum size in bytes of the compressed request header field. The limit applies equally to both name and value.",
                    "min": 1,
                    "max": 8192
                }
            }
        },
        "ConnPoolProperties": {
            "fields": {
                "upstream_connpool_server_max_cache": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Maximum number of connections a server can cache",
                    "specialValues": {
                        "0": "unlimited"
                    }
                },
                "upstream_connpool_conn_max_reuse": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Maximum number of times a connection can be reused",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "0"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "0"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "specialValues": {
                        "0": "unlimited"
                    }
                },
                "upstream_connpool_conn_idle_tmo": {
                    "type": "uint32",
                    "default": 60000,
                    "description": "Connection idle timeout",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "60000"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "60000"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 0,
                    "max": 86400000,
                    "specialValues": {
                        "0": "Infinite idle time."
                    }
                },
                "upstream_connpool_conn_life_tmo": {
                    "type": "uint32",
                    "default": 600000,
                    "description": "Connection life timeout",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "600000"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "600000"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 0,
                    "max": 86400000,
                    "specialValues": {
                        "0": "Infinite life time."
                    }
                }
            }
        },
        "PoolAnalyticsPolicy": {
            "fields": {
                "metrics_realtime_update": {
                    "type": "message",
                    "messageType": "MetricsRealTimeUpdate",
                    "description": "Enable realtime metrics and its duration."
                }
            }
        },
        "MetricsRealTimeUpdate": {
            "fields": {
                "enabled": {
                    "type": "bool",
                    "default": false,
                    "required": true,
                    "description": "Enables real time metrics collection.  When deactivated, 6 hour view is the most granular the system will track."
                },
                "duration": {
                    "type": "uint32",
                    "default": 30,
                    "description": "Real time metrics collection duration in minutes. 0 for infinite.",
                    "specialValues": {
                        "0": "infinite"
                    }
                }
            }
        },
        "HTTPServerReselect": {
            "fields": {
                "enabled": {
                    "type": "bool",
                    "default": false,
                    "required": true,
                    "description": "Enable HTTP request reselect when server responds with specific response codes.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "svr_resp_code": {
                    "type": "message",
                    "messageType": "HTTPReselectRespCode",
                    "description": "Server response codes which will trigger an HTTP request retry."
                },
                "num_retries": {
                    "type": "uint32",
                    "default": 4,
                    "description": "Number of times to retry an HTTP request when server responds with configured status codes."
                },
                "retry_nonidempotent": {
                    "type": "bool",
                    "default": false,
                    "description": "Allow retry of non-idempotent HTTP requests."
                },
                "retry_timeout": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Timeout per retry attempt, for a given request. Value of 0 indicates default timeout.",
                    "min": 0,
                    "max": 3600000
                }
            }
        },
        "HTTPReselectRespCode": {
            "fields": {
                "codes": {
                    "type": "int32",
                    "repeated": true,
                    "description": "HTTP response code to be matched.",
                    "min": 400,
                    "max": 599
                },
                "ranges": {
                    "type": "message",
                    "messageType": "HTTPStatusRange",
                    "repeated": true,
                    "description": "HTTP response code ranges to match."
                },
                "resp_code_block": {
                    "type": "enum",
                    "enumType": "HttpReselectRespCodeBlock",
                    "repeated": true,
                    "description": "Block of HTTP response codes to match for server reselect."
                }
            }
        },
        "FailAction": {
            "fields": {
                "type": {
                    "type": "enum",
                    "enumType": "FailActionEnum",
                    "default": "FAIL_ACTION_CLOSE_CONN",
                    "required": true,
                    "description": "Enables a response to client when pool experiences a failure. By default TCP connection is closed.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "FAIL_ACTION_CLOSE_CONN"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "FAIL_ACTION_CLOSE_CONN,FAIL_ACTION_HTTP_REDIRECT"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "redirect": {
                    "type": "message",
                    "messageType": "FailActionHTTPRedirect",
                    "description": "URL to redirect HTTP requests to when pool experiences a failure",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "local_rsp": {
                    "type": "message",
                    "messageType": "FailActionHTTPLocalResponse",
                    "description": "Local response to HTTP requests when pool experiences a failure",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                }
            }
        },
        "FailActionHTTPLocalResponse": {
            "fields": {
                "status_code": {
                    "type": "enum",
                    "enumType": "FailHttpStatusCode",
                    "default": "FAIL_HTTP_STATUS_CODE_503"
                },
                "file": {
                    "type": "message",
                    "messageType": "HTTPLocalFile"
                }
            }
        },
        "FailActionHTTPRedirect": {
            "fields": {
                "protocol": {
                    "type": "enum",
                    "enumType": "HTTPProtocol",
                    "default": "HTTPS",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "HTTP",
                            "default_value": "HTTP"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "host": {
                    "type": "string",
                    "required": true,
                    "description": "The host to which the redirect request is sent."
                },
                "path": {
                    "type": "string",
                    "description": "Path configuration for the redirect request. If not set the path from the original request's URI is preserved in the redirect on pool failure."
                },
                "query": {
                    "type": "string",
                    "description": "Query configuration for the redirect request URI. If not set, the query from the original request's URI is preserved in the redirect on pool failure."
                },
                "status_code": {
                    "type": "enum",
                    "enumType": "HTTPRedirectStatusCode",
                    "default": "HTTP_REDIRECT_STATUS_CODE_302",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "HTTP_REDIRECT_STATUS_CODE_302"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                }
            }
        },
        "PlacementNetwork": {
            "fields": {
                "network_uuid": {
                    "type": "string",
                    "required": true
                },
                "subnet": {
                    "type": "message",
                    "messageType": "IpAddrPrefix",
                    "required": true
                }
            }
        },
        "NetworkFilter": {
            "fields": {
                "network_uuid": {
                    "type": "string",
                    "required": true
                },
                "server_filter": {
                    "type": "string"
                }
            }
        },
        "PoolGroup": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "required": true,
                    "description": "UUID of the pool group"
                },
                "name": {
                    "type": "string",
                    "required": true,
                    "description": "The name of the pool group.",
                    "maxStringLength": 280
                },
                "members": {
                    "type": "message",
                    "messageType": "PoolGroupMember",
                    "repeated": true,
                    "description": "List of pool group members object of type PoolGroupMember."
                },
                "priority_labels_uuid": {
                    "type": "string",
                    "description": "UUID of the priority labels. If not provided, pool group member priority label will be interpreted as a number with a larger number considered higher priority.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "min_servers": {
                    "type": "uint32",
                    "default": 0,
                    "description": "The minimum number of servers to distribute traffic to.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "0"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "0"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 1,
                    "max": 65535,
                    "specialValues": {
                        "0": "Disable"
                    }
                },
                "deployment_policy_uuid": {
                    "type": "string",
                    "description": "When setup autoscale manager will automatically promote new pools into production when deployment goals are met.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "fail_action": {
                    "type": "message",
                    "messageType": "FailAction",
                    "description": "Enable an action - Close Connection, HTTP Redirect, or Local HTTP Response - when a pool group failure happens. By default, a connection will be closed, in case the pool group experiences a failure.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "implicit_priority_labels": {
                    "type": "bool",
                    "default": false,
                    "description": "Whether an implicit set of priority labels is generated."
                },
                "service_metadata": {
                    "type": "string",
                    "description": "Metadata pertaining to the service provided by this PoolGroup. In Openshift/Kubernetes environments, app metadata info is stored. Any user input to this field will be overwritten by Avi Vantage."
                },
                "markers": {
                    "type": "message",
                    "messageType": "RoleFilterMatchLabel",
                    "repeated": true,
                    "description": "List of labels to be used for granular RBAC.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "created_by": {
                    "type": "string",
                    "description": "Name of the user who created the object."
                },
                "cloud_config_cksum": {
                    "type": "string",
                    "description": "Checksum of cloud configuration for PoolGroup. Internally set by cloud connector"
                },
                "description": {
                    "type": "string",
                    "description": "Description of Pool Group."
                },
                "tenant_uuid": {
                    "type": "string"
                },
                "cloud_uuid": {
                    "type": "string",
                    "default": "Default-Cloud",
                    "immutable": true
                },
                "deactivate_primary_pool_on_down": {
                    "type": "bool",
                    "default": false,
                    "description": "Deactivate primary pool for selection when down until it is activated by user via clear poolgroup command."
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                }
            }
        },
        "PoolGroupMember": {
            "fields": {
                "pool_uuid": {
                    "type": "string",
                    "required": true,
                    "description": "UUID of the pool"
                },
                "ratio": {
                    "type": "uint32",
                    "default": 1,
                    "description": "Ratio of selecting eligible pools in the pool group. ",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "1"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "1"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 1,
                    "max": 1000,
                    "specialValues": {
                        "0": "Do not select this pool for new connections"
                    }
                },
                "priority_label": {
                    "type": "string",
                    "description": "All pools with same priority are treated similarly in a pool group. The higher the number, the higher the priority.A pool with a higher priority is selected, as long as the pool is eligible or an explicit policy chooses a different pool."
                },
                "deployment_state": {
                    "type": "enum",
                    "enumType": "PoolDeploymentState",
                    "description": "Pool deployment state used with the PG deployment policy",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                }
            },
            "repeatedKey": "pool_uuid,priority_label"
        },
        "PoolGroupDeploymentPolicy": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "required": true,
                    "description": "UUID of the pool group deployment policy"
                },
                "name": {
                    "type": "string",
                    "required": true,
                    "description": "The name of the pool group deployment policy",
                    "maxStringLength": 256
                },
                "scheme": {
                    "type": "enum",
                    "enumType": "PoolGroupDeploymentScheme",
                    "default": "BLUE_GREEN",
                    "description": "deployment scheme"
                },
                "test_traffic_ratio_rampup": {
                    "type": "uint32",
                    "default": 100,
                    "description": "Ratio of the traffic that is sent to the pool under test. test ratio of 100 means blue green",
                    "min": 1,
                    "max": 100
                },
                "rules": {
                    "type": "message",
                    "messageType": "PGDeploymentRule",
                    "repeated": true,
                    "description": ""
                },
                "webhook_uuid": {
                    "type": "string",
                    "description": "Webhook configured with URL that Avi controller will pass back information about pool group, old and new pool information and current deployment rule results"
                },
                "evaluation_duration": {
                    "type": "uint32",
                    "default": 300,
                    "description": "Duration of evaluation period for automatic deployment",
                    "min": 60,
                    "max": 86400
                },
                "target_test_traffic_ratio": {
                    "type": "uint32",
                    "default": 100,
                    "description": "Target traffic ratio before pool is made production",
                    "min": 1,
                    "max": 100
                },
                "auto_disable_old_prod_pools": {
                    "type": "bool",
                    "default": true,
                    "description": "It will automatically disable old production pools once there is a new production candidate"
                },
                "markers": {
                    "type": "message",
                    "messageType": "RoleFilterMatchLabel",
                    "repeated": true,
                    "description": "List of labels to be used for granular RBAC.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "description": {
                    "type": "string"
                },
                "tenant_uuid": {
                    "type": "string"
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                }
            }
        },
        "PGDeploymentRule": {
            "fields": {
                "metric_id": {
                    "type": "string",
                    "default": "health.health_score_value"
                },
                "operator": {
                    "type": "enum",
                    "enumType": "ComparisonOperator",
                    "default": "CO_GE"
                },
                "threshold": {
                    "type": "Unknown",
                    "description": "metric threshold that is used as the pass fail. If it is not provided then it will simply compare it with current pool vs new pool"
                }
            }
        },
        "PortalFeatureOptIn": {
            "fields": {
                "enable_ip_reputation": {
                    "type": "bool",
                    "default": false,
                    "description": "Enable to receive IP reputation updates.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "enable_appsignature_sync": {
                    "type": "bool",
                    "default": false,
                    "description": "Enable to receive Application specific signature updates.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "enable_user_agent_db_sync": {
                    "type": "bool",
                    "default": false,
                    "description": "Enable to receive Bot Management updates.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "enable_pulse_waf_management": {
                    "type": "bool",
                    "default": true,
                    "description": "Enable to receive WAF CRS updates.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false",
                            "default_value": false
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false",
                            "default_value": false
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "enable_pulse_case_management": {
                    "type": "bool",
                    "default": true,
                    "description": "Enable Pulse Cloud Services Case Management.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false",
                            "default_value": false
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false",
                            "default_value": false
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "enable_pulse_inventory": {
                    "type": "bool",
                    "default": false,
                    "description": "Enable Pulse Cloud Services Inventory.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false",
                            "default_value": false
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false",
                            "default_value": false
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                }
            }
        },
        "ProtocolParser": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "description": "UUID of the protocol parser",
                    "required": true
                },
                "name": {
                    "type": "string",
                    "description": "Name of the protocol parser",
                    "maxStringLength": 256,
                    "required": true
                },
                "parser_code": {
                    "type": "string",
                    "description": "Command script provided inline.",
                    "required": true
                },
                "markers": {
                    "type": "message",
                    "messageType": "RoleFilterMatchLabel",
                    "repeated": true,
                    "description": "List of labels to be used for granular RBAC.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "description": {
                    "type": "string",
                    "description": "Description of the protocol parser"
                },
                "tenant_uuid": {
                    "type": "string",
                    "description": "Tenant UUID of the protocol parser",
                    "required": true
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                }
            }
        },
        "RateLimiterProfile": {
            "fields": {
                "client_ip_connections_rate_limit": {
                    "type": "message",
                    "messageType": "RateProfile",
                    "description": "Rate Limit all connections made from any single client IP address to the Virtual Service."
                },
                "client_ip_requests_rate_limit": {
                    "type": "message",
                    "messageType": "RateProfile",
                    "description": "Rate Limit all HTTP requests from any single client IP address to all URLs of the Virtual Service."
                },
                "uri_requests_rate_limit": {
                    "type": "message",
                    "messageType": "RateProfile",
                    "description": "Rate Limit all HTTP requests from all client IP addresses to any single URL."
                },
                "client_ip_to_uri_requests_rate_limit": {
                    "type": "message",
                    "messageType": "RateProfile",
                    "description": "Rate Limit all HTTP requests from any single client IP address to any single URL."
                },
                "client_ip_failed_requests_rate_limit": {
                    "type": "message",
                    "messageType": "RateProfile",
                    "description": "Rate Limit all requests from a client for a specified period of time once the count of failed requests from that client crosses a threshold for that period. Clients are tracked based on their IP address. Count and time period are specified through the RateProfile. Requests are deemed failed based on client or server side error status codes, consistent with how Avi Logs and Metrics subsystems mark failed requests. "
                },
                "uri_failed_requests_rate_limit": {
                    "type": "message",
                    "messageType": "RateProfile",
                    "description": "Rate Limit all requests to a URI for a specified period of time once the count of failed requests to that URI crosses a threshold for that period. Count and time period are specified through the RateProfile. Requests are deemed failed based on client or server side error status codes, consistent with how Avi Logs and Metrics subsystems mark failed requests. "
                },
                "client_ip_to_uri_failed_requests_rate_limit": {
                    "type": "message",
                    "messageType": "RateProfile",
                    "description": "Rate Limit all requests from a client to a URI for a specified period of time once the count of failed requests from that client to the URI crosses a threshold for that period. Clients are tracked based on their IP address. Count and time period are specified through the RateProfile. Requests are deemed failed based on client or server side error status codes, consistent with how Avi Logs and Metrics subsystems mark failed requests. "
                },
                "client_ip_scanners_requests_rate_limit": {
                    "type": "message",
                    "messageType": "RateProfile",
                    "description": "Automatically track clients and classify them into 3 groups - Good, Bad, Unknown. Clients are tracked based on their IP Address. Clients are added to the Good group when the Avi Scan Detection system builds history of requests from them that complete successfully. Clients are added to Unknown group when there is insufficient history about them. Requests from such clients are rate limited to the rate specified in the RateProfile. Finally, Clients with history of failed requests are added to Bad group and their requests are rate limited with stricter thresholds than the Unknown Clients group. The Avi Scan Detection system automatically tunes itself so that the Good, Bad, and Unknown client IPs group membership changes dynamically with the changes in traffic patterns through the ADC."
                },
                "uri_scanners_requests_rate_limit": {
                    "type": "message",
                    "messageType": "RateProfile",
                    "description": "Automatically track URIs and classify them into 3 groups - Good, Bad, Unknown. URIs are added to the Good group when the Avi Scan Detection system builds history of requests to URIs that complete successfully. URIs are added to Unknown group when there is insufficient history about them. Requests for such URIs are rate limited to the rate specified in the RateProfile. Finally, URIs with history of failed requests are added to Bad group and requests to them are rate limited with stricter thresholds than the Unknown URIs group. The Avi Scan Detection system automatically tunes itself so that the Good, Bad, and Unknown URIs group membership changes dynamically with the changes in traffic patterns through the ADC."
                },
                "http_header_rate_limits": {
                    "type": "message",
                    "messageType": "RateProfile",
                    "repeated": true,
                    "description": "Rate Limit all HTTP requests from all client IP addresses that contain any single HTTP header value."
                },
                "custom_requests_rate_limit": {
                    "type": "message",
                    "messageType": "RateProfile",
                    "description": "Rate Limit all HTTP requests that map to any custom string."
                }
            }
        },
        "RateLimiterProperties": {
            "fields": {
                "msf_num_stages": {
                    "type": "uint32",
                    "default": 1,
                    "description": "Number of stages in msf rate limiter.",
                    "min": 1,
                    "max": 2
                },
                "msf_stage_size": {
                    "type": "uint64",
                    "default": 16384,
                    "description": "Each stage size in msf rate limiter."
                }
            }
        },
        "RateProfile": {
            "fields": {
                "explicit_tracking": {
                    "type": "bool",
                    "default": false,
                    "description": "Explicitly tracks an attacker across rate periods",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "fine_grain": {
                    "type": "bool",
                    "default": false,
                    "description": "Enable fine granularity",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "action": {
                    "type": "message",
                    "messageType": "RateLimiterAction",
                    "description": "Action to perform upon rate limiting",
                    "required": true
                },
                "http_header": {
                    "type": "string",
                    "description": "HTTP header name.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "http_cookie": {
                    "type": "string",
                    "description": "HTTP cookie name.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "rate_limiter": {
                    "type": "message",
                    "messageType": "RateLimiter",
                    "description": "The rate limiter configuration for this rate profile."
                }
            }
        },
        "ReportProfile": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "description": "UUID Identifier for the ReportProfile object.",
                    "maxStringLength": 256,
                    "required": true
                },
                "max_concurrent_reports": {
                    "type": "uint32",
                    "default": 1,
                    "description": "Maximum number of concurrent reports allowed to be generated.",
                    "min": 1,
                    "max": 10
                },
                "collection_rules": {
                    "type": "message",
                    "messageType": "CollectionRules",
                    "description": "Collection rules for the report."
                },
                "remote_controller": {
                    "type": "message",
                    "messageType": "RemoteController",
                    "description": "Remote controller request to enable report generation for remote controller. If enabled, the report generation will be done for the remote controller."
                }
            }
        },
        "RemoteController": {
            "fields": {
                "enabled": {
                    "type": "bool",
                    "default": false,
                    "description": "Enable remote controller request."
                },
                "address": {
                    "type": "string",
                    "description": "Remote controller address.",
                    "maxStringLength": 128
                },
                "username": {
                    "type": "string",
                    "description": "Remote controller username.",
                    "maxStringLength": 128
                },
                "password": {
                    "type": "string",
                    "description": "Remote controller password.",
                    "maxStringLength": 128
                },
                "tenant": {
                    "type": "string",
                    "description": "Remote controller tenant name.",
                    "maxStringLength": 256
                }
            }
        },
        "CollectionRules": {
            "fields": {
                "timeout": {
                    "type": "uint32",
                    "default": 1800,
                    "description": "Timeout for report generation in seconds.",
                    "min": 300,
                    "max": 3600
                },
                "min_free_disk_required": {
                    "type": "float",
                    "default": 0.5,
                    "description": "Minimum free disk required for report generation in GB.",
                    "min": 0.1,
                    "max": 20
                },
                "max_concurrent_workers": {
                    "type": "uint32",
                    "default": 1,
                    "description": "Maximum number of concurrent workers used for data collection during report generation.",
                    "min": 1,
                    "max": 10
                },
                "enforced_report_period": {
                    "type": "enum",
                    "enumType": "ReportPeriod",
                    "default": "REPORT_PERIOD_LAST_7_DAYS",
                    "description": "The period for report generation."
                },
                "enforced_report_samples": {
                    "type": "uint32",
                    "default": 2000,
                    "description": "Minimum data samples required for report generation.",
                    "min": 200,
                    "max": 5000
                }
            }
        },
        "Report": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "description": "UUID Identifier for the report generation.",
                    "maxStringLength": 256
                },
                "name": {
                    "type": "string",
                    "description": "Name of the report.",
                    "maxStringLength": 256
                },
                "state": {
                    "type": "message",
                    "messageType": "ReportGenState",
                    "description": "State of the report generation."
                },
                "node": {
                    "type": "string",
                    "description": "Cluster member node on which the report is processed.",
                    "maxStringLength": 256
                },
                "filename": {
                    "type": "string",
                    "description": "Name of the report artifact on reports repository.",
                    "maxStringLength": 256
                },
                "start_time": {
                    "type": "string",
                    "description": "Start time of the report generation.",
                    "maxStringLength": 128
                },
                "end_time": {
                    "type": "string",
                    "description": "End time of the report generation.",
                    "maxStringLength": 128
                },
                "duration": {
                    "type": "uint32",
                    "description": "Time taken to complete report generation in seconds."
                },
                "pre_check": {
                    "type": "message",
                    "messageType": "ReadinessCheckObj",
                    "description": "Pre-check details for the report generation."
                },
                "tasks": {
                    "type": "message",
                    "messageType": "TaskEventMap",
                    "repeated": true,
                    "description": "List of tasks associated with the report generation."
                },
                "total_tasks": {
                    "type": "uint32",
                    "description": "Total no. of tasks."
                },
                "tasks_completed": {
                    "type": "uint32",
                    "description": "No. of tasks completed."
                },
                "progress": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Percentage of tasks completed.",
                    "min": 0,
                    "max": 100
                },
                "request": {
                    "type": "message",
                    "messageType": "ReportGenerationRequest",
                    "description": "Request for the report generation."
                },
                "tenant_uuid": {
                    "type": "string",
                    "description": "Tenant UUID of the report generation.",
                    "maxStringLength": 256
                }
            }
        },
        "ReportGenerationRequest": {
            "fields": {
                "report": {
                    "type": "string",
                    "description": "The report to be generated.",
                    "maxStringLength": 255,
                    "required": true
                },
                "name": {
                    "type": "string",
                    "description": "Custom name for the report.",
                    "maxStringLength": 255
                },
                "parameters": {
                    "type": "message",
                    "messageType": "ReportParameter",
                    "repeated": true,
                    "description": "The parameters of the report."
                },
                "duration": {
                    "type": "message",
                    "messageType": "ReportDuration",
                    "description": "The duration of the report."
                },
                "sections": {
                    "type": "message",
                    "messageType": "ReportSection",
                    "repeated": true,
                    "description": "IDs of specified sections are collected as part of the report."
                }
            }
        },
        "ReportSection": {
            "fields": {
                "id": {
                    "type": "string",
                    "description": "The id of the section.",
                    "maxStringLength": 255,
                    "required": true
                },
                "sub_sections": {
                    "type": "message",
                    "messageType": "ReportSubSection",
                    "repeated": true,
                    "description": "The sub sections of the section."
                }
            }
        },
        "ReportSubSection": {
            "fields": {
                "id": {
                    "type": "string",
                    "description": "The id of the sub section.",
                    "maxStringLength": 255,
                    "required": true
                }
            }
        },
        "ReportDuration": {
            "fields": {
                "period": {
                    "type": "enum",
                    "enumType": "ReportPeriod",
                    "description": "The period for report generation."
                },
                "start_time": {
                    "type": "message",
                    "messageType": "TimeStamp",
                    "description": "The start timestamp of the report when period is custom."
                },
                "end_time": {
                    "type": "message",
                    "messageType": "TimeStamp",
                    "description": "The end timestamp of the report when period is custom."
                }
            }
        },
        "ReportParameter": {
            "fields": {
                "name": {
                    "type": "string",
                    "description": "The name of the parameter.",
                    "maxStringLength": 255
                },
                "value": {
                    "type": "string",
                    "description": "The value of the parameter.",
                    "maxStringLength": 255
                }
            }
        },
        "TaskEventMap": {
            "fields": {
                "task_name": {
                    "type": "string",
                    "description": "Name representing the task.",
                    "maxStringLength": 512
                },
                "nodes_events": {
                    "type": "message",
                    "messageType": "TaskEvent",
                    "repeated": true,
                    "description": "List of all events node wise."
                },
                "sub_events": {
                    "type": "message",
                    "messageType": "TaskEvent",
                    "repeated": true,
                    "description": "List of all events node wise."
                }
            }
        },
        "TaskEvent": {
            "fields": {
                "ip": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "description": "Ip of the node."
                },
                "start_time": {
                    "type": "string",
                    "description": "Task start time.",
                    "maxStringLength": 512
                },
                "end_time": {
                    "type": "string",
                    "description": "Task end time.",
                    "maxStringLength": 512
                },
                "duration": {
                    "type": "uint32",
                    "description": "Time taken to complete event in seconds."
                },
                "status": {
                    "type": "enum",
                    "enumType": "Syserr",
                    "description": "Event status."
                },
                "message": {
                    "type": "string",
                    "description": "Event message if any.",
                    "maxStringLength": 512
                },
                "sub_tasks": {
                    "type": "string",
                    "repeated": true,
                    "description": "Sub tasks executed on each node.",
                    "maxStringLength": 512
                }
            }
        },
        "ReadinessCheckObj": {
            "fields": {
                "state": {
                    "type": "message",
                    "messageType": "PreCheckOpsState",
                    "description": "The readiness check operations current fsm-state."
                },
                "checks": {
                    "type": "message",
                    "messageType": "PreChecksInfo",
                    "repeated": true,
                    "description": "List of readiness checks information."
                },
                "start_time": {
                    "type": "string",
                    "description": "Start time of the readiness check operations.",
                    "maxStringLength": 128
                },
                "end_time": {
                    "type": "string",
                    "description": "End time of the readiness check operations.",
                    "maxStringLength": 128
                },
                "duration": {
                    "type": "uint32",
                    "description": "Time taken to complete readiness checks in seconds."
                },
                "total_checks": {
                    "type": "int32",
                    "description": "Total no. of checks."
                },
                "checks_completed": {
                    "type": "int32",
                    "description": "No. of checks completed."
                },
                "progress": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Checks progress which holds value between 0-100.",
                    "min": 0,
                    "max": 100
                }
            }
        },
        "PreChecksInfo": {
            "fields": {
                "check_code": {
                    "type": "enum",
                    "enumType": "Syserr",
                    "description": "Syserr status code of the must check."
                },
                "description": {
                    "type": "string",
                    "description": "Reason for must check failure.",
                    "maxStringLength": 128
                },
                "details": {
                    "type": "string",
                    "repeated": true,
                    "description": "Additional details of the must check.",
                    "maxStringLength": 128
                },
                "state": {
                    "type": "enum",
                    "enumType": "PreCheckFsmState",
                    "description": "The must check operations current fsm-state."
                },
                "start_time": {
                    "type": "string",
                    "description": "Start time of the must check.",
                    "maxStringLength": 128
                },
                "end_time": {
                    "type": "string",
                    "description": "End time of the must check.",
                    "maxStringLength": 128
                },
                "duration": {
                    "type": "uint32",
                    "description": "Duration of the must check in seconds."
                },
                "error_details": {
                    "type": "string",
                    "repeated": true,
                    "description": "Error/Failure details of the must check.",
                    "maxStringLength": 128
                }
            }
        },
        "PreCheckOpsState": {
            "fields": {
                "state": {
                    "type": "enum",
                    "enumType": "PreCheckFsmState",
                    "description": "State of the report generation pre-checks."
                },
                "reason": {
                    "type": "string",
                    "description": "Reason for the pre-check state.",
                    "maxStringLength": 1024
                },
                "last_changed_time": {
                    "type": "message",
                    "messageType": "TimeStamp",
                    "description": "The last time the state changed."
                }
            }
        },
        "ReportGenState": {
            "fields": {
                "state": {
                    "type": "enum",
                    "enumType": "ReportFsmState",
                    "description": "State of the report generation."
                },
                "reason": {
                    "type": "string",
                    "description": "Reason for the state.",
                    "maxStringLength": 1024
                },
                "last_changed_time": {
                    "type": "message",
                    "messageType": "TimeStamp",
                    "description": "The last time the state changed."
                }
            }
        },
        "Role": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "required": true
                },
                "name": {
                    "type": "string",
                    "required": true
                },
                "privileges": {
                    "type": "message",
                    "messageType": "Permission",
                    "repeated": true
                },
                "filters": {
                    "type": "message",
                    "messageType": "RoleFilter",
                    "repeated": true,
                    "description": "Filters for granular object access control based on object labels. Multiple filters are merged using the AND operator. If empty, all objects according to the privileges will be accessible to the user.",
                    "maxRepeatedLength": 4
                },
                "allow_unlabelled_access": {
                    "type": "bool",
                    "default": true,
                    "description": "Allow access to unlabelled objects."
                },
                "tenant_uuid": {
                    "type": "string",
                    "required": true
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                }
            }
        },
        "Permission": {
            "fields": {
                "type": {
                    "type": "enum",
                    "enumType": "Privilege",
                    "required": true
                },
                "resource": {
                    "type": "enum",
                    "enumType": "AviPermissionResource",
                    "required": true
                },
                "subresource": {
                    "type": "message",
                    "messageType": "SubResource",
                    "description": "Limits the scope of Write Access on the parent resource to modification of only the specified subresources"
                }
            }
        },
        "SubResource": {
            "fields": {
                "exclude_subresources": {
                    "type": "bool",
                    "default": false,
                    "description": "Allows modification of all fields except for the specified subresources."
                },
                "subresources": {
                    "type": "enum",
                    "enumType": "AviPermissionSubResource",
                    "repeated": true,
                    "description": "Subresources user can modify. Each subresource specifies and individual field. I.e. SUBRESOURCE_POOL_ENABLED allows modification of the enabled field in the Pool object.",
                    "minRepeatedLength": 1
                }
            }
        },
        "SaasLicensingInfo": {
            "fields": {
                "enable_notional_reserve": {
                    "type": "bool",
                    "default": true,
                    "description": "Enable relaxed reservation norm allowing up to 2x free units( normally constrained to free license units ) to be reserved by upcoming SE’s."
                }
            }
        },
        "Scheduler": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "required": true
                },
                "name": {
                    "type": "string",
                    "required": true,
                    "description": "Name of scheduler",
                    "maxStringLength": 256
                },
                "enabled": {
                    "type": "bool",
                    "default": true
                },
                "run_mode": {
                    "type": "enum",
                    "enumType": "SchedulerRunMode",
                    "description": "Scheduler Run Mode"
                },
                "start_date_time": {
                    "type": "string",
                    "description": "Scheduler start date and time"
                },
                "end_date_time": {
                    "type": "string",
                    "description": "Scheduler end date and time"
                },
                "frequency": {
                    "type": "uint32",
                    "description": "Frequency at which CUSTOM scheduler will run",
                    "min": 0,
                    "max": 60
                },
                "frequency_unit": {
                    "type": "enum",
                    "enumType": "SchedulerFrequencyUnit",
                    "description": "Unit at which CUSTOM scheduler will run"
                },
                "backup_config_uuid": {
                    "type": "string",
                    "description": "Backup Configuration to be executed by this scheduler"
                },
                "run_script_uuid": {
                    "type": "string",
                    "description": "Control script to be executed by this scheduler"
                },
                "scheduler_action": {
                    "type": "enum",
                    "enumType": "SchedulerAction",
                    "default": "SCHEDULER_ACTION_BACKUP",
                    "description": "Define Scheduler Action"
                },
                "tenant_uuid": {
                    "type": "string"
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                }
            }
        },
        "SecurityPolicy": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "required": true,
                    "description": "The UUID of the security policy."
                },
                "name": {
                    "type": "string",
                    "required": true,
                    "description": "The name of the security policy.",
                    "maxStringLength": 256
                },
                "oper_mode": {
                    "type": "enum",
                    "enumType": "OperationMode",
                    "default": "DETECTION",
                    "description": "Mode of dealing with the attacks - perform detection only, or detect and mitigate the attacks."
                },
                "dns_attacks": {
                    "type": "message",
                    "messageType": "DnsAttacks",
                    "description": "Attacks utilizing the DNS protocol operations."
                },
                "tcp_attacks": {
                    "type": "message",
                    "messageType": "TcpAttacks",
                    "description": "Attacks utilizing the TCP protocol operations."
                },
                "udp_attacks": {
                    "type": "message",
                    "messageType": "UdpAttacks",
                    "description": "Attacks utilizing the UDP protocol operations."
                },
                "network_security_policy_index": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Index of the network security policy to use for the mitigation rules applied to the attacks.",
                    "required": true
                },
                "dns_policy_index": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Index of the dns policy to use for the mitigation rules applied to the dns attacks.",
                    "required": true
                },
                "dns_amplification_denyports": {
                    "type": "message",
                    "messageType": "PortMatchGeneric",
                    "description": "Source ports and port ranges to deny in DNS Amplification attacks."
                },
                "markers": {
                    "type": "message",
                    "messageType": "RoleFilterMatchLabel",
                    "repeated": true,
                    "description": "List of labels to be used for granular RBAC.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "description": {
                    "type": "string",
                    "description": "Security policy is used to specify various configuration information used to perform Distributed Denial of Service (DDoS) attacks detection and mitigation."
                },
                "tenant_uuid": {
                    "type": "string",
                    "description": "Tenancy of the security policy.",
                    "required": true
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                }
            }
        },
        "SeGroupOptions": {
            "fields": {
                "action_on_error": {
                    "type": "enum",
                    "enumType": "SeGroupErrorRecovery",
                    "default": "SUSPEND_UPGRADE_OPS_ON_ERROR",
                    "description": "The error recovery action configured for a SE Group."
                },
                "disruptive": {
                    "type": "bool",
                    "default": false,
                    "description": "Disable non-disruptive mechanism."
                }
            }
        },
        "Server": {
            "fields": {
                "ip": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "required": true,
                    "description": "IP Address of the server.  Required if there is no resolvable host name."
                },
                "port": {
                    "type": "int32",
                    "description": "Optionally specify the servers port number.  This will override the pool's default server port attribute.",
                    "min": 1,
                    "max": 65535,
                    "specialValues": {
                        "0": "use backend port in pool"
                    }
                },
                "hostname": {
                    "type": "string",
                    "description": "DNS resolvable name of the server.  May be used in place of the IP address."
                },
                "enabled": {
                    "type": "bool",
                    "default": true,
                    "description": "Enable, Disable or Graceful Disable determine if new or existing connections to the server are allowed."
                },
                "ratio": {
                    "type": "int32",
                    "default": 1,
                    "description": "Ratio of selecting eligible servers in the pool",
                    "min": 1,
                    "max": 20
                },
                "vm_uuid": {
                    "type": "string",
                    "description": "(internal-use) This field is used internally by Avi, not editable by the user."
                },
                "nw_uuid": {
                    "type": "string",
                    "description": "(internal-use) This field is used internally by Avi, not editable by the user."
                },
                "external_uuid": {
                    "type": "string",
                    "description": "UUID identifying VM in OpenStack and other external compute"
                },
                "verify_network": {
                    "type": "bool",
                    "default": false,
                    "description": "Verify server belongs to a discovered network or reachable via a discovered network. Verify reachable network isn't the OpenStack management network"
                },
                "discovered_networks": {
                    "type": "message",
                    "messageType": "DiscoveredNetwork",
                    "repeated": true,
                    "description": "(internal-use) Discovered networks providing reachability for server IP. This field is used internally by Avi, not editable by the user."
                },
                "resolve_server_by_dns": {
                    "type": "bool",
                    "default": false,
                    "description": "Auto resolve server's IP using DNS name",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "prst_hdr_val": {
                    "type": "string",
                    "description": "Header value for custom header persistence. ",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "maxStringLength": 256
                },
                "mac_address": {
                    "type": "string",
                    "description": "MAC address of server."
                },
                "static": {
                    "type": "bool",
                    "default": false,
                    "description": "If statically learned."
                },
                "server_node": {
                    "type": "string",
                    "description": "Hostname of the node where the server VM or container resides"
                },
                "availability_zone": {
                    "type": "string",
                    "description": "Availability-zone of the server VM."
                },
                "rewrite_host_header": {
                    "type": "bool",
                    "default": false,
                    "description": "Rewrite incoming Host Header to server name."
                },
                "external_orchestration_id": {
                    "type": "string",
                    "description": "UID of server in external orchestration systems"
                },
                "description": {
                    "type": "string",
                    "description": "A description of the Server."
                },
                "location": {
                    "type": "message",
                    "messageType": "GeoLocation",
                    "description": "(internal-use) Geographic location of the server.Currently only for internal usage.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "immutable": true
                },
                "autoscaling_group_name": {
                    "type": "string",
                    "description": "Name of autoscaling group this server belongs to.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "preference_order": {
                    "type": "uint32",
                    "description": "Preference order of this member in the group. The DNS Service chooses the member with the lowest preference that is operationally up.",
                    "min": 1,
                    "max": 128
                },
                "health_monitor_uuids": {
                    "type": "string",
                    "repeated": true,
                    "description": "Verify server health by applying one or more health monitors.  Active monitors generate synthetic traffic from each Service Engine and mark a server up or down based on the response. ",
                    "maxRepeatedLength": 10,
                    "maxStringLength": 128
                },
                "srv_rdata": {
                    "type": "message",
                    "messageType": "GslbServiceSrvRdata",
                    "description": "SRV record parameters for GSLB Service member."
                }
            },
            "repeatedKey": "ip,port,hostname"
        },
        "DiscoveredNetwork": {
            "fields": {
                "network_uuid": {
                    "type": "string",
                    "required": true,
                    "description": "Discovered network for this IP."
                },
                "subnet": {
                    "type": "message",
                    "messageType": "IpAddrPrefix",
                    "repeated": true,
                    "description": "Discovered subnet for this IP."
                },
                "subnet6": {
                    "type": "message",
                    "messageType": "IpAddrPrefix",
                    "repeated": true,
                    "description": "Discovered IPv6 subnet for this IP."
                }
            }
        },
        "ServerAutoScalePolicy": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "required": true
                },
                "name": {
                    "type": "string",
                    "required": true,
                    "maxStringLength": 256
                },
                "intelligent_autoscale": {
                    "type": "bool",
                    "default": false,
                    "description": "Use Avi intelligent autoscale algorithm where autoscale is performed by comparing load on the pool against estimated capacity of all the servers."
                },
                "intelligent_scaleout_margin": {
                    "type": "uint32",
                    "default": 20,
                    "description": "Minimum extra capacity as percentage of load used by the intelligent scheme. Scale-out is triggered when available capacity is less than this margin.",
                    "min": 1,
                    "max": 99
                },
                "intelligent_scalein_margin": {
                    "type": "uint32",
                    "default": 40,
                    "description": "Maximum extra capacity as percentage of load used by the intelligent scheme. Scale-in is triggered when available capacity is more than this margin.",
                    "min": 1,
                    "max": 99
                },
                "min_size": {
                    "type": "uint32",
                    "description": "No scale-in happens once number of operationally up servers reach min_servers.",
                    "min": 0,
                    "max": 400
                },
                "max_size": {
                    "type": "uint32",
                    "description": "Maximum number of servers after scale-out.",
                    "min": 0,
                    "max": 400
                },
                "max_scaleout_adjustment_step": {
                    "type": "uint32",
                    "default": 1,
                    "description": "Maximum number of servers to scale-out simultaneously. The actual number of servers to scale-out is chosen such that target number of servers is always less than or equal to the max_size."
                },
                "max_scalein_adjustment_step": {
                    "type": "uint32",
                    "default": 1,
                    "description": "Maximum number of servers to scale-in simultaneously. The actual number of servers to scale-in is chosen such that target number of servers is always more than or equal to the min_size."
                },
                "scaleout_cooldown": {
                    "type": "uint32",
                    "default": 300,
                    "description": "Cooldown period during which no new scale-out is triggered to allow previous scale-out to successfully complete."
                },
                "scalein_cooldown": {
                    "type": "uint32",
                    "default": 300,
                    "description": "Cooldown period during which no new scale-in is triggered to allow previous scale-in to successfully complete."
                },
                "scaleout_alertconfig_uuids": {
                    "type": "string",
                    "repeated": true,
                    "description": "Trigger scale-out when alerts due to any of these Alert configurations are raised."
                },
                "scalein_alertconfig_uuids": {
                    "type": "string",
                    "repeated": true,
                    "description": "Trigger scale-in when alerts due to any of these Alert configurations are raised."
                },
                "use_predicted_load": {
                    "type": "bool",
                    "default": false,
                    "description": "Use predicted load rather than current load."
                },
                "delay_for_server_garbage_collection": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Delay in minutes after which a down server will be removed from Pool. Value 0 disables this functionality."
                },
                "markers": {
                    "type": "message",
                    "messageType": "RoleFilterMatchLabel",
                    "repeated": true,
                    "description": "List of labels to be used for granular RBAC.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "scheduled_scalings": {
                    "type": "message",
                    "messageType": "ScheduledScaling",
                    "repeated": true,
                    "description": "Scheduled-based scale-in/out policy. During scheduled intervals, metrics based autoscale is not enabled and number of servers will be solely derived from ScheduleScale policy.",
                    "maxRepeatedLength": 1
                },
                "description": {
                    "type": "string"
                },
                "tenant_uuid": {
                    "type": "string",
                    "required": true
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                }
            }
        },
        "ScheduledScaling": {
            "fields": {
                "enable": {
                    "type": "bool",
                    "default": true,
                    "description": "Enables the scheduled autoscale."
                },
                "desired_capacity": {
                    "type": "uint32",
                    "description": "Desired number of servers during scheduled intervals, it may cause scale-in or scale-out based on the value."
                },
                "cron_expression": {
                    "type": "string",
                    "description": "The cron expression describing desired time for the scheduled autoscale."
                },
                "start_date": {
                    "type": "string",
                    "description": "Scheduled autoscale start date in ISO8601 format, said day will be included in scheduled and have to be in future."
                },
                "end_date": {
                    "type": "string",
                    "description": "Scheduled autoscale end date in ISO8601 format, said day will be included in scheduled and have to be in future and greater than start date."
                },
                "autoscaling_duration": {
                    "type": "uint32",
                    "default": 1,
                    "description": "Scheduled autoscale duration (in hours)",
                    "min": 1,
                    "max": 24
                },
                "schedule_max_step": {
                    "type": "uint32",
                    "default": 1,
                    "description": "Maximum number of simultaneous scale-in/out servers for scheduled autoscale. If this value is 0, regular autoscale policy dictates this. "
                }
            }
        },
        "ServiceEngine": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "required": true
                },
                "name": {
                    "type": "string",
                    "default": "VM name unknown",
                    "maxStringLength": 256
                },
                "tenant_uuid": {
                    "type": "string"
                },
                "cloud_uuid": {
                    "type": "string",
                    "default": "Default-Cloud",
                    "immutable": true
                },
                "mgmt_vnic": {
                    "type": "message",
                    "messageType": "vNIC",
                    "immutable": true
                },
                "resources": {
                    "type": "message",
                    "messageType": "SeResources",
                    "immutable": true
                },
                "data_vnics": {
                    "type": "message",
                    "messageType": "vNIC",
                    "repeated": true
                },
                "controller_ip": {
                    "type": "string",
                    "immutable": true
                },
                "host_uuid": {
                    "type": "string",
                    "immutable": true
                },
                "controller_created": {
                    "type": "bool",
                    "default": false,
                    "immutable": true
                },
                "se_group_uuid": {
                    "type": "string"
                },
                "container_mode": {
                    "type": "bool",
                    "default": false,
                    "immutable": true
                },
                "flavor": {
                    "type": "string",
                    "default": "",
                    "immutable": true
                },
                "hypervisor": {
                    "type": "enum",
                    "enumType": "Hypervisor",
                    "immutable": true
                },
                "availability_zone": {
                    "type": "string",
                    "immutable": true
                },
                "enable_state": {
                    "type": "enum",
                    "enumType": "ServiceEngineEnableState",
                    "default": "SE_STATE_ENABLED",
                    "description": "inorder to disable SE set this field appropriately"
                },
                "container_type": {
                    "type": "enum",
                    "enumType": "ContainerType",
                    "default": "CONTAINER_TYPE_HOST",
                    "immutable": true
                },
                "nsxt_no_hotplug": {
                    "type": "bool",
                    "description": "If set to true, controller does not hotplugg the vNICs"
                }
            }
        },
        "vNIC": {
            "fields": {
                "if_name": {
                    "type": "string",
                    "immutable": true
                },
                "mac_address": {
                    "type": "string",
                    "required": true,
                    "immutable": true
                },
                "connected": {
                    "type": "bool",
                    "immutable": true
                },
                "is_mgmt": {
                    "type": "bool",
                    "default": false,
                    "immutable": true
                },
                "network_uuid": {
                    "type": "string",
                    "immutable": true
                },
                "network_name": {
                    "type": "string",
                    "immutable": true
                },
                "dhcp_enabled": {
                    "type": "bool",
                    "default": true
                },
                "is_avi_internal_network": {
                    "type": "bool",
                    "default": false,
                    "immutable": true
                },
                "enabled": {
                    "type": "bool",
                    "default": true
                },
                "adapter": {
                    "type": "string",
                    "immutable": true
                },
                "vlan_id": {
                    "type": "int32",
                    "default": 0,
                    "immutable": true
                },
                "pci_id": {
                    "type": "string",
                    "immutable": true
                },
                "linux_name": {
                    "type": "string",
                    "default": "",
                    "immutable": true
                },
                "port_uuid": {
                    "type": "string",
                    "immutable": true
                },
                "del_pending": {
                    "type": "bool",
                    "default": false
                },
                "mtu": {
                    "type": "int32",
                    "default": 1500,
                    "immutable": true
                },
                "vnic_networks": {
                    "type": "message",
                    "messageType": "vNICNetwork",
                    "repeated": true
                },
                "can_se_dp_takeover": {
                    "type": "bool",
                    "default": true,
                    "immutable": true
                },
                "vrf_uuid": {
                    "type": "string"
                },
                "vrf_id": {
                    "type": "uint32",
                    "default": 0,
                    "immutable": true
                },
                "vlan_interfaces": {
                    "type": "message",
                    "messageType": "VlanInterface",
                    "repeated": true
                },
                "is_portchannel": {
                    "type": "bool",
                    "default": false,
                    "immutable": true
                },
                "members": {
                    "type": "message",
                    "messageType": "MemberInterface",
                    "repeated": true,
                    "immutable": true
                },
                "is_hsm": {
                    "type": "bool",
                    "default": false,
                    "immutable": true
                },
                "is_asm": {
                    "type": "bool",
                    "default": false,
                    "immutable": true
                },
                "ip6_autocfg_enabled": {
                    "type": "bool",
                    "default": true,
                    "description": "Enable IPv6 auto configuration"
                },
                "aggregator_chgd": {
                    "type": "bool",
                    "default": false,
                    "immutable": true
                },
                "dp_deletion_done": {
                    "type": "bool",
                    "default": false,
                    "description": "The VNIC has been cleaned up in the datapath."
                },
                "delete_vnic": {
                    "type": "bool",
                    "default": false,
                    "description": "Delete this VNIC. Please confirm dp_deletion_done before removing the VNIC from the cloud."
                },
                "link_up": {
                    "type": "bool",
                    "default": true,
                    "description": "The link is operationally up."
                },
                "num_rx_descriptors": {
                    "type": "uint32",
                    "description": "User defined value for RX descriptor ring size, expressed as power of 2. Setting a value of 0 implies the default value for that environment. (Tech-Preview, vCenter only)"
                },
                "num_tx_descriptors": {
                    "type": "uint32",
                    "description": "User defined value for TX descriptor ring size, expressed as power of 2. Setting a value of 0 implies the default value for that environment. (Tech-Preview, vCenter only)"
                },
                "tepless_ip": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "description": "Tepless IP address for TEP-less VPC deployment. This IP is used as the source IP for all traffic originated by the SE in this VRF."
                }
            },
            "repeatedKey": "mac_address"
        },
        "MemberInterface": {
            "fields": {
                "if_name": {
                    "type": "string",
                    "required": true
                },
                "active": {
                    "type": "bool",
                    "default": false
                },
                "mac_address": {
                    "type": "string",
                    "immutable": true
                }
            },
            "repeatedKey": "if_name"
        },
        "VlanInterface": {
            "fields": {
                "if_name": {
                    "type": "string",
                    "required": true
                },
                "vlan_id": {
                    "type": "uint32",
                    "default": 0,
                    "description": "VLAN ID",
                    "min": 0,
                    "max": 4096
                },
                "dhcp_enabled": {
                    "type": "bool"
                },
                "vnic_networks": {
                    "type": "message",
                    "messageType": "vNICNetwork",
                    "repeated": true
                },
                "vrf_uuid": {
                    "type": "string",
                    "default": ""
                },
                "is_mgmt": {
                    "type": "bool",
                    "default": false,
                    "immutable": true
                },
                "ip6_autocfg_enabled": {
                    "type": "bool",
                    "description": "Enable IPv6 auto configuration"
                },
                "enabled": {
                    "type": "bool",
                    "default": true,
                    "description": "Enable the interface"
                }
            },
            "repeatedKey": "if_name"
        },
        "vNICNetwork": {
            "fields": {
                "ip": {
                    "type": "message",
                    "messageType": "IpAddrPrefix",
                    "required": true
                },
                "ctlr_alloc": {
                    "type": "bool",
                    "default": false
                },
                "mode": {
                    "type": "enum",
                    "enumType": "IpAddrMode",
                    "default": "DHCP",
                    "required": true
                }
            },
            "repeatedKey": "ip"
        },
        "SeResources": {
            "fields": {
                "num_vcpus": {
                    "type": "int32",
                    "required": true
                },
                "memory": {
                    "type": "int32",
                    "required": true
                },
                "disk": {
                    "type": "int32",
                    "required": true
                },
                "hyper_threading": {
                    "type": "bool"
                },
                "sockets": {
                    "type": "int32"
                },
                "cores_per_socket": {
                    "type": "int32"
                },
                "hypervisor_mode": {
                    "type": "bool",
                    "description": "Indicates that the SE is running on a Virtual Machine."
                },
                "num_datapath_processes": {
                    "type": "uint32",
                    "description": "Indicates the number of active datapath processes."
                },
                "qat_mode": {
                    "type": "enum",
                    "enumType": "ServiceEngineQATMode",
                    "default": "QAT_OFF",
                    "description": "Usage of Intel QAT for crypto offloads."
                },
                "qat_oper_mode": {
                    "type": "enum",
                    "enumType": "ServiceEngineQATOperMode",
                    "default": "QAT_OPER_MODE_UNKNOWN",
                    "description": "Usage of Intel QAT for performance mode."
                }
            }
        },
        "ServiceEngineGroup": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "required": true
                },
                "name": {
                    "type": "string",
                    "required": true,
                    "maxStringLength": 256
                },
                "description": {
                    "type": "string"
                },
                "tenant_uuid": {
                    "type": "string"
                },
                "max_vs_per_se": {
                    "type": "int32",
                    "default": 10,
                    "description": "Maximum number of Virtual Services that can be placed on a single Service Engine.",
                    "min": 1,
                    "max": 1000
                },
                "min_scaleout_per_vs": {
                    "type": "int32",
                    "default": 1,
                    "description": "Minimum number of active Service Engines for the Virtual Service.",
                    "min": 1,
                    "max": 64
                },
                "max_scaleout_per_vs": {
                    "type": "uint32",
                    "default": 4,
                    "description": "Maximum number of active Service Engines for the Virtual Service.",
                    "min": 1,
                    "max": 64
                },
                "max_se": {
                    "type": "int32",
                    "default": 10,
                    "description": "Maximum number of Services Engines in this group.",
                    "min": 0,
                    "max": 1000
                },
                "vcpus_per_se": {
                    "type": "int32",
                    "default": 1,
                    "description": "Number of vcpus for each of the Service Engine virtual machines. Changes to this setting do not affect existing SEs."
                },
                "memory_per_se": {
                    "type": "int32",
                    "default": 2048,
                    "description": "Amount of memory for each of the Service Engine virtual machines. Changes to this setting do not affect existing SEs.",
                    "min": 2048,
                    "max": 262144
                },
                "disk_per_se": {
                    "type": "int32",
                    "default": 15,
                    "description": "Amount of disk space for each of the Service Engine virtual machines."
                },
                "max_cpu_usage": {
                    "type": "int32",
                    "default": 80,
                    "description": "When CPU usage on an SE exceeds this threshold, Virtual Services hosted on this SE may be rebalanced to other SEs to reduce load. A new SE may be created as part of this process.",
                    "min": 40,
                    "max": 90
                },
                "min_cpu_usage": {
                    "type": "int32",
                    "default": 30,
                    "description": "When CPU usage on an SE falls below the minimum threshold, Virtual Services hosted on the SE may be consolidated onto other underutilized SEs. After consolidation, unused Service Engines may then be eligible for deletion. ",
                    "min": 20,
                    "max": 60
                },
                "se_deprovision_delay": {
                    "type": "int32",
                    "default": 120,
                    "description": "Duration to preserve unused Service Engine virtual machines before deleting them. If traffic to a Virtual Service were to spike up abruptly, this SE would still be available to be utilized again rather than creating a new SE. If this value is set to 0, Controller will never delete any SEs and administrator has to manually cleanup unused SEs.",
                    "min": 0,
                    "max": 525600
                },
                "auto_rebalance": {
                    "type": "bool",
                    "default": false,
                    "description": "If set, Virtual Services will be automatically migrated when load on an SE is less than minimum or more than maximum thresholds. Only Alerts are generated when the auto_rebalance is not set.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "se_name_prefix": {
                    "type": "string",
                    "default": "Avi",
                    "description": "Prefix to use for virtual machine name of Service Engines."
                },
                "vs_host_redundancy": {
                    "type": "bool",
                    "default": true,
                    "description": "Ensure primary and secondary Service Engines are deployed on different physical hosts.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "true",
                            "default_value": true
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "true",
                            "default_value": true
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "vcenter_folder": {
                    "type": "string",
                    "default": "AviSeFolder",
                    "description": "Folder to place all the Service Engine virtual machines in vCenter."
                },
                "vcenter_datastores": {
                    "type": "message",
                    "messageType": "VcenterDatastore",
                    "repeated": true
                },
                "vcenter_datastores_include": {
                    "type": "bool",
                    "default": false
                },
                "vcenter_datastore_mode": {
                    "type": "enum",
                    "enumType": "VcenterDatastoreMode",
                    "default": "VCENTER_DATASTORE_ANY"
                },
                "vcenter_clusters": {
                    "type": "message",
                    "messageType": "VcenterClusters"
                },
                "vcenter_hosts": {
                    "type": "message",
                    "messageType": "VcenterHosts"
                },
                "cpu_reserve": {
                    "type": "bool",
                    "default": false,
                    "description": "Set CPU shares for Service Engine Virtual Machines to High"
                },
                "mem_reserve": {
                    "type": "bool",
                    "default": true
                },
                "mgmt_network_uuid": {
                    "type": "string",
                    "description": "Management network to use for Avi Service Engines"
                },
                "mgmt_subnet": {
                    "type": "message",
                    "messageType": "IpAddrPrefix",
                    "description": "Management subnet to use for Avi Service Engines"
                },
                "ha_mode": {
                    "type": "enum",
                    "enumType": "HaMode",
                    "default": "HA_MODE_SHARED",
                    "description": "High Availability mode for all the Virtual Services using this Service Engine group.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "HA_MODE_LEGACY_ACTIVE_STANDBY",
                            "default_value": "HA_MODE_LEGACY_ACTIVE_STANDBY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "HA_MODE_LEGACY_ACTIVE_STANDBY",
                            "default_value": "HA_MODE_LEGACY_ACTIVE_STANDBY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "algo": {
                    "type": "enum",
                    "enumType": "PlacementAlgorithm",
                    "default": "PLACEMENT_ALGO_PACKED",
                    "description": "In compact placement, Virtual Services are placed on existing SEs until max_vs_per_se limit is reached. In distributed placement, Virtual Services are placed on new SEs until max_se limit is reached. Once this limit is reached, Virtual Services are placed on SEs with least load."
                },
                "buffer_se": {
                    "type": "int32",
                    "default": 1,
                    "description": "Excess Service Engine capacity provisioned for HA failover"
                },
                "active_standby": {
                    "type": "bool",
                    "default": false,
                    "description": "Service Engines in active/standby mode for HA failover"
                },
                "placement_mode": {
                    "type": "enum",
                    "enumType": "PlacementMode",
                    "default": "PLACEMENT_MODE_AUTO",
                    "description": "If placement mode is 'Auto', Virtual Services are automatically placed on Service Engines."
                },
                "openstack_mgmt_network_name": {
                    "type": "string",
                    "description": "Avi Management network name"
                },
                "openstack_mgmt_network_uuid": {
                    "type": "string",
                    "description": "Management network UUID"
                },
                "instance_flavor": {
                    "type": "string",
                    "description": "Instance/Flavor name for SE instance"
                },
                "hypervisor": {
                    "type": "enum",
                    "enumType": "Hypervisor",
                    "description": "Override default hypervisor",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "se_dos_profile": {
                    "type": "message",
                    "messageType": "DosThresholdProfile"
                },
                "auto_rebalance_interval": {
                    "type": "int32",
                    "default": 300,
                    "description": "Frequency of rebalance, if 'Auto rebalance' is enabled"
                },
                "aggressive_failure_detection": {
                    "type": "bool",
                    "default": false,
                    "description": "Enable aggressive failover configuration for ha.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "realtime_se_metrics": {
                    "type": "message",
                    "messageType": "MetricsRealTimeUpdate",
                    "description": "Enable or deactivate real time SE metrics"
                },
                "vs_scaleout_timeout": {
                    "type": "uint32",
                    "default": 600,
                    "description": "Time to wait for the scaled out SE to become ready before marking the scaleout done"
                },
                "vs_scalein_timeout": {
                    "type": "uint32",
                    "default": 30,
                    "description": "Time to wait for the scaled in SE to drain existing flows before marking the scalein done"
                },
                "hardwaresecuritymodulegroup_uuid": {
                    "type": "string",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "connection_memory_percentage": {
                    "type": "uint32",
                    "default": 50,
                    "description": "Percentage of memory for connection state. This will come at the expense of memory used for HTTP in-memory cache.",
                    "min": 10,
                    "max": 90
                },
                "extra_config_multiplier": {
                    "type": "Unknown",
                    "default": 0,
                    "description": "Multiplier for extra config to support large VS/Pool config."
                },
                "vs_scalein_timeout_for_upgrade": {
                    "type": "uint32",
                    "default": 30,
                    "description": "During SE upgrade, Time to wait for the scaled-in SE to drain existing flows before marking the scalein done"
                },
                "host_attribute_key": {
                    "type": "string",
                    "description": "Key of a (Key, Value) pair identifying a label for a set of Nodes usually in Container Clouds. Needs to be specified together with host_attribute_value. SEs can be configured differently including HA modes across different SE Groups. May also be used for isolation between different classes of VirtualServices. VirtualServices' SE Group may be specified via annotations/labels. A OpenShift/Kubernetes namespace maybe annotated with a matching SE Group label as openshift.io/node-selector: apptype=prod. When multiple SE Groups are used in a Cloud with host attributes specified,just a single SE Group can exist as a match-all SE Group without a host_attribute_key."
                },
                "host_attribute_value": {
                    "type": "string",
                    "description": "Value of a (Key, Value) pair identifying a label for a set of Nodes usually in Container Clouds. Needs to be specified together with host_attribute_key."
                },
                "log_disksz": {
                    "type": "uint32",
                    "default": 10000,
                    "description": "Maximum disk capacity (in MB) to be allocated to an SE. This is exclusively used for debug and log data."
                },
                "os_reserved_memory": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Amount of extra memory to be reserved for use by the Operating System on a Service Engine."
                },
                "hm_on_standby": {
                    "type": "bool",
                    "default": true,
                    "description": "Enable active health monitoring from the standby SE for all placed virtual services.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false",
                            "default_value": false
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false",
                            "default_value": false
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "per_app": {
                    "type": "bool",
                    "default": false,
                    "description": "Per-app SE mode is designed for deploying dedicated load balancers per app (VS). In this mode, each SE is limited to a max of 2 VSs. vCPUs in per-app SEs count towards licensing usage at 25% rate.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "distribute_load_active_standby": {
                    "type": "bool",
                    "default": false,
                    "description": "Use both the active and standby Service Engines for Virtual Service placement in the legacy active standby HA mode.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "auto_redistribute_active_standby_load": {
                    "type": "bool",
                    "default": false,
                    "description": "Redistribution of virtual services from the takeover SE to the replacement SE can cause momentary traffic loss. If the auto-redistribute load option is left in its default off state, any desired rebalancing requires calls to REST API.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "custom_tag": {
                    "type": "message",
                    "messageType": "CustomTag",
                    "repeated": true,
                    "description": "Custom tag will be used to create the tags for SE instance in AWS. Note this is not the same as the prefix for SE name",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "dedicated_dispatcher_core": {
                    "type": "bool",
                    "description": "Dedicate the core that handles packet receive/transmit from the network to just the dispatching function."
                },
                "cpu_socket_affinity": {
                    "type": "bool",
                    "default": false,
                    "description": "Allocate all the CPU cores for the Service Engine Virtual Machines  on the same CPU socket. Applicable only for vCenter Cloud."
                },
                "num_flow_cores_sum_changes_to_ignore": {
                    "type": "uint32",
                    "default": 8,
                    "description": "Number of changes in num flow cores sum to ignore."
                },
                "least_load_core_selection": {
                    "type": "bool",
                    "default": true,
                    "description": "Select core with least load for new flow."
                },
                "extra_shared_config_memory": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Extra config memory to support large Geo DB configuration."
                },
                "se_tunnel_mode": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Determines if Direct Secondary Return (DSR) from secondary SE is active or not: 0: Automatically determine based on hypervisor type. 1: Enable tunnel mode - DSR is unconditionally disabled. 2: Disable tunnel mode - DSR is unconditionally enabled. Tunnel mode can be enabled or disabled at run-time.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "0"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "0"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 0,
                    "max": 2
                },
                "openstack_availability_zones": {
                    "type": "string",
                    "repeated": true,
                    "maxRepeatedLength": 5
                },
                "service_ip_subnets": {
                    "type": "message",
                    "messageType": "IpAddrPrefix",
                    "repeated": true,
                    "description": "Subnets assigned to the SE group. Required for VS group placement.",
                    "maxRepeatedLength": 128,
                    "minRepeatedLength": 0
                },
                "se_vs_hb_max_vs_in_pkt": {
                    "type": "uint32",
                    "default": 256,
                    "description": "Maximum number of virtualservices for which heartbeat messages are aggregated in one packet.",
                    "min": 1,
                    "max": 1024
                },
                "se_vs_hb_max_pkts_in_batch": {
                    "type": "uint32",
                    "default": 64,
                    "description": "Maximum number of aggregated vs heartbeat packets to send in a batch.",
                    "min": 1,
                    "max": 256
                },
                "auto_rebalance_criteria": {
                    "type": "enum",
                    "enumType": "AutoRebalanceCriterion",
                    "repeated": true,
                    "description": "Set of criteria for SE Auto Rebalance."
                },
                "cloud_uuid": {
                    "type": "string",
                    "default": "Default-Cloud",
                    "immutable": true
                },
                "iptables": {
                    "type": "message",
                    "messageType": "IptableRuleSet",
                    "repeated": true,
                    "description": "Iptable Rules",
                    "maxRepeatedLength": 128,
                    "minRepeatedLength": 0
                },
                "se_thread_multiplier": {
                    "type": "uint32",
                    "default": 1,
                    "description": "Multiplier for SE threads based on vCPU.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "1"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "1"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 1,
                    "max": 10
                },
                "async_ssl": {
                    "type": "bool",
                    "default": false,
                    "description": "SSL handshakes will be handled by dedicated SSL Threads.Requires SE Reboot.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "async_ssl_threads": {
                    "type": "uint32",
                    "default": 1,
                    "description": "Number of Async SSL threads per se_dp.Requires SE Reboot.",
                    "min": 1,
                    "max": 16
                },
                "se_udp_encap_ipc": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Determines if SE-SE IPC messages are encapsulated in a UDP header: 0: Automatically determine based on hypervisor type. 1: Use UDP encap unconditionally.Requires SE Reboot.",
                    "min": 0,
                    "max": 1
                },
                "se_tunnel_udp_port": {
                    "type": "uint32",
                    "default": 1550,
                    "description": "UDP Port for tunneled packets from secondary to primary SE in Docker bridge mode.Requires SE Reboot."
                },
                "custom_securitygroups_mgmt": {
                    "type": "string",
                    "repeated": true,
                    "description": "Custom Security Groups to be associated with management vNic for SE instances in OpenStack and AWS Clouds."
                },
                "custom_securitygroups_data": {
                    "type": "string",
                    "repeated": true,
                    "description": "Custom Security Groups to be associated with data vNics for SE instances in OpenStack and AWS Clouds."
                },
                "archive_shm_limit": {
                    "type": "uint32",
                    "default": 8,
                    "description": "Amount of SE memory in GB until which shared memory is collected in core archive."
                },
                "significant_log_throttle": {
                    "type": "uint32",
                    "default": 100,
                    "description": "This setting limits the number of significant logs generated per second per core on this SE. Default is 100 logs per second. Set it to zero (0) to deactivate throttling."
                },
                "udf_log_throttle": {
                    "type": "uint32",
                    "default": 100,
                    "description": "This setting limits the number of UDF logs generated per second per core on this SE. UDF logs are generated due to the configured client log filters or the rules with logging enabled. Default is 100 logs per second. Set it to zero (0) to deactivate throttling."
                },
                "non_significant_log_throttle": {
                    "type": "uint32",
                    "default": 100,
                    "description": "This setting limits the number of non-significant logs generated per second per core on this SE. Default is 100 logs per second. Set it to zero (0) to deactivate throttling."
                },
                "ingress_access_mgmt": {
                    "type": "enum",
                    "enumType": "SecurityGroupIngressAccess",
                    "default": "SG_INGRESS_ACCESS_ALL",
                    "description": "Program SE security group ingress rules to allow SSH/ICMP management access from remote CIDR type."
                },
                "ingress_access_data": {
                    "type": "enum",
                    "enumType": "SecurityGroupIngressAccess",
                    "default": "SG_INGRESS_ACCESS_ALL",
                    "description": "Program SE security group ingress rules to allow VIP data access from remote CIDR type."
                },
                "se_sb_dedicated_core": {
                    "type": "bool",
                    "default": false,
                    "description": "Sideband traffic will be handled by a dedicated core.Requires SE Reboot."
                },
                "se_probe_port": {
                    "type": "uint32",
                    "default": 7,
                    "description": "TCP port on SE where echo service will be run"
                },
                "se_sb_threads": {
                    "type": "uint32",
                    "default": 1,
                    "description": "Number of Sideband threads per SE.Requires SE Reboot.",
                    "min": 1,
                    "max": 128
                },
                "ignore_rtt_threshold": {
                    "type": "uint32",
                    "default": 5000,
                    "description": "Ignore RTT samples if it is above threshold"
                },
                "waf_mempool": {
                    "type": "bool",
                    "default": true,
                    "description": "Enable memory pool for WAF.Requires SE Reboot."
                },
                "waf_mempool_size": {
                    "type": "uint32",
                    "default": 64,
                    "description": "Memory pool size used for WAF.Requires SE Reboot."
                },
                "se_bandwidth_type": {
                    "type": "enum",
                    "enumType": "SEBandwidthType",
                    "description": "Select the SE bandwidth for the bandwidth license.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "SE_BANDWIDTH_UNLIMITED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "SE_BANDWIDTH_UNLIMITED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "license_type": {
                    "type": "enum",
                    "enumType": "LicenseType",
                    "description": "If no license type is specified then default license enforcement for the cloud type is chosen."
                },
                "license_tier": {
                    "type": "enum",
                    "enumType": "LicenseTierType",
                    "description": "Specifies the license tier which would be used. This field by default inherits the value from cloud."
                },
                "allow_burst": {
                    "type": "bool",
                    "description": "Allow SEs to be created using burst license"
                },
                "auto_rebalance_capacity_per_se": {
                    "type": "uint64",
                    "repeated": true,
                    "description": "Capacities of SE for auto rebalance for each criteria."
                },
                "host_gateway_monitor": {
                    "type": "bool",
                    "default": false,
                    "description": "Enable the host gateway monitor when service engine is deployed as docker container. Disabled by default."
                },
                "vss_placement": {
                    "type": "message",
                    "messageType": "VssPlacement",
                    "description": "Parameters to place Virtual Services on only a subset of the cores of an SE."
                },
                "flow_table_new_syn_max_entries": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Maximum number of flow table entries that have not completed TCP three-way handshake yet"
                },
                "disable_csum_offloads": {
                    "type": "bool",
                    "default": false,
                    "description": "Stop using TCP/UDP and IP checksum offload features of NICs"
                },
                "disable_gro": {
                    "type": "bool",
                    "description": "Disable Generic Receive Offload (GRO) in DPDK poll-mode driver packet receive path.  GRO can be enabled on NICs that do not support LRO (Large Receive Offload) or do not gain performance boost from LRO. GRO is on by default on NICs in a system with 8 vCPUs or higher."
                },
                "disable_tso": {
                    "type": "bool",
                    "default": false,
                    "description": "Disable TCP Segmentation Offload (TSO) in DPDK poll-mode driver packet transmit path. TSO is on by default on NICs that support it."
                },
                "enable_hsm_priming": {
                    "type": "bool",
                    "default": false,
                    "description": "(This is a beta feature). Enable HSM key priming. If enabled, key handles on the hsm will be synced to SE before processing client connections."
                },
                "service_ip6_subnets": {
                    "type": "message",
                    "messageType": "IpAddrPrefix",
                    "repeated": true,
                    "description": "IPv6 Subnets assigned to the SE group. Required for VS group placement.",
                    "maxRepeatedLength": 128,
                    "minRepeatedLength": 0
                },
                "se_tracert_port_range": {
                    "type": "message",
                    "messageType": "PortRange",
                    "description": "Traceroute port range"
                },
                "distribute_queues": {
                    "type": "bool",
                    "default": false,
                    "description": "Distributes queue ownership among cores so multiple cores handle dispatcher duties. Requires SE Reboot. Deprecated from 18.2.8, instead use max_queues_per_vnic.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "vss_placement_enabled": {
                    "type": "bool",
                    "default": false,
                    "description": "If set, Virtual Services will be placed on only a subset of the cores of an SE."
                },
                "enable_multi_lb": {
                    "type": "bool",
                    "default": false,
                    "description": "Applicable only for Azure cloud with Basic SKU LB. If set, additional Azure LBs will be automatically created if resources in existing LB are exhausted."
                },
                "n_log_streaming_threads": {
                    "type": "uint32",
                    "default": 1,
                    "description": "Number of threads to use for log streaming.",
                    "min": 1,
                    "max": 100
                },
                "free_list_size": {
                    "type": "uint32",
                    "default": 1024,
                    "description": "Number of entries in the free list"
                },
                "max_rules_per_lb": {
                    "type": "uint32",
                    "default": 150,
                    "description": "Applicable to Azure platform only. Maximum number of rules per Azure LB. "
                },
                "max_public_ips_per_lb": {
                    "type": "uint32",
                    "default": 30,
                    "description": "Applicable to Azure platform only. Maximum number of public IPs per Azure LB. "
                },
                "self_se_election": {
                    "type": "bool",
                    "default": false,
                    "description": "Enable SEs to elect a primary amongst themselves in the absence of a connectivity to controller.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "vip_asg": {
                    "type": "message",
                    "messageType": "VipAutoscaleGroup",
                    "description": "When vip_asg is set, Vip configuration will be managed by Avi.User will be able to configure vip_asg or Vips individually at the time of create."
                },
                "minimum_connection_memory": {
                    "type": "uint32",
                    "default": 20,
                    "description": "Indicates the percent of memory reserved for connections.",
                    "min": 0,
                    "max": 100
                },
                "shm_minimum_config_memory": {
                    "type": "uint32",
                    "default": 4,
                    "description": "Minimum required shared memory to apply any configuration.",
                    "min": 0,
                    "max": 100
                },
                "heap_minimum_config_memory": {
                    "type": "uint32",
                    "default": 8,
                    "description": "Minimum required heap memory to apply any configuration.",
                    "min": 0,
                    "max": 100
                },
                "disable_se_memory_check": {
                    "type": "bool",
                    "default": false,
                    "description": "If set, disable the config memory check done in service engine."
                },
                "memory_for_config_update": {
                    "type": "uint32",
                    "default": 15,
                    "description": "Indicates the percent of memory reserved for config updates.",
                    "min": 0,
                    "max": 100
                },
                "num_dispatcher_cores": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Number of dispatcher cores (0,1,2,4,8 or 16). If set to 0, then number of dispatcher cores is deduced automatically.Requires SE Reboot.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "0"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "0"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "ssl_preprocess_sni_hostname": {
                    "type": "bool",
                    "default": true,
                    "description": "(Beta) Preprocess SSL Client Hello for SNI hostname extension.If set to True, this will apply SNI child's SSL protocol(s), if they are different from SNI Parent's allowed SSL protocol(s)."
                },
                "se_dpdk_pmd": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Determines if DPDK pool mode driver should be used or not : 0: Automatically determine based on hypervisor/NIC type 1: Unconditionally use DPDK poll mode driver 2: Don't use DPDK poll mode driver.Requires SE Reboot.",
                    "min": 0,
                    "max": 2
                },
                "se_use_dpdk": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Determines if DPDK library should be used or not : 0: Automatically determine based on hypervisor type 1: Use DPDK if PCAP is not enabled 2: Don't use DPDK.",
                    "min": 0,
                    "max": 2
                },
                "min_se": {
                    "type": "int32",
                    "default": 1,
                    "description": "Minimum number of Services Engines in this group (relevant for SE AutoRebalance only).",
                    "min": 0,
                    "max": 1000
                },
                "se_pcap_reinit_frequency": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Frequency in seconds at which periodically a PCAP reinit check is triggered. May be used in conjunction with the configuration pcap_reinit_threshold. (Valid range : 15 mins - 12 hours, 0 - disables).",
                    "min": 900,
                    "max": 43200,
                    "specialValues": {
                        "0": "disable"
                    }
                },
                "se_pcap_reinit_threshold": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Threshold for input packet receive errors in PCAP mode exceeding which a PCAP reinit is triggered. If not set, an unconditional reinit is performed. This value is checked every pcap_reinit_frequency interval."
                },
                "ephemeral_portrange_start": {
                    "type": "uint32",
                    "description": "Start local ephemeral port number for outbound connections"
                },
                "ephemeral_portrange_end": {
                    "type": "uint32",
                    "description": "End local ephemeral port number for outbound connections"
                },
                "disable_avi_securitygroups": {
                    "type": "bool",
                    "default": false,
                    "description": "By default, Avi creates and manages security groups along with custom sg provided by user. Set this to True to disallow Avi to create and manage new security groups. Avi will only make use of custom security groups provided by user. This option is supported for AWS and OpenStack cloud types."
                },
                "se_flow_probe_retries": {
                    "type": "uint32",
                    "default": 2,
                    "description": "Flow probe retry count if no replies are received.Requires SE Reboot.",
                    "min": 0,
                    "max": 5
                },
                "vs_switchover_timeout": {
                    "type": "uint32",
                    "default": 300,
                    "description": "During SE upgrade in a legacy active/standby segroup, Time to wait for the new primary SE to accept flows before marking the switchover done."
                },
                "config_debugs_on_all_cores": {
                    "type": "bool",
                    "default": false,
                    "description": "Enable config debugs on all cores of SE."
                },
                "accelerated_networking": {
                    "type": "bool",
                    "description": "Enable accelerated networking option for Azure SE. Accelerated networking enables single root I/O virtualization (SR-IOV) to a SE VM. This improves networking performance."
                },
                "vs_se_scaleout_ready_timeout": {
                    "type": "uint32",
                    "default": 60,
                    "description": "Timeout in seconds for Service Engine to sendScaleout Ready notification of a Virtual Service.",
                    "min": 0,
                    "max": 90
                },
                "vs_se_scaleout_additional_wait_time": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Wait time for sending scaleout ready notification after Virtual Service is marked UP. In certain deployments, there may be an additional delay to accept traffic. For example, for BGP, some time is needed for route advertisement.",
                    "min": 0,
                    "max": 300
                },
                "se_dp_hm_drops": {
                    "type": "int32",
                    "default": 0,
                    "description": "Internal only. Used to simulate SE - SE HB failure."
                },
                "disable_flow_probes": {
                    "type": "bool",
                    "default": false,
                    "description": "Disable Flow Probes for Scaled out VS'es."
                },
                "dp_aggressive_hb_frequency": {
                    "type": "uint32",
                    "default": 100,
                    "description": "Frequency of SE - SE HB messages when aggressive failure mode detection is enabled."
                },
                "dp_aggressive_hb_timeout_count": {
                    "type": "uint32",
                    "default": 10,
                    "description": "Consecutive HB failures after which failure is reported to controller,when aggressive failure mode detection is enabled."
                },
                "bgp_state_update_interval": {
                    "type": "uint32",
                    "default": 60,
                    "description": "BGP peer state update interval.",
                    "min": 5,
                    "max": 100
                },
                "max_memory_per_mempool": {
                    "type": "uint32",
                    "default": 64,
                    "description": "Max bytes that can be allocated in a single mempool."
                },
                "app_cache_percent": {
                    "type": "uint32",
                    "default": 10,
                    "description": "A percent value of total SE memory reserved for applicationcaching. This is an SE bootup property and requires SE restart.Requires SE Reboot.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "0",
                            "default_value": 0
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "0",
                            "default_value": 0
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 0,
                    "max": 100,
                    "specialValues": {
                        "0": "disable"
                    }
                },
                "use_standard_alb": {
                    "type": "bool",
                    "default": true,
                    "description": "Use Standard SKU Azure Load Balancer. By default cloud level flag is set. If not set, it inherits/uses the use_standard_alb flag from the cloud."
                },
                "app_learning_memory_percent": {
                    "type": "uint32",
                    "default": 0,
                    "description": "A percent value of total SE memory reserved for Application learning. This is an SE bootup property and requires SE restart.",
                    "min": 0,
                    "max": 10
                },
                "datascript_timeout": {
                    "type": "uint64",
                    "default": 1000000,
                    "description": "Number of instructions before datascript times out.",
                    "min": 0,
                    "max": 100000000
                },
                "data_network_id": {
                    "type": "string",
                    "description": "Subnet used to spin up the data nic for Service Engines, used only for Azure cloud. Overrides the cloud level setting for Service Engine subnet."
                },
                "se_pcap_lookahead": {
                    "type": "bool",
                    "default": false,
                    "description": "Enables lookahead mode of packet receive in PCAP mode. Introduced to overcome an issue with hv_netvsc driver. Lookahead mode attempts to ensure that application and kernel's view of the receive rings are consistent."
                },
                "enable_gratarp_permanent": {
                    "type": "bool",
                    "default": false,
                    "description": "Enable GratArp for VIP_IP."
                },
                "gratarp_permanent_periodicity": {
                    "type": "uint32",
                    "default": 10,
                    "description": "GratArp periodicity for VIP-IP.",
                    "min": 5,
                    "max": 30
                },
                "reboot_on_panic": {
                    "type": "bool",
                    "default": true,
                    "description": "Reboot the VM or host on kernel panic."
                },
                "se_flow_probe_retry_timer": {
                    "type": "uint32",
                    "default": 40,
                    "description": "Timeout in milliseconds for flow probe retries.Requires SE Reboot.",
                    "min": 20,
                    "max": 50
                },
                "se_lro": {
                    "type": "bool",
                    "description": "Enable or disable Large Receive Optimization for vnics.Supported on VMXnet3.Requires SE Reboot."
                },
                "se_tx_batch_size": {
                    "type": "uint32",
                    "default": 64,
                    "description": "Number of packets to batch for transmit to the nic. Requires SE Reboot."
                },
                "se_pcap_pkt_sz": {
                    "type": "uint32",
                    "default": 69632,
                    "description": "Max size of each packet in the pcap interface. Requires SE Reboot."
                },
                "se_pcap_pkt_count": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Max number of packets the pcap interface can hold and if the value is 0 the optimum value will be chosen. The optimum value will be chosen based on SE-memory, Cloud Type and Number of Interfaces.Requires SE Reboot."
                },
                "distribute_vnics": {
                    "type": "bool",
                    "default": false,
                    "description": "Distributes vnic ownership among cores so multiple cores handle dispatcher duties.Requires SE Reboot.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "se_dp_vnic_queue_stall_event_sleep": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Time (in seconds) service engine waits for after generating a Vnic transmit queue stall event before resetting theNIC."
                },
                "se_dp_vnic_queue_stall_timeout": {
                    "type": "uint32",
                    "default": 10000,
                    "description": "Time (in milliseconds) to wait for network/NIC recovery on detecting a transmit queue stall after which service engine resets the NIC"
                },
                "se_dp_vnic_queue_stall_threshold": {
                    "type": "uint32",
                    "default": 2000,
                    "description": "Number of consecutive transmit failures to look for before generating a Vnic transmit queue stall event."
                },
                "se_dp_vnic_restart_on_queue_stall_count": {
                    "type": "uint32",
                    "default": 3,
                    "description": "Number of consecutive transmit queue stall events in se_dp_vnic_stall_se_restart_window to look for before restarting SE"
                },
                "se_dp_vnic_stall_se_restart_window": {
                    "type": "uint32",
                    "default": 3600,
                    "description": "Window of time (in seconds) during which se_dp_vnic_restart_on_queue_stall_count number of consecutive stalls results in a SE restart"
                },
                "enable_pcap_tx_ring": {
                    "type": "bool",
                    "description": "Enable TX ring support in pcap mode of operation. TSO feature is not supported with TX Ring enabled. Deprecated from 18.2.8, instead use pcap_tx_mode. Requires SE Reboot."
                },
                "se_pcap_qdisc_bypass": {
                    "type": "bool",
                    "default": true,
                    "description": "Bypass the kernel's traffic control layer, to deliver packets directly to the driver. Enabling this feature results in egress packets not being captured in host tcpdump. Note : brief packet reordering or loss may occur upon toggle."
                },
                "se_rum_sampling_nav_percent": {
                    "type": "uint32",
                    "default": 1,
                    "description": "Percentage of navigation timing data from the end user client, used for sampling to get client insights"
                },
                "se_rum_sampling_res_percent": {
                    "type": "uint32",
                    "default": 100,
                    "description": "Percentage of resource timing data from the end user client used for sampling to get client insight"
                },
                "se_rum_sampling_nav_interval": {
                    "type": "uint32",
                    "default": 1,
                    "description": "Minimum time to wait on server between taking sampleswhen sampling the navigation timing data from the end user client."
                },
                "se_rum_sampling_res_interval": {
                    "type": "uint32",
                    "default": 2,
                    "description": "Minimum time to wait on server between taking sampleswhen sampling the resource timing data from the end user client."
                },
                "se_kni_burst_factor": {
                    "type": "uint32",
                    "default": 0,
                    "description": "This knob controls the resource availability and burst size used between SE datapath and KNI. This helps in minimising packet drops when there is higher KNI traffic (non-VIP traffic from and to Linux). The factor takes the following values:     0-default.     1-doubles the burst size and KNI resources.     2-quadruples the burst size and KNI resources.    3-Increases the burst size and KNI resources by a factor of eight.",
                    "min": 0,
                    "max": 3
                },
                "max_queues_per_vnic": {
                    "type": "uint32",
                    "default": 1,
                    "description": "Maximum number of queues per vnic Setting to '0' utilises all queues that are distributed across dispatcher cores.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "1"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "1"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "se_rl_prop": {
                    "type": "message",
                    "messageType": "RateLimiterProperties",
                    "description": "Rate limiter properties."
                },
                "app_cache_threshold": {
                    "type": "uint32",
                    "default": 5,
                    "description": "The max memory that can be allocated for the app cache. This value will act as an upper bound on the cache size specified in app_cache_percent.",
                    "specialValues": {
                        "0": "disable"
                    }
                },
                "max_concurrent_external_hm": {
                    "type": "uint32",
                    "description": "Maximum number of external health monitors that can run concurrently in a service engine. This helps control the CPU and memory use by external health monitors.",
                    "specialValues": {
                        "0": "Value will be internally calculated based on cpu and memory"
                    }
                },
                "se_mtu": {
                    "type": "uint32",
                    "description": "MTU for the VNICs of SEs in the SE group.",
                    "min": 512,
                    "max": 9000
                },
                "core_shm_app_learning": {
                    "type": "bool",
                    "default": false,
                    "description": "Include shared memory for app learning in core file.Requires SE Reboot."
                },
                "core_shm_app_cache": {
                    "type": "bool",
                    "default": false,
                    "description": "Include shared memory for app cache in core file.Requires SE Reboot."
                },
                "pcap_tx_mode": {
                    "type": "enum",
                    "enumType": "PcapTxMode",
                    "default": "PCAP_TX_AUTO",
                    "description": "Determines the PCAP transmit mode of operation. Requires SE Reboot."
                },
                "se_dp_max_hb_version": {
                    "type": "uint32",
                    "default": 3,
                    "description": "The highest supported SE-SE Heartbeat protocol version. This version is reported by Secondary SE to Primary SE in Heartbeat response messages.",
                    "min": 1,
                    "max": 3
                },
                "max_num_se_dps": {
                    "type": "uint32",
                    "description": "Configures the maximum number of se_dp processes that handles traffic. If not configured, defaults to the number of CPUs on the SE. If decreased, it will only take effect after SE reboot.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "0"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "0"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 1,
                    "max": 128
                },
                "resync_time_interval": {
                    "type": "uint32",
                    "default": 65536,
                    "description": "Time interval to re-sync SE's time with wall clock time.",
                    "min": 8,
                    "max": 600000
                },
                "use_hyperthreaded_cores": {
                    "type": "bool",
                    "default": true,
                    "description": "Enables the use of hyper-threaded cores on SE. Requires SE Reboot."
                },
                "se_hyperthreaded_mode": {
                    "type": "enum",
                    "enumType": "SeCpuHtMode",
                    "default": "SE_CPU_HT_AUTO",
                    "description": "Controls the distribution of SE data path processes on CPUs which support hyper-threading. Requires hyper-threading to be enabled at host level. Requires SE Reboot. For more details please refer to SE placement KB."
                },
                "compress_ip_rules_for_each_ns_subnet": {
                    "type": "bool",
                    "default": true,
                    "description": "Compress IP rules into a single subnet based IP rule for each north-south IPAM subnet configured in PCAP mode in OpenShift/Kubernetes node."
                },
                "availability_zone_uuids": {
                    "type": "string",
                    "repeated": true,
                    "description": "Availability zones for Virtual Service High Availability"
                },
                "vcenters": {
                    "type": "message",
                    "messageType": "PlacementScopeConfig",
                    "repeated": true,
                    "description": "VCenter information for scoping at Host/Cluster level."
                },
                "se_vnic_tx_sw_queue_size": {
                    "type": "uint32",
                    "default": 256,
                    "description": "Configure the size of software transmit spillover queue when enabled. Requires SE Reboot.",
                    "min": 128,
                    "max": 2048
                },
                "se_vnic_tx_sw_queue_flush_frequency": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Configure the frequency in milliseconds of software transmit spillover queue flush when enabled. This is necessary to flush any packets in the spillover queue in the absence of a packet transmit in the normal course of operation.",
                    "min": 50,
                    "max": 500,
                    "specialValues": {
                        "0": "disable"
                    }
                },
                "transient_shared_memory_max": {
                    "type": "uint32",
                    "default": 30,
                    "description": "The threshold for the transient shared config memory in the SE.",
                    "min": 0,
                    "max": 100
                },
                "instance_flavor_info": {
                    "type": "message",
                    "messageType": "CloudFlavor",
                    "description": "Additional information associated with instance_flavor"
                },
                "labels": {
                    "type": "message",
                    "messageType": "KeyValue",
                    "repeated": true,
                    "description": "Labels associated with this SE group.",
                    "maxRepeatedLength": 1
                },
                "log_malloc_failure": {
                    "type": "bool",
                    "default": true,
                    "description": "SE will log memory allocation related failure to the se_trace file, wherever available",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "true"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "true"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "se_delayed_flow_delete": {
                    "type": "bool",
                    "default": true,
                    "description": "Delay the cleanup of flowtable entry. To be used under surveillance of Avi Support.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "true"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "true"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "se_txq_threshold": {
                    "type": "uint32",
                    "default": 2048,
                    "description": "Once the TX queue of the dispatcher reaches this threshold, hardware queues are not polled for further packets. To be used under surveillance of Avi Support.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "2048"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "2048"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ],
                    "min": 512,
                    "max": 32768
                },
                "se_mp_ring_retry_count": {
                    "type": "uint32",
                    "default": 500,
                    "description": "The retry count for the multi-producer enqueue before yielding the CPU. To be used under surveillance of Avi Support.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "500"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "500"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "se_group_analytics_policy": {
                    "type": "message",
                    "messageType": "SeGroupAnalyticsPolicy",
                    "description": "Analytics Policy for ServiceEngineGroup."
                },
                "dp_hb_frequency": {
                    "type": "uint32",
                    "default": 100,
                    "description": "Frequency of SE - SE HB messages when aggressive failure mode detection is not enabled."
                },
                "dp_hb_timeout_count": {
                    "type": "uint32",
                    "default": 10,
                    "description": "Consecutive HB failures after which failure is reported to controller, when aggressive failure mode detection is not enabled."
                },
                "pcap_tx_ring_rd_balancing_factor": {
                    "type": "uint32",
                    "default": 10,
                    "description": "In PCAP mode, reserve a configured portion of TX ring resources for itself and the remaining portion for the RX ring to achieve better balance in terms of queue depth. Requires SE Reboot.",
                    "min": 10,
                    "max": 100
                },
                "gcp_config": {
                    "type": "message",
                    "messageType": "GCPSeGroupConfig",
                    "description": "Google Cloud Platform, Service Engine Group Configuration."
                },
                "se_ip_encap_ipc": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Determines if SE-SE IPC messages are encapsulated in an IP header :     0      : Automatically determine based on hypervisor type    1      : Use IP encap unconditionally    ~[0,1] : Don't use IP encapRequires SE Reboot."
                },
                "se_l3_encap_ipc": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Determines if SE-SE IPC messages use SE interface IP instead of VIP  :     0      : Automatically determine based on hypervisor type    1      : Use SE interface IP unconditionally    ~[0,1] : Don't use SE interface IPRequires SE Reboot."
                },
                "netlink_poller_threads": {
                    "type": "uint32",
                    "default": 2,
                    "description": "Number of threads to poll for netlink messages excluding the thread for default namespace. Requires SE Reboot.",
                    "min": 1,
                    "max": 32
                },
                "netlink_sock_buf_size": {
                    "type": "uint32",
                    "default": 4,
                    "description": "Socket buffer size for the netlink sockets. Requires SE Reboot.",
                    "min": 1,
                    "max": 128
                },
                "handle_per_pkt_attack": {
                    "type": "bool",
                    "default": true,
                    "description": "Configuration to handle per packet attack handling.For example, DNS Reflection Attack is a type of attack where a response packet is sent to the DNS VS.This configuration tells if such packets should be dropped without further processing."
                },
                "per_vs_admission_control": {
                    "type": "bool",
                    "default": false,
                    "description": "Enable/Disable per VS level admission control.Enabling this feature will cause the connection and packet throttling on a particular VS that has high packet buffer consumption."
                },
                "objsync_port": {
                    "type": "uint32",
                    "default": 4001,
                    "description": "TCP port on SE management interface for InterSE Object Distribution. Supported only for externally managed security groups. Not supported on full access deployments. Requires SE reboot.",
                    "min": 1024,
                    "max": 65535
                },
                "objsync_config": {
                    "type": "message",
                    "messageType": "ObjSyncConfig",
                    "description": "Configuration knobs for InterSE Object Distribution."
                },
                "dp_aggressive_deq_interval_msec": {
                    "type": "uint32",
                    "default": 1,
                    "description": "Dequeue interval for receive queue from se_dp in aggressive mode.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ],
                    "min": 1,
                    "max": 1000
                },
                "dp_aggressive_enq_interval_msec": {
                    "type": "uint32",
                    "default": 1,
                    "description": "Enqueue interval for request queue to se_dp in aggressive mode.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ],
                    "min": 1,
                    "max": 1000
                },
                "ns_helper_deq_interval_msec": {
                    "type": "uint32",
                    "default": 20,
                    "description": "Dequeue interval for receive queue from NS HELPER.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ],
                    "min": 1,
                    "max": 1000
                },
                "dp_deq_interval_msec": {
                    "type": "uint32",
                    "default": 20,
                    "description": "Dequeue interval for receive queue from se_dp.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ],
                    "min": 1,
                    "max": 1000
                },
                "dp_enq_interval_msec": {
                    "type": "uint32",
                    "default": 20,
                    "description": "Enqueue interval for request queue to se_dp.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ],
                    "min": 1,
                    "max": 1000
                },
                "send_se_ready_timeout": {
                    "type": "uint32",
                    "default": 300,
                    "description": "Timeout for sending SE_READY without NS HELPER registration completion",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ],
                    "min": 10,
                    "max": 600
                },
                "vnic_dhcp_ip_check_interval": {
                    "type": "uint32",
                    "default": 6,
                    "description": "DHCP ip check interval",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ],
                    "min": 1,
                    "max": 1000
                },
                "vnic_dhcp_ip_max_retries": {
                    "type": "uint32",
                    "default": 10,
                    "description": "DHCP ip max retries",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "vnic_ip_delete_interval": {
                    "type": "uint32",
                    "default": 5,
                    "description": "wait interval before deleting IP. ",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "vnic_probe_interval": {
                    "type": "uint32",
                    "default": 5,
                    "description": "Probe vnic interval",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "vnic_rpc_retry_interval": {
                    "type": "uint32",
                    "default": 5,
                    "description": "Time interval for retrying the failed VNIC RPC requests",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "vnicdb_cmd_history_size": {
                    "type": "uint32",
                    "default": 256,
                    "description": "Size of vnicdb command history",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ],
                    "min": 0,
                    "max": 65535
                },
                "se_dp_isolation": {
                    "type": "bool",
                    "default": false,
                    "description": "Toggle support to run SE datapath instances in isolation on exclusive CPUs. This improves latency and performance. However, this could reduce the total number of se_dp instances created on that SE instance. Supported for >= 8 CPUs. Requires SE reboot."
                },
                "se_dp_isolation_num_non_dp_cpus": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Number of CPUs for non se-dp tasks in SE datapath isolation mode. Translates Total cpus minus 'num_non_dp_cpus' for datapath use. It is recommended to reserve an even number of CPUs for hyper-threaded processors. Requires SE reboot.",
                    "min": 1,
                    "max": 8,
                    "specialValues": {
                        "0": "auto"
                    }
                },
                "user_agent_cache_config": {
                    "type": "message",
                    "messageType": "UserAgentCacheConfig",
                    "description": "Configuration for User-Agent Cache used in Bot Management."
                },
                "sdb_scan_count": {
                    "type": "uint32",
                    "default": 1000,
                    "description": "SDB scan count",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ],
                    "min": 1,
                    "max": 1000
                },
                "sdb_pipeline_size": {
                    "type": "uint32",
                    "default": 100,
                    "description": "SDB pipeline size",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ],
                    "min": 1,
                    "max": 10000
                },
                "sdb_flush_interval": {
                    "type": "uint32",
                    "default": 100,
                    "description": "SDB pipeline flush interval",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ],
                    "min": 1,
                    "max": 10000
                },
                "l7_conns_per_core": {
                    "type": "uint32",
                    "default": 16384,
                    "description": "Number of L7 connections that can be cached per core."
                },
                "ssl_sess_cache_per_vs": {
                    "type": "uint32",
                    "default": 4096,
                    "description": "Number of SSL sessions that can be cached per VS."
                },
                "l7_resvd_listen_conns_per_core": {
                    "type": "uint32",
                    "default": 256,
                    "description": "Number of reserved L7 listener connections per core."
                },
                "upstream_connpool_enable": {
                    "type": "bool",
                    "default": true,
                    "description": "Enable upstream connection pool,"
                },
                "ngx_free_connection_stack": {
                    "type": "bool",
                    "default": false,
                    "description": "Free the connection stack."
                },
                "http_rum_console_log": {
                    "type": "bool",
                    "default": false,
                    "description": "Enable Javascript console logs on the client browser when collecting client insights.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "http_rum_min_content_length": {
                    "type": "uint32",
                    "default": 64,
                    "description": "Minimum response size content length to sample for client insights.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "64"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "64"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "upstream_connect_timeout": {
                    "type": "uint32",
                    "default": 3600000,
                    "description": "Timeout for backend connection."
                },
                "upstream_send_timeout": {
                    "type": "uint32",
                    "default": 3600000,
                    "description": "Timeout for upstream to become writable.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "3600000"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "3600000"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "upstream_read_timeout": {
                    "type": "uint32",
                    "default": 3600000,
                    "description": "Timeout for data to be received from backend."
                },
                "downstream_send_timeout": {
                    "type": "uint32",
                    "default": 3600000,
                    "description": "Timeout for downstream to become writable."
                },
                "lbaction_num_requests_to_dispatch": {
                    "type": "uint32",
                    "default": 4,
                    "description": "Number of requests to dispatch from the request. queue at a regular interval."
                },
                "lbaction_rq_per_request_max_retries": {
                    "type": "uint32",
                    "default": 22,
                    "description": "Maximum retries per request in the request queue."
                },
                "user_defined_metric_age": {
                    "type": "uint32",
                    "default": 60,
                    "description": "Defines in seconds how long before an unused user-defined-metric is garbage collected."
                },
                "enable_hsm_log": {
                    "type": "bool",
                    "default": false,
                    "description": "Enable HSM luna engine logs."
                },
                "ignore_docker_mac_change": {
                    "type": "bool",
                    "default": true,
                    "description": "Ignore docker mac change.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "se_dump_core_on_assert": {
                    "type": "bool",
                    "default": false,
                    "description": "Enable core dump on assert",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "se_packet_buffer_max": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Internal use only. Used to artificially reduce the available number of packet buffers.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "se_dp_if_state_poll_interval": {
                    "type": "uint32",
                    "default": 10,
                    "description": "Number of jiffies between polling interface state.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "se_emulated_cores": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Use this to emulate more/less cpus than is actually available. One datapath process is started for each core.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "0"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "0"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "baremetal_dispatcher_handles_flows": {
                    "type": "bool",
                    "default": false,
                    "description": "Control if dispatcher core also handles TCP flows in baremetal SE.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                },
                "use_legacy_netlink": {
                    "type": "bool",
                    "default": false,
                    "description": "Enable legacy model of netlink notifications."
                },
                "log_agent_trace_enabled": {
                    "type": "bool",
                    "default": true,
                    "description": "Enable trace logs by default on Service Engine. Configuration operations are logged along with other important logs by Service Engine."
                },
                "log_agent_debug_enabled": {
                    "type": "bool",
                    "default": false,
                    "description": "Enable debug logs by default on Service Engine. This includes all other debugging logs. Debug logs can also be explcitly enabled from the CLI shell."
                },
                "se_log_buffer_app_blocking_dequeue": {
                    "type": "bool",
                    "default": false,
                    "description": "Internal flag that blocks dataplane until all application logs are flushed to log-agent process."
                },
                "se_log_buffer_conn_blocking_dequeue": {
                    "type": "bool",
                    "default": false,
                    "description": "Internal flag that blocks dataplane until all connection logs are flushed to log-agent process."
                },
                "se_log_buffer_events_blocking_dequeue": {
                    "type": "bool",
                    "default": true,
                    "description": "Internal flag that blocks dataplane until all outstanding events are flushed to log-agent process."
                },
                "log_agent_file_sz_debug": {
                    "type": "uint32",
                    "default": 4,
                    "description": "Maximum debug log file size before rollover."
                },
                "log_agent_file_sz_conn": {
                    "type": "uint32",
                    "default": 4,
                    "description": "Maximum connection log file size before rollover."
                },
                "log_agent_file_sz_appl": {
                    "type": "uint32",
                    "default": 4,
                    "description": "Maximum application log file size before rollover."
                },
                "log_agent_file_sz_event": {
                    "type": "uint32",
                    "default": 4,
                    "description": "Maximum event log file size before rollover."
                },
                "log_agent_min_storage_per_vs": {
                    "type": "uint32",
                    "default": 10,
                    "description": "Minimum storage allocated to any given VirtualService on the Service Engine."
                },
                "log_agent_max_storage_ignore_percent": {
                    "type": "float",
                    "default": 20,
                    "description": "Maximum storage on the disk not allocated for logs on the Service Engine."
                },
                "log_agent_max_storage_excess_percent": {
                    "type": "uint32",
                    "default": 110,
                    "description": "Excess percentage threshold of disk size to trigger cleanup of logs on the Service Engine."
                },
                "se_dp_log_nf_enqueue_percent": {
                    "type": "uint32",
                    "default": 70,
                    "description": "Internal buffer full indicator on the Service Engine beyond which the unfiltered logs are abandoned."
                },
                "se_dp_log_udf_enqueue_percent": {
                    "type": "uint32",
                    "default": 90,
                    "description": "Internal buffer full indicator on the Service Engine beyond which the user filtered logs are abandoned."
                },
                "log_agent_compress_logs": {
                    "type": "bool",
                    "default": true,
                    "description": "Flag to indicate if log files are compressed upon full on the Service Engine."
                },
                "log_agent_sleep_interval": {
                    "type": "uint32",
                    "default": 10,
                    "description": "Internal timer to stall log-agent and prevent it from hogging CPU cycles on the Service Engine."
                },
                "log_agent_unknown_vs_timer": {
                    "type": "uint32",
                    "default": 1800,
                    "description": "Timeout to purge unknown Virtual Service logs from the Service Engine."
                },
                "log_agent_max_concurrent_rsync": {
                    "type": "uint32",
                    "default": 1024,
                    "description": "Maximum concurrent rsync requests initiated from log-agent to the Controller"
                },
                "log_agent_log_storage_min_sz": {
                    "type": "uint32",
                    "default": 1024,
                    "description": "Minimum storage allocated for logs irrespective of memory and cores."
                },
                "log_message_max_file_list_size": {
                    "type": "uint32",
                    "default": 64,
                    "description": "Maximum number of file names in a log message"
                },
                "deactivate_ipv6_discovery": {
                    "type": "bool",
                    "description": "If activated, IPv6 address and route discovery are deactivated.Requires SE reboot."
                },
                "markers": {
                    "type": "message",
                    "messageType": "RoleFilterMatchLabel",
                    "repeated": true,
                    "description": "List of labels to be used for granular RBAC.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "bgp_peer_monitor_failover_enabled": {
                    "type": "bool",
                    "default": false,
                    "description": "Enable BGP peer monitoring based failover."
                },
                "max_skb_frags": {
                    "type": "uint32",
                    "default": 17,
                    "description": "Maximum of number of 4 KB pages allocated to the Linux kernel GRO subsystem for packet coalescing. This parameter is limited to supported kernels only. Requires SE Reboot.",
                    "min": 1,
                    "max": 17
                },
                "hybrid_rss_mode": {
                    "type": "bool",
                    "default": false,
                    "description": "Toggles SE hybrid only mode of operation in DPDK mode with RSS configured;where-in each SE datapath instance operates as a standalone hybrid instance performing both dispatcher and proxy function. Requires reboot."
                },
                "num_dispatcher_queues": {
                    "type": "uint32",
                    "default": 1,
                    "description": "Number of queues to each dispatcher.",
                    "min": 1,
                    "max": 2
                },
                "kni_allowed_server_ports": {
                    "type": "message",
                    "messageType": "KniPortRange",
                    "repeated": true,
                    "description": "Port ranges for any servers running in inband LinuxServer clouds."
                },
                "deactivate_kni_filtering_at_dispatcher": {
                    "type": "bool",
                    "description": "Deactivate filtering of packets to KNI interface. To be used under surveillance of Avi Support."
                },
                "vcenter_parking_vnic_pg": {
                    "type": "string",
                    "description": "Parking port group to be used by 9 vnics at the time of SE creation.",
                    "maxStringLength": 128
                },
                "dpdk_gro_timeout_interval": {
                    "type": "uint32",
                    "default": 50,
                    "description": "The timeout for GRO coalescing interval. 0 indicates non-timer based GRO.",
                    "min": 0,
                    "max": 900
                },
                "se_time_tracker_props": {
                    "type": "message",
                    "messageType": "SETimeTrackerProperties",
                    "description": "Time Tracker Properties for latency audit.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "grpc_channel_connect_timeout": {
                    "type": "uint32",
                    "default": 15,
                    "description": "Timeout in seconds that SE waits for a grpc channel to connect to server, before it retries.",
                    "min": 5,
                    "max": 45
                },
                "ntp_sync_fail_event": {
                    "type": "bool",
                    "default": false,
                    "description": "Toggle SE NTP synchronization failure events generation. Disabled by default.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "ntp_sync_status_interval": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Configures the interval at which SE synchronization status with NTP server(s) is verified. A value of zero disables SE NTP synchronization status validation.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ],
                    "min": 120,
                    "max": 900,
                    "specialValues": {
                        "0": "disable"
                    }
                },
                "use_dp_util_for_scaleout": {
                    "type": "bool",
                    "default": false,
                    "description": "If enabled, the datapath CPU utilization is consulted by the auto scale-out logic.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "replay_vrf_routes_interval": {
                    "type": "uint32",
                    "default": 1000,
                    "description": "Routes in VRF are replayed at the specified interval. This should be increased if there are large number of routes.",
                    "min": 0,
                    "max": 3000
                },
                "vs_se_scalein_additional_wait_time": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Wait time for sending scalein ready notification after flows are completed. In certain deployments, there may be an additional delay to accept traffic. For example, for BGP, some time is needed for route advertisement.",
                    "min": 0,
                    "max": 300
                },
                "vs_se_primary_switchover_additional_wait_time": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Wait time for primary switchover ready notification after flows are completed. In certain deployments, there may be an additional delay to accept traffic. For example, for BGP, some time is needed for route advertisement.",
                    "min": 0,
                    "max": 300
                },
                "path_mtu_discovery_v4": {
                    "type": "bool",
                    "default": false,
                    "description": "Enable Path MTU Discovery feature for IPv4."
                },
                "path_mtu_discovery_v6": {
                    "type": "bool",
                    "default": true,
                    "description": "Enable Path MTU Discovery feature for IPv6."
                },
                "metrics_collection_mode": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Metrics collection mode, 0 = Pull mode.  se_agent pulls metrics from se_dp,  1 = Push mode. se_dp pushes metrics to se_agent.  9 = special value to reset collection state in push mode. ",
                    "min": 0,
                    "max": 1,
                    "specialValues": {
                        "9": "Reset metrics collection state"
                    }
                },
                "se_debug_trace_sz": {
                    "type": "uint32",
                    "default": 8,
                    "description": "Use to cap the size of debug ring min(se_debug_trace_sz, num_dispatcher_cores). Only applicable to > 8G systems.  Requires SE Reboot."
                },
                "multicast_enable": {
                    "type": "bool",
                    "default": true,
                    "description": "This knob enables the Service Engine to process multicast traffic(For VMware Hypervisor)."
                },
                "max_num_http_sessions_to_store": {
                    "type": "uint32",
                    "default": 50000,
                    "description": "Maximum number of HTTP session that will be created. Each session uses about 1kB in the key-value storage in shared memory. Setting this value too high can lead to exhaustion of shared memory and affect services.",
                    "min": 1,
                    "max": 2000000
                },
                "gve_enabled": {
                    "type": "bool",
                    "default": false,
                    "description": "Deploys Google Virtual Ethernet (gve) - gVNIC for all supported intances types in GCP. Applies only to newly created SE's."
                },
                "waf_use_jit_for_pcre": {
                    "type": "bool",
                    "default": true,
                    "description": "Use the JIT compiler for PCRE regular expressions in WAF. Setting this to false will impact performance."
                },
                "enable_qat": {
                    "type": "bool",
                    "default": false,
                    "description": "This knob enables the Service Engine to use QAT offloads (if the host CPU is capable, and the QAT device is exposed). Requires SE Reboot."
                },
                "pre_upgrade_se_available_mem_threshold": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Available memory threshold on SE in MB, to get qualified for upgrade operation. Adjusting this knob will override the internal value of available memory threshold for SE, thereby qualifying it for upgrade operation. '0' is a special auto value, which will indicate that memory threshold is calculated based on total memory size of the SE."
                },
                "kv_val_max_len": {
                    "type": "uint32",
                    "default": 4096,
                    "description": "Max length allowed for the value in a KV pair"
                },
                "arp_cache_timeout": {
                    "type": "uint32",
                    "default": 1200,
                    "description": "Timeout in seconds for idle ARP entries.",
                    "min": 0,
                    "max": 86400
                },
                "nd6_cache_timeout": {
                    "type": "uint32",
                    "default": 86400,
                    "description": "Timeout in seconds for idle ND6 entries.",
                    "min": 0,
                    "max": 86400
                },
                "objsync_mode": {
                    "type": "enum",
                    "enumType": "SeGroupObjsyncMode",
                    "default": "OBJSYNC_ENABLED",
                    "description": "Enables SE-SE object syncing."
                },
                "reserved_configuration": {
                    "type": "message",
                    "messageType": "ReservedConfiguration",
                    "description": "Reserved configuration used for internal configuration purposes."
                },
                "vsphere_storage_policies": {
                    "type": "message",
                    "messageType": "VsphereStoragePolicy",
                    "repeated": true,
                    "description": "vSphere VM Storage Policy UUID to be associated to the Service Engine."
                },
                "sdb_key_timeout": {
                    "type": "uint32",
                    "default": 60,
                    "description": "The time in seconds controller redis server persists the key.",
                    "min": 60,
                    "max": 600
                },
                "max_cpu_load_adaptive_sampling": {
                    "type": "uint32",
                    "default": 95,
                    "description": "When adaptive sampling is enabled, specifies the max CPU load allowed for adaptive sampling. If the CPU load exceeds this value, no requests will be sampled.",
                    "min": 1,
                    "max": 100
                },
                "disable_qat_bulk_crypto": {
                    "type": "bool",
                    "default": true,
                    "description": "This knob enables the QAT offloads for TLS application data. (if the host CPU is capable, and the QAT device is exposed). Requires SE Reboot."
                },
                "auto_rebalance_cool_down_time": {
                    "type": "uint32",
                    "default": 15,
                    "description": "The time in minutes controller waits before rebalancing the Vs again after a scalein/scaleout."
                },
                "auto_rebalance_raise_events_for_actions": {
                    "type": "bool",
                    "default": false,
                    "description": "If enabled, the controller will raise events for rebalance actions."
                },
                "auto_rebalance_dry_run_enabled": {
                    "type": "bool",
                    "default": false,
                    "description": "If enabled, the controller will not perform the rebalance actions.It will only generate the actions and update that in the debug api.This is useful for testing the rebalance logic without actually performing the actions."
                },
                "license_quota": {
                    "type": "message",
                    "messageType": "QuotaConfig",
                    "description": "License quota for the SE group.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "se_kernel_rss": {
                    "type": "bool",
                    "default": false,
                    "description": "Allows runtime updates and planting of FT entries across all dispacther cpu. Any changes does not impact existing flows. Should be used under supervision."
                },
                "audit_qat_huge_pages": {
                    "type": "bool",
                    "default": true,
                    "description": "This knob enables audit of QAT Hugepages."
                },
                "control_qat_huge_pages": {
                    "type": "bool",
                    "default": true,
                    "description": "This knob enables control of QAT Hugepages."
                },
                "qat_hpage_mem_per_process": {
                    "type": "enum",
                    "enumType": "SeQatHugePageMemPerProcess",
                    "default": "QAT_HPAGE_MEM_16MB",
                    "description": "This knob is used to set the number of QAT Hugepages."
                },
                "optimistic_placement": {
                    "type": "bool",
                    "default": false,
                    "description": "Allows packed placement on existing SEs with asynchronous spinning up of buffer SEs. Used in packed placement with buffer SEs."
                }
            }
        },
        "QuotaConfig": {
            "fields": {
                "reservation": {
                    "type": "uint64",
                    "default": 0,
                    "description": "Minimum license service units reserved for consumption. Reservation is not enforced for Tenant/SE Group.",
                    "min": 0,
                    "max": 65535
                },
                "limit": {
                    "type": "Unknown",
                    "default": -1,
                    "description": "Maximum license service units allowed for consumption. -1 as Default is maximum value.",
                    "min": -1,
                    "max": 65535
                }
            }
        },
        "VsphereStoragePolicy": {
            "fields": {
                "vcenter_uuid": {
                    "type": "string",
                    "description": "VCenter server configuration , applicable only for Nsxt-Cloud.",
                    "maxStringLength": 256
                },
                "vsphere_storage_policy_id": {
                    "type": "string",
                    "description": "vSphere VM Storage Policy UUID to be associated to the Service Engine",
                    "maxStringLength": 128
                }
            }
        },
        "ReservedConfiguration": {
            "fields": {
                "key_value_configurations": {
                    "type": "message",
                    "messageType": "KeyValueConfiguration",
                    "repeated": true,
                    "description": "List of configurations for internal purposes."
                }
            }
        },
        "KeyValueConfiguration": {
            "fields": {
                "key": {
                    "type": "string",
                    "description": "Reserved key string to be used for internal configuration.",
                    "maxStringLength": 128,
                    "required": true
                },
                "value": {
                    "type": "uint32",
                    "description": "Value corresponding to the key.",
                    "required": true
                }
            }
        },
        "SETimeTrackerProperties": {
            "fields": {
                "ingress_threshold": {
                    "type": "uint32",
                    "default": 20,
                    "description": "Maximum ingress latency threshold between dispatcher and proxy."
                },
                "egress_threshold": {
                    "type": "uint32",
                    "default": 20,
                    "description": "Maximum egress latency threshold between dispatcher and proxy."
                },
                "ingress_audit_mode": {
                    "type": "enum",
                    "enumType": "SETTAuditMode",
                    "default": "SE_TT_AUDIT_OFF",
                    "description": "Audit queueing latency from dispatcher to proxy."
                },
                "egress_audit_mode": {
                    "type": "enum",
                    "enumType": "SETTAuditMode",
                    "default": "SE_TT_AUDIT_OFF",
                    "description": "Audit queueing latency from proxy to dispatcher."
                },
                "event_gen_window": {
                    "type": "uint64",
                    "default": 300,
                    "description": "Window for cumulative event generation."
                }
            }
        },
        "KniPortRange": {
            "fields": {
                "range": {
                    "type": "message",
                    "messageType": "PortRange",
                    "description": "Port range to be allowed to KNI.",
                    "required": true
                },
                "protocol": {
                    "type": "enum",
                    "enumType": "KniTransportProtocol",
                    "description": "Protocol associated with port range.",
                    "required": true
                }
            }
        },
        "ObjSyncConfig": {
            "fields": {
                "objsync_cpu_limit": {
                    "type": "uint32",
                    "default": 0,
                    "description": "SE CPU limit for InterSE Object Distribution.",
                    "min": 0,
                    "max": 100,
                    "specialValues": {
                        "0": "No Restriction."
                    }
                },
                "objsync_reconcile_interval": {
                    "type": "uint32",
                    "default": 10,
                    "description": "Reconcile interval for InterSE Object Distribution.",
                    "min": 1,
                    "max": 120
                },
                "objsync_hub_elect_interval": {
                    "type": "uint32",
                    "default": 60,
                    "description": "Hub election interval for InterSE Object Distribution.",
                    "min": 30,
                    "max": 300
                }
            }
        },
        "GCPSeGroupConfig": {
            "fields": {
                "backend_data_vpc_network_name": {
                    "type": "string",
                    "description": "Service Engine Backend Data Network Name, used only for GCP cloud.Overrides the cloud level setting for Backend Data Network in GCP Two Arm Mode."
                },
                "backend_data_vpc_subnet_name": {
                    "type": "string",
                    "description": "Service Engine Backend Data Subnet Name, used only for GCP cloud.Overrides the cloud level setting for Backend Data Subnet in GCP Two Arm Mode."
                },
                "backend_data_vpc_project_id": {
                    "type": "string",
                    "description": "Project ID of the Service Engine Backend Data Network. By default, Service Engine Project ID will be used."
                }
            }
        },
        "SeGroupAnalyticsPolicy": {
            "fields": {
                "metrics_event_thresholds": {
                    "type": "message",
                    "messageType": "MetricsEventThreshold",
                    "repeated": true,
                    "description": "Thresholds for various events generated by metrics system."
                }
            }
        },
        "MetricsEventThreshold": {
            "fields": {
                "reset_threshold": {
                    "type": "Unknown",
                    "description": "This value is used to reset the event state machine.",
                    "min": 1,
                    "max": 100
                },
                "watermark_thresholds": {
                    "type": "uint32",
                    "repeated": true,
                    "description": "Threshold value for which event in raised. There can be multiple thresholds defined.Health score degrades when the the target is higher than this threshold.",
                    "min": 1,
                    "max": 100
                },
                "metrics_event_threshold_type": {
                    "type": "enum",
                    "enumType": "MetricsEventThresholdType",
                    "description": "Type of the metrics event threshold. This value will decide which metric rule (or rules) use configured thresholds.",
                    "required": true
                }
            },
            "repeatedKey": "metrics_event_threshold_type"
        },
        "CloudFlavor": {
            "fields": {
                "id": {
                    "type": "string",
                    "required": true
                },
                "name": {
                    "type": "string",
                    "required": true
                },
                "ram_mb": {
                    "type": "uint32"
                },
                "disk_gb": {
                    "type": "uint32"
                },
                "vcpus": {
                    "type": "uint32"
                },
                "public": {
                    "type": "bool",
                    "default": true
                },
                "max_nics": {
                    "type": "uint32"
                },
                "max_ips_per_nic": {
                    "type": "uint32"
                },
                "enhanced_nw": {
                    "type": "bool"
                },
                "meta": {
                    "type": "message",
                    "messageType": "CloudMeta",
                    "repeated": true
                },
                "cost": {
                    "type": "string"
                },
                "max_ip6s_per_nic": {
                    "type": "uint32",
                    "description": "Maximum number of IPv6 addresses that can be configured per NIC."
                },
                "is_recommended": {
                    "type": "bool",
                    "description": "If a vm flavor is recommended for requested se_usage_type.Set to True if the chosen VM flavor is recommended for requested se_usage_type.Else set to False."
                }
            }
        },
        "CloudMeta": {
            "fields": {
                "key": {
                    "type": "string",
                    "required": true
                },
                "value": {
                    "type": "string",
                    "required": true
                }
            }
        },
        "PlacementScopeConfig": {
            "fields": {
                "vcenter_uuid": {
                    "type": "string",
                    "description": "VCenter server configuration.",
                    "required": true
                },
                "vcenter_folder": {
                    "type": "string",
                    "description": "Folder to place all the Service Engine virtual machines in vCenter."
                },
                "nsxt_hosts": {
                    "type": "message",
                    "messageType": "NsxtHosts",
                    "description": "List of transport nodes include or exclude."
                },
                "nsxt_datastores": {
                    "type": "message",
                    "messageType": "NsxtDatastores",
                    "description": "List of shared datastores to include or exclude.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "nsxt_clusters": {
                    "type": "message",
                    "messageType": "NsxtClusters",
                    "description": "List of transport node clusters include or exclude.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "clusters": {
                    "type": "message",
                    "messageType": "ClusterHAConfig",
                    "repeated": true,
                    "description": "Cluster vSphere HA configuration.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                }
            },
            "repeatedKey": "vcenter_uuid"
        },
        "ClusterHAConfig": {
            "fields": {
                "cluster_id": {
                    "type": "string",
                    "description": "Transport node cluster. Avi derives vSphere HA property from vCenter cluster.If vSphere HA enabled on vCenter cluster, vSphere will handle HA of ServiceEngine VMs in case of underlying ESX failure.Ex MOB: domain-c23.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ],
                    "maxStringLength": 128
                },
                "vmg_name": {
                    "type": "string",
                    "description": "Cluster VM Group name.VM Group name is unique inside cluster",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ],
                    "maxStringLength": 128
                },
                "override_vsphere_ha": {
                    "type": "bool",
                    "default": false,
                    "description": "If this flag set to True, Avi handles ServiceEngine failure irrespective of vSphere HA enabled on vCenter cluster or not.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                }
            },
            "repeatedKey": "cluster_id"
        },
        "NsxtClusters": {
            "fields": {
                "cluster_ids": {
                    "type": "string",
                    "repeated": true,
                    "description": "List of transport node clusters.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "include": {
                    "type": "bool",
                    "default": false,
                    "description": "Include or Exclude.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                }
            }
        },
        "NsxtDatastores": {
            "fields": {
                "ds_ids": {
                    "type": "string",
                    "repeated": true,
                    "description": "List of shared datastores.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "include": {
                    "type": "bool",
                    "default": false,
                    "description": "Include or Exclude.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                }
            }
        },
        "NsxtHosts": {
            "fields": {
                "host_ids": {
                    "type": "string",
                    "repeated": true,
                    "description": "List of transport nodes."
                },
                "include": {
                    "type": "bool",
                    "default": false,
                    "description": "Include or Exclude."
                }
            }
        },
        "VipAutoscaleGroup": {
            "fields": {
                "policy": {
                    "type": "message",
                    "messageType": "VipAutoscalePolicy"
                },
                "configuration": {
                    "type": "message",
                    "messageType": "VipAutoscaleConfiguration"
                }
            }
        },
        "VipAutoscaleConfiguration": {
            "fields": {
                "zones": {
                    "type": "message",
                    "messageType": "VipAutoscaleZones",
                    "repeated": true,
                    "description": "This is the list of AZ+Subnet in which Vips will be spawned."
                }
            }
        },
        "VipAutoscaleZones": {
            "fields": {
                "availability_zone": {
                    "type": "string",
                    "description": "Availability zone associated with the subnet."
                },
                "subnet_uuid": {
                    "type": "string",
                    "description": "UUID of the subnet for new IP address allocation."
                },
                "fip_capable": {
                    "type": "bool",
                    "description": "Determines if the subnet is capable of hosting publicly accessible IP."
                }
            },
            "repeatedKey": "subnet_uuid"
        },
        "IptableRuleSet": {
            "fields": {
                "table": {
                    "type": "string",
                    "required": true
                },
                "chain": {
                    "type": "string",
                    "required": true
                },
                "rules": {
                    "type": "message",
                    "messageType": "IptableRule",
                    "repeated": true
                }
            }
        },
        "IptableRule": {
            "fields": {
                "src_ip": {
                    "type": "message",
                    "messageType": "IpAddrPrefix"
                },
                "dst_ip": {
                    "type": "message",
                    "messageType": "IpAddrPrefix"
                },
                "src_port": {
                    "type": "message",
                    "messageType": "PortRange"
                },
                "dst_port": {
                    "type": "message",
                    "messageType": "PortRange"
                },
                "proto": {
                    "type": "enum",
                    "enumType": "IptableRuleProtocol"
                },
                "input_interface": {
                    "type": "string"
                },
                "output_interface": {
                    "type": "string"
                },
                "action": {
                    "type": "enum",
                    "enumType": "IptableRuleAction",
                    "required": true
                },
                "dnat_ip": {
                    "type": "message",
                    "messageType": "IpAddr"
                },
                "tag": {
                    "type": "string"
                }
            }
        },
        "VcenterDatastore": {
            "fields": {
                "datastore_name": {
                    "type": "string"
                },
                "managed_object_id": {
                    "type": "string",
                    "description": "Will be used by default, if not set fallback to datastore_name.",
                    "maxStringLength": 256
                }
            }
        },
        "SnmpTrapProfile": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "required": true,
                    "description": "UUID of the SNMP trap profile object"
                },
                "name": {
                    "type": "string",
                    "required": true,
                    "description": "A user-friendly name of the SNMP trap configuration.",
                    "maxStringLength": 256
                },
                "trap_servers": {
                    "type": "message",
                    "messageType": "SnmpTrapServer",
                    "repeated": true,
                    "description": "The IP address or hostname of the SNMP trap destination server."
                },
                "tenant_uuid": {
                    "type": "string"
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                }
            }
        },
        "SnmpTrapServer": {
            "fields": {
                "ip_addr": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "required": true,
                    "description": "IP(v4/v6) Address or FQDN of the SNMP trap destination"
                },
                "community": {
                    "type": "string",
                    "description": "The community string to communicate with the trap server."
                },
                "version": {
                    "type": "enum",
                    "enumType": "SNMP_VER",
                    "default": "SNMP_VER2",
                    "description": "SNMP version support. V2 or V3"
                },
                "user": {
                    "type": "message",
                    "messageType": "SnmpV3UserParams",
                    "description": "SNMP version 3 configuration"
                },
                "port": {
                    "type": "uint32",
                    "default": 162,
                    "description": "The UDP port of the trap server."
                }
            },
            "repeatedKey": "ip_addr,version"
        },
        "SnmpV3UserParams": {
            "fields": {
                "username": {
                    "type": "string",
                    "description": "SNMP username to be used by SNMP clients for performing SNMP walk"
                },
                "auth_type": {
                    "type": "enum",
                    "enumType": "SNMP_V3_AUTH",
                    "default": "SNMP_V3_AUTH_MD5",
                    "description": "SNMP V3 user authentication type"
                },
                "auth_passphrase": {
                    "type": "string",
                    "default": "avinetworks",
                    "description": "SNMP V3 authentication passphrase"
                },
                "priv_type": {
                    "type": "enum",
                    "enumType": "SNMP_V3_PRIV",
                    "default": "SNMP_V3_PRIV_DES",
                    "description": "SNMP V3 privacy setting"
                },
                "priv_passphrase": {
                    "type": "string",
                    "default": "avinetworks",
                    "description": "SNMP V3 privacy passphrase"
                }
            }
        },
        "SSLCertificate": {
            "fields": {
                "version": {
                    "type": "string"
                },
                "serial_number": {
                    "type": "string"
                },
                "self_signed": {
                    "type": "bool"
                },
                "issuer": {
                    "type": "message",
                    "messageType": "SSLCertificateDescription"
                },
                "subject": {
                    "type": "message",
                    "messageType": "SSLCertificateDescription"
                },
                "key_params": {
                    "type": "message",
                    "messageType": "SSLKeyParams"
                },
                "public_key": {
                    "type": "string"
                },
                "signature_algorithm": {
                    "type": "string"
                },
                "signature": {
                    "type": "string"
                },
                "not_before": {
                    "type": "string"
                },
                "not_after": {
                    "type": "string"
                },
                "certificate": {
                    "type": "string"
                },
                "certificate_signing_request": {
                    "type": "string"
                },
                "text": {
                    "type": "string"
                },
                "fingerprint": {
                    "type": "string"
                },
                "expiry_status": {
                    "type": "enum",
                    "enumType": "SSLCertificateExpiryStatus",
                    "default": "SSL_CERTIFICATE_GOOD"
                },
                "chain_verified": {
                    "type": "bool"
                },
                "subject_alt_names": {
                    "type": "string",
                    "repeated": true,
                    "description": "subjectAltName that provides additional subject identities"
                },
                "days_until_expire": {
                    "type": "int32",
                    "default": 365,
                    "description": "Valid range: 1-3650",
                    "min": 1,
                    "max": 3650
                }
            }
        },
        "SSLKeyParams": {
            "fields": {
                "algorithm": {
                    "type": "enum",
                    "enumType": "SSLKeyAlgorithm",
                    "default": "SSL_KEY_ALGORITHM_RSA",
                    "required": true
                },
                "rsa_params": {
                    "type": "message",
                    "messageType": "SSLKeyRSAParams"
                },
                "ec_params": {
                    "type": "message",
                    "messageType": "SSLKeyECParams"
                },
                "mldsa_params": {
                    "type": "message",
                    "messageType": "SSLKeyMldsaParams",
                    "description": "Mldsa keys"
                }
            }
        },
        "SSLKeyMldsaParams": {
            "fields": {
                "algorithm": {
                    "type": "enum",
                    "enumType": "SSLKeyMldsaAlgorithm",
                    "default": "SSL_KEY_MLDSA44",
                    "description": "MLDSA signature algorithm"
                }
            }
        },
        "SSLKeyECParams": {
            "fields": {
                "curve": {
                    "type": "enum",
                    "enumType": "SSLKeyECCurve",
                    "default": "SSL_KEY_EC_CURVE_SECP256R1"
                }
            }
        },
        "SSLKeyRSAParams": {
            "fields": {
                "key_size": {
                    "type": "enum",
                    "enumType": "SSLRSAKeySize",
                    "default": "SSL_KEY_2048_BITS"
                },
                "exponent": {
                    "type": "uint32",
                    "default": 65537
                }
            }
        },
        "SSLCertificateDescription": {
            "fields": {
                "common_name": {
                    "type": "string"
                },
                "email_address": {
                    "type": "string"
                },
                "organization_unit": {
                    "type": "string"
                },
                "organization": {
                    "type": "string"
                },
                "locality": {
                    "type": "string"
                },
                "state": {
                    "type": "string"
                },
                "country": {
                    "type": "string"
                },
                "distinguished_name": {
                    "type": "string"
                }
            }
        },
        "SSLCertificateRequest": {
            "fields": {
                "name": {
                    "type": "string",
                    "required": true
                },
                "common_name": {
                    "type": "string",
                    "required": true
                },
                "email_address": {
                    "type": "string"
                },
                "organization_unit": {
                    "type": "string"
                },
                "organization": {
                    "type": "string"
                },
                "locality": {
                    "type": "string"
                },
                "state": {
                    "type": "string"
                },
                "country": {
                    "type": "string"
                },
                "challenge_password": {
                    "type": "string"
                },
                "self_signed": {
                    "type": "bool",
                    "default": false,
                    "required": true
                },
                "type": {
                    "type": "enum",
                    "enumType": "SSLCertificateType"
                },
                "key_params": {
                    "type": "message",
                    "messageType": "SSLKeyParams"
                },
                "days_until_expire": {
                    "type": "int32",
                    "default": 365,
                    "min": 1,
                    "max": 3650
                },
                "hardwaresecuritymodulegroup_uuid": {
                    "type": "string",
                    "description": "HSMGroup to use to generate the key and the certificate"
                },
                "certificate_management_profile_uuid": {
                    "type": "string"
                },
                "dynamic_params": {
                    "type": "message",
                    "messageType": "CustomParams",
                    "repeated": true,
                    "description": "Dynamic parameters needed for certificate management profile"
                },
                "subject_alt_names": {
                    "type": "string",
                    "repeated": true,
                    "description": "subjectAltName that provides additional subject identities"
                }
            }
        },
        "SSLKeyAndCertificate": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "required": true
                },
                "name": {
                    "type": "string",
                    "required": true,
                    "maxStringLength": 256
                },
                "type": {
                    "type": "enum",
                    "enumType": "SSLCertificateType"
                },
                "certificate": {
                    "type": "message",
                    "messageType": "SSLCertificate",
                    "required": true
                },
                "key_params": {
                    "type": "message",
                    "messageType": "SSLKeyParams"
                },
                "key": {
                    "type": "string",
                    "description": "Private key"
                },
                "status": {
                    "type": "enum",
                    "enumType": "SSLCertificateStatus",
                    "default": "SSL_CERTIFICATE_FINISHED"
                },
                "ca_certs": {
                    "type": "message",
                    "messageType": "CertificateAuthority",
                    "repeated": true,
                    "description": "CA certificates in certificate chain"
                },
                "enckey_base64": {
                    "type": "string",
                    "description": "Encrypted private key corresponding to the private key (e.g. those generated by an HSM such as Thales nShield)"
                },
                "enckey_name": {
                    "type": "string",
                    "description": "Name of the encrypted private key (e.g. those generated by an HSM such as Thales nShield)",
                    "maxStringLength": 255
                },
                "hardwaresecuritymodulegroup_uuid": {
                    "type": "string",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "tenant_uuid": {
                    "type": "string",
                    "required": true
                },
                "certificate_management_profile_uuid": {
                    "type": "string",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "dynamic_params": {
                    "type": "message",
                    "messageType": "CustomParams",
                    "repeated": true,
                    "description": "Dynamic parameters needed for certificate management profile",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "created_by": {
                    "type": "string",
                    "description": "Creator name"
                },
                "format": {
                    "type": "enum",
                    "enumType": "SSLFormat",
                    "default": "SSL_PEM",
                    "description": "Format of the Key/Certificate file."
                },
                "key_passphrase": {
                    "type": "string",
                    "description": "Passphrase used to encrypt the private key."
                },
                "certificate_base64": {
                    "type": "bool",
                    "default": false,
                    "description": "States if the certificate is base64 encoded."
                },
                "key_base64": {
                    "type": "bool",
                    "default": false,
                    "description": "States if the private key is base64 encoded."
                },
                "enable_ocsp_stapling": {
                    "type": "bool",
                    "default": false,
                    "description": "Enables OCSP Stapling.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "ocsp_responder_url_list_from_certs": {
                    "type": "string",
                    "repeated": true,
                    "description": "This is an Internal field to store the OCSP Responder URLs contained in the certificate.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "ocsp_config": {
                    "type": "message",
                    "messageType": "OCSPConfig",
                    "description": "Configuration related to OCSP.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "ocsp_response_info": {
                    "type": "message",
                    "messageType": "OCSPResponseInfo",
                    "description": "Information related to OCSP response.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "ocsp_error_status": {
                    "type": "enum",
                    "enumType": "OCSPErrorStatus",
                    "default": "OCSP_ERR_CERTSTATUS_DISABLED",
                    "description": "Error reported during OCSP status query.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "OCSP_ERR_CERTSTATUS_DISABLED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "OCSP_ERR_CERTSTATUS_DISABLED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "markers": {
                    "type": "message",
                    "messageType": "RoleFilterMatchLabel",
                    "repeated": true,
                    "description": "List of labels to be used for granular RBAC.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "import_key_to_hsm": {
                    "type": "bool",
                    "default": false,
                    "description": "Flag to enable Private key import to HSM while importing the certificate.",
                    "immutable": true
                },
                "is_federated": {
                    "type": "bool",
                    "default": false,
                    "description": "It Specifies whether the object has to be replicated to the GSLB followers.",
                    "immutable": true
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                }
            }
        },
        "OCSPResponseInfo": {
            "fields": {
                "ocsp_response": {
                    "type": "string",
                    "description": "Signed OCSP response received from the CA's OCSP Responder.",
                    "required": true
                },
                "cert_status": {
                    "type": "enum",
                    "enumType": "CertificateStatus",
                    "description": "Revocation status of the certificate.",
                    "required": true
                },
                "this_update": {
                    "type": "string",
                    "description": "The most recent time at which the status being indicated is known by the OCSP Responder to have been correct."
                },
                "next_update": {
                    "type": "string",
                    "description": "The time at or before which newer information will be available about the status of the certificate."
                },
                "revocation_time": {
                    "type": "string",
                    "description": "ISO 8601 compatible timestamp at which the certificate was revoked or placed on hold."
                },
                "revocation_reason": {
                    "type": "enum",
                    "enumType": "CertificateRevocationReason",
                    "description": "The reason for the revocation of the certificate."
                },
                "ocsp_resp_from_responder_url": {
                    "type": "string",
                    "description": "The OCSP Responder URL from which the response is received.",
                    "required": true
                }
            }
        },
        "OCSPConfig": {
            "fields": {
                "ocsp_req_interval": {
                    "type": "uint32",
                    "default": 86400,
                    "description": "Interval between the OCSP queries.",
                    "min": 60,
                    "max": 31536000
                },
                "ocsp_resp_timeout": {
                    "type": "uint32",
                    "description": "Time in seconds that the system waits for a reply from the OCSP responder before dropping the connection."
                },
                "responder_url_lists": {
                    "type": "string",
                    "repeated": true,
                    "description": "List of Responder URLs configured by user to do failover/override the AIA extension contained in the OCSP responder's SSL/TLS certificate."
                },
                "url_action": {
                    "type": "enum",
                    "enumType": "OCSPResponderUrlAction",
                    "default": "OCSP_RESPONDER_URL_FAILOVER",
                    "description": "Describes the type of action to take with the Responder URLs."
                },
                "failed_ocsp_jobs_retry_interval": {
                    "type": "uint32",
                    "default": 3600,
                    "description": "Describes the Time Interval after which the next OCSP job needs to be scheduled in case of the OCSP job failures.",
                    "min": 60,
                    "max": 86400
                },
                "max_tries": {
                    "type": "uint32",
                    "default": 10,
                    "description": "Maximum number of times the failed OCSP jobs can be scheduled."
                }
            }
        },
        "CertificateAuthority": {
            "fields": {
                "name": {
                    "type": "string"
                },
                "ca_uuid": {
                    "type": "string"
                }
            }
        },
        "SSLKeyAndCertificateImport": {
            "fields": {
                "name": {
                    "type": "string",
                    "required": true
                },
                "type": {
                    "type": "enum",
                    "enumType": "SSLCertificateType",
                    "default": "SSL_CERTIFICATE_TYPE_VIRTUALSERVICE"
                },
                "format": {
                    "type": "enum",
                    "enumType": "SSLFormat",
                    "default": "SSL_PEM"
                },
                "certificate": {
                    "type": "string"
                },
                "key": {
                    "type": "string",
                    "description": "Private key"
                },
                "key_passphrase": {
                    "type": "string"
                },
                "certificate_base64": {
                    "type": "bool",
                    "default": false
                },
                "key_base64": {
                    "type": "bool",
                    "default": false
                },
                "enckey_base64": {
                    "type": "string",
                    "description": "Encrypted private key corresponding to the private key (e.g. those generated by an HSM such as Thales nShield)"
                },
                "enckey_name": {
                    "type": "string",
                    "description": "Name of the encrypted private key (e.g. those generated by an HSM such as Thales nShield)",
                    "maxStringLength": 255
                },
                "hardwaresecuritymodulegroup_uuid": {
                    "type": "string",
                    "description": "HSMGroup to use to generate the key and the certificate",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "import_key_to_hsm": {
                    "type": "bool",
                    "default": false,
                    "description": "Flag to enable Private key import to HSM while importing the certificate.",
                    "immutable": true
                }
            }
        },
        "SSLProfile": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "required": true
                },
                "name": {
                    "type": "string",
                    "required": true,
                    "maxStringLength": 256
                },
                "accepted_versions": {
                    "type": "message",
                    "messageType": "SSLVersion",
                    "repeated": true,
                    "description": "Set of versions accepted by the server",
                    "minRepeatedLength": 1
                },
                "accepted_ciphers": {
                    "type": "string",
                    "default": "AES:3DES:RC4",
                    "description": "Ciphers suites represented as defined by https://www.openssl.org/docs/man1.1.1/man1/ciphers.html"
                },
                "cipher_enums": {
                    "type": "enum",
                    "enumType": "AcceptedCipherEnums",
                    "repeated": true,
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "TLS_ECDHE_ECDSA_WITH_AES_128_GCM_SHA256,TLS_ECDHE_ECDSA_WITH_AES_256_GCM_SHA384,TLS_ECDHE_RSA_WITH_AES_128_GCM_SHA256,TLS_ECDHE_RSA_WITH_AES_256_GCM_SHA384,TLS_ECDHE_ECDSA_WITH_AES_128_CBC_SHA256,TLS_ECDHE_ECDSA_WITH_AES_256_CBC_SHA384,TLS_ECDHE_RSA_WITH_AES_128_CBC_SHA256,TLS_ECDHE_RSA_WITH_AES_256_CBC_SHA384,TLS_RSA_WITH_AES_128_GCM_SHA256,TLS_RSA_WITH_AES_256_GCM_SHA384,TLS_RSA_WITH_AES_128_CBC_SHA256,TLS_RSA_WITH_AES_256_CBC_SHA256,TLS_ECDHE_ECDSA_WITH_AES_128_CBC_SHA,TLS_ECDHE_ECDSA_WITH_AES_256_CBC_SHA,TLS_ECDHE_RSA_WITH_AES_128_CBC_SHA,TLS_ECDHE_RSA_WITH_AES_256_CBC_SHA,TLS_RSA_WITH_AES_128_CBC_SHA,TLS_RSA_WITH_AES_256_CBC_SHA,TLS_RSA_WITH_3DES_EDE_CBC_SHA"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "TLS_ECDHE_ECDSA_WITH_AES_128_GCM_SHA256,TLS_ECDHE_ECDSA_WITH_AES_256_GCM_SHA384,TLS_ECDHE_RSA_WITH_AES_128_GCM_SHA256,TLS_ECDHE_RSA_WITH_AES_256_GCM_SHA384,TLS_ECDHE_ECDSA_WITH_AES_128_CBC_SHA256,TLS_ECDHE_ECDSA_WITH_AES_256_CBC_SHA384,TLS_ECDHE_RSA_WITH_AES_128_CBC_SHA256,TLS_ECDHE_RSA_WITH_AES_256_CBC_SHA384,TLS_RSA_WITH_AES_128_GCM_SHA256,TLS_RSA_WITH_AES_256_GCM_SHA384,TLS_RSA_WITH_AES_128_CBC_SHA256,TLS_RSA_WITH_AES_256_CBC_SHA256,TLS_ECDHE_ECDSA_WITH_AES_128_CBC_SHA,TLS_ECDHE_ECDSA_WITH_AES_256_CBC_SHA,TLS_ECDHE_RSA_WITH_AES_128_CBC_SHA,TLS_ECDHE_RSA_WITH_AES_256_CBC_SHA,TLS_RSA_WITH_AES_128_CBC_SHA,TLS_RSA_WITH_AES_256_CBC_SHA,TLS_RSA_WITH_3DES_EDE_CBC_SHA"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "tags": {
                    "type": "message",
                    "messageType": "Tag",
                    "repeated": true
                },
                "ssl_rating": {
                    "type": "message",
                    "messageType": "SSLRating"
                },
                "send_close_notify": {
                    "type": "bool",
                    "default": true,
                    "description": "Send 'close notify' alert message for a clean shutdown of the SSL connection."
                },
                "dhparam": {
                    "type": "string",
                    "description": "DH Parameters used in SSL. At this time, it is not configurable and is set to 2048 bits.",
                    "immutable": true
                },
                "prefer_client_cipher_ordering": {
                    "type": "bool",
                    "default": false,
                    "description": "Prefer the SSL cipher ordering presented by the client during the SSL handshake over the one specified in the SSL Profile."
                },
                "enable_ssl_session_reuse": {
                    "type": "bool",
                    "default": true,
                    "description": "Enable SSL session re-use."
                },
                "ssl_session_timeout": {
                    "type": "uint32",
                    "default": 86400,
                    "description": "The amount of time in seconds before an SSL session expires."
                },
                "type": {
                    "type": "enum",
                    "enumType": "SSLProfileType",
                    "default": "SSL_PROFILE_TYPE_APPLICATION",
                    "description": "SSL Profile Type.",
                    "immutable": true
                },
                "ciphersuites": {
                    "type": "string",
                    "default": "TLS_AES_256_GCM_SHA384:TLS_CHACHA20_POLY1305_SHA256:TLS_AES_128_GCM_SHA256",
                    "description": "TLS 1.3 Ciphers suites represented as defined by U(https://www.openssl.org/docs/man1.1.1/man1/ciphers.html).",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY",
                            "default_value": "TLS_AES_256_GCM_SHA384:TLS_AES_128_GCM_SHA256"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY",
                            "default_value": "TLS_AES_256_GCM_SHA384:TLS_AES_128_GCM_SHA256"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "enable_early_data": {
                    "type": "bool",
                    "default": false,
                    "description": "Enable early data processing for TLS1.3 connections.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "ec_named_curve": {
                    "type": "string",
                    "default": "auto",
                    "description": "Elliptic Curve Cryptography NamedCurves (TLS Supported Groups)represented as defined by RFC 8422-Section 5.1.1 and https://docs.openssl.org/master/man3/SSL_CTX_set1_curves/."
                },
                "signature_algorithm": {
                    "type": "string",
                    "default": "auto",
                    "description": "Signature Algorithms represented as defined by RFC5246-Section 7.4.1.4.1 and https://docs.openssl.org/master/man3/SSL_CTX_set1_sigalgs/."
                },
                "markers": {
                    "type": "message",
                    "messageType": "RoleFilterMatchLabel",
                    "repeated": true,
                    "description": "List of labels to be used for granular RBAC.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "is_federated": {
                    "type": "bool",
                    "default": false,
                    "description": "It Specifies whether the object has to be replicated to the GSLB followers.",
                    "immutable": true
                },
                "description": {
                    "type": "string"
                },
                "tenant_uuid": {
                    "type": "string",
                    "required": true
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                },
                "allow_legacy_renegotiation": {
                    "type": "bool",
                    "default": false,
                    "description": "Allow backend servers to use legacy renegotiation."
                }
            }
        },
        "SSLRating": {
            "fields": {
                "security_score": {
                    "type": "string"
                },
                "performance_rating": {
                    "type": "enum",
                    "enumType": "SSLScore"
                },
                "compatibility_rating": {
                    "type": "enum",
                    "enumType": "SSLScore"
                }
            }
        },
        "Tag": {
            "fields": {
                "value": {
                    "type": "string",
                    "required": true
                },
                "type": {
                    "type": "enum",
                    "enumType": "TagType",
                    "default": "USER_DEFINED"
                }
            },
            "repeatedKey": "value"
        },
        "SSLVersion": {
            "fields": {
                "type": {
                    "type": "enum",
                    "enumType": "SSLVersionType",
                    "default": "SSL_VERSION_TLS1_1",
                    "required": true,
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "SSL_VERSION_TLS1,SSL_VERSION_TLS1_1,SSL_VERSION_TLS1_2"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "SSL_VERSION_TLS1,SSL_VERSION_TLS1_1,SSL_VERSION_TLS1_2"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                }
            },
            "repeatedKey": "type"
        },
        "SSOPolicy": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "description": "UUID of the SSO Policy.",
                    "required": true
                },
                "name": {
                    "type": "string",
                    "description": "Name of the SSO Policy.",
                    "maxStringLength": 256,
                    "required": true
                },
                "authentication_policy": {
                    "type": "message",
                    "messageType": "AuthenticationPolicy",
                    "description": "Authentication Policy Settings"
                },
                "authorization_policy": {
                    "type": "message",
                    "messageType": "AuthorizationPolicy",
                    "description": "Authorization Policy Settings"
                },
                "type": {
                    "type": "enum",
                    "enumType": "SSOPolicyType",
                    "default": "SSO_TYPE_SAML",
                    "description": "SSO Policy Type",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "SSO_TYPE_SAML, SSO_TYPE_JWT, SSO_TYPE_LDAP, SSO_TYPE_OAUTH"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "SSO_TYPE_SAML, SSO_TYPE_JWT, SSO_TYPE_LDAP, SSO_TYPE_OAUTH"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "required": true
                },
                "markers": {
                    "type": "message",
                    "messageType": "RoleFilterMatchLabel",
                    "repeated": true,
                    "description": "List of labels to be used for granular RBAC.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "tenant_uuid": {
                    "type": "string",
                    "description": "UUID of the Tenant.",
                    "required": true
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                }
            }
        },
        "AuthenticationPolicy": {
            "fields": {
                "default_auth_profile_uuid": {
                    "type": "string",
                    "description": "Auth Profile to use for validating users"
                },
                "authn_rules": {
                    "type": "message",
                    "messageType": "AuthenticationRule",
                    "repeated": true,
                    "description": "Add rules to apply auth profile to specific targets."
                }
            }
        },
        "AuthenticationRule": {
            "fields": {
                "name": {
                    "type": "string",
                    "description": "Name of the rule.",
                    "required": true
                },
                "index": {
                    "type": "int32",
                    "description": "Index of the rule.",
                    "required": true
                },
                "enable": {
                    "type": "bool",
                    "default": true,
                    "description": "Enable or disable the rule.",
                    "required": true
                },
                "match": {
                    "type": "message",
                    "messageType": "AuthenticationMatch",
                    "description": "Add match criteria to the rule.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "action": {
                    "type": "message",
                    "messageType": "AuthenticationAction",
                    "description": "Enable or disable authentication for matched targets."
                }
            },
            "repeatedKey": "name"
        },
        "AuthenticationAction": {
            "fields": {
                "type": {
                    "type": "enum",
                    "enumType": "AuthenticationActionEnum",
                    "default": "USE_DEFAULT_AUTHENTICATION",
                    "description": "Authentication Action to be taken for a matched Rule.",
                    "required": true
                }
            }
        },
        "AuthenticationMatch": {
            "fields": {
                "client_ip": {
                    "type": "message",
                    "messageType": "IpAddrMatch",
                    "description": "Configure client ip addresses"
                },
                "path": {
                    "type": "message",
                    "messageType": "PathMatch",
                    "description": "Configure request paths"
                },
                "host_hdr": {
                    "type": "message",
                    "messageType": "HostHdrMatch",
                    "description": "Configure the host header"
                }
            }
        },
        "StaticRoute": {
            "fields": {
                "prefix": {
                    "type": "message",
                    "messageType": "IpAddrPrefix",
                    "required": true
                },
                "next_hop": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "required": true
                },
                "if_name": {
                    "type": "string"
                },
                "route_id": {
                    "type": "string",
                    "required": true
                },
                "disable_gateway_monitor": {
                    "type": "bool",
                    "description": "Disable the gateway monitor for default gateway. They are monitored by default."
                },
                "labels": {
                    "type": "message",
                    "messageType": "KeyValue",
                    "repeated": true,
                    "description": "Labels associated with this route.",
                    "maxRepeatedLength": 1
                }
            },
            "repeatedKey": "route_id"
        },
        "StringGroup": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "required": true,
                    "description": "UUID of the string group"
                },
                "name": {
                    "type": "string",
                    "required": true,
                    "description": "Name of the string group",
                    "maxStringLength": 256
                },
                "kv": {
                    "type": "message",
                    "messageType": "KeyValue",
                    "repeated": true,
                    "description": "Configure Key:Value in the string group"
                },
                "type": {
                    "type": "enum",
                    "enumType": "StringGroupType",
                    "default": "SG_TYPE_STRING",
                    "required": true,
                    "description": "Type of StringGroup."
                },
                "longest_match": {
                    "type": "bool",
                    "default": false,
                    "description": "Enable the longest match, default is the shortest match."
                },
                "markers": {
                    "type": "message",
                    "messageType": "RoleFilterMatchLabel",
                    "repeated": true,
                    "description": "List of labels to be used for granular RBAC.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "description": {
                    "type": "string"
                },
                "tenant_uuid": {
                    "type": "string",
                    "required": true
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                }
            }
        },
        "SysTestEmailParams": {
            "fields": {
                "to_emails": {
                    "type": "string",
                    "required": true,
                    "description": "Alerts are sent to the comma separated list of  email recipients"
                },
                "cc_emails": {
                    "type": "string",
                    "description": "Alerts are copied to the comma separated list of  email recipients"
                },
                "subject": {
                    "type": "string",
                    "required": true,
                    "description": "The Subject line of the originating email from  Avi Controller"
                },
                "text": {
                    "type": "string",
                    "required": true,
                    "description": "The email context"
                }
            }
        },
        "SystemConfiguration": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "required": true
                },
                "dns_configuration": {
                    "type": "message",
                    "messageType": "DNSConfiguration"
                },
                "ntp_configuration": {
                    "type": "message",
                    "messageType": "NTPConfiguration"
                },
                "portal_configuration": {
                    "type": "message",
                    "messageType": "PortalConfiguration"
                },
                "global_tenant_config": {
                    "type": "message",
                    "messageType": "TenantConfiguration"
                },
                "email_configuration": {
                    "type": "message",
                    "messageType": "EmailConfiguration"
                },
                "admin_auth_configuration": {
                    "type": "message",
                    "messageType": "AdminAuthConfiguration"
                },
                "docker_mode": {
                    "type": "bool",
                    "default": false,
                    "immutable": true
                },
                "snmp_configuration": {
                    "type": "message",
                    "messageType": "SnmpConfiguration"
                },
                "linux_configuration": {
                    "type": "message",
                    "messageType": "LinuxConfiguration"
                },
                "proxy_configuration": {
                    "type": "message",
                    "messageType": "ProxyConfiguration"
                },
                "mgmt_ip_access_control": {
                    "type": "message",
                    "messageType": "MgmtIpAccessControl",
                    "description": "Configure Ip Access control for controller to restrict open access."
                },
                "ssh_ciphers": {
                    "type": "string",
                    "repeated": true,
                    "description": "Allowed Ciphers list for SSH to the management interface on the Controller and Service Engines. If this is not specified, all the default ciphers are allowed."
                },
                "ssh_hmacs": {
                    "type": "string",
                    "repeated": true,
                    "description": "Allowed HMAC list for SSH to the management interface on the Controller and Service Engines. If this is not specified, all the default HMACs are allowed."
                },
                "dns_virtualservice_uuids": {
                    "type": "string",
                    "repeated": true,
                    "description": "DNS virtualservices hosting FQDN records for applications across Avi Vantage. If no virtualservices are provided, Avi Vantage will provide DNS services for configured applications. Switching back to Avi Vantage from DNS virtualservices is not allowed.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "default_license_tier": {
                    "type": "enum",
                    "enumType": "LicenseTierType",
                    "default": "ENTERPRISE_WITH_CLOUD_SERVICES",
                    "description": "Specifies the default license tier which would be used by new Clouds.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY",
                            "default_value": "ESSENTIALS"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY",
                            "default_value": "BASIC"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "secure_channel_configuration": {
                    "type": "message",
                    "messageType": "SecureChannelConfiguration",
                    "description": "Configure Secure Channel properties"
                },
                "welcome_workflow_complete": {
                    "type": "bool",
                    "default": false,
                    "description": "This flag is set once the Initial Controller Setup workflow is complete."
                },
                "fips_mode": {
                    "type": "bool",
                    "default": false,
                    "description": "FIPS mode current state.",
                    "immutable": true
                },
                "enable_cors": {
                    "type": "bool",
                    "default": false,
                    "description": "Enable CORS Header.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "common_criteria_mode": {
                    "type": "bool",
                    "default": false,
                    "description": "Common criteria mode's current state.",
                    "immutable": true
                },
                "controller_analytics_policy": {
                    "type": "message",
                    "messageType": "ControllerAnalyticsPolicy",
                    "description": "Controller metrics event dynamic thresholds can be set here. CONTROLLER_CPU_HIGH and CONTROLLER_MEM_HIGH evets can take configured dynamic thresholds."
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                },
                "host_key_algorithm_exclude": {
                    "type": "string",
                    "default": "",
                    "description": "Users can specify comma separated list of deprecated host key algorithm.If nothing is specified, all known algorithms provided by OpenSSH will be supported.This change could only apply on the controller node.",
                    "maxStringLength": 1000
                },
                "kex_algorithm_exclude": {
                    "type": "string",
                    "default": "",
                    "description": "Users can specify comma separated list of deprecated key exchange algorithm.If nothing is specified, all known algorithms provided by OpenSSH will be supported.This change could only apply on the controller node.",
                    "maxStringLength": 1000
                },
                "rekey_volume_limit": {
                    "type": "string",
                    "default": "default",
                    "description": "Users can specify and update the size/volume limit of RekeyLimit in sshd_config.If nothing is specified, the default setting will be default.",
                    "maxStringLength": 255
                },
                "rekey_time_limit": {
                    "type": "string",
                    "default": "none",
                    "description": "Users can specify and update the time limit of RekeyLimit in sshd_config.If nothing is specified, the default setting will be none.",
                    "maxStringLength": 255
                },
                "sddcmanager_fqdn": {
                    "type": "string",
                    "default": "",
                    "description": "FQDN of SDDC Manager in VCF responsible for management of this ALB Controller Cluster",
                    "maxStringLength": 255
                },
                "enable_host_header_check": {
                    "type": "bool",
                    "default": false,
                    "description": "Validates the host header against a list of trusted domains."
                },
                "trusted_host_profiles_uuids": {
                    "type": "string",
                    "repeated": true,
                    "description": "Trusted Host Profiles for host header validation. Only works when host_header_check is set to true.",
                    "maxRepeatedLength": 20,
                    "maxStringLength": 256
                },
                "telemetry_configuration": {
                    "type": "message",
                    "messageType": "TelemetryConfiguration",
                    "description": "Telemetry configuration"
                },
                "truststore_pkiprofile_uuid": {
                    "type": "string",
                    "description": "Reference to PKIProfile used for validating the CA certificates for external comminications from Avi Load Balancer Controller  This acts as trust store for Avi Load Balancer Controller.",
                    "maxStringLength": 256
                },
                "legacy_ssl_support": {
                    "type": "bool",
                    "default": false,
                    "description": "Allow Outgoing Connections from Controller to Servers Using TLS 1.0/1.1"
                },
                "avi_email_login_password": {
                    "type": "string",
                    "description": "Password for avi_email_login user.",
                    "maxStringLength": 256
                },
                "syslog_servers": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "repeated": true,
                    "description": "The destination Syslog server IP(v4/v6) address or FQDN"
                },
                "sync_kex_host_to_se": {
                    "type": "bool",
                    "default": false,
                    "description": "Ability to sync the KexAlgorithms & HostKeyAlgorithms to SEs"
                },
                "sync_syslog_to_se": {
                    "type": "bool",
                    "default": false,
                    "description": "Ability to sync the syslog server config to SEs"
                },
                "license_quota": {
                    "type": "message",
                    "messageType": "QuotaConfig",
                    "description": "License quota for the system.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "enable_license_quota": {
                    "type": "bool",
                    "default": true,
                    "description": "Enable license quota for the system."
                },
                "service_auth_configurations": {
                    "type": "message",
                    "messageType": "ServiceAuthConfiguration",
                    "repeated": true,
                    "description": "Service Auth configurations.",
                    "minRepeatedLength": 0
                },
                "password_policy_managed_at_ops": {
                    "type": "bool",
                    "default": false,
                    "description": "Indicates whether password policy fields are managed by VCF-Ops."
                }
            }
        },
        "ServiceAuthConfiguration": {
            "fields": {
                "index": {
                    "type": "int32",
                    "description": "Index used for maintaining order of ServiceAuthConfiguration.",
                    "required": true
                },
                "auth_profile_uuid": {
                    "type": "string",
                    "description": "UUID of the AuthProfile.",
                    "maxStringLength": 255,
                    "required": true
                },
                "auth_mapping_profile_uuid": {
                    "type": "string",
                    "description": "UUID of the AuthMappingProfile(set of auth mapping rules) to be assigned to a user on successful match.",
                    "maxStringLength": 255,
                    "required": true
                }
            },
            "repeatedKey": "index"
        },
        "TelemetryConfiguration": {
            "fields": {
                "enable": {
                    "type": "bool",
                    "default": true,
                    "description": "Enables VMware Customer Experience Improvement Program ( CEIP ).",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "url": {
                    "type": "string",
                    "default": "https://telemetry.pulse.broadcom.com",
                    "description": "The FQDN or IP address of the Telemetry Server.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ],
                    "maxStringLength": 255
                }
            }
        },
        "ControllerAnalyticsPolicy": {
            "fields": {
                "metrics_event_thresholds": {
                    "type": "message",
                    "messageType": "MetricsEventThreshold",
                    "repeated": true,
                    "description": "Thresholds for various events generated by metrics system."
                }
            }
        },
        "SecureChannelConfiguration": {
            "fields": {
                "sslkeyandcertificate_uuids": {
                    "type": "string",
                    "repeated": true,
                    "description": "Certificate for secure channel. Leave list empty to use system default certs.",
                    "maxRepeatedLength": 1
                }
            }
        },
        "MgmtIpAccessControl": {
            "fields": {
                "ssh_access": {
                    "type": "message",
                    "messageType": "IpAddrMatch",
                    "description": "Configure IP addresses to access controller using SSH"
                },
                "api_access": {
                    "type": "message",
                    "messageType": "IpAddrMatch",
                    "description": "Configure IP addresses to access controller using API"
                },
                "shell_server_access": {
                    "type": "message",
                    "messageType": "IpAddrMatch",
                    "description": "Configure IP addresses to access controller using CLI Shell"
                },
                "snmp_access": {
                    "type": "message",
                    "messageType": "IpAddrMatch",
                    "description": "Configure IP addresses to access controller using SNMP"
                },
                "sysint_access": {
                    "type": "message",
                    "messageType": "IpAddrMatch",
                    "description": "Configure IP addresses to access controller using sysint access"
                }
            }
        },
        "LinuxConfiguration": {
            "fields": {
                "motd": {
                    "type": "string",
                    "default": "",
                    "description": "Message of the day, shown to users on login via the command line interface, web interface, or ssh."
                },
                "banner": {
                    "type": "string",
                    "default": "",
                    "description": "Banner displayed before login to ssh, and UI"
                },
                "cis_mode": {
                    "type": "bool",
                    "default": false,
                    "description": "Enforce CIS benchmark recommendations for Avi Controller and Service Engines. The enforcement is as per CIS DIL 1.0.1 level 2, for applicable controls."
                }
            }
        },
        "SnmpConfiguration": {
            "fields": {
                "community": {
                    "type": "string",
                    "description": "Community string for SNMP v2c"
                },
                "sys_location": {
                    "type": "string",
                    "description": "Sets the sysLocation in system MIB"
                },
                "sys_contact": {
                    "type": "string",
                    "default": "support@avinetworks.com",
                    "description": "Sets the sysContact in system MIB"
                },
                "version": {
                    "type": "enum",
                    "enumType": "SNMP_VER",
                    "default": "SNMP_VER2",
                    "description": "SNMP version support. V2 or V3"
                },
                "snmp_v3_config": {
                    "type": "message",
                    "messageType": "SnmpV3Configuration",
                    "description": "SNMP version 3 configuration"
                },
                "large_trap_payload": {
                    "type": "bool",
                    "default": false,
                    "description": "Support for 4096 bytes trap payload"
                }
            }
        },
        "SnmpV3Configuration": {
            "fields": {
                "user": {
                    "type": "message",
                    "messageType": "SnmpV3UserParams",
                    "description": "SNMP ver 3 user definition"
                },
                "engine_id": {
                    "type": "string",
                    "description": "Engine Id of the Avi Controller SNMP"
                }
            }
        },
        "AdminAuthConfiguration": {
            "fields": {
                "allow_local_user_login": {
                    "type": "bool",
                    "default": true,
                    "description": "Allow any user created locally to login with local credentials"
                },
                "remote_auth_configurations": {
                    "type": "message",
                    "messageType": "RemoteAuthConfiguration",
                    "repeated": true,
                    "description": "Remote Auth configurations.",
                    "minRepeatedLength": 0,
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                }
            }
        },
        "RemoteAuthConfiguration": {
            "fields": {
                "index": {
                    "type": "int32",
                    "description": "Index used for maintaining order of RemoteAuthConfiguration.",
                    "required": true
                },
                "auth_profile_uuid": {
                    "type": "string",
                    "description": "UUID of the auth profile.",
                    "maxStringLength": 255,
                    "required": true
                },
                "auth_mapping_profile_uuid": {
                    "type": "string",
                    "description": "UUID of the AuthMappingProfile(set of auth mapping rules) to be assigned to a user on successful match.",
                    "maxStringLength": 255,
                    "required": true
                }
            },
            "repeatedKey": "index"
        },
        "EmailConfiguration": {
            "fields": {
                "smtp_type": {
                    "type": "enum",
                    "enumType": "SMTPType",
                    "default": "SMTP_LOCAL_HOST",
                    "required": true,
                    "description": "Type of SMTP Mail Service"
                },
                "from_email": {
                    "type": "string",
                    "default": "admin@avicontroller.net",
                    "description": "Email address in From field"
                },
                "mail_server_name": {
                    "type": "string",
                    "default": "localhost",
                    "description": "Mail server FQDN or IP(v4/v6) address"
                },
                "mail_server_port": {
                    "type": "uint32",
                    "default": 25,
                    "description": "Mail server port"
                },
                "auth_username": {
                    "type": "string",
                    "description": "Username for mail server"
                },
                "auth_password": {
                    "type": "string",
                    "description": "Password for mail server"
                },
                "disable_tls": {
                    "type": "bool",
                    "default": false,
                    "description": "When set, disables TLS on the connection to the mail server."
                },
                "email_timezone": {
                    "type": "enum",
                    "enumType": "EmailTimezone",
                    "description": "Timezone for timestamps in alert emails"
                },
                "from_name": {
                    "type": "string",
                    "description": "Friendly name in From field",
                    "maxStringLength": 30
                }
            }
        },
        "TenantConfiguration": {
            "fields": {
                "tenant_vrf": {
                    "type": "bool",
                    "default": false,
                    "description": "When \"Per Tenant IP Domain\" is selected, each tenant gets its own routing domain that is not shared with any other tenant. When \"Share IP Domain across all tenants\" is selected, all tenants share the same routing domain."
                },
                "se_in_provider_context": {
                    "type": "bool",
                    "default": true,
                    "description": "Controls the ownership of ServiceEngines. Service Engines can either be exclusively owned by each tenant or owned by the administrator and shared by all tenants. When ServiceEngines are owned by the administrator, each tenant can have either read access or no access to their Service Engines."
                },
                "tenant_access_to_provider_se": {
                    "type": "bool",
                    "default": true
                },
                "license_quota": {
                    "type": "message",
                    "messageType": "QuotaConfig",
                    "description": "License quota for the tenant.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "app_quota": {
                    "type": "message",
                    "messageType": "AppQuotaConfig",
                    "description": "Application quota for the tenant."
                },
                "enable_tenant_binding": {
                    "type": "bool",
                    "default": false,
                    "description": "Enable tenant binding mode for this tenant. When enabled, only explicitly shared objects from admin tenant will be visible."
                }
            }
        },
        "AppQuotaConfig": {
            "fields": {
                "vs_limit": {
                    "type": "int32",
                    "default": -1,
                    "description": "Maximum number of Virtual Services allowed for this tenant. -1 as Default is maximum value, set to 0 to disallow any VS creation.",
                    "min": -1,
                    "max": 65535
                }
            }
        },
        "PortalConfiguration": {
            "fields": {
                "enable_https": {
                    "type": "bool",
                    "default": true
                },
                "redirect_to_https": {
                    "type": "bool",
                    "default": true
                },
                "enable_http": {
                    "type": "bool",
                    "default": true
                },
                "sslkeyandcertificate_uuids": {
                    "type": "string",
                    "repeated": true,
                    "description": "Certificates for system portal. Maximum 2 allowed. Leave list empty to use system default certs",
                    "maxRepeatedLength": 2
                },
                "use_uuid_from_input": {
                    "type": "bool",
                    "default": false,
                    "description": "Use UUID in POST object data as UUID of the new object, instead of a generated UUID."
                },
                "sslprofile_uuid": {
                    "type": "string",
                    "default": "System-Standard-Portal"
                },
                "enable_clickjacking_protection": {
                    "type": "bool",
                    "default": true,
                    "description": "Enable/Disable Clickjacking protection"
                },
                "allow_basic_authentication": {
                    "type": "bool",
                    "default": false,
                    "description": "Enable/Disable HTTP basic authentication"
                },
                "http_port": {
                    "type": "uint32",
                    "description": "HTTP port",
                    "min": 1,
                    "max": 65535
                },
                "https_port": {
                    "type": "uint32",
                    "description": "HTTPS port",
                    "min": 1,
                    "max": 65535
                },
                "disable_remote_cli_shell": {
                    "type": "bool",
                    "default": false,
                    "description": "Disable Remote CLI Shell Client access"
                },
                "disable_swagger": {
                    "type": "bool",
                    "default": false,
                    "description": "Disable Swagger access"
                },
                "api_force_timeout": {
                    "type": "uint32",
                    "default": 24,
                    "description": "Force API session timeout after the specified time (in hours)",
                    "min": 1,
                    "max": 24
                },
                "pkiprofile_uuid": {
                    "type": "string",
                    "description": "Reference to PKIProfile Config used for CRL validation.",
                    "maxStringLength": 256
                },
                "legacy_ssl_support": {
                    "type": "bool",
                    "default": false,
                    "description": "Allow Incoming Connections from Clients Using TLS 1.0/1.1 to Controller"
                },
                "enable_rate_limiter": {
                    "type": "bool",
                    "default": false,
                    "description": "Feature flag for enabling rate limiter(false by default)"
                }
            }
        },
        "DNSConfiguration": {
            "fields": {
                "server_list": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "repeated": true,
                    "description": "List of DNS Server IP(v4/v6) addresses or FQDNs"
                },
                "search_domain": {
                    "type": "string",
                    "description": "Search domain to use in DNS lookup, multiple domains must be delimited by space only"
                }
            }
        },
        "Tenant": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "required": true
                },
                "name": {
                    "type": "string",
                    "required": true,
                    "maxStringLength": 256
                },
                "local": {
                    "type": "bool",
                    "default": true,
                    "immutable": true
                },
                "description": {
                    "type": "string"
                },
                "config_settings": {
                    "type": "message",
                    "messageType": "TenantConfiguration"
                },
                "created_by": {
                    "type": "string",
                    "description": "Creator of this tenant"
                },
                "enforce_label_group": {
                    "type": "bool",
                    "default": false,
                    "description": "The referred label groups are enforced on the tenant if this is set to true.If this is set to false, the label groups are suggested for the tenant."
                },
                "label_group_uuids": {
                    "type": "string",
                    "repeated": true,
                    "description": "The label_groups to be enforced on the tenant. This is strictly enforced only if enforce_label_group is set to True"
                },
                "attrs": {
                    "type": "message",
                    "messageType": "KeyValue",
                    "repeated": true,
                    "description": "Key/value tenant attributes."
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                },
                "vcf_org_id": {
                    "type": "string",
                    "description": "VCF organization identifier. This field is automatically populated exclusively for tenants associated with VCF organizations.",
                    "maxStringLength": 128
                }
            }
        },
        "TrafficCloneProfile": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "required": true,
                    "description": "UUID of the Traffic Clone Profile."
                },
                "name": {
                    "type": "string",
                    "required": true,
                    "description": "Name for the Traffic Clone Profile.",
                    "maxStringLength": 256
                },
                "clone_servers": {
                    "type": "message",
                    "messageType": "CloneServer",
                    "repeated": true,
                    "maxRepeatedLength": 10,
                    "minRepeatedLength": 0
                },
                "preserve_client_ip": {
                    "type": "bool",
                    "default": false,
                    "description": "Specifies if client IP needs to be preserved to clone destination"
                },
                "markers": {
                    "type": "message",
                    "messageType": "RoleFilterMatchLabel",
                    "repeated": true,
                    "description": "List of labels to be used for granular RBAC.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "tenant_uuid": {
                    "type": "string",
                    "required": true
                },
                "cloud_uuid": {
                    "type": "string",
                    "default": "Default-Cloud",
                    "immutable": true
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                }
            }
        },
        "CloneServer": {
            "fields": {
                "ip_address": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "description": "IP Address of the Clone Server."
                },
                "mac": {
                    "type": "string",
                    "description": "MAC Address of the Clone Server."
                },
                "subnet": {
                    "type": "message",
                    "messageType": "IpAddrPrefix",
                    "description": "Subnet of the network to clone the traffic to"
                },
                "network_uuid": {
                    "type": "string",
                    "description": "Network to clone the traffic to"
                }
            }
        },
        "UpgradeOpsState": {
            "fields": {
                "state": {
                    "type": "enum",
                    "enumType": "UpgradeFsmState",
                    "description": "The upgrade operations current fsm-state."
                },
                "last_changed_time": {
                    "type": "message",
                    "messageType": "TimeStamp",
                    "description": "The last time the state changed."
                },
                "reason": {
                    "type": "string",
                    "description": "Descriptive reason for the state-change."
                },
                "rebooted": {
                    "type": "bool",
                    "description": "State for keeping track of reboot status during upgrade operation.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                }
            }
        },
        "UpgradeParams": {
            "fields": {
                "image_uuid": {
                    "type": "string",
                    "description": "Image uuid for identifying base image."
                },
                "controller_patch_uuid": {
                    "type": "string",
                    "description": "Image uuid for identifying Controller patch."
                },
                "se_patch_uuid": {
                    "type": "string",
                    "description": "Image uuid for identifying Service Engine patch."
                },
                "system": {
                    "type": "bool",
                    "description": "Apply upgrade operations such as Upgrade/Patch to Controller and ALL SE groups."
                },
                "se_group_options": {
                    "type": "message",
                    "messageType": "SeGroupOptions",
                    "description": "This field identifies SE group options that need to be applied during the upgrade operations."
                },
                "se_group_uuids": {
                    "type": "string",
                    "repeated": true,
                    "description": "This field identifies the list of SE groups for which the upgrade operations are applicable.  This field is ignored if the 'system' is enabled."
                },
                "skip_warnings": {
                    "type": "bool",
                    "description": "This is flag when set as true skips few optional must check."
                },
                "prechecks_only": {
                    "type": "bool",
                    "description": "This flag is set to run the pre-checks without the subsequent upgrade operations."
                },
                "dryrun": {
                    "type": "bool",
                    "description": "This flag is set to perform the upgrade dry-run operations."
                }
            }
        },
        "UserAccountProfile": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "required": true
                },
                "name": {
                    "type": "string",
                    "required": true
                },
                "max_concurrent_sessions": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Maximum number of concurrent sessions allowed. There are unlimited sessions by default."
                },
                "complexity_constraint": {
                    "type": "message",
                    "messageType": "ComplexityConstraint",
                    "description": "Password complexity constraints for the user account profile.",
                    "required": true
                },
                "expiration_constraint": {
                    "type": "message",
                    "messageType": "ExpirationConstraint",
                    "description": "Password expiration settings for the user account profile.",
                    "required": true
                },
                "lockout_constraint": {
                    "type": "message",
                    "messageType": "LockoutConstraint",
                    "description": "Account lockout settings for the user account profile.",
                    "required": true
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                }
            }
        },
        "LockoutConstraint": {
            "fields": {
                "lockout_max_auth_failures": {
                    "type": "uint32",
                    "default": 3,
                    "description": "Number of failed attempts before account lockout. Defaults to 3. Setting it to 0 allows unlimited login failure attempts without any lockout.",
                    "min": 0,
                    "max": 5
                },
                "lockout_evaluation_period": {
                    "type": "uint32",
                    "default": 900,
                    "description": "Time window for evaluating failed attempts in seconds. Defaults to 900 seconds.",
                    "min": 300,
                    "max": 1800,
                    "specialValues": {
                        "0": "Do not reset login failure counts on the basis of any evaluation window."
                    }
                },
                "lockout_period": {
                    "type": "uint32",
                    "default": 900,
                    "description": "Account lockout duration in seconds. Defaults to 900 seconds.",
                    "min": 600,
                    "max": 1800
                }
            }
        },
        "ExpirationConstraint": {
            "fields": {
                "password_expiration_days": {
                    "type": "uint32",
                    "default": 365,
                    "description": "Password expiry period in days. Defaults to 365 days.",
                    "min": 30,
                    "max": 730
                }
            }
        },
        "ComplexityConstraint": {
            "fields": {
                "min_length": {
                    "type": "uint32",
                    "default": 15,
                    "description": "Minimum password length. Defaults to 15 characters.",
                    "min": 8,
                    "max": 64
                },
                "min_uppercase": {
                    "type": "uint32",
                    "default": 1,
                    "description": "Minimum number of uppercase characters required.",
                    "min": 0,
                    "max": 10
                },
                "min_lowercase": {
                    "type": "uint32",
                    "default": 1,
                    "description": "Minimum number of lowercase characters required.",
                    "min": 0,
                    "max": 10
                },
                "min_special": {
                    "type": "uint32",
                    "default": 1,
                    "description": "Minimum number of special characters required.",
                    "min": 0,
                    "max": 10
                },
                "min_numeric": {
                    "type": "uint32",
                    "default": 1,
                    "description": "Minimum number of numeric characters required.",
                    "min": 0,
                    "max": 10
                },
                "password_history": {
                    "type": "uint32",
                    "default": 5,
                    "description": "Number of previous passwords to remember. Defaults to 5.",
                    "min": 1,
                    "max": 10
                }
            }
        },
        "VcenterInventoryDiagRsp": {
            "fields": {
                "vcenter_url": {
                    "type": "string"
                },
                "datacenter": {
                    "type": "string"
                },
                "state": {
                    "type": "enum",
                    "enumType": "CloudState"
                },
                "total_hosts": {
                    "type": "int32"
                },
                "errored_hosts": {
                    "type": "int32"
                },
                "hosts": {
                    "type": "message",
                    "messageType": "VcenterHostDiag",
                    "repeated": true
                },
                "networks": {
                    "type": "message",
                    "messageType": "VcenterNetworkDiag"
                }
            }
        },
        "VcenterNetworkDiag": {
            "fields": {
                "mgmt_nw_diag": {
                    "type": "message",
                    "messageType": "VcenterMgmtNwDiag"
                },
                "overlapping_subnets": {
                    "type": "message",
                    "messageType": "OverlappingSubnetInfo",
                    "repeated": true
                }
            }
        },
        "VcenterMgmtNwDiag": {
            "fields": {
                "name": {
                    "type": "string"
                },
                "is_static": {
                    "type": "bool",
                    "default": true,
                    "description": "Static/DHCP mode for vCenter Management Network"
                },
                "static_no_ip_pool": {
                    "type": "bool",
                    "default": false,
                    "description": "Static IP configuration for Management Network"
                },
                "static_subnet_not_present": {
                    "type": "bool",
                    "default": false,
                    "description": "IP subnet for Management Network not provided"
                },
                "static_ip_pool_exhausted": {
                    "type": "bool",
                    "default": false,
                    "description": "Static IP Pool configuration exhausted for Management Network"
                }
            }
        },
        "VcenterHostDiag": {
            "fields": {
                "name": {
                    "type": "string",
                    "required": true
                },
                "powerstate_up": {
                    "type": "bool",
                    "default": true,
                    "description": "ESX Host Power State"
                },
                "maintenance_mode": {
                    "type": "bool",
                    "default": false,
                    "description": "ESX Host Maintenance Mode"
                },
                "connection_state": {
                    "type": "bool",
                    "default": true,
                    "description": "ESX Host connection to vCenter"
                },
                "cntlr_accessible": {
                    "type": "bool",
                    "default": true,
                    "description": "ESX Host accessible from Avi Controller"
                },
                "quarantined": {
                    "type": "bool",
                    "default": false,
                    "description": "ESX Host quarantined from Service Engine Placements"
                }
            }
        },
        "VcenterClusters": {
            "fields": {
                "cluster_uuids": {
                    "type": "string",
                    "repeated": true
                },
                "include": {
                    "type": "bool",
                    "default": false
                }
            }
        },
        "VcenterHosts": {
            "fields": {
                "host_uuids": {
                    "type": "string",
                    "repeated": true
                },
                "include": {
                    "type": "bool",
                    "default": false
                }
            }
        },
        "VCenterServer": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "description": "VCenter config UUID."
                },
                "name": {
                    "type": "string",
                    "description": "vCenter name.",
                    "maxStringLength": 256,
                    "required": true
                },
                "vcenter_url": {
                    "type": "string",
                    "description": "VCenter hostname or IP address."
                },
                "vcenter_credentials_uuid": {
                    "type": "string",
                    "description": "Credentials to access VCenter"
                },
                "content_lib": {
                    "type": "message",
                    "messageType": "ContentLibConfig",
                    "description": "VCenter template to create Service Engine"
                },
                "tenant_uuid": {
                    "type": "string",
                    "description": "VCenter belongs to tenant."
                },
                "cloud_uuid": {
                    "type": "string",
                    "description": "VCenter belongs to cloud.",
                    "immutable": true,
                    "required": true
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                }
            }
        },
        "VIMgrClusterRuntime": {
            "fields": {
                "type": {
                    "type": "enum",
                    "enumType": "CloudType",
                    "required": true
                },
                "uuid": {
                    "type": "string",
                    "required": true
                },
                "name": {
                    "type": "string",
                    "required": true,
                    "maxStringLength": 256
                },
                "managed_object_id": {
                    "type": "string",
                    "required": true
                },
                "datacenter_managed_object_id": {
                    "type": "string"
                },
                "datacenter_uuid": {
                    "type": "string"
                },
                "host_uuids": {
                    "type": "string",
                    "repeated": true
                },
                "tenant_uuid": {
                    "type": "string",
                    "default": "admin"
                },
                "cloud_uuid": {
                    "type": "string",
                    "default": "Default-Cloud"
                }
            }
        },
        "VIMgrHostRuntime": {
            "fields": {
                "type": {
                    "type": "enum",
                    "enumType": "CloudType",
                    "required": true
                },
                "uuid": {
                    "type": "string",
                    "required": true
                },
                "name": {
                    "type": "string",
                    "required": true,
                    "maxStringLength": 256
                },
                "managed_object_id": {
                    "type": "string",
                    "required": true
                },
                "cluster_name": {
                    "type": "string"
                },
                "cluster_uuid": {
                    "type": "string"
                },
                "num_cpu_packages": {
                    "type": "int32"
                },
                "num_cpu_cores": {
                    "type": "int32"
                },
                "num_cpu_threads": {
                    "type": "int32"
                },
                "cpu_hz": {
                    "type": "Unknown"
                },
                "mem": {
                    "type": "Unknown"
                },
                "pnics": {
                    "type": "message",
                    "messageType": "CdpLldpInfo",
                    "repeated": true
                },
                "vm_uuids": {
                    "type": "string",
                    "repeated": true
                },
                "mgmt_portgroup": {
                    "type": "string",
                    "default": ""
                },
                "powerstate": {
                    "type": "string"
                },
                "maintenance_mode": {
                    "type": "bool"
                },
                "connection_state": {
                    "type": "string",
                    "default": "connected"
                },
                "quarantined": {
                    "type": "bool"
                },
                "quarantine_start_ts": {
                    "type": "string"
                },
                "quarantined_periods": {
                    "type": "int32",
                    "default": 1
                },
                "cntlr_accessible": {
                    "type": "bool",
                    "default": true
                },
                "network_uuids": {
                    "type": "string",
                    "repeated": true
                },
                "se_fail_cnt": {
                    "type": "int32"
                },
                "se_success_cnt": {
                    "type": "int32"
                },
                "tenant_uuid": {
                    "type": "string",
                    "default": "admin"
                },
                "cloud_uuid": {
                    "type": "string",
                    "default": "Default-Cloud"
                }
            }
        },
        "CdpLldpInfo": {
            "fields": {
                "switch_info_type": {
                    "type": "enum",
                    "enumType": "PNIC_SWITCH_INFO"
                },
                "device": {
                    "type": "string"
                },
                "chassis": {
                    "type": "string"
                },
                "port": {
                    "type": "string"
                },
                "mgmtaddr": {
                    "type": "string"
                },
                "system_name": {
                    "type": "string"
                }
            }
        },
        "VipAutoscalePolicy": {
            "fields": {
                "min_size": {
                    "type": "uint32",
                    "default": 1,
                    "description": "The minimum size of the group."
                },
                "max_size": {
                    "type": "uint32",
                    "default": 5,
                    "description": "The maximum size of the group."
                },
                "dns_cooldown": {
                    "type": "uint32",
                    "default": 60,
                    "description": "The amount of time, in seconds, when a Vip is withdrawn before a scaling activity starts."
                },
                "suspend": {
                    "type": "bool",
                    "default": false,
                    "description": "When set, scaling is suspended."
                }
            }
        },
        "VirtualService": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "required": true,
                    "description": "UUID of the VirtualService."
                },
                "name": {
                    "type": "string",
                    "required": true,
                    "description": "Name for the Virtual Service.",
                    "maxStringLength": 256
                },
                "fqdn": {
                    "type": "string",
                    "description": "DNS resolvable, fully qualified domain name of the virtualservice. Only one of 'fqdn' and 'dns_info' configuration is allowed.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "enabled": {
                    "type": "bool",
                    "default": true,
                    "description": "Enable or disable the Virtual Service."
                },
                "services": {
                    "type": "message",
                    "messageType": "Service",
                    "repeated": true,
                    "description": "List of Services defined for this Virtual Service.",
                    "maxRepeatedLength": 2048,
                    "minRepeatedLength": 0
                },
                "application_profile_uuid": {
                    "type": "string",
                    "default": "System-HTTP",
                    "description": "Enable application layer specific features for the Virtual Service.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY",
                            "default_value": "System-L4-Application"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "network_profile_uuid": {
                    "type": "string",
                    "default": "System-TCP-Proxy",
                    "description": "Determines network settings such as protocol, TCP or UDP, and related options for the protocol.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY",
                            "default_value": "System-TCP-Fast-Path"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "server_network_profile_uuid": {
                    "type": "string",
                    "description": "Determines the network settings profile for the server side of TCP proxied connections.  Leave blank to use the same settings as the client to VS side of the connection.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "pool_uuid": {
                    "type": "string",
                    "description": "The pool is an object that contains destination servers and related attributes such as load-balancing and persistence."
                },
                "se_group_uuid": {
                    "type": "string",
                    "description": "The Service Engine Group to use for this Virtual Service. Moving to a new SE Group is disruptive to existing connections for this VS."
                },
                "network_security_policy_uuid": {
                    "type": "string",
                    "description": "Network security policies for the Virtual Service."
                },
                "http_policies": {
                    "type": "message",
                    "messageType": "HTTPPolicies",
                    "repeated": true,
                    "description": "HTTP Policies applied on the data traffic of the Virtual Service"
                },
                "dns_policies": {
                    "type": "message",
                    "messageType": "DnsPolicies",
                    "repeated": true,
                    "description": "DNS Policies applied on the dns traffic of the Virtual Service",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "security_policy_uuid": {
                    "type": "string",
                    "description": "Security policy applied on the traffic of the Virtual Service. This policy is used to perform security actions such as Distributed Denial of Service (DDoS) attack mitigation, etc.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "ssl_key_and_certificate_uuids": {
                    "type": "string",
                    "repeated": true,
                    "description": "Select or create one or two certificates, EC and/or RSA, that will be presented to SSL/TLS terminated connections."
                },
                "ssl_profile_uuid": {
                    "type": "string",
                    "description": "Determines the set of SSL versions and ciphers to accept for SSL/TLS terminated connections."
                },
                "performance_limits": {
                    "type": "message",
                    "messageType": "PerformanceLimits",
                    "description": "Optional settings that determine performance limits like max connections or bandwdith etc."
                },
                "analytics_policy": {
                    "type": "message",
                    "messageType": "AnalyticsPolicy",
                    "description": "Determines analytics settings for the application."
                },
                "vrf_context_uuid": {
                    "type": "string",
                    "description": "Virtual Routing Context that the Virtual Service is bound to. This is used to provide the isolation of the set of networks the application is attached to."
                },
                "enable_autogw": {
                    "type": "bool",
                    "default": true,
                    "description": "Response traffic to clients will be sent back to the source MAC address of the connection, rather than statically sent to a default gateway.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false",
                            "default_value": false
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false",
                            "default_value": false
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "analytics_profile_uuid": {
                    "type": "string",
                    "default": "System-Analytics-Profile",
                    "description": "Specifies settings related to analytics."
                },
                "host_name_xlate": {
                    "type": "string",
                    "description": "Translate the host name sent to the servers to this value.  Translate the host name sent from servers back to the value used by the client.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "vs_datascripts": {
                    "type": "message",
                    "messageType": "VSDataScripts",
                    "repeated": true,
                    "description": "Datascripts applied on the data traffic of the Virtual Service",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "weight": {
                    "type": "uint32",
                    "default": 1,
                    "description": "The Quality of Service weight to assign to traffic transmitted from this Virtual Service.  A higher weight will prioritize traffic versus other Virtual Services sharing the same Service Engines.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "1"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "1"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 1,
                    "max": 128
                },
                "delay_fairness": {
                    "type": "bool",
                    "default": false,
                    "description": "Select the algorithm for QoS fairness.  This determines how multiple Virtual Services sharing the same Service Engines will prioritize traffic over a congested network.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "max_cps_per_client": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Maximum connections per second per client IP.",
                    "min": 10,
                    "max": 1000,
                    "specialValues": {
                        "0": "unlimited"
                    }
                },
                "limit_doser": {
                    "type": "bool",
                    "default": false,
                    "description": "Limit potential DoS attackers who exceed max_cps_per_client significantly to a fraction of max_cps_per_client for a while."
                },
                "type": {
                    "type": "enum",
                    "enumType": "VirtualServiceType",
                    "default": "VS_TYPE_NORMAL",
                    "description": "Specify if this is a normal Virtual Service, or if it is the parent or child of an SNI-enabled virtual hosted Virtual Service.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "VS_TYPE_NORMAL"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "VS_TYPE_NORMAL,VS_TYPE_VH_PARENT"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "immutable": true
                },
                "vh_parent_vs_uuid": {
                    "type": "string",
                    "description": "Specifies the Virtual Service acting as Virtual Hosting (SNI) parent."
                },
                "vh_domain_name": {
                    "type": "string",
                    "repeated": true,
                    "description": "The exact name requested from the client's SNI-enabled TLS hello domain name field. If this is a match, the parent VS will forward the connection to this child VS."
                },
                "cloud_type": {
                    "type": "enum",
                    "enumType": "CloudType",
                    "default": "CLOUD_NONE",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "CLOUD_NONE,CLOUD_VCENTER"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "CLOUD_NONE,CLOUD_NSXT"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "connections_rate_limit": {
                    "type": "message",
                    "messageType": "RateProfile",
                    "description": "Rate limit the incoming connections to this virtual service",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "requests_rate_limit": {
                    "type": "message",
                    "messageType": "RateProfile",
                    "description": "Rate limit the incoming requests to this virtual service",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "use_bridge_ip_as_vip": {
                    "type": "bool",
                    "default": false,
                    "description": "Use Bridge IP as VIP on each Host in Mesos deployments",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "flow_dist": {
                    "type": "enum",
                    "enumType": "SeFlowDist",
                    "default": "LOAD_AWARE",
                    "description": "Criteria for flow distribution among SEs.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "LOAD_AWARE"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "LOAD_AWARE"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "ign_pool_net_reach": {
                    "type": "bool",
                    "default": false,
                    "description": "Ignore Pool servers network reachability constraints for Virtual Service placement."
                },
                "ssl_sess_cache_avg_size": {
                    "type": "uint32",
                    "default": 1024,
                    "description": "Expected number of SSL session cache entries (may be exceeded).",
                    "min": 1024,
                    "max": 16383
                },
                "pool_group_uuid": {
                    "type": "string",
                    "description": "The pool group is an object that contains pools.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "remove_listening_port_on_vs_down": {
                    "type": "bool",
                    "default": false,
                    "description": "Remove listening port if VirtualService is down"
                },
                "close_client_conn_on_config_update": {
                    "type": "bool",
                    "default": false,
                    "description": "close client connection on vs config update",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "bulk_sync_kvcache": {
                    "type": "bool",
                    "default": false,
                    "description": "(This is a beta feature). Sync Key-Value cache to the new SEs when VS is scaled out. For ex: SSL sessions are stored using VS's Key-Value cache. When the VS is scaled out, the SSL session information is synced to the new SE, allowing existing SSL sessions to be reused on the new SE. ",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "topology_policies": {
                    "type": "message",
                    "messageType": "DnsPolicies",
                    "repeated": true,
                    "description": "Topology Policies applied on the dns traffic of the Virtual Service based onGSLB Topology algorithm",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "advertise_down_vs": {
                    "type": "bool",
                    "default": false,
                    "description": "Keep advertising Virtual Service via BGP even if it is marked down by health monitor. This setting takes effect for future Virtual Service flaps. To advertise current VSes that are down, please disable and re-enable the Virtual Service.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "revoke_vip_route": {
                    "type": "bool",
                    "default": false,
                    "description": "Revoke the advertisement of Virtual Service via the cloud if it is marked down by health monitor. Supported for NSXT clouds only.This setting takes effect for future Virtual Service flaps. To advertise current VSes that are down, please disable and re-enable the Virtual Service."
                },
                "description": {
                    "type": "string"
                },
                "tenant_uuid": {
                    "type": "string",
                    "required": true
                },
                "cloud_uuid": {
                    "type": "string",
                    "default": "Default-Cloud",
                    "immutable": true
                },
                "east_west_placement": {
                    "type": "bool",
                    "default": false,
                    "description": "Force placement on all SE's in service group (Mesos mode only)",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "scaleout_ecmp": {
                    "type": "bool",
                    "default": false,
                    "description": "Disable re-distribution of flows across service engines for a virtual service. Enable if the network itself performs flow hashing with ECMP in environments such as GCP"
                },
                "microservice_uuid": {
                    "type": "string",
                    "description": "Microservice representing the virtual service",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "service_pool_select": {
                    "type": "message",
                    "messageType": "ServicePoolSelector",
                    "repeated": true,
                    "description": "Select pool based on destination port",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "created_by": {
                    "type": "string",
                    "description": "Creator name"
                },
                "cloud_config_cksum": {
                    "type": "string",
                    "description": "Checksum of cloud configuration for VS. Internally set by cloud connector"
                },
                "enable_rhi": {
                    "type": "bool",
                    "description": "Enable Route Health Injection using the BGP Config in the vrf context",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "snat_ip": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "repeated": true,
                    "description": "NAT'ted floating source IP Address(es) for upstream connection to servers",
                    "maxRepeatedLength": 32,
                    "minRepeatedLength": 0,
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "active_standby_se_tag": {
                    "type": "enum",
                    "enumType": "ActiveStandbySeTag",
                    "default": "ACTIVE_STANDBY_SE_1",
                    "description": "This configuration only applies if the VirtualService is in Legacy Active Standby HA mode and Load Distribution among Active Standby is enabled. This field is used to tag the VirtualService so that VirtualServices with the same tag will share the same Active ServiceEngine. VirtualServices with different tags will have different Active ServiceEngines. If one of the ServiceEngine's in the ServiceEngineGroup fails, all VirtualServices will end up using the same Active ServiceEngine. Redistribution of the VirtualServices can be either manual or automated when the failed ServiceEngine recovers. Redistribution is based on the auto redistribute property of the ServiceEngineGroup."
                },
                "flow_label_type": {
                    "type": "enum",
                    "enumType": "FlowLabelType",
                    "default": "NO_LABEL",
                    "description": "Criteria for flow labelling."
                },
                "enable_rhi_snat": {
                    "type": "bool",
                    "description": "Enable Route Health Injection for Source NAT'ted floating IP Address using the BGP Config in the vrf context",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "static_dns_records": {
                    "type": "message",
                    "messageType": "DnsRecord",
                    "repeated": true,
                    "description": "List of static DNS records applied to this Virtual Service. These are static entries and no health monitoring is performed against the IP addresses.",
                    "maxRepeatedLength": 2000,
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "dns_info": {
                    "type": "message",
                    "messageType": "DnsInfo",
                    "repeated": true,
                    "description": "Service discovery specific data including fully qualified domain name, type and Time-To-Live of the DNS record. Note that only one of fqdn and dns_info setting is allowed.",
                    "maxRepeatedLength": 1000,
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "service_metadata": {
                    "type": "string",
                    "description": "Metadata pertaining to the Service provided by this virtual service. In Openshift/Kubernetes environments, egress pod info is stored. Any user input to this field will be overwritten by Avi Vantage."
                },
                "traffic_clone_profile_uuid": {
                    "type": "string",
                    "description": "Server network or list of servers for cloning traffic.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "content_rewrite": {
                    "type": "message",
                    "messageType": "ContentRewriteProfile",
                    "description": "Profile used to match and rewrite strings in request and/or response body.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "sideband_profile": {
                    "type": "message",
                    "messageType": "SidebandProfile",
                    "description": "Sideband configuration to be used for this virtualservice.It can be used for sending traffic to sideband VIPs for external inspection etc.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "vip": {
                    "type": "message",
                    "messageType": "Vip",
                    "repeated": true,
                    "description": "List of Virtual Service IPs. While creating a 'Shared VS',please use vsvip_ref to point to the shared entities."
                },
                "vsvip_uuid": {
                    "type": "string",
                    "description": "Mostly used during the creation of Shared VS, this field refers to entities that can be shared across Virtual Services."
                },
                "waf_policy_uuid": {
                    "type": "string",
                    "description": "WAF policy for the Virtual Service.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "sp_pool_uuids": {
                    "type": "string",
                    "repeated": true,
                    "description": "GSLB pools used to manage site-persistence functionality. Each site-persistence pool contains the virtualservices in all the other sites, that is auto-generated by the GSLB manager. This is a read-only field for the user."
                },
                "use_vip_as_snat": {
                    "type": "bool",
                    "default": false,
                    "description": "Use the Virtual IP as the SNAT IP for health monitoring and sending traffic to the backend servers instead of the Service Engine interface IP. The caveat of enabling this option is that the VirtualService cannot be configued in an Active-Active HA mode. DNS based Multi VIP solution has to be used for HA & Non-disruptive Upgrade purposes.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "error_page_profile_uuid": {
                    "type": "string",
                    "description": "Error Page Profile to be used for this virtualservice.This profile is used to send the custom error page to the client generated by the proxy"
                },
                "l4_policies": {
                    "type": "message",
                    "messageType": "L4Policies",
                    "repeated": true,
                    "description": "L4 Policies applied to the data traffic of the Virtual Service"
                },
                "traffic_enabled": {
                    "type": "bool",
                    "default": true,
                    "description": "Knob to enable the Virtual Service traffic on its assigned service engines. This setting is effective only when the enabled flag is set to True."
                },
                "bgp_peer_labels": {
                    "type": "string",
                    "repeated": true,
                    "description": "Select BGP peers, using peer label, for VsVip advertisement.",
                    "maxRepeatedLength": 128,
                    "maxStringLength": 128
                },
                "markers": {
                    "type": "message",
                    "messageType": "RoleFilterMatchLabel",
                    "repeated": true,
                    "description": "List of labels to be used for granular RBAC.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "bgp_local_preference": {
                    "type": "uint32",
                    "description": "LOCAL_PREF to be used for VsVip advertised. Applicable only over iBGP."
                },
                "bgp_num_as_path_prepend": {
                    "type": "uint32",
                    "description": "Number of times the local AS should be prepended additionally to VsVip. Applicable only over eBGP",
                    "min": 1,
                    "max": 10
                },
                "vsvip_cloud_config_cksum": {
                    "type": "string",
                    "description": "Checksum of cloud configuration for VsVip. Internally set by cloud connector"
                },
                "azure_availability_set": {
                    "type": "string",
                    "description": "(internal-use)Applicable for Azure only. Azure Availability set to which this VS is associated. Internally set by the cloud connector"
                },
                "min_pools_up": {
                    "type": "uint32",
                    "description": "Minimum number of UP pools to mark VS up."
                },
                "allow_invalid_client_cert": {
                    "type": "bool",
                    "default": false,
                    "description": "Process request even if invalid client certificate is presented. Datascript APIs need to be used for processing of such requests.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "ssl_profile_selectors": {
                    "type": "message",
                    "messageType": "SSLProfileSelector",
                    "repeated": true,
                    "description": "Select SSL Profile based on client IP address match.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "sso_policy_uuid": {
                    "type": "string",
                    "description": "The SSO Policy attached to the virtualservice.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "saml_sp_config": {
                    "type": "message",
                    "messageType": "SAMLSPConfig",
                    "description": "Application-specific SAML config.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "test_se_datastore_level_1_uuid": {
                    "type": "string",
                    "description": "Used for testing SE Datastore Upgrade 2.0 functionality"
                },
                "icap_request_profile_uuids": {
                    "type": "string",
                    "repeated": true,
                    "description": "The config settings for the ICAP server when checking the HTTP request.",
                    "maxRepeatedLength": 1,
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "jwt_config": {
                    "type": "message",
                    "messageType": "JWTValidationVsConfig",
                    "description": "Application-specific config for JWT validation."
                },
                "vh_matches": {
                    "type": "message",
                    "messageType": "VHMatch",
                    "repeated": true,
                    "description": "Match criteria to select this child VS."
                },
                "vh_type": {
                    "type": "enum",
                    "enumType": "VHType",
                    "default": "VS_TYPE_VH_SNI",
                    "description": "Specify if the Virtual Hosting VS is of type SNI or Enhanced.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "VS_TYPE_VH_SNI,VS_TYPE_VH_ENHANCED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ],
                    "immutable": true
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                },
                "bot_policy_uuid": {
                    "type": "string",
                    "description": "Bot detection policy for the Virtual Service.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "ldap_vs_config": {
                    "type": "message",
                    "messageType": "LDAPVSConfig",
                    "description": "Application-specific LDAP config.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "oauth_vs_config": {
                    "type": "message",
                    "messageType": "OAuthVSConfig",
                    "description": "VirtualService specific OAuth config.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "enable_session": {
                    "type": "bool",
                    "default": false,
                    "description": "Enable HTTP sessions for this virtual service. If enabled, a session cookie will be added to HTTP responses and persistent key-value store will be activated."
                },
                "csrf_policy_uuid": {
                    "type": "string",
                    "description": "CSRF Protection policy for the Virtual Service.",
                    "maxStringLength": 128
                },
                "snat_ip6_addresses": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "repeated": true,
                    "description": "IPV6 address for SE snat",
                    "maxRepeatedLength": 32,
                    "minRepeatedLength": 0,
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "application_insights_uuid": {
                    "type": "string",
                    "description": "Application Insights Configuration for the Virtual Service to learn application data.",
                    "maxStringLength": 128
                },
                "positive_security_uuid": {
                    "type": "string",
                    "description": "Positive Security Configuration for the Virtual Service to generate rules from the application data.",
                    "maxStringLength": 128
                }
            }
        },
        "OAuthVSConfig": {
            "fields": {
                "redirect_uri": {
                    "type": "string",
                    "description": "Redirect URI specified in the request to Authorization Server.",
                    "maxStringLength": 300
                },
                "cookie_name": {
                    "type": "string",
                    "description": "HTTP cookie name for authorized session.",
                    "maxStringLength": 128
                },
                "cookie_timeout": {
                    "type": "int32",
                    "default": 60,
                    "description": "HTTP cookie timeout for authorized session.",
                    "min": 1,
                    "max": 1440
                },
                "oauth_settings": {
                    "type": "message",
                    "messageType": "OAuthSettings",
                    "repeated": true,
                    "description": "Application and IDP settings for OAuth/OIDC.",
                    "maxRepeatedLength": 1
                },
                "key": {
                    "type": "message",
                    "messageType": "HttpCookiePersistenceKey",
                    "repeated": true,
                    "description": "Key to generate the cookie."
                },
                "logout_uri": {
                    "type": "string",
                    "description": "URI which triggers OAuth logout.",
                    "maxStringLength": 300
                },
                "post_logout_redirect_uri": {
                    "type": "string",
                    "description": "URI to which IDP will redirect to after the logout.",
                    "maxStringLength": 300
                }
            }
        },
        "OAuthSettings": {
            "fields": {
                "auth_profile_uuid": {
                    "type": "string",
                    "description": "Auth Profile to use for validating users",
                    "maxStringLength": 128,
                    "required": true
                },
                "app_settings": {
                    "type": "message",
                    "messageType": "OAuthAppSettings",
                    "description": "Application-specific OAuth config."
                },
                "resource_server": {
                    "type": "message",
                    "messageType": "OAuthResourceServer",
                    "description": "Resource Server OAuth config."
                }
            },
            "repeatedKey": "auth_profile_uuid"
        },
        "OAuthResourceServer": {
            "fields": {
                "access_type": {
                    "type": "enum",
                    "enumType": "AccessTokenType",
                    "default": "ACCESS_TOKEN_TYPE_JWT",
                    "description": "Access token type.",
                    "required": true
                },
                "opaque_token_params": {
                    "type": "message",
                    "messageType": "OpaqueTokenValidationParams",
                    "description": "Validation parameters to be used when access token type is opaque."
                },
                "jwt_params": {
                    "type": "message",
                    "messageType": "JWTValidationParams",
                    "description": "Validation parameters to be used when access token type is JWT."
                },
                "introspection_data_timeout": {
                    "type": "int32",
                    "default": 0,
                    "description": "Lifetime of the cached introspection data.",
                    "min": 0,
                    "max": 1440,
                    "specialValues": {
                        "0": "No caching of introspection data"
                    }
                }
            }
        },
        "JWTValidationParams": {
            "fields": {
                "audience": {
                    "type": "string",
                    "description": "Audience parameter used for validation using JWT token.",
                    "maxStringLength": 128
                }
            }
        },
        "OpaqueTokenValidationParams": {
            "fields": {
                "server_id": {
                    "type": "string",
                    "description": "Resource server specific identifier used to validate against introspection endpoint when access token is opaque.",
                    "maxStringLength": 128,
                    "required": true
                },
                "server_secret": {
                    "type": "string",
                    "description": "Resource server specific password/secret.",
                    "maxStringLength": 128,
                    "required": true
                }
            }
        },
        "LDAPVSConfig": {
            "fields": {
                "realm": {
                    "type": "string",
                    "description": "Basic authentication realm to present to a user along with the prompt for credentials."
                },
                "se_auth_ldap_cache_size": {
                    "type": "uint32",
                    "default": 100000,
                    "description": "Size of LDAP auth credentials cache used on the dataplane."
                },
                "se_auth_ldap_conns_per_server": {
                    "type": "uint32",
                    "default": 1,
                    "description": "Number of concurrent connections to LDAP server by a single basic auth LDAP process."
                },
                "se_auth_ldap_connect_timeout": {
                    "type": "uint32",
                    "default": 10000,
                    "description": "Default connection timeout enforced on connections to LDAP server."
                },
                "se_auth_ldap_reconnect_timeout": {
                    "type": "uint32",
                    "default": 10000,
                    "description": "Default reconnect timeout enforced on connections to LDAP server."
                },
                "se_auth_ldap_bind_timeout": {
                    "type": "uint32",
                    "default": 5000,
                    "description": "Default bind timeout enforced on connections to LDAP server."
                },
                "se_auth_ldap_request_timeout": {
                    "type": "uint32",
                    "default": 10000,
                    "description": "Default login or group search request timeout enforced on connections to LDAP server."
                },
                "se_auth_ldap_servers_failover_only": {
                    "type": "bool",
                    "default": false,
                    "description": "If enabled, connections are always made to the first available LDAP server in the list and will failover to subsequent servers."
                }
            }
        },
        "VHMatch": {
            "fields": {
                "host": {
                    "type": "string",
                    "description": "Host/domain name match configuration.",
                    "required": true
                },
                "rules": {
                    "type": "message",
                    "messageType": "VHMatchRule",
                    "repeated": true,
                    "description": "Add rules for selecting the virtual service. At least one rule must be configured.",
                    "minRepeatedLength": 1
                }
            }
        },
        "VHMatchRule": {
            "fields": {
                "name": {
                    "type": "string",
                    "description": "Name for the match rule.",
                    "maxStringLength": 256,
                    "required": true
                },
                "matches": {
                    "type": "message",
                    "messageType": "MatchTarget",
                    "description": "Match criteria for selecting the virtual service.",
                    "required": true
                }
            },
            "repeatedKey": "name"
        },
        "JWTValidationVsConfig": {
            "fields": {
                "jwt_location": {
                    "type": "enum",
                    "enumType": "JWTLocation",
                    "default": "JWT_LOCATION_AUTHORIZATION_HEADER",
                    "description": "Defines where to look for JWT in the request.",
                    "required": true
                },
                "jwt_name": {
                    "type": "string",
                    "description": "Name by which the JWT can be identified if the token is sent as a query param in the request url."
                },
                "audience": {
                    "type": "string",
                    "description": "Uniquely identifies a resource server. This is used to validate against the aud claim."
                },
                "protected_resource": {
                    "type": "string",
                    "description": "The protected resource identifier. This is a URL that uniquely identifies the protected resource. Typically the base URL of the API/service.",
                    "maxStringLength": 1024
                },
                "protected_resource_name": {
                    "type": "string",
                    "description": "Human-readable name of the protected resource.",
                    "maxStringLength": 256
                }
            }
        },
        "SAMLSPConfig": {
            "fields": {
                "entity_id": {
                    "type": "string",
                    "description": "Globally unique SAML entityID for this node. The SAML application entity ID on the IDP should match this.",
                    "required": true
                },
                "single_signon_url": {
                    "type": "string",
                    "description": "SAML Single Signon endpoint to receive the Authentication response. This also specifies the destination endpoint to be configured for this application on the IDP. If the authn_req_acs_type is set to 'Use AssertionConsumerServiceURL', this endpoint will be sent in the AssertionConsumerServiceURL attribute of the Authentication request.",
                    "required": true
                },
                "sp_metadata": {
                    "type": "string",
                    "description": "SAML SP metadata for this application."
                },
                "key": {
                    "type": "message",
                    "messageType": "HttpCookiePersistenceKey",
                    "repeated": true,
                    "description": "Key to generate the cookie."
                },
                "cookie_timeout": {
                    "type": "int32",
                    "default": 60,
                    "description": "Cookie timeout in minutes.",
                    "min": 1,
                    "max": 1440
                },
                "cookie_name": {
                    "type": "string",
                    "description": "HTTP cookie name for authenticated session.",
                    "maxStringLength": 128
                },
                "signing_ssl_key_and_certificate_uuid": {
                    "type": "string",
                    "description": "SP will use this SSL certificate to sign requests going to the IdP and decrypt the assertions coming from IdP."
                },
                "use_idp_session_timeout": {
                    "type": "bool",
                    "description": "By enabling this field IdP can control how long the SP session can exist through the SessionNotOnOrAfter field in the AuthNStatement of SAML Response."
                },
                "authn_req_acs_type": {
                    "type": "enum",
                    "enumType": "SAMLAuthNRequestACSType",
                    "default": "SAML_AUTHN_REQ_ACS_TYPE_NONE",
                    "description": "Option to set the ACS attributes in the AuthnRequest ",
                    "required": true
                },
                "acs_index": {
                    "type": "int32",
                    "default": 0,
                    "description": "Index to be used in the AssertionConsumerServiceIndex attribute of the Authentication request, if the authn_req_acs_type is set to Use AssertionConsumerServiceIndex",
                    "min": 0,
                    "max": 64
                }
            }
        },
        "SSLProfileSelector": {
            "fields": {
                "client_ip_list": {
                    "type": "message",
                    "messageType": "IpAddrMatch",
                    "description": "Configure client IP address groups.",
                    "required": true
                },
                "ssl_profile_uuid": {
                    "type": "string",
                    "description": "SSL profile for the client IP addresses listed.",
                    "required": true
                }
            },
            "repeatedKey": "client_ip_list"
        },
        "L4Policies": {
            "fields": {
                "index": {
                    "type": "int32",
                    "description": "Index of the virtual service L4 policy set",
                    "required": true
                },
                "l4_policy_set_uuid": {
                    "type": "string",
                    "description": "ID of the virtual service L4 policy set",
                    "required": true
                }
            },
            "repeatedKey": "index"
        },
        "Vip": {
            "fields": {
                "vip_id": {
                    "type": "string",
                    "description": "Unique ID associated with the vip.",
                    "maxStringLength": 16,
                    "required": true
                },
                "ip_address": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "description": "IPv4 Address of the VIP."
                },
                "enabled": {
                    "type": "bool",
                    "default": true,
                    "description": "Enable or disable the Vip."
                },
                "network_uuid": {
                    "type": "string",
                    "description": "Manually override the network on which the Vip is placed."
                },
                "port_uuid": {
                    "type": "string",
                    "description": "(internal-use) Network port assigned to the Vip IP address."
                },
                "subnet_uuid": {
                    "type": "string",
                    "description": "If auto_allocate_ip is True, then the subnet for the Vip IP address allocation. This field is applicable only if the VirtualService belongs to an Openstack or AWS cloud, in which case it is mandatory, if auto_allocate is selected."
                },
                "subnet": {
                    "type": "message",
                    "messageType": "IpAddrPrefix",
                    "description": "Subnet providing reachability for client facing Vip IP."
                },
                "discovered_networks": {
                    "type": "message",
                    "messageType": "DiscoveredNetwork",
                    "repeated": true,
                    "description": "Discovered networks providing reachability for client facing Vip IP."
                },
                "availability_zone": {
                    "type": "string",
                    "description": "Availability-zone to place the Virtual Service.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "auto_allocate_ip": {
                    "type": "bool",
                    "default": false,
                    "description": "Auto-allocate VIP from the provided subnet."
                },
                "floating_ip": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "description": "Floating IPv4 to associate with this Vip.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "auto_allocate_floating_ip": {
                    "type": "bool",
                    "default": false,
                    "description": "Auto-allocate floating/elastic IP from the Cloud infrastructure.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "floating_subnet_uuid": {
                    "type": "string",
                    "description": "If auto_allocate_floating_ip is True and more than one floating-ip subnets exist, then the subnet for the floating IP address allocation.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "avi_allocated_vip": {
                    "type": "bool",
                    "default": false,
                    "description": "(internal-use) VIP allocated by Avi in the Cloud infrastructure.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "avi_allocated_fip": {
                    "type": "bool",
                    "default": false,
                    "description": "(internal-use) FIP allocated by Avi in the Cloud infrastructure.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "ipam_network_subnet": {
                    "type": "message",
                    "messageType": "IPNetworkSubnet",
                    "description": "Subnet and/or Network for allocating VirtualService IP by IPAM Provider module."
                },
                "ip6_address": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "description": "IPv6 Address of the Vip."
                },
                "subnet6_uuid": {
                    "type": "string",
                    "description": "If auto_allocate_ip is True, then the subnet for the Vip IPv6 address allocation. This field is applicable only if the VirtualService belongs to an Openstack or AWS cloud, in which case it is mandatory, if auto_allocate is selected.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "subnet6": {
                    "type": "message",
                    "messageType": "IpAddrPrefix",
                    "description": "Subnet providing reachability for client facing Vip IPv6.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "floating_ip6": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "description": "Floating IPv6 address to associate with this Vip.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "floating_subnet6_uuid": {
                    "type": "string",
                    "description": "If auto_allocate_floating_ip is True and more than one floating-ip subnets exist, then the subnet for the floating IPv6 address allocation.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "auto_allocate_ip_type": {
                    "type": "enum",
                    "enumType": "IpAddressVersions",
                    "default": "V4_ONLY",
                    "description": "Specifies whether to auto-allocate only a V4 address, only a V6 address, or one of each type.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "V4_ONLY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "V4_ONLY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "placement_networks": {
                    "type": "message",
                    "messageType": "VipPlacementNetwork",
                    "repeated": true,
                    "description": "Placement networks/subnets to use for vip placement.",
                    "maxRepeatedLength": 10
                },
                "prefix_length": {
                    "type": "uint32",
                    "default": 32,
                    "description": "Mask applied for the Vip, non-default mask supported only for wildcard Vip.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "32"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "32"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ],
                    "min": 0,
                    "max": 32
                }
            },
            "repeatedKey": "vip_id"
        },
        "VipPlacementNetwork": {
            "fields": {
                "network_uuid": {
                    "type": "string",
                    "description": "Network to use for vip placement."
                },
                "subnet": {
                    "type": "message",
                    "messageType": "IpAddrPrefix",
                    "description": "IPv4 Subnet to use for vip placement."
                },
                "subnet6": {
                    "type": "message",
                    "messageType": "IpAddrPrefix",
                    "description": "IPv6 subnet to use for vip placement."
                }
            }
        },
        "IPNetworkSubnet": {
            "fields": {
                "network_uuid": {
                    "type": "string",
                    "description": "Network for VirtualService IP allocation with Vantage as the IPAM provider. Network should be created before this is configured."
                },
                "subnet": {
                    "type": "message",
                    "messageType": "IpAddrPrefix",
                    "description": "Subnet for VirtualService IP allocation with Vantage or Infoblox as the IPAM provider. Only one of subnet or subnet_uuid configuration is allowed."
                },
                "subnet_uuid": {
                    "type": "string",
                    "description": "Subnet UUID or Name or Prefix for VirtualService IP allocation with AWS or OpenStack as the IPAM provider. Only one of subnet or subnet_uuid configuration is allowed.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "subnet6": {
                    "type": "message",
                    "messageType": "IpAddrPrefix",
                    "description": "Subnet for VirtualService IPv6 allocation with Vantage or Infoblox as the IPAM provider. Only one of subnet or subnet_uuid configuration is allowed.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "subnet6_uuid": {
                    "type": "string",
                    "description": "Subnet UUID or Name or Prefix for VirtualService IPv6 allocation with AWS or OpenStack as the IPAM provider. Only one of subnet or subnet_uuid configuration is allowed.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "range": {
                    "type": "message",
                    "messageType": "IpAddrRange",
                    "description": "IPv4 reserved range of IPs for VirtualService IP allocation with Infoblox as the IPAM provider."
                },
                "ipv6_range": {
                    "type": "message",
                    "messageType": "IpAddrRange",
                    "description": "IPv6 reserved range of IPs for VirtualService IP allocation with Infoblox as the IPAM provider."
                }
            }
        },
        "SidebandProfile": {
            "fields": {
                "ip": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "repeated": true,
                    "description": "IP Address of the sideband server."
                },
                "sideband_max_request_body_size": {
                    "type": "int32",
                    "default": 1024,
                    "description": "Maximum size of the request body that will be sent on the sideband.",
                    "min": 0,
                    "max": 16384
                }
            }
        },
        "DnsInfo": {
            "fields": {
                "fqdn": {
                    "type": "string",
                    "description": "Fully qualified domain name."
                },
                "ttl": {
                    "type": "uint32",
                    "description": "Time to live for fqdn record. Default value is chosen from DNS profile for this cloud if no value provided."
                },
                "type": {
                    "type": "enum",
                    "enumType": "DnsRecordType",
                    "default": "DNS_RECORD_A",
                    "description": "DNS record type"
                },
                "num_records_in_response": {
                    "type": "uint32",
                    "description": "Specifies the number of records returned for this FQDN. Enter 0 to return all records. Default is 0",
                    "min": 0,
                    "max": 20,
                    "specialValues": {
                        "0": "Return all records"
                    }
                },
                "algorithm": {
                    "type": "enum",
                    "enumType": "DnsRecordResponseAlgorithm",
                    "default": "DNS_RECORD_RESPONSE_CONSISTENT_HASH",
                    "description": "Specifies the algorithm to pick the IP address(es) to be returned, when multiple entries are configured. This does not apply if num_records_in_response is 0. Default is consistent hash."
                },
                "cname": {
                    "type": "message",
                    "messageType": "DnsCnameRdata",
                    "description": "Canonical name in CNAME record."
                },
                "metadata": {
                    "type": "string",
                    "description": "Any metadata associated with this record"
                }
            },
            "repeatedKey": "fqdn"
        },
        "DnsRecord": {
            "fields": {
                "fqdn": {
                    "type": "string",
                    "repeated": true,
                    "description": "Fully Qualified Domain Name",
                    "minRepeatedLength": 1
                },
                "type": {
                    "type": "enum",
                    "enumType": "DnsRecordType",
                    "required": true,
                    "description": "DNS record type"
                },
                "ttl": {
                    "type": "uint32",
                    "description": "Time To Live for this DNS record"
                },
                "ip_address": {
                    "type": "message",
                    "messageType": "DnsARdata",
                    "repeated": true,
                    "description": "IP address in A record",
                    "maxRepeatedLength": 4
                },
                "service_locator": {
                    "type": "message",
                    "messageType": "DnsSrvRdata",
                    "repeated": true,
                    "description": "Service locator info in SRV record",
                    "maxRepeatedLength": 4
                },
                "cname": {
                    "type": "message",
                    "messageType": "DnsCnameRdata",
                    "description": "Canonical name in CNAME record"
                },
                "ns": {
                    "type": "message",
                    "messageType": "DnsNsRdata",
                    "repeated": true,
                    "description": "Name Server information in NS record",
                    "maxRepeatedLength": 13
                },
                "num_records_in_response": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Specifies the number of records returned by the DNS service. Enter 0 to return all records. Default is 0",
                    "min": 0,
                    "max": 20,
                    "specialValues": {
                        "0": "Return all records"
                    }
                },
                "algorithm": {
                    "type": "enum",
                    "enumType": "DnsRecordResponseAlgorithm",
                    "default": "DNS_RECORD_RESPONSE_ROUND_ROBIN",
                    "description": "Specifies the algorithm to pick the IP address(es) to be returned, when multiple entries are configured. This does not apply if num_records_in_response is 0. Default is round-robin."
                },
                "wildcard_match": {
                    "type": "bool",
                    "default": false,
                    "description": "Enable wild-card match of fqdn: if an exact match is not found in the DNS table, the longest match is chosen by wild-carding the fqdn in the DNS request. Default is false."
                },
                "delegated": {
                    "type": "bool",
                    "default": false,
                    "description": "Configured FQDNs are delegated domains (i.e. they represent a zone cut)."
                },
                "ip6_address": {
                    "type": "message",
                    "messageType": "DnsAAAARdata",
                    "repeated": true,
                    "description": "IPv6 address in AAAA record",
                    "maxRepeatedLength": 4
                },
                "description": {
                    "type": "string",
                    "description": "Details of DNS record"
                },
                "metadata": {
                    "type": "string",
                    "description": "Internal metadata for the DNS record"
                },
                "mx_records": {
                    "type": "message",
                    "messageType": "DnsMxRdata",
                    "repeated": true,
                    "description": "MX record.",
                    "maxRepeatedLength": 4
                },
                "txt_records": {
                    "type": "message",
                    "messageType": "DnsTxtRdata",
                    "repeated": true,
                    "description": "Text record.",
                    "maxRepeatedLength": 4
                }
            },
            "repeatedKey": "fqdn"
        },
        "DnsSrvRdata": {
            "fields": {
                "priority": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Priority of the target hosting the service, low value implies higher priority for this service record",
                    "min": 0,
                    "max": 65535
                },
                "weight": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Relative weight for service records with same priority, high value implies higher preference for this service record",
                    "min": 0,
                    "max": 65535
                },
                "target": {
                    "type": "string",
                    "default": "default.host",
                    "description": "Canonical hostname, of the machine hosting the service, with no trailing period. 'default.host' is valid but not 'default.host.'"
                },
                "port": {
                    "type": "uint32",
                    "required": true,
                    "description": "Service port",
                    "min": 0,
                    "max": 65535
                }
            }
        },
        "ServicePoolSelector": {
            "fields": {
                "service_port": {
                    "type": "uint32",
                    "required": true,
                    "description": "Pool based destination port",
                    "min": 1,
                    "max": 65535
                },
                "service_pool_uuid": {
                    "type": "string"
                },
                "service_protocol": {
                    "type": "enum",
                    "enumType": "ProtocolType",
                    "description": "Destination protocol to match for the pool selection. If not specified, it will match any protocol."
                },
                "service_pool_group_uuid": {
                    "type": "string"
                },
                "service_port_range_end": {
                    "type": "uint32",
                    "default": 0,
                    "description": "The end of the Service port number range.",
                    "min": 1,
                    "max": 65535,
                    "specialValues": {
                        "0": "single port"
                    }
                }
            },
            "repeatedKey": "service_port,service_protocol,service_port_range_end"
        },
        "DnsPolicies": {
            "fields": {
                "index": {
                    "type": "uint32",
                    "description": "Index of the dns policy",
                    "required": true
                },
                "dns_policy_uuid": {
                    "type": "string",
                    "description": "UUID of the dns policy",
                    "required": true
                }
            },
            "repeatedKey": "index"
        },
        "VSDataScripts": {
            "fields": {
                "index": {
                    "type": "int32",
                    "required": true,
                    "description": "Index of the virtual service datascript collection."
                },
                "vs_datascript_set_uuid": {
                    "type": "string",
                    "required": true,
                    "description": "UUID of the virtual service datascript collection."
                }
            },
            "repeatedKey": "index"
        },
        "AnalyticsPolicy": {
            "fields": {
                "full_client_logs": {
                    "type": "message",
                    "messageType": "FullClientLogs"
                },
                "client_log_filters": {
                    "type": "message",
                    "messageType": "ClientLogFilter",
                    "repeated": true
                },
                "udf_log_throttle": {
                    "type": "uint32",
                    "default": 10,
                    "description": "This setting limits the total number of UDF logs generated per second for this VS on each SE. UDF logs are generated due to the configured client log filters or the rules with logging enabled. Default is 10 logs per second. Set it to zero (0) to deactivate throttling. Note that the SE group's throttle value takes precedence over this setting."
                },
                "significant_log_throttle": {
                    "type": "uint32",
                    "default": 10,
                    "description": "This setting limits the number of significant logs generated per second for this VS on each SE. Default is 10 logs per second. Set it to zero (0) to deactivate throttling. Note that the SE group's throttle value takes precedence over this setting."
                },
                "client_insights": {
                    "type": "enum",
                    "enumType": "ClientInsights",
                    "default": "NO_INSIGHTS",
                    "description": "Gain insights from sampled client to server HTTP requests and responses."
                },
                "metrics_realtime_update": {
                    "type": "message",
                    "messageType": "MetricsRealTimeUpdate",
                    "description": "Settings to turn on realtime metrics and set duration for realtime updates"
                },
                "client_insights_sampling": {
                    "type": "message",
                    "messageType": "ClientInsightsSampling",
                    "description": ""
                },
                "all_headers": {
                    "type": "bool",
                    "default": false,
                    "description": "Log all headers."
                },
                "learning_log_policy": {
                    "type": "message",
                    "messageType": "LearningLogPolicy",
                    "description": "Configuration for learning logging determining whether it's enabled and where is the destination"
                }
            }
        },
        "LearningLogPolicy": {
            "fields": {
                "enabled": {
                    "type": "bool",
                    "default": false,
                    "description": "Determine whether app learning logging is enabled."
                },
                "host": {
                    "type": "string",
                    "description": "Host name where learning logs will be sent to."
                },
                "port": {
                    "type": "uint32",
                    "description": "Port number for the service listening for learning logs."
                }
            }
        },
        "ClientInsightsSampling": {
            "fields": {
                "skip_uris": {
                    "type": "message",
                    "messageType": "StringMatch",
                    "description": "URL patterns to avoid when inserting RUM script.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "sample_uris": {
                    "type": "message",
                    "messageType": "StringMatch",
                    "description": "URL patterns to check when inserting RUM script.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "client_ip": {
                    "type": "message",
                    "messageType": "IpAddrMatch",
                    "description": "Client IP addresses to check when inserting RUM script."
                }
            }
        },
        "ClientLogFilter": {
            "fields": {
                "index": {
                    "type": "uint32",
                    "required": true
                },
                "name": {
                    "type": "string",
                    "required": true
                },
                "client_ip": {
                    "type": "message",
                    "messageType": "IpAddrMatch"
                },
                "all_headers": {
                    "type": "bool",
                    "default": false
                },
                "uri": {
                    "type": "message",
                    "messageType": "StringMatch",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "enabled": {
                    "type": "bool",
                    "default": false,
                    "required": true
                },
                "duration": {
                    "type": "uint32",
                    "default": 30,
                    "specialValues": {
                        "0": "infinite"
                    }
                }
            }
        },
        "FullClientLogs": {
            "fields": {
                "enabled": {
                    "type": "bool",
                    "default": false,
                    "required": true,
                    "description": "Capture all client logs including connections and requests.  When deactivated, only errors will be logged.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false",
                            "default_value": false
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false",
                            "default_value": false
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "duration": {
                    "type": "uint32",
                    "default": 30,
                    "description": "How long should the system capture all logs, measured in minutes. Set to 0 for infinite.",
                    "specialValues": {
                        "0": "infinite"
                    }
                },
                "throttle": {
                    "type": "uint32",
                    "default": 10,
                    "description": "This setting limits the number of non-significant logs generated per second for this VS on each SE. Default is 10 logs per second. Set it to zero (0) to deactivate throttling. Note that the SE group's throttle value takes precedence over this setting."
                }
            }
        },
        "PerformanceLimits": {
            "fields": {
                "max_concurrent_connections": {
                    "type": "int32",
                    "description": "The maximum number of concurrent client conections allowed to the Virtual Service."
                },
                "max_throughput": {
                    "type": "int32",
                    "description": "The maximum throughput per second for all clients allowed through the client side of the Virtual Service per SE.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                }
            }
        },
        "HTTPPolicies": {
            "fields": {
                "index": {
                    "type": "int32",
                    "required": true,
                    "description": "Index of the virtual service HTTP policy collection"
                },
                "http_policy_set_uuid": {
                    "type": "string",
                    "required": true,
                    "description": "UUID of the virtual service HTTP policy collection"
                }
            },
            "repeatedKey": "http_policy_set_uuid"
        },
        "Service": {
            "fields": {
                "port": {
                    "type": "uint32",
                    "required": true,
                    "description": "The Virtual Service's port number.",
                    "min": 0,
                    "max": 65535
                },
                "enable_ssl": {
                    "type": "bool",
                    "default": false,
                    "description": "Enable SSL termination and offload for traffic from clients."
                },
                "override_network_profile_uuid": {
                    "type": "string",
                    "description": "Override the network profile for this specific service port.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "port_range_end": {
                    "type": "uint32",
                    "default": 0,
                    "description": "The end of the Virtual Service's port number range.",
                    "min": 1,
                    "max": 65535,
                    "specialValues": {
                        "0": "single port"
                    }
                },
                "override_application_profile_uuid": {
                    "type": "string",
                    "description": "Enable application layer specific features for the this specific service.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "enable_http2": {
                    "type": "bool",
                    "default": false,
                    "description": "Enable HTTP2 on this port.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "horizon_internal_ports": {
                    "type": "bool",
                    "default": false,
                    "description": "Used for Horizon deployment. If set used for L7 redirect."
                },
                "is_active_ftp_data_port": {
                    "type": "bool",
                    "default": false,
                    "description": "Source port used by VS for active FTP data connections."
                },
                "is_passive_ftp_data_port": {
                    "type": "bool",
                    "default": false,
                    "description": "Source port used by VS for passive FTP data connections.Change in this flag is disruptive update."
                }
            },
            "repeatedKey": "port,override_network_profile_uuid,port_range_end"
        },
        "VrfContext": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "required": true
                },
                "name": {
                    "type": "string",
                    "required": true,
                    "maxStringLength": 256
                },
                "static_routes": {
                    "type": "message",
                    "messageType": "StaticRoute",
                    "repeated": true
                },
                "bgp_profile": {
                    "type": "message",
                    "messageType": "BgpProfile",
                    "description": "Bgp Local and Peer Info",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "system_default": {
                    "type": "bool",
                    "default": false,
                    "immutable": true
                },
                "gateway_mon": {
                    "type": "message",
                    "messageType": "GatewayMonitor",
                    "repeated": true,
                    "description": "Configure ping based heartbeat check for gateway in service engines of vrf.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "internal_gateway_monitor": {
                    "type": "message",
                    "messageType": "InternalGatewayMonitor",
                    "description": "Configure ping based heartbeat check for all default gateways in service engines of vrf."
                },
                "debugvrfcontext": {
                    "type": "message",
                    "messageType": "DebugVrfContext",
                    "description": "Configure debug flags for VRF"
                },
                "bfd_profile": {
                    "type": "message",
                    "messageType": "BfdProfile",
                    "description": "BFD configuration profile.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "lldp_enable": {
                    "type": "bool",
                    "default": true,
                    "description": "Enable LLDP.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "true"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "true"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "attrs": {
                    "type": "message",
                    "messageType": "KeyValue",
                    "repeated": true,
                    "description": "Key/value vrfcontext attributes.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "markers": {
                    "type": "message",
                    "messageType": "RoleFilterMatchLabel",
                    "repeated": true,
                    "description": "List of labels to be used for granular RBAC.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "description": {
                    "type": "string"
                },
                "tenant_uuid": {
                    "type": "string"
                },
                "cloud_uuid": {
                    "type": "string",
                    "default": "Default-Cloud"
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                }
            }
        },
        "BfdProfile": {
            "fields": {
                "multi": {
                    "type": "uint32",
                    "default": 3,
                    "description": "Default detection multiplier used in BFD.",
                    "min": 3,
                    "max": 255
                },
                "mintx": {
                    "type": "uint32",
                    "default": 1000,
                    "description": "Default desired minimum transmit interval (in ms) used in BFD.",
                    "min": 500,
                    "max": 4000000
                },
                "minrx": {
                    "type": "uint32",
                    "default": 1000,
                    "description": "Default required minimum receive interval (in ms) used in BFD.",
                    "min": 500,
                    "max": 4000000
                }
            }
        },
        "DebugVrfContext": {
            "fields": {
                "flags": {
                    "type": "message",
                    "messageType": "DebugVrf",
                    "repeated": true
                },
                "command_buffer_size": {
                    "type": "uint32",
                    "default": 32768,
                    "description": "Vrf config command buffer size.",
                    "min": 1,
                    "max": 32768
                },
                "command_buffer_interval": {
                    "type": "uint32",
                    "default": 2,
                    "description": "Vrf config command buffer process interval.",
                    "min": 1,
                    "max": 4
                }
            }
        },
        "DebugVrf": {
            "fields": {
                "flag": {
                    "type": "enum",
                    "enumType": "DebugVrfFlag",
                    "required": true
                }
            },
            "repeatedKey": "flag"
        },
        "InternalGatewayMonitor": {
            "fields": {
                "gateway_monitor_interval": {
                    "type": "uint32",
                    "default": 1000,
                    "description": "The interval between two ping requests sent by the gateway monitor in milliseconds. If a value is not specified, requests are sent every second.",
                    "min": 100,
                    "max": 60000
                },
                "gateway_monitor_failure_threshold": {
                    "type": "uint32",
                    "default": 10,
                    "description": "The number of consecutive failed gateway health checks before a gateway is marked down.",
                    "min": 3,
                    "max": 50
                },
                "gateway_monitor_success_threshold": {
                    "type": "uint32",
                    "default": 15,
                    "description": "The number of consecutive successful gateway health checks before a gateway that was marked down by the gateway monitor is marked up.",
                    "min": 3,
                    "max": 50
                },
                "disable_gateway_monitor": {
                    "type": "bool",
                    "default": false,
                    "description": "Disable the gateway monitor for default gateway. They are monitored by default."
                }
            }
        },
        "BgpProfile": {
            "fields": {
                "local_as": {
                    "type": "uint32",
                    "required": true,
                    "description": "Local Autonomous System ID",
                    "min": 1,
                    "max": 4294967295
                },
                "ibgp": {
                    "type": "bool",
                    "default": true,
                    "required": true,
                    "description": "BGP peer type"
                },
                "peers": {
                    "type": "message",
                    "messageType": "BgpPeer",
                    "repeated": true,
                    "description": "BGP Peers",
                    "maxRepeatedLength": 128,
                    "minRepeatedLength": 0
                },
                "keepalive_interval": {
                    "type": "uint32",
                    "default": 60,
                    "description": "Keepalive interval for Peers",
                    "min": 0,
                    "max": 3600
                },
                "hold_time": {
                    "type": "uint32",
                    "default": 180,
                    "description": "Hold time for Peers",
                    "min": 3,
                    "max": 7200
                },
                "send_community": {
                    "type": "bool",
                    "default": true,
                    "description": "Send community attribute to all peers."
                },
                "community": {
                    "type": "string",
                    "repeated": true,
                    "description": "Community string either in aa:nn format where aa, nn is within [1,65535] or local-AS|no-advertise|no-export|internet.",
                    "maxRepeatedLength": 16,
                    "minRepeatedLength": 0
                },
                "ip_communities": {
                    "type": "message",
                    "messageType": "IpCommunity",
                    "repeated": true,
                    "description": "Communities per IP address range.",
                    "maxRepeatedLength": 1024,
                    "minRepeatedLength": 0
                },
                "local_preference": {
                    "type": "uint32",
                    "description": "LOCAL_PREF to be used for routes advertised. Applicable only over iBGP."
                },
                "num_as_path_prepend": {
                    "type": "uint32",
                    "description": "Number of times the local AS should be prepended additionally.",
                    "min": 1,
                    "max": 10
                },
                "routing_options": {
                    "type": "message",
                    "messageType": "BgpRoutingOptions",
                    "repeated": true,
                    "description": "Learning and advertising options for BGP peers.",
                    "maxRepeatedLength": 128,
                    "minRepeatedLength": 0
                },
                "shutdown": {
                    "type": "bool",
                    "default": false,
                    "description": "Shutdown the bgp"
                }
            }
        },
        "BgpRoutingOptions": {
            "fields": {
                "label": {
                    "type": "string",
                    "description": "Features are applied to peers matching this label.",
                    "maxStringLength": 128,
                    "required": true
                },
                "learn_only_default_route": {
                    "type": "bool",
                    "description": "Learn only default route from the BGP peer."
                },
                "learn_routes": {
                    "type": "bool",
                    "description": "Learn routes from the BGP peer."
                },
                "advertise_default_route": {
                    "type": "bool",
                    "description": "Advertise self as default router to the BGP peer."
                },
                "advertise_learned_routes": {
                    "type": "bool",
                    "description": "Advertise the learned routes to the BGP peer."
                },
                "max_learn_limit": {
                    "type": "uint32",
                    "default": 50,
                    "description": "Maximum number of routes that can be learned from a BGP peer.",
                    "min": 50,
                    "max": 250
                }
            },
            "repeatedKey": "label"
        },
        "IpCommunity": {
            "fields": {
                "ip_begin": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "required": true,
                    "description": "Beginning of IP address range."
                },
                "ip_end": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "description": "End of IP address range. Optional if ip_begin is the only IP address in specified IP range."
                },
                "community": {
                    "type": "string",
                    "repeated": true,
                    "description": "Community string either in aa:nn format where aa, nn is within [1,65535] or local-AS|no-advertise|no-export|internet.",
                    "maxRepeatedLength": 16,
                    "minRepeatedLength": 1
                }
            },
            "repeatedKey": "ip_begin"
        },
        "BgpPeer": {
            "fields": {
                "remote_as": {
                    "type": "uint32",
                    "description": "Peer Autonomous System ID",
                    "min": 1,
                    "max": 4294967295
                },
                "peer_ip": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "description": "IP Address of the BGP Peer"
                },
                "subnet": {
                    "type": "message",
                    "messageType": "IpAddrPrefix",
                    "description": "Subnet providing reachability for Peer"
                },
                "md5_secret": {
                    "type": "string",
                    "description": "Peer Autonomous System Md5 Digest Secret Key"
                },
                "bfd": {
                    "type": "bool",
                    "default": true,
                    "description": "Enable Bi-Directional Forward Detection. Only async mode supported."
                },
                "network_uuid": {
                    "type": "string",
                    "default": "",
                    "description": "Network providing reachability for Peer"
                },
                "advertise_vip": {
                    "type": "bool",
                    "default": true,
                    "description": "Advertise VIP to this Peer"
                },
                "advertise_snat_ip": {
                    "type": "bool",
                    "default": true,
                    "description": "Advertise SNAT IP to this Peer"
                },
                "advertisement_interval": {
                    "type": "uint32",
                    "default": 5,
                    "description": "Advertisement interval for this Peer",
                    "min": 1,
                    "max": 60
                },
                "connect_timer": {
                    "type": "uint32",
                    "default": 10,
                    "description": "Connect timer for this Peer",
                    "min": 1,
                    "max": 120
                },
                "keepalive_interval": {
                    "type": "uint32",
                    "description": "Keepalive interval for this Peer",
                    "min": 0,
                    "max": 3600
                },
                "hold_time": {
                    "type": "uint32",
                    "description": "Hold time for this Peer",
                    "min": 3,
                    "max": 7200
                },
                "ebgp_multihop": {
                    "type": "uint32",
                    "default": 0,
                    "description": "TTL for multihop ebgp Peer",
                    "min": 0,
                    "max": 255
                },
                "local_as": {
                    "type": "uint32",
                    "description": "Local AS to use for this ebgp peer. If specified, this will override the local AS configured at the VRF level",
                    "min": 1,
                    "max": 4294967295
                },
                "peer_ip6": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "description": "IPv6 Address of the BGP Peer."
                },
                "subnet6": {
                    "type": "message",
                    "messageType": "IpAddrPrefix",
                    "description": "IPv6 subnet providing reachability for Peer."
                },
                "shutdown": {
                    "type": "bool",
                    "default": false,
                    "description": "Shutdown the BGP peer."
                },
                "label": {
                    "type": "string",
                    "description": "Label used to enable learning and/or advertisement of routes to this peer.",
                    "immutable": true,
                    "maxStringLength": 128
                },
                "ibgp_local_as_override": {
                    "type": "bool",
                    "description": "Override the profile level local_as with the peer level remote_as."
                }
            },
            "repeatedKey": "peer_ip,subnet,peer_ip6,subnet6"
        },
        "VSDataScriptSet": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "required": true,
                    "description": "UUID of the virtual service datascript collection"
                },
                "name": {
                    "type": "string",
                    "required": true,
                    "description": "Name for the virtual service datascript collection",
                    "maxStringLength": 256
                },
                "datascript": {
                    "type": "message",
                    "messageType": "VSDataScript",
                    "repeated": true,
                    "description": "DataScripts to execute"
                },
                "pool_uuids": {
                    "type": "string",
                    "repeated": true,
                    "description": "UUID of pools that could be referred by VSDataScriptSet objects.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "pool_group_uuids": {
                    "type": "string",
                    "repeated": true,
                    "description": "UUID of pool groups that could be referred by VSDataScriptSet objects."
                },
                "ipgroup_uuids": {
                    "type": "string",
                    "repeated": true,
                    "description": "UUID of IP Groups that could be referred by VSDataScriptSet objects.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "string_group_uuids": {
                    "type": "string",
                    "repeated": true,
                    "description": "UUID of String Groups that could be referred by VSDataScriptSet objects.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "created_by": {
                    "type": "string",
                    "description": "Creator name"
                },
                "protocol_parser_uuids": {
                    "type": "string",
                    "repeated": true,
                    "description": "List of protocol parsers that could be referred by VSDataScriptSet objects.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "ip_reputation_db_uuid": {
                    "type": "string",
                    "description": "IP reputation database that can be used by DataScript functions."
                },
                "markers": {
                    "type": "message",
                    "messageType": "RoleFilterMatchLabel",
                    "repeated": true,
                    "description": "List of labels to be used for granular RBAC.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "snat_ips": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "repeated": true,
                    "description": "IPv4 address used by a VS-DataScript in avi.l4.source_ip api.",
                    "maxRepeatedLength": 8
                },
                "snat_ip6s": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "repeated": true,
                    "description": "IPv6 address used by a VS-DataScript in avi.l4.source_ip api.",
                    "maxRepeatedLength": 8
                },
                "description": {
                    "type": "string"
                },
                "tenant_uuid": {
                    "type": "string",
                    "required": true
                },
                "rate_limiters": {
                    "type": "message",
                    "messageType": "RateLimiter",
                    "repeated": true,
                    "description": "The Rate Limit definitions needed for this DataScript. The name is composed of the Virtual Service name and the DataScript name.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "geo_db_uuid": {
                    "type": "string",
                    "description": "Geo Location Mapping Database used by this DataScriptSet."
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                },
                "ssl_profile_uuids": {
                    "type": "string",
                    "repeated": true,
                    "description": "UUIDs of SSLProfile objects that could be referred by VSDataScriptSet objects.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "ssl_key_certificate_uuids": {
                    "type": "string",
                    "repeated": true,
                    "description": "UUIDs of SSLKeyAndCertificate objects that could be referred by VSDataScriptSet objects.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "pki_profile_uuids": {
                    "type": "string",
                    "repeated": true,
                    "description": "UUIDs of PKIProfile objects that could be referred by VSDataScriptSet objects.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                }
            }
        },
        "VSDataScript": {
            "fields": {
                "evt": {
                    "type": "enum",
                    "enumType": "VSDataScriptEvent",
                    "required": true,
                    "description": "Event triggering execution of datascript",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "VS_DATASCRIPT_EVT_HTTP_REQ,VS_DATASCRIPT_EVT_HTTP_RESP"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "script": {
                    "type": "string",
                    "required": true,
                    "description": "Datascript to execute when the event triggers"
                }
            }
        },
        "VssPlacement": {
            "fields": {
                "num_subcores": {
                    "type": "uint32",
                    "default": 4,
                    "description": "Number of sub-cores that comprise a CPU core.",
                    "min": 1,
                    "max": 128
                },
                "core_nonaffinity": {
                    "type": "uint32",
                    "default": 2,
                    "description": "Degree of core non-affinity for VS placement.",
                    "min": 1,
                    "max": 256
                }
            }
        },
        "VsVip": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "required": true,
                    "description": "UUID of the VsVip object."
                },
                "name": {
                    "type": "string",
                    "required": true,
                    "description": "Name for the VsVip object.",
                    "maxStringLength": 280
                },
                "vip": {
                    "type": "message",
                    "messageType": "Vip",
                    "repeated": true,
                    "description": "List of Virtual Service IPs and other shareable entities."
                },
                "dns_info": {
                    "type": "message",
                    "messageType": "DnsInfo",
                    "repeated": true,
                    "description": "Service discovery specific data including fully qualified domain name, type and Time-To-Live of the DNS record. This takes effect only if dns profile isassociated with cloud.",
                    "maxRepeatedLength": 1000,
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "DISALLOWED"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "vrf_context_uuid": {
                    "type": "string",
                    "description": "Virtual Routing Context that the Virtual Service is bound to. This is used to provide the isolation of the set of networks the application is attached to.",
                    "immutable": true
                },
                "east_west_placement": {
                    "type": "bool",
                    "default": false,
                    "description": "Force placement on all Service Engines in the Service Engine Group (Container clouds only)",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_LIMITED",
                            "allowed_value": "false"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_ANY"
                        }
                    ]
                },
                "tier1_lr": {
                    "type": "string",
                    "description": "This sets the placement scope of virtualservice to given tier1 logical router in Nsx-t.",
                    "immutable": true
                },
                "ipam_selector": {
                    "type": "message",
                    "messageType": "Selector",
                    "description": "Determines the set of IPAM networks to use for this VsVip. Selector type must be SELECTOR_IPAM and only one label is supported."
                },
                "bgp_peer_labels": {
                    "type": "string",
                    "repeated": true,
                    "description": "Select BGP peers, using peer label, for VsVip advertisement.",
                    "maxRepeatedLength": 128,
                    "maxStringLength": 128
                },
                "markers": {
                    "type": "message",
                    "messageType": "RoleFilterMatchLabel",
                    "repeated": true,
                    "description": "List of labels to be used for granular RBAC.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "bgp_local_preference": {
                    "type": "uint32",
                    "description": "LOCAL_PREF to be used for VsVip advertised. Applicable only over iBGP."
                },
                "bgp_num_as_path_prepend": {
                    "type": "uint32",
                    "description": "Number of times the local AS should be prepended additionally to VsVip. Applicable only over eBGP",
                    "min": 1,
                    "max": 10
                },
                "tenant_uuid": {
                    "type": "string",
                    "required": true
                },
                "cloud_uuid": {
                    "type": "string",
                    "default": "Default-Cloud",
                    "immutable": true
                },
                "vsvip_cloud_config_cksum": {
                    "type": "string",
                    "description": "Checksum of cloud configuration for VsVip. Internally set by cloud connector"
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                }
            }
        },
        "Selector": {
            "fields": {
                "type": {
                    "type": "enum",
                    "enumType": "SelectorType",
                    "description": "Selector type",
                    "required": true
                },
                "labels": {
                    "type": "message",
                    "messageType": "KeyValueTuple",
                    "repeated": true,
                    "description": "Labels as key value pairs to select on",
                    "minRepeatedLength": 1
                }
            }
        },
        "WafApplicationSignatures": {
            "fields": {
                "provider_uuid": {
                    "type": "string",
                    "default": "System-WafApplicationSignatures-Trustwave",
                    "description": "The external provide for the rules.",
                    "required": true
                },
                "ruleset_version": {
                    "type": "string",
                    "description": "The version in use of the provided ruleset."
                },
                "selected_applications": {
                    "type": "string",
                    "repeated": true,
                    "description": "List of applications for which we use the rules from the WafApplicationSignatureProvider."
                },
                "rule_overrides": {
                    "type": "message",
                    "messageType": "WafRuleOverrides",
                    "repeated": true,
                    "description": "Override attributes of application signature rules."
                },
                "resolved_rules": {
                    "type": "message",
                    "messageType": "WafRule",
                    "repeated": true,
                    "description": "A resolved version of the active application specific rules together with the overrides."
                }
            }
        },
        "WafRule": {
            "fields": {
                "index": {
                    "type": "uint32",
                    "required": true
                },
                "name": {
                    "type": "string",
                    "description": "User-friendly optional name for a rule."
                },
                "rule_id": {
                    "type": "string",
                    "description": "Identifier (id) for a rule per Modsec language. All SecRule and SecAction directives require an id. It is extracted from the id action in a Modsec rule. Rules within a single WAF Policy are required to have unique rule_ids."
                },
                "enable": {
                    "type": "bool",
                    "default": true,
                    "description": "Enable or disable WAF Rule Group.",
                    "required": true
                },
                "rule": {
                    "type": "string",
                    "description": "Rule as per Modsec language.",
                    "required": true
                },
                "exclude_list": {
                    "type": "message",
                    "messageType": "WafExcludeListEntry",
                    "repeated": true,
                    "description": "Exclude list for the WAF rule. The fields in the exclude list entry are logically and'ed to deduce the exclusion criteria. If there are multiple excludelist entries, it will be 'logical or' of them."
                },
                "tags": {
                    "type": "string",
                    "repeated": true,
                    "description": "Tags for WAF rule as per Modsec language. They are extracted from the tag action in a ModSec rule."
                },
                "mode": {
                    "type": "enum",
                    "enumType": "WafMode",
                    "description": "WAF Rule mode. This can be either detection, enforcement or evaluation. If this is not set, the Policy mode is used. This only takes effect if the policy allows delegation."
                },
                "is_sensitive": {
                    "type": "bool",
                    "default": false,
                    "description": "The rule field is sensitive and will not be displayed.",
                    "immutable": true
                },
                "phase": {
                    "type": "enum",
                    "enumType": "WafPhase",
                    "description": "The execution phase where this rule will be executed."
                },
                "paranoia_level": {
                    "type": "enum",
                    "enumType": "WafParanoiaLevel",
                    "description": "WAF rule paranoia level. This field is informative, like rule_id and tags, it is generated by the system from the rule text. This field is filled for CRS rules."
                }
            },
            "repeatedKey": "index"
        },
        "WafExcludeListEntry": {
            "fields": {
                "client_subnet": {
                    "type": "message",
                    "messageType": "IpAddrPrefix",
                    "description": "Client IP Subnet to exclude for WAF rules."
                },
                "uri_path": {
                    "type": "string",
                    "description": "URI Path to exclude for WAF rules."
                },
                "match_element": {
                    "type": "string",
                    "description": "The match_element can be 'ARGS:xxx', 'ARGS_GET:xxx', 'ARGS_POST:xxx', 'ARGS_NAMES:xxx', 'FILES:xxx', 'QUERY_STRING', 'REQUEST_BASENAME', 'REQUEST_BODY', 'REQUEST_URI', 'REQUEST_URI_RAW', 'REQUEST_COOKIES:xxx', 'REQUEST_COOKIES_NAMES:xxx', 'REQUEST_HEADERS:xxx', 'REQUEST_HEADERS_NAMES:xxx', 'RESPONSE_HEADERS:xxx' or XML:xxx. These match_elements in the HTTP Transaction (if present) will be excluded when executing WAF Rules."
                },
                "uri_match_criteria": {
                    "type": "message",
                    "messageType": "WafExclusionType",
                    "description": "Criteria for URI matching."
                },
                "match_element_criteria": {
                    "type": "message",
                    "messageType": "WafExclusionType",
                    "description": "Criteria for match_element matching."
                },
                "description": {
                    "type": "string",
                    "description": "Free-text comment about this exclusion."
                }
            }
        },
        "WafExclusionType": {
            "fields": {
                "match_op": {
                    "type": "enum",
                    "enumType": "StringOperation",
                    "default": "EQUALS",
                    "description": "String Operation to use for matching the Exclusion.",
                    "required": true
                },
                "match_case": {
                    "type": "enum",
                    "enumType": "MatchCase",
                    "default": "SENSITIVE",
                    "description": "Case sensitivity to use for the matching.",
                    "required": true
                }
            }
        },
        "WafRuleOverrides": {
            "fields": {
                "rule_id": {
                    "type": "string",
                    "description": "The rule_id of the rule where attributes are overridden.",
                    "required": true
                },
                "enable": {
                    "type": "bool",
                    "description": "Override the enable flag for this rule."
                },
                "mode": {
                    "type": "enum",
                    "enumType": "WafMode",
                    "description": "Override the waf mode for this rule."
                },
                "exclude_list": {
                    "type": "message",
                    "messageType": "WafExcludeListEntry",
                    "repeated": true,
                    "description": "Replace the exclude list for this rule."
                }
            },
            "repeatedKey": "rule_id"
        },
        "WafApplicationSignatureProvider": {
            "fields": {
                "uuid": {
                    "type": "string"
                },
                "name": {
                    "type": "string",
                    "description": "Name of Application Specific Ruleset Provider.",
                    "immutable": true,
                    "maxStringLength": 256
                },
                "tenant_uuid": {
                    "type": "string",
                    "immutable": true
                },
                "ruleset_version": {
                    "type": "string",
                    "description": "Version of signatures."
                },
                "available_applications": {
                    "type": "message",
                    "messageType": "WafApplicationSignatureAppVersion",
                    "repeated": true,
                    "description": "Available application names and the ruleset version, when the rules for an application changed the last time."
                },
                "signatures": {
                    "type": "message",
                    "messageType": "WafRule",
                    "repeated": true,
                    "description": "The WAF rules. Not visible in the API."
                },
                "service_status": {
                    "type": "message",
                    "messageType": "WebApplicationSignatureServiceStatus",
                    "description": "If this object is managed by the Application Signatures update service, this field contain the status of this syncronization."
                },
                "filter_rules_on_import": {
                    "type": "bool",
                    "default": true,
                    "description": "If this is set to false, all provided rules are imported when updating this object. If this is set to true, only newer rules are considered for import. Newer rules are rules where the rule id is not in the range of 2,000,000 to 2,080,000 or where the rule has a tag with a CVE from 2013 or newer. All other rules are ignored on rule import."
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                }
            }
        },
        "WebApplicationSignatureServiceStatus": {
            "fields": {
                "error": {
                    "type": "string",
                    "description": "If the last attempted update failed, this is a more detailed error message."
                },
                "last_successful_update_check": {
                    "type": "message",
                    "messageType": "TimeStamp",
                    "description": "The time when the Application Signature service last successfull attemped to update this object. It will be not update, if an error occurs during an update attempt. In this case, the error will be set."
                },
                "upstream_sync_timestamp": {
                    "type": "message",
                    "messageType": "TimeStamp",
                    "description": "A timestamp field. It is used by the Application Signature Sync service to keep track of the current version."
                }
            }
        },
        "WafApplicationSignatureAppVersion": {
            "fields": {
                "application": {
                    "type": "string",
                    "description": "Name of an application in the rule set."
                },
                "last_changed_ruleset_version": {
                    "type": "string",
                    "description": "The last version of the rule set when the rules corresponding to the application changed."
                },
                "number_of_rules": {
                    "type": "uint32",
                    "description": "The number of rules available for this application."
                }
            }
        },
        "WafCRS": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "required": true,
                    "immutable": true
                },
                "version": {
                    "type": "string",
                    "description": "The version of this ruleset object.",
                    "immutable": true,
                    "required": true
                },
                "release_date": {
                    "type": "string",
                    "description": "The release date of this version in RFC 3339 / ISO 8601 format.",
                    "immutable": true,
                    "required": true
                },
                "description": {
                    "type": "string",
                    "description": "A short description of this ruleset.",
                    "immutable": true,
                    "required": true
                },
                "groups": {
                    "type": "message",
                    "messageType": "WafRuleGroup",
                    "repeated": true,
                    "description": "WAF Rules are sorted in groups based on their characterization.",
                    "maxRepeatedLength": 64,
                    "immutable": true
                },
                "name": {
                    "type": "string",
                    "description": "The name of this ruleset object.",
                    "immutable": true,
                    "maxStringLength": 256,
                    "required": true
                },
                "tenant_uuid": {
                    "type": "string",
                    "description": "Tenant that this object belongs to.",
                    "immutable": true,
                    "required": true
                },
                "integrity": {
                    "type": "string",
                    "description": "Integrity protection value.",
                    "immutable": true,
                    "required": true
                },
                "markers": {
                    "type": "message",
                    "messageType": "RoleFilterMatchLabel",
                    "repeated": true,
                    "description": "List of labels to be used for granular RBAC.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "files": {
                    "type": "message",
                    "messageType": "WafDataFile",
                    "repeated": true,
                    "description": "List of Data Files used for WAF Rules.",
                    "immutable": true
                },
                "restricted_extensions": {
                    "type": "string",
                    "repeated": true,
                    "description": "WAF Restricted File Extensions.",
                    "immutable": true,
                    "maxStringLength": 128
                },
                "restricted_headers": {
                    "type": "string",
                    "repeated": true,
                    "description": "WAF Restricted HTTP Headers.",
                    "immutable": true,
                    "maxStringLength": 128
                },
                "allowed_request_content_type_charsets": {
                    "type": "string",
                    "repeated": true,
                    "description": "Allowed request content type character sets in WAF.",
                    "immutable": true,
                    "maxStringLength": 128
                },
                "integrity_values": {
                    "type": "string",
                    "repeated": true,
                    "description": "Integrity protection values for CRS.",
                    "immutable": true,
                    "maxStringLength": 128
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                }
            }
        },
        "WafDataFile": {
            "fields": {
                "name": {
                    "type": "string",
                    "description": "WAF Data File Name.",
                    "required": true
                },
                "data": {
                    "type": "string",
                    "description": "Stringified WAF File Data.",
                    "required": true
                },
                "type": {
                    "type": "enum",
                    "enumType": "WafDataFileType",
                    "default": "WAF_DATAFILE_PM_FROM_FILE",
                    "description": "WAF data file type."
                }
            }
        },
        "WafRuleGroup": {
            "fields": {
                "index": {
                    "type": "uint32",
                    "required": true
                },
                "name": {
                    "type": "string",
                    "required": true
                },
                "enable": {
                    "type": "bool",
                    "default": true,
                    "description": "Enable or disable WAF Rule Group.",
                    "required": true
                },
                "rules": {
                    "type": "message",
                    "messageType": "WafRule",
                    "repeated": true,
                    "description": "Rules as per Modsec language."
                },
                "exclude_list": {
                    "type": "message",
                    "messageType": "WafExcludeListEntry",
                    "repeated": true,
                    "description": "Exclude list for the WAF rule group. The fields in the exclude list entry are logically and'ed to deduce the exclusion criteria. If there are multiple excludelist entries, it will be 'logical or' of them."
                }
            },
            "repeatedKey": "index"
        },
        "WafLog": {
            "fields": {
                "rule_logs": {
                    "type": "message",
                    "messageType": "WafRuleLog",
                    "repeated": true
                },
                "status": {
                    "type": "enum",
                    "enumType": "WafStatusCode",
                    "description": "Denotes whether WAF is running in detection mode or enforcement mode, whether any rules matched the transaction, and whether transaction is dropped by the WAF module."
                },
                "latency_request_header_phase": {
                    "type": "uint64",
                    "description": "Latency (in microseconds) in WAF Request Header Phase"
                },
                "latency_request_body_phase": {
                    "type": "uint64",
                    "description": "Latency (in microseconds) in WAF Request Body Phase"
                },
                "latency_response_header_phase": {
                    "type": "uint64",
                    "description": "Latency (in microseconds) in WAF Response Header Phase"
                },
                "latency_response_body_phase": {
                    "type": "uint64",
                    "description": "Latency (in microseconds) in WAF Response Body Phase"
                },
                "rules_configured": {
                    "type": "bool",
                    "default": false,
                    "description": "Set to true if there are ModSecurity rules in the policy."
                },
                "psm_logs": {
                    "type": "message",
                    "messageType": "WafPSMLog",
                    "repeated": true,
                    "description": "Log Entries generated by WAF Positive Security Model."
                },
                "psm_configured": {
                    "type": "bool",
                    "default": false,
                    "description": "Set to true if there are Positive Security Model rules in the policy."
                },
                "application_rule_logs": {
                    "type": "message",
                    "messageType": "WafRuleLog",
                    "repeated": true,
                    "description": "Log Entries generated by Application Specific Signature rules."
                },
                "application_rules_configured": {
                    "type": "bool",
                    "default": false,
                    "description": "Set to true if there are Application Specific Signature rules in the policy."
                },
                "allowlist_logs": {
                    "type": "message",
                    "messageType": "WafAllowlistLog",
                    "repeated": true,
                    "description": "Log Entries generated by WAF allowlist rules."
                },
                "allowlist_configured": {
                    "type": "bool",
                    "default": false,
                    "description": "Set to true if there are allowlist rules in the policy."
                },
                "allowlist_processed": {
                    "type": "bool",
                    "default": false,
                    "description": "Set to true if allowlist rules were processed."
                },
                "rules_processed": {
                    "type": "bool",
                    "default": false,
                    "description": "Set to true if ModSecurity rules were processed."
                },
                "psm_processed": {
                    "type": "bool",
                    "default": false,
                    "description": "Set to true if Positive Security Model rules were processed."
                },
                "application_rules_processed": {
                    "type": "bool",
                    "default": false,
                    "description": "Set to true if Application Specific Signature rules were processed."
                },
                "memory_allocated": {
                    "type": "uint64",
                    "description": "The total memory consumed by WAF to process this request."
                },
                "omitted_signature_stats": {
                    "type": "message",
                    "messageType": "OmittedWafLogStats",
                    "description": "Omitted WAF rule log stats."
                },
                "omitted_app_rule_stats": {
                    "type": "message",
                    "messageType": "OmittedWafLogStats",
                    "description": "Omitted Application rule log stats."
                },
                "learning_status": {
                    "type": "enum",
                    "enumType": "WafLearningStatus",
                    "default": "NOT_ACTIVE",
                    "description": "Indicate if this request is used for learning. If it is not used, this field contains the reason for this decision."
                },
                "used_body_parser": {
                    "type": "enum",
                    "enumType": "WafRequestParser",
                    "default": "WAF_REQUEST_PARSER_DO_NOT_PARSE",
                    "description": "Indicate which parser was used for this request body (if any)."
                }
            }
        },
        "OmittedWafLogStats": {
            "fields": {
                "rules": {
                    "type": "uint32",
                    "default": 0,
                    "description": "The total count of omitted rule logs."
                },
                "match_elements": {
                    "type": "uint32",
                    "default": 0,
                    "description": "The total count of omitted match element logs in all rules."
                }
            }
        },
        "WafAllowlistLog": {
            "fields": {
                "rule_name": {
                    "type": "string",
                    "description": "Name of the matched rule."
                },
                "actions": {
                    "type": "enum",
                    "enumType": "WafPolicyAllowlistAction",
                    "repeated": true,
                    "description": "Actions generated by this rule."
                }
            }
        },
        "WafRuleLog": {
            "fields": {
                "phase": {
                    "type": "string",
                    "description": "Phase in which transaction matched the Rule - for instance, Request Header Phase"
                },
                "rule_id": {
                    "type": "uint64",
                    "description": "ID of the matching rule per ModSec language"
                },
                "rule_group": {
                    "type": "string",
                    "description": "Rule Group for the matching rule"
                },
                "msg": {
                    "type": "string",
                    "description": "Rule's msg string per ModSec language"
                },
                "matches": {
                    "type": "message",
                    "messageType": "WafRuleMatchData",
                    "repeated": true,
                    "description": "Transaction data that matched the rule"
                },
                "tags": {
                    "type": "string",
                    "repeated": true,
                    "description": "Rule's tags per ModSec language"
                },
                "rule_name": {
                    "type": "string",
                    "description": "Name of the rule"
                },
                "omitted_match_elements": {
                    "type": "uint32",
                    "default": 0,
                    "description": "The count of omitted match element logs in the current rule."
                }
            }
        },
        "WafRuleMatchData": {
            "fields": {
                "match_element": {
                    "type": "string",
                    "description": "Field from a transaction that matches the rule, for instance if the request parameter is password=foobar, then match_element is ARGS:password."
                },
                "match_value": {
                    "type": "string",
                    "description": "Value of the field from a transaction that matches the rule. For instance, if the request parameter is password=foo, then match_value is foo. The value can be truncated if it is too long. In this case, this field starts at the position where the actual match started inside the value, and that position is stored in match_value_offset. This is done to ensure the relevant part is shown."
                },
                "is_internal": {
                    "type": "bool",
                    "default": false,
                    "description": "The match_element is an internal variable. It is not possible to add exclusions for this element."
                },
                "match_value_offset": {
                    "type": "uint64",
                    "default": 0,
                    "description": "The starting index of the first character of match_value field with respect to original match value."
                }
            }
        },
        "WafPSMLog": {
            "fields": {
                "group_uuid": {
                    "type": "string",
                    "description": "UUID of the PSM group."
                },
                "group_name": {
                    "type": "string",
                    "description": "Name of the PSM group."
                },
                "location": {
                    "type": "string",
                    "description": "Name of the PSM location."
                },
                "rule_id": {
                    "type": "string",
                    "description": "Rule ID of the matching rule."
                },
                "rule_name": {
                    "type": "string",
                    "description": "Name of the matching rule."
                },
                "matches": {
                    "type": "message",
                    "messageType": "WafRuleMatchData",
                    "repeated": true,
                    "description": "Transaction data that matched the rule."
                },
                "actions": {
                    "type": "enum",
                    "enumType": "WafAction",
                    "repeated": true,
                    "description": "Actions generated by this rule."
                }
            }
        },
        "WafPolicy": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "required": true
                },
                "name": {
                    "type": "string",
                    "required": true,
                    "maxStringLength": 256
                },
                "description": {
                    "type": "string"
                },
                "tenant_uuid": {
                    "type": "string",
                    "required": true
                },
                "mode": {
                    "type": "enum",
                    "enumType": "WafMode",
                    "default": "WAF_MODE_DETECTION_ONLY",
                    "description": "WAF Policy mode. This can be either detection, enforcement or evaluation. It can be overwritten by rules if allow_mode_delegation is set.",
                    "required": true
                },
                "waf_profile_uuid": {
                    "type": "string",
                    "description": "WAF Profile for WAF policy",
                    "required": true
                },
                "pre_crs_groups": {
                    "type": "message",
                    "messageType": "WafRuleGroup",
                    "repeated": true,
                    "description": "WAF Rules are categorized in to groups based on their characterization. These groups are created by the user and will be  enforced before the CRS groups."
                },
                "post_crs_groups": {
                    "type": "message",
                    "messageType": "WafRuleGroup",
                    "repeated": true,
                    "description": "WAF Rules are categorized in to groups based on their characterization. These groups are created by the user and will be enforced after the CRS groups."
                },
                "paranoia_level": {
                    "type": "enum",
                    "enumType": "WafParanoiaLevel",
                    "default": "WAF_PARANOIA_LEVEL_LOW",
                    "description": "WAF Ruleset paranoia  mode. This is used to select Rules based on the paranoia-level tag."
                },
                "created_by": {
                    "type": "string",
                    "description": "Creator name"
                },
                "waf_crs_uuid": {
                    "type": "string",
                    "default": "CRS-VERSION-NOT-APPLICABLE",
                    "description": "WAF core ruleset used for the CRS part of this Policy."
                },
                "failure_mode": {
                    "type": "enum",
                    "enumType": "WafFailureMode",
                    "default": "WAF_FAILURE_MODE_OPEN",
                    "description": "WAF Policy failure mode. This can be 'Open' or 'Closed'."
                },
                "allow_mode_delegation": {
                    "type": "bool",
                    "default": true,
                    "description": "Allow Rules to overwrite the policy mode. This must be set if the policy mode is set to enforcement."
                },
                "positive_security_model": {
                    "type": "message",
                    "messageType": "WafPositiveSecurityModel",
                    "description": "The Positive Security Model. This is used to describe how the request or parts of the request should look like. It is executed in the Request Body Phase of Avi WAF."
                },
                "application_signatures": {
                    "type": "message",
                    "messageType": "WafApplicationSignatures",
                    "description": "Application Specific Signatures"
                },
                "allowlist": {
                    "type": "message",
                    "messageType": "WafPolicyAllowlist",
                    "description": "A set of rules which describe conditions under which the request will bypass the WAF. This will be processed in the request header phase before any other WAF related code."
                },
                "geo_db_uuid": {
                    "type": "string",
                    "description": "Geo Location Mapping Database used by this WafPolicy."
                },
                "markers": {
                    "type": "message",
                    "messageType": "RoleFilterMatchLabel",
                    "repeated": true,
                    "description": "List of labels to be used for granular RBAC.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "crs_overrides": {
                    "type": "message",
                    "messageType": "WafRuleGroupOverrides",
                    "repeated": true,
                    "description": "Override attributes for CRS rules."
                },
                "bypass_static_extensions": {
                    "type": "bool",
                    "default": true,
                    "description": "Enable the functionality to bypass WAF for static file extensions."
                },
                "required_data_files": {
                    "type": "message",
                    "messageType": "WafPolicyRequiredDataFile",
                    "repeated": true,
                    "description": "The data files and types referred in this WAF policy."
                },
                "auto_update_crs": {
                    "type": "bool",
                    "default": false,
                    "description": "If this flag is set, the system will try to keep the CRS version used in this policy up-to-date. If a newer CRS object is available on this controller, the system will issue the CRS upgrade process for this WAF Policy. It will not update polices if the current CRS version is CRS-VERSION-NOT-APPLICABLE."
                },
                "use_evaluation_mode_on_crs_update": {
                    "type": "bool",
                    "default": true,
                    "description": "While updating CRS, the system will make sure that new rules are added in EVALUATION mode. A CRS update will set new rules into EVALUATION mode by adding crs_overrides for the new rules. If this flag is not set or if the old CRS object was empty, the new rules will be added without crs_overrides. This option is used for the auto_update_crs workflow as well as for the UI based CRS update workflow."
                },
                "sampling_mode": {
                    "type": "enum",
                    "enumType": "WafSamplingMode",
                    "default": "WAF_SAMPLING_MODE_NO_SAMPLING",
                    "description": "If and how WAF should use sampling to restrict the number of requests checked."
                },
                "fixed_sampling_rate": {
                    "type": "uint32",
                    "default": 1,
                    "description": "If sampling_mode is set to FIXED_SAMPLING, this value determines the percentage of requests choosen for WAF processing.",
                    "min": 1,
                    "max": 100
                },
                "enable_streaming": {
                    "type": "bool",
                    "default": false,
                    "description": "If this is set, WAF will let requests be streamed to the backend servers. If not set, requests and responses will be buffered up to the configured maximum values. It can only be set if the WafPolicy is not set to enforcement mode."
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                }
            }
        },
        "WafPolicyRequiredDataFile": {
            "fields": {
                "name": {
                    "type": "string",
                    "description": "Name of the data file.",
                    "maxStringLength": 128
                },
                "type": {
                    "type": "enum",
                    "enumType": "WafDataFileType",
                    "description": "Type of the data file."
                }
            }
        },
        "WafRuleGroupOverrides": {
            "fields": {
                "name": {
                    "type": "string",
                    "description": "The name of the group where attributes or rules are overridden.",
                    "required": true
                },
                "enable": {
                    "type": "bool",
                    "description": "Override the enable flag for this group."
                },
                "mode": {
                    "type": "enum",
                    "enumType": "WafMode",
                    "description": "Override the waf mode for this group.."
                },
                "exclude_list": {
                    "type": "message",
                    "messageType": "WafExcludeListEntry",
                    "repeated": true,
                    "description": "Replace the exclude list for this group."
                },
                "rule_overrides": {
                    "type": "message",
                    "messageType": "WafRuleOverrides",
                    "repeated": true,
                    "description": "Rule specific overrides."
                }
            },
            "repeatedKey": "name"
        },
        "WafPolicyAllowlist": {
            "fields": {
                "rules": {
                    "type": "message",
                    "messageType": "WafPolicyAllowlistRule",
                    "repeated": true,
                    "description": "Rules to bypass WAF."
                }
            }
        },
        "WafPolicyAllowlistRule": {
            "fields": {
                "index": {
                    "type": "uint32",
                    "description": "Rules are processed in order of this index field.",
                    "required": true
                },
                "name": {
                    "type": "string",
                    "description": "A name describing the rule in a short form.",
                    "required": true
                },
                "enable": {
                    "type": "bool",
                    "default": true,
                    "description": "Enable or deactivate the rule."
                },
                "match": {
                    "type": "message",
                    "messageType": "MatchTarget",
                    "description": "Match criteria describing requests to which this rule should be applied.",
                    "required": true
                },
                "actions": {
                    "type": "enum",
                    "enumType": "WafPolicyAllowlistAction",
                    "repeated": true,
                    "description": "Actions to be performed upon successful matching.",
                    "maxRepeatedLength": 1,
                    "minRepeatedLength": 1
                },
                "description": {
                    "type": "string",
                    "description": "Description of this rule."
                },
                "sampling_percent": {
                    "type": "uint32",
                    "default": 100,
                    "description": "Percentage of traffic that is sampled.",
                    "min": 0,
                    "max": 100
                }
            },
            "repeatedKey": "index"
        },
        "WafPositiveSecurityModel": {
            "fields": {
                "group_uuids": {
                    "type": "string",
                    "repeated": true,
                    "description": "These groups should be used to separate different levels of concern. The order of the groups matters, one group may mark parts of the request as valid, so that subsequent groups will not check these parts."
                }
            }
        },
        "WafPolicyPSMGroup": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "description": "UUID of this object.",
                    "required": true
                },
                "tenant_uuid": {
                    "type": "string",
                    "description": "Tenant that this object belongs to.",
                    "immutable": true,
                    "required": true
                },
                "name": {
                    "type": "string",
                    "description": "User defined name of the group.",
                    "maxStringLength": 256,
                    "required": true
                },
                "enable": {
                    "type": "bool",
                    "default": true,
                    "description": "Enable or disable this WAF rule group."
                },
                "locations": {
                    "type": "message",
                    "messageType": "WafPSMLocation",
                    "repeated": true,
                    "description": "Positive Security Model locations. These are used to partition the application name space."
                },
                "hit_action": {
                    "type": "enum",
                    "enumType": "WafAction",
                    "default": "WAF_ACTION_ALLOW_PARAMETER",
                    "description": "If a rule in this group matches the match_value pattern, this action will be executed. Allowed actions are WAF_ACTION_NO_OP and WAF_ACTION_ALLOW_PARAMETER."
                },
                "miss_action": {
                    "type": "enum",
                    "enumType": "WafAction",
                    "default": "WAF_ACTION_NO_OP",
                    "description": "If a rule in this group does not match the match_value pattern, this action will be executed. Allowed actions are WAF_ACTION_NO_OP and WAF_ACTION_BLOCK."
                },
                "description": {
                    "type": "string",
                    "description": "Free-text comment about this group."
                },
                "is_learning_group": {
                    "type": "bool",
                    "default": false,
                    "description": "This field indicates that this group is used for learning.",
                    "immutable": true
                },
                "markers": {
                    "type": "message",
                    "messageType": "RoleFilterMatchLabel",
                    "repeated": true,
                    "description": "List of labels to be used for granular RBAC.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "location_match_miss_action": {
                    "type": "enum",
                    "enumType": "WafAction",
                    "default": "WAF_ACTION_NO_OP",
                    "description": "If there is no location matching the request, this action will be executed. Allowed actions are WAF_ACTION_NO_OP and WAF_ACTION_BLOCK."
                },
                "completely_described_match_elements": {
                    "type": "enum",
                    "enumType": "WafVariable",
                    "repeated": true,
                    "description": "A list of all match element collections which are completely described in the PSM Group. Every input value which matches one of the elements in this list but is not handled by a WAF PSM rule, will run the match_element miss_action. Allowed values are WAF_VARIABLE_ARGS.",
                    "maxRepeatedLength": 1
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                }
            }
        },
        "WafPSMLocation": {
            "fields": {
                "index": {
                    "type": "uint32",
                    "description": "Location index, this is used to determine the order of the locations.",
                    "required": true
                },
                "name": {
                    "type": "string",
                    "description": "User defined name for this location, it must be unique in the group.",
                    "required": true
                },
                "match": {
                    "type": "message",
                    "messageType": "WafPSMLocationMatch",
                    "description": "Apply these rules only if the request is matching this description."
                },
                "rules": {
                    "type": "message",
                    "messageType": "WafPSMRule",
                    "repeated": true,
                    "description": "A list of rules which should be applied on this location."
                },
                "description": {
                    "type": "string",
                    "description": "Free-text comment about this location."
                }
            },
            "repeatedKey": "name"
        },
        "WafPSMRule": {
            "fields": {
                "index": {
                    "type": "uint32",
                    "description": "Rule index, this is used to determine the order of the rules.",
                    "required": true
                },
                "rule_id": {
                    "type": "string",
                    "description": "Id field which is used for log and metric generation. This id must be unique for all rules in this group.",
                    "required": true
                },
                "name": {
                    "type": "string",
                    "description": "Name of the rule.",
                    "required": true
                },
                "enable": {
                    "type": "bool",
                    "default": true,
                    "description": "Enable or disable this rule."
                },
                "mode": {
                    "type": "enum",
                    "enumType": "WafMode",
                    "description": "WAF Rule mode. This can be detection or enforcement. If this is not set, the Policy mode is used. This only takes effect if the policy allows delegation."
                },
                "paranoia_level": {
                    "type": "enum",
                    "enumType": "WafParanoiaLevel",
                    "default": "WAF_PARANOIA_LEVEL_LOW",
                    "description": "WAF Ruleset paranoia mode. This is used to select Rules based on the paranoia-level."
                },
                "match_elements": {
                    "type": "message",
                    "messageType": "WafPSMMatchElement",
                    "repeated": true,
                    "description": "The match elements, for example ARGS:id or ARGS|!ARGS:password."
                },
                "match_value_max_length": {
                    "type": "uint32",
                    "description": "The maximum allowed length of the match_value. If this is not set, the length will not be checked."
                },
                "match_value_pattern": {
                    "type": "string",
                    "description": "A regular expression which describes the expected value."
                },
                "match_case": {
                    "type": "enum",
                    "enumType": "MatchCase",
                    "default": "INSENSITIVE",
                    "description": "The field match_value_pattern regular expression is case sensitive."
                },
                "description": {
                    "type": "string",
                    "description": "Free-text comment about this rule."
                },
                "match_value_string_group_uuid": {
                    "type": "string",
                    "description": "The UUID of a string group containing key used in match_value_string_group_key."
                },
                "match_value_string_group_key": {
                    "type": "string",
                    "description": "If match_value_string_group_uuid and match_value_string_group_key are set, the referenced regular expression is used as match_value_pattern."
                },
                "ignore_hit_action": {
                    "type": "bool",
                    "default": false,
                    "description": "If this is set, the hit action for this match will be WAF_ACTION_NO_OP."
                }
            },
            "repeatedKey": "rule_id"
        },
        "WafPSMMatchElement": {
            "fields": {
                "index": {
                    "type": "uint32",
                    "description": "Match_element index.",
                    "required": true
                },
                "name": {
                    "type": "enum",
                    "enumType": "WafVariable",
                    "description": "The variable specification. For example ARGS or REQUEST_COOKIES. This can be a scalar like PATH_INFO.",
                    "required": true
                },
                "sub_element": {
                    "type": "string",
                    "description": "The name of the request collection element. This can be empty, if we address the whole collection or a scalar element."
                },
                "excluded": {
                    "type": "bool",
                    "default": false,
                    "description": "Mark this element excluded, like in '!ARGS:password'."
                },
                "match_op": {
                    "type": "enum",
                    "enumType": "StringOperation",
                    "default": "EQUALS",
                    "description": "String operation to use for matching the sub_element. Default is EQUALS."
                },
                "match_case": {
                    "type": "enum",
                    "enumType": "MatchCase",
                    "default": "INSENSITIVE",
                    "description": "Case sensitivity of match_op operation."
                }
            },
            "repeatedKey": "index"
        },
        "WafPSMLocationMatch": {
            "fields": {
                "methods": {
                    "type": "message",
                    "messageType": "MethodMatch",
                    "description": "Apply the rules only to requests that have the specified methods. If this is not set, the method will not be checked."
                },
                "path": {
                    "type": "message",
                    "messageType": "PathMatch",
                    "description": "Apply the rules only to requests that match the specified URI. If this is not set, the path will not be checked."
                },
                "host": {
                    "type": "message",
                    "messageType": "HostHdrMatch",
                    "description": "Apply the rules only to requests that match the specified Host header. If this is not set, the host header will not be checked."
                }
            }
        },
        "WafProfile": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "required": true
                },
                "name": {
                    "type": "string",
                    "required": true,
                    "maxStringLength": 256
                },
                "description": {
                    "type": "string"
                },
                "tenant_uuid": {
                    "type": "string",
                    "required": true
                },
                "config": {
                    "type": "message",
                    "messageType": "WafConfig",
                    "description": "Config params for WAF.",
                    "required": true
                },
                "files": {
                    "type": "message",
                    "messageType": "WafDataFile",
                    "repeated": true,
                    "description": "List of Data Files Used for WAF Rules."
                },
                "markers": {
                    "type": "message",
                    "messageType": "RoleFilterMatchLabel",
                    "repeated": true,
                    "description": "List of labels to be used for granular RBAC.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                }
            }
        },
        "WafConfig": {
            "fields": {
                "request_hdr_default_action": {
                    "type": "string",
                    "default": "phase:1,deny,status:403,log,auditlog",
                    "description": "WAF default action for Request Header Phase.",
                    "required": true
                },
                "request_body_default_action": {
                    "type": "string",
                    "default": "phase:2,deny,status:403,log,auditlog",
                    "description": "WAF default action for Request Body Phase.",
                    "required": true
                },
                "response_hdr_default_action": {
                    "type": "string",
                    "default": "phase:3,deny,status:403,log,auditlog",
                    "description": "WAF default action for Response Header Phase.",
                    "required": true
                },
                "response_body_default_action": {
                    "type": "string",
                    "default": "phase:4,deny,status:403,log,auditlog",
                    "description": "WAF default action for Response Body Phase.",
                    "required": true
                },
                "allowed_http_versions": {
                    "type": "enum",
                    "enumType": "HTTPVersion",
                    "repeated": true,
                    "description": "WAF allowed HTTP Versions.",
                    "maxRepeatedLength": 8
                },
                "allowed_methods": {
                    "type": "enum",
                    "enumType": "HTTPMethod",
                    "repeated": true,
                    "description": "WAF allowed HTTP methods."
                },
                "restricted_extensions": {
                    "type": "string",
                    "repeated": true,
                    "description": "WAF Restricted File Extensions.",
                    "maxStringLength": 128
                },
                "restricted_headers": {
                    "type": "string",
                    "repeated": true,
                    "description": "WAF Restricted HTTP Headers.",
                    "maxStringLength": 128
                },
                "static_extensions": {
                    "type": "string",
                    "repeated": true,
                    "description": "WAF Static File Extensions. GET and HEAD requests with no query args and one of these extensions are allowed and not checked by the ruleset.",
                    "maxStringLength": 128
                },
                "server_response_max_body_size": {
                    "type": "uint32",
                    "default": 128,
                    "description": "Maximum size for response body scanned by WAF",
                    "min": 1,
                    "max": 32768
                },
                "argument_separator": {
                    "type": "string",
                    "default": "&",
                    "description": "Argument seperator"
                },
                "cookie_format_version": {
                    "type": "uint32",
                    "default": 0,
                    "description": "0: For Netscape Cookies. 1: For version 1 cookies.",
                    "min": 0,
                    "max": 1
                },
                "regex_match_limit": {
                    "type": "uint32",
                    "default": 30000,
                    "description": "Limit CPU utilization for each regular expression match when processing rules"
                },
                "max_execution_time": {
                    "type": "uint32",
                    "default": 50,
                    "description": "The maximum period of time WAF processing is allowed to take for a single request. A value of 0 (zero) means no limit and should not be chosen in production deployments. It is only used for exceptional situations where crashes of se_dp processes are acceptable. The behavior of the system if this time is exceeded depends on two other configuration settings, the WAF policy mode and the WAF failure mode. In WAF policy mode 'Detection', the request is allowed and flagged for both failure mode 'Closed' and 'Open'. In enforcement node, 'Closed' means the request is rejected, 'Open' means the request is allowed and flagged. Irrespective of these settings, no subsequent WAF rules of this or other phases will be executed once the maximum execution time has been exceeded.",
                    "min": 0,
                    "max": 5000,
                    "specialValues": {
                        "0": "Do not apply this restriction."
                    }
                },
                "client_request_max_body_size": {
                    "type": "uint32",
                    "default": 32,
                    "description": "Maximum size for the client request body scanned by WAF",
                    "min": 1,
                    "max": 32768
                },
                "ignore_incomplete_request_body_error": {
                    "type": "bool",
                    "default": true,
                    "description": "Ignore request body parsing errors due to partial scanning"
                },
                "status_code_for_rejected_requests": {
                    "type": "enum",
                    "enumType": "HTTPResponseCodes",
                    "default": "HTTP_RESPONSE_CODE_403",
                    "description": "HTTP status code used by WAF Positive Security Model when rejecting a request."
                },
                "regex_recursion_limit": {
                    "type": "uint32",
                    "default": 10000,
                    "description": "Limit depth of recursion for each regular expression match when processing rules"
                },
                "xml_xxe_protection": {
                    "type": "bool",
                    "default": true,
                    "description": "Block or flag XML requests referring to External Entities."
                },
                "status_header_name": {
                    "type": "string",
                    "default": "X-WAF-Result",
                    "description": "The name of the request header indicating WAF evaluation status to pool servers."
                },
                "send_status_header": {
                    "type": "bool",
                    "default": false,
                    "description": "Whether or not to send WAF status in a request header to pool servers."
                },
                "content_type_mappings": {
                    "type": "message",
                    "messageType": "WafContentTypeMapping",
                    "repeated": true,
                    "description": "WAF Content-Types and their request body parsers. Use this field to configure which Content-Types should be handled by WAF and which parser should be used. All Content-Types here are treated as 'allowed'. The order of entries matters. If the request's Content-Type matches an entry, its request body parser will run and no other parser will be invoked."
                },
                "allowed_request_content_type_charsets": {
                    "type": "string",
                    "repeated": true,
                    "description": "Allowed request content type character sets in WAF.",
                    "maxStringLength": 128
                },
                "xml_collection": {
                    "type": "enum",
                    "enumType": "WafXmlCollection",
                    "default": "WAF_XML_COLLECTION_XML",
                    "description": "Collection variable set by the XML request body parser."
                },
                "enforce_max_body_size": {
                    "type": "bool",
                    "default": false,
                    "description": "Flag or Reject the client request if it exceeds client_request_max_body_size."
                },
                "enable_json_parsing_limits": {
                    "type": "bool",
                    "default": false,
                    "description": "If this is set, the limits from the json_parsing_limit section are checked on parsing. "
                },
                "json_parsing_limits": {
                    "type": "message",
                    "messageType": "JsonParsingLimits",
                    "description": "The parsing limits for JSON objects. If one of theses limits is exceeded, parsing will stop generating new key-value pairs for WAF and will set the REQUEST_BODY_ERROR variable to indicate this. However, it will continue the parsing itself to detect problems in the structure of the JSON body."
                },
                "match_element_sub_parsers": {
                    "type": "message",
                    "messageType": "WafMatchElementSubParser",
                    "repeated": true,
                    "description": "Every match element listed here will be parsed by a second parser. This happens non-recursivly."
                }
            }
        },
        "WafMatchElementSubParser": {
            "fields": {
                "index": {
                    "type": "uint32",
                    "description": "Determine the order of the rules.",
                    "required": true
                },
                "match_element": {
                    "type": "string",
                    "description": "The match element for which a subparser can be specified. Allowed values are of the form 'ARGS:name' where name can be any string or a regular expression.",
                    "maxStringLength": 128,
                    "required": true
                },
                "match_op": {
                    "type": "enum",
                    "enumType": "StringOperation",
                    "default": "EQUALS",
                    "description": "String Operation to use for matching the match element name. Allowed values are EQUALS and REGEX_MATCH."
                },
                "match_case": {
                    "type": "enum",
                    "enumType": "MatchCase",
                    "default": "SENSITIVE",
                    "description": "Case sensitivity to use for the matching."
                },
                "sub_parser": {
                    "type": "enum",
                    "enumType": "WafRequestParser",
                    "default": "WAF_REQUEST_PARSER_AUTO_DETECT",
                    "description": "Select the parser for this element. Allowed values are JSON, XML and AUTO_DETECT."
                }
            },
            "repeatedKey": "index"
        },
        "JsonParsingLimits": {
            "fields": {
                "max_nesting_level": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Maximum nesting level of a json document. 0 means no restriction.",
                    "min": 0,
                    "max": 256,
                    "specialValues": {
                        "0": "Do not apply this restriction."
                    }
                },
                "max_value_length": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Maximum length of a single value (string). 0 means no restriction.",
                    "min": 0,
                    "max": 1048576,
                    "specialValues": {
                        "0": "Do not apply this restriction."
                    }
                },
                "max_subelements": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Maximum number of elements in an array or object. 0 means no restriction.",
                    "min": 0,
                    "max": 1048576,
                    "specialValues": {
                        "0": "Do not apply this restriction."
                    }
                },
                "max_total_elements": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Maximum number of all elements in the whole document. 0 means no restriction.",
                    "min": 0,
                    "max": 1048576,
                    "specialValues": {
                        "0": "Do not apply this restriction."
                    }
                }
            }
        },
        "WafContentTypeMapping": {
            "fields": {
                "content_type": {
                    "type": "string",
                    "description": "Request Content-Type. When it is equal to request Content-Type header value, the specified request_body_parser is used.",
                    "maxStringLength": 128,
                    "required": true
                },
                "request_body_parser": {
                    "type": "enum",
                    "enumType": "WafRequestParser",
                    "description": "Request body parser.",
                    "required": true
                },
                "match_op": {
                    "type": "enum",
                    "enumType": "StringOperation",
                    "default": "EQUALS",
                    "description": "String operation to use for matching the content_type. Only EQUALS and REGEX_MATCH are supported string operations here. All EQUALS matches are checked before REGEX_MATCH matches."
                }
            }
        },
        "SystemReport": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "description": "UUID Identifier for the report",
                    "maxStringLength": 256
                },
                "name": {
                    "type": "string",
                    "description": "Name of the report derived from operation in a readable format. Ex: upgrade_system_1a5c",
                    "maxStringLength": 256
                },
                "tenant_uuid": {
                    "type": "string",
                    "description": "Tenant UUID associated with the Object",
                    "maxStringLength": 256
                },
                "image_uuid": {
                    "type": "string",
                    "description": "System Image associated with the report",
                    "maxStringLength": 256
                },
                "controller_patch_image_uuid": {
                    "type": "string",
                    "description": "Controller Patch Image associated with the report",
                    "maxStringLength": 256
                },
                "se_patch_image_uuid": {
                    "type": "string",
                    "description": "SE Patch Image associated with the report",
                    "maxStringLength": 256
                },
                "state": {
                    "type": "message",
                    "messageType": "ReportOpsState",
                    "description": "Report state combines all applicable states. Ex: readiness_reports.system_readiness.state."
                },
                "downloadable": {
                    "type": "bool",
                    "default": false,
                    "description": "Indicates whether this report is downloadable as an archive"
                },
                "archive_ref": {
                    "type": "string",
                    "description": "Relative path to the report archive file on filesystem.The archive includes exported system configuration and current object as json.",
                    "maxStringLength": 1024
                },
                "summary": {
                    "type": "message",
                    "messageType": "ReportSummary",
                    "description": "Summary of the report"
                },
                "readiness_reports": {
                    "type": "message",
                    "messageType": "ReportDetail",
                    "repeated": true,
                    "description": "Readiness state of the system. Ex: Upgrade Pre-check Results"
                },
                "events": {
                    "type": "message",
                    "messageType": "ReportEvent",
                    "repeated": true,
                    "description": "List of events associated with the report"
                },
                "tasks": {
                    "type": "message",
                    "messageType": "ReportTask",
                    "repeated": true,
                    "description": "List of tasks associated with the report"
                },
                "dryrun_info": {
                    "type": "message",
                    "messageType": "DryrunInfo",
                    "description": "Dry-run report."
                },
                "operation": {
                    "type": "string",
                    "description": "Nature of operation. Ex: Controller Upgrade, System Patch, etc.",
                    "maxStringLength": 256
                },
                "type": {
                    "type": "string",
                    "description": "Type of report. Pre-Checks, Dry-run or an upgrade operation.",
                    "maxStringLength": 256
                }
            }
        },
        "DryrunInfo": {
            "fields": {
                "state": {
                    "type": "message",
                    "messageType": "UpgradeOpsState",
                    "description": "Current status of the dry-run operation."
                },
                "operation": {
                    "type": "enum",
                    "enumType": "UpgradeOpsType",
                    "description": "Dryrun operations requested."
                },
                "params": {
                    "type": "message",
                    "messageType": "UpgradeParams",
                    "description": "Parameters for performing the dry-run operation."
                },
                "worker": {
                    "type": "string",
                    "description": "Node on which the dry-run is performed.",
                    "maxStringLength": 256
                },
                "start_time": {
                    "type": "string",
                    "description": "Start time of dry-run operation.",
                    "maxStringLength": 256
                },
                "end_time": {
                    "type": "string",
                    "description": "End time of dry-run operation.",
                    "maxStringLength": 256
                },
                "duration": {
                    "type": "int32",
                    "description": "Duration of dry-run operation in seconds."
                },
                "total_tasks": {
                    "type": "int32",
                    "description": "Total number of tasks in the Upgrade operation."
                },
                "tasks_completed": {
                    "type": "int32",
                    "description": "Completed set of tasks in the Upgrade operation."
                },
                "progress": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Dry-run operations progress which holds value between 0-100",
                    "min": 0,
                    "max": 100
                },
                "upgrade_events": {
                    "type": "message",
                    "messageType": "EventMap",
                    "repeated": true,
                    "description": "Controller events for dry-run operation."
                }
            }
        },
        "EventMap": {
            "fields": {
                "task": {
                    "type": "enum",
                    "enumType": "UpgradeTasks",
                    "description": "Enum representing the task.(Not in use)."
                },
                "nodes_events": {
                    "type": "message",
                    "messageType": "UpgradeEvent",
                    "repeated": true,
                    "description": "List of all events node wise.(Not in use)."
                },
                "task_name": {
                    "type": "string",
                    "description": "Name representing the task."
                },
                "sub_events": {
                    "type": "message",
                    "messageType": "UpgradeEvent",
                    "repeated": true,
                    "description": "List of all events node wise."
                }
            }
        },
        "UpgradeEvent": {
            "fields": {
                "ip": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "description": "Ip of the node."
                },
                "start_time": {
                    "type": "string",
                    "description": "Task start time."
                },
                "end_time": {
                    "type": "string",
                    "description": "Task end time."
                },
                "status": {
                    "type": "bool",
                    "default": false,
                    "description": "Upgrade event status."
                },
                "message": {
                    "type": "string",
                    "description": "Upgrade event message if any."
                },
                "duration": {
                    "type": "uint32",
                    "description": "Time taken to complete upgrade event in seconds."
                },
                "sub_tasks": {
                    "type": "string",
                    "repeated": true,
                    "description": "Sub tasks executed on each node."
                }
            }
        },
        "ReportTask": {
            "fields": {
                "name": {
                    "type": "string",
                    "description": "Name for the Task journal",
                    "maxStringLength": 256,
                    "required": true
                },
                "reason": {
                    "type": "string",
                    "description": "Reason in case of failure",
                    "maxStringLength": 1024
                },
                "summary": {
                    "type": "message",
                    "messageType": "JournalSummary",
                    "description": "Copy of journal summary for immediate visibility."
                },
                "task_journal_uuid": {
                    "type": "string",
                    "description": "Journal reference for the task.",
                    "maxStringLength": 256
                }
            }
        },
        "JournalSummary": {
            "fields": {
                "type": {
                    "type": "string",
                    "description": "Process Type.",
                    "maxStringLength": 256,
                    "required": true
                },
                "description": {
                    "type": "string",
                    "description": "Description of the process.",
                    "maxStringLength": 1024
                },
                "start_time": {
                    "type": "string",
                    "description": "Start time of the process.",
                    "maxStringLength": 512
                },
                "end_time": {
                    "type": "string",
                    "description": "End time of the process.",
                    "maxStringLength": 512
                },
                "duration": {
                    "type": "uint32",
                    "description": "Duration of the process in seconds."
                },
                "status": {
                    "type": "string",
                    "description": "Status of the process.",
                    "maxStringLength": 256
                },
                "reason": {
                    "type": "string",
                    "description": "Summary reason for process.",
                    "maxStringLength": 1024
                },
                "error_count": {
                    "type": "uint32",
                    "description": "Number of errors in the process."
                },
                "warning_count": {
                    "type": "uint32",
                    "description": "Number of warnings in the process."
                },
                "state": {
                    "type": "enum",
                    "enumType": "TaskState",
                    "description": "State of the Journal Summary."
                }
            }
        },
        "ReportEvent": {
            "fields": {
                "event_name": {
                    "type": "string",
                    "description": "Name representing the event.",
                    "maxStringLength": 512
                },
                "start_time": {
                    "type": "string",
                    "description": "Event start time.",
                    "maxStringLength": 512
                },
                "end_time": {
                    "type": "string",
                    "description": "Event end time.",
                    "maxStringLength": 512
                },
                "duration": {
                    "type": "uint32",
                    "description": "Time taken to complete event in seconds."
                },
                "status": {
                    "type": "enum",
                    "enumType": "Syserr",
                    "description": "Event status."
                },
                "messages": {
                    "type": "string",
                    "repeated": true,
                    "description": "Event message if any.",
                    "maxStringLength": 65536
                }
            }
        },
        "ReportDetail": {
            "fields": {
                "node_uuid": {
                    "type": "string",
                    "description": "UUID Identifier for the node such as cluster, se group or se.",
                    "maxStringLength": 256
                },
                "name": {
                    "type": "string",
                    "description": "Name of the node such as cluster name, se group name or se name.",
                    "maxStringLength": 256
                },
                "obj_cloud_uuid": {
                    "type": "string",
                    "description": "Cloud that this object belongs to.",
                    "maxStringLength": 256
                },
                "node_type": {
                    "type": "enum",
                    "enumType": "NodeType",
                    "description": "Type of the system such as controller_cluster, se_group or se."
                },
                "system_readiness": {
                    "type": "message",
                    "messageType": "UpgradeReadinessCheckObj",
                    "description": "System readiness check detail"
                }
            }
        },
        "UpgradeReadinessCheckObj": {
            "fields": {
                "state": {
                    "type": "message",
                    "messageType": "UpgradeOpsState",
                    "description": "The Upgrade readiness check operations current fsm-state."
                },
                "checks": {
                    "type": "message",
                    "messageType": "MustChecksInfo",
                    "repeated": true,
                    "description": "List of Upgrade readiness check exceptions."
                },
                "start_time": {
                    "type": "string",
                    "description": "Time at which execution of upgrade readiness checks was started.",
                    "maxStringLength": 128
                },
                "end_time": {
                    "type": "string",
                    "description": "Time at which execution of upgrade readiness checks was completed.",
                    "maxStringLength": 128
                },
                "duration": {
                    "type": "uint32",
                    "description": "Time taken to complete upgrade readiness checks in seconds."
                },
                "upgrade_ops": {
                    "type": "enum",
                    "enumType": "UpgradeOpsType",
                    "description": "Upgrade operations along with type requested such as UpgradeSystem UpgradeController etc."
                },
                "image_uuid": {
                    "type": "string",
                    "description": "Image uuid for identifying the next base image.",
                    "maxStringLength": 128
                },
                "patch_image_uuid": {
                    "type": "string",
                    "description": "Image uuid for identifying the next patch.",
                    "maxStringLength": 128
                },
                "total_checks": {
                    "type": "int32",
                    "description": "Total no. of checks."
                },
                "checks_completed": {
                    "type": "int32",
                    "description": "No. of checks completed."
                },
                "progress": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Checks progress which holds value between 0-100",
                    "min": 0,
                    "max": 100
                }
            }
        },
        "MustChecksInfo": {
            "fields": {
                "check_code": {
                    "type": "enum",
                    "enumType": "Syserr",
                    "description": "Syserr status code of the must check."
                },
                "description": {
                    "type": "string",
                    "description": "Reason for must check failure.",
                    "maxStringLength": 128
                },
                "details": {
                    "type": "string",
                    "repeated": true,
                    "description": "Additional details of the must check.",
                    "maxStringLength": 128
                },
                "state": {
                    "type": "enum",
                    "enumType": "UpgradeFsmState",
                    "description": "The must check operations current fsm-state."
                },
                "start_time": {
                    "type": "string",
                    "description": "Time at which execution of must check was started.",
                    "maxStringLength": 128
                },
                "end_time": {
                    "type": "string",
                    "description": "Time at which execution of must check was completed.",
                    "maxStringLength": 128
                },
                "duration": {
                    "type": "uint32",
                    "description": "Time taken to complete must check in seconds."
                },
                "error_details": {
                    "type": "string",
                    "repeated": true,
                    "description": "Error/Failure details of the must check.",
                    "maxStringLength": 128
                }
            }
        },
        "ReportSummary": {
            "fields": {
                "title": {
                    "type": "string",
                    "description": "User friendly title for the report.",
                    "maxStringLength": 1024
                },
                "description": {
                    "type": "string",
                    "description": "Detailed description of the report.",
                    "maxStringLength": 65536
                },
                "previews": {
                    "type": "string",
                    "repeated": true,
                    "description": "Preview of the operations performed in the report. Ex: Upgrade Pre-check Previews.",
                    "maxStringLength": 1024
                }
            }
        },
        "ReportOpsState": {
            "fields": {
                "state": {
                    "type": "enum",
                    "enumType": "ReportState",
                    "description": "The system operation's current fsm-state."
                },
                "last_changed_time": {
                    "type": "message",
                    "messageType": "TimeStamp",
                    "description": "The last time the state changed."
                },
                "reason": {
                    "type": "string",
                    "description": "Descriptive reason for the state-change.",
                    "maxStringLength": 65536
                }
            }
        },
        "Webhook": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "required": true,
                    "description": "UUID of the webhook profile"
                },
                "name": {
                    "type": "string",
                    "required": true,
                    "description": "The name of the webhook profile",
                    "maxStringLength": 256
                },
                "callback_url": {
                    "type": "string",
                    "description": "Callback URL for the Webhook"
                },
                "verification_token": {
                    "type": "string",
                    "description": "Verification token sent back with the callback asquery parameters"
                },
                "markers": {
                    "type": "message",
                    "messageType": "RoleFilterMatchLabel",
                    "repeated": true,
                    "description": "List of labels to be used for granular RBAC.",
                    "fieldLicenses": [
                        {
                            "tier": "ESSENTIALS",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "BASIC",
                            "allowed": "ALLOW_ANY"
                        },
                        {
                            "tier": "ENTERPRISE",
                            "allowed": "ALLOW_DEFAULT"
                        },
                        {
                            "tier": "ENTERPRISE_WITH_CLOUD_SERVICES",
                            "allowed": "ALLOW_DEFAULT"
                        }
                    ]
                },
                "description": {
                    "type": "string"
                },
                "tenant_uuid": {
                    "type": "string",
                    "required": true
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                }
            }
        },
        "TenantSystemConfiguration": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "description": "Tenant System Configuration UUID.",
                    "maxStringLength": 255,
                    "required": true
                },
                "name": {
                    "type": "string",
                    "description": "Name of the Tenant System Configuration object.",
                    "maxStringLength": 255,
                    "required": true
                },
                "tenant_uuid": {
                    "type": "string",
                    "description": "Unique Identifier of the tenant that this object belongs to.",
                    "maxStringLength": 255
                },
                "dns_virtualservice_uuids": {
                    "type": "string",
                    "repeated": true,
                    "description": "DNS virtual services hosting FQDN records for applications configured within this tenant.",
                    "maxStringLength": 255
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                }
            }
        },
        "TrustedHostProfile": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "description": "TrustedHostProfile UUID",
                    "maxStringLength": 256,
                    "required": true
                },
                "name": {
                    "type": "string",
                    "description": "TrustedHostProfile name",
                    "maxStringLength": 256,
                    "required": true
                },
                "hosts": {
                    "type": "message",
                    "messageType": "TrustedHost",
                    "repeated": true,
                    "description": "List of Host IP(v4/v6) addresses or FQDNs",
                    "maxRepeatedLength": 20,
                    "minRepeatedLength": 1,
                    "required": true
                },
                "tenant_uuid": {
                    "type": "string",
                    "default": "admin",
                    "description": "Tenant ref for trusted host profile",
                    "maxStringLength": 256
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                }
            }
        },
        "TrustedHost": {
            "fields": {
                "host": {
                    "type": "message",
                    "messageType": "IpAddr",
                    "description": "Any valid IPv4, IPv6, or domain address.",
                    "required": true
                },
                "port": {
                    "type": "int32",
                    "description": "Optionally specify the port number.",
                    "min": 1,
                    "max": 65535
                }
            },
            "repeatedKey": "host,port"
        },
        "UpgradeProfile": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "description": "UUID Identifier for the UpgradeProfile object.",
                    "maxStringLength": 256,
                    "required": true
                },
                "service_engine": {
                    "type": "message",
                    "messageType": "ServiceEngineParams",
                    "description": "List of service engine upgrade related configurable parameters."
                },
                "image": {
                    "type": "message",
                    "messageType": "ImageParams",
                    "description": "List of image related configurable parameters."
                },
                "dry_run": {
                    "type": "message",
                    "messageType": "DryRunParams",
                    "description": "List of dryrun related configurable parameters."
                },
                "pre_checks": {
                    "type": "message",
                    "messageType": "PreChecksParams",
                    "description": "List of upgrade pre-checks related configurable parameters."
                },
                "controller_params": {
                    "type": "message",
                    "messageType": "ControllerParams",
                    "description": "List of controller upgrade related configurable parameters."
                }
            }
        },
        "ControllerParams": {
            "fields": {
                "task_base_timeout": {
                    "type": "uint32",
                    "default": 300,
                    "description": "Base timeout value for all controller-specific upgrade operation tasks. The timeout value for each task is a multiple of task_base_timeout. For example, SwitchAndReboot task timeout = [multiplier] * task_base_timeout. (The multiplier varies by task.)",
                    "min": 300,
                    "max": 3600
                }
            }
        },
        "PreChecksParams": {
            "fields": {
                "max_alerts": {
                    "type": "uint32",
                    "default": 200,
                    "description": "Maximum number of alerts allowed for configuration export.",
                    "min": 200,
                    "max": 500
                },
                "checks_base_timeout": {
                    "type": "uint32",
                    "default": 60,
                    "description": "Base timeout value for all upgrade pre-checks operations. The timeout value for applicable checks is a multiple of checks_base_timeout. For example, config export timeout = [multiplier] * checks_base_timeout. (The multiplier varies by operation.)"
                }
            }
        },
        "DryRunParams": {
            "fields": {
                "preferred_worker": {
                    "type": "string",
                    "description": "VM hostname of the preferred worker node. Example: node2.controller.local. When configured, dry-run is performed on specified node. When not configured, one of the follower node is elected for dry-run.",
                    "maxStringLength": 255
                },
                "num_cpu": {
                    "type": "uint32",
                    "default": 2,
                    "description": "Number of CPU(s) allocated for dry-run."
                },
                "memory": {
                    "type": "float",
                    "default": 6,
                    "description": "Amount of memory allocated for dry-run."
                },
                "allow_single_node": {
                    "type": "bool",
                    "default": false,
                    "description": "Allow dry-run operation on single node controller."
                }
            }
        },
        "ImageParams": {
            "fields": {
                "max_image_size": {
                    "type": "uint32",
                    "default": 10,
                    "description": "Maximum permitted size for image uploads.",
                    "min": 10,
                    "max": 15
                },
                "image_replication_timeout": {
                    "type": "uint32",
                    "default": 600,
                    "description": "Maximum wait time to replicate image files from Leader to followers.",
                    "min": 600,
                    "max": 3600
                }
            }
        },
        "ServiceEngineParams": {
            "fields": {
                "task_base_timeout": {
                    "type": "uint32",
                    "default": 300,
                    "description": "Base timeout value for all service engine upgrade operation tasks. The timeout for certain tasks is a multiple of this field. For example, in the CopyAndInstallImage task, the ServiceEngine has a maximum wait time to install an image or package, i.e., timeout = [scaling factor] * task_base_timeout.",
                    "min": 300,
                    "max": 3600
                },
                "simultaneous_image_downloads": {
                    "type": "uint32",
                    "default": 5,
                    "description": "Number of simultaneous ServiceEngine image downloads in a ServiceEngineGroup. It is used to pace ServiceEngine upgrade package downloads so that controller network/CPU bandwidth is a bounded operation.",
                    "min": 1,
                    "max": 20
                },
                "image_data_transfer_size": {
                    "type": "uint32",
                    "default": 512,
                    "description": "This parameter defines the buffer size during ServiceEngine image downloads in a ServiceEngineGroup.It is used to pace the ServiceEngine upgrade package downloads so that controller network/CPU/Memory bandwidth is a bounded operation. It generally specifies the buffer size used for data transfer.",
                    "min": 64,
                    "max": 2048
                },
                "concurrent_segroup_upgrades": {
                    "type": "uint32",
                    "default": 8,
                    "description": "This parameter is used to control the number of concurrent segroup upgrades. This field value takes affect upon controller warm reboot. The value is modified based on flavor size of controller.",
                    "min": 1,
                    "max": 24
                },
                "se_connect_timeout": {
                    "type": "uint32",
                    "default": 600,
                    "description": "Amount of time Controller waits for a regular-sized SE (<128GB memory)to reconnect after it is rebooted during upgrade.",
                    "min": 600,
                    "max": 1200
                },
                "large_se_connect_timeout": {
                    "type": "uint32",
                    "default": 1200,
                    "description": "Amount of time Controller waits for a large-sized SE (>=128GB memory)to reconnect after it is rebooted during upgrade.",
                    "min": 1200,
                    "max": 2400
                }
            }
        },
        "TechSupport": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "description": "UUID Identifier for the techsupport invocation.",
                    "maxStringLength": 256
                },
                "name": {
                    "type": "string",
                    "description": "Name of techsupport invocation.",
                    "maxStringLength": 256
                },
                "state": {
                    "type": "message",
                    "messageType": "TechSupportState",
                    "description": "State of current/last techsupport invocation."
                },
                "level": {
                    "type": "string",
                    "description": "Name of the techsupport level.",
                    "maxStringLength": 256
                },
                "obj_uuid": {
                    "type": "string",
                    "description": "Techsupport collection object uuid specified for different objects such as SE/VS/Pool etc.",
                    "maxStringLength": 256
                },
                "obj_name": {
                    "type": "string",
                    "description": "Object name if one exists.",
                    "maxStringLength": 256
                },
                "tasks": {
                    "type": "message",
                    "messageType": "TechSupportEventMap",
                    "repeated": true,
                    "description": "Events performed for techsupport collection."
                },
                "total_tasks": {
                    "type": "int32",
                    "description": "Total number of tasks in the techsupport collection."
                },
                "tasks_completed": {
                    "type": "int32",
                    "description": "Completed set of tasks in the techsupport collection."
                },
                "progress": {
                    "type": "uint32",
                    "default": 0,
                    "description": "Techsupport collection progress which holds value between 0-100.",
                    "min": 0,
                    "max": 100
                },
                "errors": {
                    "type": "string",
                    "repeated": true,
                    "description": "Error logged during techsupport collection.",
                    "maxStringLength": 256
                },
                "warnings": {
                    "type": "string",
                    "repeated": true,
                    "description": "Warning logged during techsupport collection.",
                    "maxStringLength": 256
                },
                "case_number": {
                    "type": "string",
                    "description": "'Customer case number for which this techsupport is generated. ''Useful for connected portal and other use-cases.'",
                    "maxStringLength": 256
                },
                "description": {
                    "type": "string",
                    "description": "User provided description to capture additional details and context regarding the techsupport invocation.",
                    "maxStringLength": 256
                },
                "node": {
                    "type": "string",
                    "description": "Cluster member node on which the techsupport tarball bundle is saved.",
                    "maxStringLength": 256
                },
                "techsupport_readiness": {
                    "type": "message",
                    "messageType": "ReadinessCheckObj",
                    "description": "Techsupport readiness checks execution details."
                },
                "start_time": {
                    "type": "string",
                    "description": "Start timestamp of techsupport collection.",
                    "maxStringLength": 128
                },
                "end_time": {
                    "type": "string",
                    "description": "End timestamp of techsupport collection.",
                    "maxStringLength": 128
                },
                "duration": {
                    "type": "uint32",
                    "description": "Total time taken for techsupport collection."
                },
                "params": {
                    "type": "message",
                    "messageType": "TechSupportParams",
                    "description": "Techsupport params associated with latest techsupport collection. User passed params will have more preference."
                },
                "output": {
                    "type": "string",
                    "description": "Techsupport collection output file path.",
                    "maxStringLength": 256
                },
                "size": {
                    "type": "Unknown",
                    "description": "Size of collected techsupport tarball.",
                    "maxStringLength": 256
                },
                "tenant_uuid": {
                    "type": "string",
                    "description": "Tenant UUID associated with the techsupport.",
                    "maxStringLength": 256
                }
            }
        },
        "TechSupportParams": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "description": "Techsupport uuid for RPC related requirements.",
                    "maxStringLength": 256
                },
                "level": {
                    "type": "string",
                    "description": "Techsupport collection level.",
                    "maxStringLength": 256
                },
                "slug": {
                    "type": "string",
                    "description": "Techsupport collection slug; Typically uuid of a vs, gslb etc.",
                    "maxStringLength": 256
                },
                "start_timestamp": {
                    "type": "string",
                    "description": "Start timestamp of techsupport collection.",
                    "maxStringLength": 256
                },
                "case_number": {
                    "type": "string",
                    "description": "'Customer case number for which this techsupport is generated. ''Useful for connected portal and other use-cases.'",
                    "maxStringLength": 256
                },
                "duration": {
                    "type": "string",
                    "description": "Collect events based on duration, specify one from choices [m, h, d, w]. i.e. minutes, hours, days, weeks. e.g. 10m, 5h, 2d, 1w. e.g. techsupport debuglogs duration 30m",
                    "maxStringLength": 256
                },
                "description": {
                    "type": "string",
                    "description": "User provided description to capture additional details and context regarding the techsupport invocation.",
                    "maxStringLength": 256
                },
                "skip_warnings": {
                    "type": "bool",
                    "description": "Use this flag for skippable warnings.",
                    "maxStringLength": 256
                },
                "pattern": {
                    "type": "string",
                    "description": "Specify pattern to collect specific info in techsupport. User can specify error patterns to filter files based on pattern only. This way will reduce unnecessary collection.",
                    "maxStringLength": 256
                },
                "event_params": {
                    "type": "message",
                    "messageType": "TechSupportEventParams",
                    "description": "Specify this params to set threshold for all event files. User provided parameters will take precedence over the profile parameters."
                },
                "name": {
                    "type": "string",
                    "description": "Name of the objects like service engine, vs, pool etc.",
                    "maxStringLength": 256
                },
                "tenant": {
                    "type": "string",
                    "description": "X-Avi-Tenant of HTTP POST request for authentication. Always admin for now, can be override in the future.",
                    "maxStringLength": 256
                }
            }
        },
        "TechSupportEventParams": {
            "fields": {
                "days": {
                    "type": "uint32",
                    "default": 2,
                    "description": "Collect events for the specified number of past days. e.g. User specified 3, collect events for past 3 days. If have 20 files with 3 days old then collect on basis of specified number of files.",
                    "min": 1,
                    "max": 5
                },
                "files": {
                    "type": "uint32",
                    "default": 8,
                    "description": "Collect events for the specified number of files. e.g. User specified 5, collect atmost 5 events files. If have 10 files with 2 days old then collect only specified number of files.",
                    "min": 1,
                    "max": 10
                },
                "collect_all_events": {
                    "type": "bool",
                    "default": false,
                    "description": "Collect all events agnostic of duration, days and files. This flag will have higher precedence over duration, files and days. If flag is false then precedence given to duration passed while invocation."
                }
            }
        },
        "TechSupportEventMap": {
            "fields": {
                "task_name": {
                    "type": "string",
                    "description": "Name of the task.",
                    "maxStringLength": 128
                },
                "description": {
                    "type": "string",
                    "description": "Task description if any.",
                    "maxStringLength": 512
                },
                "start_time": {
                    "type": "string",
                    "description": "Start timestamp of techsupport collection.",
                    "maxStringLength": 128
                },
                "end_time": {
                    "type": "string",
                    "description": "End timestamp of techsupport collection.",
                    "maxStringLength": 128
                },
                "duration": {
                    "type": "uint32",
                    "description": "Duration of techsupport collection."
                },
                "sub_events": {
                    "type": "message",
                    "messageType": "UpgradeEvent",
                    "repeated": true,
                    "description": "List of all events node wise."
                },
                "status": {
                    "type": "enum",
                    "enumType": "Syserr",
                    "description": "Task status."
                },
                "details": {
                    "type": "string",
                    "repeated": true,
                    "description": "Additional details of the task.",
                    "maxStringLength": 128
                }
            }
        },
        "TechSupportState": {
            "fields": {
                "state": {
                    "type": "enum",
                    "enumType": "TechSupportFsmState",
                    "description": "The upgrade operations current fsm-state."
                },
                "reason": {
                    "type": "string",
                    "description": "Descriptive reason for the techsupport state-change.",
                    "maxStringLength": 256
                },
                "last_changed_time": {
                    "type": "message",
                    "messageType": "TimeStamp",
                    "description": "The last time the state changed."
                }
            }
        },
        "TechSupportProfile": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "description": "UUID Identifier for the techsupport profile.",
                    "maxStringLength": 128,
                    "required": true
                },
                "max_disk_size_percent": {
                    "type": "uint32",
                    "default": 10,
                    "description": "Max disk size in percent of total disk size reserved for the techsupport. The value is in Percentage to make it agnostic of controller flavors. e.g. small [disk=5 GB, TS space available = 500MB] Large [ disk= 100Gb, TS Space available= 10GB] XL [disk=1TB, TS space available=100GB]",
                    "min": 10,
                    "max": 25
                },
                "min_free_disk_required": {
                    "type": "uint32",
                    "default": 5,
                    "description": "Min free disk required for the techsupport invocation. The value is in Percentage to make it agnostic of controller flavors. e.g. small [disk=5 GB, TS space available = 250MB] Large [ disk= 100Gb, TS Space available= 5GB] XL [disk=1TB, TS space available=50GB]",
                    "min": 5,
                    "max": 10
                },
                "file_size_threshold": {
                    "type": "uint32",
                    "default": 128,
                    "description": "Max file size threshold to archive in techsupport collection. files above this threshold will not be collected and an warning will be flagged.",
                    "min": 128,
                    "max": 512
                },
                "simultaneous_invocations": {
                    "type": "uint32",
                    "default": 1,
                    "description": "Number of simultaneous techsupport invocation allowed.",
                    "min": 1,
                    "max": 2
                },
                "no_of_techsupport_retentions": {
                    "type": "uint32",
                    "default": 4,
                    "description": "Number of techsupport to retain from techsupport cleanup policy.",
                    "min": 1,
                    "max": 5
                },
                "event_params": {
                    "type": "message",
                    "messageType": "TechSupportEventParams",
                    "description": "Specify this params to set threshold for event files. User provided parameters will take precedence over the profile parameters."
                },
                "archive_rules": {
                    "type": "message",
                    "messageType": "ArchiveRules",
                    "description": "Define the policy for techsupport archive rules. These rules allow you to specify files that should be collected in the techsupport bundle, even if they exceed the default file size threshold. e.g. To ensure a 450MB file, such as /var/sample.log, is collected with every invocation, configure and add its path to the TechSupportProfile."
                },
                "task_timeout": {
                    "type": "uint32",
                    "default": 180,
                    "description": "Generic timeout for techsupport task collection. This can be used for task, script executions etc. Tweak the timeout value in cases of timeout observation in the logs."
                }
            }
        },
        "ArchiveRules": {
            "fields": {
                "rules": {
                    "type": "message",
                    "messageType": "ArchivePolicy",
                    "repeated": true,
                    "description": "Archive policy for file path to have specific threshold. Techsupport will skip collection of file if file size is greater than threshold."
                }
            }
        },
        "ArchivePolicy": {
            "fields": {
                "file_path": {
                    "type": "string",
                    "description": "Specify a file path to add archive rule.",
                    "maxStringLength": 256
                },
                "threshold": {
                    "type": "uint32",
                    "default": 128,
                    "description": "Specify a threshold for file path in MB."
                }
            }
        },
        "ApplicationInsightsPolicy": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "description": "UUID of the Application Insights Configuration",
                    "maxStringLength": 128,
                    "required": true
                },
                "name": {
                    "type": "string",
                    "description": "The name of the Application Insights Configuration.",
                    "maxStringLength": 256,
                    "required": true
                },
                "description": {
                    "type": "string",
                    "description": "Details of the Application Insights Configuration.",
                    "maxStringLength": 1024
                },
                "tenant_uuid": {
                    "type": "string",
                    "description": "Details of the Tenant for the Application Insights Configuration.",
                    "maxStringLength": 128,
                    "required": true
                },
                "enable_application_insights": {
                    "type": "bool",
                    "default": false,
                    "description": "Enable Application Insights, formerly called learning for this virtual service."
                },
                "application_insights_params": {
                    "type": "message",
                    "messageType": "ApplicationInsightsParams",
                    "description": "Application insights parameters to filter application learning from clients."
                },
                "application_sampling_config": {
                    "type": "message",
                    "messageType": "ApplicationSamplingConfig",
                    "description": "Application sampling configuration to control rate and volume of data ingestion for Application Insights that the ServiceEngines are expected to send to the controller."
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                }
            }
        },
        "ApplicationInsightsParams": {
            "fields": {
                "enable_per_uri_learning": {
                    "type": "bool",
                    "default": true,
                    "description": "If true, learns the params per URI path."
                },
                "learn_from_authenticated_clients_only": {
                    "type": "bool",
                    "default": false,
                    "description": "Limit Application Learning only from Authenticated clients."
                },
                "trusted_ipgroup_uuid": {
                    "type": "string",
                    "description": "Limits Application Learning from client IPs within the configured IP Address Group.",
                    "maxStringLength": 128
                },
                "learn_from_bots": {
                    "type": "message",
                    "messageType": "BotDetectionMatch",
                    "description": "If Bot detection is active for this Virtual Service, learning will only be performed on application data from clients within the configured bot classification types."
                },
                "enable_learn_from_bots": {
                    "type": "bool",
                    "default": false,
                    "description": "If set to true, limit application learning only from clients which match the learn_from_bots specification. The settings learn_from_authenticated_clients_only and trusted_ip_groups always take precedence."
                },
                "learn_from_urls_without_args": {
                    "type": "bool",
                    "default": false,
                    "description": "When true, the WAF includes argument-less URIs in its learning process"
                },
                "max_uris": {
                    "type": "uint32",
                    "default": 500,
                    "description": "Maximum number of URIs for Application Insights.",
                    "min": 10,
                    "max": 10000
                },
                "max_params": {
                    "type": "uint32",
                    "default": 100,
                    "description": "Maximum number of parameters per URI programmed for Application Insights.",
                    "min": 10,
                    "max": 1000
                }
            }
        },
        "ApplicationSamplingConfig": {
            "fields": {
                "max_sampling_percent": {
                    "type": "uint32",
                    "default": 1,
                    "description": "Maximum percent of the application data subjected to Application learning.",
                    "min": 1,
                    "max": 100
                },
                "min_update_interval": {
                    "type": "uint32",
                    "default": 30,
                    "description": "Minimum periodicity at which ServiceEngine sends the application data to the controller.",
                    "min": 1,
                    "max": 60
                }
            }
        },
        "PositiveSecurityPolicy": {
            "fields": {
                "uuid": {
                    "type": "string",
                    "description": "UUID of the Positive Security Configuration",
                    "maxStringLength": 128,
                    "required": true
                },
                "name": {
                    "type": "string",
                    "description": "The name of the PositiveSecurity Configuration.",
                    "maxStringLength": 256
                },
                "description": {
                    "type": "string",
                    "description": "Details of the Positive Security Configuration.",
                    "maxStringLength": 1024
                },
                "tenant_uuid": {
                    "type": "string",
                    "description": "Details of the tenant for positive security policy.",
                    "maxStringLength": 128,
                    "required": true
                },
                "enable_positive_security_rule_updates": {
                    "type": "bool",
                    "default": false,
                    "description": "Enable Positive Security rule generation using the application learning data Rules will be programmed in a dedicated learning group."
                },
                "positive_security_params": {
                    "type": "message",
                    "messageType": "PositiveSecurityParams",
                    "description": "Parameters for generating positive security rules."
                },
                "enable_regex_programming": {
                    "type": "bool",
                    "default": false,
                    "description": "Enable dynamic regex generation for positive security rules. This is an experimental feature and shouldn't be used in production."
                },
                "configpb_attributes": {
                    "type": "message",
                    "messageType": "ConfigPbAttributes",
                    "description": "Protobuf versioning for config pbs."
                }
            }
        },
        "PositiveSecurityParams": {
            "fields": {
                "max_uris": {
                    "type": "uint32",
                    "default": 500,
                    "description": "Maximum number of URIs programmed for an application.",
                    "min": 10,
                    "max": 10000
                },
                "max_params": {
                    "type": "uint32",
                    "default": 100,
                    "description": "Maximum number of parameters per URI programmed for an application.",
                    "min": 10,
                    "max": 1000
                },
                "min_hits_to_program": {
                    "type": "uint64",
                    "default": 10000,
                    "description": "Minimum number of occurances required for a Param to qualify for programming into a PSM rule."
                },
                "min_confidence": {
                    "type": "enum",
                    "enumType": "AppLearningConfidenceLabel",
                    "default": "CONFIDENCE_VERY_HIGH",
                    "description": "Minimum confidence label required for positive security rule updates."
                },
                "confidence_override": {
                    "type": "message",
                    "messageType": "AppLearningConfidenceOverride",
                    "description": "Configure thresholds for the confidence labels defined by AppLearningConfidenceLabel"
                }
            }
        },
        "AppLearningConfidenceOverride": {
            "fields": {
                "confid_very_high_value": {
                    "type": "uint32",
                    "default": 9999,
                    "description": "Confidence threshold for label CONFIDENCE_VERY_HIGH."
                },
                "confid_high_value": {
                    "type": "uint32",
                    "default": 9500,
                    "description": "Confidence threshold for label CONFIDENCE_HIGH."
                },
                "confid_probable_value": {
                    "type": "uint32",
                    "default": 9000,
                    "description": "Confidence threshold for label CONFIDENCE_PROBABLE."
                },
                "confid_low_value": {
                    "type": "uint32",
                    "default": 7500,
                    "description": "Confidence threshold for label CONFIDENCE_LOW."
                }
            }
        }
    }
};
